(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebaaf"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebaaf"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fY3DL", function(module, exports) {

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $enL5v = parcelRequire("enL5v");

var $itJXR = parcelRequire("itJXR");
"use strict";
var $b9ff487ecf55a226$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateNonce = module.exports.checkContractWalletSignature = module.exports.SiweMessage = module.exports.SignatureType = module.exports.ErrorTypes = void 0;

var $e1JsE = parcelRequire("e1JsE");

var $jjEJ1 = parcelRequire("jjEJ1");parcelRequire("cQsQJ");
var $3Y82Z = parcelRequire("3Y82Z");
var $aLhZE = parcelRequire("aLhZE");

var $dpFzc = parcelRequire("dpFzc");
/**
 * Possible message error types.
 */ var $b9ff487ecf55a226$var$ErrorTypes;
(function(ErrorTypes) {
    /**Thrown when the `validate()` function can verify the message. */ ErrorTypes["INVALID_SIGNATURE"] = "Invalid signature.";
    /**Thrown when the `expirationTime` is present and in the past. */ ErrorTypes["EXPIRED_MESSAGE"] = "Expired message.";
    /**Thrown when some required field is missing. */ ErrorTypes["MALFORMED_SESSION"] = "Malformed session.";
})($b9ff487ecf55a226$var$ErrorTypes = module.exports.ErrorTypes || (module.exports.ErrorTypes = {}));
/**@deprecated
 * Possible signature types that this library supports.
 *
 * This enum will be removed in future releases. And signature type will be
 * inferred from version.
 */ var $b9ff487ecf55a226$var$SignatureType;
(function(SignatureType) {
    /**EIP-191 signature scheme */ SignatureType["PERSONAL_SIGNATURE"] = "Personal signature";
})($b9ff487ecf55a226$var$SignatureType = module.exports.SignatureType || (module.exports.SignatureType = {}));
var $b9ff487ecf55a226$var$SiweMessage = /*#__PURE__*/ function() {
    function SiweMessage(param) {
        (0, $9j09T._)(this, SiweMessage);
        if (typeof param === "string") {
            var parsedMessage = new $dpFzc.ParsedMessage(param);
            this.domain = parsedMessage.domain;
            this.address = parsedMessage.address;
            this.statement = parsedMessage.statement;
            this.uri = parsedMessage.uri;
            this.version = parsedMessage.version;
            this.nonce = parsedMessage.nonce;
            this.issuedAt = parsedMessage.issuedAt;
            this.expirationTime = parsedMessage.expirationTime;
            this.notBefore = parsedMessage.notBefore;
            this.requestId = parsedMessage.requestId;
            this.chainId = parsedMessage.chainId;
            this.resources = parsedMessage.resources;
        } else {
            Object.assign(this, param);
            if (typeof this.chainId === "string") this.chainId = parseInt(this.chainId);
        }
    }
    (0, $eDeHT._)(SiweMessage, [
        {
            /**
     * Given a sign message (EIP-4361) returns the correct matching groups.
     * @param message {string}
     * @returns {RegExpExecArray} The matching groups for the message
     */ key: "regexFromMessage",
            value: function regexFromMessage(message) {
                var parsedMessage = new $dpFzc.ParsedMessageRegExp(message);
                return parsedMessage.match;
            }
        },
        {
            /**
     * This function can be used to retrieve an EIP-4361 formated message for
     * signature, although you can call it directly it's advised to use
     * [signMessage()] instead which will resolve to the correct method based
     * on the [type] attribute of this object, in case of other formats being
     * implemented.
     * @returns {string} EIP-4361 formated message, ready for EIP-191 signing.
     */ key: "toMessage",
            value: function toMessage() {
                var header = "".concat(this.domain, " wants you to sign in with your Ethereum account:");
                var uriField = "URI: ".concat(this.uri);
                var prefix = [
                    header,
                    this.address
                ].join("\n");
                var versionField = "Version: ".concat(this.version);
                if (!this.nonce) this.nonce = (0, module.exports.generateNonce)();
                var chainField = "Chain ID: " + this.chainId || "1";
                var nonceField = "Nonce: ".concat(this.nonce);
                var suffixArray = [
                    uriField,
                    versionField,
                    chainField,
                    nonceField
                ];
                if (this.issuedAt) Date.parse(this.issuedAt);
                this.issuedAt = this.issuedAt ? this.issuedAt : new Date().toISOString();
                suffixArray.push("Issued At: ".concat(this.issuedAt));
                if (this.expirationTime) {
                    var expiryField = "Expiration Time: ".concat(this.expirationTime);
                    suffixArray.push(expiryField);
                }
                if (this.notBefore) suffixArray.push("Not Before: ".concat(this.notBefore));
                if (this.requestId) suffixArray.push("Request ID: ".concat(this.requestId));
                if (this.resources) suffixArray.push([
                    "Resources:"
                ].concat((0, $enL5v._)(this.resources.map(function(x) {
                    return "- ".concat(x);
                }))).join("\n"));
                var suffix = suffixArray.join("\n");
                prefix = [
                    prefix,
                    this.statement
                ].join("\n\n");
                if (this.statement) prefix += "\n";
                return [
                    prefix,
                    suffix
                ].join("\n");
            }
        },
        {
            /** @deprecated
     * signMessage method is deprecated, use prepareMessage instead.
     *
     * This method parses all the fields in the object and creates a sign
     * message according with the type defined.
     * @returns {string} Returns a message ready to be signed according with the
     * type defined in the object.
     */ key: "signMessage",
            value: function signMessage() {
                console && console.warn && console.warn("signMessage method is deprecated, use prepareMessage instead.");
                return this.prepareMessage();
            }
        },
        {
            /**
     * This method parses all the fields in the object and creates a sign
     * message according with the type defined.
     * @returns {string} Returns a message ready to be signed according with the
     * type defined in the object.
     */ key: "prepareMessage",
            value: function prepareMessage() {
                var message;
                switch(this.version){
                    case "1":
                        message = this.toMessage();
                        break;
                    default:
                        message = this.toMessage();
                        break;
                }
                return message;
            }
        },
        {
            /**
     * Validates the integrity of the fields of this objects by matching it's
     * signature.
     * @param provider A Web3 provider able to perform a contract check, this is
     * required if support for Smart Contract Wallets that implement EIP-1271 is
     * needed.
     * @returns {Promise<SiweMessage>} This object if valid.
     */ key: "validate",
            value: function validate() {
                var signature = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.signature, provider = arguments.length > 1 ? arguments[1] : void 0;
                return $b9ff487ecf55a226$var$__awaiter(this, void 0, void 0, function() {
                    var _this;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        _this = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                return $b9ff487ecf55a226$var$__awaiter(_this, void 0, void 0, function() {
                                    var message, missing, addr, _, isValidSignature, e, parsedMessage, exp, e1;
                                    return (0, $itJXR.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                message = this.prepareMessage();
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    10,
                                                    ,
                                                    11
                                                ]);
                                                missing = [];
                                                if (!message) missing.push("`message`");
                                                if (!signature) missing.push("`signature`");
                                                if (!this.address) missing.push("`address`");
                                                if (missing.length > 0) throw new Error("".concat($b9ff487ecf55a226$var$ErrorTypes.MALFORMED_SESSION, " missing: ").concat(missing.join(", "), "."));
                                                _state.label = 2;
                                            case 2:
                                                _state.trys.push([
                                                    2,
                                                    3,
                                                    4,
                                                    9
                                                ]);
                                                addr = $3Y82Z.utils.verifyMessage(message, signature);
                                                return [
                                                    3,
                                                    9
                                                ];
                                            case 3:
                                                _ = _state.sent();
                                                return [
                                                    3,
                                                    9
                                                ];
                                            case 4:
                                                if (!(addr !== this.address)) return [
                                                    3,
                                                    8
                                                ];
                                                _state.label = 5;
                                            case 5:
                                                _state.trys.push([
                                                    5,
                                                    7,
                                                    ,
                                                    8
                                                ]);
                                                return [
                                                    4,
                                                    (0, module.exports.checkContractWalletSignature)(this, signature, provider)
                                                ];
                                            case 6:
                                                isValidSignature = _state.sent();
                                                if (!isValidSignature) throw new Error("".concat($b9ff487ecf55a226$var$ErrorTypes.INVALID_SIGNATURE, ": ").concat(addr, " !== ").concat(this.address));
                                                return [
                                                    3,
                                                    8
                                                ];
                                            case 7:
                                                e = _state.sent();
                                                throw e;
                                            case 8:
                                                return [
                                                    7
                                                ];
                                            case 9:
                                                parsedMessage = new SiweMessage(message);
                                                if (parsedMessage.expirationTime) {
                                                    exp = new Date(parsedMessage.expirationTime).getTime();
                                                    if (isNaN(exp)) throw new Error("".concat($b9ff487ecf55a226$var$ErrorTypes.MALFORMED_SESSION, " invalid expiration date."));
                                                    if (new Date().getTime() >= exp) throw new Error($b9ff487ecf55a226$var$ErrorTypes.EXPIRED_MESSAGE);
                                                }
                                                resolve(parsedMessage);
                                                return [
                                                    3,
                                                    11
                                                ];
                                            case 10:
                                                e1 = _state.sent();
                                                reject(e1);
                                                return [
                                                    3,
                                                    11
                                                ];
                                            case 11:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    });
                });
            }
        }
    ]);
    return SiweMessage;
}();
module.exports.SiweMessage = $b9ff487ecf55a226$var$SiweMessage;
/**
 * This method calls the EIP-1271 method for Smart Contract wallets
 * @param message The EIP-4361 parsed message
 * @param provider Web3 provider able to perform a contract check (Web3/EthersJS).
 * @returns {Promise<boolean>} Checks for the smart contract (if it exists) if
 * the signature is valid for given address.
 */ var $b9ff487ecf55a226$var$checkContractWalletSignature = function(message, signature, provider) {
    return $b9ff487ecf55a226$var$__awaiter(void 0, void 0, void 0, function() {
        var abi, walletContract, hashMessage, e;
        return (0, $itJXR.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!provider) return [
                        2,
                        false
                    ];
                    abi = [
                        "function isValidSignature(bytes32 _message, bytes _signature) public view returns (bool)"
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    walletContract = new $jjEJ1.Contract(message.address, abi, provider);
                    hashMessage = $aLhZE.hashMessage(message.signMessage());
                    return [
                        4,
                        walletContract.isValidSignature(hashMessage, signature)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    e = _state.sent();
                    throw e;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
};
module.exports.checkContractWalletSignature = $b9ff487ecf55a226$var$checkContractWalletSignature;
/**
 * This method leverages a native CSPRNG with support for both browser and Node.js
 * environments in order generate a cryptographically secure nonce for use in the
 * SiweMessage in order to prevent replay attacks.
 *
 * 96 bits has been chosen as a number to sufficiently balance size and security considerations
 * relative to the lifespan of it's usage.
 *
 * @returns cryptographically generated random nonce with 96 bits of entropy encoded with
 * an alphanumeric character set.
 */ var $b9ff487ecf55a226$var$generateNonce = function() {
    return (0, $e1JsE.randomStringForEntropy)(96);
};
module.exports.generateNonce = $b9ff487ecf55a226$var$generateNonce;

});
parcelRegister("e1JsE", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomStringForEntropy = module.exports.randomString = module.exports.randomUint32 = module.exports.randomBytes = module.exports.defaultRandomSource = void 0;

var $d3fPs = parcelRequire("d3fPs");

var $5PCcg = parcelRequire("5PCcg");

var $3L7eY = parcelRequire("3L7eY");
module.exports.defaultRandomSource = new $d3fPs.SystemRandomSource();
function $02a2a6e880e802f7$var$randomBytes(length) {
    var prng = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : module.exports.defaultRandomSource;
    return prng.randomBytes(length);
}
module.exports.randomBytes = $02a2a6e880e802f7$var$randomBytes;
/**
 * Returns a uniformly random unsigned 32-bit integer.
 */ function $02a2a6e880e802f7$var$randomUint32() {
    var prng = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : module.exports.defaultRandomSource;
    // Generate 4-byte random buffer.
    var buf = $02a2a6e880e802f7$var$randomBytes(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    var result = (0, $5PCcg.readUint32LE)(buf);
    // Clean the buffer.
    (0, $3L7eY.wipe)(buf);
    return result;
}
module.exports.randomUint32 = $02a2a6e880e802f7$var$randomUint32;
/** 62 alphanumeric characters for default charset of randomString() */ var $02a2a6e880e802f7$var$ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
/**
 * Returns a uniform random string of the given length
 * with characters from the given charset.
 *
 * Charset must not have more than 256 characters.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $02a2a6e880e802f7$var$randomString(length) {
    var charset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $02a2a6e880e802f7$var$ALPHANUMERIC, prng = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : module.exports.defaultRandomSource;
    if (charset.length < 2) throw new Error("randomString charset is too short");
    if (charset.length > 256) throw new Error("randomString charset is too long");
    var out = "";
    var charsLen = charset.length;
    var maxByte = 256 - 256 % charsLen;
    while(length > 0){
        var buf = $02a2a6e880e802f7$var$randomBytes(Math.ceil(length * 256 / maxByte), prng);
        for(var i = 0; i < buf.length && length > 0; i++){
            var randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, $3L7eY.wipe)(buf);
    }
    return out;
}
module.exports.randomString = $02a2a6e880e802f7$var$randomString;
/**
 * Returns uniform random string containing at least the given
 * number of bits of entropy.
 *
 * For example, randomStringForEntropy(128) will return a 22-character
 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
 * will return a 39-character numeric string, both will contain at
 * least 128 bits of entropy.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $02a2a6e880e802f7$var$randomStringForEntropy(bits) {
    var charset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $02a2a6e880e802f7$var$ALPHANUMERIC, prng = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : module.exports.defaultRandomSource;
    var length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return $02a2a6e880e802f7$var$randomString(length, charset, prng);
}
module.exports.randomStringForEntropy = $02a2a6e880e802f7$var$randomStringForEntropy;

});
parcelRegister("d3fPs", function(module, exports) {

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SystemRandomSource = void 0;

var $2iVnb = parcelRequire("2iVnb");

var $173o5 = parcelRequire("173o5");
var $9807d57ddd343775$var$SystemRandomSource = /*#__PURE__*/ function() {
    function SystemRandomSource() {
        (0, $9j09T._)(this, SystemRandomSource);
        this.isAvailable = false;
        this.name = "";
        // Try browser.
        this._source = new $2iVnb.BrowserRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Browser";
            return;
        }
        // If no browser source, try Node.
        this._source = new $173o5.NodeRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Node";
            return;
        }
    }
    (0, $eDeHT._)(SystemRandomSource, [
        {
            key: "randomBytes",
            value: function randomBytes(length) {
                if (!this.isAvailable) throw new Error("System random byte generator is not available.");
                return this._source.randomBytes(length);
            }
        }
    ]);
    return SystemRandomSource;
}();
module.exports.SystemRandomSource = $9807d57ddd343775$var$SystemRandomSource;

});
parcelRegister("2iVnb", function(module, exports) {

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserRandomSource = void 0;
var $1ad9c44c973a6130$var$QUOTA = 65536;
var $1ad9c44c973a6130$var$BrowserRandomSource = /*#__PURE__*/ function() {
    function BrowserRandomSource() {
        (0, $9j09T._)(this, BrowserRandomSource);
        this.isAvailable = false;
        this.isInstantiated = false;
        var browserCrypto = typeof self !== "undefined" ? self.crypto || self.msCrypto // IE11 has msCrypto
         : null;
        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
            this._crypto = browserCrypto;
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    (0, $eDeHT._)(BrowserRandomSource, [
        {
            key: "randomBytes",
            value: function randomBytes(length) {
                if (!this.isAvailable || !this._crypto) throw new Error("Browser random byte generator is not available.");
                var out = new Uint8Array(length);
                for(var i = 0; i < out.length; i += $1ad9c44c973a6130$var$QUOTA)this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, $1ad9c44c973a6130$var$QUOTA)));
                return out;
            }
        }
    ]);
    return BrowserRandomSource;
}();
module.exports.BrowserRandomSource = $1ad9c44c973a6130$var$BrowserRandomSource;

});

parcelRegister("173o5", function(module, exports) {

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeRandomSource = void 0;

var $3L7eY = parcelRequire("3L7eY");

var $0cf912974e120ed6$var$NodeRandomSource = /*#__PURE__*/ function() {
    function NodeRandomSource() {
        (0, $9j09T._)(this, NodeRandomSource);
        this.isAvailable = false;
        this.isInstantiated = false;
        {
            var nodeCrypto = (parcelRequire("8uCnf"));
            if (nodeCrypto && nodeCrypto.randomBytes) {
                this._crypto = nodeCrypto;
                this.isAvailable = true;
                this.isInstantiated = true;
            }
        }
    }
    (0, $eDeHT._)(NodeRandomSource, [
        {
            key: "randomBytes",
            value: function randomBytes(length) {
                if (!this.isAvailable || !this._crypto) throw new Error("Node.js random byte generator is not available.");
                // Get random bytes (result is Buffer).
                var buffer = this._crypto.randomBytes(length);
                // Make sure we got the length that we requested.
                if (buffer.length !== length) throw new Error("NodeRandomSource: got fewer bytes than requested");
                // Allocate output array.
                var out = new Uint8Array(length);
                // Copy bytes from buffer to output.
                for(var i = 0; i < out.length; i++)out[i] = buffer[i];
                // Cleanup.
                (0, $3L7eY.wipe)(buffer);
                return out;
            }
        }
    ]);
    return NodeRandomSource;
}();
module.exports.NodeRandomSource = $0cf912974e120ed6$var$NodeRandomSource;

});
parcelRegister("3L7eY", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */ function $2bcb60ae60fa76c4$var$wipe(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for(var i = 0; i < array.length; i++)array[i] = 0;
    return array;
}
module.exports.wipe = $2bcb60ae60fa76c4$var$wipe;

});



parcelRegister("5PCcg", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gFiz6 = parcelRequire("gFiz6");
// TODO(dchest): add asserts for correct value ranges and array offsets.
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * signed 16-bit integer and returns it.
 */ function $43ef583f335bac38$var$readInt16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
}
module.exports.readInt16BE = $43ef583f335bac38$var$readInt16BE;
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * unsigned 16-bit integer and returns it.
 */ function $43ef583f335bac38$var$readUint16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
}
module.exports.readUint16BE = $43ef583f335bac38$var$readUint16BE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * signed 16-bit integer and returns it.
 */ function $43ef583f335bac38$var$readInt16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
}
module.exports.readInt16LE = $43ef583f335bac38$var$readInt16LE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * unsigned 16-bit integer and returns it.
 */ function $43ef583f335bac38$var$readUint16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) >>> 0;
}
module.exports.readUint16LE = $43ef583f335bac38$var$readUint16LE;
/**
 * Writes 2-byte big-endian representation of 16-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $43ef583f335bac38$var$writeUint16BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
module.exports.writeUint16BE = $43ef583f335bac38$var$writeUint16BE;
module.exports.writeInt16BE = $43ef583f335bac38$var$writeUint16BE;
/**
 * Writes 2-byte little-endian representation of 16-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $43ef583f335bac38$var$writeUint16LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
module.exports.writeUint16LE = $43ef583f335bac38$var$writeUint16LE;
module.exports.writeInt16LE = $43ef583f335bac38$var$writeUint16LE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * signed 32-bit integer and returns it.
 */ function $43ef583f335bac38$var$readInt32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
}
module.exports.readInt32BE = $43ef583f335bac38$var$readInt32BE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * unsigned 32-bit integer and returns it.
 */ function $43ef583f335bac38$var$readUint32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
}
module.exports.readUint32BE = $43ef583f335bac38$var$readUint32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * signed 32-bit integer and returns it.
 */ function $43ef583f335bac38$var$readInt32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
}
module.exports.readInt32LE = $43ef583f335bac38$var$readInt32LE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * unsigned 32-bit integer and returns it.
 */ function $43ef583f335bac38$var$readUint32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
}
module.exports.readUint32LE = $43ef583f335bac38$var$readUint32LE;
/**
 * Writes 4-byte big-endian representation of 32-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $43ef583f335bac38$var$writeUint32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
module.exports.writeUint32BE = $43ef583f335bac38$var$writeUint32BE;
module.exports.writeInt32BE = $43ef583f335bac38$var$writeUint32BE;
/**
 * Writes 4-byte little-endian representation of 32-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $43ef583f335bac38$var$writeUint32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
module.exports.writeUint32LE = $43ef583f335bac38$var$writeUint32LE;
module.exports.writeInt32LE = $43ef583f335bac38$var$writeUint32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $43ef583f335bac38$var$readInt64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $43ef583f335bac38$var$readInt32BE(array, offset);
    var lo = $43ef583f335bac38$var$readInt32BE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
module.exports.readInt64BE = $43ef583f335bac38$var$readInt64BE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $43ef583f335bac38$var$readUint64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $43ef583f335bac38$var$readUint32BE(array, offset);
    var lo = $43ef583f335bac38$var$readUint32BE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
module.exports.readUint64BE = $43ef583f335bac38$var$readUint64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $43ef583f335bac38$var$readInt64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $43ef583f335bac38$var$readInt32LE(array, offset);
    var hi = $43ef583f335bac38$var$readInt32LE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
module.exports.readInt64LE = $43ef583f335bac38$var$readInt64LE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $43ef583f335bac38$var$readUint64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $43ef583f335bac38$var$readUint32LE(array, offset);
    var hi = $43ef583f335bac38$var$readUint32LE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
module.exports.readUint64LE = $43ef583f335bac38$var$readUint64LE;
/**
 * Writes 8-byte big-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $43ef583f335bac38$var$writeUint64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $43ef583f335bac38$var$writeUint32BE(value / 0x100000000 >>> 0, out, offset);
    $43ef583f335bac38$var$writeUint32BE(value >>> 0, out, offset + 4);
    return out;
}
module.exports.writeUint64BE = $43ef583f335bac38$var$writeUint64BE;
module.exports.writeInt64BE = $43ef583f335bac38$var$writeUint64BE;
/**
 * Writes 8-byte little-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $43ef583f335bac38$var$writeUint64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $43ef583f335bac38$var$writeUint32LE(value >>> 0, out, offset);
    $43ef583f335bac38$var$writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
module.exports.writeUint64LE = $43ef583f335bac38$var$writeUint64LE;
module.exports.writeInt64LE = $43ef583f335bac38$var$writeUint64LE;
/**
 * Reads bytes from array starting at offset as big-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $43ef583f335bac38$var$readUintBE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintBE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintBE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
module.exports.readUintBE = $43ef583f335bac38$var$readUintBE;
/**
 * Reads bytes from array starting at offset as little-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $43ef583f335bac38$var$readUintLE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintLE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintLE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
module.exports.readUintLE = $43ef583f335bac38$var$readUintLE;
/**
 * Writes a big-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $43ef583f335bac38$var$writeUintBE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintBE supports only bitLengths divisible by 8");
    if (!$gFiz6.isSafeInteger(value)) throw new Error("writeUintBE value must be an integer");
    var div = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
module.exports.writeUintBE = $43ef583f335bac38$var$writeUintBE;
/**
 * Writes a little-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $43ef583f335bac38$var$writeUintLE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintLE supports only bitLengths divisible by 8");
    if (!$gFiz6.isSafeInteger(value)) throw new Error("writeUintLE value must be an integer");
    var div = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
module.exports.writeUintLE = $43ef583f335bac38$var$writeUintLE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * 32-bit floating-point number and returns it.
 */ function $43ef583f335bac38$var$readFloat32BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
module.exports.readFloat32BE = $43ef583f335bac38$var$readFloat32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * 32-bit floating-point number and returns it.
 */ function $43ef583f335bac38$var$readFloat32LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
module.exports.readFloat32LE = $43ef583f335bac38$var$readFloat32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $43ef583f335bac38$var$readFloat64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
module.exports.readFloat64BE = $43ef583f335bac38$var$readFloat64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $43ef583f335bac38$var$readFloat64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
module.exports.readFloat64LE = $43ef583f335bac38$var$readFloat64LE;
/**
 * Writes 4-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $43ef583f335bac38$var$writeFloat32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
module.exports.writeFloat32BE = $43ef583f335bac38$var$writeFloat32BE;
/**
 * Writes 4-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $43ef583f335bac38$var$writeFloat32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
module.exports.writeFloat32LE = $43ef583f335bac38$var$writeFloat32LE;
/**
 * Writes 8-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $43ef583f335bac38$var$writeFloat64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
module.exports.writeFloat64BE = $43ef583f335bac38$var$writeFloat64BE;
/**
 * Writes 8-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $43ef583f335bac38$var$writeFloat64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}
module.exports.writeFloat64LE = $43ef583f335bac38$var$writeFloat64LE;

});
parcelRegister("gFiz6", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Package int provides helper functions for integerss.
 */ // Shim using 16-bit pieces.
function $c21ee054cb8e1f99$var$imulShim(a, b) {
    var ah = a >>> 16 & 0xffff, al = a & 0xffff;
    var bh = b >>> 16 & 0xffff, bl = b & 0xffff;
    return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
}
/** 32-bit integer multiplication.  */ // Use system Math.imul if available, otherwise use our shim.
module.exports.mul = Math.imul || $c21ee054cb8e1f99$var$imulShim;
/** 32-bit integer addition.  */ function $c21ee054cb8e1f99$var$add(a, b) {
    return a + b | 0;
}
module.exports.add = $c21ee054cb8e1f99$var$add;
/**  32-bit integer subtraction.  */ function $c21ee054cb8e1f99$var$sub(a, b) {
    return a - b | 0;
}
module.exports.sub = $c21ee054cb8e1f99$var$sub;
/** 32-bit integer left rotation */ function $c21ee054cb8e1f99$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
module.exports.rotl = $c21ee054cb8e1f99$var$rotl;
/** 32-bit integer left rotation */ function $c21ee054cb8e1f99$var$rotr(x, n) {
    return x << 32 - n | x >>> n;
}
module.exports.rotr = $c21ee054cb8e1f99$var$rotr;
function $c21ee054cb8e1f99$var$isIntegerShim(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
}
/**
 * Returns true if the argument is an integer number.
 *
 * In ES2015, Number.isInteger.
 */ module.exports.isInteger = Number.isInteger || $c21ee054cb8e1f99$var$isIntegerShim;
/**
 *  Math.pow(2, 53) - 1
 *
 *  In ES2015 Number.MAX_SAFE_INTEGER.
 */ module.exports.MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Returns true if the argument is a safe integer number
 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
 *
 * In ES2015, Number.isSafeInteger.
 */ module.exports.isSafeInteger = function(n) {
    return module.exports.isInteger(n) && n >= -module.exports.MAX_SAFE_INTEGER && n <= module.exports.MAX_SAFE_INTEGER;
};

});



parcelRegister("jjEJ1", function(module, exports) {

$parcel$export(module.exports, "BaseContract", function () { return $e0ff61dc692dde55$export$304faa4fc17528db; });
$parcel$export(module.exports, "Contract", function () { return $e0ff61dc692dde55$export$8517d80acf00e19a; });
$parcel$export(module.exports, "ContractFactory", function () { return $e0ff61dc692dde55$export$505569a6bf584fd9; });

var $feAea = parcelRequire("feAea");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $15W2b = parcelRequire("15W2b");

var $711He = parcelRequire("711He");

var $i0LXg = parcelRequire("i0LXg");

var $enL5v = parcelRequire("enL5v");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");

var $jG7Zp = parcelRequire("jG7Zp");
var $hrmiK = parcelRequire("hrmiK");

var $fH8QX = parcelRequire("fH8QX");

var $3KRXu = parcelRequire("3KRXu");

var $hFSWi = parcelRequire("hFSWi");

var $7ryKd = parcelRequire("7ryKd");

var $2tHqU = parcelRequire("2tHqU");

var $iqBKf = parcelRequire("iqBKf");

var $60XIC = parcelRequire("60XIC");

var $ihGvV = parcelRequire("ihGvV");

var $enS8s = parcelRequire("enS8s");
"use strict";
var $e0ff61dc692dde55$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e0ff61dc692dde55$var$logger = new (0, $ihGvV.Logger)((0, $enS8s.version));
///////////////////////////////
var $e0ff61dc692dde55$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    from: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true,
    customData: true
};
function $e0ff61dc692dde55$var$resolveName(resolver, nameOrPromise) {
    return $e0ff61dc692dde55$var$__awaiter(this, void 0, void 0, function() {
        var name, address;
        return (0, $itJXR.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        nameOrPromise
                    ];
                case 1:
                    name = _state.sent();
                    if (typeof name !== "string") $e0ff61dc692dde55$var$logger.throwArgumentError("invalid address or ENS name", "name", name);
                    // If it is already an address, just use it (after adding checksum)
                    try {
                        return [
                            2,
                            (0, $hFSWi.getAddress)(name)
                        ];
                    } catch (error) {}
                    if (!resolver) $e0ff61dc692dde55$var$logger.throwError("a provider or signer is needed to resolve ENS names", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "resolveName"
                    });
                    return [
                        4,
                        resolver.resolveName(name)
                    ];
                case 2:
                    address = _state.sent();
                    if (address == null) $e0ff61dc692dde55$var$logger.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
                    return [
                        2,
                        address
                    ];
            }
        });
    });
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function $e0ff61dc692dde55$var$resolveAddresses(resolver, value, paramType) {
    return $e0ff61dc692dde55$var$__awaiter(this, void 0, void 0, function() {
        return (0, $itJXR.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!Array.isArray(paramType)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        Promise.all(paramType.map(function(paramType, index) {
                            return $e0ff61dc692dde55$var$resolveAddresses(resolver, Array.isArray(value) ? value[index] : value[paramType.name], paramType);
                        }))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    if (!(paramType.type === "address")) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        $e0ff61dc692dde55$var$resolveName(resolver, value)
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    if (!(paramType.type === "tuple")) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        $e0ff61dc692dde55$var$resolveAddresses(resolver, value, paramType.components)
                    ];
                case 5:
                    return [
                        2,
                        _state.sent()
                    ];
                case 6:
                    if (!(paramType.baseType === "array")) return [
                        3,
                        8
                    ];
                    if (!Array.isArray(value)) return [
                        2,
                        Promise.reject($e0ff61dc692dde55$var$logger.makeError("invalid value for array", (0, $ihGvV.Logger).errors.INVALID_ARGUMENT, {
                            argument: "value",
                            value: value
                        }))
                    ];
                    return [
                        4,
                        Promise.all(value.map(function(v) {
                            return $e0ff61dc692dde55$var$resolveAddresses(resolver, v, paramType.arrayChildren);
                        }))
                    ];
                case 7:
                    return [
                        2,
                        _state.sent()
                    ];
                case 8:
                    return [
                        2,
                        value
                    ];
            }
        });
    });
}
function $e0ff61dc692dde55$var$populateTransaction(contract, fragment, args) {
    return $e0ff61dc692dde55$var$__awaiter(this, void 0, void 0, function() {
        var _this, overrides, resolved, data, tx, ro, intrinsic, bytes, i, roValue, leftovers;
        return (0, $itJXR.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _this = this;
                    // If an extra argument is given, it is overrides
                    overrides = {};
                    if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") overrides = (0, $iqBKf.shallowCopy)(args.pop());
                    // Make sure the parameter count matches
                    $e0ff61dc692dde55$var$logger.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
                    // Populate "from" override (allow promises)
                    if (contract.signer) {
                        if (overrides.from) // Contracts with a Signer are from the Signer's frame-of-reference;
                        // but we allow overriding "from" if it matches the signer
                        overrides.from = (0, $iqBKf.resolveProperties)({
                            override: $e0ff61dc692dde55$var$resolveName(contract.signer, overrides.from),
                            signer: contract.signer.getAddress()
                        }).then(function(check) {
                            return $e0ff61dc692dde55$var$__awaiter(_this, void 0, void 0, function() {
                                return (0, $itJXR.__generator)(this, function(_state) {
                                    if ((0, $hFSWi.getAddress)(check.signer) !== check.override) $e0ff61dc692dde55$var$logger.throwError("Contract with a Signer cannot override from", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                                        operation: "overrides.from"
                                    });
                                    return [
                                        2,
                                        check.override
                                    ];
                                });
                            });
                        });
                        else overrides.from = contract.signer.getAddress();
                    } else if (overrides.from) overrides.from = $e0ff61dc692dde55$var$resolveName(contract.provider, overrides.from);
                    return [
                        4,
                        (0, $iqBKf.resolveProperties)({
                            args: $e0ff61dc692dde55$var$resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
                            address: contract.resolvedAddress,
                            overrides: (0, $iqBKf.resolveProperties)(overrides) || {}
                        })
                    ];
                case 1:
                    resolved = _state.sent();
                    // The ABI coded transaction
                    data = contract.interface.encodeFunctionData(fragment, resolved.args);
                    tx = {
                        data: data,
                        to: resolved.address
                    };
                    // Resolved Overrides
                    ro = resolved.overrides;
                    // Populate simple overrides
                    if (ro.nonce != null) tx.nonce = (0, $7ryKd.BigNumber).from(ro.nonce).toNumber();
                    if (ro.gasLimit != null) tx.gasLimit = (0, $7ryKd.BigNumber).from(ro.gasLimit);
                    if (ro.gasPrice != null) tx.gasPrice = (0, $7ryKd.BigNumber).from(ro.gasPrice);
                    if (ro.maxFeePerGas != null) tx.maxFeePerGas = (0, $7ryKd.BigNumber).from(ro.maxFeePerGas);
                    if (ro.maxPriorityFeePerGas != null) tx.maxPriorityFeePerGas = (0, $7ryKd.BigNumber).from(ro.maxPriorityFeePerGas);
                    if (ro.from != null) tx.from = ro.from;
                    if (ro.type != null) tx.type = ro.type;
                    if (ro.accessList != null) tx.accessList = (0, $60XIC.accessListify)(ro.accessList);
                    // If there was no "gasLimit" override, but the ABI specifies a default, use it
                    if (tx.gasLimit == null && fragment.gas != null) {
                        // Compute the intrinsic gas cost for this transaction
                        // @TODO: This is based on the yellow paper as of Petersburg; this is something
                        // we may wish to parameterize in v6 as part of the Network object. Since this
                        // is always a non-nil to address, we can ignore G_create, but may wish to add
                        // similar logic to the ContractFactory.
                        intrinsic = 21000;
                        bytes = (0, $2tHqU.arrayify)(data);
                        for(i = 0; i < bytes.length; i++){
                            intrinsic += 4;
                            if (bytes[i]) intrinsic += 64;
                        }
                        tx.gasLimit = (0, $7ryKd.BigNumber).from(fragment.gas).add(intrinsic);
                    }
                    // Populate "value" override
                    if (ro.value) {
                        roValue = (0, $7ryKd.BigNumber).from(ro.value);
                        if (!roValue.isZero() && !fragment.payable) $e0ff61dc692dde55$var$logger.throwError("non-payable method cannot override value", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                            operation: "overrides.value",
                            value: overrides.value
                        });
                        tx.value = roValue;
                    }
                    if (ro.customData) tx.customData = (0, $iqBKf.shallowCopy)(ro.customData);
                    // Remove the overrides
                    delete overrides.nonce;
                    delete overrides.gasLimit;
                    delete overrides.gasPrice;
                    delete overrides.from;
                    delete overrides.value;
                    delete overrides.type;
                    delete overrides.accessList;
                    delete overrides.maxFeePerGas;
                    delete overrides.maxPriorityFeePerGas;
                    delete overrides.customData;
                    // Make sure there are no stray overrides, which may indicate a
                    // typo or using an unsupported key.
                    leftovers = Object.keys(overrides).filter(function(key) {
                        return overrides[key] != null;
                    });
                    if (leftovers.length) $e0ff61dc692dde55$var$logger.throwError("cannot override ".concat(leftovers.map(function(l) {
                        return JSON.stringify(l);
                    }).join(",")), (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "overrides",
                        overrides: leftovers
                    });
                    return [
                        2,
                        tx
                    ];
            }
        });
    });
}
function $e0ff61dc692dde55$var$buildPopulate(contract, fragment) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $e0ff61dc692dde55$var$populateTransaction(contract, fragment, args);
    };
}
function $e0ff61dc692dde55$var$buildEstimate(contract, fragment) {
    var signerOrProvider = contract.signer || contract.provider;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $e0ff61dc692dde55$var$__awaiter(this, void 0, void 0, function() {
            var tx;
            return (0, $itJXR.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!signerOrProvider) $e0ff61dc692dde55$var$logger.throwError("estimate require a provider or signer", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                            operation: "estimateGas"
                        });
                        return [
                            4,
                            $e0ff61dc692dde55$var$populateTransaction(contract, fragment, args)
                        ];
                    case 1:
                        tx = _state.sent();
                        return [
                            4,
                            signerOrProvider.estimateGas(tx)
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
    };
}
function $e0ff61dc692dde55$var$addContractWait(contract, tx) {
    var wait = tx.wait.bind(tx);
    tx.wait = function(confirmations) {
        return wait(confirmations).then(function(receipt) {
            receipt.events = receipt.logs.map(function(log) {
                var event = (0, $iqBKf.deepCopy)(log);
                var parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                } catch (e) {}
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = function(data, topics) {
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = function() {
                    return contract.provider;
                };
                event.getBlock = function() {
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = function() {
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = function() {
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
}
function $e0ff61dc692dde55$var$buildCall(contract, fragment, collapseSimple) {
    var signerOrProvider = contract.signer || contract.provider;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $e0ff61dc692dde55$var$__awaiter(this, void 0, void 0, function() {
            var blockTag, overrides, tx, result, value;
            return (0, $itJXR.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Extract the "blockTag" override if present
                        blockTag = undefined;
                        if (!(args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object")) return [
                            3,
                            3
                        ];
                        overrides = (0, $iqBKf.shallowCopy)(args.pop());
                        if (!(overrides.blockTag != null)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            overrides.blockTag
                        ];
                    case 1:
                        blockTag = _state.sent();
                        _state.label = 2;
                    case 2:
                        delete overrides.blockTag;
                        args.push(overrides);
                        _state.label = 3;
                    case 3:
                        if (!(contract.deployTransaction != null)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            contract._deployed(blockTag)
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            4,
                            $e0ff61dc692dde55$var$populateTransaction(contract, fragment, args)
                        ];
                    case 6:
                        tx = _state.sent();
                        return [
                            4,
                            signerOrProvider.call(tx, blockTag)
                        ];
                    case 7:
                        result = _state.sent();
                        try {
                            value = contract.interface.decodeFunctionResult(fragment, result);
                            if (collapseSimple && fragment.outputs.length === 1) value = value[0];
                            return [
                                2,
                                value
                            ];
                        } catch (error) {
                            if (error.code === (0, $ihGvV.Logger).errors.CALL_EXCEPTION) {
                                error.address = contract.address;
                                error.args = args;
                                error.transaction = tx;
                            }
                            throw error;
                        }
                        return [
                            2
                        ];
                }
            });
        });
    };
}
function $e0ff61dc692dde55$var$buildSend(contract, fragment) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $e0ff61dc692dde55$var$__awaiter(this, void 0, void 0, function() {
            var txRequest, tx;
            return (0, $itJXR.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!contract.signer) $e0ff61dc692dde55$var$logger.throwError("sending a transaction requires a signer", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                            operation: "sendTransaction"
                        });
                        if (!(contract.deployTransaction != null)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            contract._deployed()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            $e0ff61dc692dde55$var$populateTransaction(contract, fragment, args)
                        ];
                    case 3:
                        txRequest = _state.sent();
                        return [
                            4,
                            contract.signer.sendTransaction(txRequest)
                        ];
                    case 4:
                        tx = _state.sent();
                        // Tweak the tx.wait so the receipt has extra properties
                        $e0ff61dc692dde55$var$addContractWait(contract, tx);
                        return [
                            2,
                            tx
                        ];
                }
            });
        });
    };
}
function $e0ff61dc692dde55$var$buildDefault(contract, fragment, collapseSimple) {
    if (fragment.constant) return $e0ff61dc692dde55$var$buildCall(contract, fragment, collapseSimple);
    return $e0ff61dc692dde55$var$buildSend(contract, fragment);
}
function $e0ff61dc692dde55$var$getEventTag(filter) {
    if (filter.address && (filter.topics == null || filter.topics.length === 0)) return "*";
    return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map(function(topic) {
        if (Array.isArray(topic)) return topic.join("|");
        return topic;
    }).join(":") : "");
}
var $e0ff61dc692dde55$var$RunningEvent = /*#__PURE__*/ function() {
    function RunningEvent(tag, filter) {
        (0, $9j09T._)(this, RunningEvent);
        (0, $iqBKf.defineReadOnly)(this, "tag", tag);
        (0, $iqBKf.defineReadOnly)(this, "filter", filter);
        this._listeners = [];
    }
    (0, $eDeHT._)(RunningEvent, [
        {
            key: "addListener",
            value: function addListener(listener, once) {
                this._listeners.push({
                    listener: listener,
                    once: once
                });
            }
        },
        {
            key: "removeListener",
            value: function removeListener(listener) {
                var done = false;
                this._listeners = this._listeners.filter(function(item) {
                    if (done || item.listener !== listener) return true;
                    done = true;
                    return false;
                });
            }
        },
        {
            key: "removeAllListeners",
            value: function removeAllListeners() {
                this._listeners = [];
            }
        },
        {
            key: "listeners",
            value: function listeners() {
                return this._listeners.map(function(i) {
                    return i.listener;
                });
            }
        },
        {
            key: "listenerCount",
            value: function listenerCount() {
                return this._listeners.length;
            }
        },
        {
            key: "run",
            value: function run(args) {
                var _this = this;
                var listenerCount = this.listenerCount();
                this._listeners = this._listeners.filter(function(item) {
                    var argsCopy = args.slice();
                    // Call the callback in the next event loop
                    setTimeout(function() {
                        item.listener.apply(_this, argsCopy);
                    }, 0);
                    // Reschedule it if it not "once"
                    return !item.once;
                });
                return listenerCount;
            }
        },
        {
            key: "prepareEvent",
            value: function prepareEvent(event) {}
        },
        {
            // Returns the array that will be applied to an emit
            key: "getEmit",
            value: function getEmit(event) {
                return [
                    event
                ];
            }
        }
    ]);
    return RunningEvent;
}();
var $e0ff61dc692dde55$var$ErrorRunningEvent = /*#__PURE__*/ function(RunningEvent) {
    (0, $i0LXg._)(ErrorRunningEvent, RunningEvent);
    var _super = (0, $a1vXf._)(ErrorRunningEvent);
    function ErrorRunningEvent() {
        (0, $9j09T._)(this, ErrorRunningEvent);
        return _super.call(this, "error", null);
    }
    return ErrorRunningEvent;
}($e0ff61dc692dde55$var$RunningEvent);
// @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
var $e0ff61dc692dde55$var$FragmentRunningEvent = /*#__PURE__*/ function(RunningEvent) {
    (0, $i0LXg._)(FragmentRunningEvent, RunningEvent);
    var _super = (0, $a1vXf._)(FragmentRunningEvent);
    function FragmentRunningEvent(address, contractInterface, fragment, topics) {
        (0, $9j09T._)(this, FragmentRunningEvent);
        var _this;
        var filter = {
            address: address
        };
        var topic = contractInterface.getEventTopic(fragment);
        if (topics) {
            if (topic !== topics[0]) $e0ff61dc692dde55$var$logger.throwArgumentError("topic mismatch", "topics", topics);
            filter.topics = topics.slice();
        } else filter.topics = [
            topic
        ];
        _this = _super.call(this, $e0ff61dc692dde55$var$getEventTag(filter), filter);
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "address", address);
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "interface", contractInterface);
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "fragment", fragment);
        return _this;
    }
    (0, $eDeHT._)(FragmentRunningEvent, [
        {
            key: "prepareEvent",
            value: function prepareEvent(event) {
                var _this = this;
                (0, $15W2b._)((0, $711He._)(FragmentRunningEvent.prototype), "prepareEvent", this).call(this, event);
                event.event = this.fragment.name;
                event.eventSignature = this.fragment.format();
                event.decode = function(data, topics) {
                    return _this.interface.decodeEventLog(_this.fragment, data, topics);
                };
                try {
                    event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
                } catch (error) {
                    event.args = null;
                    event.decodeError = error;
                }
            }
        },
        {
            key: "getEmit",
            value: function getEmit(event) {
                var errors = (0, $jG7Zp.checkResultErrors)(event.args);
                if (errors.length) throw errors[0].error;
                var args = (event.args || []).slice();
                args.push(event);
                return args;
            }
        }
    ]);
    return FragmentRunningEvent;
}($e0ff61dc692dde55$var$RunningEvent);
// A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
var $e0ff61dc692dde55$var$WildcardRunningEvent = /*#__PURE__*/ function(RunningEvent) {
    (0, $i0LXg._)(WildcardRunningEvent, RunningEvent);
    var _super = (0, $a1vXf._)(WildcardRunningEvent);
    function WildcardRunningEvent(address, contractInterface) {
        (0, $9j09T._)(this, WildcardRunningEvent);
        var _this;
        _this = _super.call(this, "*", {
            address: address
        });
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "address", address);
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "interface", contractInterface);
        return _this;
    }
    (0, $eDeHT._)(WildcardRunningEvent, [
        {
            key: "prepareEvent",
            value: function prepareEvent(event) {
                var _this = this;
                (0, $15W2b._)((0, $711He._)(WildcardRunningEvent.prototype), "prepareEvent", this).call(this, event);
                try {
                    var parsed = this.interface.parseLog(event);
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                    event.decode = function(data, topics) {
                        return _this.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.args = parsed.args;
                } catch (error) {
                // No matching event
                }
            }
        }
    ]);
    return WildcardRunningEvent;
}($e0ff61dc692dde55$var$RunningEvent);
var $e0ff61dc692dde55$export$304faa4fc17528db = /*#__PURE__*/ function _target() {
    function BaseContract(addressOrName, contractInterface, signerOrProvider) {
        var _this = this;
        (0, $9j09T._)(this, BaseContract);
        $e0ff61dc692dde55$var$logger.checkNew(this instanceof BaseContract ? this.constructor : void 0, $e0ff61dc692dde55$export$8517d80acf00e19a);
        // @TODO: Maybe still check the addressOrName looks like a valid address or name?
        //address = getAddress(address);
        (0, $iqBKf.defineReadOnly)(this, "interface", (0, $iqBKf.getStatic)(this instanceof BaseContract ? this.constructor : void 0, "getInterface")(contractInterface));
        if (signerOrProvider == null) {
            (0, $iqBKf.defineReadOnly)(this, "provider", null);
            (0, $iqBKf.defineReadOnly)(this, "signer", null);
        } else if ((0, $3KRXu.Signer).isSigner(signerOrProvider)) {
            (0, $iqBKf.defineReadOnly)(this, "provider", signerOrProvider.provider || null);
            (0, $iqBKf.defineReadOnly)(this, "signer", signerOrProvider);
        } else if ((0, $fH8QX.Provider).isProvider(signerOrProvider)) {
            (0, $iqBKf.defineReadOnly)(this, "provider", signerOrProvider);
            (0, $iqBKf.defineReadOnly)(this, "signer", null);
        } else $e0ff61dc692dde55$var$logger.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
        (0, $iqBKf.defineReadOnly)(this, "callStatic", {});
        (0, $iqBKf.defineReadOnly)(this, "estimateGas", {});
        (0, $iqBKf.defineReadOnly)(this, "functions", {});
        (0, $iqBKf.defineReadOnly)(this, "populateTransaction", {});
        (0, $iqBKf.defineReadOnly)(this, "filters", {});
        {
            var uniqueFilters = {};
            Object.keys(this.interface.events).forEach(function(eventSignature) {
                var event = _this.interface.events[eventSignature];
                (0, $iqBKf.defineReadOnly)(_this.filters, eventSignature, function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return {
                        address: _this.address,
                        topics: _this.interface.encodeFilterTopics(event, args)
                    };
                });
                if (!uniqueFilters[event.name]) uniqueFilters[event.name] = [];
                uniqueFilters[event.name].push(eventSignature);
            });
            Object.keys(uniqueFilters).forEach(function(name) {
                var filters = uniqueFilters[name];
                if (filters.length === 1) (0, $iqBKf.defineReadOnly)(_this.filters, name, _this.filters[filters[0]]);
                else $e0ff61dc692dde55$var$logger.warn("Duplicate definition of ".concat(name, " (").concat(filters.join(", "), ")"));
            });
        }
        (0, $iqBKf.defineReadOnly)(this, "_runningEvents", {});
        (0, $iqBKf.defineReadOnly)(this, "_wrappedEmits", {});
        if (addressOrName == null) $e0ff61dc692dde55$var$logger.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
        (0, $iqBKf.defineReadOnly)(this, "address", addressOrName);
        if (this.provider) (0, $iqBKf.defineReadOnly)(this, "resolvedAddress", $e0ff61dc692dde55$var$resolveName(this.provider, addressOrName));
        else try {
            (0, $iqBKf.defineReadOnly)(this, "resolvedAddress", Promise.resolve((0, $hFSWi.getAddress)(addressOrName)));
        } catch (error) {
            // Without a provider, we cannot use ENS names
            $e0ff61dc692dde55$var$logger.throwError("provider is required to use ENS name as contract address", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "new Contract"
            });
        }
        var uniqueNames = {};
        var uniqueSignatures = {};
        Object.keys(this.interface.functions).forEach(function(signature) {
            var fragment = _this.interface.functions[signature];
            // Check that the signature is unique; if not the ABI generation has
            // not been cleaned or may be incorrectly generated
            if (uniqueSignatures[signature]) {
                $e0ff61dc692dde55$var$logger.warn("Duplicate ABI entry for ".concat(JSON.stringify(signature)));
                return;
            }
            uniqueSignatures[signature] = true;
            // Track unique names; we only expose bare named functions if they
            // are ambiguous
            {
                var name = fragment.name;
                if (!uniqueNames["%".concat(name)]) uniqueNames["%".concat(name)] = [];
                uniqueNames["%".concat(name)].push(signature);
            }
            if (_this[signature] == null) (0, $iqBKf.defineReadOnly)(_this, signature, $e0ff61dc692dde55$var$buildDefault(_this, fragment, true));
            // We do not collapse simple calls on this bucket, which allows
            // frameworks to safely use this without introspection as well as
            // allows decoding error recovery.
            if (_this.functions[signature] == null) (0, $iqBKf.defineReadOnly)(_this.functions, signature, $e0ff61dc692dde55$var$buildDefault(_this, fragment, false));
            if (_this.callStatic[signature] == null) (0, $iqBKf.defineReadOnly)(_this.callStatic, signature, $e0ff61dc692dde55$var$buildCall(_this, fragment, true));
            if (_this.populateTransaction[signature] == null) (0, $iqBKf.defineReadOnly)(_this.populateTransaction, signature, $e0ff61dc692dde55$var$buildPopulate(_this, fragment));
            if (_this.estimateGas[signature] == null) (0, $iqBKf.defineReadOnly)(_this.estimateGas, signature, $e0ff61dc692dde55$var$buildEstimate(_this, fragment));
        });
        Object.keys(uniqueNames).forEach(function(name) {
            // Ambiguous names to not get attached as bare names
            var signatures = uniqueNames[name];
            if (signatures.length > 1) return;
            // Strip off the leading "%" used for prototype protection
            name = name.substring(1);
            var signature = signatures[0];
            // If overwriting a member property that is null, swallow the error
            try {
                if (_this[name] == null) (0, $iqBKf.defineReadOnly)(_this, name, _this[signature]);
            } catch (e) {}
            if (_this.functions[name] == null) (0, $iqBKf.defineReadOnly)(_this.functions, name, _this.functions[signature]);
            if (_this.callStatic[name] == null) (0, $iqBKf.defineReadOnly)(_this.callStatic, name, _this.callStatic[signature]);
            if (_this.populateTransaction[name] == null) (0, $iqBKf.defineReadOnly)(_this.populateTransaction, name, _this.populateTransaction[signature]);
            if (_this.estimateGas[name] == null) (0, $iqBKf.defineReadOnly)(_this.estimateGas, name, _this.estimateGas[signature]);
        });
    }
    (0, $eDeHT._)(BaseContract, [
        {
            // @TODO: Allow timeout?
            key: "deployed",
            value: function deployed() {
                return this._deployed();
            }
        },
        {
            key: "_deployed",
            value: function _deployed(blockTag) {
                var _this = this;
                if (!this._deployedPromise) {
                    // If we were just deployed, we know the transaction we should occur in
                    if (this.deployTransaction) this._deployedPromise = this.deployTransaction.wait().then(function() {
                        return _this;
                    });
                    else // @TODO: Once we allow a timeout to be passed in, we will wait
                    // up to that many blocks for getCode
                    // Otherwise, poll for our code to be deployed
                    this._deployedPromise = this.provider.getCode(this.address, blockTag).then(function(code) {
                        if (code === "0x") $e0ff61dc692dde55$var$logger.throwError("contract not deployed", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                            contractAddress: _this.address,
                            operation: "getDeployed"
                        });
                        return _this;
                    });
                }
                return this._deployedPromise;
            }
        },
        {
            // @TODO:
            // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
            // @TODO:
            // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
            key: "fallback",
            value: function fallback(overrides) {
                var _this = this;
                if (!this.signer) $e0ff61dc692dde55$var$logger.throwError("sending a transactions require a signer", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "sendTransaction(fallback)"
                });
                var tx = (0, $iqBKf.shallowCopy)(overrides || {});
                [
                    "from",
                    "to"
                ].forEach(function(key) {
                    if (tx[key] == null) return;
                    $e0ff61dc692dde55$var$logger.throwError("cannot override " + key, (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: key
                    });
                });
                tx.to = this.resolvedAddress;
                return this.deployed().then(function() {
                    return _this.signer.sendTransaction(tx);
                });
            }
        },
        {
            // Reconnect to a different signer or provider
            key: "connect",
            value: function connect(signerOrProvider) {
                if (typeof signerOrProvider === "string") signerOrProvider = new (0, $3KRXu.VoidSigner)(signerOrProvider, this.provider);
                var contract = new this.constructor(this.address, this.interface, signerOrProvider);
                if (this.deployTransaction) (0, $iqBKf.defineReadOnly)(contract, "deployTransaction", this.deployTransaction);
                return contract;
            }
        },
        {
            // Re-attach to a different on-chain instance of this contract
            key: "attach",
            value: function attach(addressOrName) {
                return new this.constructor(addressOrName, this.interface, this.signer || this.provider);
            }
        },
        {
            key: "_normalizeRunningEvent",
            value: function _normalizeRunningEvent(runningEvent) {
                // Already have an instance of this event running; we can re-use it
                if (this._runningEvents[runningEvent.tag]) return this._runningEvents[runningEvent.tag];
                return runningEvent;
            }
        },
        {
            key: "_getRunningEvent",
            value: function _getRunningEvent(eventName) {
                if (typeof eventName === "string") {
                    // Listen for "error" events (if your contract has an error event, include
                    // the full signature to bypass this special event keyword)
                    if (eventName === "error") return this._normalizeRunningEvent(new $e0ff61dc692dde55$var$ErrorRunningEvent());
                    // Listen for any event that is registered
                    if (eventName === "event") return this._normalizeRunningEvent(new $e0ff61dc692dde55$var$RunningEvent("event", null));
                    // Listen for any event
                    if (eventName === "*") return this._normalizeRunningEvent(new $e0ff61dc692dde55$var$WildcardRunningEvent(this.address, this.interface));
                    // Get the event Fragment (throws if ambiguous/unknown event)
                    var fragment = this.interface.getEvent(eventName);
                    return this._normalizeRunningEvent(new $e0ff61dc692dde55$var$FragmentRunningEvent(this.address, this.interface, fragment));
                }
                // We have topics to filter by...
                if (eventName.topics && eventName.topics.length > 0) {
                    // Is it a known topichash? (throws if no matching topichash)
                    try {
                        var topic = eventName.topics[0];
                        if (typeof topic !== "string") throw new Error("invalid topic"); // @TODO: May happen for anonymous events
                        var fragment1 = this.interface.getEvent(topic);
                        return this._normalizeRunningEvent(new $e0ff61dc692dde55$var$FragmentRunningEvent(this.address, this.interface, fragment1, eventName.topics));
                    } catch (error) {}
                    // Filter by the unknown topichash
                    var filter = {
                        address: this.address,
                        topics: eventName.topics
                    };
                    return this._normalizeRunningEvent(new $e0ff61dc692dde55$var$RunningEvent($e0ff61dc692dde55$var$getEventTag(filter), filter));
                }
                return this._normalizeRunningEvent(new $e0ff61dc692dde55$var$WildcardRunningEvent(this.address, this.interface));
            }
        },
        {
            key: "_checkRunningEvents",
            value: function _checkRunningEvents(runningEvent) {
                if (runningEvent.listenerCount() === 0) {
                    delete this._runningEvents[runningEvent.tag];
                    // If we have a poller for this, remove it
                    var emit = this._wrappedEmits[runningEvent.tag];
                    if (emit && runningEvent.filter) {
                        this.provider.off(runningEvent.filter, emit);
                        delete this._wrappedEmits[runningEvent.tag];
                    }
                }
            }
        },
        {
            // Subclasses can override this to gracefully recover
            // from parse errors if they wish
            key: "_wrapEvent",
            value: function _wrapEvent(runningEvent, log, listener) {
                var _this = this;
                var event = (0, $iqBKf.deepCopy)(log);
                event.removeListener = function() {
                    if (!listener) return;
                    runningEvent.removeListener(listener);
                    _this._checkRunningEvents(runningEvent);
                };
                event.getBlock = function() {
                    return _this.provider.getBlock(log.blockHash);
                };
                event.getTransaction = function() {
                    return _this.provider.getTransaction(log.transactionHash);
                };
                event.getTransactionReceipt = function() {
                    return _this.provider.getTransactionReceipt(log.transactionHash);
                };
                // This may throw if the topics and data mismatch the signature
                runningEvent.prepareEvent(event);
                return event;
            }
        },
        {
            key: "_addEventListener",
            value: function _addEventListener(runningEvent, listener, once) {
                var _this = this;
                if (!this.provider) $e0ff61dc692dde55$var$logger.throwError("events require a provider or a signer with a provider", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "once"
                });
                runningEvent.addListener(listener, once);
                // Track this running event and its listeners (may already be there; but no hard in updating)
                this._runningEvents[runningEvent.tag] = runningEvent;
                // If we are not polling the provider, start polling
                if (!this._wrappedEmits[runningEvent.tag]) {
                    var wrappedEmit = function(log) {
                        var event = _this._wrapEvent(runningEvent, log, listener);
                        // Try to emit the result for the parameterized event...
                        if (event.decodeError == null) try {
                            var args = runningEvent.getEmit(event);
                            _this.emit.apply(_this, [
                                runningEvent.filter
                            ].concat((0, $enL5v._)(args)));
                        } catch (error) {
                            event.decodeError = error.error;
                        }
                        // Always emit "event" for fragment-base events
                        if (runningEvent.filter != null) _this.emit("event", event);
                        // Emit "error" if there was an error
                        if (event.decodeError != null) _this.emit("error", event.decodeError, event);
                    };
                    this._wrappedEmits[runningEvent.tag] = wrappedEmit;
                    // Special events, like "error" do not have a filter
                    if (runningEvent.filter != null) this.provider.on(runningEvent.filter, wrappedEmit);
                }
            }
        },
        {
            key: "queryFilter",
            value: function queryFilter(event, fromBlockOrBlockhash, toBlock) {
                var _this = this;
                var runningEvent = this._getRunningEvent(event);
                var filter = (0, $iqBKf.shallowCopy)(runningEvent.filter);
                if (typeof fromBlockOrBlockhash === "string" && (0, $2tHqU.isHexString)(fromBlockOrBlockhash, 32)) {
                    if (toBlock != null) $e0ff61dc692dde55$var$logger.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
                    filter.blockHash = fromBlockOrBlockhash;
                } else {
                    filter.fromBlock = fromBlockOrBlockhash != null ? fromBlockOrBlockhash : 0;
                    filter.toBlock = toBlock != null ? toBlock : "latest";
                }
                return this.provider.getLogs(filter).then(function(logs) {
                    return logs.map(function(log) {
                        return _this._wrapEvent(runningEvent, log, null);
                    });
                });
            }
        },
        {
            key: "on",
            value: function on(event, listener) {
                this._addEventListener(this._getRunningEvent(event), listener, false);
                return this;
            }
        },
        {
            key: "once",
            value: function once(event, listener) {
                this._addEventListener(this._getRunningEvent(event), listener, true);
                return this;
            }
        },
        {
            key: "emit",
            value: function emit(eventName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (!this.provider) return false;
                var runningEvent = this._getRunningEvent(eventName);
                var result = runningEvent.run(args) > 0;
                // May have drained all the "once" events; check for living events
                this._checkRunningEvents(runningEvent);
                return result;
            }
        },
        {
            key: "listenerCount",
            value: function listenerCount(eventName) {
                var _this = this;
                if (!this.provider) return 0;
                if (eventName == null) return Object.keys(this._runningEvents).reduce(function(accum, key) {
                    return accum + _this._runningEvents[key].listenerCount();
                }, 0);
                return this._getRunningEvent(eventName).listenerCount();
            }
        },
        {
            key: "listeners",
            value: function listeners(eventName) {
                if (!this.provider) return [];
                if (eventName == null) {
                    var result = [];
                    for(var tag in this._runningEvents)this._runningEvents[tag].listeners().forEach(function(listener) {
                        result.push(listener);
                    });
                    return result;
                }
                return this._getRunningEvent(eventName).listeners();
            }
        },
        {
            key: "removeAllListeners",
            value: function removeAllListeners(eventName) {
                if (!this.provider) return this;
                if (eventName == null) {
                    for(var tag in this._runningEvents){
                        var runningEvent = this._runningEvents[tag];
                        runningEvent.removeAllListeners();
                        this._checkRunningEvents(runningEvent);
                    }
                    return this;
                }
                // Delete any listeners
                var runningEvent1 = this._getRunningEvent(eventName);
                runningEvent1.removeAllListeners();
                this._checkRunningEvents(runningEvent1);
                return this;
            }
        },
        {
            key: "off",
            value: function off(eventName, listener) {
                if (!this.provider) return this;
                var runningEvent = this._getRunningEvent(eventName);
                runningEvent.removeListener(listener);
                this._checkRunningEvents(runningEvent);
                return this;
            }
        },
        {
            key: "removeListener",
            value: function removeListener(eventName, listener) {
                return this.off(eventName, listener);
            }
        }
    ], [
        {
            key: "getContractAddress",
            value: function getContractAddress1(transaction) {
                return (0, $hFSWi.getContractAddress)(transaction);
            }
        },
        {
            key: "getInterface",
            value: function getInterface(contractInterface) {
                if ((0, $hrmiK.Interface).isInterface(contractInterface)) return contractInterface;
                return new (0, $hrmiK.Interface)(contractInterface);
            }
        },
        {
            key: "isIndexed",
            value: function isIndexed(value) {
                return (0, $hrmiK.Indexed).isIndexed(value);
            }
        }
    ]);
    return BaseContract;
}();
var $e0ff61dc692dde55$export$8517d80acf00e19a = /*#__PURE__*/ function(BaseContract) {
    (0, $i0LXg._)(Contract, BaseContract);
    var _super = (0, $a1vXf._)(Contract);
    function Contract() {
        (0, $9j09T._)(this, Contract);
        return _super.apply(this, arguments);
    }
    return Contract;
}($e0ff61dc692dde55$export$304faa4fc17528db);
var $e0ff61dc692dde55$export$505569a6bf584fd9 = /*#__PURE__*/ function _target() {
    function ContractFactory(contractInterface, bytecode, signer) {
        (0, $9j09T._)(this, ContractFactory);
        var bytecodeHex = null;
        if (typeof bytecode === "string") bytecodeHex = bytecode;
        else if ((0, $2tHqU.isBytes)(bytecode)) bytecodeHex = (0, $2tHqU.hexlify)(bytecode);
        else if (bytecode && typeof bytecode.object === "string") // Allow the bytecode object from the Solidity compiler
        bytecodeHex = bytecode.object;
        else // Crash in the next verification step
        bytecodeHex = "!";
        // Make sure it is 0x prefixed
        if (bytecodeHex.substring(0, 2) !== "0x") bytecodeHex = "0x" + bytecodeHex;
        // Make sure the final result is valid bytecode
        if (!(0, $2tHqU.isHexString)(bytecodeHex) || bytecodeHex.length % 2) $e0ff61dc692dde55$var$logger.throwArgumentError("invalid bytecode", "bytecode", bytecode);
        // If we have a signer, make sure it is valid
        if (signer && !(0, $3KRXu.Signer).isSigner(signer)) $e0ff61dc692dde55$var$logger.throwArgumentError("invalid signer", "signer", signer);
        (0, $iqBKf.defineReadOnly)(this, "bytecode", bytecodeHex);
        (0, $iqBKf.defineReadOnly)(this, "interface", (0, $iqBKf.getStatic)(this instanceof ContractFactory ? this.constructor : void 0, "getInterface")(contractInterface));
        (0, $iqBKf.defineReadOnly)(this, "signer", signer || null);
    }
    (0, $eDeHT._)(ContractFactory, [
        {
            // @TODO: Future; rename to populateTransaction?
            key: "getDeployTransaction",
            value: function getDeployTransaction() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var tx = {};
                // If we have 1 additional argument, we allow transaction overrides
                if (args.length === this.interface.deploy.inputs.length + 1 && typeof args[args.length - 1] === "object") {
                    tx = (0, $iqBKf.shallowCopy)(args.pop());
                    for(var key in tx){
                        if (!$e0ff61dc692dde55$var$allowedTransactionKeys[key]) throw new Error("unknown transaction override " + key);
                    }
                }
                // Do not allow these to be overridden in a deployment transaction
                [
                    "data",
                    "from",
                    "to"
                ].forEach(function(key) {
                    if (tx[key] == null) return;
                    $e0ff61dc692dde55$var$logger.throwError("cannot override " + key, (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: key
                    });
                });
                if (tx.value) {
                    var value = (0, $7ryKd.BigNumber).from(tx.value);
                    if (!value.isZero() && !this.interface.deploy.payable) $e0ff61dc692dde55$var$logger.throwError("non-payable constructor cannot override value", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "overrides.value",
                        value: tx.value
                    });
                }
                // Make sure the call matches the constructor signature
                $e0ff61dc692dde55$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
                // Set the data to the bytecode + the encoded constructor arguments
                tx.data = (0, $2tHqU.hexlify)((0, $2tHqU.concat)([
                    this.bytecode,
                    this.interface.encodeDeploy(args)
                ]));
                return tx;
            }
        },
        {
            key: "deploy",
            value: function deploy() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return $e0ff61dc692dde55$var$__awaiter(this, void 0, void 0, function() {
                    var overrides, params, unsignedTx, tx, address, contract;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                overrides = {};
                                // If 1 extra parameter was passed in, it contains overrides
                                if (args.length === this.interface.deploy.inputs.length + 1) overrides = args.pop();
                                // Make sure the call matches the constructor signature
                                $e0ff61dc692dde55$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
                                return [
                                    4,
                                    $e0ff61dc692dde55$var$resolveAddresses(this.signer, args, this.interface.deploy.inputs)
                                ];
                            case 1:
                                params = _state.sent();
                                params.push(overrides);
                                // Get the deployment transaction (with optional overrides)
                                unsignedTx = this.getDeployTransaction.apply(this, (0, $enL5v._)(params));
                                return [
                                    4,
                                    this.signer.sendTransaction(unsignedTx)
                                ];
                            case 2:
                                tx = _state.sent();
                                address = (0, $iqBKf.getStatic)(this.constructor, "getContractAddress")(tx);
                                contract = (0, $iqBKf.getStatic)(this.constructor, "getContract")(address, this.interface, this.signer);
                                // Add the modified wait that wraps events
                                $e0ff61dc692dde55$var$addContractWait(contract, tx);
                                (0, $iqBKf.defineReadOnly)(contract, "deployTransaction", tx);
                                return [
                                    2,
                                    contract
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "attach",
            value: function attach(address) {
                return this.constructor.getContract(address, this.interface, this.signer);
            }
        },
        {
            key: "connect",
            value: function connect(signer) {
                return new this.constructor(this.interface, this.bytecode, signer);
            }
        }
    ], [
        {
            key: "fromSolidity",
            value: function fromSolidity(compilerOutput, signer) {
                if (compilerOutput == null) $e0ff61dc692dde55$var$logger.throwError("missing compiler output", (0, $ihGvV.Logger).errors.MISSING_ARGUMENT, {
                    argument: "compilerOutput"
                });
                if (typeof compilerOutput === "string") compilerOutput = JSON.parse(compilerOutput);
                var abi = compilerOutput.abi;
                var bytecode = null;
                if (compilerOutput.bytecode) bytecode = compilerOutput.bytecode;
                else if (compilerOutput.evm && compilerOutput.evm.bytecode) bytecode = compilerOutput.evm.bytecode;
                return new this(abi, bytecode, signer);
            }
        },
        {
            key: "getInterface",
            value: function getInterface(contractInterface) {
                return $e0ff61dc692dde55$export$8517d80acf00e19a.getInterface(contractInterface);
            }
        },
        {
            key: "getContractAddress",
            value: function getContractAddress1(tx) {
                return (0, $hFSWi.getContractAddress)(tx);
            }
        },
        {
            key: "getContract",
            value: function getContract(address, contractInterface, signer) {
                return new $e0ff61dc692dde55$export$8517d80acf00e19a(address, contractInterface, signer);
            }
        }
    ]);
    return ContractFactory;
}();

});
parcelRegister("jG7Zp", function(module, exports) {

$parcel$export(module.exports, "checkResultErrors", function () { return $e53823155eefe034$export$5546b9ec21157cc2; });
$parcel$export(module.exports, "Coder", function () { return $e53823155eefe034$export$2c0c39526f8bad46; });
$parcel$export(module.exports, "Writer", function () { return $e53823155eefe034$export$d7a960146e1a269e; });
$parcel$export(module.exports, "Reader", function () { return $e53823155eefe034$export$2f7a2f0e90c07dc4; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $2tHqU = parcelRequire("2tHqU");

var $7ryKd = parcelRequire("7ryKd");

var $iqBKf = parcelRequire("iqBKf");

var $ihGvV = parcelRequire("ihGvV");

var $73tL3 = parcelRequire("73tL3");
"use strict";
var $e53823155eefe034$var$logger = new (0, $ihGvV.Logger)((0, $73tL3.version));
function $e53823155eefe034$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    var errors = [];
    var checkErrors = function checkErrors1(path, object) {
        if (!Array.isArray(object)) return;
        for(var key in object){
            var childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
var $e53823155eefe034$export$2c0c39526f8bad46 = /*#__PURE__*/ function() {
    function Coder(name, type, localName, dynamic) {
        (0, $9j09T._)(this, Coder);
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    (0, $eDeHT._)(Coder, [
        {
            key: "_throwError",
            value: function _throwError(message, value) {
                $e53823155eefe034$var$logger.throwArgumentError(message, this.localName, value);
            }
        }
    ]);
    return Coder;
}();
var $e53823155eefe034$export$d7a960146e1a269e = /*#__PURE__*/ function() {
    function Writer(wordSize) {
        (0, $9j09T._)(this, Writer);
        (0, $iqBKf.defineReadOnly)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    (0, $eDeHT._)(Writer, [
        {
            key: "data",
            get: function get() {
                return (0, $2tHqU.hexConcat)(this._data);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._dataLength;
            }
        },
        {
            key: "_writeData",
            value: function _writeData(data) {
                this._data.push(data);
                this._dataLength += data.length;
                return data.length;
            }
        },
        {
            key: "appendWriter",
            value: function appendWriter(writer) {
                return this._writeData((0, $2tHqU.concat)(writer._data));
            }
        },
        {
            // Arrayish items; padded on the right to wordSize
            key: "writeBytes",
            value: function writeBytes(value) {
                var bytes = (0, $2tHqU.arrayify)(value);
                var paddingOffset = bytes.length % this.wordSize;
                if (paddingOffset) bytes = (0, $2tHqU.concat)([
                    bytes,
                    this._padding.slice(paddingOffset)
                ]);
                return this._writeData(bytes);
            }
        },
        {
            key: "_getValue",
            value: function _getValue(value) {
                var bytes = (0, $2tHqU.arrayify)((0, $7ryKd.BigNumber).from(value));
                if (bytes.length > this.wordSize) $e53823155eefe034$var$logger.throwError("value out-of-bounds", (0, $ihGvV.Logger).errors.BUFFER_OVERRUN, {
                    length: this.wordSize,
                    offset: bytes.length
                });
                if (bytes.length % this.wordSize) bytes = (0, $2tHqU.concat)([
                    this._padding.slice(bytes.length % this.wordSize),
                    bytes
                ]);
                return bytes;
            }
        },
        {
            // BigNumberish items; padded on the left to wordSize
            key: "writeValue",
            value: function writeValue(value) {
                return this._writeData(this._getValue(value));
            }
        },
        {
            key: "writeUpdatableValue",
            value: function writeUpdatableValue() {
                var _this = this;
                var offset = this._data.length;
                this._data.push(this._padding);
                this._dataLength += this.wordSize;
                return function(value) {
                    _this._data[offset] = _this._getValue(value);
                };
            }
        }
    ]);
    return Writer;
}();
var $e53823155eefe034$export$2f7a2f0e90c07dc4 = /*#__PURE__*/ function() {
    function Reader(data, wordSize, coerceFunc, allowLoose) {
        (0, $9j09T._)(this, Reader);
        (0, $iqBKf.defineReadOnly)(this, "_data", (0, $2tHqU.arrayify)(data));
        (0, $iqBKf.defineReadOnly)(this, "wordSize", wordSize || 32);
        (0, $iqBKf.defineReadOnly)(this, "_coerceFunc", coerceFunc);
        (0, $iqBKf.defineReadOnly)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    (0, $eDeHT._)(Reader, [
        {
            key: "data",
            get: function get() {
                return (0, $2tHqU.hexlify)(this._data);
            }
        },
        {
            key: "consumed",
            get: function get() {
                return this._offset;
            }
        },
        {
            key: "coerce",
            value: function coerce(name, value) {
                if (this._coerceFunc) return this._coerceFunc(name, value);
                return Reader.coerce(name, value);
            }
        },
        {
            key: "_peekBytes",
            value: function _peekBytes(offset, length, loose) {
                var alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
                if (this._offset + alignedLength > this._data.length) {
                    if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
                    else $e53823155eefe034$var$logger.throwError("data out-of-bounds", (0, $ihGvV.Logger).errors.BUFFER_OVERRUN, {
                        length: this._data.length,
                        offset: this._offset + alignedLength
                    });
                }
                return this._data.slice(this._offset, this._offset + alignedLength);
            }
        },
        {
            key: "subReader",
            value: function subReader(offset) {
                return new Reader(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
            }
        },
        {
            key: "readBytes",
            value: function readBytes(length, loose) {
                var bytes = this._peekBytes(0, length, !!loose);
                this._offset += bytes.length;
                // @TODO: Make sure the length..end bytes are all 0?
                return bytes.slice(0, length);
            }
        },
        {
            key: "readValue",
            value: function readValue() {
                return (0, $7ryKd.BigNumber).from(this.readBytes(this.wordSize));
            }
        }
    ], [
        {
            key: "coerce",
            value: // The default Coerce function
            function coerce(name, value) {
                var match = name.match("^u?int([0-9]+)$");
                if (match && parseInt(match[1]) <= 48) value = value.toNumber();
                return value;
            }
        }
    ]);
    return Reader;
}();

});
parcelRegister("2tHqU", function(module, exports) {

$parcel$export(module.exports, "isBytesLike", function () { return $1cdffb1332311751$export$9a14abb1a440cd5e; });
$parcel$export(module.exports, "isHexString", function () { return $1cdffb1332311751$export$b02a40aff8e4ad18; });
$parcel$export(module.exports, "isBytes", function () { return $1cdffb1332311751$export$c6fabfbfd097fc30; });
$parcel$export(module.exports, "arrayify", function () { return $1cdffb1332311751$export$3131421a7d01b4fb; });
$parcel$export(module.exports, "concat", function () { return $1cdffb1332311751$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "stripZeros", function () { return $1cdffb1332311751$export$a8f4574d0e56446c; });
$parcel$export(module.exports, "zeroPad", function () { return $1cdffb1332311751$export$3cdc770bf8b2ed3d; });
$parcel$export(module.exports, "hexlify", function () { return $1cdffb1332311751$export$2b0d6b5fbe698c70; });
$parcel$export(module.exports, "hexDataLength", function () { return $1cdffb1332311751$export$13882f896d3c0683; });
$parcel$export(module.exports, "hexDataSlice", function () { return $1cdffb1332311751$export$15da666eba198c18; });
$parcel$export(module.exports, "hexConcat", function () { return $1cdffb1332311751$export$6d4b99629b38754a; });
$parcel$export(module.exports, "hexValue", function () { return $1cdffb1332311751$export$6916af760a341dd3; });
$parcel$export(module.exports, "hexStripZeros", function () { return $1cdffb1332311751$export$967bc0082a978949; });
$parcel$export(module.exports, "hexZeroPad", function () { return $1cdffb1332311751$export$e9c46a54370b47e8; });
$parcel$export(module.exports, "splitSignature", function () { return $1cdffb1332311751$export$7fb170f1e457988f; });
$parcel$export(module.exports, "joinSignature", function () { return $1cdffb1332311751$export$71bb9d78a59bbe25; });

var $jquDQ = parcelRequire("jquDQ");

var $ihGvV = parcelRequire("ihGvV");

var $4h6f2 = parcelRequire("4h6f2");
"use strict";
var $1cdffb1332311751$var$logger = new (0, $ihGvV.Logger)((0, $4h6f2.version));
///////////////////////////////
function $1cdffb1332311751$var$isHexable(value) {
    return !!value.toHexString;
}
function $1cdffb1332311751$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        var args = Array.prototype.slice.call(arguments);
        return $1cdffb1332311751$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $1cdffb1332311751$export$9a14abb1a440cd5e(value) {
    return $1cdffb1332311751$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $1cdffb1332311751$export$c6fabfbfd097fc30(value);
}
function $1cdffb1332311751$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $1cdffb1332311751$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$1cdffb1332311751$var$isInteger(value.length) || value.length < 0) return false;
    for(var i = 0; i < value.length; i++){
        var v = value[i];
        if (!$1cdffb1332311751$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $1cdffb1332311751$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $1cdffb1332311751$var$logger.checkSafeUint53(value, "invalid arrayify value");
        var result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $1cdffb1332311751$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($1cdffb1332311751$var$isHexable(value)) value = value.toHexString();
    if ($1cdffb1332311751$export$b02a40aff8e4ad18(value)) {
        var hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0x0" + hex.substring(2);
            else if (options.hexPad === "right") hex += "0";
            else $1cdffb1332311751$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        var result1 = [];
        for(var i = 0; i < hex.length; i += 2)result1.push(parseInt(hex.substring(i, i + 2), 16));
        return $1cdffb1332311751$var$addSlice(new Uint8Array(result1));
    }
    if ($1cdffb1332311751$export$c6fabfbfd097fc30(value)) return $1cdffb1332311751$var$addSlice(new Uint8Array(value));
    return $1cdffb1332311751$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $1cdffb1332311751$export$ee1b3e54f0441b22(items) {
    var objects = items.map(function(item) {
        return $1cdffb1332311751$export$3131421a7d01b4fb(item);
    });
    var length = objects.reduce(function(accum, item) {
        return accum + item.length;
    }, 0);
    var result = new Uint8Array(length);
    objects.reduce(function(offset, object) {
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $1cdffb1332311751$var$addSlice(result);
}
function $1cdffb1332311751$export$a8f4574d0e56446c(value) {
    var result = $1cdffb1332311751$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    var start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $1cdffb1332311751$export$3cdc770bf8b2ed3d(value, length) {
    value = $1cdffb1332311751$export$3131421a7d01b4fb(value);
    if (value.length > length) $1cdffb1332311751$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    var result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $1cdffb1332311751$var$addSlice(result);
}
function $1cdffb1332311751$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
var $1cdffb1332311751$var$HexCharacters = "0123456789abcdef";
function $1cdffb1332311751$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $1cdffb1332311751$var$logger.checkSafeUint53(value, "invalid hexlify value");
        var hex = "";
        while(value){
            hex = $1cdffb1332311751$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if ((typeof value === "undefined" ? "undefined" : (0, $jquDQ._)(value)) === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($1cdffb1332311751$var$isHexable(value)) return value.toHexString();
    if ($1cdffb1332311751$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $1cdffb1332311751$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($1cdffb1332311751$export$c6fabfbfd097fc30(value)) {
        var result = "0x";
        for(var i = 0; i < value.length; i++){
            var v = value[i];
            result += $1cdffb1332311751$var$HexCharacters[(v & 0xf0) >> 4] + $1cdffb1332311751$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $1cdffb1332311751$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $1cdffb1332311751$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $1cdffb1332311751$export$2b0d6b5fbe698c70(data);
    else if (!$1cdffb1332311751$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $1cdffb1332311751$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $1cdffb1332311751$export$2b0d6b5fbe698c70(data);
    else if (!$1cdffb1332311751$export$b02a40aff8e4ad18(data) || data.length % 2) $1cdffb1332311751$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $1cdffb1332311751$export$6d4b99629b38754a(items) {
    var result = "0x";
    items.forEach(function(item) {
        result += $1cdffb1332311751$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $1cdffb1332311751$export$6916af760a341dd3(value) {
    var trimmed = $1cdffb1332311751$export$967bc0082a978949($1cdffb1332311751$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $1cdffb1332311751$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $1cdffb1332311751$export$2b0d6b5fbe698c70(value);
    if (!$1cdffb1332311751$export$b02a40aff8e4ad18(value)) $1cdffb1332311751$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    var offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $1cdffb1332311751$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $1cdffb1332311751$export$2b0d6b5fbe698c70(value);
    else if (!$1cdffb1332311751$export$b02a40aff8e4ad18(value)) $1cdffb1332311751$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $1cdffb1332311751$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $1cdffb1332311751$export$7fb170f1e457988f(signature) {
    var result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0
    };
    if ($1cdffb1332311751$export$9a14abb1a440cd5e(signature)) {
        var bytes = $1cdffb1332311751$export$3131421a7d01b4fb(signature);
        if (bytes.length !== 65) $1cdffb1332311751$var$logger.throwArgumentError("invalid signature string; must be 65 bytes", "signature", signature);
        // Get the r, s and v
        result.r = $1cdffb1332311751$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
        result.s = $1cdffb1332311751$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        result.v = bytes[64];
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $1cdffb1332311751$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $1cdffb1332311751$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            var vs = $1cdffb1332311751$export$3cdc770bf8b2ed3d($1cdffb1332311751$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $1cdffb1332311751$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            var recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $1cdffb1332311751$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            var s = $1cdffb1332311751$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $1cdffb1332311751$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $1cdffb1332311751$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            var recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $1cdffb1332311751$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$1cdffb1332311751$export$b02a40aff8e4ad18(result.r)) $1cdffb1332311751$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $1cdffb1332311751$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$1cdffb1332311751$export$b02a40aff8e4ad18(result.s)) $1cdffb1332311751$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $1cdffb1332311751$export$e9c46a54370b47e8(result.s, 32);
        var vs1 = $1cdffb1332311751$export$3131421a7d01b4fb(result.s);
        if (vs1[0] >= 128) $1cdffb1332311751$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs1[0] |= 0x80;
        var _vs = $1cdffb1332311751$export$2b0d6b5fbe698c70(vs1);
        if (result._vs) {
            if (!$1cdffb1332311751$export$b02a40aff8e4ad18(result._vs)) $1cdffb1332311751$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $1cdffb1332311751$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $1cdffb1332311751$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    return result;
}
function $1cdffb1332311751$export$71bb9d78a59bbe25(signature) {
    signature = $1cdffb1332311751$export$7fb170f1e457988f(signature);
    return $1cdffb1332311751$export$2b0d6b5fbe698c70($1cdffb1332311751$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRegister("ihGvV", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $d4facae27fdd990b$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "Logger", function () { return $d4facae27fdd990b$export$efa9a398d6368992; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $RVNgz = parcelRequire("RVNgz");
"use strict";
var $d4facae27fdd990b$var$_permanentCensorErrors = false;
var $d4facae27fdd990b$var$_censorErrors = false;
var $d4facae27fdd990b$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
var $d4facae27fdd990b$var$_logLevel = $d4facae27fdd990b$var$LogLevels["default"];
var $d4facae27fdd990b$var$_globalLogger = null;
function $d4facae27fdd990b$var$_checkNormalize() {
    try {
        var missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach(function(form) {
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
var $d4facae27fdd990b$var$_normalizeError = $d4facae27fdd990b$var$_checkNormalize();
var $d4facae27fdd990b$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($d4facae27fdd990b$export$243e62d78d3b544d || ($d4facae27fdd990b$export$243e62d78d3b544d = {}));
var $d4facae27fdd990b$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})($d4facae27fdd990b$export$d4e71bc0b80dc0fb || ($d4facae27fdd990b$export$d4e71bc0b80dc0fb = {}));
var $d4facae27fdd990b$var$HEX = "0123456789abcdef";
var $d4facae27fdd990b$export$efa9a398d6368992 = /*#__PURE__*/ function() {
    function Logger(version) {
        (0, $9j09T._)(this, Logger);
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    (0, $eDeHT._)(Logger, [
        {
            key: "_log",
            value: function _log(logLevel, args) {
                var level = logLevel.toLowerCase();
                if ($d4facae27fdd990b$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
                if ($d4facae27fdd990b$var$_logLevel > $d4facae27fdd990b$var$LogLevels[level]) return;
                console.log.apply(console, args);
            }
        },
        {
            key: "debug",
            value: function debug() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._log(Logger.levels.DEBUG, args);
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._log(Logger.levels.INFO, args);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._log(Logger.levels.WARNING, args);
            }
        },
        {
            key: "makeError",
            value: function makeError(message, code, params) {
                // Errors are being censored
                if ($d4facae27fdd990b$var$_censorErrors) return this.makeError("censored error", code, {});
                if (!code) code = Logger.errors.UNKNOWN_ERROR;
                if (!params) params = {};
                var messageDetails = [];
                Object.keys(params).forEach(function(key) {
                    var value = params[key];
                    try {
                        if (value instanceof Uint8Array) {
                            var hex = "";
                            for(var i = 0; i < value.length; i++){
                                hex += $d4facae27fdd990b$var$HEX[value[i] >> 4];
                                hex += $d4facae27fdd990b$var$HEX[value[i] & 0x0f];
                            }
                            messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                        } else messageDetails.push(key + "=" + JSON.stringify(value));
                    } catch (error) {
                        messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
                    }
                });
                messageDetails.push("code=".concat(code));
                messageDetails.push("version=".concat(this.version));
                var reason = message;
                if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
                // @TODO: Any??
                var error = new Error(message);
                error.reason = reason;
                error.code = code;
                Object.keys(params).forEach(function(key) {
                    error[key] = params[key];
                });
                return error;
            }
        },
        {
            key: "throwError",
            value: function throwError(message, code, params) {
                throw this.makeError(message, code, params);
            }
        },
        {
            key: "throwArgumentError",
            value: function throwArgumentError(message, name, value) {
                return this.throwError(message, Logger.errors.INVALID_ARGUMENT, {
                    argument: name,
                    value: value
                });
            }
        },
        {
            key: "assert",
            value: function assert(condition, message, code, params) {
                if (!!condition) return;
                this.throwError(message, code, params);
            }
        },
        {
            key: "assertArgument",
            value: function assertArgument(condition, message, name, value) {
                if (!!condition) return;
                this.throwArgumentError(message, name, value);
            }
        },
        {
            key: "checkNormalize",
            value: function checkNormalize(message) {
                if (message == null) message = "platform missing String.prototype.normalize";
                if ($d4facae27fdd990b$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "String.prototype.normalize",
                    form: $d4facae27fdd990b$var$_normalizeError
                });
            }
        },
        {
            key: "checkSafeUint53",
            value: function checkSafeUint53(value, message) {
                if (typeof value !== "number") return;
                if (message == null) message = "value not safe";
                if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, Logger.errors.NUMERIC_FAULT, {
                    operation: "checkSafeInteger",
                    fault: "out-of-safe-range",
                    value: value
                });
                if (value % 1) this.throwError(message, Logger.errors.NUMERIC_FAULT, {
                    operation: "checkSafeInteger",
                    fault: "non-integer",
                    value: value
                });
            }
        },
        {
            key: "checkArgumentCount",
            value: function checkArgumentCount(count, expectedCount, message) {
                if (message) message = ": " + message;
                else message = "";
                if (count < expectedCount) this.throwError("missing argument" + message, Logger.errors.MISSING_ARGUMENT, {
                    count: count,
                    expectedCount: expectedCount
                });
                if (count > expectedCount) this.throwError("too many arguments" + message, Logger.errors.UNEXPECTED_ARGUMENT, {
                    count: count,
                    expectedCount: expectedCount
                });
            }
        },
        {
            key: "checkNew",
            value: function checkNew(target, kind) {
                if (target === Object || target == null) this.throwError("missing new", Logger.errors.MISSING_NEW, {
                    name: kind.name
                });
            }
        },
        {
            key: "checkAbstract",
            value: function checkAbstract(target, kind) {
                if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", Logger.errors.UNSUPPORTED_OPERATION, {
                    name: target.name,
                    operation: "new"
                });
                else if (target === Object || target == null) this.throwError("missing new", Logger.errors.MISSING_NEW, {
                    name: kind.name
                });
            }
        }
    ], [
        {
            key: "globalLogger",
            value: function globalLogger() {
                if (!$d4facae27fdd990b$var$_globalLogger) $d4facae27fdd990b$var$_globalLogger = new Logger((0, $RVNgz.version));
                return $d4facae27fdd990b$var$_globalLogger;
            }
        },
        {
            key: "setCensorship",
            value: function setCensorship(censorship, permanent) {
                if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "setCensorship"
                });
                if ($d4facae27fdd990b$var$_permanentCensorErrors) {
                    if (!censorship) return;
                    this.globalLogger().throwError("error censorship permanent", Logger.errors.UNSUPPORTED_OPERATION, {
                        operation: "setCensorship"
                    });
                }
                $d4facae27fdd990b$var$_censorErrors = !!censorship;
                $d4facae27fdd990b$var$_permanentCensorErrors = !!permanent;
            }
        },
        {
            key: "setLogLevel",
            value: function setLogLevel(logLevel) {
                var level = $d4facae27fdd990b$var$LogLevels[logLevel.toLowerCase()];
                if (level == null) {
                    Logger.globalLogger().warn("invalid log level - " + logLevel);
                    return;
                }
                $d4facae27fdd990b$var$_logLevel = level;
            }
        },
        {
            key: "from",
            value: function from(version) {
                return new Logger(version);
            }
        }
    ]);
    return Logger;
}();
$d4facae27fdd990b$export$efa9a398d6368992.errors = $d4facae27fdd990b$export$d4e71bc0b80dc0fb;
$d4facae27fdd990b$export$efa9a398d6368992.levels = $d4facae27fdd990b$export$243e62d78d3b544d;

});
parcelRegister("RVNgz", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $0a21c7f5ce295600$export$83d89fbfd8236492; });
var $0a21c7f5ce295600$export$83d89fbfd8236492 = "logger/5.5.0";

});


parcelRegister("4h6f2", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $31cd97645dd45f35$export$83d89fbfd8236492; });
var $31cd97645dd45f35$export$83d89fbfd8236492 = "bytes/5.5.0";

});


parcelRegister("7ryKd", function(module, exports) {

$parcel$export(module.exports, "isBigNumberish", function () { return $56b6018c516fea9f$export$a3d0a7fa9b65683b; });
$parcel$export(module.exports, "BigNumber", function () { return $56b6018c516fea9f$export$d97aa349ed20696; });
$parcel$export(module.exports, "_base36To16", function () { return $56b6018c516fea9f$export$51e4a08295f7770f; });
$parcel$export(module.exports, "_base16To36", function () { return $56b6018c516fea9f$export$1293db5d29c264ff; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $jquDQ = parcelRequire("jquDQ");

var $iQTsY = parcelRequire("iQTsY");

var $2tHqU = parcelRequire("2tHqU");

var $ihGvV = parcelRequire("ihGvV");

var $7fn1r = parcelRequire("7fn1r");
"use strict";
var $56b6018c516fea9f$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY))).BN;
var $56b6018c516fea9f$var$logger = new (0, $ihGvV.Logger)((0, $7fn1r.version));
var $56b6018c516fea9f$var$_constructorGuard = {};
var $56b6018c516fea9f$var$MAX_SAFE = 0x1fffffffffffff;
function $56b6018c516fea9f$export$a3d0a7fa9b65683b(value) {
    return value != null && ($56b6018c516fea9f$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $2tHqU.isHexString)(value) || (typeof value === "undefined" ? "undefined" : (0, $jquDQ._)(value)) === "bigint" || (0, $2tHqU.isBytes)(value));
}
// Only warn about passing 10 into radix once
var $56b6018c516fea9f$var$_warnedToStringRadix = false;
var $56b6018c516fea9f$export$d97aa349ed20696 = /*#__PURE__*/ function _target() {
    function BigNumber(constructorGuard, hex) {
        (0, $9j09T._)(this, BigNumber);
        $56b6018c516fea9f$var$logger.checkNew(this instanceof BigNumber ? this.constructor : void 0, BigNumber);
        if (constructorGuard !== $56b6018c516fea9f$var$_constructorGuard) $56b6018c516fea9f$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    (0, $eDeHT._)(BigNumber, [
        {
            key: "fromTwos",
            value: function fromTwos(value) {
                return $56b6018c516fea9f$var$toBigNumber($56b6018c516fea9f$var$toBN(this).fromTwos(value));
            }
        },
        {
            key: "toTwos",
            value: function toTwos(value) {
                return $56b6018c516fea9f$var$toBigNumber($56b6018c516fea9f$var$toBN(this).toTwos(value));
            }
        },
        {
            key: "abs",
            value: function abs() {
                if (this._hex[0] === "-") return BigNumber.from(this._hex.substring(1));
                return this;
            }
        },
        {
            key: "add",
            value: function add(other) {
                return $56b6018c516fea9f$var$toBigNumber($56b6018c516fea9f$var$toBN(this).add($56b6018c516fea9f$var$toBN(other)));
            }
        },
        {
            key: "sub",
            value: function sub(other) {
                return $56b6018c516fea9f$var$toBigNumber($56b6018c516fea9f$var$toBN(this).sub($56b6018c516fea9f$var$toBN(other)));
            }
        },
        {
            key: "div",
            value: function div(other) {
                var o = BigNumber.from(other);
                if (o.isZero()) $56b6018c516fea9f$var$throwFault("division by zero", "div");
                return $56b6018c516fea9f$var$toBigNumber($56b6018c516fea9f$var$toBN(this).div($56b6018c516fea9f$var$toBN(other)));
            }
        },
        {
            key: "mul",
            value: function mul(other) {
                return $56b6018c516fea9f$var$toBigNumber($56b6018c516fea9f$var$toBN(this).mul($56b6018c516fea9f$var$toBN(other)));
            }
        },
        {
            key: "mod",
            value: function mod(other) {
                var value = $56b6018c516fea9f$var$toBN(other);
                if (value.isNeg()) $56b6018c516fea9f$var$throwFault("cannot modulo negative values", "mod");
                return $56b6018c516fea9f$var$toBigNumber($56b6018c516fea9f$var$toBN(this).umod(value));
            }
        },
        {
            key: "pow",
            value: function pow(other) {
                var value = $56b6018c516fea9f$var$toBN(other);
                if (value.isNeg()) $56b6018c516fea9f$var$throwFault("cannot raise to negative values", "pow");
                return $56b6018c516fea9f$var$toBigNumber($56b6018c516fea9f$var$toBN(this).pow(value));
            }
        },
        {
            key: "and",
            value: function and(other) {
                var value = $56b6018c516fea9f$var$toBN(other);
                if (this.isNegative() || value.isNeg()) $56b6018c516fea9f$var$throwFault("cannot 'and' negative values", "and");
                return $56b6018c516fea9f$var$toBigNumber($56b6018c516fea9f$var$toBN(this).and(value));
            }
        },
        {
            key: "or",
            value: function or(other) {
                var value = $56b6018c516fea9f$var$toBN(other);
                if (this.isNegative() || value.isNeg()) $56b6018c516fea9f$var$throwFault("cannot 'or' negative values", "or");
                return $56b6018c516fea9f$var$toBigNumber($56b6018c516fea9f$var$toBN(this).or(value));
            }
        },
        {
            key: "xor",
            value: function xor(other) {
                var value = $56b6018c516fea9f$var$toBN(other);
                if (this.isNegative() || value.isNeg()) $56b6018c516fea9f$var$throwFault("cannot 'xor' negative values", "xor");
                return $56b6018c516fea9f$var$toBigNumber($56b6018c516fea9f$var$toBN(this).xor(value));
            }
        },
        {
            key: "mask",
            value: function mask(value) {
                if (this.isNegative() || value < 0) $56b6018c516fea9f$var$throwFault("cannot mask negative values", "mask");
                return $56b6018c516fea9f$var$toBigNumber($56b6018c516fea9f$var$toBN(this).maskn(value));
            }
        },
        {
            key: "shl",
            value: function shl(value) {
                if (this.isNegative() || value < 0) $56b6018c516fea9f$var$throwFault("cannot shift negative values", "shl");
                return $56b6018c516fea9f$var$toBigNumber($56b6018c516fea9f$var$toBN(this).shln(value));
            }
        },
        {
            key: "shr",
            value: function shr(value) {
                if (this.isNegative() || value < 0) $56b6018c516fea9f$var$throwFault("cannot shift negative values", "shr");
                return $56b6018c516fea9f$var$toBigNumber($56b6018c516fea9f$var$toBN(this).shrn(value));
            }
        },
        {
            key: "eq",
            value: function eq(other) {
                return $56b6018c516fea9f$var$toBN(this).eq($56b6018c516fea9f$var$toBN(other));
            }
        },
        {
            key: "lt",
            value: function lt(other) {
                return $56b6018c516fea9f$var$toBN(this).lt($56b6018c516fea9f$var$toBN(other));
            }
        },
        {
            key: "lte",
            value: function lte(other) {
                return $56b6018c516fea9f$var$toBN(this).lte($56b6018c516fea9f$var$toBN(other));
            }
        },
        {
            key: "gt",
            value: function gt(other) {
                return $56b6018c516fea9f$var$toBN(this).gt($56b6018c516fea9f$var$toBN(other));
            }
        },
        {
            key: "gte",
            value: function gte(other) {
                return $56b6018c516fea9f$var$toBN(this).gte($56b6018c516fea9f$var$toBN(other));
            }
        },
        {
            key: "isNegative",
            value: function isNegative() {
                return this._hex[0] === "-";
            }
        },
        {
            key: "isZero",
            value: function isZero() {
                return $56b6018c516fea9f$var$toBN(this).isZero();
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                try {
                    return $56b6018c516fea9f$var$toBN(this).toNumber();
                } catch (error) {
                    $56b6018c516fea9f$var$throwFault("overflow", "toNumber", this.toString());
                }
                return null;
            }
        },
        {
            key: "toBigInt",
            value: function toBigInt() {
                try {
                    return BigInt(this.toString());
                } catch (e) {}
                return $56b6018c516fea9f$var$logger.throwError("this platform does not support BigInt", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                    value: this.toString()
                });
            }
        },
        {
            key: "toString",
            value: function toString() {
                // Lots of people expect this, which we do not support, so check (See: #889)
                if (arguments.length > 0) {
                    if (arguments[0] === 10) {
                        if (!$56b6018c516fea9f$var$_warnedToStringRadix) {
                            $56b6018c516fea9f$var$_warnedToStringRadix = true;
                            $56b6018c516fea9f$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                        }
                    } else if (arguments[0] === 16) $56b6018c516fea9f$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $ihGvV.Logger).errors.UNEXPECTED_ARGUMENT, {});
                    else $56b6018c516fea9f$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $ihGvV.Logger).errors.UNEXPECTED_ARGUMENT, {});
                }
                return $56b6018c516fea9f$var$toBN(this).toString(10);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return this._hex;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(key) {
                return {
                    type: "BigNumber",
                    hex: this.toHexString()
                };
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (value instanceof BigNumber) return value;
                if (typeof value === "string") {
                    if (value.match(/^-?0x[0-9a-f]+$/i)) return new BigNumber($56b6018c516fea9f$var$_constructorGuard, $56b6018c516fea9f$var$toHex(value));
                    if (value.match(/^-?[0-9]+$/)) return new BigNumber($56b6018c516fea9f$var$_constructorGuard, $56b6018c516fea9f$var$toHex(new $56b6018c516fea9f$var$BN(value)));
                    return $56b6018c516fea9f$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
                }
                if (typeof value === "number") {
                    if (value % 1) $56b6018c516fea9f$var$throwFault("underflow", "BigNumber.from", value);
                    if (value >= $56b6018c516fea9f$var$MAX_SAFE || value <= -$56b6018c516fea9f$var$MAX_SAFE) $56b6018c516fea9f$var$throwFault("overflow", "BigNumber.from", value);
                    return BigNumber.from(String(value));
                }
                var anyValue = value;
                if ((typeof anyValue === "undefined" ? "undefined" : (0, $jquDQ._)(anyValue)) === "bigint") return BigNumber.from(anyValue.toString());
                if ((0, $2tHqU.isBytes)(anyValue)) return BigNumber.from((0, $2tHqU.hexlify)(anyValue));
                if (anyValue) {
                    // Hexable interface (takes priority)
                    if (anyValue.toHexString) {
                        var hex = anyValue.toHexString();
                        if (typeof hex === "string") return BigNumber.from(hex);
                    } else {
                        // For now, handle legacy JSON-ified values (goes away in v6)
                        var hex1 = anyValue._hex;
                        // New-form JSON
                        if (hex1 == null && anyValue.type === "BigNumber") hex1 = anyValue.hex;
                        if (typeof hex1 === "string") {
                            if ((0, $2tHqU.isHexString)(hex1) || hex1[0] === "-" && (0, $2tHqU.isHexString)(hex1.substring(1))) return BigNumber.from(hex1);
                        }
                    }
                }
                return $56b6018c516fea9f$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
            }
        },
        {
            key: "isBigNumber",
            value: function isBigNumber(value) {
                return !!(value && value._isBigNumber);
            }
        }
    ]);
    return BigNumber;
}();
// Normalize the hex string
function $56b6018c516fea9f$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $56b6018c516fea9f$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $56b6018c516fea9f$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $56b6018c516fea9f$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $56b6018c516fea9f$var$toBigNumber(value) {
    return $56b6018c516fea9f$export$d97aa349ed20696.from($56b6018c516fea9f$var$toHex(value));
}
function $56b6018c516fea9f$var$toBN(value) {
    var hex = $56b6018c516fea9f$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $56b6018c516fea9f$var$BN("-" + hex.substring(3), 16);
    return new $56b6018c516fea9f$var$BN(hex.substring(2), 16);
}
function $56b6018c516fea9f$var$throwFault(fault, operation, value) {
    var params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $56b6018c516fea9f$var$logger.throwError(fault, (0, $ihGvV.Logger).errors.NUMERIC_FAULT, params);
}
function $56b6018c516fea9f$export$51e4a08295f7770f(value) {
    return new $56b6018c516fea9f$var$BN(value, 36).toString(16);
}
function $56b6018c516fea9f$export$1293db5d29c264ff(value) {
    return new $56b6018c516fea9f$var$BN(value, 16).toString(36);
}

});
parcelRegister("iQTsY", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("8uCnf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7fn1r", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $546bcadf18d37b99$export$83d89fbfd8236492; });
var $546bcadf18d37b99$export$83d89fbfd8236492 = "bignumber/5.5.0";

});


parcelRegister("iqBKf", function(module, exports) {

$parcel$export(module.exports, "defineReadOnly", function () { return $d6a7ef096dfca659$export$104236534534f9be; });
$parcel$export(module.exports, "getStatic", function () { return $d6a7ef096dfca659$export$f695fbbf3cdaaf47; });
$parcel$export(module.exports, "resolveProperties", function () { return $d6a7ef096dfca659$export$d503dd157d963b60; });
$parcel$export(module.exports, "checkProperties", function () { return $d6a7ef096dfca659$export$ae5a316ba623b73a; });
$parcel$export(module.exports, "shallowCopy", function () { return $d6a7ef096dfca659$export$9c13236873b118a5; });
$parcel$export(module.exports, "deepCopy", function () { return $d6a7ef096dfca659$export$6c40052bed430212; });
$parcel$export(module.exports, "Description", function () { return $d6a7ef096dfca659$export$393edc798c47379d; });

var $9j09T = parcelRequire("9j09T");

var $jquDQ = parcelRequire("jquDQ");

var $itJXR = parcelRequire("itJXR");

var $ihGvV = parcelRequire("ihGvV");

var $8mobb = parcelRequire("8mobb");
"use strict";
var $d6a7ef096dfca659$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d6a7ef096dfca659$var$logger = new (0, $ihGvV.Logger)((0, $8mobb.version));
function $d6a7ef096dfca659$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $d6a7ef096dfca659$export$f695fbbf3cdaaf47(ctor, key) {
    for(var i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $d6a7ef096dfca659$export$d503dd157d963b60(object) {
    return $d6a7ef096dfca659$var$__awaiter(this, void 0, void 0, function() {
        var promises, results;
        return (0, $itJXR.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    promises = Object.keys(object).map(function(key) {
                        var value = object[key];
                        return Promise.resolve(value).then(function(v) {
                            return {
                                key: key,
                                value: v
                            };
                        });
                    });
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 1:
                    results = _state.sent();
                    return [
                        2,
                        results.reduce(function(accum, result) {
                            accum[result.key] = result.value;
                            return accum;
                        }, {})
                    ];
            }
        });
    });
}
function $d6a7ef096dfca659$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $d6a7ef096dfca659$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach(function(key) {
        if (!properties[key]) $d6a7ef096dfca659$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $d6a7ef096dfca659$export$9c13236873b118a5(object) {
    var result = {};
    for(var key in object)result[key] = object[key];
    return result;
}
var $d6a7ef096dfca659$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $d6a7ef096dfca659$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $d6a7ef096dfca659$var$opaque[typeof object === "undefined" ? "undefined" : (0, $jquDQ._)(object)]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        var keys = Object.keys(object);
        for(var i = 0; i < keys.length; i++){
            var value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$d6a7ef096dfca659$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $d6a7ef096dfca659$var$logger.throwArgumentError("Cannot deepCopy ".concat(typeof object === "undefined" ? "undefined" : (0, $jquDQ._)(object)), "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $d6a7ef096dfca659$var$_deepCopy(object) {
    if ($d6a7ef096dfca659$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map(function(item) {
        return $d6a7ef096dfca659$export$6c40052bed430212(item);
    }));
    if (typeof object === "object") {
        var result = {};
        for(var key in object){
            var value = object[key];
            if (value === undefined) continue;
            $d6a7ef096dfca659$export$104236534534f9be(result, key, $d6a7ef096dfca659$export$6c40052bed430212(value));
        }
        return result;
    }
    return $d6a7ef096dfca659$var$logger.throwArgumentError("Cannot deepCopy ".concat(typeof object === "undefined" ? "undefined" : (0, $jquDQ._)(object)), "object", object);
}
function $d6a7ef096dfca659$export$6c40052bed430212(object) {
    return $d6a7ef096dfca659$var$_deepCopy(object);
}
var $d6a7ef096dfca659$export$393edc798c47379d = function Description(info) {
    (0, $9j09T._)(this, Description);
    for(var key in info)this[key] = $d6a7ef096dfca659$export$6c40052bed430212(info[key]);
};

});
parcelRegister("8mobb", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $61632252fbb2be76$export$83d89fbfd8236492; });
var $61632252fbb2be76$export$83d89fbfd8236492 = "properties/5.5.0";

});


parcelRegister("73tL3", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $522fe58548e989db$export$83d89fbfd8236492; });
var $522fe58548e989db$export$83d89fbfd8236492 = "abi/5.5.0";

});


parcelRegister("hrmiK", function(module, exports) {

$parcel$export(module.exports, "LogDescription", function () { return $cb2641e1217f9c55$export$c2ab6499be98b3c5; });
$parcel$export(module.exports, "TransactionDescription", function () { return $cb2641e1217f9c55$export$7a3223b0fadb690b; });
$parcel$export(module.exports, "Indexed", function () { return $cb2641e1217f9c55$export$8ef99100a3c56f8c; });
$parcel$export(module.exports, "Interface", function () { return $cb2641e1217f9c55$export$48cefb51a4e315b2; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $hFSWi = parcelRequire("hFSWi");

var $7ryKd = parcelRequire("7ryKd");

var $2tHqU = parcelRequire("2tHqU");

var $9QZv3 = parcelRequire("9QZv3");

var $8Ub7X = parcelRequire("8Ub7X");

var $iqBKf = parcelRequire("iqBKf");

var $6yv4j = parcelRequire("6yv4j");

var $jG7Zp = parcelRequire("jG7Zp");

var $bsEDm = parcelRequire("bsEDm");

var $ihGvV = parcelRequire("ihGvV");

var $73tL3 = parcelRequire("73tL3");
"use strict";
var $cb2641e1217f9c55$var$logger = new (0, $ihGvV.Logger)((0, $73tL3.version));
var $cb2641e1217f9c55$export$c2ab6499be98b3c5 = /*#__PURE__*/ function(Description) {
    (0, $i0LXg._)(LogDescription, Description);
    var _super = (0, $a1vXf._)(LogDescription);
    function LogDescription() {
        (0, $9j09T._)(this, LogDescription);
        return _super.apply(this, arguments);
    }
    return LogDescription;
}((0, $iqBKf.Description));
var $cb2641e1217f9c55$export$7a3223b0fadb690b = /*#__PURE__*/ function(Description) {
    (0, $i0LXg._)(TransactionDescription, Description);
    var _super = (0, $a1vXf._)(TransactionDescription);
    function TransactionDescription() {
        (0, $9j09T._)(this, TransactionDescription);
        return _super.apply(this, arguments);
    }
    return TransactionDescription;
}((0, $iqBKf.Description));
var $cb2641e1217f9c55$export$cfba08fc0e40e2ab = /*#__PURE__*/ function(Description) {
    (0, $i0LXg._)(ErrorDescription, Description);
    var _super = (0, $a1vXf._)(ErrorDescription);
    function ErrorDescription() {
        (0, $9j09T._)(this, ErrorDescription);
        return _super.apply(this, arguments);
    }
    return ErrorDescription;
}((0, $iqBKf.Description));
var $cb2641e1217f9c55$export$8ef99100a3c56f8c = /*#__PURE__*/ function(Description) {
    (0, $i0LXg._)(Indexed, Description);
    var _super = (0, $a1vXf._)(Indexed);
    function Indexed() {
        (0, $9j09T._)(this, Indexed);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(Indexed, null, [
        {
            key: "isIndexed",
            value: function isIndexed(value) {
                return !!(value && value._isIndexed);
            }
        }
    ]);
    return Indexed;
}((0, $iqBKf.Description));
var $cb2641e1217f9c55$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function $cb2641e1217f9c55$var$wrapAccessError(property, error) {
    var wrap = new Error("deferred error during ABI decoding triggered accessing ".concat(property));
    wrap.error = error;
    return wrap;
}
var $cb2641e1217f9c55$export$48cefb51a4e315b2 = /*#__PURE__*/ function _target() {
    function Interface(fragments) {
        var _this = this;
        (0, $9j09T._)(this, Interface);
        $cb2641e1217f9c55$var$logger.checkNew(this instanceof Interface ? this.constructor : void 0, Interface);
        var abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $iqBKf.defineReadOnly)(this, "fragments", abi.map(function(fragment) {
            return (0, $bsEDm.Fragment).from(fragment);
        }).filter(function(fragment) {
            return fragment != null;
        }));
        (0, $iqBKf.defineReadOnly)(this, "_abiCoder", (0, $iqBKf.getStatic)(this instanceof Interface ? this.constructor : void 0, "getAbiCoder")());
        (0, $iqBKf.defineReadOnly)(this, "functions", {});
        (0, $iqBKf.defineReadOnly)(this, "errors", {});
        (0, $iqBKf.defineReadOnly)(this, "events", {});
        (0, $iqBKf.defineReadOnly)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach(function(fragment) {
            var bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (_this.deploy) {
                        $cb2641e1217f9c55$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $iqBKf.defineReadOnly)(_this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = _this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = _this.events;
                    break;
                case "error":
                    bucket = _this.errors;
                    break;
                default:
                    return;
            }
            var signature = fragment.format();
            if (bucket[signature]) {
                $cb2641e1217f9c55$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $iqBKf.defineReadOnly)(this, "deploy", (0, $bsEDm.ConstructorFragment).from({
            payable: false,
            type: "constructor"
        }));
        (0, $iqBKf.defineReadOnly)(this, "_isInterface", true);
    }
    (0, $eDeHT._)(Interface, [
        {
            key: "format",
            value: function format(_format) {
                if (!_format) _format = (0, $bsEDm.FormatTypes).full;
                if (_format === (0, $bsEDm.FormatTypes).sighash) $cb2641e1217f9c55$var$logger.throwArgumentError("interface does not support formatting sighash", "format", _format);
                var abi = this.fragments.map(function(fragment) {
                    return fragment.format(_format);
                });
                // We need to re-bundle the JSON fragments a bit
                if (_format === (0, $bsEDm.FormatTypes).json) return JSON.stringify(abi.map(function(j) {
                    return JSON.parse(j);
                }));
                return abi;
            }
        },
        {
            // Find a function definition by any means necessary (unless it is ambiguous)
            key: "getFunction",
            value: function getFunction(nameOrSignatureOrSighash) {
                if ((0, $2tHqU.isHexString)(nameOrSignatureOrSighash)) {
                    for(var name in this.functions){
                        if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
                    }
                    $cb2641e1217f9c55$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
                }
                // It is a bare name, look up the function (will return null if ambiguous)
                if (nameOrSignatureOrSighash.indexOf("(") === -1) {
                    var name1 = nameOrSignatureOrSighash.trim();
                    var matching = Object.keys(this.functions).filter(function(f) {
                        return f.split("(" /* fix:) */ )[0] === name1;
                    });
                    if (matching.length === 0) $cb2641e1217f9c55$var$logger.throwArgumentError("no matching function", "name", name1);
                    else if (matching.length > 1) $cb2641e1217f9c55$var$logger.throwArgumentError("multiple matching functions", "name", name1);
                    return this.functions[matching[0]];
                }
                // Normalize the signature and lookup the function
                var result = this.functions[(0, $bsEDm.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
                if (!result) $cb2641e1217f9c55$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
                return result;
            }
        },
        {
            // Find an event definition by any means necessary (unless it is ambiguous)
            key: "getEvent",
            value: function getEvent(nameOrSignatureOrTopic) {
                if ((0, $2tHqU.isHexString)(nameOrSignatureOrTopic)) {
                    var topichash = nameOrSignatureOrTopic.toLowerCase();
                    for(var name in this.events){
                        if (topichash === this.getEventTopic(name)) return this.events[name];
                    }
                    $cb2641e1217f9c55$var$logger.throwArgumentError("no matching event", "topichash", topichash);
                }
                // It is a bare name, look up the function (will return null if ambiguous)
                if (nameOrSignatureOrTopic.indexOf("(") === -1) {
                    var name1 = nameOrSignatureOrTopic.trim();
                    var matching = Object.keys(this.events).filter(function(f) {
                        return f.split("(" /* fix:) */ )[0] === name1;
                    });
                    if (matching.length === 0) $cb2641e1217f9c55$var$logger.throwArgumentError("no matching event", "name", name1);
                    else if (matching.length > 1) $cb2641e1217f9c55$var$logger.throwArgumentError("multiple matching events", "name", name1);
                    return this.events[matching[0]];
                }
                // Normalize the signature and lookup the function
                var result = this.events[(0, $bsEDm.EventFragment).fromString(nameOrSignatureOrTopic).format()];
                if (!result) $cb2641e1217f9c55$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
                return result;
            }
        },
        {
            // Find a function definition by any means necessary (unless it is ambiguous)
            key: "getError",
            value: function getError(nameOrSignatureOrSighash) {
                if ((0, $2tHqU.isHexString)(nameOrSignatureOrSighash)) {
                    var getSighash = (0, $iqBKf.getStatic)(this.constructor, "getSighash");
                    for(var name in this.errors){
                        var error = this.errors[name];
                        if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
                    }
                    $cb2641e1217f9c55$var$logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
                }
                // It is a bare name, look up the function (will return null if ambiguous)
                if (nameOrSignatureOrSighash.indexOf("(") === -1) {
                    var name1 = nameOrSignatureOrSighash.trim();
                    var matching = Object.keys(this.errors).filter(function(f) {
                        return f.split("(" /* fix:) */ )[0] === name1;
                    });
                    if (matching.length === 0) $cb2641e1217f9c55$var$logger.throwArgumentError("no matching error", "name", name1);
                    else if (matching.length > 1) $cb2641e1217f9c55$var$logger.throwArgumentError("multiple matching errors", "name", name1);
                    return this.errors[matching[0]];
                }
                // Normalize the signature and lookup the function
                var result = this.errors[(0, $bsEDm.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
                if (!result) $cb2641e1217f9c55$var$logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
                return result;
            }
        },
        {
            // Get the sighash (the bytes4 selector) used by Solidity to identify a function
            key: "getSighash",
            value: function getSighash(fragment) {
                if (typeof fragment === "string") try {
                    fragment = this.getFunction(fragment);
                } catch (error) {
                    try {
                        fragment = this.getError(fragment);
                    } catch (_) {
                        throw error;
                    }
                }
                return (0, $iqBKf.getStatic)(this.constructor, "getSighash")(fragment);
            }
        },
        {
            // Get the topic (the bytes32 hash) used by Solidity to identify an event
            key: "getEventTopic",
            value: function getEventTopic(eventFragment) {
                if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
                return (0, $iqBKf.getStatic)(this.constructor, "getEventTopic")(eventFragment);
            }
        },
        {
            key: "_decodeParams",
            value: function _decodeParams(params, data) {
                return this._abiCoder.decode(params, data);
            }
        },
        {
            key: "_encodeParams",
            value: function _encodeParams(params, values) {
                return this._abiCoder.encode(params, values);
            }
        },
        {
            key: "encodeDeploy",
            value: function encodeDeploy(values) {
                return this._encodeParams(this.deploy.inputs, values || []);
            }
        },
        {
            key: "decodeErrorResult",
            value: function decodeErrorResult(fragment, data) {
                if (typeof fragment === "string") fragment = this.getError(fragment);
                var bytes = (0, $2tHqU.arrayify)(data);
                if ((0, $2tHqU.hexlify)(bytes.slice(0, 4)) !== this.getSighash(fragment)) $cb2641e1217f9c55$var$logger.throwArgumentError("data signature does not match error ".concat(fragment.name, "."), "data", (0, $2tHqU.hexlify)(bytes));
                return this._decodeParams(fragment.inputs, bytes.slice(4));
            }
        },
        {
            key: "encodeErrorResult",
            value: function encodeErrorResult(fragment, values) {
                if (typeof fragment === "string") fragment = this.getError(fragment);
                return (0, $2tHqU.hexlify)((0, $2tHqU.concat)([
                    this.getSighash(fragment),
                    this._encodeParams(fragment.inputs, values || [])
                ]));
            }
        },
        {
            // Decode the data for a function call (e.g. tx.data)
            key: "decodeFunctionData",
            value: function decodeFunctionData(functionFragment, data) {
                if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
                var bytes = (0, $2tHqU.arrayify)(data);
                if ((0, $2tHqU.hexlify)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $cb2641e1217f9c55$var$logger.throwArgumentError("data signature does not match function ".concat(functionFragment.name, "."), "data", (0, $2tHqU.hexlify)(bytes));
                return this._decodeParams(functionFragment.inputs, bytes.slice(4));
            }
        },
        {
            // Encode the data for a function call (e.g. tx.data)
            key: "encodeFunctionData",
            value: function encodeFunctionData(functionFragment, values) {
                if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
                return (0, $2tHqU.hexlify)((0, $2tHqU.concat)([
                    this.getSighash(functionFragment),
                    this._encodeParams(functionFragment.inputs, values || [])
                ]));
            }
        },
        {
            // Decode the result from a function call (e.g. from eth_call)
            key: "decodeFunctionResult",
            value: function decodeFunctionResult(functionFragment, data) {
                if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
                var bytes = (0, $2tHqU.arrayify)(data);
                var reason = null;
                var errorArgs = null;
                var errorName = null;
                var errorSignature = null;
                switch(bytes.length % this._abiCoder._getWordSize()){
                    case 0:
                        try {
                            return this._abiCoder.decode(functionFragment.outputs, bytes);
                        } catch (error) {}
                        break;
                    case 4:
                        {
                            var selector = (0, $2tHqU.hexlify)(bytes.slice(0, 4));
                            var builtin = $cb2641e1217f9c55$var$BuiltinErrors[selector];
                            if (builtin) {
                                errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                                errorName = builtin.name;
                                errorSignature = builtin.signature;
                                if (builtin.reason) reason = errorArgs[0];
                            } else try {
                                var _$error = this.getError(selector);
                                errorArgs = this._abiCoder.decode(_$error.inputs, bytes.slice(4));
                                errorName = _$error.name;
                                errorSignature = _$error.format();
                            } catch (error) {
                                console.log(error);
                            }
                            break;
                        }
                }
                return $cb2641e1217f9c55$var$logger.throwError("call revert exception", (0, $ihGvV.Logger).errors.CALL_EXCEPTION, {
                    method: functionFragment.format(),
                    errorArgs: errorArgs,
                    errorName: errorName,
                    errorSignature: errorSignature,
                    reason: reason
                });
            }
        },
        {
            // Encode the result for a function call (e.g. for eth_call)
            key: "encodeFunctionResult",
            value: function encodeFunctionResult(functionFragment, values) {
                if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
                return (0, $2tHqU.hexlify)(this._abiCoder.encode(functionFragment.outputs, values || []));
            }
        },
        {
            // Create the filter for the event with search criteria (e.g. for eth_filterLog)
            key: "encodeFilterTopics",
            value: function encodeFilterTopics(eventFragment, values) {
                var _this = this;
                if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
                if (values.length > eventFragment.inputs.length) $cb2641e1217f9c55$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $ihGvV.Logger).errors.UNEXPECTED_ARGUMENT, {
                    argument: "values",
                    value: values
                });
                var topics = [];
                if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
                var encodeTopic = function(param, value) {
                    if (param.type === "string") return (0, $9QZv3.id)(value);
                    else if (param.type === "bytes") return (0, $8Ub7X.keccak256)((0, $2tHqU.hexlify)(value));
                    // Check addresses are valid
                    if (param.type === "address") _this._abiCoder.encode([
                        "address"
                    ], [
                        value
                    ]);
                    return (0, $2tHqU.hexZeroPad)((0, $2tHqU.hexlify)(value), 32);
                };
                values.forEach(function(value, index) {
                    var param = eventFragment.inputs[index];
                    if (!param.indexed) {
                        if (value != null) $cb2641e1217f9c55$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                        return;
                    }
                    if (value == null) topics.push(null);
                    else if (param.baseType === "array" || param.baseType === "tuple") $cb2641e1217f9c55$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
                    else if (Array.isArray(value)) topics.push(value.map(function(value) {
                        return encodeTopic(param, value);
                    }));
                    else topics.push(encodeTopic(param, value));
                });
                // Trim off trailing nulls
                while(topics.length && topics[topics.length - 1] === null)topics.pop();
                return topics;
            }
        },
        {
            key: "encodeEventLog",
            value: function encodeEventLog(eventFragment, values) {
                var _this = this;
                if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
                var topics = [];
                var dataTypes = [];
                var dataValues = [];
                if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
                if (values.length !== eventFragment.inputs.length) $cb2641e1217f9c55$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
                eventFragment.inputs.forEach(function(param, index) {
                    var value = values[index];
                    if (param.indexed) {
                        if (param.type === "string") topics.push((0, $9QZv3.id)(value));
                        else if (param.type === "bytes") topics.push((0, $8Ub7X.keccak256)(value));
                        else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                        throw new Error("not implemented");
                        else topics.push(_this._abiCoder.encode([
                            param.type
                        ], [
                            value
                        ]));
                    } else {
                        dataTypes.push(param);
                        dataValues.push(value);
                    }
                });
                return {
                    data: this._abiCoder.encode(dataTypes, dataValues),
                    topics: topics
                };
            }
        },
        {
            // Decode a filter for the event and the search criteria
            key: "decodeEventLog",
            value: function decodeEventLog(eventFragment, data, topics) {
                var _loop = function(i) {
                    var value = result[i];
                    if (value instanceof Error) Object.defineProperty(result, i, {
                        enumerable: true,
                        get: function() {
                            throw $cb2641e1217f9c55$var$wrapAccessError("index ".concat(i), value);
                        }
                    });
                };
                if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
                if (topics != null && !eventFragment.anonymous) {
                    var topicHash = this.getEventTopic(eventFragment);
                    if (!(0, $2tHqU.isHexString)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $cb2641e1217f9c55$var$logger.throwError("fragment/topic mismatch", (0, $ihGvV.Logger).errors.INVALID_ARGUMENT, {
                        argument: "topics[0]",
                        expected: topicHash,
                        value: topics[0]
                    });
                    topics = topics.slice(1);
                }
                var indexed = [];
                var nonIndexed = [];
                var dynamic = [];
                eventFragment.inputs.forEach(function(param, index) {
                    if (param.indexed) {
                        if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                            indexed.push((0, $bsEDm.ParamType).fromObject({
                                type: "bytes32",
                                name: param.name
                            }));
                            dynamic.push(true);
                        } else {
                            indexed.push(param);
                            dynamic.push(false);
                        }
                    } else {
                        nonIndexed.push(param);
                        dynamic.push(false);
                    }
                });
                var resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $2tHqU.concat)(topics)) : null;
                var resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
                var result = [];
                var nonIndexedIndex = 0, indexedIndex = 0;
                eventFragment.inputs.forEach(function(param, index) {
                    if (param.indexed) {
                        if (resultIndexed == null) result[index] = new $cb2641e1217f9c55$export$8ef99100a3c56f8c({
                            _isIndexed: true,
                            hash: null
                        });
                        else if (dynamic[index]) result[index] = new $cb2641e1217f9c55$export$8ef99100a3c56f8c({
                            _isIndexed: true,
                            hash: resultIndexed[indexedIndex++]
                        });
                        else try {
                            result[index] = resultIndexed[indexedIndex++];
                        } catch (error) {
                            result[index] = error;
                        }
                    } else try {
                        result[index] = resultNonIndexed[nonIndexedIndex++];
                    } catch (error) {
                        result[index] = error;
                    }
                    // Add the keyword argument if named and safe
                    if (param.name && result[param.name] == null) {
                        var value = result[index];
                        // Make error named values throw on access
                        if (value instanceof Error) Object.defineProperty(result, param.name, {
                            enumerable: true,
                            get: function() {
                                throw $cb2641e1217f9c55$var$wrapAccessError("property ".concat(JSON.stringify(param.name)), value);
                            }
                        });
                        else result[param.name] = value;
                    }
                });
                // Make all error indexed values throw on access
                for(var i = 0; i < result.length; i++)_loop(i);
                return Object.freeze(result);
            }
        },
        {
            // Given a transaction, find the matching function fragment (if any) and
            // determine all its properties and call parameters
            key: "parseTransaction",
            value: function parseTransaction(tx) {
                var fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
                if (!fragment) return null;
                return new $cb2641e1217f9c55$export$7a3223b0fadb690b({
                    args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
                    functionFragment: fragment,
                    name: fragment.name,
                    signature: fragment.format(),
                    sighash: this.getSighash(fragment),
                    value: (0, $7ryKd.BigNumber).from(tx.value || "0")
                });
            }
        },
        {
            // @TODO
            //parseCallResult(data: BytesLike): ??
            // Given an event log, find the matching event fragment (if any) and
            // determine all its properties and values
            key: "parseLog",
            value: function parseLog(log) {
                var fragment = this.getEvent(log.topics[0]);
                if (!fragment || fragment.anonymous) return null;
                // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
                //        Probably not, because just because it is the only event in the ABI does
                //        not mean we have the full ABI; maybe just a fragment?
                return new $cb2641e1217f9c55$export$c2ab6499be98b3c5({
                    eventFragment: fragment,
                    name: fragment.name,
                    signature: fragment.format(),
                    topic: this.getEventTopic(fragment),
                    args: this.decodeEventLog(fragment, log.data, log.topics)
                });
            }
        },
        {
            key: "parseError",
            value: function parseError(data) {
                var hexData = (0, $2tHqU.hexlify)(data);
                var fragment = this.getError(hexData.substring(0, 10).toLowerCase());
                if (!fragment) return null;
                return new $cb2641e1217f9c55$export$cfba08fc0e40e2ab({
                    args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
                    errorFragment: fragment,
                    name: fragment.name,
                    signature: fragment.format(),
                    sighash: this.getSighash(fragment)
                });
            }
        }
    ], [
        {
            key: "getAbiCoder",
            value: // Sub-classes can override these to handle other blockchains
            function getAbiCoder() {
                return 0, $6yv4j.defaultAbiCoder;
            }
        },
        {
            key: "getAddress",
            value: function getAddress1(address) {
                return (0, $hFSWi.getAddress)(address);
            }
        },
        {
            key: "getSighash",
            value: function getSighash(fragment) {
                return (0, $2tHqU.hexDataSlice)((0, $9QZv3.id)(fragment.format()), 0, 4);
            }
        },
        {
            key: "getEventTopic",
            value: function getEventTopic(eventFragment) {
                return (0, $9QZv3.id)(eventFragment.format());
            }
        },
        {
            key: "isInterface",
            value: /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ function isInterface(value) {
                return !!(value && value._isInterface);
            }
        }
    ]);
    return Interface;
}();

});
parcelRegister("hFSWi", function(module, exports) {

$parcel$export(module.exports, "getAddress", function () { return $cde0e1ca3f95325f$export$88411125f012957a; });
$parcel$export(module.exports, "isAddress", function () { return $cde0e1ca3f95325f$export$977e255126d763d6; });
$parcel$export(module.exports, "getIcapAddress", function () { return $cde0e1ca3f95325f$export$962c4ddada9f668f; });
$parcel$export(module.exports, "getContractAddress", function () { return $cde0e1ca3f95325f$export$b7fbffef12272e40; });
$parcel$export(module.exports, "getCreate2Address", function () { return $cde0e1ca3f95325f$export$e0b22d96621f73a2; });

var $2tHqU = parcelRequire("2tHqU");

var $7ryKd = parcelRequire("7ryKd");

var $8Ub7X = parcelRequire("8Ub7X");

var $8gMN8 = parcelRequire("8gMN8");

var $ihGvV = parcelRequire("ihGvV");

var $iY7Er = parcelRequire("iY7Er");
"use strict";
var $cde0e1ca3f95325f$var$logger = new (0, $ihGvV.Logger)((0, $iY7Er.version));
function $cde0e1ca3f95325f$var$getChecksumAddress(address) {
    if (!(0, $2tHqU.isHexString)(address, 20)) $cde0e1ca3f95325f$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    var chars = address.substring(2).split("");
    var expanded = new Uint8Array(40);
    for(var i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    var hashed = (0, $2tHqU.arrayify)((0, $8Ub7X.keccak256)(expanded));
    for(var i1 = 0; i1 < 40; i1 += 2){
        if (hashed[i1 >> 1] >> 4 >= 8) chars[i1] = chars[i1].toUpperCase();
        if ((hashed[i1 >> 1] & 0x0f) >= 8) chars[i1 + 1] = chars[i1 + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
var $cde0e1ca3f95325f$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $cde0e1ca3f95325f$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
var $cde0e1ca3f95325f$var$ibanLookup = {};
for(var $cde0e1ca3f95325f$var$i = 0; $cde0e1ca3f95325f$var$i < 10; $cde0e1ca3f95325f$var$i++)$cde0e1ca3f95325f$var$ibanLookup[String($cde0e1ca3f95325f$var$i)] = String($cde0e1ca3f95325f$var$i);
for(var $cde0e1ca3f95325f$var$i1 = 0; $cde0e1ca3f95325f$var$i1 < 26; $cde0e1ca3f95325f$var$i1++)$cde0e1ca3f95325f$var$ibanLookup[String.fromCharCode(65 + $cde0e1ca3f95325f$var$i1)] = String(10 + $cde0e1ca3f95325f$var$i1);
// How many decimal digits can we process? (for 64-bit float, this is 15)
var $cde0e1ca3f95325f$var$safeDigits = Math.floor($cde0e1ca3f95325f$var$log10($cde0e1ca3f95325f$var$MAX_SAFE_INTEGER));
function $cde0e1ca3f95325f$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    var expanded = address.split("").map(function(c) {
        return $cde0e1ca3f95325f$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $cde0e1ca3f95325f$var$safeDigits){
        var block = expanded.substring(0, $cde0e1ca3f95325f$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    var checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $cde0e1ca3f95325f$export$88411125f012957a(address) {
    var result = null;
    if (typeof address !== "string") $cde0e1ca3f95325f$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $cde0e1ca3f95325f$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $cde0e1ca3f95325f$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $cde0e1ca3f95325f$var$ibanChecksum(address)) $cde0e1ca3f95325f$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $7ryKd._base36To16)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $cde0e1ca3f95325f$var$getChecksumAddress("0x" + result);
    } else $cde0e1ca3f95325f$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $cde0e1ca3f95325f$export$977e255126d763d6(address) {
    try {
        $cde0e1ca3f95325f$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $cde0e1ca3f95325f$export$962c4ddada9f668f(address) {
    var base36 = (0, $7ryKd._base16To36)($cde0e1ca3f95325f$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $cde0e1ca3f95325f$var$ibanChecksum("XE00" + base36) + base36;
}
function $cde0e1ca3f95325f$export$b7fbffef12272e40(transaction) {
    var from = null;
    try {
        from = $cde0e1ca3f95325f$export$88411125f012957a(transaction.from);
    } catch (error) {
        $cde0e1ca3f95325f$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    var nonce = (0, $2tHqU.stripZeros)((0, $2tHqU.arrayify)((0, $7ryKd.BigNumber).from(transaction.nonce).toHexString()));
    return $cde0e1ca3f95325f$export$88411125f012957a((0, $2tHqU.hexDataSlice)((0, $8Ub7X.keccak256)((0, $8gMN8.encode)([
        from,
        nonce
    ])), 12));
}
function $cde0e1ca3f95325f$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $2tHqU.hexDataLength)(salt) !== 32) $cde0e1ca3f95325f$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $2tHqU.hexDataLength)(initCodeHash) !== 32) $cde0e1ca3f95325f$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $cde0e1ca3f95325f$export$88411125f012957a((0, $2tHqU.hexDataSlice)((0, $8Ub7X.keccak256)((0, $2tHqU.concat)([
        "0xff",
        $cde0e1ca3f95325f$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}

});
parcelRegister("8Ub7X", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $67bc2f5893de5301$export$f8151fce47ad1c35; });

var $ghAOg = parcelRequire("ghAOg");

var $2tHqU = parcelRequire("2tHqU");
"use strict";
function $67bc2f5893de5301$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($ghAOg))).keccak_256((0, $2tHqU.arrayify)(data));
}

});
parcelRegister("ghAOg", function(module, exports) {

var $jquDQ = parcelRequire("jquDQ");

var $8uCnf = parcelRequire("8uCnf");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $8uCnf === "object" && $8uCnf.versions && $8uCnf.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function createOutputMethod(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function createShakeOutputMethod(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function createCshakeOutputMethod(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function createKmacOutputMethod(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function createOutputMethods(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function createMethod(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function createShakeMethod(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function createCshakeMethod(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function createKmacMethod(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message === "undefined" ? "undefined" : (0, $jquDQ._)(message);
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str === "undefined" ? "undefined" : (0, $jquDQ._)(str);
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function f(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});


parcelRegister("8gMN8", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $6055aa4dd530187c$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $6055aa4dd530187c$export$2f872c0f2117be69; });

var $2tHqU = parcelRequire("2tHqU");

var $ihGvV = parcelRequire("ihGvV");

var $3XGUM = parcelRequire("3XGUM");
"use strict";
var $6055aa4dd530187c$var$logger = new (0, $ihGvV.Logger)((0, $3XGUM.version));
function $6055aa4dd530187c$var$arrayifyInteger(value) {
    var result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $6055aa4dd530187c$var$unarrayifyInteger(data, offset, length) {
    var result = 0;
    for(var i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $6055aa4dd530187c$var$_encode(object) {
    if (Array.isArray(object)) {
        var payload = [];
        object.forEach(function(child) {
            payload = payload.concat($6055aa4dd530187c$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        var length = $6055aa4dd530187c$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $2tHqU.isBytesLike)(object)) $6055aa4dd530187c$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    var data = Array.prototype.slice.call((0, $2tHqU.arrayify)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    var length1 = $6055aa4dd530187c$var$arrayifyInteger(data.length);
    length1.unshift(0xb7 + length1.length);
    return length1.concat(data);
}
function $6055aa4dd530187c$export$c564cdbbe6da493(object) {
    return (0, $2tHqU.hexlify)($6055aa4dd530187c$var$_encode(object));
}
function $6055aa4dd530187c$var$_decodeChildren(data, offset, childOffset, length) {
    var result = [];
    while(childOffset < offset + 1 + length){
        var decoded = $6055aa4dd530187c$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $6055aa4dd530187c$var$logger.throwError("child data too short", (0, $ihGvV.Logger).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $6055aa4dd530187c$var$_decode(data, offset) {
    if (data.length === 0) $6055aa4dd530187c$var$logger.throwError("data too short", (0, $ihGvV.Logger).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        var lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $6055aa4dd530187c$var$logger.throwError("data short segment too short", (0, $ihGvV.Logger).errors.BUFFER_OVERRUN, {});
        var length = $6055aa4dd530187c$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $6055aa4dd530187c$var$logger.throwError("data long segment too short", (0, $ihGvV.Logger).errors.BUFFER_OVERRUN, {});
        return $6055aa4dd530187c$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        var length1 = data[offset] - 0xc0;
        if (offset + 1 + length1 > data.length) $6055aa4dd530187c$var$logger.throwError("data array too short", (0, $ihGvV.Logger).errors.BUFFER_OVERRUN, {});
        return $6055aa4dd530187c$var$_decodeChildren(data, offset, offset + 1, length1);
    } else if (data[offset] >= 0xb8) {
        var lengthLength1 = data[offset] - 0xb7;
        if (offset + 1 + lengthLength1 > data.length) $6055aa4dd530187c$var$logger.throwError("data array too short", (0, $ihGvV.Logger).errors.BUFFER_OVERRUN, {});
        var length2 = $6055aa4dd530187c$var$unarrayifyInteger(data, offset + 1, lengthLength1);
        if (offset + 1 + lengthLength1 + length2 > data.length) $6055aa4dd530187c$var$logger.throwError("data array too short", (0, $ihGvV.Logger).errors.BUFFER_OVERRUN, {});
        var result = (0, $2tHqU.hexlify)(data.slice(offset + 1 + lengthLength1, offset + 1 + lengthLength1 + length2));
        return {
            consumed: 1 + lengthLength1 + length2,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        var length3 = data[offset] - 0x80;
        if (offset + 1 + length3 > data.length) $6055aa4dd530187c$var$logger.throwError("data too short", (0, $ihGvV.Logger).errors.BUFFER_OVERRUN, {});
        var result1 = (0, $2tHqU.hexlify)(data.slice(offset + 1, offset + 1 + length3));
        return {
            consumed: 1 + length3,
            result: result1
        };
    }
    return {
        consumed: 1,
        result: (0, $2tHqU.hexlify)(data[offset])
    };
}
function $6055aa4dd530187c$export$2f872c0f2117be69(data) {
    var bytes = (0, $2tHqU.arrayify)(data);
    var decoded = $6055aa4dd530187c$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $6055aa4dd530187c$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}

});
parcelRegister("3XGUM", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $2e282bcbb890aa58$export$83d89fbfd8236492; });
var $2e282bcbb890aa58$export$83d89fbfd8236492 = "rlp/5.5.0";

});


parcelRegister("iY7Er", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $dcf3c3fd19fa524e$export$83d89fbfd8236492; });
var $dcf3c3fd19fa524e$export$83d89fbfd8236492 = "address/5.5.0";

});


parcelRegister("9QZv3", function(module, exports) {

$parcel$export(module.exports, "id", function () { return $72c8acf546455234$export$d560c7e4a29451c2; });

var $8Ub7X = parcelRequire("8Ub7X");

var $5RaVA = parcelRequire("5RaVA");
function $72c8acf546455234$export$d560c7e4a29451c2(text) {
    return (0, $8Ub7X.keccak256)((0, $5RaVA.toUtf8Bytes)(text));
}

});
parcelRegister("5RaVA", function(module, exports) {

$parcel$export(module.exports, "UnicodeNormalizationForm", function () { return $443a6106a4e84947$export$c6986442964129f5; });
$parcel$export(module.exports, "Utf8ErrorReason", function () { return $443a6106a4e84947$export$c285fa6ac15ff6a6; });
$parcel$export(module.exports, "Utf8ErrorFuncs", function () { return $443a6106a4e84947$export$c6e2180c5bb5bc05; });
$parcel$export(module.exports, "toUtf8Bytes", function () { return $443a6106a4e84947$export$8feeb310b4b4752f; });
$parcel$export(module.exports, "_toEscapedUtf8String", function () { return $443a6106a4e84947$export$a7a0ec15960b9055; });
$parcel$export(module.exports, "_toUtf8String", function () { return $443a6106a4e84947$export$232e1dab03132235; });
$parcel$export(module.exports, "toUtf8String", function () { return $443a6106a4e84947$export$7643a1dc2c38d5eb; });
$parcel$export(module.exports, "toUtf8CodePoints", function () { return $443a6106a4e84947$export$ae470a36a31b28c2; });

var $2tHqU = parcelRequire("2tHqU");

var $ihGvV = parcelRequire("ihGvV");

var $4SM7V = parcelRequire("4SM7V");
"use strict";
var $443a6106a4e84947$var$logger = new (0, $ihGvV.Logger)((0, $4SM7V.version));
var $443a6106a4e84947$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($443a6106a4e84947$export$c6986442964129f5 || ($443a6106a4e84947$export$c6986442964129f5 = {}));
var $443a6106a4e84947$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($443a6106a4e84947$export$c285fa6ac15ff6a6 || ($443a6106a4e84947$export$c285fa6ac15ff6a6 = {}));
function $443a6106a4e84947$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $443a6106a4e84947$var$logger.throwArgumentError("invalid codepoint at offset ".concat(offset, "; ").concat(reason), "bytes", bytes);
}
function $443a6106a4e84947$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $443a6106a4e84947$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $443a6106a4e84947$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        var i = 0;
        for(var o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $443a6106a4e84947$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $443a6106a4e84947$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $443a6106a4e84947$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $443a6106a4e84947$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
var $443a6106a4e84947$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $443a6106a4e84947$var$errorFunc,
    ignore: $443a6106a4e84947$var$ignoreFunc,
    replace: $443a6106a4e84947$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $443a6106a4e84947$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $443a6106a4e84947$export$c6e2180c5bb5bc05.error;
    bytes = (0, $2tHqU.arrayify)(bytes);
    var result = [];
    var i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        var c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        var extraLength = null;
        var overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($443a6106a4e84947$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($443a6106a4e84947$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($443a6106a4e84947$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        var res = c & (1 << 8 - extraLength - 1) - 1;
        for(var j = 0; j < extraLength; j++){
            var nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($443a6106a4e84947$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($443a6106a4e84947$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($443a6106a4e84947$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($443a6106a4e84947$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $443a6106a4e84947$export$8feeb310b4b4752f(str) {
    var form = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $443a6106a4e84947$export$c6986442964129f5.current;
    if (form != $443a6106a4e84947$export$c6986442964129f5.current) {
        $443a6106a4e84947$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    var result = [];
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            var c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            var pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $2tHqU.arrayify)(result);
}
function $443a6106a4e84947$var$escapeChar(value) {
    var hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $443a6106a4e84947$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $443a6106a4e84947$var$getUtf8CodePoints(bytes, onError).map(function(codePoint) {
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $443a6106a4e84947$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $443a6106a4e84947$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $443a6106a4e84947$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $443a6106a4e84947$export$232e1dab03132235(codePoints) {
    return codePoints.map(function(codePoint) {
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $443a6106a4e84947$export$7643a1dc2c38d5eb(bytes, onError) {
    return $443a6106a4e84947$export$232e1dab03132235($443a6106a4e84947$var$getUtf8CodePoints(bytes, onError));
}
function $443a6106a4e84947$export$ae470a36a31b28c2(str) {
    var form = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $443a6106a4e84947$export$c6986442964129f5.current;
    return $443a6106a4e84947$var$getUtf8CodePoints($443a6106a4e84947$export$8feeb310b4b4752f(str, form));
}

});
parcelRegister("4SM7V", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $38e1898aa14dc8b1$export$83d89fbfd8236492; });
var $38e1898aa14dc8b1$export$83d89fbfd8236492 = "strings/5.5.0";

});



parcelRegister("6yv4j", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", function () { return $4c5e049912f120ac$export$fe041e1a83d3efc6; });
$parcel$export(module.exports, "defaultAbiCoder", function () { return $4c5e049912f120ac$export$51d1cfcdb913adff; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $2tHqU = parcelRequire("2tHqU");

var $iqBKf = parcelRequire("iqBKf");

var $ihGvV = parcelRequire("ihGvV");

var $73tL3 = parcelRequire("73tL3");

var $jG7Zp = parcelRequire("jG7Zp");

var $kg699 = parcelRequire("kg699");

var $3FERB = parcelRequire("3FERB");

var $eoc9T = parcelRequire("eoc9T");

var $88dgp = parcelRequire("88dgp");

var $bcDSE = parcelRequire("bcDSE");

var $8CKHY = parcelRequire("8CKHY");

var $HHUg1 = parcelRequire("HHUg1");

var $faR1i = parcelRequire("faR1i");

var $eBPP7 = parcelRequire("eBPP7");

var $bsEDm = parcelRequire("bsEDm");
"use strict";
var $4c5e049912f120ac$var$logger = new (0, $ihGvV.Logger)((0, $73tL3.version));
var $4c5e049912f120ac$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
var $4c5e049912f120ac$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
var $4c5e049912f120ac$export$fe041e1a83d3efc6 = /*#__PURE__*/ function _target() {
    function AbiCoder(coerceFunc) {
        (0, $9j09T._)(this, AbiCoder);
        $4c5e049912f120ac$var$logger.checkNew(this instanceof AbiCoder ? this.constructor : void 0, AbiCoder);
        (0, $iqBKf.defineReadOnly)(this, "coerceFunc", coerceFunc || null);
    }
    (0, $eDeHT._)(AbiCoder, [
        {
            key: "_getCoder",
            value: function _getCoder(param) {
                var _this = this;
                switch(param.baseType){
                    case "address":
                        return new (0, $kg699.AddressCoder)(param.name);
                    case "bool":
                        return new (0, $eoc9T.BooleanCoder)(param.name);
                    case "string":
                        return new (0, $faR1i.StringCoder)(param.name);
                    case "bytes":
                        return new (0, $88dgp.BytesCoder)(param.name);
                    case "array":
                        return new (0, $3FERB.ArrayCoder)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
                    case "tuple":
                        return new (0, $eBPP7.TupleCoder)((param.components || []).map(function(component) {
                            return _this._getCoder(component);
                        }), param.name);
                    case "":
                        return new (0, $8CKHY.NullCoder)(param.name);
                }
                // u?int[0-9]*
                var match = param.type.match($4c5e049912f120ac$var$paramTypeNumber);
                if (match) {
                    var size = parseInt(match[2] || "256");
                    if (size === 0 || size > 256 || size % 8 !== 0) $4c5e049912f120ac$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
                    return new (0, $HHUg1.NumberCoder)(size / 8, match[1] === "int", param.name);
                }
                // bytes[0-9]+
                match = param.type.match($4c5e049912f120ac$var$paramTypeBytes);
                if (match) {
                    var size1 = parseInt(match[1]);
                    if (size1 === 0 || size1 > 32) $4c5e049912f120ac$var$logger.throwArgumentError("invalid bytes length", "param", param);
                    return new (0, $bcDSE.FixedBytesCoder)(size1, param.name);
                }
                return $4c5e049912f120ac$var$logger.throwArgumentError("invalid type", "type", param.type);
            }
        },
        {
            key: "_getWordSize",
            value: function _getWordSize() {
                return 32;
            }
        },
        {
            key: "_getReader",
            value: function _getReader(data, allowLoose) {
                return new (0, $jG7Zp.Reader)(data, this._getWordSize(), this.coerceFunc, allowLoose);
            }
        },
        {
            key: "_getWriter",
            value: function _getWriter() {
                return new (0, $jG7Zp.Writer)(this._getWordSize());
            }
        },
        {
            key: "getDefaultValue",
            value: function getDefaultValue(types) {
                var _this = this;
                var coders = types.map(function(type) {
                    return _this._getCoder((0, $bsEDm.ParamType).from(type));
                });
                var coder = new (0, $eBPP7.TupleCoder)(coders, "_");
                return coder.defaultValue();
            }
        },
        {
            key: "encode",
            value: function encode(types, values) {
                var _this = this;
                if (types.length !== values.length) $4c5e049912f120ac$var$logger.throwError("types/values length mismatch", (0, $ihGvV.Logger).errors.INVALID_ARGUMENT, {
                    count: {
                        types: types.length,
                        values: values.length
                    },
                    value: {
                        types: types,
                        values: values
                    }
                });
                var coders = types.map(function(type) {
                    return _this._getCoder((0, $bsEDm.ParamType).from(type));
                });
                var coder = new (0, $eBPP7.TupleCoder)(coders, "_");
                var writer = this._getWriter();
                coder.encode(writer, values);
                return writer.data;
            }
        },
        {
            key: "decode",
            value: function decode(types, data, loose) {
                var _this = this;
                var coders = types.map(function(type) {
                    return _this._getCoder((0, $bsEDm.ParamType).from(type));
                });
                var coder = new (0, $eBPP7.TupleCoder)(coders, "_");
                return coder.decode(this._getReader((0, $2tHqU.arrayify)(data), loose));
            }
        }
    ]);
    return AbiCoder;
}();
var $4c5e049912f120ac$export$51d1cfcdb913adff = new $4c5e049912f120ac$export$fe041e1a83d3efc6();

});
parcelRegister("kg699", function(module, exports) {

$parcel$export(module.exports, "AddressCoder", function () { return $ebfa11dcf749cd11$export$59dbbded7775bfe7; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $hFSWi = parcelRequire("hFSWi");

var $2tHqU = parcelRequire("2tHqU");

var $jG7Zp = parcelRequire("jG7Zp");
"use strict";
var $ebfa11dcf749cd11$export$59dbbded7775bfe7 = /*#__PURE__*/ function(Coder) {
    (0, $i0LXg._)(AddressCoder, Coder);
    var _super = (0, $a1vXf._)(AddressCoder);
    function AddressCoder(localName) {
        (0, $9j09T._)(this, AddressCoder);
        return _super.call(this, "address", "address", localName, false);
    }
    (0, $eDeHT._)(AddressCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return "0x0000000000000000000000000000000000000000";
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                try {
                    value = (0, $hFSWi.getAddress)(value);
                } catch (error) {
                    this._throwError(error.message, value);
                }
                return writer.writeValue(value);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return (0, $hFSWi.getAddress)((0, $2tHqU.hexZeroPad)(reader.readValue().toHexString(), 20));
            }
        }
    ]);
    return AddressCoder;
}((0, $jG7Zp.Coder));

});

parcelRegister("3FERB", function(module, exports) {

$parcel$export(module.exports, "pack", function () { return $2ac4e615ee3751fa$export$2a703dbb0cb35339; });
$parcel$export(module.exports, "unpack", function () { return $2ac4e615ee3751fa$export$417857010dc9287f; });
$parcel$export(module.exports, "ArrayCoder", function () { return $2ac4e615ee3751fa$export$88bc419d2df11f54; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $ihGvV = parcelRequire("ihGvV");

var $73tL3 = parcelRequire("73tL3");

var $jG7Zp = parcelRequire("jG7Zp");

var $lsy7E = parcelRequire("lsy7E");
"use strict";
var $2ac4e615ee3751fa$var$logger = new (0, $ihGvV.Logger)((0, $73tL3.version));
function $2ac4e615ee3751fa$export$2a703dbb0cb35339(writer, coders, values) {
    var arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        var unique = {};
        arrayValues = coders.map(function(coder) {
            var name = coder.localName;
            if (!name) $2ac4e615ee3751fa$var$logger.throwError("cannot encode object for signature with missing names", (0, $ihGvV.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $2ac4e615ee3751fa$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $ihGvV.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $2ac4e615ee3751fa$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $2ac4e615ee3751fa$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    var staticWriter = new (0, $jG7Zp.Writer)(writer.wordSize);
    var dynamicWriter = new (0, $jG7Zp.Writer)(writer.wordSize);
    var updateFuncs = [];
    coders.forEach(function(coder, index) {
        var value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            var dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            var updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push(function(baseOffset) {
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach(function(func) {
        func(staticWriter.length);
    });
    var length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $2ac4e615ee3751fa$export$417857010dc9287f(reader, coders) {
    var _loop = function(i) {
        var value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: function() {
                throw value;
            }
        });
    };
    var values = [];
    // A reader anchored to this base
    var baseReader = reader.subReader(0);
    coders.forEach(function(coder) {
        var value = null;
        if (coder.dynamic) {
            var offset = reader.readValue();
            var offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $ihGvV.Logger).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $ihGvV.Logger).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    var uniqueNames = coders.reduce(function(accum, coder) {
        var name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach(function(coder, index) {
        var name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        var value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: function() {
                throw value;
            }
        });
        else values[name] = value;
    });
    for(var i = 0; i < values.length; i++)_loop(i);
    return Object.freeze(values);
}
var $2ac4e615ee3751fa$export$88bc419d2df11f54 = /*#__PURE__*/ function(Coder) {
    (0, $i0LXg._)(ArrayCoder, Coder);
    var _super = (0, $a1vXf._)(ArrayCoder);
    function ArrayCoder(coder, length, localName) {
        (0, $9j09T._)(this, ArrayCoder);
        var _this;
        var type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        var dynamic = length === -1 || coder.dynamic;
        _this = _super.call(this, "array", type, localName, dynamic);
        _this.coder = coder;
        _this.length = length;
        return _this;
    }
    (0, $eDeHT._)(ArrayCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                // Verifies the child coder is valid (even if the array is dynamic or 0-length)
                var defaultChild = this.coder.defaultValue();
                var result = [];
                for(var i = 0; i < this.length; i++)result.push(defaultChild);
                return result;
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                if (!Array.isArray(value)) this._throwError("expected array value", value);
                var count = this.length;
                if (count === -1) {
                    count = value.length;
                    writer.writeValue(value.length);
                }
                $2ac4e615ee3751fa$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
                var coders = [];
                for(var i = 0; i < value.length; i++)coders.push(this.coder);
                return $2ac4e615ee3751fa$export$2a703dbb0cb35339(writer, coders, value);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                var count = this.length;
                if (count === -1) {
                    count = reader.readValue().toNumber();
                    // Check that there is *roughly* enough data to ensure
                    // stray random data is not being read as a length. Each
                    // slot requires at least 32 bytes for their value (or 32
                    // bytes as a link to the data). This could use a much
                    // tighter bound, but we are erroring on the side of safety.
                    if (count * 32 > reader._data.length) $2ac4e615ee3751fa$var$logger.throwError("insufficient data length", (0, $ihGvV.Logger).errors.BUFFER_OVERRUN, {
                        length: reader._data.length,
                        count: count
                    });
                }
                var coders = [];
                for(var i = 0; i < count; i++)coders.push(new (0, $lsy7E.AnonymousCoder)(this.coder));
                return reader.coerce(this.name, $2ac4e615ee3751fa$export$417857010dc9287f(reader, coders));
            }
        }
    ]);
    return ArrayCoder;
}((0, $jG7Zp.Coder));

});
parcelRegister("lsy7E", function(module, exports) {

$parcel$export(module.exports, "AnonymousCoder", function () { return $f9f6ae7a3e4f3ca6$export$87c41d1139a03fa2; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $jG7Zp = parcelRequire("jG7Zp");
"use strict";
var $f9f6ae7a3e4f3ca6$export$87c41d1139a03fa2 = /*#__PURE__*/ function(Coder) {
    (0, $i0LXg._)(AnonymousCoder, Coder);
    var _super = (0, $a1vXf._)(AnonymousCoder);
    function AnonymousCoder(coder) {
        (0, $9j09T._)(this, AnonymousCoder);
        var _this;
        _this = _super.call(this, coder.name, coder.type, undefined, coder.dynamic);
        _this.coder = coder;
        return _this;
    }
    (0, $eDeHT._)(AnonymousCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return this.coder.defaultValue();
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                return this.coder.encode(writer, value);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return this.coder.decode(reader);
            }
        }
    ]);
    return AnonymousCoder;
}((0, $jG7Zp.Coder));

});


parcelRegister("eoc9T", function(module, exports) {

$parcel$export(module.exports, "BooleanCoder", function () { return $a79cbd01d5f0fa87$export$fe9118d6c093150c; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $jG7Zp = parcelRequire("jG7Zp");
"use strict";
var $a79cbd01d5f0fa87$export$fe9118d6c093150c = /*#__PURE__*/ function(Coder) {
    (0, $i0LXg._)(BooleanCoder, Coder);
    var _super = (0, $a1vXf._)(BooleanCoder);
    function BooleanCoder(localName) {
        (0, $9j09T._)(this, BooleanCoder);
        return _super.call(this, "bool", "bool", localName, false);
    }
    (0, $eDeHT._)(BooleanCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return false;
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                return writer.writeValue(value ? 1 : 0);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return reader.coerce(this.type, !reader.readValue().isZero());
            }
        }
    ]);
    return BooleanCoder;
}((0, $jG7Zp.Coder));

});

parcelRegister("88dgp", function(module, exports) {

$parcel$export(module.exports, "DynamicBytesCoder", function () { return $5eb95bfb7eca2bc4$export$db9eadd8df12ad2e; });
$parcel$export(module.exports, "BytesCoder", function () { return $5eb95bfb7eca2bc4$export$e5823e9574df18d2; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $15W2b = parcelRequire("15W2b");

var $711He = parcelRequire("711He");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $2tHqU = parcelRequire("2tHqU");

var $jG7Zp = parcelRequire("jG7Zp");
"use strict";
var $5eb95bfb7eca2bc4$export$db9eadd8df12ad2e = /*#__PURE__*/ function(Coder) {
    (0, $i0LXg._)(DynamicBytesCoder, Coder);
    var _super = (0, $a1vXf._)(DynamicBytesCoder);
    function DynamicBytesCoder(type, localName) {
        (0, $9j09T._)(this, DynamicBytesCoder);
        return _super.call(this, type, type, localName, true);
    }
    (0, $eDeHT._)(DynamicBytesCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return "0x";
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                value = (0, $2tHqU.arrayify)(value);
                var length = writer.writeValue(value.length);
                length += writer.writeBytes(value);
                return length;
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return reader.readBytes(reader.readValue().toNumber(), true);
            }
        }
    ]);
    return DynamicBytesCoder;
}((0, $jG7Zp.Coder));
var $5eb95bfb7eca2bc4$export$e5823e9574df18d2 = /*#__PURE__*/ function(DynamicBytesCoder) {
    (0, $i0LXg._)(BytesCoder, DynamicBytesCoder);
    var _super = (0, $a1vXf._)(BytesCoder);
    function BytesCoder(localName) {
        (0, $9j09T._)(this, BytesCoder);
        return _super.call(this, "bytes", localName);
    }
    (0, $eDeHT._)(BytesCoder, [
        {
            key: "decode",
            value: function decode(reader) {
                return reader.coerce(this.name, (0, $2tHqU.hexlify)((0, $15W2b._)((0, $711He._)(BytesCoder.prototype), "decode", this).call(this, reader)));
            }
        }
    ]);
    return BytesCoder;
}($5eb95bfb7eca2bc4$export$db9eadd8df12ad2e);

});

parcelRegister("bcDSE", function(module, exports) {

$parcel$export(module.exports, "FixedBytesCoder", function () { return $827fc0276b64a376$export$7dec9db68e6bcf5a; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $2tHqU = parcelRequire("2tHqU");

var $jG7Zp = parcelRequire("jG7Zp");
"use strict";
var $827fc0276b64a376$export$7dec9db68e6bcf5a = /*#__PURE__*/ function(Coder) {
    (0, $i0LXg._)(FixedBytesCoder, Coder);
    var _super = (0, $a1vXf._)(FixedBytesCoder);
    function FixedBytesCoder(size, localName) {
        (0, $9j09T._)(this, FixedBytesCoder);
        var _this;
        var name = "bytes" + String(size);
        _this = _super.call(this, name, name, localName, false);
        _this.size = size;
        return _this;
    }
    (0, $eDeHT._)(FixedBytesCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                var data = (0, $2tHqU.arrayify)(value);
                if (data.length !== this.size) this._throwError("incorrect data length", value);
                return writer.writeBytes(data);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return reader.coerce(this.name, (0, $2tHqU.hexlify)(reader.readBytes(this.size)));
            }
        }
    ]);
    return FixedBytesCoder;
}((0, $jG7Zp.Coder));

});

parcelRegister("8CKHY", function(module, exports) {

$parcel$export(module.exports, "NullCoder", function () { return $64761a9e2bbd701a$export$70982cadf2d6b4ec; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $jG7Zp = parcelRequire("jG7Zp");
"use strict";
var $64761a9e2bbd701a$export$70982cadf2d6b4ec = /*#__PURE__*/ function(Coder) {
    (0, $i0LXg._)(NullCoder, Coder);
    var _super = (0, $a1vXf._)(NullCoder);
    function NullCoder(localName) {
        (0, $9j09T._)(this, NullCoder);
        return _super.call(this, "null", "", localName, false);
    }
    (0, $eDeHT._)(NullCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return null;
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                if (value != null) this._throwError("not null", value);
                return writer.writeBytes([]);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                reader.readBytes(0);
                return reader.coerce(this.name, null);
            }
        }
    ]);
    return NullCoder;
}((0, $jG7Zp.Coder));

});

parcelRegister("HHUg1", function(module, exports) {

$parcel$export(module.exports, "NumberCoder", function () { return $08361328ab2967b3$export$b934dc8cfe13938c; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $7ryKd = parcelRequire("7ryKd");

var $3bevF = parcelRequire("3bevF");

var $jG7Zp = parcelRequire("jG7Zp");
"use strict";
var $08361328ab2967b3$export$b934dc8cfe13938c = /*#__PURE__*/ function(Coder) {
    (0, $i0LXg._)(NumberCoder, Coder);
    var _super = (0, $a1vXf._)(NumberCoder);
    function NumberCoder(size, signed, localName) {
        (0, $9j09T._)(this, NumberCoder);
        var _this;
        var name = (signed ? "int" : "uint") + size * 8;
        _this = _super.call(this, name, name, localName, false);
        _this.size = size;
        _this.signed = signed;
        return _this;
    }
    (0, $eDeHT._)(NumberCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return 0;
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                var v = (0, $7ryKd.BigNumber).from(value);
                // Check bounds are safe for encoding
                var maxUintValue = (0, $3bevF.MaxUint256).mask(writer.wordSize * 8);
                if (this.signed) {
                    var bounds = maxUintValue.mask(this.size * 8 - 1);
                    if (v.gt(bounds) || v.lt(bounds.add((0, $3bevF.One)).mul((0, $3bevF.NegativeOne)))) this._throwError("value out-of-bounds", value);
                } else if (v.lt((0, $3bevF.Zero)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
                v = v.toTwos(this.size * 8).mask(this.size * 8);
                if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
                return writer.writeValue(v);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                var value = reader.readValue().mask(this.size * 8);
                if (this.signed) value = value.fromTwos(this.size * 8);
                return reader.coerce(this.name, value);
            }
        }
    ]);
    return NumberCoder;
}((0, $jG7Zp.Coder));

});
parcelRegister("3bevF", function(module, exports) {

$parcel$export(module.exports, "NegativeOne", function () { return $250da78362d2a6bb$export$c83ef0909a6ddeec; });
$parcel$export(module.exports, "Zero", function () { return $250da78362d2a6bb$export$aaef8a3eae948f03; });
$parcel$export(module.exports, "One", function () { return $250da78362d2a6bb$export$9aa05a5866350bcf; });
$parcel$export(module.exports, "Two", function () { return $250da78362d2a6bb$export$9276dd97bf62cc8d; });
$parcel$export(module.exports, "WeiPerEther", function () { return $250da78362d2a6bb$export$c8db55bd7405209e; });
$parcel$export(module.exports, "MaxUint256", function () { return $250da78362d2a6bb$export$1b53890de5aabdd0; });
$parcel$export(module.exports, "MinInt256", function () { return $250da78362d2a6bb$export$963c9b9317b80aaf; });
$parcel$export(module.exports, "MaxInt256", function () { return $250da78362d2a6bb$export$6f8dbb07ebe6d738; });

var $7ryKd = parcelRequire("7ryKd");
var $250da78362d2a6bb$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $7ryKd.BigNumber).from(-1);
var $250da78362d2a6bb$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $7ryKd.BigNumber).from(0);
var $250da78362d2a6bb$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $7ryKd.BigNumber).from(1);
var $250da78362d2a6bb$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $7ryKd.BigNumber).from(2);
var $250da78362d2a6bb$export$c8db55bd7405209e = /*#__PURE__*/ (0, $7ryKd.BigNumber).from("1000000000000000000");
var $250da78362d2a6bb$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $7ryKd.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
var $250da78362d2a6bb$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $7ryKd.BigNumber).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
var $250da78362d2a6bb$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $7ryKd.BigNumber).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");

});


parcelRegister("faR1i", function(module, exports) {

$parcel$export(module.exports, "StringCoder", function () { return $b0c0ead83652115e$export$2d1b854518731426; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $15W2b = parcelRequire("15W2b");

var $711He = parcelRequire("711He");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $5RaVA = parcelRequire("5RaVA");

var $88dgp = parcelRequire("88dgp");
"use strict";
var $b0c0ead83652115e$export$2d1b854518731426 = /*#__PURE__*/ function(DynamicBytesCoder) {
    (0, $i0LXg._)(StringCoder, DynamicBytesCoder);
    var _super = (0, $a1vXf._)(StringCoder);
    function StringCoder(localName) {
        (0, $9j09T._)(this, StringCoder);
        return _super.call(this, "string", localName);
    }
    (0, $eDeHT._)(StringCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return "";
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                return (0, $15W2b._)((0, $711He._)(StringCoder.prototype), "encode", this).call(this, writer, (0, $5RaVA.toUtf8Bytes)(value));
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return (0, $5RaVA.toUtf8String)((0, $15W2b._)((0, $711He._)(StringCoder.prototype), "decode", this).call(this, reader));
            }
        }
    ]);
    return StringCoder;
}((0, $88dgp.DynamicBytesCoder));

});

parcelRegister("eBPP7", function(module, exports) {

$parcel$export(module.exports, "TupleCoder", function () { return $aa2cb8712d1f7e57$export$e9fceba8f110fea6; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $jG7Zp = parcelRequire("jG7Zp");

var $3FERB = parcelRequire("3FERB");
"use strict";
var $aa2cb8712d1f7e57$export$e9fceba8f110fea6 = /*#__PURE__*/ function(Coder) {
    (0, $i0LXg._)(TupleCoder, Coder);
    var _super = (0, $a1vXf._)(TupleCoder);
    function TupleCoder(coders, localName) {
        (0, $9j09T._)(this, TupleCoder);
        var _this;
        var dynamic = false;
        var types = [];
        coders.forEach(function(coder) {
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        var type = "tuple(" + types.join(",") + ")";
        _this = _super.call(this, "tuple", type, localName, dynamic);
        _this.coders = coders;
        return _this;
    }
    (0, $eDeHT._)(TupleCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                var values = [];
                this.coders.forEach(function(coder) {
                    values.push(coder.defaultValue());
                });
                // We only output named properties for uniquely named coders
                var uniqueNames = this.coders.reduce(function(accum, coder) {
                    var name = coder.localName;
                    if (name) {
                        if (!accum[name]) accum[name] = 0;
                        accum[name]++;
                    }
                    return accum;
                }, {});
                // Add named values
                this.coders.forEach(function(coder, index) {
                    var name = coder.localName;
                    if (!name || uniqueNames[name] !== 1) return;
                    if (name === "length") name = "_length";
                    if (values[name] != null) return;
                    values[name] = values[index];
                });
                return Object.freeze(values);
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                return (0, $3FERB.pack)(writer, this.coders, value);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return reader.coerce(this.name, (0, $3FERB.unpack)(reader, this.coders));
            }
        }
    ]);
    return TupleCoder;
}((0, $jG7Zp.Coder));

});

parcelRegister("bsEDm", function(module, exports) {

$parcel$export(module.exports, "FormatTypes", function () { return $8581d448cf24c27c$export$f010f239efc4d445; });
$parcel$export(module.exports, "ParamType", function () { return $8581d448cf24c27c$export$426dc07f493a4c47; });
$parcel$export(module.exports, "Fragment", function () { return $8581d448cf24c27c$export$ffb0004e005737fa; });
$parcel$export(module.exports, "FunctionFragment", function () { return $8581d448cf24c27c$export$8d576c928b93668f; });
$parcel$export(module.exports, "EventFragment", function () { return $8581d448cf24c27c$export$958548f08bac2833; });
$parcel$export(module.exports, "ConstructorFragment", function () { return $8581d448cf24c27c$export$3ac5c9504f801ea4; });
$parcel$export(module.exports, "ErrorFragment", function () { return $8581d448cf24c27c$export$2c42c6d543aa9b59; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $7ryKd = parcelRequire("7ryKd");

var $iqBKf = parcelRequire("iqBKf");

var $ihGvV = parcelRequire("ihGvV");

var $73tL3 = parcelRequire("73tL3");
"use strict";
var $8581d448cf24c27c$var$logger = new (0, $ihGvV.Logger)((0, $73tL3.version));
var $8581d448cf24c27c$var$_constructorGuard = {};
var $8581d448cf24c27c$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
var $8581d448cf24c27c$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $8581d448cf24c27c$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($8581d448cf24c27c$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($8581d448cf24c27c$var$ModifiersNest[name]) return true;
    }
    if ($8581d448cf24c27c$var$ModifiersBytes[name] || name === "payable") $8581d448cf24c27c$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $8581d448cf24c27c$var$parseParamType(param, allowIndexed) {
    var originalParam = param;
    function throwError(i) {
        $8581d448cf24c27c$var$logger.throwArgumentError("unexpected character at position ".concat(i), "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        var node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    var parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    var node = parent;
    for(var i = 0; i < param.length; i++){
        var c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $8581d448cf24c27c$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($8581d448cf24c27c$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $8581d448cf24c27c$var$verifyType(node.type);
                var child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($8581d448cf24c27c$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $8581d448cf24c27c$var$verifyType(node.type);
                var sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $8581d448cf24c27c$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($8581d448cf24c27c$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $8581d448cf24c27c$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($8581d448cf24c27c$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $8581d448cf24c27c$var$verifyType(parent.type);
    return parent;
}
function $8581d448cf24c27c$var$populate(object, params) {
    for(var key in params)(0, $iqBKf.defineReadOnly)(object, key, params[key]);
}
var $8581d448cf24c27c$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
var $8581d448cf24c27c$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
var $8581d448cf24c27c$export$426dc07f493a4c47 = /*#__PURE__*/ function() {
    function ParamType(constructorGuard, params) {
        (0, $9j09T._)(this, ParamType);
        if (constructorGuard !== $8581d448cf24c27c$var$_constructorGuard) $8581d448cf24c27c$var$logger.throwError("use fromString", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $8581d448cf24c27c$var$populate(this, params);
        var match = this.type.match($8581d448cf24c27c$var$paramTypeArray);
        if (match) $8581d448cf24c27c$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: ParamType.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $8581d448cf24c27c$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    (0, $eDeHT._)(ParamType, [
        {
            // Format the parameter fragment
            //   - sighash: "(uint256,address)"
            //   - minimal: "tuple(uint256,address) indexed"
            //   - full:    "tuple(uint256 foo, address bar) indexed baz"
            key: "format",
            value: function format(format) {
                if (!format) format = $8581d448cf24c27c$export$f010f239efc4d445.sighash;
                if (!$8581d448cf24c27c$export$f010f239efc4d445[format]) $8581d448cf24c27c$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $8581d448cf24c27c$export$f010f239efc4d445.json) {
                    var result = {
                        type: this.baseType === "tuple" ? "tuple" : this.type,
                        name: this.name || undefined
                    };
                    if (typeof this.indexed === "boolean") result.indexed = this.indexed;
                    if (this.components) result.components = this.components.map(function(comp) {
                        return JSON.parse(comp.format(format));
                    });
                    return JSON.stringify(result);
                }
                var result1 = "";
                // Array
                if (this.baseType === "array") {
                    result1 += this.arrayChildren.format(format);
                    result1 += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
                } else if (this.baseType === "tuple") {
                    if (format !== $8581d448cf24c27c$export$f010f239efc4d445.sighash) result1 += this.type;
                    result1 += "(" + this.components.map(function(comp) {
                        return comp.format(format);
                    }).join(format === $8581d448cf24c27c$export$f010f239efc4d445.full ? ", " : ",") + ")";
                } else result1 += this.type;
                if (format !== $8581d448cf24c27c$export$f010f239efc4d445.sighash) {
                    if (this.indexed === true) result1 += " indexed";
                    if (format === $8581d448cf24c27c$export$f010f239efc4d445.full && this.name) result1 += " " + this.name;
                }
                return result1;
            }
        }
    ], [
        {
            key: "from",
            value: function from(value, allowIndexed) {
                if (typeof value === "string") return ParamType.fromString(value, allowIndexed);
                return ParamType.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (ParamType.isParamType(value)) return value;
                return new ParamType($8581d448cf24c27c$var$_constructorGuard, {
                    name: value.name || null,
                    type: $8581d448cf24c27c$var$verifyType(value.type),
                    indexed: value.indexed == null ? null : !!value.indexed,
                    components: value.components ? value.components.map(ParamType.fromObject) : null
                });
            }
        },
        {
            key: "fromString",
            value: function fromString(value, allowIndexed) {
                function ParamTypify(node) {
                    return ParamType.fromObject({
                        name: node.name,
                        type: node.type,
                        indexed: node.indexed,
                        components: node.components
                    });
                }
                return ParamTypify($8581d448cf24c27c$var$parseParamType(value, !!allowIndexed));
            }
        },
        {
            key: "isParamType",
            value: function isParamType(value) {
                return !!(value != null && value._isParamType);
            }
        }
    ]);
    return ParamType;
}();
function $8581d448cf24c27c$var$parseParams(value, allowIndex) {
    return $8581d448cf24c27c$var$splitNesting(value).map(function(param) {
        return $8581d448cf24c27c$export$426dc07f493a4c47.fromString(param, allowIndex);
    });
}
var $8581d448cf24c27c$export$ffb0004e005737fa = /*#__PURE__*/ function() {
    function Fragment(constructorGuard, params) {
        (0, $9j09T._)(this, Fragment);
        if (constructorGuard !== $8581d448cf24c27c$var$_constructorGuard) $8581d448cf24c27c$var$logger.throwError("use a static from method", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $8581d448cf24c27c$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    (0, $eDeHT._)(Fragment, null, [
        {
            key: "from",
            value: function from(value) {
                if (Fragment.isFragment(value)) return value;
                if (typeof value === "string") return Fragment.fromString(value);
                return Fragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (Fragment.isFragment(value)) return value;
                switch(value.type){
                    case "function":
                        return $8581d448cf24c27c$export$8d576c928b93668f.fromObject(value);
                    case "event":
                        return $8581d448cf24c27c$export$958548f08bac2833.fromObject(value);
                    case "constructor":
                        return $8581d448cf24c27c$export$3ac5c9504f801ea4.fromObject(value);
                    case "error":
                        return $8581d448cf24c27c$export$2c42c6d543aa9b59.fromObject(value);
                    case "fallback":
                    case "receive":
                        // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                        return null;
                }
                return $8581d448cf24c27c$var$logger.throwArgumentError("invalid fragment object", "value", value);
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
                value = value.replace(/\s/g, " ");
                value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
                value = value.trim();
                if (value.split(" ")[0] === "event") return $8581d448cf24c27c$export$958548f08bac2833.fromString(value.substring(5).trim());
                else if (value.split(" ")[0] === "function") return $8581d448cf24c27c$export$8d576c928b93668f.fromString(value.substring(8).trim());
                else if (value.split("(")[0].trim() === "constructor") return $8581d448cf24c27c$export$3ac5c9504f801ea4.fromString(value.trim());
                else if (value.split(" ")[0] === "error") return $8581d448cf24c27c$export$2c42c6d543aa9b59.fromString(value.substring(5).trim());
                return $8581d448cf24c27c$var$logger.throwArgumentError("unsupported fragment", "value", value);
            }
        },
        {
            key: "isFragment",
            value: function isFragment(value) {
                return !!(value && value._isFragment);
            }
        }
    ]);
    return Fragment;
}();
var $8581d448cf24c27c$export$958548f08bac2833 = /*#__PURE__*/ function(Fragment) {
    (0, $i0LXg._)(EventFragment, Fragment);
    var _super = (0, $a1vXf._)(EventFragment);
    function EventFragment() {
        (0, $9j09T._)(this, EventFragment);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(EventFragment, [
        {
            key: "format",
            value: function format(format) {
                if (!format) format = $8581d448cf24c27c$export$f010f239efc4d445.sighash;
                if (!$8581d448cf24c27c$export$f010f239efc4d445[format]) $8581d448cf24c27c$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $8581d448cf24c27c$export$f010f239efc4d445.json) return JSON.stringify({
                    type: "event",
                    anonymous: this.anonymous,
                    name: this.name,
                    inputs: this.inputs.map(function(input) {
                        return JSON.parse(input.format(format));
                    })
                });
                var result = "";
                if (format !== $8581d448cf24c27c$export$f010f239efc4d445.sighash) result += "event ";
                result += this.name + "(" + this.inputs.map(function(input) {
                    return input.format(format);
                }).join(format === $8581d448cf24c27c$export$f010f239efc4d445.full ? ", " : ",") + ") ";
                if (format !== $8581d448cf24c27c$export$f010f239efc4d445.sighash) {
                    if (this.anonymous) result += "anonymous ";
                }
                return result.trim();
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (typeof value === "string") return EventFragment.fromString(value);
                return EventFragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (EventFragment.isEventFragment(value)) return value;
                if (value.type !== "event") $8581d448cf24c27c$var$logger.throwArgumentError("invalid event object", "value", value);
                var params = {
                    name: $8581d448cf24c27c$var$verifyIdentifier(value.name),
                    anonymous: value.anonymous,
                    inputs: value.inputs ? value.inputs.map($8581d448cf24c27c$export$426dc07f493a4c47.fromObject) : [],
                    type: "event"
                };
                return new EventFragment($8581d448cf24c27c$var$_constructorGuard, params);
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                var match = value.match($8581d448cf24c27c$var$regexParen);
                if (!match) $8581d448cf24c27c$var$logger.throwArgumentError("invalid event string", "value", value);
                var anonymous = false;
                match[3].split(" ").forEach(function(modifier) {
                    switch(modifier.trim()){
                        case "anonymous":
                            anonymous = true;
                            break;
                        case "":
                            break;
                        default:
                            $8581d448cf24c27c$var$logger.warn("unknown modifier: " + modifier);
                    }
                });
                return EventFragment.fromObject({
                    name: match[1].trim(),
                    anonymous: anonymous,
                    inputs: $8581d448cf24c27c$var$parseParams(match[2], true),
                    type: "event"
                });
            }
        },
        {
            key: "isEventFragment",
            value: function isEventFragment(value) {
                return value && value._isFragment && value.type === "event";
            }
        }
    ]);
    return EventFragment;
}($8581d448cf24c27c$export$ffb0004e005737fa);
function $8581d448cf24c27c$var$parseGas(value, params) {
    params.gas = null;
    var comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $8581d448cf24c27c$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $8581d448cf24c27c$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $7ryKd.BigNumber).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $8581d448cf24c27c$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach(function(modifier) {
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $8581d448cf24c27c$var$verifyState(value) {
    var result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $8581d448cf24c27c$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $8581d448cf24c27c$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $8581d448cf24c27c$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $8581d448cf24c27c$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $8581d448cf24c27c$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
var $8581d448cf24c27c$export$3ac5c9504f801ea4 = /*#__PURE__*/ function(Fragment) {
    (0, $i0LXg._)(ConstructorFragment, Fragment);
    var _super = (0, $a1vXf._)(ConstructorFragment);
    function ConstructorFragment() {
        (0, $9j09T._)(this, ConstructorFragment);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(ConstructorFragment, [
        {
            key: "format",
            value: function format(format) {
                if (!format) format = $8581d448cf24c27c$export$f010f239efc4d445.sighash;
                if (!$8581d448cf24c27c$export$f010f239efc4d445[format]) $8581d448cf24c27c$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $8581d448cf24c27c$export$f010f239efc4d445.json) return JSON.stringify({
                    type: "constructor",
                    stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
                    payable: this.payable,
                    gas: this.gas ? this.gas.toNumber() : undefined,
                    inputs: this.inputs.map(function(input) {
                        return JSON.parse(input.format(format));
                    })
                });
                if (format === $8581d448cf24c27c$export$f010f239efc4d445.sighash) $8581d448cf24c27c$var$logger.throwError("cannot format a constructor for sighash", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "format(sighash)"
                });
                var result = "constructor(" + this.inputs.map(function(input) {
                    return input.format(format);
                }).join(format === $8581d448cf24c27c$export$f010f239efc4d445.full ? ", " : ",") + ") ";
                if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
                return result.trim();
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (typeof value === "string") return ConstructorFragment.fromString(value);
                return ConstructorFragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (ConstructorFragment.isConstructorFragment(value)) return value;
                if (value.type !== "constructor") $8581d448cf24c27c$var$logger.throwArgumentError("invalid constructor object", "value", value);
                var state = $8581d448cf24c27c$var$verifyState(value);
                if (state.constant) $8581d448cf24c27c$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
                var params = {
                    name: null,
                    type: value.type,
                    inputs: value.inputs ? value.inputs.map($8581d448cf24c27c$export$426dc07f493a4c47.fromObject) : [],
                    payable: state.payable,
                    stateMutability: state.stateMutability,
                    gas: value.gas ? (0, $7ryKd.BigNumber).from(value.gas) : null
                };
                return new ConstructorFragment($8581d448cf24c27c$var$_constructorGuard, params);
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                var params = {
                    type: "constructor"
                };
                value = $8581d448cf24c27c$var$parseGas(value, params);
                var parens = value.match($8581d448cf24c27c$var$regexParen);
                if (!parens || parens[1].trim() !== "constructor") $8581d448cf24c27c$var$logger.throwArgumentError("invalid constructor string", "value", value);
                params.inputs = $8581d448cf24c27c$var$parseParams(parens[2].trim(), false);
                $8581d448cf24c27c$var$parseModifiers(parens[3].trim(), params);
                return ConstructorFragment.fromObject(params);
            }
        },
        {
            key: "isConstructorFragment",
            value: function isConstructorFragment(value) {
                return value && value._isFragment && value.type === "constructor";
            }
        }
    ]);
    return ConstructorFragment;
}($8581d448cf24c27c$export$ffb0004e005737fa);
var $8581d448cf24c27c$export$8d576c928b93668f = /*#__PURE__*/ function(ConstructorFragment) {
    (0, $i0LXg._)(FunctionFragment, ConstructorFragment);
    var _super = (0, $a1vXf._)(FunctionFragment);
    function FunctionFragment() {
        (0, $9j09T._)(this, FunctionFragment);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(FunctionFragment, [
        {
            key: "format",
            value: function format(format) {
                if (!format) format = $8581d448cf24c27c$export$f010f239efc4d445.sighash;
                if (!$8581d448cf24c27c$export$f010f239efc4d445[format]) $8581d448cf24c27c$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $8581d448cf24c27c$export$f010f239efc4d445.json) return JSON.stringify({
                    type: "function",
                    name: this.name,
                    constant: this.constant,
                    stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
                    payable: this.payable,
                    gas: this.gas ? this.gas.toNumber() : undefined,
                    inputs: this.inputs.map(function(input) {
                        return JSON.parse(input.format(format));
                    }),
                    outputs: this.outputs.map(function(output) {
                        return JSON.parse(output.format(format));
                    })
                });
                var result = "";
                if (format !== $8581d448cf24c27c$export$f010f239efc4d445.sighash) result += "function ";
                result += this.name + "(" + this.inputs.map(function(input) {
                    return input.format(format);
                }).join(format === $8581d448cf24c27c$export$f010f239efc4d445.full ? ", " : ",") + ") ";
                if (format !== $8581d448cf24c27c$export$f010f239efc4d445.sighash) {
                    if (this.stateMutability) {
                        if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
                    } else if (this.constant) result += "view ";
                    if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map(function(output) {
                        return output.format(format);
                    }).join(", ") + ") ";
                    if (this.gas != null) result += "@" + this.gas.toString() + " ";
                }
                return result.trim();
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (typeof value === "string") return FunctionFragment.fromString(value);
                return FunctionFragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (FunctionFragment.isFunctionFragment(value)) return value;
                if (value.type !== "function") $8581d448cf24c27c$var$logger.throwArgumentError("invalid function object", "value", value);
                var state = $8581d448cf24c27c$var$verifyState(value);
                var params = {
                    type: value.type,
                    name: $8581d448cf24c27c$var$verifyIdentifier(value.name),
                    constant: state.constant,
                    inputs: value.inputs ? value.inputs.map($8581d448cf24c27c$export$426dc07f493a4c47.fromObject) : [],
                    outputs: value.outputs ? value.outputs.map($8581d448cf24c27c$export$426dc07f493a4c47.fromObject) : [],
                    payable: state.payable,
                    stateMutability: state.stateMutability,
                    gas: value.gas ? (0, $7ryKd.BigNumber).from(value.gas) : null
                };
                return new FunctionFragment($8581d448cf24c27c$var$_constructorGuard, params);
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                var params = {
                    type: "function"
                };
                value = $8581d448cf24c27c$var$parseGas(value, params);
                var comps = value.split(" returns ");
                if (comps.length > 2) $8581d448cf24c27c$var$logger.throwArgumentError("invalid function string", "value", value);
                var parens = comps[0].match($8581d448cf24c27c$var$regexParen);
                if (!parens) $8581d448cf24c27c$var$logger.throwArgumentError("invalid function signature", "value", value);
                params.name = parens[1].trim();
                if (params.name) $8581d448cf24c27c$var$verifyIdentifier(params.name);
                params.inputs = $8581d448cf24c27c$var$parseParams(parens[2], false);
                $8581d448cf24c27c$var$parseModifiers(parens[3].trim(), params);
                // We have outputs
                if (comps.length > 1) {
                    var returns = comps[1].match($8581d448cf24c27c$var$regexParen);
                    if (returns[1].trim() != "" || returns[3].trim() != "") $8581d448cf24c27c$var$logger.throwArgumentError("unexpected tokens", "value", value);
                    params.outputs = $8581d448cf24c27c$var$parseParams(returns[2], false);
                } else params.outputs = [];
                return FunctionFragment.fromObject(params);
            }
        },
        {
            key: "isFunctionFragment",
            value: function isFunctionFragment(value) {
                return value && value._isFragment && value.type === "function";
            }
        }
    ]);
    return FunctionFragment;
}($8581d448cf24c27c$export$3ac5c9504f801ea4);
//export class StructFragment extends Fragment {
//}
function $8581d448cf24c27c$var$checkForbidden(fragment) {
    var sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") $8581d448cf24c27c$var$logger.throwArgumentError("cannot specify user defined ".concat(sig, " error"), "fragment", fragment);
    return fragment;
}
var $8581d448cf24c27c$export$2c42c6d543aa9b59 = /*#__PURE__*/ function(Fragment) {
    (0, $i0LXg._)(ErrorFragment, Fragment);
    var _super = (0, $a1vXf._)(ErrorFragment);
    function ErrorFragment() {
        (0, $9j09T._)(this, ErrorFragment);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(ErrorFragment, [
        {
            key: "format",
            value: function format(format) {
                if (!format) format = $8581d448cf24c27c$export$f010f239efc4d445.sighash;
                if (!$8581d448cf24c27c$export$f010f239efc4d445[format]) $8581d448cf24c27c$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $8581d448cf24c27c$export$f010f239efc4d445.json) return JSON.stringify({
                    type: "error",
                    name: this.name,
                    inputs: this.inputs.map(function(input) {
                        return JSON.parse(input.format(format));
                    })
                });
                var result = "";
                if (format !== $8581d448cf24c27c$export$f010f239efc4d445.sighash) result += "error ";
                result += this.name + "(" + this.inputs.map(function(input) {
                    return input.format(format);
                }).join(format === $8581d448cf24c27c$export$f010f239efc4d445.full ? ", " : ",") + ") ";
                return result.trim();
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (typeof value === "string") return ErrorFragment.fromString(value);
                return ErrorFragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (ErrorFragment.isErrorFragment(value)) return value;
                if (value.type !== "error") $8581d448cf24c27c$var$logger.throwArgumentError("invalid error object", "value", value);
                var params = {
                    type: value.type,
                    name: $8581d448cf24c27c$var$verifyIdentifier(value.name),
                    inputs: value.inputs ? value.inputs.map($8581d448cf24c27c$export$426dc07f493a4c47.fromObject) : []
                };
                return $8581d448cf24c27c$var$checkForbidden(new ErrorFragment($8581d448cf24c27c$var$_constructorGuard, params));
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                var params = {
                    type: "error"
                };
                var parens = value.match($8581d448cf24c27c$var$regexParen);
                if (!parens) $8581d448cf24c27c$var$logger.throwArgumentError("invalid error signature", "value", value);
                params.name = parens[1].trim();
                if (params.name) $8581d448cf24c27c$var$verifyIdentifier(params.name);
                params.inputs = $8581d448cf24c27c$var$parseParams(parens[2], false);
                return $8581d448cf24c27c$var$checkForbidden(ErrorFragment.fromObject(params));
            }
        },
        {
            key: "isErrorFragment",
            value: function isErrorFragment(value) {
                return value && value._isFragment && value.type === "error";
            }
        }
    ]);
    return ErrorFragment;
}($8581d448cf24c27c$export$ffb0004e005737fa);
function $8581d448cf24c27c$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
var $8581d448cf24c27c$var$regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function $8581d448cf24c27c$var$verifyIdentifier(value) {
    if (!value || !value.match($8581d448cf24c27c$var$regexIdentifier)) $8581d448cf24c27c$var$logger.throwArgumentError('invalid identifier "'.concat(value, '"'), "value", value);
    return value;
}
var $8581d448cf24c27c$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $8581d448cf24c27c$var$splitNesting(value) {
    value = value.trim();
    var result = [];
    var accum = "";
    var depth = 0;
    for(var offset = 0; offset < value.length; offset++){
        var c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $8581d448cf24c27c$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}

});



parcelRegister("fH8QX", function(module, exports) {

$parcel$export(module.exports, "ForkEvent", function () { return $b6d1bd3b1d74c91b$export$406ece1549ccd00e; });
$parcel$export(module.exports, "Provider", function () { return $b6d1bd3b1d74c91b$export$2881499e37b75b9a; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");

var $7ryKd = parcelRequire("7ryKd");

var $2tHqU = parcelRequire("2tHqU");

var $iqBKf = parcelRequire("iqBKf");

var $ihGvV = parcelRequire("ihGvV");

var $97JvF = parcelRequire("97JvF");
"use strict";
var $b6d1bd3b1d74c91b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b6d1bd3b1d74c91b$var$logger = new (0, $ihGvV.Logger)((0, $97JvF.version));
var $b6d1bd3b1d74c91b$export$406ece1549ccd00e = /*#__PURE__*/ function(Description) {
    (0, $i0LXg._)(ForkEvent, Description);
    var _super = (0, $a1vXf._)(ForkEvent);
    function ForkEvent() {
        (0, $9j09T._)(this, ForkEvent);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(ForkEvent, null, [
        {
            key: "isForkEvent",
            value: function isForkEvent(value) {
                return !!(value && value._isForkEvent);
            }
        }
    ]);
    return ForkEvent;
}((0, $iqBKf.Description));
var $b6d1bd3b1d74c91b$export$5b2cada8494f9d99 = /*#__PURE__*/ function(ForkEvent) {
    (0, $i0LXg._)(BlockForkEvent, ForkEvent);
    var _super = (0, $a1vXf._)(BlockForkEvent);
    function BlockForkEvent(blockHash, expiry) {
        (0, $9j09T._)(this, BlockForkEvent);
        if (!(0, $2tHqU.isHexString)(blockHash, 32)) $b6d1bd3b1d74c91b$var$logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
        return _super.call(this, {
            _isForkEvent: true,
            _isBlockForkEvent: true,
            expiry: expiry || 0,
            blockHash: blockHash
        });
    }
    return BlockForkEvent;
}($b6d1bd3b1d74c91b$export$406ece1549ccd00e);
var $b6d1bd3b1d74c91b$export$26bcd61a55716c98 = /*#__PURE__*/ function(ForkEvent) {
    (0, $i0LXg._)(TransactionForkEvent, ForkEvent);
    var _super = (0, $a1vXf._)(TransactionForkEvent);
    function TransactionForkEvent(hash, expiry) {
        (0, $9j09T._)(this, TransactionForkEvent);
        if (!(0, $2tHqU.isHexString)(hash, 32)) $b6d1bd3b1d74c91b$var$logger.throwArgumentError("invalid transaction hash", "hash", hash);
        return _super.call(this, {
            _isForkEvent: true,
            _isTransactionForkEvent: true,
            expiry: expiry || 0,
            hash: hash
        });
    }
    return TransactionForkEvent;
}($b6d1bd3b1d74c91b$export$406ece1549ccd00e);
var $b6d1bd3b1d74c91b$export$8f8609bfee47c93 = /*#__PURE__*/ function(ForkEvent) {
    (0, $i0LXg._)(TransactionOrderForkEvent, ForkEvent);
    var _super = (0, $a1vXf._)(TransactionOrderForkEvent);
    function TransactionOrderForkEvent(beforeHash, afterHash, expiry) {
        (0, $9j09T._)(this, TransactionOrderForkEvent);
        if (!(0, $2tHqU.isHexString)(beforeHash, 32)) $b6d1bd3b1d74c91b$var$logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
        if (!(0, $2tHqU.isHexString)(afterHash, 32)) $b6d1bd3b1d74c91b$var$logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
        return _super.call(this, {
            _isForkEvent: true,
            _isTransactionOrderForkEvent: true,
            expiry: expiry || 0,
            beforeHash: beforeHash,
            afterHash: afterHash
        });
    }
    return TransactionOrderForkEvent;
}($b6d1bd3b1d74c91b$export$406ece1549ccd00e);
var $b6d1bd3b1d74c91b$export$2881499e37b75b9a = /*#__PURE__*/ function _target() {
    function Provider() {
        (0, $9j09T._)(this, Provider);
        $b6d1bd3b1d74c91b$var$logger.checkAbstract(this instanceof Provider ? this.constructor : void 0, Provider);
        (0, $iqBKf.defineReadOnly)(this, "_isProvider", true);
    }
    (0, $eDeHT._)(Provider, [
        {
            key: "getFeeData",
            value: function getFeeData() {
                return $b6d1bd3b1d74c91b$var$__awaiter(this, void 0, void 0, function() {
                    var _ref, block, gasPrice, maxFeePerGas, maxPriorityFeePerGas;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $iqBKf.resolveProperties)({
                                        block: this.getBlock("latest"),
                                        gasPrice: this.getGasPrice().catch(function(error) {
                                            // @TODO: Why is this now failing on Calaveras?
                                            //console.log(error);
                                            return null;
                                        })
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), block = _ref.block, gasPrice = _ref.gasPrice;
                                maxFeePerGas = null, maxPriorityFeePerGas = null;
                                if (block && block.baseFeePerGas) {
                                    // We may want to compute this more accurately in the future,
                                    // using the formula "check if the base fee is correct".
                                    // See: https://eips.ethereum.org/EIPS/eip-1559
                                    maxPriorityFeePerGas = (0, $7ryKd.BigNumber).from("2500000000");
                                    maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
                                }
                                return [
                                    2,
                                    {
                                        maxFeePerGas: maxFeePerGas,
                                        maxPriorityFeePerGas: maxPriorityFeePerGas,
                                        gasPrice: gasPrice
                                    }
                                ];
                        }
                    });
                });
            }
        },
        {
            // Alias for "on"
            key: "addListener",
            value: function addListener(eventName, listener) {
                return this.on(eventName, listener);
            }
        },
        {
            // Alias for "off"
            key: "removeListener",
            value: function removeListener(eventName, listener) {
                return this.off(eventName, listener);
            }
        }
    ], [
        {
            key: "isProvider",
            value: function isProvider(value) {
                return !!(value && value._isProvider);
            }
        }
    ]);
    return Provider;
}();

});
parcelRegister("97JvF", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $6a4811c797d12bd1$export$83d89fbfd8236492; });
var $6a4811c797d12bd1$export$83d89fbfd8236492 = "abstract-provider/5.5.1";

});


parcelRegister("3KRXu", function(module, exports) {

$parcel$export(module.exports, "Signer", function () { return $2bbf860246301732$export$fdf54fdde81cc9f0; });
$parcel$export(module.exports, "VoidSigner", function () { return $2bbf860246301732$export$7dbc56d9b9612bad; });

var $feAea = parcelRequire("feAea");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");

var $iqBKf = parcelRequire("iqBKf");

var $ihGvV = parcelRequire("ihGvV");

var $31IFu = parcelRequire("31IFu");
"use strict";
var $2bbf860246301732$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2bbf860246301732$var$logger = new (0, $ihGvV.Logger)((0, $31IFu.version));
var $2bbf860246301732$var$allowedTransactionKeys = [
    "accessList",
    "chainId",
    "customData",
    "data",
    "from",
    "gasLimit",
    "gasPrice",
    "maxFeePerGas",
    "maxPriorityFeePerGas",
    "nonce",
    "to",
    "type",
    "value"
];
var $2bbf860246301732$var$forwardErrors = [
    (0, $ihGvV.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $ihGvV.Logger).errors.NONCE_EXPIRED,
    (0, $ihGvV.Logger).errors.REPLACEMENT_UNDERPRICED
];
var $2bbf860246301732$export$fdf54fdde81cc9f0 = /*#__PURE__*/ function _target() {
    function Signer() {
        (0, $9j09T._)(this, Signer);
        $2bbf860246301732$var$logger.checkAbstract(this instanceof Signer ? this.constructor : void 0, Signer);
        (0, $iqBKf.defineReadOnly)(this, "_isSigner", true);
    }
    (0, $eDeHT._)(Signer, [
        {
            ///////////////////
            // Sub-classes MAY override these
            key: "getBalance",
            value: function getBalance(blockTag) {
                return $2bbf860246301732$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("getBalance");
                                return [
                                    4,
                                    this.provider.getBalance(this.getAddress(), blockTag)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getTransactionCount",
            value: function getTransactionCount(blockTag) {
                return $2bbf860246301732$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("getTransactionCount");
                                return [
                                    4,
                                    this.provider.getTransactionCount(this.getAddress(), blockTag)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            // Populates "from" if unspecified, and estimates the gas for the transaction
            key: "estimateGas",
            value: function estimateGas(transaction) {
                return $2bbf860246301732$var$__awaiter(this, void 0, void 0, function() {
                    var tx;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("estimateGas");
                                return [
                                    4,
                                    (0, $iqBKf.resolveProperties)(this.checkTransaction(transaction))
                                ];
                            case 1:
                                tx = _state.sent();
                                return [
                                    4,
                                    this.provider.estimateGas(tx)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            // Populates "from" if unspecified, and calls with the transaction
            key: "call",
            value: function call(transaction, blockTag) {
                return $2bbf860246301732$var$__awaiter(this, void 0, void 0, function() {
                    var tx;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("call");
                                return [
                                    4,
                                    (0, $iqBKf.resolveProperties)(this.checkTransaction(transaction))
                                ];
                            case 1:
                                tx = _state.sent();
                                return [
                                    4,
                                    this.provider.call(tx, blockTag)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            // Populates all fields in a transaction, signs it and sends it to the network
            key: "sendTransaction",
            value: function sendTransaction(transaction) {
                return $2bbf860246301732$var$__awaiter(this, void 0, void 0, function() {
                    var tx, signedTx;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("sendTransaction");
                                return [
                                    4,
                                    this.populateTransaction(transaction)
                                ];
                            case 1:
                                tx = _state.sent();
                                return [
                                    4,
                                    this.signTransaction(tx)
                                ];
                            case 2:
                                signedTx = _state.sent();
                                return [
                                    4,
                                    this.provider.sendTransaction(signedTx)
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getChainId",
            value: function getChainId() {
                return $2bbf860246301732$var$__awaiter(this, void 0, void 0, function() {
                    var network;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("getChainId");
                                return [
                                    4,
                                    this.provider.getNetwork()
                                ];
                            case 1:
                                network = _state.sent();
                                return [
                                    2,
                                    network.chainId
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getGasPrice",
            value: function getGasPrice() {
                return $2bbf860246301732$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("getGasPrice");
                                return [
                                    4,
                                    this.provider.getGasPrice()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getFeeData",
            value: function getFeeData() {
                return $2bbf860246301732$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("getFeeData");
                                return [
                                    4,
                                    this.provider.getFeeData()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "resolveName",
            value: function resolveName(name) {
                return $2bbf860246301732$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("resolveName");
                                return [
                                    4,
                                    this.provider.resolveName(name)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            // Checks a transaction does not contain invalid keys and if
            // no "from" is provided, populates it.
            // - does NOT require a provider
            // - adds "from" is not present
            // - returns a COPY (safe to mutate the result)
            // By default called from: (overriding these prevents it)
            //   - call
            //   - estimateGas
            //   - populateTransaction (and therefor sendTransaction)
            key: "checkTransaction",
            value: function checkTransaction(transaction) {
                for(var key in transaction)if ($2bbf860246301732$var$allowedTransactionKeys.indexOf(key) === -1) $2bbf860246301732$var$logger.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
                var tx = (0, $iqBKf.shallowCopy)(transaction);
                if (tx.from == null) tx.from = this.getAddress();
                else // Make sure any provided address matches this signer
                tx.from = Promise.all([
                    Promise.resolve(tx.from),
                    this.getAddress()
                ]).then(function(result) {
                    if (result[0].toLowerCase() !== result[1].toLowerCase()) $2bbf860246301732$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
                    return result[0];
                });
                return tx;
            }
        },
        {
            // Populates ALL keys for a transaction and checks that "from" matches
            // this Signer. Should be used by sendTransaction but NOT by signTransaction.
            // By default called from: (overriding these prevents it)
            //   - sendTransaction
            //
            // Notes:
            //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
            key: "populateTransaction",
            value: function populateTransaction(transaction) {
                return $2bbf860246301732$var$__awaiter(this, void 0, void 0, function() {
                    var _this, tx, hasEip1559, feeData, gasPrice;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    (0, $iqBKf.resolveProperties)(this.checkTransaction(transaction))
                                ];
                            case 1:
                                tx = _state.sent();
                                if (tx.to != null) {
                                    tx.to = Promise.resolve(tx.to).then(function(to) {
                                        return $2bbf860246301732$var$__awaiter(_this, void 0, void 0, function() {
                                            var address;
                                            return (0, $itJXR.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (to == null) return [
                                                            2,
                                                            null
                                                        ];
                                                        return [
                                                            4,
                                                            this.resolveName(to)
                                                        ];
                                                    case 1:
                                                        address = _state.sent();
                                                        if (address == null) $2bbf860246301732$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                                                        return [
                                                            2,
                                                            address
                                                        ];
                                                }
                                            });
                                        });
                                    });
                                    // Prevent this error from causing an UnhandledPromiseException
                                    tx.to.catch(function(error) {});
                                }
                                // Do not allow mixing pre-eip-1559 and eip-1559 properties
                                hasEip1559 = tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null;
                                if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) $2bbf860246301732$var$logger.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
                                else if ((tx.type === 0 || tx.type === 1) && hasEip1559) $2bbf860246301732$var$logger.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
                                if (!((tx.type === 2 || tx.type == null) && tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null)) return [
                                    3,
                                    2
                                ];
                                // Fully-formed EIP-1559 transaction (skip getFeeData)
                                tx.type = 2;
                                return [
                                    3,
                                    5
                                ];
                            case 2:
                                if (!(tx.type === 0 || tx.type === 1)) return [
                                    3,
                                    3
                                ];
                                // Explicit Legacy or EIP-2930 transaction
                                // Populate missing gasPrice
                                if (tx.gasPrice == null) tx.gasPrice = this.getGasPrice();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                return [
                                    4,
                                    this.getFeeData()
                                ];
                            case 4:
                                feeData = _state.sent();
                                if (tx.type == null) {
                                    // We need to auto-detect the intended type of this transaction...
                                    if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                                        // The network supports EIP-1559!
                                        // Upgrade transaction from null to eip-1559
                                        tx.type = 2;
                                        if (tx.gasPrice != null) {
                                            // Using legacy gasPrice property on an eip-1559 network,
                                            // so use gasPrice as both fee properties
                                            gasPrice = tx.gasPrice;
                                            delete tx.gasPrice;
                                            tx.maxFeePerGas = gasPrice;
                                            tx.maxPriorityFeePerGas = gasPrice;
                                        } else {
                                            // Populate missing fee data
                                            if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                                            if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                                        }
                                    } else if (feeData.gasPrice != null) {
                                        // Network doesn't support EIP-1559...
                                        // ...but they are trying to use EIP-1559 properties
                                        if (hasEip1559) $2bbf860246301732$var$logger.throwError("network does not support EIP-1559", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                                            operation: "populateTransaction"
                                        });
                                        // Populate missing fee data
                                        if (tx.gasPrice == null) tx.gasPrice = feeData.gasPrice;
                                        // Explicitly set untyped transaction to legacy
                                        tx.type = 0;
                                    } else // getFeeData has failed us.
                                    $2bbf860246301732$var$logger.throwError("failed to get consistent fee data", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                                        operation: "signer.getFeeData"
                                    });
                                } else if (tx.type === 2) {
                                    // Explicitly using EIP-1559
                                    // Populate missing fee data
                                    if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                                    if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                                }
                                _state.label = 5;
                            case 5:
                                if (tx.nonce == null) tx.nonce = this.getTransactionCount("pending");
                                if (tx.gasLimit == null) tx.gasLimit = this.estimateGas(tx).catch(function(error) {
                                    if ($2bbf860246301732$var$forwardErrors.indexOf(error.code) >= 0) throw error;
                                    return $2bbf860246301732$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $ihGvV.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
                                        error: error,
                                        tx: tx
                                    });
                                });
                                if (tx.chainId == null) tx.chainId = this.getChainId();
                                else tx.chainId = Promise.all([
                                    Promise.resolve(tx.chainId),
                                    this.getChainId()
                                ]).then(function(results) {
                                    if (results[1] !== 0 && results[0] !== results[1]) $2bbf860246301732$var$logger.throwArgumentError("chainId address mismatch", "transaction", transaction);
                                    return results[0];
                                });
                                return [
                                    4,
                                    (0, $iqBKf.resolveProperties)(tx)
                                ];
                            case 6:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            ///////////////////
            // Sub-classes SHOULD leave these alone
            key: "_checkProvider",
            value: function _checkProvider(operation) {
                if (!this.provider) $2bbf860246301732$var$logger.throwError("missing provider", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: operation || "_checkProvider"
                });
            }
        }
    ], [
        {
            key: "isSigner",
            value: function isSigner(value) {
                return !!(value && value._isSigner);
            }
        }
    ]);
    return Signer;
}();
var $2bbf860246301732$export$7dbc56d9b9612bad = /*#__PURE__*/ function _target(Signer) {
    (0, $i0LXg._)(VoidSigner, Signer);
    var _super = (0, $a1vXf._)(VoidSigner);
    function VoidSigner(address, provider) {
        (0, $9j09T._)(this, VoidSigner);
        var _this;
        $2bbf860246301732$var$logger.checkNew(this instanceof VoidSigner ? this.constructor : void 0, VoidSigner);
        _this = _super.call(this);
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "address", address);
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "provider", provider || null);
        return _this;
    }
    (0, $eDeHT._)(VoidSigner, [
        {
            key: "getAddress",
            value: function getAddress() {
                return Promise.resolve(this.address);
            }
        },
        {
            key: "_fail",
            value: function _fail(message, operation) {
                return Promise.resolve().then(function() {
                    $2bbf860246301732$var$logger.throwError(message, (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: operation
                    });
                });
            }
        },
        {
            key: "signMessage",
            value: function signMessage(message) {
                return this._fail("VoidSigner cannot sign messages", "signMessage");
            }
        },
        {
            key: "signTransaction",
            value: function signTransaction(transaction) {
                return this._fail("VoidSigner cannot sign transactions", "signTransaction");
            }
        },
        {
            key: "_signTypedData",
            value: function _signTypedData(domain, types, value) {
                return this._fail("VoidSigner cannot sign typed data", "signTypedData");
            }
        },
        {
            key: "connect",
            value: function connect(provider) {
                return new VoidSigner(this.address, provider);
            }
        }
    ]);
    return VoidSigner;
}($2bbf860246301732$export$fdf54fdde81cc9f0);

});
parcelRegister("31IFu", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $23441d4028f19e63$export$83d89fbfd8236492; });
var $23441d4028f19e63$export$83d89fbfd8236492 = "abstract-signer/5.5.0";

});


parcelRegister("60XIC", function(module, exports) {

$parcel$export(module.exports, "TransactionTypes", function () { return $4611110b71609ee8$export$80349e05e0724e11; });
$parcel$export(module.exports, "computeAddress", function () { return $4611110b71609ee8$export$e67e2732ba9803f9; });
$parcel$export(module.exports, "recoverAddress", function () { return $4611110b71609ee8$export$23cc18f96d8510e2; });
$parcel$export(module.exports, "accessListify", function () { return $4611110b71609ee8$export$6c8662b1600dce2; });
$parcel$export(module.exports, "serialize", function () { return $4611110b71609ee8$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "parse", function () { return $4611110b71609ee8$export$98e6a39c04603d36; });

var $hFSWi = parcelRequire("hFSWi");

var $7ryKd = parcelRequire("7ryKd");

var $2tHqU = parcelRequire("2tHqU");

var $3bevF = parcelRequire("3bevF");

var $8Ub7X = parcelRequire("8Ub7X");

var $iqBKf = parcelRequire("iqBKf");

var $8gMN8 = parcelRequire("8gMN8");

var $9WpJo = parcelRequire("9WpJo");

var $ihGvV = parcelRequire("ihGvV");

var $fHSzO = parcelRequire("fHSzO");
"use strict";
var $4611110b71609ee8$var$logger = new (0, $ihGvV.Logger)((0, $fHSzO.version));
var $4611110b71609ee8$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($4611110b71609ee8$export$80349e05e0724e11 || ($4611110b71609ee8$export$80349e05e0724e11 = {}));
///////////////////////////////
function $4611110b71609ee8$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $hFSWi.getAddress)(value);
}
function $4611110b71609ee8$var$handleNumber(value) {
    if (value === "0x") return 0, $3bevF.Zero;
    return (0, $7ryKd.BigNumber).from(value);
}
// Legacy Transaction Fields
var $4611110b71609ee8$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
var $4611110b71609ee8$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $4611110b71609ee8$export$e67e2732ba9803f9(key) {
    var publicKey = (0, $9WpJo.computePublicKey)(key);
    return (0, $hFSWi.getAddress)((0, $2tHqU.hexDataSlice)((0, $8Ub7X.keccak256)((0, $2tHqU.hexDataSlice)(publicKey, 1)), 12));
}
function $4611110b71609ee8$export$23cc18f96d8510e2(digest, signature) {
    return $4611110b71609ee8$export$e67e2732ba9803f9((0, $9WpJo.recoverPublicKey)((0, $2tHqU.arrayify)(digest), signature));
}
function $4611110b71609ee8$var$formatNumber(value, name) {
    var result = (0, $2tHqU.stripZeros)((0, $7ryKd.BigNumber).from(value).toHexString());
    if (result.length > 32) $4611110b71609ee8$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $4611110b71609ee8$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $hFSWi.getAddress)(addr),
        storageKeys: (storageKeys || []).map(function(storageKey, index) {
            if ((0, $2tHqU.hexDataLength)(storageKey) !== 32) $4611110b71609ee8$var$logger.throwArgumentError("invalid access list storageKey", "accessList[".concat(addr, ":").concat(index, "]"), storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $4611110b71609ee8$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map(function(set, index) {
        if (Array.isArray(set)) {
            if (set.length > 2) $4611110b71609ee8$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", "value[".concat(index, "]"), set);
            return $4611110b71609ee8$var$accessSetify(set[0], set[1]);
        }
        return $4611110b71609ee8$var$accessSetify(set.address, set.storageKeys);
    });
    var result = Object.keys(value).map(function(addr) {
        var storageKeys = value[addr].reduce(function(accum, storageKey) {
            accum[storageKey] = true;
            return accum;
        }, {});
        return $4611110b71609ee8$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort(function(a, b) {
        return a.address.localeCompare(b.address);
    });
    return result;
}
function $4611110b71609ee8$var$formatAccessList(value) {
    return $4611110b71609ee8$export$6c8662b1600dce2(value).map(function(set) {
        return [
            set.address,
            set.storageKeys
        ];
    });
}
function $4611110b71609ee8$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        var gasPrice = (0, $7ryKd.BigNumber).from(transaction.gasPrice);
        var maxFeePerGas = (0, $7ryKd.BigNumber).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $4611110b71609ee8$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    var fields = [
        $4611110b71609ee8$var$formatNumber(transaction.chainId || 0, "chainId"),
        $4611110b71609ee8$var$formatNumber(transaction.nonce || 0, "nonce"),
        $4611110b71609ee8$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $4611110b71609ee8$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $4611110b71609ee8$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $hFSWi.getAddress)(transaction.to) : "0x",
        $4611110b71609ee8$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $4611110b71609ee8$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        var sig = (0, $2tHqU.splitSignature)(signature);
        fields.push($4611110b71609ee8$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $2tHqU.stripZeros)(sig.r));
        fields.push((0, $2tHqU.stripZeros)(sig.s));
    }
    return (0, $2tHqU.hexConcat)([
        "0x02",
        $8gMN8.encode(fields)
    ]);
}
function $4611110b71609ee8$var$_serializeEip2930(transaction, signature) {
    var fields = [
        $4611110b71609ee8$var$formatNumber(transaction.chainId || 0, "chainId"),
        $4611110b71609ee8$var$formatNumber(transaction.nonce || 0, "nonce"),
        $4611110b71609ee8$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $4611110b71609ee8$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $hFSWi.getAddress)(transaction.to) : "0x",
        $4611110b71609ee8$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $4611110b71609ee8$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        var sig = (0, $2tHqU.splitSignature)(signature);
        fields.push($4611110b71609ee8$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $2tHqU.stripZeros)(sig.r));
        fields.push((0, $2tHqU.stripZeros)(sig.s));
    }
    return (0, $2tHqU.hexConcat)([
        "0x01",
        $8gMN8.encode(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $4611110b71609ee8$var$_serialize(transaction, signature) {
    (0, $iqBKf.checkProperties)(transaction, $4611110b71609ee8$var$allowedTransactionKeys);
    var raw = [];
    $4611110b71609ee8$var$transactionFields.forEach(function(fieldInfo) {
        var value = transaction[fieldInfo.name] || [];
        var options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $2tHqU.arrayify)((0, $2tHqU.hexlify)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $4611110b71609ee8$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $2tHqU.stripZeros)(value);
            if (value.length > fieldInfo.maxLength) $4611110b71609ee8$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $2tHqU.hexlify)(value));
    });
    var chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $4611110b71609ee8$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $2tHqU.isBytesLike)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $2tHqU.hexlify)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $8gMN8.encode(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    var sig = (0, $2tHqU.splitSignature)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    var v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $4611110b71609ee8$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $4611110b71609ee8$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $2tHqU.hexlify)(v));
    raw.push((0, $2tHqU.stripZeros)((0, $2tHqU.arrayify)(sig.r)));
    raw.push((0, $2tHqU.stripZeros)((0, $2tHqU.arrayify)(sig.s)));
    return $8gMN8.encode(raw);
}
function $4611110b71609ee8$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $4611110b71609ee8$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $4611110b71609ee8$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $4611110b71609ee8$var$_serializeEip2930(transaction, signature);
        case 2:
            return $4611110b71609ee8$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $4611110b71609ee8$var$logger.throwError("unsupported transaction type: ".concat(transaction.type), (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $4611110b71609ee8$var$_parseEipSignature(tx, fields, serialize) {
    try {
        var recid = $4611110b71609ee8$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $4611110b71609ee8$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $2tHqU.hexZeroPad)(fields[1], 32);
    tx.s = (0, $2tHqU.hexZeroPad)(fields[2], 32);
    try {
        var digest = (0, $8Ub7X.keccak256)(serialize(tx));
        tx.from = $4611110b71609ee8$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {
        console.log(error);
    }
}
function $4611110b71609ee8$var$_parseEip1559(payload) {
    var transaction = $8gMN8.decode(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $4611110b71609ee8$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $2tHqU.hexlify)(payload));
    var maxPriorityFeePerGas = $4611110b71609ee8$var$handleNumber(transaction[2]);
    var maxFeePerGas = $4611110b71609ee8$var$handleNumber(transaction[3]);
    var tx = {
        type: 2,
        chainId: $4611110b71609ee8$var$handleNumber(transaction[0]).toNumber(),
        nonce: $4611110b71609ee8$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $4611110b71609ee8$var$handleNumber(transaction[4]),
        to: $4611110b71609ee8$var$handleAddress(transaction[5]),
        value: $4611110b71609ee8$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $4611110b71609ee8$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $8Ub7X.keccak256)(payload);
    $4611110b71609ee8$var$_parseEipSignature(tx, transaction.slice(9), $4611110b71609ee8$var$_serializeEip1559);
    return tx;
}
function $4611110b71609ee8$var$_parseEip2930(payload) {
    var transaction = $8gMN8.decode(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $4611110b71609ee8$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $2tHqU.hexlify)(payload));
    var tx = {
        type: 1,
        chainId: $4611110b71609ee8$var$handleNumber(transaction[0]).toNumber(),
        nonce: $4611110b71609ee8$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $4611110b71609ee8$var$handleNumber(transaction[2]),
        gasLimit: $4611110b71609ee8$var$handleNumber(transaction[3]),
        to: $4611110b71609ee8$var$handleAddress(transaction[4]),
        value: $4611110b71609ee8$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $4611110b71609ee8$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $8Ub7X.keccak256)(payload);
    $4611110b71609ee8$var$_parseEipSignature(tx, transaction.slice(8), $4611110b71609ee8$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $4611110b71609ee8$var$_parse(rawTransaction) {
    var transaction = $8gMN8.decode(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $4611110b71609ee8$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    var tx = {
        nonce: $4611110b71609ee8$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $4611110b71609ee8$var$handleNumber(transaction[1]),
        gasLimit: $4611110b71609ee8$var$handleNumber(transaction[2]),
        to: $4611110b71609ee8$var$handleAddress(transaction[3]),
        value: $4611110b71609ee8$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $7ryKd.BigNumber).from(transaction[6]).toNumber();
    } catch (error) {
        console.log(error);
        return tx;
    }
    tx.r = (0, $2tHqU.hexZeroPad)(transaction[7], 32);
    tx.s = (0, $2tHqU.hexZeroPad)(transaction[8], 32);
    if ((0, $7ryKd.BigNumber).from(tx.r).isZero() && (0, $7ryKd.BigNumber).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        var recoveryParam = tx.v - 27;
        var raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $2tHqU.hexlify)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        var digest = (0, $8Ub7X.keccak256)($8gMN8.encode(raw));
        try {
            tx.from = $4611110b71609ee8$export$23cc18f96d8510e2(digest, {
                r: (0, $2tHqU.hexlify)(tx.r),
                s: (0, $2tHqU.hexlify)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {
            console.log(error);
        }
        tx.hash = (0, $8Ub7X.keccak256)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $4611110b71609ee8$export$98e6a39c04603d36(rawTransaction) {
    var payload = (0, $2tHqU.arrayify)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $4611110b71609ee8$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $4611110b71609ee8$var$_parseEip2930(payload);
        case 2:
            return $4611110b71609ee8$var$_parseEip1559(payload);
        default:
            break;
    }
    return $4611110b71609ee8$var$logger.throwError("unsupported transaction type: ".concat(payload[0]), (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}

});
parcelRegister("9WpJo", function(module, exports) {

$parcel$export(module.exports, "SigningKey", function () { return $73cd7d7e5b0f24b1$export$21643ca94aed3e83; });
$parcel$export(module.exports, "computePublicKey", function () { return $73cd7d7e5b0f24b1$export$4a89473d39301224; });
$parcel$export(module.exports, "recoverPublicKey", function () { return $73cd7d7e5b0f24b1$export$952dd09fbe0232b7; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $3NoJ3 = parcelRequire("3NoJ3");

var $2tHqU = parcelRequire("2tHqU");

var $iqBKf = parcelRequire("iqBKf");

var $ihGvV = parcelRequire("ihGvV");

var $lUlTy = parcelRequire("lUlTy");
"use strict";
var $73cd7d7e5b0f24b1$var$logger = new (0, $ihGvV.Logger)((0, $lUlTy.version));
var $73cd7d7e5b0f24b1$var$_curve = null;
function $73cd7d7e5b0f24b1$var$getCurve() {
    if (!$73cd7d7e5b0f24b1$var$_curve) $73cd7d7e5b0f24b1$var$_curve = new (0, $3NoJ3.EC)("secp256k1");
    return $73cd7d7e5b0f24b1$var$_curve;
}
var $73cd7d7e5b0f24b1$export$21643ca94aed3e83 = /*#__PURE__*/ function() {
    function SigningKey(privateKey) {
        (0, $9j09T._)(this, SigningKey);
        (0, $iqBKf.defineReadOnly)(this, "curve", "secp256k1");
        (0, $iqBKf.defineReadOnly)(this, "privateKey", (0, $2tHqU.hexlify)(privateKey));
        var keyPair = $73cd7d7e5b0f24b1$var$getCurve().keyFromPrivate((0, $2tHqU.arrayify)(this.privateKey));
        (0, $iqBKf.defineReadOnly)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $iqBKf.defineReadOnly)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $iqBKf.defineReadOnly)(this, "_isSigningKey", true);
    }
    (0, $eDeHT._)(SigningKey, [
        {
            key: "_addPoint",
            value: function _addPoint(other) {
                var p0 = $73cd7d7e5b0f24b1$var$getCurve().keyFromPublic((0, $2tHqU.arrayify)(this.publicKey));
                var p1 = $73cd7d7e5b0f24b1$var$getCurve().keyFromPublic((0, $2tHqU.arrayify)(other));
                return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
            }
        },
        {
            key: "signDigest",
            value: function signDigest(digest) {
                var keyPair = $73cd7d7e5b0f24b1$var$getCurve().keyFromPrivate((0, $2tHqU.arrayify)(this.privateKey));
                var digestBytes = (0, $2tHqU.arrayify)(digest);
                if (digestBytes.length !== 32) $73cd7d7e5b0f24b1$var$logger.throwArgumentError("bad digest length", "digest", digest);
                var signature = keyPair.sign(digestBytes, {
                    canonical: true
                });
                return (0, $2tHqU.splitSignature)({
                    recoveryParam: signature.recoveryParam,
                    r: (0, $2tHqU.hexZeroPad)("0x" + signature.r.toString(16), 32),
                    s: (0, $2tHqU.hexZeroPad)("0x" + signature.s.toString(16), 32)
                });
            }
        },
        {
            key: "computeSharedSecret",
            value: function computeSharedSecret(otherKey) {
                var keyPair = $73cd7d7e5b0f24b1$var$getCurve().keyFromPrivate((0, $2tHqU.arrayify)(this.privateKey));
                var otherKeyPair = $73cd7d7e5b0f24b1$var$getCurve().keyFromPublic((0, $2tHqU.arrayify)($73cd7d7e5b0f24b1$export$4a89473d39301224(otherKey)));
                return (0, $2tHqU.hexZeroPad)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
            }
        }
    ], [
        {
            key: "isSigningKey",
            value: function isSigningKey(value) {
                return !!(value && value._isSigningKey);
            }
        }
    ]);
    return SigningKey;
}();
function $73cd7d7e5b0f24b1$export$952dd09fbe0232b7(digest, signature) {
    var sig = (0, $2tHqU.splitSignature)(signature);
    var rs = {
        r: (0, $2tHqU.arrayify)(sig.r),
        s: (0, $2tHqU.arrayify)(sig.s)
    };
    return "0x" + $73cd7d7e5b0f24b1$var$getCurve().recoverPubKey((0, $2tHqU.arrayify)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $73cd7d7e5b0f24b1$export$4a89473d39301224(key, compressed) {
    var bytes = (0, $2tHqU.arrayify)(key);
    if (bytes.length === 32) {
        var signingKey = new $73cd7d7e5b0f24b1$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $73cd7d7e5b0f24b1$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $2tHqU.hexlify)(bytes);
        return "0x" + $73cd7d7e5b0f24b1$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $2tHqU.hexlify)(bytes);
        return "0x" + $73cd7d7e5b0f24b1$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $73cd7d7e5b0f24b1$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}

});
parcelRegister("3NoJ3", function(module, exports) {

$parcel$export(module.exports, "EC", function () { return $2c3920b24a7ddc60$export$129fe12d32abc311; });

var $iQTsY = parcelRequire("iQTsY");

var $3EYbz = parcelRequire("3EYbz");
var $2c3920b24a7ddc60$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $2c3920b24a7ddc60$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function $2c3920b24a7ddc60$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function require(path, base) {
            return $2c3920b24a7ddc60$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $2c3920b24a7ddc60$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function $2c3920b24a7ddc60$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function $2c3920b24a7ddc60$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function get() {
                return n[k];
            }
        });
    });
    return a;
}
function $2c3920b24a7ddc60$var$commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $2c3920b24a7ddc60$var$minimalisticAssert = $2c3920b24a7ddc60$var$assert;
function $2c3920b24a7ddc60$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$2c3920b24a7ddc60$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var $2c3920b24a7ddc60$var$utils_1 = $2c3920b24a7ddc60$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var $2c3920b24a7ddc60$var$utils_1$1 = $2c3920b24a7ddc60$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    utils.assert = $2c3920b24a7ddc60$var$minimalisticAssert;
    utils.toArray = $2c3920b24a7ddc60$var$utils_1.toArray;
    utils.zero2 = $2c3920b24a7ddc60$var$utils_1.zero2;
    utils.toHex = $2c3920b24a7ddc60$var$utils_1.toHex;
    utils.encode = $2c3920b24a7ddc60$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(bytes, "hex", "le");
    }
    utils.intFromLE = intFromLE;
});
"use strict";
var $2c3920b24a7ddc60$var$getNAF = $2c3920b24a7ddc60$var$utils_1$1.getNAF;
var $2c3920b24a7ddc60$var$getJSF = $2c3920b24a7ddc60$var$utils_1$1.getJSF;
var $2c3920b24a7ddc60$var$assert$1 = $2c3920b24a7ddc60$var$utils_1$1.assert;
function $2c3920b24a7ddc60$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $2c3920b24a7ddc60$var$base = $2c3920b24a7ddc60$var$BaseCurve;
$2c3920b24a7ddc60$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$2c3920b24a7ddc60$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$2c3920b24a7ddc60$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $2c3920b24a7ddc60$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $2c3920b24a7ddc60$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$2c3920b24a7ddc60$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $2c3920b24a7ddc60$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $2c3920b24a7ddc60$var$assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$2c3920b24a7ddc60$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $2c3920b24a7ddc60$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $2c3920b24a7ddc60$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $2c3920b24a7ddc60$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $2c3920b24a7ddc60$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$2c3920b24a7ddc60$var$BaseCurve.BasePoint = $2c3920b24a7ddc60$var$BasePoint;
$2c3920b24a7ddc60$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$2c3920b24a7ddc60$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$2c3920b24a7ddc60$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $2c3920b24a7ddc60$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $2c3920b24a7ddc60$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $2c3920b24a7ddc60$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$2c3920b24a7ddc60$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$2c3920b24a7ddc60$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$2c3920b24a7ddc60$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $2c3920b24a7ddc60$var$utils_1$1.encode(this._encode(compact), enc);
};
$2c3920b24a7ddc60$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$2c3920b24a7ddc60$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$2c3920b24a7ddc60$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$2c3920b24a7ddc60$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$2c3920b24a7ddc60$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$2c3920b24a7ddc60$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $2c3920b24a7ddc60$var$inherits_browser = $2c3920b24a7ddc60$var$createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function TempCtor() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var $2c3920b24a7ddc60$var$assert$2 = $2c3920b24a7ddc60$var$utils_1$1.assert;
function $2c3920b24a7ddc60$var$ShortCurve(conf) {
    $2c3920b24a7ddc60$var$base.call(this, "short", conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$2c3920b24a7ddc60$var$inherits_browser($2c3920b24a7ddc60$var$ShortCurve, $2c3920b24a7ddc60$var$base);
var $2c3920b24a7ddc60$var$short_1 = $2c3920b24a7ddc60$var$ShortCurve;
$2c3920b24a7ddc60$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $2c3920b24a7ddc60$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$2c3920b24a7ddc60$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$2c3920b24a7ddc60$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$2c3920b24a7ddc60$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$2c3920b24a7ddc60$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$2c3920b24a7ddc60$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$2c3920b24a7ddc60$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $2c3920b24a7ddc60$var$Point(curve, x, y, isRed) {
    $2c3920b24a7ddc60$var$base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$2c3920b24a7ddc60$var$inherits_browser($2c3920b24a7ddc60$var$Point, $2c3920b24a7ddc60$var$base.BasePoint);
$2c3920b24a7ddc60$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $2c3920b24a7ddc60$var$Point(this, x, y, isRed);
};
$2c3920b24a7ddc60$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $2c3920b24a7ddc60$var$Point.fromJSON(this, obj, red);
};
$2c3920b24a7ddc60$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function endoMul(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$2c3920b24a7ddc60$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$2c3920b24a7ddc60$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$2c3920b24a7ddc60$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$2c3920b24a7ddc60$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$2c3920b24a7ddc60$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$2c3920b24a7ddc60$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$2c3920b24a7ddc60$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$2c3920b24a7ddc60$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$2c3920b24a7ddc60$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$2c3920b24a7ddc60$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$2c3920b24a7ddc60$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$2c3920b24a7ddc60$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$2c3920b24a7ddc60$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function negate(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$2c3920b24a7ddc60$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $2c3920b24a7ddc60$var$JPoint(curve, x, y, z) {
    $2c3920b24a7ddc60$var$base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$2c3920b24a7ddc60$var$inherits_browser($2c3920b24a7ddc60$var$JPoint, $2c3920b24a7ddc60$var$base.BasePoint);
$2c3920b24a7ddc60$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $2c3920b24a7ddc60$var$JPoint(this, x, y, z);
};
$2c3920b24a7ddc60$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$2c3920b24a7ddc60$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$2c3920b24a7ddc60$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$2c3920b24a7ddc60$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$2c3920b24a7ddc60$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$2c3920b24a7ddc60$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$2c3920b24a7ddc60$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$2c3920b24a7ddc60$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$2c3920b24a7ddc60$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$2c3920b24a7ddc60$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$2c3920b24a7ddc60$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$2c3920b24a7ddc60$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$2c3920b24a7ddc60$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$2c3920b24a7ddc60$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$2c3920b24a7ddc60$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $2c3920b24a7ddc60$var$curve_1 = $2c3920b24a7ddc60$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = $2c3920b24a7ddc60$var$base;
    curve.short = $2c3920b24a7ddc60$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $2c3920b24a7ddc60$var$curves_1 = $2c3920b24a7ddc60$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curves = exports;
    var _$assert = $2c3920b24a7ddc60$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === "short") this.curve = new $2c3920b24a7ddc60$var$curve_1.short(options);
        else if (options.type === "edwards") this.curve = new $2c3920b24a7ddc60$var$curve_1.edwards(options);
        else this.curve = new $2c3920b24a7ddc60$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        _$assert(this.g.validate(), "Invalid curve");
        _$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function get() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($3EYbz))).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($3EYbz))).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($3EYbz))).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($3EYbz))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($3EYbz))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($3EYbz))).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($3EYbz))).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($3EYbz))).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function $2c3920b24a7ddc60$var$HmacDRBG(options) {
    if (!(this instanceof $2c3920b24a7ddc60$var$HmacDRBG)) return new $2c3920b24a7ddc60$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $2c3920b24a7ddc60$var$utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $2c3920b24a7ddc60$var$utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $2c3920b24a7ddc60$var$utils_1.toArray(options.pers, options.persEnc || "hex");
    $2c3920b24a7ddc60$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var $2c3920b24a7ddc60$var$hmacDrbg = $2c3920b24a7ddc60$var$HmacDRBG;
$2c3920b24a7ddc60$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$2c3920b24a7ddc60$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($3EYbz))).hmac(this.hash, this.K);
};
$2c3920b24a7ddc60$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$2c3920b24a7ddc60$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $2c3920b24a7ddc60$var$utils_1.toArray(entropy, entropyEnc);
    add = $2c3920b24a7ddc60$var$utils_1.toArray(add, addEnc);
    $2c3920b24a7ddc60$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$2c3920b24a7ddc60$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $2c3920b24a7ddc60$var$utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $2c3920b24a7ddc60$var$utils_1.encode(res, enc);
};
"use strict";
var $2c3920b24a7ddc60$var$assert$3 = $2c3920b24a7ddc60$var$utils_1$1.assert;
function $2c3920b24a7ddc60$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $2c3920b24a7ddc60$var$key = $2c3920b24a7ddc60$var$KeyPair;
$2c3920b24a7ddc60$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $2c3920b24a7ddc60$var$KeyPair) return pub;
    return new $2c3920b24a7ddc60$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$2c3920b24a7ddc60$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $2c3920b24a7ddc60$var$KeyPair) return priv;
    return new $2c3920b24a7ddc60$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$2c3920b24a7ddc60$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$2c3920b24a7ddc60$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$2c3920b24a7ddc60$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$2c3920b24a7ddc60$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$2c3920b24a7ddc60$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $2c3920b24a7ddc60$var$assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $2c3920b24a7ddc60$var$assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$2c3920b24a7ddc60$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $2c3920b24a7ddc60$var$assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$2c3920b24a7ddc60$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$2c3920b24a7ddc60$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$2c3920b24a7ddc60$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var $2c3920b24a7ddc60$var$assert$4 = $2c3920b24a7ddc60$var$utils_1$1.assert;
function $2c3920b24a7ddc60$var$Signature(options, enc) {
    if (options instanceof $2c3920b24a7ddc60$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $2c3920b24a7ddc60$var$assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $2c3920b24a7ddc60$var$signature = $2c3920b24a7ddc60$var$Signature;
function $2c3920b24a7ddc60$var$Position() {
    this.place = 0;
}
function $2c3920b24a7ddc60$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $2c3920b24a7ddc60$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$2c3920b24a7ddc60$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $2c3920b24a7ddc60$var$utils_1$1.toArray(data, enc);
    var p = new $2c3920b24a7ddc60$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $2c3920b24a7ddc60$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $2c3920b24a7ddc60$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $2c3920b24a7ddc60$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(s);
    this.recoveryParam = null;
    return true;
};
function $2c3920b24a7ddc60$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$2c3920b24a7ddc60$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $2c3920b24a7ddc60$var$rmPadding(r);
    s = $2c3920b24a7ddc60$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $2c3920b24a7ddc60$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $2c3920b24a7ddc60$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $2c3920b24a7ddc60$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $2c3920b24a7ddc60$var$utils_1$1.encode(res, enc);
};
"use strict";
var $2c3920b24a7ddc60$var$rand = /*RicMoo:ethers:require(brorand)*/ function rand() {
    throw new Error("unsupported");
};
var $2c3920b24a7ddc60$var$assert$5 = $2c3920b24a7ddc60$var$utils_1$1.assert;
function $2c3920b24a7ddc60$var$EC(options) {
    if (!(this instanceof $2c3920b24a7ddc60$var$EC)) return new $2c3920b24a7ddc60$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $2c3920b24a7ddc60$var$assert$5(Object.prototype.hasOwnProperty.call($2c3920b24a7ddc60$var$curves_1, options), "Unknown curve " + options);
        options = $2c3920b24a7ddc60$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $2c3920b24a7ddc60$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $2c3920b24a7ddc60$var$ec = $2c3920b24a7ddc60$var$EC;
$2c3920b24a7ddc60$var$EC.prototype.keyPair = function keyPair(options) {
    return new $2c3920b24a7ddc60$var$key(this, options);
};
$2c3920b24a7ddc60$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $2c3920b24a7ddc60$var$key.fromPrivate(this, priv, enc);
};
$2c3920b24a7ddc60$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $2c3920b24a7ddc60$var$key.fromPublic(this, pub, enc);
};
$2c3920b24a7ddc60$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $2c3920b24a7ddc60$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $2c3920b24a7ddc60$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$2c3920b24a7ddc60$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$2c3920b24a7ddc60$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $2c3920b24a7ddc60$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $2c3920b24a7ddc60$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$2c3920b24a7ddc60$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $2c3920b24a7ddc60$var$signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$2c3920b24a7ddc60$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $2c3920b24a7ddc60$var$assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new $2c3920b24a7ddc60$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($iQTsY)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$2c3920b24a7ddc60$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $2c3920b24a7ddc60$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $2c3920b24a7ddc60$var$elliptic_1 = $2c3920b24a7ddc60$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $2c3920b24a7ddc60$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = $2c3920b24a7ddc60$var$curve_1;
    elliptic.curves = $2c3920b24a7ddc60$var$curves_1;
    // Protocols
    elliptic.ec = $2c3920b24a7ddc60$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $2c3920b24a7ddc60$export$129fe12d32abc311 = $2c3920b24a7ddc60$var$elliptic_1.ec;

});
parcelRegister("3EYbz", function(module, exports) {
var $2aa3cb263ab8e053$var$hash = module.exports;

$2aa3cb263ab8e053$var$hash.utils = (parcelRequire("2Cp0x"));

$2aa3cb263ab8e053$var$hash.common = (parcelRequire("h6n2C"));

$2aa3cb263ab8e053$var$hash.sha = (parcelRequire("d2xGl"));

$2aa3cb263ab8e053$var$hash.ripemd = (parcelRequire("aYkjs"));

$2aa3cb263ab8e053$var$hash.hmac = (parcelRequire("dAutq"));
// Proxy hash functions to the main object
$2aa3cb263ab8e053$var$hash.sha1 = $2aa3cb263ab8e053$var$hash.sha.sha1;
$2aa3cb263ab8e053$var$hash.sha256 = $2aa3cb263ab8e053$var$hash.sha.sha256;
$2aa3cb263ab8e053$var$hash.sha224 = $2aa3cb263ab8e053$var$hash.sha.sha224;
$2aa3cb263ab8e053$var$hash.sha384 = $2aa3cb263ab8e053$var$hash.sha.sha384;
$2aa3cb263ab8e053$var$hash.sha512 = $2aa3cb263ab8e053$var$hash.sha.sha512;
$2aa3cb263ab8e053$var$hash.ripemd160 = $2aa3cb263ab8e053$var$hash.ripemd.ripemd160;

});
parcelRegister("2Cp0x", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $1e828768959b92d4$export$69f1b2dcda23c5f8; }, function (v) { return $1e828768959b92d4$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $1e828768959b92d4$export$45b10814cc054894; }, function (v) { return $1e828768959b92d4$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $1e828768959b92d4$export$7ea66e3774a60b67; }, function (v) { return $1e828768959b92d4$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $1e828768959b92d4$export$34a52f00f601f6f1; }, function (v) { return $1e828768959b92d4$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $1e828768959b92d4$export$812b0cbd5e8a72ab; }, function (v) { return $1e828768959b92d4$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $1e828768959b92d4$export$f24f9e11d63bb314; }, function (v) { return $1e828768959b92d4$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $1e828768959b92d4$export$b71357c7e07ca1f1; }, function (v) { return $1e828768959b92d4$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $1e828768959b92d4$export$2e58a4b541fdcbe8; }, function (v) { return $1e828768959b92d4$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $1e828768959b92d4$export$183b950bde9faab8; }, function (v) { return $1e828768959b92d4$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $1e828768959b92d4$export$4785c77169fea59e; }, function (v) { return $1e828768959b92d4$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $1e828768959b92d4$export$242a185dfcffac5b; }, function (v) { return $1e828768959b92d4$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $1e828768959b92d4$export$58c04ae0ae31877d; }, function (v) { return $1e828768959b92d4$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $1e828768959b92d4$export$d058ca695f8c6f11; }, function (v) { return $1e828768959b92d4$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $1e828768959b92d4$export$a1efd7fc3e986367; }, function (v) { return $1e828768959b92d4$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $1e828768959b92d4$export$bbfea4a2b5abaab4; }, function (v) { return $1e828768959b92d4$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $1e828768959b92d4$export$97ad4afc7de86152; }, function (v) { return $1e828768959b92d4$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $1e828768959b92d4$export$ce4673d9a79f6a4b; }, function (v) { return $1e828768959b92d4$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $1e828768959b92d4$export$786cc99fc6eedc0b; }, function (v) { return $1e828768959b92d4$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $1e828768959b92d4$export$45c59b9a1848dd0; }, function (v) { return $1e828768959b92d4$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $1e828768959b92d4$export$50d8f613e76d3034; }, function (v) { return $1e828768959b92d4$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $1e828768959b92d4$export$b8e83683c60ee162; }, function (v) { return $1e828768959b92d4$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $1e828768959b92d4$export$aeeb51790d1bcc4a; }, function (v) { return $1e828768959b92d4$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $1e828768959b92d4$export$bb7c616f719ad9c; }, function (v) { return $1e828768959b92d4$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $1e828768959b92d4$export$4d63290824f9d7df; }, function (v) { return $1e828768959b92d4$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $1e828768959b92d4$export$2f64ceb90ef28ea1; }, function (v) { return $1e828768959b92d4$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $1e828768959b92d4$export$8d2089d465f6d10d; }, function (v) { return $1e828768959b92d4$export$8d2089d465f6d10d = v; });
var $1e828768959b92d4$export$69f1b2dcda23c5f8;
var $1e828768959b92d4$export$45b10814cc054894;
var $1e828768959b92d4$export$7ea66e3774a60b67;
var $1e828768959b92d4$export$34a52f00f601f6f1;
var $1e828768959b92d4$export$812b0cbd5e8a72ab;
var $1e828768959b92d4$export$f24f9e11d63bb314;
var $1e828768959b92d4$export$b71357c7e07ca1f1;
var $1e828768959b92d4$export$2e58a4b541fdcbe8;
var $1e828768959b92d4$export$183b950bde9faab8;
var $1e828768959b92d4$export$4785c77169fea59e;
var $1e828768959b92d4$export$242a185dfcffac5b;
var $1e828768959b92d4$export$58c04ae0ae31877d;
var $1e828768959b92d4$export$d058ca695f8c6f11;
var $1e828768959b92d4$export$a1efd7fc3e986367;
var $1e828768959b92d4$export$bbfea4a2b5abaab4;
var $1e828768959b92d4$export$97ad4afc7de86152;
var $1e828768959b92d4$export$ce4673d9a79f6a4b;
var $1e828768959b92d4$export$786cc99fc6eedc0b;
var $1e828768959b92d4$export$45c59b9a1848dd0;
var $1e828768959b92d4$export$50d8f613e76d3034;
var $1e828768959b92d4$export$b8e83683c60ee162;
var $1e828768959b92d4$export$aeeb51790d1bcc4a;
var $1e828768959b92d4$export$bb7c616f719ad9c;
var $1e828768959b92d4$export$4d63290824f9d7df;
var $1e828768959b92d4$export$2f64ceb90ef28ea1;
var $1e828768959b92d4$export$8d2089d465f6d10d;
"use strict";

var $dnKxJ = parcelRequire("dnKxJ");

var $55dMx = parcelRequire("55dMx");
$1e828768959b92d4$export$69f1b2dcda23c5f8 = $55dMx;
function $1e828768959b92d4$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $1e828768959b92d4$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($1e828768959b92d4$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$1e828768959b92d4$export$45b10814cc054894 = $1e828768959b92d4$var$toArray;
function $1e828768959b92d4$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $1e828768959b92d4$var$zero2(msg[i].toString(16));
    return res;
}
$1e828768959b92d4$export$7ea66e3774a60b67 = $1e828768959b92d4$var$toHex;
function $1e828768959b92d4$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$1e828768959b92d4$export$34a52f00f601f6f1 = $1e828768959b92d4$var$htonl;
function $1e828768959b92d4$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $1e828768959b92d4$var$htonl(w);
        res += $1e828768959b92d4$var$zero8(w.toString(16));
    }
    return res;
}
$1e828768959b92d4$export$812b0cbd5e8a72ab = $1e828768959b92d4$var$toHex32;
function $1e828768959b92d4$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$1e828768959b92d4$export$f24f9e11d63bb314 = $1e828768959b92d4$var$zero2;
function $1e828768959b92d4$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$1e828768959b92d4$export$b71357c7e07ca1f1 = $1e828768959b92d4$var$zero8;
function $1e828768959b92d4$var$join32(msg, start, end, endian) {
    var len = end - start;
    $dnKxJ(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$1e828768959b92d4$export$2e58a4b541fdcbe8 = $1e828768959b92d4$var$join32;
function $1e828768959b92d4$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$1e828768959b92d4$export$183b950bde9faab8 = $1e828768959b92d4$var$split32;
function $1e828768959b92d4$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$1e828768959b92d4$export$4785c77169fea59e = $1e828768959b92d4$var$rotr32;
function $1e828768959b92d4$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$1e828768959b92d4$export$242a185dfcffac5b = $1e828768959b92d4$var$rotl32;
function $1e828768959b92d4$var$sum32(a, b) {
    return a + b >>> 0;
}
$1e828768959b92d4$export$58c04ae0ae31877d = $1e828768959b92d4$var$sum32;
function $1e828768959b92d4$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$1e828768959b92d4$export$d058ca695f8c6f11 = $1e828768959b92d4$var$sum32_3;
function $1e828768959b92d4$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$1e828768959b92d4$export$a1efd7fc3e986367 = $1e828768959b92d4$var$sum32_4;
function $1e828768959b92d4$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$1e828768959b92d4$export$bbfea4a2b5abaab4 = $1e828768959b92d4$var$sum32_5;
function $1e828768959b92d4$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$1e828768959b92d4$export$97ad4afc7de86152 = $1e828768959b92d4$var$sum64;
function $1e828768959b92d4$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$1e828768959b92d4$export$ce4673d9a79f6a4b = $1e828768959b92d4$var$sum64_hi;
function $1e828768959b92d4$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$1e828768959b92d4$export$786cc99fc6eedc0b = $1e828768959b92d4$var$sum64_lo;
function $1e828768959b92d4$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$1e828768959b92d4$export$45c59b9a1848dd0 = $1e828768959b92d4$var$sum64_4_hi;
function $1e828768959b92d4$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$1e828768959b92d4$export$50d8f613e76d3034 = $1e828768959b92d4$var$sum64_4_lo;
function $1e828768959b92d4$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$1e828768959b92d4$export$b8e83683c60ee162 = $1e828768959b92d4$var$sum64_5_hi;
function $1e828768959b92d4$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$1e828768959b92d4$export$aeeb51790d1bcc4a = $1e828768959b92d4$var$sum64_5_lo;
function $1e828768959b92d4$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$1e828768959b92d4$export$bb7c616f719ad9c = $1e828768959b92d4$var$rotr64_hi;
function $1e828768959b92d4$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$1e828768959b92d4$export$4d63290824f9d7df = $1e828768959b92d4$var$rotr64_lo;
function $1e828768959b92d4$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$1e828768959b92d4$export$2f64ceb90ef28ea1 = $1e828768959b92d4$var$shr64_hi;
function $1e828768959b92d4$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$1e828768959b92d4$export$8d2089d465f6d10d = $1e828768959b92d4$var$shr64_lo;

});
parcelRegister("dnKxJ", function(module, exports) {
module.exports = $9be186cf3d4ab8e8$var$assert;
function $9be186cf3d4ab8e8$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$9be186cf3d4ab8e8$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});

parcelRegister("55dMx", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("h6n2C", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $c734deb70ab020f8$export$8687658379b577e6; }, function (v) { return $c734deb70ab020f8$export$8687658379b577e6 = v; });
var $c734deb70ab020f8$export$8687658379b577e6;
"use strict";

var $2Cp0x = parcelRequire("2Cp0x");

var $dnKxJ = parcelRequire("dnKxJ");
function $c734deb70ab020f8$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$c734deb70ab020f8$export$8687658379b577e6 = $c734deb70ab020f8$var$BlockHash;
$c734deb70ab020f8$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $2Cp0x.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $2Cp0x.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$c734deb70ab020f8$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $dnKxJ(this.pending === null);
    return this._digest(enc);
};
$c734deb70ab020f8$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("d2xGl", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $97e596c7af8e1cfd$export$5091bdda49ba90f5; }, function (v) { return $97e596c7af8e1cfd$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $97e596c7af8e1cfd$export$97b70509d4e397ea; }, function (v) { return $97e596c7af8e1cfd$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $97e596c7af8e1cfd$export$bced8d2aada2d1c9; }, function (v) { return $97e596c7af8e1cfd$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $97e596c7af8e1cfd$export$612d47d55dedde45; }, function (v) { return $97e596c7af8e1cfd$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $97e596c7af8e1cfd$export$a888d2532e6dc7bb; }, function (v) { return $97e596c7af8e1cfd$export$a888d2532e6dc7bb = v; });
var $97e596c7af8e1cfd$export$5091bdda49ba90f5;
var $97e596c7af8e1cfd$export$97b70509d4e397ea;
var $97e596c7af8e1cfd$export$bced8d2aada2d1c9;
var $97e596c7af8e1cfd$export$612d47d55dedde45;
var $97e596c7af8e1cfd$export$a888d2532e6dc7bb;
"use strict";

$97e596c7af8e1cfd$export$5091bdda49ba90f5 = (parcelRequire("8zFYL"));

$97e596c7af8e1cfd$export$97b70509d4e397ea = (parcelRequire("aiSHt"));

$97e596c7af8e1cfd$export$bced8d2aada2d1c9 = (parcelRequire("1WUtY"));

$97e596c7af8e1cfd$export$612d47d55dedde45 = (parcelRequire("9wHIw"));

$97e596c7af8e1cfd$export$a888d2532e6dc7bb = (parcelRequire("1BEV4"));

});
parcelRegister("8zFYL", function(module, exports) {
"use strict";

var $2Cp0x = parcelRequire("2Cp0x");

var $h6n2C = parcelRequire("h6n2C");

var $2LZf2 = parcelRequire("2LZf2");
var $63e227c72b2757ff$var$rotl32 = $2Cp0x.rotl32;
var $63e227c72b2757ff$var$sum32 = $2Cp0x.sum32;
var $63e227c72b2757ff$var$sum32_5 = $2Cp0x.sum32_5;
var $63e227c72b2757ff$var$ft_1 = $2LZf2.ft_1;
var $63e227c72b2757ff$var$BlockHash = $h6n2C.BlockHash;
var $63e227c72b2757ff$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $63e227c72b2757ff$var$SHA1() {
    if (!(this instanceof $63e227c72b2757ff$var$SHA1)) return new $63e227c72b2757ff$var$SHA1();
    $63e227c72b2757ff$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$2Cp0x.inherits($63e227c72b2757ff$var$SHA1, $63e227c72b2757ff$var$BlockHash);
module.exports = $63e227c72b2757ff$var$SHA1;
$63e227c72b2757ff$var$SHA1.blockSize = 512;
$63e227c72b2757ff$var$SHA1.outSize = 160;
$63e227c72b2757ff$var$SHA1.hmacStrength = 80;
$63e227c72b2757ff$var$SHA1.padLength = 64;
$63e227c72b2757ff$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $63e227c72b2757ff$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $63e227c72b2757ff$var$sum32_5($63e227c72b2757ff$var$rotl32(a, 5), $63e227c72b2757ff$var$ft_1(s, b, c, d), e, W[i], $63e227c72b2757ff$var$sha1_K[s]);
        e = d;
        d = c;
        c = $63e227c72b2757ff$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $63e227c72b2757ff$var$sum32(this.h[0], a);
    this.h[1] = $63e227c72b2757ff$var$sum32(this.h[1], b);
    this.h[2] = $63e227c72b2757ff$var$sum32(this.h[2], c);
    this.h[3] = $63e227c72b2757ff$var$sum32(this.h[3], d);
    this.h[4] = $63e227c72b2757ff$var$sum32(this.h[4], e);
};
$63e227c72b2757ff$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $2Cp0x.toHex32(this.h, "big");
    else return $2Cp0x.split32(this.h, "big");
};

});
parcelRegister("2LZf2", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $204f79dc51caf0b3$export$5a92649d7ddb9f63; }, function (v) { return $204f79dc51caf0b3$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $204f79dc51caf0b3$export$c6d0d020c3a6269; }, function (v) { return $204f79dc51caf0b3$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $204f79dc51caf0b3$export$eb90c27fca05f956; }, function (v) { return $204f79dc51caf0b3$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $204f79dc51caf0b3$export$14a4a98e063b1999; }, function (v) { return $204f79dc51caf0b3$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $204f79dc51caf0b3$export$d20cecfa1564c686; }, function (v) { return $204f79dc51caf0b3$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $204f79dc51caf0b3$export$44fd472a12fc6db; }, function (v) { return $204f79dc51caf0b3$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $204f79dc51caf0b3$export$1ed238bb6ea1dd47; }, function (v) { return $204f79dc51caf0b3$export$1ed238bb6ea1dd47 = v; });
var $204f79dc51caf0b3$export$5a92649d7ddb9f63;
var $204f79dc51caf0b3$export$c6d0d020c3a6269;
var $204f79dc51caf0b3$export$eb90c27fca05f956;
var $204f79dc51caf0b3$export$cc992891a14496a1;
var $204f79dc51caf0b3$export$14a4a98e063b1999;
var $204f79dc51caf0b3$export$d20cecfa1564c686;
var $204f79dc51caf0b3$export$44fd472a12fc6db;
var $204f79dc51caf0b3$export$1ed238bb6ea1dd47;
"use strict";

var $2Cp0x = parcelRequire("2Cp0x");
var $204f79dc51caf0b3$var$rotr32 = $2Cp0x.rotr32;
function $204f79dc51caf0b3$var$ft_1(s, x, y, z) {
    if (s === 0) return $204f79dc51caf0b3$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $204f79dc51caf0b3$var$p32(x, y, z);
    if (s === 2) return $204f79dc51caf0b3$var$maj32(x, y, z);
}
$204f79dc51caf0b3$export$5a92649d7ddb9f63 = $204f79dc51caf0b3$var$ft_1;
function $204f79dc51caf0b3$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$204f79dc51caf0b3$export$c6d0d020c3a6269 = $204f79dc51caf0b3$var$ch32;
function $204f79dc51caf0b3$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$204f79dc51caf0b3$export$eb90c27fca05f956 = $204f79dc51caf0b3$var$maj32;
function $204f79dc51caf0b3$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$204f79dc51caf0b3$export$cc992891a14496a1 = $204f79dc51caf0b3$var$p32;
function $204f79dc51caf0b3$var$s0_256(x) {
    return $204f79dc51caf0b3$var$rotr32(x, 2) ^ $204f79dc51caf0b3$var$rotr32(x, 13) ^ $204f79dc51caf0b3$var$rotr32(x, 22);
}
$204f79dc51caf0b3$export$14a4a98e063b1999 = $204f79dc51caf0b3$var$s0_256;
function $204f79dc51caf0b3$var$s1_256(x) {
    return $204f79dc51caf0b3$var$rotr32(x, 6) ^ $204f79dc51caf0b3$var$rotr32(x, 11) ^ $204f79dc51caf0b3$var$rotr32(x, 25);
}
$204f79dc51caf0b3$export$d20cecfa1564c686 = $204f79dc51caf0b3$var$s1_256;
function $204f79dc51caf0b3$var$g0_256(x) {
    return $204f79dc51caf0b3$var$rotr32(x, 7) ^ $204f79dc51caf0b3$var$rotr32(x, 18) ^ x >>> 3;
}
$204f79dc51caf0b3$export$44fd472a12fc6db = $204f79dc51caf0b3$var$g0_256;
function $204f79dc51caf0b3$var$g1_256(x) {
    return $204f79dc51caf0b3$var$rotr32(x, 17) ^ $204f79dc51caf0b3$var$rotr32(x, 19) ^ x >>> 10;
}
$204f79dc51caf0b3$export$1ed238bb6ea1dd47 = $204f79dc51caf0b3$var$g1_256;

});


parcelRegister("aiSHt", function(module, exports) {
"use strict";

var $2Cp0x = parcelRequire("2Cp0x");

var $1WUtY = parcelRequire("1WUtY");
function $7806042291a782d2$var$SHA224() {
    if (!(this instanceof $7806042291a782d2$var$SHA224)) return new $7806042291a782d2$var$SHA224();
    $1WUtY.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$2Cp0x.inherits($7806042291a782d2$var$SHA224, $1WUtY);
module.exports = $7806042291a782d2$var$SHA224;
$7806042291a782d2$var$SHA224.blockSize = 512;
$7806042291a782d2$var$SHA224.outSize = 224;
$7806042291a782d2$var$SHA224.hmacStrength = 192;
$7806042291a782d2$var$SHA224.padLength = 64;
$7806042291a782d2$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $2Cp0x.toHex32(this.h.slice(0, 7), "big");
    else return $2Cp0x.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("1WUtY", function(module, exports) {
"use strict";

var $2Cp0x = parcelRequire("2Cp0x");

var $h6n2C = parcelRequire("h6n2C");

var $2LZf2 = parcelRequire("2LZf2");

var $dnKxJ = parcelRequire("dnKxJ");
var $16b7057bce9348b5$var$sum32 = $2Cp0x.sum32;
var $16b7057bce9348b5$var$sum32_4 = $2Cp0x.sum32_4;
var $16b7057bce9348b5$var$sum32_5 = $2Cp0x.sum32_5;
var $16b7057bce9348b5$var$ch32 = $2LZf2.ch32;
var $16b7057bce9348b5$var$maj32 = $2LZf2.maj32;
var $16b7057bce9348b5$var$s0_256 = $2LZf2.s0_256;
var $16b7057bce9348b5$var$s1_256 = $2LZf2.s1_256;
var $16b7057bce9348b5$var$g0_256 = $2LZf2.g0_256;
var $16b7057bce9348b5$var$g1_256 = $2LZf2.g1_256;
var $16b7057bce9348b5$var$BlockHash = $h6n2C.BlockHash;
var $16b7057bce9348b5$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $16b7057bce9348b5$var$SHA256() {
    if (!(this instanceof $16b7057bce9348b5$var$SHA256)) return new $16b7057bce9348b5$var$SHA256();
    $16b7057bce9348b5$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $16b7057bce9348b5$var$sha256_K;
    this.W = new Array(64);
}
$2Cp0x.inherits($16b7057bce9348b5$var$SHA256, $16b7057bce9348b5$var$BlockHash);
module.exports = $16b7057bce9348b5$var$SHA256;
$16b7057bce9348b5$var$SHA256.blockSize = 512;
$16b7057bce9348b5$var$SHA256.outSize = 256;
$16b7057bce9348b5$var$SHA256.hmacStrength = 192;
$16b7057bce9348b5$var$SHA256.padLength = 64;
$16b7057bce9348b5$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $16b7057bce9348b5$var$sum32_4($16b7057bce9348b5$var$g1_256(W[i - 2]), W[i - 7], $16b7057bce9348b5$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $dnKxJ(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $16b7057bce9348b5$var$sum32_5(h, $16b7057bce9348b5$var$s1_256(e), $16b7057bce9348b5$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $16b7057bce9348b5$var$sum32($16b7057bce9348b5$var$s0_256(a), $16b7057bce9348b5$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $16b7057bce9348b5$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $16b7057bce9348b5$var$sum32(T1, T2);
    }
    this.h[0] = $16b7057bce9348b5$var$sum32(this.h[0], a);
    this.h[1] = $16b7057bce9348b5$var$sum32(this.h[1], b);
    this.h[2] = $16b7057bce9348b5$var$sum32(this.h[2], c);
    this.h[3] = $16b7057bce9348b5$var$sum32(this.h[3], d);
    this.h[4] = $16b7057bce9348b5$var$sum32(this.h[4], e);
    this.h[5] = $16b7057bce9348b5$var$sum32(this.h[5], f);
    this.h[6] = $16b7057bce9348b5$var$sum32(this.h[6], g);
    this.h[7] = $16b7057bce9348b5$var$sum32(this.h[7], h);
};
$16b7057bce9348b5$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $2Cp0x.toHex32(this.h, "big");
    else return $2Cp0x.split32(this.h, "big");
};

});


parcelRegister("9wHIw", function(module, exports) {
"use strict";

var $2Cp0x = parcelRequire("2Cp0x");

var $1BEV4 = parcelRequire("1BEV4");
function $6ef903854922507e$var$SHA384() {
    if (!(this instanceof $6ef903854922507e$var$SHA384)) return new $6ef903854922507e$var$SHA384();
    $1BEV4.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$2Cp0x.inherits($6ef903854922507e$var$SHA384, $1BEV4);
module.exports = $6ef903854922507e$var$SHA384;
$6ef903854922507e$var$SHA384.blockSize = 1024;
$6ef903854922507e$var$SHA384.outSize = 384;
$6ef903854922507e$var$SHA384.hmacStrength = 192;
$6ef903854922507e$var$SHA384.padLength = 128;
$6ef903854922507e$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $2Cp0x.toHex32(this.h.slice(0, 12), "big");
    else return $2Cp0x.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("1BEV4", function(module, exports) {
"use strict";

var $2Cp0x = parcelRequire("2Cp0x");

var $h6n2C = parcelRequire("h6n2C");

var $dnKxJ = parcelRequire("dnKxJ");
var $12b8fce31ea23626$var$rotr64_hi = $2Cp0x.rotr64_hi;
var $12b8fce31ea23626$var$rotr64_lo = $2Cp0x.rotr64_lo;
var $12b8fce31ea23626$var$shr64_hi = $2Cp0x.shr64_hi;
var $12b8fce31ea23626$var$shr64_lo = $2Cp0x.shr64_lo;
var $12b8fce31ea23626$var$sum64 = $2Cp0x.sum64;
var $12b8fce31ea23626$var$sum64_hi = $2Cp0x.sum64_hi;
var $12b8fce31ea23626$var$sum64_lo = $2Cp0x.sum64_lo;
var $12b8fce31ea23626$var$sum64_4_hi = $2Cp0x.sum64_4_hi;
var $12b8fce31ea23626$var$sum64_4_lo = $2Cp0x.sum64_4_lo;
var $12b8fce31ea23626$var$sum64_5_hi = $2Cp0x.sum64_5_hi;
var $12b8fce31ea23626$var$sum64_5_lo = $2Cp0x.sum64_5_lo;
var $12b8fce31ea23626$var$BlockHash = $h6n2C.BlockHash;
var $12b8fce31ea23626$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $12b8fce31ea23626$var$SHA512() {
    if (!(this instanceof $12b8fce31ea23626$var$SHA512)) return new $12b8fce31ea23626$var$SHA512();
    $12b8fce31ea23626$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $12b8fce31ea23626$var$sha512_K;
    this.W = new Array(160);
}
$2Cp0x.inherits($12b8fce31ea23626$var$SHA512, $12b8fce31ea23626$var$BlockHash);
module.exports = $12b8fce31ea23626$var$SHA512;
$12b8fce31ea23626$var$SHA512.blockSize = 1024;
$12b8fce31ea23626$var$SHA512.outSize = 512;
$12b8fce31ea23626$var$SHA512.hmacStrength = 192;
$12b8fce31ea23626$var$SHA512.padLength = 128;
$12b8fce31ea23626$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $12b8fce31ea23626$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $12b8fce31ea23626$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $12b8fce31ea23626$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $12b8fce31ea23626$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $12b8fce31ea23626$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $12b8fce31ea23626$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$12b8fce31ea23626$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $dnKxJ(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $12b8fce31ea23626$var$s1_512_hi(eh, el);
        var c1_lo = $12b8fce31ea23626$var$s1_512_lo(eh, el);
        var c2_hi = $12b8fce31ea23626$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $12b8fce31ea23626$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $12b8fce31ea23626$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $12b8fce31ea23626$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $12b8fce31ea23626$var$s0_512_hi(ah, al);
        c0_lo = $12b8fce31ea23626$var$s0_512_lo(ah, al);
        c1_hi = $12b8fce31ea23626$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $12b8fce31ea23626$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $12b8fce31ea23626$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $12b8fce31ea23626$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $12b8fce31ea23626$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $12b8fce31ea23626$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $12b8fce31ea23626$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $12b8fce31ea23626$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $12b8fce31ea23626$var$sum64(this.h, 0, ah, al);
    $12b8fce31ea23626$var$sum64(this.h, 2, bh, bl);
    $12b8fce31ea23626$var$sum64(this.h, 4, ch, cl);
    $12b8fce31ea23626$var$sum64(this.h, 6, dh, dl);
    $12b8fce31ea23626$var$sum64(this.h, 8, eh, el);
    $12b8fce31ea23626$var$sum64(this.h, 10, fh, fl);
    $12b8fce31ea23626$var$sum64(this.h, 12, gh, gl);
    $12b8fce31ea23626$var$sum64(this.h, 14, hh, hl);
};
$12b8fce31ea23626$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $2Cp0x.toHex32(this.h, "big");
    else return $2Cp0x.split32(this.h, "big");
};
function $12b8fce31ea23626$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $12b8fce31ea23626$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $12b8fce31ea23626$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $12b8fce31ea23626$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $12b8fce31ea23626$var$s0_512_hi(xh, xl) {
    var c0_hi = $12b8fce31ea23626$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $12b8fce31ea23626$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $12b8fce31ea23626$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $12b8fce31ea23626$var$s0_512_lo(xh, xl) {
    var c0_lo = $12b8fce31ea23626$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $12b8fce31ea23626$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $12b8fce31ea23626$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $12b8fce31ea23626$var$s1_512_hi(xh, xl) {
    var c0_hi = $12b8fce31ea23626$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $12b8fce31ea23626$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $12b8fce31ea23626$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $12b8fce31ea23626$var$s1_512_lo(xh, xl) {
    var c0_lo = $12b8fce31ea23626$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $12b8fce31ea23626$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $12b8fce31ea23626$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $12b8fce31ea23626$var$g0_512_hi(xh, xl) {
    var c0_hi = $12b8fce31ea23626$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $12b8fce31ea23626$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $12b8fce31ea23626$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $12b8fce31ea23626$var$g0_512_lo(xh, xl) {
    var c0_lo = $12b8fce31ea23626$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $12b8fce31ea23626$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $12b8fce31ea23626$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $12b8fce31ea23626$var$g1_512_hi(xh, xl) {
    var c0_hi = $12b8fce31ea23626$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $12b8fce31ea23626$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $12b8fce31ea23626$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $12b8fce31ea23626$var$g1_512_lo(xh, xl) {
    var c0_lo = $12b8fce31ea23626$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $12b8fce31ea23626$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $12b8fce31ea23626$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("aYkjs", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $7fcf43aa38cbf53b$export$d1cea0ee4e3f0d3e; }, function (v) { return $7fcf43aa38cbf53b$export$d1cea0ee4e3f0d3e = v; });
var $7fcf43aa38cbf53b$export$d1cea0ee4e3f0d3e;
"use strict";

var $2Cp0x = parcelRequire("2Cp0x");

var $h6n2C = parcelRequire("h6n2C");
var $7fcf43aa38cbf53b$var$rotl32 = $2Cp0x.rotl32;
var $7fcf43aa38cbf53b$var$sum32 = $2Cp0x.sum32;
var $7fcf43aa38cbf53b$var$sum32_3 = $2Cp0x.sum32_3;
var $7fcf43aa38cbf53b$var$sum32_4 = $2Cp0x.sum32_4;
var $7fcf43aa38cbf53b$var$BlockHash = $h6n2C.BlockHash;
function $7fcf43aa38cbf53b$var$RIPEMD160() {
    if (!(this instanceof $7fcf43aa38cbf53b$var$RIPEMD160)) return new $7fcf43aa38cbf53b$var$RIPEMD160();
    $7fcf43aa38cbf53b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$2Cp0x.inherits($7fcf43aa38cbf53b$var$RIPEMD160, $7fcf43aa38cbf53b$var$BlockHash);
$7fcf43aa38cbf53b$export$d1cea0ee4e3f0d3e = $7fcf43aa38cbf53b$var$RIPEMD160;
$7fcf43aa38cbf53b$var$RIPEMD160.blockSize = 512;
$7fcf43aa38cbf53b$var$RIPEMD160.outSize = 160;
$7fcf43aa38cbf53b$var$RIPEMD160.hmacStrength = 192;
$7fcf43aa38cbf53b$var$RIPEMD160.padLength = 64;
$7fcf43aa38cbf53b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $7fcf43aa38cbf53b$var$sum32($7fcf43aa38cbf53b$var$rotl32($7fcf43aa38cbf53b$var$sum32_4(A, $7fcf43aa38cbf53b$var$f(j, B, C, D), msg[$7fcf43aa38cbf53b$var$r[j] + start], $7fcf43aa38cbf53b$var$K(j)), $7fcf43aa38cbf53b$var$s[j]), E);
        A = E;
        E = D;
        D = $7fcf43aa38cbf53b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $7fcf43aa38cbf53b$var$sum32($7fcf43aa38cbf53b$var$rotl32($7fcf43aa38cbf53b$var$sum32_4(Ah, $7fcf43aa38cbf53b$var$f(79 - j, Bh, Ch, Dh), msg[$7fcf43aa38cbf53b$var$rh[j] + start], $7fcf43aa38cbf53b$var$Kh(j)), $7fcf43aa38cbf53b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $7fcf43aa38cbf53b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $7fcf43aa38cbf53b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $7fcf43aa38cbf53b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $7fcf43aa38cbf53b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $7fcf43aa38cbf53b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $7fcf43aa38cbf53b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$7fcf43aa38cbf53b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $2Cp0x.toHex32(this.h, "little");
    else return $2Cp0x.split32(this.h, "little");
};
function $7fcf43aa38cbf53b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $7fcf43aa38cbf53b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $7fcf43aa38cbf53b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $7fcf43aa38cbf53b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $7fcf43aa38cbf53b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $7fcf43aa38cbf53b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $7fcf43aa38cbf53b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("dAutq", function(module, exports) {
"use strict";

var $2Cp0x = parcelRequire("2Cp0x");

var $dnKxJ = parcelRequire("dnKxJ");
function $9e4646988d976652$var$Hmac(hash, key, enc) {
    if (!(this instanceof $9e4646988d976652$var$Hmac)) return new $9e4646988d976652$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($2Cp0x.toArray(key, enc));
}
module.exports = $9e4646988d976652$var$Hmac;
$9e4646988d976652$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $dnKxJ(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$9e4646988d976652$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$9e4646988d976652$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});



parcelRegister("lUlTy", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $ff2fcfd2a286717d$export$83d89fbfd8236492; });
var $ff2fcfd2a286717d$export$83d89fbfd8236492 = "signing-key/5.5.0";

});


parcelRegister("fHSzO", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $b6f534efa2980d54$export$83d89fbfd8236492; });
var $b6f534efa2980d54$export$83d89fbfd8236492 = "transactions/5.5.0";

});


parcelRegister("enS8s", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $a78d34d120880886$export$83d89fbfd8236492; });
var $a78d34d120880886$export$83d89fbfd8236492 = "contracts/5.5.0";

});


parcelRegister("cQsQJ", function(module, exports) {

$parcel$export(module.exports, "ethers", function () { return (parcelRequire("3Y82Z")); });

var $3Y82Z = parcelRequire("3Y82Z");
var $3KRXu = parcelRequire("3KRXu");
var $ldEQw = parcelRequire("ldEQw");
var $664kq = parcelRequire("664kq");
var $jjEJ1 = parcelRequire("jjEJ1");
var $7ryKd = parcelRequire("7ryKd");
var $5TPG5 = parcelRequire("5TPG5");
var $koVFy = parcelRequire("koVFy");
var $ihGvV = parcelRequire("ihGvV");
var $aLhZE = parcelRequire("aLhZE");
var $1qgQ3 = parcelRequire("1qgQ3");
var $kBXZw = parcelRequire("kBXZw");
var $gXjmM = parcelRequire("gXjmM");
"use strict";
try {
    var $95a0b844e0fb63d0$var$anyGlobal = window;
    if ($95a0b844e0fb63d0$var$anyGlobal._ethers == null) $95a0b844e0fb63d0$var$anyGlobal._ethers = $3Y82Z;
} catch (error) {}

});
parcelRegister("3Y82Z", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $2e3d37b7eb29d627$export$af88d00dbe7f521; });
$parcel$export(module.exports, "Signer", function () { return (parcelRequire("3KRXu")).Signer; });
$parcel$export(module.exports, "Wallet", function () { return (parcelRequire("ldEQw")).Wallet; });
$parcel$export(module.exports, "VoidSigner", function () { return (parcelRequire("3KRXu")).VoidSigner; });
$parcel$export(module.exports, "getDefaultProvider", function () { return (parcelRequire("664kq")).getDefaultProvider; });
$parcel$export(module.exports, "providers", function () { return (parcelRequire("664kq")); });
$parcel$export(module.exports, "BaseContract", function () { return (parcelRequire("jjEJ1")).BaseContract; });
$parcel$export(module.exports, "Contract", function () { return (parcelRequire("jjEJ1")).Contract; });
$parcel$export(module.exports, "ContractFactory", function () { return (parcelRequire("jjEJ1")).ContractFactory; });
$parcel$export(module.exports, "BigNumber", function () { return (parcelRequire("7ryKd")).BigNumber; });
$parcel$export(module.exports, "FixedNumber", function () { return (parcelRequire("5TPG5")).FixedNumber; });
$parcel$export(module.exports, "constants", function () { return (parcelRequire("koVFy")); });
$parcel$export(module.exports, "errors", function () { return (parcelRequire("ihGvV")).ErrorCode; });
$parcel$export(module.exports, "utils", function () { return (parcelRequire("aLhZE")); });
$parcel$export(module.exports, "wordlists", function () { return (parcelRequire("1qgQ3")).wordlists; });
$parcel$export(module.exports, "version", function () { return (parcelRequire("kBXZw")).version; });
$parcel$export(module.exports, "Wordlist", function () { return (parcelRequire("gXjmM")).Wordlist; });

var $jjEJ1 = parcelRequire("jjEJ1");

var $7ryKd = parcelRequire("7ryKd");
var $5TPG5 = parcelRequire("5TPG5");

var $3KRXu = parcelRequire("3KRXu");

var $ldEQw = parcelRequire("ldEQw");

var $koVFy = parcelRequire("koVFy");

var $664kq = parcelRequire("664kq");

var $gXjmM = parcelRequire("gXjmM");
var $1qgQ3 = parcelRequire("1qgQ3");

var $aLhZE = parcelRequire("aLhZE");

var $ihGvV = parcelRequire("ihGvV");

var $kBXZw = parcelRequire("kBXZw");
"use strict";
var $2e3d37b7eb29d627$export$af88d00dbe7f521 = new (0, $ihGvV.Logger)((0, $kBXZw.version));

});
parcelRegister("5TPG5", function(module, exports) {

$parcel$export(module.exports, "formatFixed", function () { return $44ba2cef7be40f46$export$cc011b843b5d69f2; });
$parcel$export(module.exports, "parseFixed", function () { return $44ba2cef7be40f46$export$1b039987e86d7269; });
$parcel$export(module.exports, "FixedNumber", function () { return $44ba2cef7be40f46$export$d4693c66c2213e45; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $jquDQ = parcelRequire("jquDQ");

var $2tHqU = parcelRequire("2tHqU");

var $ihGvV = parcelRequire("ihGvV");

var $7fn1r = parcelRequire("7fn1r");

var $7ryKd = parcelRequire("7ryKd");
"use strict";
var $44ba2cef7be40f46$var$logger = new (0, $ihGvV.Logger)((0, $7fn1r.version));
var $44ba2cef7be40f46$var$_constructorGuard = {};
var $44ba2cef7be40f46$var$Zero = (0, $7ryKd.BigNumber).from(0);
var $44ba2cef7be40f46$var$NegativeOne = (0, $7ryKd.BigNumber).from(-1);
function $44ba2cef7be40f46$var$throwFault(message, fault, operation, value) {
    var params = {
        fault: fault,
        operation: operation
    };
    if (value !== undefined) params.value = value;
    return $44ba2cef7be40f46$var$logger.throwError(message, (0, $ihGvV.Logger).errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
var $44ba2cef7be40f46$var$zeros = "0";
while($44ba2cef7be40f46$var$zeros.length < 256)$44ba2cef7be40f46$var$zeros += $44ba2cef7be40f46$var$zeros;
// Returns a string "1" followed by decimal "0"s
function $44ba2cef7be40f46$var$getMultiplier(decimals) {
    if (typeof decimals !== "number") try {
        decimals = (0, $7ryKd.BigNumber).from(decimals).toNumber();
    } catch (e) {}
    if (typeof decimals === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) return "1" + $44ba2cef7be40f46$var$zeros.substring(0, decimals);
    return $44ba2cef7be40f46$var$logger.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function $44ba2cef7be40f46$export$cc011b843b5d69f2(value, decimals) {
    if (decimals == null) decimals = 0;
    var multiplier = $44ba2cef7be40f46$var$getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = (0, $7ryKd.BigNumber).from(value);
    var negative = value.lt($44ba2cef7be40f46$var$Zero);
    if (negative) value = value.mul($44ba2cef7be40f46$var$NegativeOne);
    var fraction = value.mod(multiplier).toString();
    while(fraction.length < multiplier.length - 1)fraction = "0" + fraction;
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    var whole = value.div(multiplier).toString();
    if (multiplier.length === 1) value = whole;
    else value = whole + "." + fraction;
    if (negative) value = "-" + value;
    return value;
}
function $44ba2cef7be40f46$export$1b039987e86d7269(value, decimals) {
    if (decimals == null) decimals = 0;
    var multiplier = $44ba2cef7be40f46$var$getMultiplier(decimals);
    if (typeof value !== "string" || !value.match(/^-?[0-9.]+$/)) $44ba2cef7be40f46$var$logger.throwArgumentError("invalid decimal value", "value", value);
    // Is it negative?
    var negative = value.substring(0, 1) === "-";
    if (negative) value = value.substring(1);
    if (value === ".") $44ba2cef7be40f46$var$logger.throwArgumentError("missing value", "value", value);
    // Split it into a whole and fractional part
    var comps = value.split(".");
    if (comps.length > 2) $44ba2cef7be40f46$var$logger.throwArgumentError("too many decimal points", "value", value);
    var whole = comps[0], fraction = comps[1];
    if (!whole) whole = "0";
    if (!fraction) fraction = "0";
    // Trim trailing zeros
    while(fraction[fraction.length - 1] === "0")fraction = fraction.substring(0, fraction.length - 1);
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) $44ba2cef7be40f46$var$throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") fraction = "0";
    // Fully pad the string with zeros to get to wei
    while(fraction.length < multiplier.length - 1)fraction += "0";
    var wholeValue = (0, $7ryKd.BigNumber).from(whole);
    var fractionValue = (0, $7ryKd.BigNumber).from(fraction);
    var wei = wholeValue.mul(multiplier).add(fractionValue);
    if (negative) wei = wei.mul($44ba2cef7be40f46$var$NegativeOne);
    return wei;
}
var $44ba2cef7be40f46$export$1f3ec5b8f47ebd4d = /*#__PURE__*/ function() {
    function FixedFormat(constructorGuard, signed, width, decimals) {
        (0, $9j09T._)(this, FixedFormat);
        if (constructorGuard !== $44ba2cef7be40f46$var$_constructorGuard) $44ba2cef7be40f46$var$logger.throwError("cannot use FixedFormat constructor; use FixedFormat.from", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = $44ba2cef7be40f46$var$getMultiplier(decimals);
        Object.freeze(this);
    }
    (0, $eDeHT._)(FixedFormat, null, [
        {
            key: "from",
            value: function from(value) {
                if (value instanceof FixedFormat) return value;
                if (typeof value === "number") value = "fixed128x".concat(value);
                var signed = true;
                var width = 128;
                var decimals = 18;
                if (typeof value === "string") {
                    if (value === "fixed") ;
                    else if (value === "ufixed") signed = false;
                    else {
                        var match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                        if (!match) $44ba2cef7be40f46$var$logger.throwArgumentError("invalid fixed format", "format", value);
                        signed = match[1] !== "u";
                        width = parseInt(match[2]);
                        decimals = parseInt(match[3]);
                    }
                } else if (value) {
                    var check = function(key, type, defaultValue) {
                        if (value[key] == null) return defaultValue;
                        if ((0, $jquDQ._)(value[key]) !== type) $44ba2cef7be40f46$var$logger.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                        return value[key];
                    };
                    signed = check("signed", "boolean", signed);
                    width = check("width", "number", width);
                    decimals = check("decimals", "number", decimals);
                }
                if (width % 8) $44ba2cef7be40f46$var$logger.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
                if (decimals > 80) $44ba2cef7be40f46$var$logger.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
                return new FixedFormat($44ba2cef7be40f46$var$_constructorGuard, signed, width, decimals);
            }
        }
    ]);
    return FixedFormat;
}();
var $44ba2cef7be40f46$export$d4693c66c2213e45 = /*#__PURE__*/ function _target() {
    function FixedNumber(constructorGuard, hex, value, format) {
        (0, $9j09T._)(this, FixedNumber);
        $44ba2cef7be40f46$var$logger.checkNew(this instanceof FixedNumber ? this.constructor : void 0, FixedNumber);
        if (constructorGuard !== $44ba2cef7be40f46$var$_constructorGuard) $44ba2cef7be40f46$var$logger.throwError("cannot use FixedNumber constructor; use FixedNumber.from", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
    (0, $eDeHT._)(FixedNumber, [
        {
            key: "_checkFormat",
            value: function _checkFormat(other) {
                if (this.format.name !== other.format.name) $44ba2cef7be40f46$var$logger.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
            }
        },
        {
            key: "addUnsafe",
            value: function addUnsafe(other) {
                this._checkFormat(other);
                var a = $44ba2cef7be40f46$export$1b039987e86d7269(this._value, this.format.decimals);
                var b = $44ba2cef7be40f46$export$1b039987e86d7269(other._value, other.format.decimals);
                return FixedNumber.fromValue(a.add(b), this.format.decimals, this.format);
            }
        },
        {
            key: "subUnsafe",
            value: function subUnsafe(other) {
                this._checkFormat(other);
                var a = $44ba2cef7be40f46$export$1b039987e86d7269(this._value, this.format.decimals);
                var b = $44ba2cef7be40f46$export$1b039987e86d7269(other._value, other.format.decimals);
                return FixedNumber.fromValue(a.sub(b), this.format.decimals, this.format);
            }
        },
        {
            key: "mulUnsafe",
            value: function mulUnsafe(other) {
                this._checkFormat(other);
                var a = $44ba2cef7be40f46$export$1b039987e86d7269(this._value, this.format.decimals);
                var b = $44ba2cef7be40f46$export$1b039987e86d7269(other._value, other.format.decimals);
                return FixedNumber.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
            }
        },
        {
            key: "divUnsafe",
            value: function divUnsafe(other) {
                this._checkFormat(other);
                var a = $44ba2cef7be40f46$export$1b039987e86d7269(this._value, this.format.decimals);
                var b = $44ba2cef7be40f46$export$1b039987e86d7269(other._value, other.format.decimals);
                return FixedNumber.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
            }
        },
        {
            key: "floor",
            value: function floor() {
                var comps = this.toString().split(".");
                if (comps.length === 1) comps.push("0");
                var result = FixedNumber.from(comps[0], this.format);
                var hasFraction = !comps[1].match(/^(0*)$/);
                if (this.isNegative() && hasFraction) result = result.subUnsafe($44ba2cef7be40f46$var$ONE.toFormat(result.format));
                return result;
            }
        },
        {
            key: "ceiling",
            value: function ceiling() {
                var comps = this.toString().split(".");
                if (comps.length === 1) comps.push("0");
                var result = FixedNumber.from(comps[0], this.format);
                var hasFraction = !comps[1].match(/^(0*)$/);
                if (!this.isNegative() && hasFraction) result = result.addUnsafe($44ba2cef7be40f46$var$ONE.toFormat(result.format));
                return result;
            }
        },
        {
            // @TODO: Support other rounding algorithms
            key: "round",
            value: function round(decimals) {
                if (decimals == null) decimals = 0;
                // If we are already in range, we're done
                var comps = this.toString().split(".");
                if (comps.length === 1) comps.push("0");
                if (decimals < 0 || decimals > 80 || decimals % 1) $44ba2cef7be40f46$var$logger.throwArgumentError("invalid decimal count", "decimals", decimals);
                if (comps[1].length <= decimals) return this;
                var factor = FixedNumber.from("1" + $44ba2cef7be40f46$var$zeros.substring(0, decimals), this.format);
                var bump = $44ba2cef7be40f46$var$BUMP.toFormat(this.format);
                return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
            }
        },
        {
            key: "isZero",
            value: function isZero() {
                return this._value === "0.0" || this._value === "0";
            }
        },
        {
            key: "isNegative",
            value: function isNegative() {
                return this._value[0] === "-";
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this._value;
            }
        },
        {
            key: "toHexString",
            value: function toHexString(width) {
                if (width == null) return this._hex;
                if (width % 8) $44ba2cef7be40f46$var$logger.throwArgumentError("invalid byte width", "width", width);
                var hex = (0, $7ryKd.BigNumber).from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
                return (0, $2tHqU.hexZeroPad)(hex, width / 8);
            }
        },
        {
            key: "toUnsafeFloat",
            value: function toUnsafeFloat() {
                return parseFloat(this.toString());
            }
        },
        {
            key: "toFormat",
            value: function toFormat(format) {
                return FixedNumber.fromString(this._value, format);
            }
        }
    ], [
        {
            key: "fromValue",
            value: function fromValue(value, decimals, format) {
                // If decimals looks more like a format, and there is no format, shift the parameters
                if (format == null && decimals != null && !(0, $7ryKd.isBigNumberish)(decimals)) {
                    format = decimals;
                    decimals = null;
                }
                if (decimals == null) decimals = 0;
                if (format == null) format = "fixed";
                return FixedNumber.fromString($44ba2cef7be40f46$export$cc011b843b5d69f2(value, decimals), $44ba2cef7be40f46$export$1f3ec5b8f47ebd4d.from(format));
            }
        },
        {
            key: "fromString",
            value: function fromString(value, format) {
                if (format == null) format = "fixed";
                var fixedFormat = $44ba2cef7be40f46$export$1f3ec5b8f47ebd4d.from(format);
                var numeric = $44ba2cef7be40f46$export$1b039987e86d7269(value, fixedFormat.decimals);
                if (!fixedFormat.signed && numeric.lt($44ba2cef7be40f46$var$Zero)) $44ba2cef7be40f46$var$throwFault("unsigned value cannot be negative", "overflow", "value", value);
                var hex = null;
                if (fixedFormat.signed) hex = numeric.toTwos(fixedFormat.width).toHexString();
                else {
                    hex = numeric.toHexString();
                    hex = (0, $2tHqU.hexZeroPad)(hex, fixedFormat.width / 8);
                }
                var decimal = $44ba2cef7be40f46$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
                return new FixedNumber($44ba2cef7be40f46$var$_constructorGuard, hex, decimal, fixedFormat);
            }
        },
        {
            key: "fromBytes",
            value: function fromBytes(value, format) {
                if (format == null) format = "fixed";
                var fixedFormat = $44ba2cef7be40f46$export$1f3ec5b8f47ebd4d.from(format);
                if ((0, $2tHqU.arrayify)(value).length > fixedFormat.width / 8) throw new Error("overflow");
                var numeric = (0, $7ryKd.BigNumber).from(value);
                if (fixedFormat.signed) numeric = numeric.fromTwos(fixedFormat.width);
                var hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
                var decimal = $44ba2cef7be40f46$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
                return new FixedNumber($44ba2cef7be40f46$var$_constructorGuard, hex, decimal, fixedFormat);
            }
        },
        {
            key: "from",
            value: function from(value, format) {
                if (typeof value === "string") return FixedNumber.fromString(value, format);
                if ((0, $2tHqU.isBytes)(value)) return FixedNumber.fromBytes(value, format);
                try {
                    return FixedNumber.fromValue(value, 0, format);
                } catch (error) {
                    // Allow NUMERIC_FAULT to bubble up
                    if (error.code !== (0, $ihGvV.Logger).errors.INVALID_ARGUMENT) throw error;
                }
                return $44ba2cef7be40f46$var$logger.throwArgumentError("invalid FixedNumber value", "value", value);
            }
        },
        {
            key: "isFixedNumber",
            value: function isFixedNumber(value) {
                return !!(value && value._isFixedNumber);
            }
        }
    ]);
    return FixedNumber;
}();
var $44ba2cef7be40f46$var$ONE = $44ba2cef7be40f46$export$d4693c66c2213e45.from(1);
var $44ba2cef7be40f46$var$BUMP = $44ba2cef7be40f46$export$d4693c66c2213e45.from("0.5");

});

parcelRegister("ldEQw", function(module, exports) {

$parcel$export(module.exports, "Wallet", function () { return $f72a7f0bd89c1309$export$bcca3ea514774656; });
$parcel$export(module.exports, "verifyMessage", function () { return $f72a7f0bd89c1309$export$228d0e772cc158cb; });
$parcel$export(module.exports, "verifyTypedData", function () { return $f72a7f0bd89c1309$export$3603b1c1bcd76798; });

var $feAea = parcelRequire("feAea");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");

var $hFSWi = parcelRequire("hFSWi");

var $fH8QX = parcelRequire("fH8QX");

var $3KRXu = parcelRequire("3KRXu");

var $2tHqU = parcelRequire("2tHqU");

var $65WSG = parcelRequire("65WSG");
var $axO07 = parcelRequire("axO07");

var $3HvNL = parcelRequire("3HvNL");

var $8Ub7X = parcelRequire("8Ub7X");

var $iqBKf = parcelRequire("iqBKf");

var $6wezB = parcelRequire("6wezB");

var $9WpJo = parcelRequire("9WpJo");

var $97iju = parcelRequire("97iju");
var $eEEnh = parcelRequire("eEEnh");

var $60XIC = parcelRequire("60XIC");

var $ihGvV = parcelRequire("ihGvV");

var $5PqJc = parcelRequire("5PqJc");
"use strict";
var $f72a7f0bd89c1309$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f72a7f0bd89c1309$var$logger = new (0, $ihGvV.Logger)((0, $5PqJc.version));
function $f72a7f0bd89c1309$var$isAccount(value) {
    return value != null && (0, $2tHqU.isHexString)(value.privateKey, 32) && value.address != null;
}
function $f72a7f0bd89c1309$var$hasMnemonic(value) {
    var mnemonic = value.mnemonic;
    return mnemonic && mnemonic.phrase;
}
var $f72a7f0bd89c1309$export$bcca3ea514774656 = /*#__PURE__*/ function _target(Signer) {
    (0, $i0LXg._)(Wallet, Signer);
    var _super = (0, $a1vXf._)(Wallet);
    function Wallet(privateKey, provider) {
        (0, $9j09T._)(this, Wallet);
        var _this;
        $f72a7f0bd89c1309$var$logger.checkNew(this instanceof Wallet ? this.constructor : void 0, Wallet);
        _this = _super.call(this);
        if ($f72a7f0bd89c1309$var$isAccount(privateKey)) {
            var signingKey = new (0, $9WpJo.SigningKey)(privateKey.privateKey);
            (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "_signingKey", function() {
                return signingKey;
            });
            (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "address", (0, $60XIC.computeAddress)(_this.publicKey));
            if (_this.address !== (0, $hFSWi.getAddress)(privateKey.address)) $f72a7f0bd89c1309$var$logger.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]");
            if ($f72a7f0bd89c1309$var$hasMnemonic(privateKey)) {
                var srcMnemonic = privateKey.mnemonic;
                (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "_mnemonic", function() {
                    return {
                        phrase: srcMnemonic.phrase,
                        path: srcMnemonic.path || (0, $3HvNL.defaultPath),
                        locale: srcMnemonic.locale || "en"
                    };
                });
                var mnemonic = _this.mnemonic;
                var node = (0, $3HvNL.HDNode).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path);
                if ((0, $60XIC.computeAddress)(node.privateKey) !== _this.address) $f72a7f0bd89c1309$var$logger.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
            } else (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "_mnemonic", function() {
                return null;
            });
        } else {
            if ((0, $9WpJo.SigningKey).isSigningKey(privateKey)) {
                /* istanbul ignore if */ if (privateKey.curve !== "secp256k1") $f72a7f0bd89c1309$var$logger.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]");
                (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "_signingKey", function() {
                    return privateKey;
                });
            } else {
                // A lot of common tools do not prefix private keys with a 0x (see: #1166)
                if (typeof privateKey === "string") {
                    if (privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) privateKey = "0x" + privateKey;
                }
                var signingKey1 = new (0, $9WpJo.SigningKey)(privateKey);
                (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "_signingKey", function() {
                    return signingKey1;
                });
            }
            (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "_mnemonic", function() {
                return null;
            });
            (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "address", (0, $60XIC.computeAddress)(_this.publicKey));
        }
        /* istanbul ignore if */ if (provider && !(0, $fH8QX.Provider).isProvider(provider)) $f72a7f0bd89c1309$var$logger.throwArgumentError("invalid provider", "provider", provider);
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "provider", provider || null);
        return _this;
    }
    (0, $eDeHT._)(Wallet, [
        {
            key: "mnemonic",
            get: function get() {
                return this._mnemonic();
            }
        },
        {
            key: "privateKey",
            get: function get() {
                return this._signingKey().privateKey;
            }
        },
        {
            key: "publicKey",
            get: function get() {
                return this._signingKey().publicKey;
            }
        },
        {
            key: "getAddress",
            value: function getAddress() {
                return Promise.resolve(this.address);
            }
        },
        {
            key: "connect",
            value: function connect(provider) {
                return new Wallet(this, provider);
            }
        },
        {
            key: "signTransaction",
            value: function signTransaction(transaction) {
                var _this = this;
                return (0, $iqBKf.resolveProperties)(transaction).then(function(tx) {
                    if (tx.from != null) {
                        if ((0, $hFSWi.getAddress)(tx.from) !== _this.address) $f72a7f0bd89c1309$var$logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
                        delete tx.from;
                    }
                    var signature = _this._signingKey().signDigest((0, $8Ub7X.keccak256)((0, $60XIC.serialize)(tx)));
                    return (0, $60XIC.serialize)(tx, signature);
                });
            }
        },
        {
            key: "signMessage",
            value: function signMessage(message) {
                return $f72a7f0bd89c1309$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $2tHqU.joinSignature)(this._signingKey().signDigest((0, $axO07.hashMessage)(message)))
                        ];
                    });
                });
            }
        },
        {
            key: "_signTypedData",
            value: function _signTypedData(domain, types, value) {
                return $f72a7f0bd89c1309$var$__awaiter(this, void 0, void 0, function() {
                    var _this, populated;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    (0, $65WSG.TypedDataEncoder).resolveNames(domain, types, value, function(name) {
                                        if (_this.provider == null) $f72a7f0bd89c1309$var$logger.throwError("cannot resolve ENS names without a provider", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                                            operation: "resolveName",
                                            value: name
                                        });
                                        return _this.provider.resolveName(name);
                                    })
                                ];
                            case 1:
                                populated = _state.sent();
                                return [
                                    2,
                                    (0, $2tHqU.joinSignature)(this._signingKey().signDigest((0, $65WSG.TypedDataEncoder).hash(populated.domain, types, populated.value)))
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "encrypt",
            value: function encrypt(password, options, progressCallback) {
                if (typeof options === "function" && !progressCallback) {
                    progressCallback = options;
                    options = {};
                }
                if (progressCallback && typeof progressCallback !== "function") throw new Error("invalid callback");
                if (!options) options = {};
                return (0, $eEEnh.encrypt)(this, password, options, progressCallback);
            }
        }
    ], [
        {
            key: "createRandom",
            value: /**
     *  Static methods to create Wallet instances.
     */ function createRandom(options) {
                var entropy = (0, $6wezB.randomBytes)(16);
                if (!options) options = {};
                if (options.extraEntropy) entropy = (0, $2tHqU.arrayify)((0, $2tHqU.hexDataSlice)((0, $8Ub7X.keccak256)((0, $2tHqU.concat)([
                    entropy,
                    options.extraEntropy
                ])), 0, 16));
                var mnemonic = (0, $3HvNL.entropyToMnemonic)(entropy, options.locale);
                return Wallet.fromMnemonic(mnemonic, options.path, options.locale);
            }
        },
        {
            key: "fromEncryptedJson",
            value: function fromEncryptedJson(json, password, progressCallback) {
                return (0, $97iju.decryptJsonWallet)(json, password, progressCallback).then(function(account) {
                    return new Wallet(account);
                });
            }
        },
        {
            key: "fromEncryptedJsonSync",
            value: function fromEncryptedJsonSync(json, password) {
                return new Wallet((0, $97iju.decryptJsonWalletSync)(json, password));
            }
        },
        {
            key: "fromMnemonic",
            value: function fromMnemonic(mnemonic, path, wordlist) {
                if (!path) path = (0, $3HvNL.defaultPath);
                return new Wallet((0, $3HvNL.HDNode).fromMnemonic(mnemonic, null, wordlist).derivePath(path));
            }
        }
    ]);
    return Wallet;
}((0, $3KRXu.Signer));
function $f72a7f0bd89c1309$export$228d0e772cc158cb(message, signature) {
    return (0, $60XIC.recoverAddress)((0, $axO07.hashMessage)(message), signature);
}
function $f72a7f0bd89c1309$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $60XIC.recoverAddress)((0, $65WSG.TypedDataEncoder).hash(domain, types, value), signature);
}

});
parcelRegister("65WSG", function(module, exports) {

$parcel$export(module.exports, "TypedDataEncoder", function () { return $4700e2432cd8997c$export$458ab927ae635c3; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $itJXR = parcelRequire("itJXR");

var $hFSWi = parcelRequire("hFSWi");

var $7ryKd = parcelRequire("7ryKd");

var $2tHqU = parcelRequire("2tHqU");

var $8Ub7X = parcelRequire("8Ub7X");

var $iqBKf = parcelRequire("iqBKf");

var $ihGvV = parcelRequire("ihGvV");

var $2Lbyz = parcelRequire("2Lbyz");

var $9QZv3 = parcelRequire("9QZv3");
var $4700e2432cd8997c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4700e2432cd8997c$var$logger = new (0, $ihGvV.Logger)((0, $2Lbyz.version));
var $4700e2432cd8997c$var$padding = new Uint8Array(32);
$4700e2432cd8997c$var$padding.fill(0);
var $4700e2432cd8997c$var$NegativeOne = (0, $7ryKd.BigNumber).from(-1);
var $4700e2432cd8997c$var$Zero = (0, $7ryKd.BigNumber).from(0);
var $4700e2432cd8997c$var$One = (0, $7ryKd.BigNumber).from(1);
var $4700e2432cd8997c$var$MaxUint256 = (0, $7ryKd.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $4700e2432cd8997c$var$hexPadRight(value) {
    var bytes = (0, $2tHqU.arrayify)(value);
    var padOffset = bytes.length % 32;
    if (padOffset) return (0, $2tHqU.hexConcat)([
        bytes,
        $4700e2432cd8997c$var$padding.slice(padOffset)
    ]);
    return (0, $2tHqU.hexlify)(bytes);
}
var $4700e2432cd8997c$var$hexTrue = (0, $2tHqU.hexZeroPad)($4700e2432cd8997c$var$One.toHexString(), 32);
var $4700e2432cd8997c$var$hexFalse = (0, $2tHqU.hexZeroPad)($4700e2432cd8997c$var$Zero.toHexString(), 32);
var $4700e2432cd8997c$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
var $4700e2432cd8997c$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $4700e2432cd8997c$var$checkString(key) {
    return function(value) {
        if (typeof value !== "string") $4700e2432cd8997c$var$logger.throwArgumentError("invalid domain value for ".concat(JSON.stringify(key)), "domain.".concat(key), value);
        return value;
    };
}
var $4700e2432cd8997c$var$domainChecks = {
    name: $4700e2432cd8997c$var$checkString("name"),
    version: $4700e2432cd8997c$var$checkString("version"),
    chainId: function chainId(value) {
        try {
            return (0, $7ryKd.BigNumber).from(value).toString();
        } catch (error) {}
        return $4700e2432cd8997c$var$logger.throwArgumentError('invalid domain value for "chainId"', "domain.chainId", value);
    },
    verifyingContract: function verifyingContract(value) {
        try {
            return (0, $hFSWi.getAddress)(value).toLowerCase();
        } catch (error) {}
        return $4700e2432cd8997c$var$logger.throwArgumentError('invalid domain value "verifyingContract"', "domain.verifyingContract", value);
    },
    salt: function salt(value) {
        try {
            var bytes = (0, $2tHqU.arrayify)(value);
            if (bytes.length !== 32) throw new Error("bad length");
            return (0, $2tHqU.hexlify)(bytes);
        } catch (error) {}
        return $4700e2432cd8997c$var$logger.throwArgumentError('invalid domain value "salt"', "domain.salt", value);
    }
};
function $4700e2432cd8997c$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        var match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            var signed = match[1] === "";
            var width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || match[2] && match[2] !== String(width)) $4700e2432cd8997c$var$logger.throwArgumentError("invalid numeric width", "type", type);
            var boundsUpper = $4700e2432cd8997c$var$MaxUint256.mask(signed ? width - 1 : width);
            var boundsLower = signed ? boundsUpper.add($4700e2432cd8997c$var$One).mul($4700e2432cd8997c$var$NegativeOne) : $4700e2432cd8997c$var$Zero;
            return function(value) {
                var v = (0, $7ryKd.BigNumber).from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) $4700e2432cd8997c$var$logger.throwArgumentError("value out-of-bounds for ".concat(type), "value", value);
                return (0, $2tHqU.hexZeroPad)(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        var match1 = type.match(/^bytes(\d+)$/);
        if (match1) {
            var width1 = parseInt(match1[1]);
            if (width1 === 0 || width1 > 32 || match1[1] !== String(width1)) $4700e2432cd8997c$var$logger.throwArgumentError("invalid bytes width", "type", type);
            return function(value) {
                var bytes = (0, $2tHqU.arrayify)(value);
                if (bytes.length !== width1) $4700e2432cd8997c$var$logger.throwArgumentError("invalid length for ".concat(type), "value", value);
                return $4700e2432cd8997c$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $2tHqU.hexZeroPad)((0, $hFSWi.getAddress)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $4700e2432cd8997c$var$hexFalse : $4700e2432cd8997c$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $8Ub7X.keccak256)(value);
            };
        case "string":
            return function(value) {
                return (0, $9QZv3.id)(value);
            };
    }
    return null;
}
function $4700e2432cd8997c$var$encodeType(name, fields) {
    return "".concat(name, "(").concat(fields.map(function(param) {
        var _$name = param.name, type = param.type;
        return type + " " + _$name;
    }).join(","), ")");
}
var $4700e2432cd8997c$export$458ab927ae635c3 = /*#__PURE__*/ function() {
    "use strict";
    function TypedDataEncoder(types) {
        var _loop = function(name) {
            var uniqueNames = {};
            types[name].forEach(function(field) {
                // Check each field has a unique name
                if (uniqueNames[field.name]) $4700e2432cd8997c$var$logger.throwArgumentError("duplicate variable name ".concat(JSON.stringify(field.name), " in ").concat(JSON.stringify(name)), "types", types);
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                var baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) $4700e2432cd8997c$var$logger.throwArgumentError("circular type reference to ".concat(JSON.stringify(baseType)), "types", types);
                // Is this a base encoding type?
                var encoder = $4700e2432cd8997c$var$getBaseEncoder(baseType);
                if (encoder) return;
                if (!parents[baseType]) $4700e2432cd8997c$var$logger.throwArgumentError("unknown type ".concat(JSON.stringify(baseType)), "types", types);
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        };
        (0, $9j09T._)(this, TypedDataEncoder);
        (0, $iqBKf.defineReadOnly)(this, "types", Object.freeze((0, $iqBKf.deepCopy)(types)));
        (0, $iqBKf.defineReadOnly)(this, "_encoderCache", {});
        (0, $iqBKf.defineReadOnly)(this, "_types", {});
        // Link struct types to their direct child structs
        var links = {};
        // Link structs to structs which contain them as a child
        var parents = {};
        // Link all subtypes within a given struct
        var subtypes = {};
        Object.keys(types).forEach(function(type) {
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for(var name in types)_loop(name);
        // Deduce the primary type
        var primaryTypes = Object.keys(parents).filter(function(n) {
            return parents[n].length === 0;
        });
        if (primaryTypes.length === 0) $4700e2432cd8997c$var$logger.throwArgumentError("missing primary type", "types", types);
        else if (primaryTypes.length > 1) $4700e2432cd8997c$var$logger.throwArgumentError("ambiguous primary types or unused types: ".concat(primaryTypes.map(function(t) {
            return JSON.stringify(t);
        }).join(", ")), "types", types);
        (0, $iqBKf.defineReadOnly)(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) $4700e2432cd8997c$var$logger.throwArgumentError("circular type reference to ".concat(JSON.stringify(type)), "types", types);
            found[type] = true;
            Object.keys(links[type]).forEach(function(child) {
                if (!parents[child]) return;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach(function(subtype) {
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for(var name1 in subtypes){
            var st = Object.keys(subtypes[name1]);
            st.sort();
            this._types[name1] = $4700e2432cd8997c$var$encodeType(name1, types[name1]) + st.map(function(t) {
                return $4700e2432cd8997c$var$encodeType(t, types[t]);
            }).join("");
        }
    }
    (0, $eDeHT._)(TypedDataEncoder, [
        {
            key: "getEncoder",
            value: function getEncoder(type) {
                var encoder = this._encoderCache[type];
                if (!encoder) encoder = this._encoderCache[type] = this._getEncoder(type);
                return encoder;
            }
        },
        {
            key: "_getEncoder",
            value: function _getEncoder(type) {
                var _this = this;
                // Basic encoder type (address, bool, uint256, etc)
                {
                    var encoder = $4700e2432cd8997c$var$getBaseEncoder(type);
                    if (encoder) return encoder;
                }
                // Array
                var match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
                if (match) {
                    var subtype = match[1];
                    var subEncoder = this.getEncoder(subtype);
                    var length = parseInt(match[3]);
                    return function(value) {
                        if (length >= 0 && value.length !== length) $4700e2432cd8997c$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                        var result = value.map(subEncoder);
                        if (_this._types[subtype]) result = result.map((0, $8Ub7X.keccak256));
                        return (0, $8Ub7X.keccak256)((0, $2tHqU.hexConcat)(result));
                    };
                }
                // Struct
                var fields = this.types[type];
                if (fields) {
                    var encodedType = (0, $9QZv3.id)(this._types[type]);
                    return function(value) {
                        var values = fields.map(function(param) {
                            var name = param.name, _$type = param.type;
                            var result = _this.getEncoder(_$type)(value[name]);
                            if (_this._types[_$type]) return (0, $8Ub7X.keccak256)(result);
                            return result;
                        });
                        values.unshift(encodedType);
                        return (0, $2tHqU.hexConcat)(values);
                    };
                }
                return $4700e2432cd8997c$var$logger.throwArgumentError("unknown type: ".concat(type), "type", type);
            }
        },
        {
            key: "encodeType",
            value: function encodeType(name) {
                var result = this._types[name];
                if (!result) $4700e2432cd8997c$var$logger.throwArgumentError("unknown type: ".concat(JSON.stringify(name)), "name", name);
                return result;
            }
        },
        {
            key: "encodeData",
            value: function encodeData(type, value) {
                return this.getEncoder(type)(value);
            }
        },
        {
            key: "hashStruct",
            value: function hashStruct(name, value) {
                return (0, $8Ub7X.keccak256)(this.encodeData(name, value));
            }
        },
        {
            key: "encode",
            value: function encode(value) {
                return this.encodeData(this.primaryType, value);
            }
        },
        {
            key: "hash",
            value: function hash(value) {
                return this.hashStruct(this.primaryType, value);
            }
        },
        {
            key: "_visit",
            value: function _visit(type, value, callback) {
                var _this = this;
                // Basic encoder type (address, bool, uint256, etc)
                {
                    var encoder = $4700e2432cd8997c$var$getBaseEncoder(type);
                    if (encoder) return callback(type, value);
                }
                // Array
                var match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
                if (match) {
                    var subtype = match[1];
                    var length = parseInt(match[3]);
                    if (length >= 0 && value.length !== length) $4700e2432cd8997c$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                    return value.map(function(v) {
                        return _this._visit(subtype, v, callback);
                    });
                }
                // Struct
                var fields = this.types[type];
                if (fields) return fields.reduce(function(accum, param) {
                    var name = param.name, _$type = param.type;
                    accum[name] = _this._visit(_$type, value[name], callback);
                    return accum;
                }, {});
                return $4700e2432cd8997c$var$logger.throwArgumentError("unknown type: ".concat(type), "type", type);
            }
        },
        {
            key: "visit",
            value: function visit(value, callback) {
                return this._visit(this.primaryType, value, callback);
            }
        }
    ], [
        {
            key: "from",
            value: function from(types) {
                return new TypedDataEncoder(types);
            }
        },
        {
            key: "getPrimaryType",
            value: function getPrimaryType(types) {
                return TypedDataEncoder.from(types).primaryType;
            }
        },
        {
            key: "hashStruct",
            value: function hashStruct(name, types, value) {
                return TypedDataEncoder.from(types).hashStruct(name, value);
            }
        },
        {
            key: "hashDomain",
            value: function hashDomain(domain) {
                var domainFields = [];
                for(var name in domain){
                    var type = $4700e2432cd8997c$var$domainFieldTypes[name];
                    if (!type) $4700e2432cd8997c$var$logger.throwArgumentError("invalid typed-data domain key: ".concat(JSON.stringify(name)), "domain", domain);
                    domainFields.push({
                        name: name,
                        type: type
                    });
                }
                domainFields.sort(function(a, b) {
                    return $4700e2432cd8997c$var$domainFieldNames.indexOf(a.name) - $4700e2432cd8997c$var$domainFieldNames.indexOf(b.name);
                });
                return TypedDataEncoder.hashStruct("EIP712Domain", {
                    EIP712Domain: domainFields
                }, domain);
            }
        },
        {
            key: "encode",
            value: function encode(domain, types, value) {
                return (0, $2tHqU.hexConcat)([
                    "0x1901",
                    TypedDataEncoder.hashDomain(domain),
                    TypedDataEncoder.from(types).hash(value)
                ]);
            }
        },
        {
            key: "hash",
            value: function hash(domain, types, value) {
                return (0, $8Ub7X.keccak256)(TypedDataEncoder.encode(domain, types, value));
            }
        },
        {
            key: "resolveNames",
            value: // Replaces all address types with ENS names with their looked up address
            function resolveNames(domain, types, value, resolveName) {
                return $4700e2432cd8997c$var$__awaiter(this, void 0, void 0, function() {
                    var ensCache, encoder, _tmp, _tmp1, _i, name;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Make a copy to isolate it from the object passed in
                                domain = (0, $iqBKf.shallowCopy)(domain);
                                // Look up all ENS names
                                ensCache = {};
                                // Do we need to look up the domain's verifyingContract?
                                if (domain.verifyingContract && !(0, $2tHqU.isHexString)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
                                // We are going to use the encoder to visit all the base values
                                encoder = TypedDataEncoder.from(types);
                                // Get a list of all the addresses
                                encoder.visit(value, function(type, value) {
                                    if (type === "address" && !(0, $2tHqU.isHexString)(value, 20)) ensCache[value] = "0x";
                                    return value;
                                });
                                _tmp = [];
                                for(_tmp1 in ensCache)_tmp.push(_tmp1);
                                _i = 0;
                                _state.label = 1;
                            case 1:
                                if (!(_i < _tmp.length)) return [
                                    3,
                                    4
                                ];
                                name = _tmp[_i];
                                return [
                                    4,
                                    resolveName(name)
                                ];
                            case 2:
                                ensCache[name] = _state.sent();
                                _state.label = 3;
                            case 3:
                                _i++;
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                // Replace the domain verifyingContract if needed
                                if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
                                // Replace all ENS names with their address
                                value = encoder.visit(value, function(type, value) {
                                    if (type === "address" && ensCache[value]) return ensCache[value];
                                    return value;
                                });
                                return [
                                    2,
                                    {
                                        domain: domain,
                                        value: value
                                    }
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getPayload",
            value: function getPayload(domain, types, value) {
                // Validate the domain fields
                TypedDataEncoder.hashDomain(domain);
                // Derive the EIP712Domain Struct reference type
                var domainValues = {};
                var domainTypes = [];
                $4700e2432cd8997c$var$domainFieldNames.forEach(function(name) {
                    var _$value = domain[name];
                    if (_$value == null) return;
                    domainValues[name] = $4700e2432cd8997c$var$domainChecks[name](_$value);
                    domainTypes.push({
                        name: name,
                        type: $4700e2432cd8997c$var$domainFieldTypes[name]
                    });
                });
                var encoder = TypedDataEncoder.from(types);
                var typesWithDomain = (0, $iqBKf.shallowCopy)(types);
                if (typesWithDomain.EIP712Domain) $4700e2432cd8997c$var$logger.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
                else typesWithDomain.EIP712Domain = domainTypes;
                // Validate the data structures and types
                encoder.encode(value);
                return {
                    types: typesWithDomain,
                    domain: domainValues,
                    primaryType: encoder.primaryType,
                    message: encoder.visit(value, function(type, value) {
                        // bytes
                        if (type.match(/^bytes(\d*)/)) return (0, $2tHqU.hexlify)((0, $2tHqU.arrayify)(value));
                        // uint or int
                        if (type.match(/^u?int/)) return (0, $7ryKd.BigNumber).from(value).toString();
                        switch(type){
                            case "address":
                                return value.toLowerCase();
                            case "bool":
                                return !!value;
                            case "string":
                                if (typeof value !== "string") $4700e2432cd8997c$var$logger.throwArgumentError("invalid string", "value", value);
                                return value;
                        }
                        return $4700e2432cd8997c$var$logger.throwArgumentError("unsupported type", "type", type);
                    })
                };
            }
        }
    ]);
    return TypedDataEncoder;
}();

});
parcelRegister("2Lbyz", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $2028ef715b80333b$export$83d89fbfd8236492; });
var $2028ef715b80333b$export$83d89fbfd8236492 = "hash/5.5.0";

});


parcelRegister("axO07", function(module, exports) {

$parcel$export(module.exports, "hashMessage", function () { return $7ad3c5948712b9f0$export$d4c241cec96564c1; });

var $2tHqU = parcelRequire("2tHqU");

var $8Ub7X = parcelRequire("8Ub7X");

var $5RaVA = parcelRequire("5RaVA");
var $7ad3c5948712b9f0$export$1ff3fdc4802a2ba6 = "\x19Ethereum Signed Message:\n";
function $7ad3c5948712b9f0$export$d4c241cec96564c1(message) {
    if (typeof message === "string") message = (0, $5RaVA.toUtf8Bytes)(message);
    return (0, $8Ub7X.keccak256)((0, $2tHqU.concat)([
        (0, $5RaVA.toUtf8Bytes)($7ad3c5948712b9f0$export$1ff3fdc4802a2ba6),
        (0, $5RaVA.toUtf8Bytes)(String(message.length)),
        message
    ]));
}

});

parcelRegister("3HvNL", function(module, exports) {

$parcel$export(module.exports, "defaultPath", function () { return $2b1e0e602549b62c$export$d48ad89f7e11a603; });
$parcel$export(module.exports, "HDNode", function () { return $2b1e0e602549b62c$export$b68640c53e22b952; });
$parcel$export(module.exports, "entropyToMnemonic", function () { return $2b1e0e602549b62c$export$4becd65eb23312e6; });
$parcel$export(module.exports, "mnemonicToEntropy", function () { return $2b1e0e602549b62c$export$135e090d58b310ca; });
$parcel$export(module.exports, "mnemonicToSeed", function () { return $2b1e0e602549b62c$export$3dee74f1204ab09f; });
$parcel$export(module.exports, "isValidMnemonic", function () { return $2b1e0e602549b62c$export$5eea3393c6119c80; });
$parcel$export(module.exports, "getAccountPath", function () { return $2b1e0e602549b62c$export$22b80e4f9eff636d; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $3fxSP = parcelRequire("3fxSP");

var $2tHqU = parcelRequire("2tHqU");

var $7ryKd = parcelRequire("7ryKd");

var $5RaVA = parcelRequire("5RaVA");

var $8f1wS = parcelRequire("8f1wS");

var $iqBKf = parcelRequire("iqBKf");

var $9WpJo = parcelRequire("9WpJo");

var $iM01F = parcelRequire("iM01F");
var $ipnM1 = parcelRequire("ipnM1");

var $60XIC = parcelRequire("60XIC");

var $1qgQ3 = parcelRequire("1qgQ3");

var $ihGvV = parcelRequire("ihGvV");

var $9I0To = parcelRequire("9I0To");
"use strict";
var $2b1e0e602549b62c$var$logger = new (0, $ihGvV.Logger)((0, $9I0To.version));
var $2b1e0e602549b62c$var$N = (0, $7ryKd.BigNumber).from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// "Bitcoin seed"
var $2b1e0e602549b62c$var$MasterSecret = (0, $5RaVA.toUtf8Bytes)("Bitcoin seed");
var $2b1e0e602549b62c$var$HardenedBit = 0x80000000;
// Returns a byte with the MSB bits set
function $2b1e0e602549b62c$var$getUpperMask(bits) {
    return (1 << bits) - 1 << 8 - bits;
}
// Returns a byte with the LSB bits set
function $2b1e0e602549b62c$var$getLowerMask(bits) {
    return (1 << bits) - 1;
}
function $2b1e0e602549b62c$var$bytes32(value) {
    return (0, $2tHqU.hexZeroPad)((0, $2tHqU.hexlify)(value), 32);
}
function $2b1e0e602549b62c$var$base58check(data) {
    return (0, $3fxSP.Base58).encode((0, $2tHqU.concat)([
        data,
        (0, $2tHqU.hexDataSlice)((0, $iM01F.sha256)((0, $iM01F.sha256)(data)), 0, 4)
    ]));
}
function $2b1e0e602549b62c$var$getWordlist(wordlist) {
    if (wordlist == null) return (0, $1qgQ3.wordlists)["en"];
    if (typeof wordlist === "string") {
        var words = (0, $1qgQ3.wordlists)[wordlist];
        if (words == null) $2b1e0e602549b62c$var$logger.throwArgumentError("unknown locale", "wordlist", wordlist);
        return words;
    }
    return wordlist;
}
var $2b1e0e602549b62c$var$_constructorGuard = {};
var $2b1e0e602549b62c$export$d48ad89f7e11a603 = "m/44'/60'/0'/0/0";
var $2b1e0e602549b62c$export$b68640c53e22b952 = /*#__PURE__*/ function _target() {
    function HDNode(constructorGuard, privateKey, publicKey, parentFingerprint, chainCode, index, depth, mnemonicOrPath) {
        (0, $9j09T._)(this, HDNode);
        $2b1e0e602549b62c$var$logger.checkNew(this instanceof HDNode ? this.constructor : void 0, HDNode);
        /* istanbul ignore if */ if (constructorGuard !== $2b1e0e602549b62c$var$_constructorGuard) throw new Error("HDNode constructor cannot be called directly");
        if (privateKey) {
            var signingKey = new (0, $9WpJo.SigningKey)(privateKey);
            (0, $iqBKf.defineReadOnly)(this, "privateKey", signingKey.privateKey);
            (0, $iqBKf.defineReadOnly)(this, "publicKey", signingKey.compressedPublicKey);
        } else {
            (0, $iqBKf.defineReadOnly)(this, "privateKey", null);
            (0, $iqBKf.defineReadOnly)(this, "publicKey", (0, $2tHqU.hexlify)(publicKey));
        }
        (0, $iqBKf.defineReadOnly)(this, "parentFingerprint", parentFingerprint);
        (0, $iqBKf.defineReadOnly)(this, "fingerprint", (0, $2tHqU.hexDataSlice)((0, $iM01F.ripemd160)((0, $iM01F.sha256)(this.publicKey)), 0, 4));
        (0, $iqBKf.defineReadOnly)(this, "address", (0, $60XIC.computeAddress)(this.publicKey));
        (0, $iqBKf.defineReadOnly)(this, "chainCode", chainCode);
        (0, $iqBKf.defineReadOnly)(this, "index", index);
        (0, $iqBKf.defineReadOnly)(this, "depth", depth);
        if (mnemonicOrPath == null) {
            // From a source that does not preserve the path (e.g. extended keys)
            (0, $iqBKf.defineReadOnly)(this, "mnemonic", null);
            (0, $iqBKf.defineReadOnly)(this, "path", null);
        } else if (typeof mnemonicOrPath === "string") {
            // From a source that does not preserve the mnemonic (e.g. neutered)
            (0, $iqBKf.defineReadOnly)(this, "mnemonic", null);
            (0, $iqBKf.defineReadOnly)(this, "path", mnemonicOrPath);
        } else {
            // From a fully qualified source
            (0, $iqBKf.defineReadOnly)(this, "mnemonic", mnemonicOrPath);
            (0, $iqBKf.defineReadOnly)(this, "path", mnemonicOrPath.path);
        }
    }
    (0, $eDeHT._)(HDNode, [
        {
            key: "extendedKey",
            get: function get() {
                // We only support the mainnet values for now, but if anyone needs
                // testnet values, let me know. I believe current sentiment is that
                // we should always use mainnet, and use BIP-44 to derive the network
                //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
                //   - Testnet: public=0x043587CF, private=0x04358394
                if (this.depth >= 256) throw new Error("Depth too large!");
                return $2b1e0e602549b62c$var$base58check((0, $2tHqU.concat)([
                    this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
                    (0, $2tHqU.hexlify)(this.depth),
                    this.parentFingerprint,
                    (0, $2tHqU.hexZeroPad)((0, $2tHqU.hexlify)(this.index), 4),
                    this.chainCode,
                    this.privateKey != null ? (0, $2tHqU.concat)([
                        "0x00",
                        this.privateKey
                    ]) : this.publicKey
                ]));
            }
        },
        {
            key: "neuter",
            value: function neuter() {
                return new HDNode($2b1e0e602549b62c$var$_constructorGuard, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
            }
        },
        {
            key: "_derive",
            value: function _derive(index) {
                if (index > 0xffffffff) throw new Error("invalid index - " + String(index));
                // Base path
                var path = this.path;
                if (path) path += "/" + (index & ~$2b1e0e602549b62c$var$HardenedBit);
                var data = new Uint8Array(37);
                if (index & $2b1e0e602549b62c$var$HardenedBit) {
                    if (!this.privateKey) throw new Error("cannot derive child of neutered node");
                    // Data = 0x00 || ser_256(k_par)
                    data.set((0, $2tHqU.arrayify)(this.privateKey), 1);
                    // Hardened path
                    if (path) path += "'";
                } else // Data = ser_p(point(k_par))
                data.set((0, $2tHqU.arrayify)(this.publicKey));
                // Data += ser_32(i)
                for(var i = 24; i >= 0; i -= 8)data[33 + (i >> 3)] = index >> 24 - i & 0xff;
                var I = (0, $2tHqU.arrayify)((0, $iM01F.computeHmac)((0, $ipnM1.SupportedAlgorithm).sha512, this.chainCode, data));
                var IL = I.slice(0, 32);
                var IR = I.slice(32);
                // The private key
                var ki = null;
                // The public key
                var Ki = null;
                if (this.privateKey) ki = $2b1e0e602549b62c$var$bytes32((0, $7ryKd.BigNumber).from(IL).add(this.privateKey).mod($2b1e0e602549b62c$var$N));
                else {
                    var ek = new (0, $9WpJo.SigningKey)((0, $2tHqU.hexlify)(IL));
                    Ki = ek._addPoint(this.publicKey);
                }
                var mnemonicOrPath = path;
                var srcMnemonic = this.mnemonic;
                if (srcMnemonic) mnemonicOrPath = Object.freeze({
                    phrase: srcMnemonic.phrase,
                    path: path,
                    locale: srcMnemonic.locale || "en"
                });
                return new HDNode($2b1e0e602549b62c$var$_constructorGuard, ki, Ki, this.fingerprint, $2b1e0e602549b62c$var$bytes32(IR), index, this.depth + 1, mnemonicOrPath);
            }
        },
        {
            key: "derivePath",
            value: function derivePath(path) {
                var components = path.split("/");
                if (components.length === 0 || components[0] === "m" && this.depth !== 0) throw new Error("invalid path - " + path);
                if (components[0] === "m") components.shift();
                var result = this;
                for(var i = 0; i < components.length; i++){
                    var component = components[i];
                    if (component.match(/^[0-9]+'$/)) {
                        var index = parseInt(component.substring(0, component.length - 1));
                        if (index >= $2b1e0e602549b62c$var$HardenedBit) throw new Error("invalid path index - " + component);
                        result = result._derive($2b1e0e602549b62c$var$HardenedBit + index);
                    } else if (component.match(/^[0-9]+$/)) {
                        var index1 = parseInt(component);
                        if (index1 >= $2b1e0e602549b62c$var$HardenedBit) throw new Error("invalid path index - " + component);
                        result = result._derive(index1);
                    } else throw new Error("invalid path component - " + component);
                }
                return result;
            }
        }
    ], [
        {
            key: "_fromSeed",
            value: function _fromSeed(seed, mnemonic) {
                var seedArray = (0, $2tHqU.arrayify)(seed);
                if (seedArray.length < 16 || seedArray.length > 64) throw new Error("invalid seed");
                var I = (0, $2tHqU.arrayify)((0, $iM01F.computeHmac)((0, $ipnM1.SupportedAlgorithm).sha512, $2b1e0e602549b62c$var$MasterSecret, seedArray));
                return new HDNode($2b1e0e602549b62c$var$_constructorGuard, $2b1e0e602549b62c$var$bytes32(I.slice(0, 32)), null, "0x00000000", $2b1e0e602549b62c$var$bytes32(I.slice(32)), 0, 0, mnemonic);
            }
        },
        {
            key: "fromMnemonic",
            value: function fromMnemonic(mnemonic, password, wordlist) {
                // If a locale name was passed in, find the associated wordlist
                wordlist = $2b1e0e602549b62c$var$getWordlist(wordlist);
                // Normalize the case and spacing in the mnemonic (throws if the mnemonic is invalid)
                mnemonic = $2b1e0e602549b62c$export$4becd65eb23312e6($2b1e0e602549b62c$export$135e090d58b310ca(mnemonic, wordlist), wordlist);
                return HDNode._fromSeed($2b1e0e602549b62c$export$3dee74f1204ab09f(mnemonic, password), {
                    phrase: mnemonic,
                    path: "m",
                    locale: wordlist.locale
                });
            }
        },
        {
            key: "fromSeed",
            value: function fromSeed(seed) {
                return HDNode._fromSeed(seed, null);
            }
        },
        {
            key: "fromExtendedKey",
            value: function fromExtendedKey(extendedKey) {
                var bytes = (0, $3fxSP.Base58).decode(extendedKey);
                if (bytes.length !== 82 || $2b1e0e602549b62c$var$base58check(bytes.slice(0, 78)) !== extendedKey) $2b1e0e602549b62c$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
                var depth = bytes[4];
                var parentFingerprint = (0, $2tHqU.hexlify)(bytes.slice(5, 9));
                var index = parseInt((0, $2tHqU.hexlify)(bytes.slice(9, 13)).substring(2), 16);
                var chainCode = (0, $2tHqU.hexlify)(bytes.slice(13, 45));
                var key = bytes.slice(45, 78);
                switch((0, $2tHqU.hexlify)(bytes.slice(0, 4))){
                    // Public Key
                    case "0x0488b21e":
                    case "0x043587cf":
                        return new HDNode($2b1e0e602549b62c$var$_constructorGuard, null, (0, $2tHqU.hexlify)(key), parentFingerprint, chainCode, index, depth, null);
                    // Private Key
                    case "0x0488ade4":
                    case "0x04358394 ":
                        if (key[0] !== 0) break;
                        return new HDNode($2b1e0e602549b62c$var$_constructorGuard, (0, $2tHqU.hexlify)(key.slice(1)), null, parentFingerprint, chainCode, index, depth, null);
                }
                return $2b1e0e602549b62c$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
            }
        }
    ]);
    return HDNode;
}();
function $2b1e0e602549b62c$export$3dee74f1204ab09f(mnemonic, password) {
    if (!password) password = "";
    var salt = (0, $5RaVA.toUtf8Bytes)("mnemonic" + password, (0, $5RaVA.UnicodeNormalizationForm).NFKD);
    return (0, $8f1wS.pbkdf2)((0, $5RaVA.toUtf8Bytes)(mnemonic, (0, $5RaVA.UnicodeNormalizationForm).NFKD), salt, 2048, 64, "sha512");
}
function $2b1e0e602549b62c$export$135e090d58b310ca(mnemonic, wordlist) {
    wordlist = $2b1e0e602549b62c$var$getWordlist(wordlist);
    $2b1e0e602549b62c$var$logger.checkNormalize();
    var words = wordlist.split(mnemonic);
    if (words.length % 3 !== 0) throw new Error("invalid mnemonic");
    var entropy = (0, $2tHqU.arrayify)(new Uint8Array(Math.ceil(11 * words.length / 8)));
    var offset = 0;
    for(var i = 0; i < words.length; i++){
        var index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        if (index === -1) throw new Error("invalid mnemonic");
        for(var bit = 0; bit < 11; bit++){
            if (index & 1 << 10 - bit) entropy[offset >> 3] |= 1 << 7 - offset % 8;
            offset++;
        }
    }
    var entropyBits = 32 * words.length / 3;
    var checksumBits = words.length / 3;
    var checksumMask = $2b1e0e602549b62c$var$getUpperMask(checksumBits);
    var checksum = (0, $2tHqU.arrayify)((0, $iM01F.sha256)(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    if (checksum !== (entropy[entropy.length - 1] & checksumMask)) throw new Error("invalid checksum");
    return (0, $2tHqU.hexlify)(entropy.slice(0, entropyBits / 8));
}
function $2b1e0e602549b62c$export$4becd65eb23312e6(entropy, wordlist) {
    wordlist = $2b1e0e602549b62c$var$getWordlist(wordlist);
    entropy = (0, $2tHqU.arrayify)(entropy);
    if (entropy.length % 4 !== 0 || entropy.length < 16 || entropy.length > 32) throw new Error("invalid entropy");
    var indices = [
        0
    ];
    var remainingBits = 11;
    for(var i = 0; i < entropy.length; i++)// Consume the whole byte (with still more to go)
    if (remainingBits > 8) {
        indices[indices.length - 1] <<= 8;
        indices[indices.length - 1] |= entropy[i];
        remainingBits -= 8;
    // This byte will complete an 11-bit index
    } else {
        indices[indices.length - 1] <<= remainingBits;
        indices[indices.length - 1] |= entropy[i] >> 8 - remainingBits;
        // Start the next word
        indices.push(entropy[i] & $2b1e0e602549b62c$var$getLowerMask(8 - remainingBits));
        remainingBits += 3;
    }
    // Compute the checksum bits
    var checksumBits = entropy.length / 4;
    var checksum = (0, $2tHqU.arrayify)((0, $iM01F.sha256)(entropy))[0] & $2b1e0e602549b62c$var$getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= checksum >> 8 - checksumBits;
    return wordlist.join(indices.map(function(index) {
        return wordlist.getWord(index);
    }));
}
function $2b1e0e602549b62c$export$5eea3393c6119c80(mnemonic, wordlist) {
    try {
        $2b1e0e602549b62c$export$135e090d58b310ca(mnemonic, wordlist);
        return true;
    } catch (error) {}
    return false;
}
function $2b1e0e602549b62c$export$22b80e4f9eff636d(index) {
    if (typeof index !== "number" || index < 0 || index >= $2b1e0e602549b62c$var$HardenedBit || index % 1) $2b1e0e602549b62c$var$logger.throwArgumentError("invalid account index", "index", index);
    return "m/44'/60'/".concat(index, "'/0/0");
}

});
parcelRegister("3fxSP", function(module, exports) {

$parcel$export(module.exports, "Base58", function () { return $25dd0e5413d011f4$export$45a587635c9954b2; });
/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */ 
var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $2tHqU = parcelRequire("2tHqU");

var $iqBKf = parcelRequire("iqBKf");
var $25dd0e5413d011f4$export$240043ab8e806ec7 = /*#__PURE__*/ function() {
    "use strict";
    function BaseX(alphabet) {
        (0, $9j09T._)(this, BaseX);
        (0, $iqBKf.defineReadOnly)(this, "alphabet", alphabet);
        (0, $iqBKf.defineReadOnly)(this, "base", alphabet.length);
        (0, $iqBKf.defineReadOnly)(this, "_alphabetMap", {});
        (0, $iqBKf.defineReadOnly)(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for(var i = 0; i < alphabet.length; i++)this._alphabetMap[alphabet.charAt(i)] = i;
    }
    (0, $eDeHT._)(BaseX, [
        {
            key: "encode",
            value: function encode(value) {
                var source = (0, $2tHqU.arrayify)(value);
                if (source.length === 0) return "";
                var digits = [
                    0
                ];
                for(var i = 0; i < source.length; ++i){
                    var carry = source[i];
                    for(var j = 0; j < digits.length; ++j){
                        carry += digits[j] << 8;
                        digits[j] = carry % this.base;
                        carry = carry / this.base | 0;
                    }
                    while(carry > 0){
                        digits.push(carry % this.base);
                        carry = carry / this.base | 0;
                    }
                }
                var string = "";
                // deal with leading zeros
                for(var k = 0; source[k] === 0 && k < source.length - 1; ++k)string += this._leader;
                // convert digits to a string
                for(var q = digits.length - 1; q >= 0; --q)string += this.alphabet[digits[q]];
                return string;
            }
        },
        {
            key: "decode",
            value: function decode(value) {
                if (typeof value !== "string") throw new TypeError("Expected String");
                var bytes = [];
                if (value.length === 0) return new Uint8Array(bytes);
                bytes.push(0);
                for(var i = 0; i < value.length; i++){
                    var byte = this._alphabetMap[value[i]];
                    if (byte === undefined) throw new Error("Non-base" + this.base + " character");
                    var carry = byte;
                    for(var j = 0; j < bytes.length; ++j){
                        carry += bytes[j] * this.base;
                        bytes[j] = carry & 0xff;
                        carry >>= 8;
                    }
                    while(carry > 0){
                        bytes.push(carry & 0xff);
                        carry >>= 8;
                    }
                }
                // deal with leading zeros
                for(var k = 0; value[k] === this._leader && k < value.length - 1; ++k)bytes.push(0);
                return (0, $2tHqU.arrayify)(new Uint8Array(bytes.reverse()));
            }
        }
    ]);
    return BaseX;
}();
var $25dd0e5413d011f4$export$cfabb2852920f5ec = new $25dd0e5413d011f4$export$240043ab8e806ec7("abcdefghijklmnopqrstuvwxyz234567");
var $25dd0e5413d011f4$export$45a587635c9954b2 = new $25dd0e5413d011f4$export$240043ab8e806ec7("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
 //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
 //console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))

});

parcelRegister("8f1wS", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $6000e92695d7b338$export$448fa22aedc9dbca; });

var $2tHqU = parcelRequire("2tHqU");

var $iM01F = parcelRequire("iM01F");
"use strict";
function $6000e92695d7b338$export$448fa22aedc9dbca(password, salt, iterations, keylen, hashAlgorithm) {
    password = (0, $2tHqU.arrayify)(password);
    salt = (0, $2tHqU.arrayify)(salt);
    var hLen;
    var l = 1;
    var DK = new Uint8Array(keylen);
    var block1 = new Uint8Array(salt.length + 4);
    block1.set(salt);
    //salt.copy(block1, 0, 0, salt.length)
    var r;
    var T;
    for(var i = 1; i <= l; i++){
        //block1.writeUInt32BE(i, salt.length)
        block1[salt.length] = i >> 24 & 0xff;
        block1[salt.length + 1] = i >> 16 & 0xff;
        block1[salt.length + 2] = i >> 8 & 0xff;
        block1[salt.length + 3] = i & 0xff;
        //let U = createHmac(password).update(block1).digest();
        var U = (0, $2tHqU.arrayify)((0, $iM01F.computeHmac)(hashAlgorithm, password, block1));
        if (!hLen) {
            hLen = U.length;
            T = new Uint8Array(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
        }
        //U.copy(T, 0, 0, hLen)
        T.set(U);
        for(var j = 1; j < iterations; j++){
            //U = createHmac(password).update(U).digest();
            U = (0, $2tHqU.arrayify)((0, $iM01F.computeHmac)(hashAlgorithm, password, U));
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        var destPos = (i - 1) * hLen;
        var len = i === l ? r : hLen;
        //T.copy(DK, destPos, 0, len)
        DK.set((0, $2tHqU.arrayify)(T).slice(0, len), destPos);
    }
    return (0, $2tHqU.hexlify)(DK);
}

});
parcelRegister("iM01F", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $daacbad741a83351$export$d1cea0ee4e3f0d3e; });
$parcel$export(module.exports, "sha256", function () { return $daacbad741a83351$export$bced8d2aada2d1c9; });
$parcel$export(module.exports, "sha512", function () { return $daacbad741a83351$export$a888d2532e6dc7bb; });
$parcel$export(module.exports, "computeHmac", function () { return $daacbad741a83351$export$967075d2f3b8e7ff; });

var $3EYbz = parcelRequire("3EYbz");

var $2tHqU = parcelRequire("2tHqU");

var $ipnM1 = parcelRequire("ipnM1");

var $ihGvV = parcelRequire("ihGvV");

var $1sWXN = parcelRequire("1sWXN");
"use strict";
var $daacbad741a83351$var$logger = new (0, $ihGvV.Logger)((0, $1sWXN.version));
function $daacbad741a83351$export$d1cea0ee4e3f0d3e(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($3EYbz))).ripemd160().update((0, $2tHqU.arrayify)(data)).digest("hex");
}
function $daacbad741a83351$export$bced8d2aada2d1c9(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($3EYbz))).sha256().update((0, $2tHqU.arrayify)(data)).digest("hex");
}
function $daacbad741a83351$export$a888d2532e6dc7bb(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($3EYbz))).sha512().update((0, $2tHqU.arrayify)(data)).digest("hex");
}
function $daacbad741a83351$export$967075d2f3b8e7ff(algorithm, key, data) {
    if (!(0, $ipnM1.SupportedAlgorithm)[algorithm]) $daacbad741a83351$var$logger.throwError("unsupported algorithm " + algorithm, (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($3EYbz))).hmac((0, (/*@__PURE__*/$parcel$interopDefault($3EYbz)))[algorithm], (0, $2tHqU.arrayify)(key)).update((0, $2tHqU.arrayify)(data)).digest("hex");
}

});
parcelRegister("ipnM1", function(module, exports) {

$parcel$export(module.exports, "SupportedAlgorithm", function () { return $d66d00b7cc659701$export$d2a8849cfb277c; });
var $d66d00b7cc659701$export$d2a8849cfb277c;
(function(SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})($d66d00b7cc659701$export$d2a8849cfb277c || ($d66d00b7cc659701$export$d2a8849cfb277c = {}));

});

parcelRegister("1sWXN", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $111624deb0213bc4$export$83d89fbfd8236492; });
var $111624deb0213bc4$export$83d89fbfd8236492 = "sha2/5.5.0";

});



parcelRegister("1qgQ3", function(module, exports) {

$parcel$export(module.exports, "wordlists", function () { return $109547f6ea248b52$export$e8e1b4711c2d1939; });

var $hBfSS = parcelRequire("hBfSS");
"use strict";
var $109547f6ea248b52$export$e8e1b4711c2d1939 = {
    en: (0, $hBfSS.langEn)
};

});
parcelRegister("hBfSS", function(module, exports) {

$parcel$export(module.exports, "langEn", function () { return $cd02369d5a55f026$export$a2c9518710cf1f49; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $gXjmM = parcelRequire("gXjmM");
"use strict";
var $cd02369d5a55f026$var$words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
var $cd02369d5a55f026$var$wordlist = null;
function $cd02369d5a55f026$var$loadWords(lang) {
    if ($cd02369d5a55f026$var$wordlist != null) return;
    $cd02369d5a55f026$var$wordlist = $cd02369d5a55f026$var$words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" ");
    // Verify the computed list matches the official list
    /* istanbul ignore if */ if ((0, $gXjmM.Wordlist).check(lang) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60") {
        $cd02369d5a55f026$var$wordlist = null;
        throw new Error("BIP39 Wordlist for en (English) FAILED");
    }
}
var $cd02369d5a55f026$var$LangEn = /*#__PURE__*/ function(Wordlist) {
    (0, $i0LXg._)(LangEn, Wordlist);
    var _super = (0, $a1vXf._)(LangEn);
    function LangEn() {
        (0, $9j09T._)(this, LangEn);
        return _super.call(this, "en");
    }
    (0, $eDeHT._)(LangEn, [
        {
            key: "getWord",
            value: function getWord(index) {
                $cd02369d5a55f026$var$loadWords(this);
                return $cd02369d5a55f026$var$wordlist[index];
            }
        },
        {
            key: "getWordIndex",
            value: function getWordIndex(word) {
                $cd02369d5a55f026$var$loadWords(this);
                return $cd02369d5a55f026$var$wordlist.indexOf(word);
            }
        }
    ]);
    return LangEn;
}((0, $gXjmM.Wordlist));
var $cd02369d5a55f026$export$a2c9518710cf1f49 = new $cd02369d5a55f026$var$LangEn();
(0, $gXjmM.Wordlist).register($cd02369d5a55f026$export$a2c9518710cf1f49);

});
parcelRegister("gXjmM", function(module, exports) {

$parcel$export(module.exports, "Wordlist", function () { return $c5812dcc72b00733$export$4d9531a8ddb0ebca; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $9QZv3 = parcelRequire("9QZv3");

var $iqBKf = parcelRequire("iqBKf");

var $ihGvV = parcelRequire("ihGvV");

var $i1rwa = parcelRequire("i1rwa");
"use strict";
// This gets overridden by rollup
var $c5812dcc72b00733$var$exportWordlist = false;
var $c5812dcc72b00733$export$af88d00dbe7f521 = new (0, $ihGvV.Logger)((0, $i1rwa.version));
var $c5812dcc72b00733$export$4d9531a8ddb0ebca = /*#__PURE__*/ function _target() {
    function Wordlist(locale) {
        (0, $9j09T._)(this, Wordlist);
        $c5812dcc72b00733$export$af88d00dbe7f521.checkAbstract(this instanceof Wordlist ? this.constructor : void 0, Wordlist);
        (0, $iqBKf.defineReadOnly)(this, "locale", locale);
    }
    (0, $eDeHT._)(Wordlist, [
        {
            // Subclasses may override this
            key: "split",
            value: function split(mnemonic) {
                return mnemonic.toLowerCase().split(/ +/g);
            }
        },
        {
            // Subclasses may override this
            key: "join",
            value: function join(words) {
                return words.join(" ");
            }
        }
    ], [
        {
            key: "check",
            value: function check(wordlist) {
                var words = [];
                for(var i = 0; i < 2048; i++){
                    var word = wordlist.getWord(i);
                    /* istanbul ignore if */ if (i !== wordlist.getWordIndex(word)) return "0x";
                    words.push(word);
                }
                return (0, $9QZv3.id)(words.join("\n") + "\n");
            }
        },
        {
            key: "register",
            value: function register(lang, name) {
                if (!name) name = lang.locale;
                /* istanbul ignore if */ if ($c5812dcc72b00733$var$exportWordlist) try {
                    var anyGlobal = window;
                    if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
                        if (!anyGlobal._ethers.wordlists[name]) (0, $iqBKf.defineReadOnly)(anyGlobal._ethers.wordlists, name, lang);
                    }
                } catch (error) {}
            }
        }
    ]);
    return Wordlist;
}();

});
parcelRegister("i1rwa", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $d1edaa7a567f4166$export$83d89fbfd8236492; });
var $d1edaa7a567f4166$export$83d89fbfd8236492 = "wordlists/5.5.0";

});




parcelRegister("9I0To", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $7118ea5bb11b8ce6$export$83d89fbfd8236492; });
var $7118ea5bb11b8ce6$export$83d89fbfd8236492 = "hdnode/5.5.0";

});


parcelRegister("6wezB", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $4bf1092f4834466b$export$5f828d93ff035aa8; });

var $2tHqU = parcelRequire("2tHqU");

var $ihGvV = parcelRequire("ihGvV");

var $604xV = parcelRequire("604xV");
"use strict";
var $4bf1092f4834466b$var$logger = new (0, $ihGvV.Logger)((0, $604xV.version));
// Debugging line for testing browser lib in node
//const window = { crypto: { getRandomValues: () => { } } };
var $4bf1092f4834466b$var$anyGlobal = null;
try {
    $4bf1092f4834466b$var$anyGlobal = window;
    if ($4bf1092f4834466b$var$anyGlobal == null) throw new Error("try next");
} catch (error) {
    try {
        $4bf1092f4834466b$var$anyGlobal = $parcel$global;
        if ($4bf1092f4834466b$var$anyGlobal == null) throw new Error("try next");
    } catch (error) {
        $4bf1092f4834466b$var$anyGlobal = {};
    }
}
var $4bf1092f4834466b$var$crypto = $4bf1092f4834466b$var$anyGlobal.crypto || $4bf1092f4834466b$var$anyGlobal.msCrypto;
if (!$4bf1092f4834466b$var$crypto || !$4bf1092f4834466b$var$crypto.getRandomValues) {
    $4bf1092f4834466b$var$logger.warn("WARNING: Missing strong random number source");
    $4bf1092f4834466b$var$crypto = {
        getRandomValues: function getRandomValues(buffer) {
            return $4bf1092f4834466b$var$logger.throwError("no secure random source avaialble", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "crypto.getRandomValues"
            });
        }
    };
}
function $4bf1092f4834466b$export$5f828d93ff035aa8(length) {
    if (length <= 0 || length > 1024 || length % 1 || length != length) $4bf1092f4834466b$var$logger.throwArgumentError("invalid length", "length", length);
    var result = new Uint8Array(length);
    $4bf1092f4834466b$var$crypto.getRandomValues(result);
    return (0, $2tHqU.arrayify)(result);
}

});
parcelRegister("604xV", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $45e644ed6656e7fb$export$83d89fbfd8236492; });
var $45e644ed6656e7fb$export$83d89fbfd8236492 = "random/5.5.0";

});


parcelRegister("97iju", function(module, exports) {

$parcel$export(module.exports, "decryptJsonWallet", function () { return $6a32f927960c8560$export$e74fcde37488267a; });
$parcel$export(module.exports, "decryptJsonWalletSync", function () { return $6a32f927960c8560$export$7a81c437a678891a; });

var $2EM98 = parcelRequire("2EM98");

var $awZzE = parcelRequire("awZzE");

var $eEEnh = parcelRequire("eEEnh");
"use strict";
function $6a32f927960c8560$export$e74fcde37488267a(json, password, progressCallback) {
    if ((0, $awZzE.isCrowdsaleWallet)(json)) {
        if (progressCallback) progressCallback(0);
        var account = (0, $2EM98.decrypt)(json, password);
        if (progressCallback) progressCallback(1);
        return Promise.resolve(account);
    }
    if ((0, $awZzE.isKeystoreWallet)(json)) return (0, $eEEnh.decrypt)(json, password, progressCallback);
    return Promise.reject(new Error("invalid JSON wallet"));
}
function $6a32f927960c8560$export$7a81c437a678891a(json, password) {
    if ((0, $awZzE.isCrowdsaleWallet)(json)) return (0, $2EM98.decrypt)(json, password);
    if ((0, $awZzE.isKeystoreWallet)(json)) return (0, $eEEnh.decryptSync)(json, password);
    throw new Error("invalid JSON wallet");
}

});
parcelRegister("2EM98", function(module, exports) {

$parcel$export(module.exports, "decrypt", function () { return $1ef4aa13a0395a70$export$e85a0c9a1067c5d3; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $bVtKz = parcelRequire("bVtKz");

var $hFSWi = parcelRequire("hFSWi");

var $2tHqU = parcelRequire("2tHqU");

var $8Ub7X = parcelRequire("8Ub7X");

var $8f1wS = parcelRequire("8f1wS");

var $5RaVA = parcelRequire("5RaVA");

var $iqBKf = parcelRequire("iqBKf");

var $ihGvV = parcelRequire("ihGvV");

var $7gF0P = parcelRequire("7gF0P");

var $7CcUS = parcelRequire("7CcUS");
"use strict";
var $1ef4aa13a0395a70$var$logger = new (0, $ihGvV.Logger)((0, $7gF0P.version));
var $1ef4aa13a0395a70$export$93a76d16f88f2b3 = /*#__PURE__*/ function(Description) {
    (0, $i0LXg._)(CrowdsaleAccount, Description);
    var _super = (0, $a1vXf._)(CrowdsaleAccount);
    function CrowdsaleAccount() {
        (0, $9j09T._)(this, CrowdsaleAccount);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(CrowdsaleAccount, [
        {
            key: "isCrowdsaleAccount",
            value: function isCrowdsaleAccount(value) {
                return !!(value && value._isCrowdsaleAccount);
            }
        }
    ]);
    return CrowdsaleAccount;
}((0, $iqBKf.Description));
function $1ef4aa13a0395a70$export$e85a0c9a1067c5d3(json, password) {
    var data = JSON.parse(json);
    password = (0, $7CcUS.getPassword)(password);
    // Ethereum Address
    var ethaddr = (0, $hFSWi.getAddress)((0, $7CcUS.searchPath)(data, "ethaddr"));
    // Encrypted Seed
    var encseed = (0, $7CcUS.looseArrayify)((0, $7CcUS.searchPath)(data, "encseed"));
    if (!encseed || encseed.length % 16 !== 0) $1ef4aa13a0395a70$var$logger.throwArgumentError("invalid encseed", "json", json);
    var key = (0, $2tHqU.arrayify)((0, $8f1wS.pbkdf2)(password, password, 2000, 32, "sha256")).slice(0, 16);
    var iv = encseed.slice(0, 16);
    var encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    var aesCbc = new (0, (/*@__PURE__*/$parcel$interopDefault($bVtKz))).ModeOfOperation.cbc(key, iv);
    var seed = (0, (/*@__PURE__*/$parcel$interopDefault($bVtKz))).padding.pkcs7.strip((0, $2tHqU.arrayify)(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    var seedHex = "";
    for(var i = 0; i < seed.length; i++)seedHex += String.fromCharCode(seed[i]);
    var seedHexBytes = (0, $5RaVA.toUtf8Bytes)(seedHex);
    var privateKey = (0, $8Ub7X.keccak256)(seedHexBytes);
    return new $1ef4aa13a0395a70$export$93a76d16f88f2b3({
        _isCrowdsaleAccount: true,
        address: ethaddr,
        privateKey: privateKey
    });
}

});
parcelRegister("bVtKz", function(module, exports) {
"use strict";
(function(root) {
    function checkInt(value) {
        return parseInt(value) === value;
    }
    function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) return false;
        for(var i = 0; i < arrayish.length; i++){
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) return false;
        }
        return true;
    }
    function coerceArray(arg, copy) {
        // ArrayBuffer view
        if (arg.buffer && ArrayBuffer.isView(arg) && arg.name === "Uint8Array") {
            if (copy) {
                if (arg.slice) arg = arg.slice();
                else arg = Array.prototype.slice.call(arg);
            }
            return arg;
        }
        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) throw new Error("Array contains invalid value: " + arg);
            return new Uint8Array(arg);
        }
        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) return new Uint8Array(arg);
        throw new Error("unsupported array-like object");
    }
    function createArray(length) {
        return new Uint8Array(length);
    }
    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            else sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
        }
        targetArray.set(sourceArray, targetStart);
    }
    var convertUtf8 = function() {
        function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while(i < text.length){
                var c = text.charCodeAt(i++);
                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16));
                    i += 2;
                // otherwise, just the actual byte
                } else result.push(c);
            }
            return coerceArray(result);
        }
        function fromBytes(bytes) {
            var result = [], i = 0;
            while(i < bytes.length){
                var c = bytes[i];
                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode((c & 0x1f) << 6 | bytes[i + 1] & 0x3f));
                    i += 2;
                } else {
                    result.push(String.fromCharCode((c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f));
                    i += 3;
                }
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    var convertHex = function() {
        function toBytes(text) {
            var result = [];
            for(var i = 0; i < text.length; i += 2)result.push(parseInt(text.substr(i, 2), 16));
            return result;
        }
        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = "0123456789abcdef";
        function fromBytes(bytes) {
            var result = [];
            for(var i = 0; i < bytes.length; i++){
                var v = bytes[i];
                result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    // Number of rounds by keysize
    var numberOfRounds = {
        16: 10,
        24: 12,
        32: 14
    };
    // Round constant words
    var rcon = [
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1b,
        0x36,
        0x6c,
        0xd8,
        0xab,
        0x4d,
        0x9a,
        0x2f,
        0x5e,
        0xbc,
        0x63,
        0xc6,
        0x97,
        0x35,
        0x6a,
        0xd4,
        0xb3,
        0x7d,
        0xfa,
        0xef,
        0xc5,
        0x91
    ];
    // S-box and Inverse S-box (S is for Substitution)
    var S = [
        0x63,
        0x7c,
        0x77,
        0x7b,
        0xf2,
        0x6b,
        0x6f,
        0xc5,
        0x30,
        0x01,
        0x67,
        0x2b,
        0xfe,
        0xd7,
        0xab,
        0x76,
        0xca,
        0x82,
        0xc9,
        0x7d,
        0xfa,
        0x59,
        0x47,
        0xf0,
        0xad,
        0xd4,
        0xa2,
        0xaf,
        0x9c,
        0xa4,
        0x72,
        0xc0,
        0xb7,
        0xfd,
        0x93,
        0x26,
        0x36,
        0x3f,
        0xf7,
        0xcc,
        0x34,
        0xa5,
        0xe5,
        0xf1,
        0x71,
        0xd8,
        0x31,
        0x15,
        0x04,
        0xc7,
        0x23,
        0xc3,
        0x18,
        0x96,
        0x05,
        0x9a,
        0x07,
        0x12,
        0x80,
        0xe2,
        0xeb,
        0x27,
        0xb2,
        0x75,
        0x09,
        0x83,
        0x2c,
        0x1a,
        0x1b,
        0x6e,
        0x5a,
        0xa0,
        0x52,
        0x3b,
        0xd6,
        0xb3,
        0x29,
        0xe3,
        0x2f,
        0x84,
        0x53,
        0xd1,
        0x00,
        0xed,
        0x20,
        0xfc,
        0xb1,
        0x5b,
        0x6a,
        0xcb,
        0xbe,
        0x39,
        0x4a,
        0x4c,
        0x58,
        0xcf,
        0xd0,
        0xef,
        0xaa,
        0xfb,
        0x43,
        0x4d,
        0x33,
        0x85,
        0x45,
        0xf9,
        0x02,
        0x7f,
        0x50,
        0x3c,
        0x9f,
        0xa8,
        0x51,
        0xa3,
        0x40,
        0x8f,
        0x92,
        0x9d,
        0x38,
        0xf5,
        0xbc,
        0xb6,
        0xda,
        0x21,
        0x10,
        0xff,
        0xf3,
        0xd2,
        0xcd,
        0x0c,
        0x13,
        0xec,
        0x5f,
        0x97,
        0x44,
        0x17,
        0xc4,
        0xa7,
        0x7e,
        0x3d,
        0x64,
        0x5d,
        0x19,
        0x73,
        0x60,
        0x81,
        0x4f,
        0xdc,
        0x22,
        0x2a,
        0x90,
        0x88,
        0x46,
        0xee,
        0xb8,
        0x14,
        0xde,
        0x5e,
        0x0b,
        0xdb,
        0xe0,
        0x32,
        0x3a,
        0x0a,
        0x49,
        0x06,
        0x24,
        0x5c,
        0xc2,
        0xd3,
        0xac,
        0x62,
        0x91,
        0x95,
        0xe4,
        0x79,
        0xe7,
        0xc8,
        0x37,
        0x6d,
        0x8d,
        0xd5,
        0x4e,
        0xa9,
        0x6c,
        0x56,
        0xf4,
        0xea,
        0x65,
        0x7a,
        0xae,
        0x08,
        0xba,
        0x78,
        0x25,
        0x2e,
        0x1c,
        0xa6,
        0xb4,
        0xc6,
        0xe8,
        0xdd,
        0x74,
        0x1f,
        0x4b,
        0xbd,
        0x8b,
        0x8a,
        0x70,
        0x3e,
        0xb5,
        0x66,
        0x48,
        0x03,
        0xf6,
        0x0e,
        0x61,
        0x35,
        0x57,
        0xb9,
        0x86,
        0xc1,
        0x1d,
        0x9e,
        0xe1,
        0xf8,
        0x98,
        0x11,
        0x69,
        0xd9,
        0x8e,
        0x94,
        0x9b,
        0x1e,
        0x87,
        0xe9,
        0xce,
        0x55,
        0x28,
        0xdf,
        0x8c,
        0xa1,
        0x89,
        0x0d,
        0xbf,
        0xe6,
        0x42,
        0x68,
        0x41,
        0x99,
        0x2d,
        0x0f,
        0xb0,
        0x54,
        0xbb,
        0x16
    ];
    var Si = [
        0x52,
        0x09,
        0x6a,
        0xd5,
        0x30,
        0x36,
        0xa5,
        0x38,
        0xbf,
        0x40,
        0xa3,
        0x9e,
        0x81,
        0xf3,
        0xd7,
        0xfb,
        0x7c,
        0xe3,
        0x39,
        0x82,
        0x9b,
        0x2f,
        0xff,
        0x87,
        0x34,
        0x8e,
        0x43,
        0x44,
        0xc4,
        0xde,
        0xe9,
        0xcb,
        0x54,
        0x7b,
        0x94,
        0x32,
        0xa6,
        0xc2,
        0x23,
        0x3d,
        0xee,
        0x4c,
        0x95,
        0x0b,
        0x42,
        0xfa,
        0xc3,
        0x4e,
        0x08,
        0x2e,
        0xa1,
        0x66,
        0x28,
        0xd9,
        0x24,
        0xb2,
        0x76,
        0x5b,
        0xa2,
        0x49,
        0x6d,
        0x8b,
        0xd1,
        0x25,
        0x72,
        0xf8,
        0xf6,
        0x64,
        0x86,
        0x68,
        0x98,
        0x16,
        0xd4,
        0xa4,
        0x5c,
        0xcc,
        0x5d,
        0x65,
        0xb6,
        0x92,
        0x6c,
        0x70,
        0x48,
        0x50,
        0xfd,
        0xed,
        0xb9,
        0xda,
        0x5e,
        0x15,
        0x46,
        0x57,
        0xa7,
        0x8d,
        0x9d,
        0x84,
        0x90,
        0xd8,
        0xab,
        0x00,
        0x8c,
        0xbc,
        0xd3,
        0x0a,
        0xf7,
        0xe4,
        0x58,
        0x05,
        0xb8,
        0xb3,
        0x45,
        0x06,
        0xd0,
        0x2c,
        0x1e,
        0x8f,
        0xca,
        0x3f,
        0x0f,
        0x02,
        0xc1,
        0xaf,
        0xbd,
        0x03,
        0x01,
        0x13,
        0x8a,
        0x6b,
        0x3a,
        0x91,
        0x11,
        0x41,
        0x4f,
        0x67,
        0xdc,
        0xea,
        0x97,
        0xf2,
        0xcf,
        0xce,
        0xf0,
        0xb4,
        0xe6,
        0x73,
        0x96,
        0xac,
        0x74,
        0x22,
        0xe7,
        0xad,
        0x35,
        0x85,
        0xe2,
        0xf9,
        0x37,
        0xe8,
        0x1c,
        0x75,
        0xdf,
        0x6e,
        0x47,
        0xf1,
        0x1a,
        0x71,
        0x1d,
        0x29,
        0xc5,
        0x89,
        0x6f,
        0xb7,
        0x62,
        0x0e,
        0xaa,
        0x18,
        0xbe,
        0x1b,
        0xfc,
        0x56,
        0x3e,
        0x4b,
        0xc6,
        0xd2,
        0x79,
        0x20,
        0x9a,
        0xdb,
        0xc0,
        0xfe,
        0x78,
        0xcd,
        0x5a,
        0xf4,
        0x1f,
        0xdd,
        0xa8,
        0x33,
        0x88,
        0x07,
        0xc7,
        0x31,
        0xb1,
        0x12,
        0x10,
        0x59,
        0x27,
        0x80,
        0xec,
        0x5f,
        0x60,
        0x51,
        0x7f,
        0xa9,
        0x19,
        0xb5,
        0x4a,
        0x0d,
        0x2d,
        0xe5,
        0x7a,
        0x9f,
        0x93,
        0xc9,
        0x9c,
        0xef,
        0xa0,
        0xe0,
        0x3b,
        0x4d,
        0xae,
        0x2a,
        0xf5,
        0xb0,
        0xc8,
        0xeb,
        0xbb,
        0x3c,
        0x83,
        0x53,
        0x99,
        0x61,
        0x17,
        0x2b,
        0x04,
        0x7e,
        0xba,
        0x77,
        0xd6,
        0x26,
        0xe1,
        0x69,
        0x14,
        0x63,
        0x55,
        0x21,
        0x0c,
        0x7d
    ];
    // Transformations for encryption
    var T1 = [
        0xc66363a5,
        0xf87c7c84,
        0xee777799,
        0xf67b7b8d,
        0xfff2f20d,
        0xd66b6bbd,
        0xde6f6fb1,
        0x91c5c554,
        0x60303050,
        0x02010103,
        0xce6767a9,
        0x562b2b7d,
        0xe7fefe19,
        0xb5d7d762,
        0x4dababe6,
        0xec76769a,
        0x8fcaca45,
        0x1f82829d,
        0x89c9c940,
        0xfa7d7d87,
        0xeffafa15,
        0xb25959eb,
        0x8e4747c9,
        0xfbf0f00b,
        0x41adadec,
        0xb3d4d467,
        0x5fa2a2fd,
        0x45afafea,
        0x239c9cbf,
        0x53a4a4f7,
        0xe4727296,
        0x9bc0c05b,
        0x75b7b7c2,
        0xe1fdfd1c,
        0x3d9393ae,
        0x4c26266a,
        0x6c36365a,
        0x7e3f3f41,
        0xf5f7f702,
        0x83cccc4f,
        0x6834345c,
        0x51a5a5f4,
        0xd1e5e534,
        0xf9f1f108,
        0xe2717193,
        0xabd8d873,
        0x62313153,
        0x2a15153f,
        0x0804040c,
        0x95c7c752,
        0x46232365,
        0x9dc3c35e,
        0x30181828,
        0x379696a1,
        0x0a05050f,
        0x2f9a9ab5,
        0x0e070709,
        0x24121236,
        0x1b80809b,
        0xdfe2e23d,
        0xcdebeb26,
        0x4e272769,
        0x7fb2b2cd,
        0xea75759f,
        0x1209091b,
        0x1d83839e,
        0x582c2c74,
        0x341a1a2e,
        0x361b1b2d,
        0xdc6e6eb2,
        0xb45a5aee,
        0x5ba0a0fb,
        0xa45252f6,
        0x763b3b4d,
        0xb7d6d661,
        0x7db3b3ce,
        0x5229297b,
        0xdde3e33e,
        0x5e2f2f71,
        0x13848497,
        0xa65353f5,
        0xb9d1d168,
        0x00000000,
        0xc1eded2c,
        0x40202060,
        0xe3fcfc1f,
        0x79b1b1c8,
        0xb65b5bed,
        0xd46a6abe,
        0x8dcbcb46,
        0x67bebed9,
        0x7239394b,
        0x944a4ade,
        0x984c4cd4,
        0xb05858e8,
        0x85cfcf4a,
        0xbbd0d06b,
        0xc5efef2a,
        0x4faaaae5,
        0xedfbfb16,
        0x864343c5,
        0x9a4d4dd7,
        0x66333355,
        0x11858594,
        0x8a4545cf,
        0xe9f9f910,
        0x04020206,
        0xfe7f7f81,
        0xa05050f0,
        0x783c3c44,
        0x259f9fba,
        0x4ba8a8e3,
        0xa25151f3,
        0x5da3a3fe,
        0x804040c0,
        0x058f8f8a,
        0x3f9292ad,
        0x219d9dbc,
        0x70383848,
        0xf1f5f504,
        0x63bcbcdf,
        0x77b6b6c1,
        0xafdada75,
        0x42212163,
        0x20101030,
        0xe5ffff1a,
        0xfdf3f30e,
        0xbfd2d26d,
        0x81cdcd4c,
        0x180c0c14,
        0x26131335,
        0xc3ecec2f,
        0xbe5f5fe1,
        0x359797a2,
        0x884444cc,
        0x2e171739,
        0x93c4c457,
        0x55a7a7f2,
        0xfc7e7e82,
        0x7a3d3d47,
        0xc86464ac,
        0xba5d5de7,
        0x3219192b,
        0xe6737395,
        0xc06060a0,
        0x19818198,
        0x9e4f4fd1,
        0xa3dcdc7f,
        0x44222266,
        0x542a2a7e,
        0x3b9090ab,
        0x0b888883,
        0x8c4646ca,
        0xc7eeee29,
        0x6bb8b8d3,
        0x2814143c,
        0xa7dede79,
        0xbc5e5ee2,
        0x160b0b1d,
        0xaddbdb76,
        0xdbe0e03b,
        0x64323256,
        0x743a3a4e,
        0x140a0a1e,
        0x924949db,
        0x0c06060a,
        0x4824246c,
        0xb85c5ce4,
        0x9fc2c25d,
        0xbdd3d36e,
        0x43acacef,
        0xc46262a6,
        0x399191a8,
        0x319595a4,
        0xd3e4e437,
        0xf279798b,
        0xd5e7e732,
        0x8bc8c843,
        0x6e373759,
        0xda6d6db7,
        0x018d8d8c,
        0xb1d5d564,
        0x9c4e4ed2,
        0x49a9a9e0,
        0xd86c6cb4,
        0xac5656fa,
        0xf3f4f407,
        0xcfeaea25,
        0xca6565af,
        0xf47a7a8e,
        0x47aeaee9,
        0x10080818,
        0x6fbabad5,
        0xf0787888,
        0x4a25256f,
        0x5c2e2e72,
        0x381c1c24,
        0x57a6a6f1,
        0x73b4b4c7,
        0x97c6c651,
        0xcbe8e823,
        0xa1dddd7c,
        0xe874749c,
        0x3e1f1f21,
        0x964b4bdd,
        0x61bdbddc,
        0x0d8b8b86,
        0x0f8a8a85,
        0xe0707090,
        0x7c3e3e42,
        0x71b5b5c4,
        0xcc6666aa,
        0x904848d8,
        0x06030305,
        0xf7f6f601,
        0x1c0e0e12,
        0xc26161a3,
        0x6a35355f,
        0xae5757f9,
        0x69b9b9d0,
        0x17868691,
        0x99c1c158,
        0x3a1d1d27,
        0x279e9eb9,
        0xd9e1e138,
        0xebf8f813,
        0x2b9898b3,
        0x22111133,
        0xd26969bb,
        0xa9d9d970,
        0x078e8e89,
        0x339494a7,
        0x2d9b9bb6,
        0x3c1e1e22,
        0x15878792,
        0xc9e9e920,
        0x87cece49,
        0xaa5555ff,
        0x50282878,
        0xa5dfdf7a,
        0x038c8c8f,
        0x59a1a1f8,
        0x09898980,
        0x1a0d0d17,
        0x65bfbfda,
        0xd7e6e631,
        0x844242c6,
        0xd06868b8,
        0x824141c3,
        0x299999b0,
        0x5a2d2d77,
        0x1e0f0f11,
        0x7bb0b0cb,
        0xa85454fc,
        0x6dbbbbd6,
        0x2c16163a
    ];
    var T2 = [
        0xa5c66363,
        0x84f87c7c,
        0x99ee7777,
        0x8df67b7b,
        0x0dfff2f2,
        0xbdd66b6b,
        0xb1de6f6f,
        0x5491c5c5,
        0x50603030,
        0x03020101,
        0xa9ce6767,
        0x7d562b2b,
        0x19e7fefe,
        0x62b5d7d7,
        0xe64dabab,
        0x9aec7676,
        0x458fcaca,
        0x9d1f8282,
        0x4089c9c9,
        0x87fa7d7d,
        0x15effafa,
        0xebb25959,
        0xc98e4747,
        0x0bfbf0f0,
        0xec41adad,
        0x67b3d4d4,
        0xfd5fa2a2,
        0xea45afaf,
        0xbf239c9c,
        0xf753a4a4,
        0x96e47272,
        0x5b9bc0c0,
        0xc275b7b7,
        0x1ce1fdfd,
        0xae3d9393,
        0x6a4c2626,
        0x5a6c3636,
        0x417e3f3f,
        0x02f5f7f7,
        0x4f83cccc,
        0x5c683434,
        0xf451a5a5,
        0x34d1e5e5,
        0x08f9f1f1,
        0x93e27171,
        0x73abd8d8,
        0x53623131,
        0x3f2a1515,
        0x0c080404,
        0x5295c7c7,
        0x65462323,
        0x5e9dc3c3,
        0x28301818,
        0xa1379696,
        0x0f0a0505,
        0xb52f9a9a,
        0x090e0707,
        0x36241212,
        0x9b1b8080,
        0x3ddfe2e2,
        0x26cdebeb,
        0x694e2727,
        0xcd7fb2b2,
        0x9fea7575,
        0x1b120909,
        0x9e1d8383,
        0x74582c2c,
        0x2e341a1a,
        0x2d361b1b,
        0xb2dc6e6e,
        0xeeb45a5a,
        0xfb5ba0a0,
        0xf6a45252,
        0x4d763b3b,
        0x61b7d6d6,
        0xce7db3b3,
        0x7b522929,
        0x3edde3e3,
        0x715e2f2f,
        0x97138484,
        0xf5a65353,
        0x68b9d1d1,
        0x00000000,
        0x2cc1eded,
        0x60402020,
        0x1fe3fcfc,
        0xc879b1b1,
        0xedb65b5b,
        0xbed46a6a,
        0x468dcbcb,
        0xd967bebe,
        0x4b723939,
        0xde944a4a,
        0xd4984c4c,
        0xe8b05858,
        0x4a85cfcf,
        0x6bbbd0d0,
        0x2ac5efef,
        0xe54faaaa,
        0x16edfbfb,
        0xc5864343,
        0xd79a4d4d,
        0x55663333,
        0x94118585,
        0xcf8a4545,
        0x10e9f9f9,
        0x06040202,
        0x81fe7f7f,
        0xf0a05050,
        0x44783c3c,
        0xba259f9f,
        0xe34ba8a8,
        0xf3a25151,
        0xfe5da3a3,
        0xc0804040,
        0x8a058f8f,
        0xad3f9292,
        0xbc219d9d,
        0x48703838,
        0x04f1f5f5,
        0xdf63bcbc,
        0xc177b6b6,
        0x75afdada,
        0x63422121,
        0x30201010,
        0x1ae5ffff,
        0x0efdf3f3,
        0x6dbfd2d2,
        0x4c81cdcd,
        0x14180c0c,
        0x35261313,
        0x2fc3ecec,
        0xe1be5f5f,
        0xa2359797,
        0xcc884444,
        0x392e1717,
        0x5793c4c4,
        0xf255a7a7,
        0x82fc7e7e,
        0x477a3d3d,
        0xacc86464,
        0xe7ba5d5d,
        0x2b321919,
        0x95e67373,
        0xa0c06060,
        0x98198181,
        0xd19e4f4f,
        0x7fa3dcdc,
        0x66442222,
        0x7e542a2a,
        0xab3b9090,
        0x830b8888,
        0xca8c4646,
        0x29c7eeee,
        0xd36bb8b8,
        0x3c281414,
        0x79a7dede,
        0xe2bc5e5e,
        0x1d160b0b,
        0x76addbdb,
        0x3bdbe0e0,
        0x56643232,
        0x4e743a3a,
        0x1e140a0a,
        0xdb924949,
        0x0a0c0606,
        0x6c482424,
        0xe4b85c5c,
        0x5d9fc2c2,
        0x6ebdd3d3,
        0xef43acac,
        0xa6c46262,
        0xa8399191,
        0xa4319595,
        0x37d3e4e4,
        0x8bf27979,
        0x32d5e7e7,
        0x438bc8c8,
        0x596e3737,
        0xb7da6d6d,
        0x8c018d8d,
        0x64b1d5d5,
        0xd29c4e4e,
        0xe049a9a9,
        0xb4d86c6c,
        0xfaac5656,
        0x07f3f4f4,
        0x25cfeaea,
        0xafca6565,
        0x8ef47a7a,
        0xe947aeae,
        0x18100808,
        0xd56fbaba,
        0x88f07878,
        0x6f4a2525,
        0x725c2e2e,
        0x24381c1c,
        0xf157a6a6,
        0xc773b4b4,
        0x5197c6c6,
        0x23cbe8e8,
        0x7ca1dddd,
        0x9ce87474,
        0x213e1f1f,
        0xdd964b4b,
        0xdc61bdbd,
        0x860d8b8b,
        0x850f8a8a,
        0x90e07070,
        0x427c3e3e,
        0xc471b5b5,
        0xaacc6666,
        0xd8904848,
        0x05060303,
        0x01f7f6f6,
        0x121c0e0e,
        0xa3c26161,
        0x5f6a3535,
        0xf9ae5757,
        0xd069b9b9,
        0x91178686,
        0x5899c1c1,
        0x273a1d1d,
        0xb9279e9e,
        0x38d9e1e1,
        0x13ebf8f8,
        0xb32b9898,
        0x33221111,
        0xbbd26969,
        0x70a9d9d9,
        0x89078e8e,
        0xa7339494,
        0xb62d9b9b,
        0x223c1e1e,
        0x92158787,
        0x20c9e9e9,
        0x4987cece,
        0xffaa5555,
        0x78502828,
        0x7aa5dfdf,
        0x8f038c8c,
        0xf859a1a1,
        0x80098989,
        0x171a0d0d,
        0xda65bfbf,
        0x31d7e6e6,
        0xc6844242,
        0xb8d06868,
        0xc3824141,
        0xb0299999,
        0x775a2d2d,
        0x111e0f0f,
        0xcb7bb0b0,
        0xfca85454,
        0xd66dbbbb,
        0x3a2c1616
    ];
    var T3 = [
        0x63a5c663,
        0x7c84f87c,
        0x7799ee77,
        0x7b8df67b,
        0xf20dfff2,
        0x6bbdd66b,
        0x6fb1de6f,
        0xc55491c5,
        0x30506030,
        0x01030201,
        0x67a9ce67,
        0x2b7d562b,
        0xfe19e7fe,
        0xd762b5d7,
        0xabe64dab,
        0x769aec76,
        0xca458fca,
        0x829d1f82,
        0xc94089c9,
        0x7d87fa7d,
        0xfa15effa,
        0x59ebb259,
        0x47c98e47,
        0xf00bfbf0,
        0xadec41ad,
        0xd467b3d4,
        0xa2fd5fa2,
        0xafea45af,
        0x9cbf239c,
        0xa4f753a4,
        0x7296e472,
        0xc05b9bc0,
        0xb7c275b7,
        0xfd1ce1fd,
        0x93ae3d93,
        0x266a4c26,
        0x365a6c36,
        0x3f417e3f,
        0xf702f5f7,
        0xcc4f83cc,
        0x345c6834,
        0xa5f451a5,
        0xe534d1e5,
        0xf108f9f1,
        0x7193e271,
        0xd873abd8,
        0x31536231,
        0x153f2a15,
        0x040c0804,
        0xc75295c7,
        0x23654623,
        0xc35e9dc3,
        0x18283018,
        0x96a13796,
        0x050f0a05,
        0x9ab52f9a,
        0x07090e07,
        0x12362412,
        0x809b1b80,
        0xe23ddfe2,
        0xeb26cdeb,
        0x27694e27,
        0xb2cd7fb2,
        0x759fea75,
        0x091b1209,
        0x839e1d83,
        0x2c74582c,
        0x1a2e341a,
        0x1b2d361b,
        0x6eb2dc6e,
        0x5aeeb45a,
        0xa0fb5ba0,
        0x52f6a452,
        0x3b4d763b,
        0xd661b7d6,
        0xb3ce7db3,
        0x297b5229,
        0xe33edde3,
        0x2f715e2f,
        0x84971384,
        0x53f5a653,
        0xd168b9d1,
        0x00000000,
        0xed2cc1ed,
        0x20604020,
        0xfc1fe3fc,
        0xb1c879b1,
        0x5bedb65b,
        0x6abed46a,
        0xcb468dcb,
        0xbed967be,
        0x394b7239,
        0x4ade944a,
        0x4cd4984c,
        0x58e8b058,
        0xcf4a85cf,
        0xd06bbbd0,
        0xef2ac5ef,
        0xaae54faa,
        0xfb16edfb,
        0x43c58643,
        0x4dd79a4d,
        0x33556633,
        0x85941185,
        0x45cf8a45,
        0xf910e9f9,
        0x02060402,
        0x7f81fe7f,
        0x50f0a050,
        0x3c44783c,
        0x9fba259f,
        0xa8e34ba8,
        0x51f3a251,
        0xa3fe5da3,
        0x40c08040,
        0x8f8a058f,
        0x92ad3f92,
        0x9dbc219d,
        0x38487038,
        0xf504f1f5,
        0xbcdf63bc,
        0xb6c177b6,
        0xda75afda,
        0x21634221,
        0x10302010,
        0xff1ae5ff,
        0xf30efdf3,
        0xd26dbfd2,
        0xcd4c81cd,
        0x0c14180c,
        0x13352613,
        0xec2fc3ec,
        0x5fe1be5f,
        0x97a23597,
        0x44cc8844,
        0x17392e17,
        0xc45793c4,
        0xa7f255a7,
        0x7e82fc7e,
        0x3d477a3d,
        0x64acc864,
        0x5de7ba5d,
        0x192b3219,
        0x7395e673,
        0x60a0c060,
        0x81981981,
        0x4fd19e4f,
        0xdc7fa3dc,
        0x22664422,
        0x2a7e542a,
        0x90ab3b90,
        0x88830b88,
        0x46ca8c46,
        0xee29c7ee,
        0xb8d36bb8,
        0x143c2814,
        0xde79a7de,
        0x5ee2bc5e,
        0x0b1d160b,
        0xdb76addb,
        0xe03bdbe0,
        0x32566432,
        0x3a4e743a,
        0x0a1e140a,
        0x49db9249,
        0x060a0c06,
        0x246c4824,
        0x5ce4b85c,
        0xc25d9fc2,
        0xd36ebdd3,
        0xacef43ac,
        0x62a6c462,
        0x91a83991,
        0x95a43195,
        0xe437d3e4,
        0x798bf279,
        0xe732d5e7,
        0xc8438bc8,
        0x37596e37,
        0x6db7da6d,
        0x8d8c018d,
        0xd564b1d5,
        0x4ed29c4e,
        0xa9e049a9,
        0x6cb4d86c,
        0x56faac56,
        0xf407f3f4,
        0xea25cfea,
        0x65afca65,
        0x7a8ef47a,
        0xaee947ae,
        0x08181008,
        0xbad56fba,
        0x7888f078,
        0x256f4a25,
        0x2e725c2e,
        0x1c24381c,
        0xa6f157a6,
        0xb4c773b4,
        0xc65197c6,
        0xe823cbe8,
        0xdd7ca1dd,
        0x749ce874,
        0x1f213e1f,
        0x4bdd964b,
        0xbddc61bd,
        0x8b860d8b,
        0x8a850f8a,
        0x7090e070,
        0x3e427c3e,
        0xb5c471b5,
        0x66aacc66,
        0x48d89048,
        0x03050603,
        0xf601f7f6,
        0x0e121c0e,
        0x61a3c261,
        0x355f6a35,
        0x57f9ae57,
        0xb9d069b9,
        0x86911786,
        0xc15899c1,
        0x1d273a1d,
        0x9eb9279e,
        0xe138d9e1,
        0xf813ebf8,
        0x98b32b98,
        0x11332211,
        0x69bbd269,
        0xd970a9d9,
        0x8e89078e,
        0x94a73394,
        0x9bb62d9b,
        0x1e223c1e,
        0x87921587,
        0xe920c9e9,
        0xce4987ce,
        0x55ffaa55,
        0x28785028,
        0xdf7aa5df,
        0x8c8f038c,
        0xa1f859a1,
        0x89800989,
        0x0d171a0d,
        0xbfda65bf,
        0xe631d7e6,
        0x42c68442,
        0x68b8d068,
        0x41c38241,
        0x99b02999,
        0x2d775a2d,
        0x0f111e0f,
        0xb0cb7bb0,
        0x54fca854,
        0xbbd66dbb,
        0x163a2c16
    ];
    var T4 = [
        0x6363a5c6,
        0x7c7c84f8,
        0x777799ee,
        0x7b7b8df6,
        0xf2f20dff,
        0x6b6bbdd6,
        0x6f6fb1de,
        0xc5c55491,
        0x30305060,
        0x01010302,
        0x6767a9ce,
        0x2b2b7d56,
        0xfefe19e7,
        0xd7d762b5,
        0xababe64d,
        0x76769aec,
        0xcaca458f,
        0x82829d1f,
        0xc9c94089,
        0x7d7d87fa,
        0xfafa15ef,
        0x5959ebb2,
        0x4747c98e,
        0xf0f00bfb,
        0xadadec41,
        0xd4d467b3,
        0xa2a2fd5f,
        0xafafea45,
        0x9c9cbf23,
        0xa4a4f753,
        0x727296e4,
        0xc0c05b9b,
        0xb7b7c275,
        0xfdfd1ce1,
        0x9393ae3d,
        0x26266a4c,
        0x36365a6c,
        0x3f3f417e,
        0xf7f702f5,
        0xcccc4f83,
        0x34345c68,
        0xa5a5f451,
        0xe5e534d1,
        0xf1f108f9,
        0x717193e2,
        0xd8d873ab,
        0x31315362,
        0x15153f2a,
        0x04040c08,
        0xc7c75295,
        0x23236546,
        0xc3c35e9d,
        0x18182830,
        0x9696a137,
        0x05050f0a,
        0x9a9ab52f,
        0x0707090e,
        0x12123624,
        0x80809b1b,
        0xe2e23ddf,
        0xebeb26cd,
        0x2727694e,
        0xb2b2cd7f,
        0x75759fea,
        0x09091b12,
        0x83839e1d,
        0x2c2c7458,
        0x1a1a2e34,
        0x1b1b2d36,
        0x6e6eb2dc,
        0x5a5aeeb4,
        0xa0a0fb5b,
        0x5252f6a4,
        0x3b3b4d76,
        0xd6d661b7,
        0xb3b3ce7d,
        0x29297b52,
        0xe3e33edd,
        0x2f2f715e,
        0x84849713,
        0x5353f5a6,
        0xd1d168b9,
        0x00000000,
        0xeded2cc1,
        0x20206040,
        0xfcfc1fe3,
        0xb1b1c879,
        0x5b5bedb6,
        0x6a6abed4,
        0xcbcb468d,
        0xbebed967,
        0x39394b72,
        0x4a4ade94,
        0x4c4cd498,
        0x5858e8b0,
        0xcfcf4a85,
        0xd0d06bbb,
        0xefef2ac5,
        0xaaaae54f,
        0xfbfb16ed,
        0x4343c586,
        0x4d4dd79a,
        0x33335566,
        0x85859411,
        0x4545cf8a,
        0xf9f910e9,
        0x02020604,
        0x7f7f81fe,
        0x5050f0a0,
        0x3c3c4478,
        0x9f9fba25,
        0xa8a8e34b,
        0x5151f3a2,
        0xa3a3fe5d,
        0x4040c080,
        0x8f8f8a05,
        0x9292ad3f,
        0x9d9dbc21,
        0x38384870,
        0xf5f504f1,
        0xbcbcdf63,
        0xb6b6c177,
        0xdada75af,
        0x21216342,
        0x10103020,
        0xffff1ae5,
        0xf3f30efd,
        0xd2d26dbf,
        0xcdcd4c81,
        0x0c0c1418,
        0x13133526,
        0xecec2fc3,
        0x5f5fe1be,
        0x9797a235,
        0x4444cc88,
        0x1717392e,
        0xc4c45793,
        0xa7a7f255,
        0x7e7e82fc,
        0x3d3d477a,
        0x6464acc8,
        0x5d5de7ba,
        0x19192b32,
        0x737395e6,
        0x6060a0c0,
        0x81819819,
        0x4f4fd19e,
        0xdcdc7fa3,
        0x22226644,
        0x2a2a7e54,
        0x9090ab3b,
        0x8888830b,
        0x4646ca8c,
        0xeeee29c7,
        0xb8b8d36b,
        0x14143c28,
        0xdede79a7,
        0x5e5ee2bc,
        0x0b0b1d16,
        0xdbdb76ad,
        0xe0e03bdb,
        0x32325664,
        0x3a3a4e74,
        0x0a0a1e14,
        0x4949db92,
        0x06060a0c,
        0x24246c48,
        0x5c5ce4b8,
        0xc2c25d9f,
        0xd3d36ebd,
        0xacacef43,
        0x6262a6c4,
        0x9191a839,
        0x9595a431,
        0xe4e437d3,
        0x79798bf2,
        0xe7e732d5,
        0xc8c8438b,
        0x3737596e,
        0x6d6db7da,
        0x8d8d8c01,
        0xd5d564b1,
        0x4e4ed29c,
        0xa9a9e049,
        0x6c6cb4d8,
        0x5656faac,
        0xf4f407f3,
        0xeaea25cf,
        0x6565afca,
        0x7a7a8ef4,
        0xaeaee947,
        0x08081810,
        0xbabad56f,
        0x787888f0,
        0x25256f4a,
        0x2e2e725c,
        0x1c1c2438,
        0xa6a6f157,
        0xb4b4c773,
        0xc6c65197,
        0xe8e823cb,
        0xdddd7ca1,
        0x74749ce8,
        0x1f1f213e,
        0x4b4bdd96,
        0xbdbddc61,
        0x8b8b860d,
        0x8a8a850f,
        0x707090e0,
        0x3e3e427c,
        0xb5b5c471,
        0x6666aacc,
        0x4848d890,
        0x03030506,
        0xf6f601f7,
        0x0e0e121c,
        0x6161a3c2,
        0x35355f6a,
        0x5757f9ae,
        0xb9b9d069,
        0x86869117,
        0xc1c15899,
        0x1d1d273a,
        0x9e9eb927,
        0xe1e138d9,
        0xf8f813eb,
        0x9898b32b,
        0x11113322,
        0x6969bbd2,
        0xd9d970a9,
        0x8e8e8907,
        0x9494a733,
        0x9b9bb62d,
        0x1e1e223c,
        0x87879215,
        0xe9e920c9,
        0xcece4987,
        0x5555ffaa,
        0x28287850,
        0xdfdf7aa5,
        0x8c8c8f03,
        0xa1a1f859,
        0x89898009,
        0x0d0d171a,
        0xbfbfda65,
        0xe6e631d7,
        0x4242c684,
        0x6868b8d0,
        0x4141c382,
        0x9999b029,
        0x2d2d775a,
        0x0f0f111e,
        0xb0b0cb7b,
        0x5454fca8,
        0xbbbbd66d,
        0x16163a2c
    ];
    // Transformations for decryption
    var T5 = [
        0x51f4a750,
        0x7e416553,
        0x1a17a4c3,
        0x3a275e96,
        0x3bab6bcb,
        0x1f9d45f1,
        0xacfa58ab,
        0x4be30393,
        0x2030fa55,
        0xad766df6,
        0x88cc7691,
        0xf5024c25,
        0x4fe5d7fc,
        0xc52acbd7,
        0x26354480,
        0xb562a38f,
        0xdeb15a49,
        0x25ba1b67,
        0x45ea0e98,
        0x5dfec0e1,
        0xc32f7502,
        0x814cf012,
        0x8d4697a3,
        0x6bd3f9c6,
        0x038f5fe7,
        0x15929c95,
        0xbf6d7aeb,
        0x955259da,
        0xd4be832d,
        0x587421d3,
        0x49e06929,
        0x8ec9c844,
        0x75c2896a,
        0xf48e7978,
        0x99583e6b,
        0x27b971dd,
        0xbee14fb6,
        0xf088ad17,
        0xc920ac66,
        0x7dce3ab4,
        0x63df4a18,
        0xe51a3182,
        0x97513360,
        0x62537f45,
        0xb16477e0,
        0xbb6bae84,
        0xfe81a01c,
        0xf9082b94,
        0x70486858,
        0x8f45fd19,
        0x94de6c87,
        0x527bf8b7,
        0xab73d323,
        0x724b02e2,
        0xe31f8f57,
        0x6655ab2a,
        0xb2eb2807,
        0x2fb5c203,
        0x86c57b9a,
        0xd33708a5,
        0x302887f2,
        0x23bfa5b2,
        0x02036aba,
        0xed16825c,
        0x8acf1c2b,
        0xa779b492,
        0xf307f2f0,
        0x4e69e2a1,
        0x65daf4cd,
        0x0605bed5,
        0xd134621f,
        0xc4a6fe8a,
        0x342e539d,
        0xa2f355a0,
        0x058ae132,
        0xa4f6eb75,
        0x0b83ec39,
        0x4060efaa,
        0x5e719f06,
        0xbd6e1051,
        0x3e218af9,
        0x96dd063d,
        0xdd3e05ae,
        0x4de6bd46,
        0x91548db5,
        0x71c45d05,
        0x0406d46f,
        0x605015ff,
        0x1998fb24,
        0xd6bde997,
        0x894043cc,
        0x67d99e77,
        0xb0e842bd,
        0x07898b88,
        0xe7195b38,
        0x79c8eedb,
        0xa17c0a47,
        0x7c420fe9,
        0xf8841ec9,
        0x00000000,
        0x09808683,
        0x322bed48,
        0x1e1170ac,
        0x6c5a724e,
        0xfd0efffb,
        0x0f853856,
        0x3daed51e,
        0x362d3927,
        0x0a0fd964,
        0x685ca621,
        0x9b5b54d1,
        0x24362e3a,
        0x0c0a67b1,
        0x9357e70f,
        0xb4ee96d2,
        0x1b9b919e,
        0x80c0c54f,
        0x61dc20a2,
        0x5a774b69,
        0x1c121a16,
        0xe293ba0a,
        0xc0a02ae5,
        0x3c22e043,
        0x121b171d,
        0x0e090d0b,
        0xf28bc7ad,
        0x2db6a8b9,
        0x141ea9c8,
        0x57f11985,
        0xaf75074c,
        0xee99ddbb,
        0xa37f60fd,
        0xf701269f,
        0x5c72f5bc,
        0x44663bc5,
        0x5bfb7e34,
        0x8b432976,
        0xcb23c6dc,
        0xb6edfc68,
        0xb8e4f163,
        0xd731dcca,
        0x42638510,
        0x13972240,
        0x84c61120,
        0x854a247d,
        0xd2bb3df8,
        0xaef93211,
        0xc729a16d,
        0x1d9e2f4b,
        0xdcb230f3,
        0x0d8652ec,
        0x77c1e3d0,
        0x2bb3166c,
        0xa970b999,
        0x119448fa,
        0x47e96422,
        0xa8fc8cc4,
        0xa0f03f1a,
        0x567d2cd8,
        0x223390ef,
        0x87494ec7,
        0xd938d1c1,
        0x8ccaa2fe,
        0x98d40b36,
        0xa6f581cf,
        0xa57ade28,
        0xdab78e26,
        0x3fadbfa4,
        0x2c3a9de4,
        0x5078920d,
        0x6a5fcc9b,
        0x547e4662,
        0xf68d13c2,
        0x90d8b8e8,
        0x2e39f75e,
        0x82c3aff5,
        0x9f5d80be,
        0x69d0937c,
        0x6fd52da9,
        0xcf2512b3,
        0xc8ac993b,
        0x10187da7,
        0xe89c636e,
        0xdb3bbb7b,
        0xcd267809,
        0x6e5918f4,
        0xec9ab701,
        0x834f9aa8,
        0xe6956e65,
        0xaaffe67e,
        0x21bccf08,
        0xef15e8e6,
        0xbae79bd9,
        0x4a6f36ce,
        0xea9f09d4,
        0x29b07cd6,
        0x31a4b2af,
        0x2a3f2331,
        0xc6a59430,
        0x35a266c0,
        0x744ebc37,
        0xfc82caa6,
        0xe090d0b0,
        0x33a7d815,
        0xf104984a,
        0x41ecdaf7,
        0x7fcd500e,
        0x1791f62f,
        0x764dd68d,
        0x43efb04d,
        0xccaa4d54,
        0xe49604df,
        0x9ed1b5e3,
        0x4c6a881b,
        0xc12c1fb8,
        0x4665517f,
        0x9d5eea04,
        0x018c355d,
        0xfa877473,
        0xfb0b412e,
        0xb3671d5a,
        0x92dbd252,
        0xe9105633,
        0x6dd64713,
        0x9ad7618c,
        0x37a10c7a,
        0x59f8148e,
        0xeb133c89,
        0xcea927ee,
        0xb761c935,
        0xe11ce5ed,
        0x7a47b13c,
        0x9cd2df59,
        0x55f2733f,
        0x1814ce79,
        0x73c737bf,
        0x53f7cdea,
        0x5ffdaa5b,
        0xdf3d6f14,
        0x7844db86,
        0xcaaff381,
        0xb968c43e,
        0x3824342c,
        0xc2a3405f,
        0x161dc372,
        0xbce2250c,
        0x283c498b,
        0xff0d9541,
        0x39a80171,
        0x080cb3de,
        0xd8b4e49c,
        0x6456c190,
        0x7bcb8461,
        0xd532b670,
        0x486c5c74,
        0xd0b85742
    ];
    var T6 = [
        0x5051f4a7,
        0x537e4165,
        0xc31a17a4,
        0x963a275e,
        0xcb3bab6b,
        0xf11f9d45,
        0xabacfa58,
        0x934be303,
        0x552030fa,
        0xf6ad766d,
        0x9188cc76,
        0x25f5024c,
        0xfc4fe5d7,
        0xd7c52acb,
        0x80263544,
        0x8fb562a3,
        0x49deb15a,
        0x6725ba1b,
        0x9845ea0e,
        0xe15dfec0,
        0x02c32f75,
        0x12814cf0,
        0xa38d4697,
        0xc66bd3f9,
        0xe7038f5f,
        0x9515929c,
        0xebbf6d7a,
        0xda955259,
        0x2dd4be83,
        0xd3587421,
        0x2949e069,
        0x448ec9c8,
        0x6a75c289,
        0x78f48e79,
        0x6b99583e,
        0xdd27b971,
        0xb6bee14f,
        0x17f088ad,
        0x66c920ac,
        0xb47dce3a,
        0x1863df4a,
        0x82e51a31,
        0x60975133,
        0x4562537f,
        0xe0b16477,
        0x84bb6bae,
        0x1cfe81a0,
        0x94f9082b,
        0x58704868,
        0x198f45fd,
        0x8794de6c,
        0xb7527bf8,
        0x23ab73d3,
        0xe2724b02,
        0x57e31f8f,
        0x2a6655ab,
        0x07b2eb28,
        0x032fb5c2,
        0x9a86c57b,
        0xa5d33708,
        0xf2302887,
        0xb223bfa5,
        0xba02036a,
        0x5ced1682,
        0x2b8acf1c,
        0x92a779b4,
        0xf0f307f2,
        0xa14e69e2,
        0xcd65daf4,
        0xd50605be,
        0x1fd13462,
        0x8ac4a6fe,
        0x9d342e53,
        0xa0a2f355,
        0x32058ae1,
        0x75a4f6eb,
        0x390b83ec,
        0xaa4060ef,
        0x065e719f,
        0x51bd6e10,
        0xf93e218a,
        0x3d96dd06,
        0xaedd3e05,
        0x464de6bd,
        0xb591548d,
        0x0571c45d,
        0x6f0406d4,
        0xff605015,
        0x241998fb,
        0x97d6bde9,
        0xcc894043,
        0x7767d99e,
        0xbdb0e842,
        0x8807898b,
        0x38e7195b,
        0xdb79c8ee,
        0x47a17c0a,
        0xe97c420f,
        0xc9f8841e,
        0x00000000,
        0x83098086,
        0x48322bed,
        0xac1e1170,
        0x4e6c5a72,
        0xfbfd0eff,
        0x560f8538,
        0x1e3daed5,
        0x27362d39,
        0x640a0fd9,
        0x21685ca6,
        0xd19b5b54,
        0x3a24362e,
        0xb10c0a67,
        0x0f9357e7,
        0xd2b4ee96,
        0x9e1b9b91,
        0x4f80c0c5,
        0xa261dc20,
        0x695a774b,
        0x161c121a,
        0x0ae293ba,
        0xe5c0a02a,
        0x433c22e0,
        0x1d121b17,
        0x0b0e090d,
        0xadf28bc7,
        0xb92db6a8,
        0xc8141ea9,
        0x8557f119,
        0x4caf7507,
        0xbbee99dd,
        0xfda37f60,
        0x9ff70126,
        0xbc5c72f5,
        0xc544663b,
        0x345bfb7e,
        0x768b4329,
        0xdccb23c6,
        0x68b6edfc,
        0x63b8e4f1,
        0xcad731dc,
        0x10426385,
        0x40139722,
        0x2084c611,
        0x7d854a24,
        0xf8d2bb3d,
        0x11aef932,
        0x6dc729a1,
        0x4b1d9e2f,
        0xf3dcb230,
        0xec0d8652,
        0xd077c1e3,
        0x6c2bb316,
        0x99a970b9,
        0xfa119448,
        0x2247e964,
        0xc4a8fc8c,
        0x1aa0f03f,
        0xd8567d2c,
        0xef223390,
        0xc787494e,
        0xc1d938d1,
        0xfe8ccaa2,
        0x3698d40b,
        0xcfa6f581,
        0x28a57ade,
        0x26dab78e,
        0xa43fadbf,
        0xe42c3a9d,
        0x0d507892,
        0x9b6a5fcc,
        0x62547e46,
        0xc2f68d13,
        0xe890d8b8,
        0x5e2e39f7,
        0xf582c3af,
        0xbe9f5d80,
        0x7c69d093,
        0xa96fd52d,
        0xb3cf2512,
        0x3bc8ac99,
        0xa710187d,
        0x6ee89c63,
        0x7bdb3bbb,
        0x09cd2678,
        0xf46e5918,
        0x01ec9ab7,
        0xa8834f9a,
        0x65e6956e,
        0x7eaaffe6,
        0x0821bccf,
        0xe6ef15e8,
        0xd9bae79b,
        0xce4a6f36,
        0xd4ea9f09,
        0xd629b07c,
        0xaf31a4b2,
        0x312a3f23,
        0x30c6a594,
        0xc035a266,
        0x37744ebc,
        0xa6fc82ca,
        0xb0e090d0,
        0x1533a7d8,
        0x4af10498,
        0xf741ecda,
        0x0e7fcd50,
        0x2f1791f6,
        0x8d764dd6,
        0x4d43efb0,
        0x54ccaa4d,
        0xdfe49604,
        0xe39ed1b5,
        0x1b4c6a88,
        0xb8c12c1f,
        0x7f466551,
        0x049d5eea,
        0x5d018c35,
        0x73fa8774,
        0x2efb0b41,
        0x5ab3671d,
        0x5292dbd2,
        0x33e91056,
        0x136dd647,
        0x8c9ad761,
        0x7a37a10c,
        0x8e59f814,
        0x89eb133c,
        0xeecea927,
        0x35b761c9,
        0xede11ce5,
        0x3c7a47b1,
        0x599cd2df,
        0x3f55f273,
        0x791814ce,
        0xbf73c737,
        0xea53f7cd,
        0x5b5ffdaa,
        0x14df3d6f,
        0x867844db,
        0x81caaff3,
        0x3eb968c4,
        0x2c382434,
        0x5fc2a340,
        0x72161dc3,
        0x0cbce225,
        0x8b283c49,
        0x41ff0d95,
        0x7139a801,
        0xde080cb3,
        0x9cd8b4e4,
        0x906456c1,
        0x617bcb84,
        0x70d532b6,
        0x74486c5c,
        0x42d0b857
    ];
    var T7 = [
        0xa75051f4,
        0x65537e41,
        0xa4c31a17,
        0x5e963a27,
        0x6bcb3bab,
        0x45f11f9d,
        0x58abacfa,
        0x03934be3,
        0xfa552030,
        0x6df6ad76,
        0x769188cc,
        0x4c25f502,
        0xd7fc4fe5,
        0xcbd7c52a,
        0x44802635,
        0xa38fb562,
        0x5a49deb1,
        0x1b6725ba,
        0x0e9845ea,
        0xc0e15dfe,
        0x7502c32f,
        0xf012814c,
        0x97a38d46,
        0xf9c66bd3,
        0x5fe7038f,
        0x9c951592,
        0x7aebbf6d,
        0x59da9552,
        0x832dd4be,
        0x21d35874,
        0x692949e0,
        0xc8448ec9,
        0x896a75c2,
        0x7978f48e,
        0x3e6b9958,
        0x71dd27b9,
        0x4fb6bee1,
        0xad17f088,
        0xac66c920,
        0x3ab47dce,
        0x4a1863df,
        0x3182e51a,
        0x33609751,
        0x7f456253,
        0x77e0b164,
        0xae84bb6b,
        0xa01cfe81,
        0x2b94f908,
        0x68587048,
        0xfd198f45,
        0x6c8794de,
        0xf8b7527b,
        0xd323ab73,
        0x02e2724b,
        0x8f57e31f,
        0xab2a6655,
        0x2807b2eb,
        0xc2032fb5,
        0x7b9a86c5,
        0x08a5d337,
        0x87f23028,
        0xa5b223bf,
        0x6aba0203,
        0x825ced16,
        0x1c2b8acf,
        0xb492a779,
        0xf2f0f307,
        0xe2a14e69,
        0xf4cd65da,
        0xbed50605,
        0x621fd134,
        0xfe8ac4a6,
        0x539d342e,
        0x55a0a2f3,
        0xe132058a,
        0xeb75a4f6,
        0xec390b83,
        0xefaa4060,
        0x9f065e71,
        0x1051bd6e,
        0x8af93e21,
        0x063d96dd,
        0x05aedd3e,
        0xbd464de6,
        0x8db59154,
        0x5d0571c4,
        0xd46f0406,
        0x15ff6050,
        0xfb241998,
        0xe997d6bd,
        0x43cc8940,
        0x9e7767d9,
        0x42bdb0e8,
        0x8b880789,
        0x5b38e719,
        0xeedb79c8,
        0x0a47a17c,
        0x0fe97c42,
        0x1ec9f884,
        0x00000000,
        0x86830980,
        0xed48322b,
        0x70ac1e11,
        0x724e6c5a,
        0xfffbfd0e,
        0x38560f85,
        0xd51e3dae,
        0x3927362d,
        0xd9640a0f,
        0xa621685c,
        0x54d19b5b,
        0x2e3a2436,
        0x67b10c0a,
        0xe70f9357,
        0x96d2b4ee,
        0x919e1b9b,
        0xc54f80c0,
        0x20a261dc,
        0x4b695a77,
        0x1a161c12,
        0xba0ae293,
        0x2ae5c0a0,
        0xe0433c22,
        0x171d121b,
        0x0d0b0e09,
        0xc7adf28b,
        0xa8b92db6,
        0xa9c8141e,
        0x198557f1,
        0x074caf75,
        0xddbbee99,
        0x60fda37f,
        0x269ff701,
        0xf5bc5c72,
        0x3bc54466,
        0x7e345bfb,
        0x29768b43,
        0xc6dccb23,
        0xfc68b6ed,
        0xf163b8e4,
        0xdccad731,
        0x85104263,
        0x22401397,
        0x112084c6,
        0x247d854a,
        0x3df8d2bb,
        0x3211aef9,
        0xa16dc729,
        0x2f4b1d9e,
        0x30f3dcb2,
        0x52ec0d86,
        0xe3d077c1,
        0x166c2bb3,
        0xb999a970,
        0x48fa1194,
        0x642247e9,
        0x8cc4a8fc,
        0x3f1aa0f0,
        0x2cd8567d,
        0x90ef2233,
        0x4ec78749,
        0xd1c1d938,
        0xa2fe8cca,
        0x0b3698d4,
        0x81cfa6f5,
        0xde28a57a,
        0x8e26dab7,
        0xbfa43fad,
        0x9de42c3a,
        0x920d5078,
        0xcc9b6a5f,
        0x4662547e,
        0x13c2f68d,
        0xb8e890d8,
        0xf75e2e39,
        0xaff582c3,
        0x80be9f5d,
        0x937c69d0,
        0x2da96fd5,
        0x12b3cf25,
        0x993bc8ac,
        0x7da71018,
        0x636ee89c,
        0xbb7bdb3b,
        0x7809cd26,
        0x18f46e59,
        0xb701ec9a,
        0x9aa8834f,
        0x6e65e695,
        0xe67eaaff,
        0xcf0821bc,
        0xe8e6ef15,
        0x9bd9bae7,
        0x36ce4a6f,
        0x09d4ea9f,
        0x7cd629b0,
        0xb2af31a4,
        0x23312a3f,
        0x9430c6a5,
        0x66c035a2,
        0xbc37744e,
        0xcaa6fc82,
        0xd0b0e090,
        0xd81533a7,
        0x984af104,
        0xdaf741ec,
        0x500e7fcd,
        0xf62f1791,
        0xd68d764d,
        0xb04d43ef,
        0x4d54ccaa,
        0x04dfe496,
        0xb5e39ed1,
        0x881b4c6a,
        0x1fb8c12c,
        0x517f4665,
        0xea049d5e,
        0x355d018c,
        0x7473fa87,
        0x412efb0b,
        0x1d5ab367,
        0xd25292db,
        0x5633e910,
        0x47136dd6,
        0x618c9ad7,
        0x0c7a37a1,
        0x148e59f8,
        0x3c89eb13,
        0x27eecea9,
        0xc935b761,
        0xe5ede11c,
        0xb13c7a47,
        0xdf599cd2,
        0x733f55f2,
        0xce791814,
        0x37bf73c7,
        0xcdea53f7,
        0xaa5b5ffd,
        0x6f14df3d,
        0xdb867844,
        0xf381caaf,
        0xc43eb968,
        0x342c3824,
        0x405fc2a3,
        0xc372161d,
        0x250cbce2,
        0x498b283c,
        0x9541ff0d,
        0x017139a8,
        0xb3de080c,
        0xe49cd8b4,
        0xc1906456,
        0x84617bcb,
        0xb670d532,
        0x5c74486c,
        0x5742d0b8
    ];
    var T8 = [
        0xf4a75051,
        0x4165537e,
        0x17a4c31a,
        0x275e963a,
        0xab6bcb3b,
        0x9d45f11f,
        0xfa58abac,
        0xe303934b,
        0x30fa5520,
        0x766df6ad,
        0xcc769188,
        0x024c25f5,
        0xe5d7fc4f,
        0x2acbd7c5,
        0x35448026,
        0x62a38fb5,
        0xb15a49de,
        0xba1b6725,
        0xea0e9845,
        0xfec0e15d,
        0x2f7502c3,
        0x4cf01281,
        0x4697a38d,
        0xd3f9c66b,
        0x8f5fe703,
        0x929c9515,
        0x6d7aebbf,
        0x5259da95,
        0xbe832dd4,
        0x7421d358,
        0xe0692949,
        0xc9c8448e,
        0xc2896a75,
        0x8e7978f4,
        0x583e6b99,
        0xb971dd27,
        0xe14fb6be,
        0x88ad17f0,
        0x20ac66c9,
        0xce3ab47d,
        0xdf4a1863,
        0x1a3182e5,
        0x51336097,
        0x537f4562,
        0x6477e0b1,
        0x6bae84bb,
        0x81a01cfe,
        0x082b94f9,
        0x48685870,
        0x45fd198f,
        0xde6c8794,
        0x7bf8b752,
        0x73d323ab,
        0x4b02e272,
        0x1f8f57e3,
        0x55ab2a66,
        0xeb2807b2,
        0xb5c2032f,
        0xc57b9a86,
        0x3708a5d3,
        0x2887f230,
        0xbfa5b223,
        0x036aba02,
        0x16825ced,
        0xcf1c2b8a,
        0x79b492a7,
        0x07f2f0f3,
        0x69e2a14e,
        0xdaf4cd65,
        0x05bed506,
        0x34621fd1,
        0xa6fe8ac4,
        0x2e539d34,
        0xf355a0a2,
        0x8ae13205,
        0xf6eb75a4,
        0x83ec390b,
        0x60efaa40,
        0x719f065e,
        0x6e1051bd,
        0x218af93e,
        0xdd063d96,
        0x3e05aedd,
        0xe6bd464d,
        0x548db591,
        0xc45d0571,
        0x06d46f04,
        0x5015ff60,
        0x98fb2419,
        0xbde997d6,
        0x4043cc89,
        0xd99e7767,
        0xe842bdb0,
        0x898b8807,
        0x195b38e7,
        0xc8eedb79,
        0x7c0a47a1,
        0x420fe97c,
        0x841ec9f8,
        0x00000000,
        0x80868309,
        0x2bed4832,
        0x1170ac1e,
        0x5a724e6c,
        0x0efffbfd,
        0x8538560f,
        0xaed51e3d,
        0x2d392736,
        0x0fd9640a,
        0x5ca62168,
        0x5b54d19b,
        0x362e3a24,
        0x0a67b10c,
        0x57e70f93,
        0xee96d2b4,
        0x9b919e1b,
        0xc0c54f80,
        0xdc20a261,
        0x774b695a,
        0x121a161c,
        0x93ba0ae2,
        0xa02ae5c0,
        0x22e0433c,
        0x1b171d12,
        0x090d0b0e,
        0x8bc7adf2,
        0xb6a8b92d,
        0x1ea9c814,
        0xf1198557,
        0x75074caf,
        0x99ddbbee,
        0x7f60fda3,
        0x01269ff7,
        0x72f5bc5c,
        0x663bc544,
        0xfb7e345b,
        0x4329768b,
        0x23c6dccb,
        0xedfc68b6,
        0xe4f163b8,
        0x31dccad7,
        0x63851042,
        0x97224013,
        0xc6112084,
        0x4a247d85,
        0xbb3df8d2,
        0xf93211ae,
        0x29a16dc7,
        0x9e2f4b1d,
        0xb230f3dc,
        0x8652ec0d,
        0xc1e3d077,
        0xb3166c2b,
        0x70b999a9,
        0x9448fa11,
        0xe9642247,
        0xfc8cc4a8,
        0xf03f1aa0,
        0x7d2cd856,
        0x3390ef22,
        0x494ec787,
        0x38d1c1d9,
        0xcaa2fe8c,
        0xd40b3698,
        0xf581cfa6,
        0x7ade28a5,
        0xb78e26da,
        0xadbfa43f,
        0x3a9de42c,
        0x78920d50,
        0x5fcc9b6a,
        0x7e466254,
        0x8d13c2f6,
        0xd8b8e890,
        0x39f75e2e,
        0xc3aff582,
        0x5d80be9f,
        0xd0937c69,
        0xd52da96f,
        0x2512b3cf,
        0xac993bc8,
        0x187da710,
        0x9c636ee8,
        0x3bbb7bdb,
        0x267809cd,
        0x5918f46e,
        0x9ab701ec,
        0x4f9aa883,
        0x956e65e6,
        0xffe67eaa,
        0xbccf0821,
        0x15e8e6ef,
        0xe79bd9ba,
        0x6f36ce4a,
        0x9f09d4ea,
        0xb07cd629,
        0xa4b2af31,
        0x3f23312a,
        0xa59430c6,
        0xa266c035,
        0x4ebc3774,
        0x82caa6fc,
        0x90d0b0e0,
        0xa7d81533,
        0x04984af1,
        0xecdaf741,
        0xcd500e7f,
        0x91f62f17,
        0x4dd68d76,
        0xefb04d43,
        0xaa4d54cc,
        0x9604dfe4,
        0xd1b5e39e,
        0x6a881b4c,
        0x2c1fb8c1,
        0x65517f46,
        0x5eea049d,
        0x8c355d01,
        0x877473fa,
        0x0b412efb,
        0x671d5ab3,
        0xdbd25292,
        0x105633e9,
        0xd647136d,
        0xd7618c9a,
        0xa10c7a37,
        0xf8148e59,
        0x133c89eb,
        0xa927eece,
        0x61c935b7,
        0x1ce5ede1,
        0x47b13c7a,
        0xd2df599c,
        0xf2733f55,
        0x14ce7918,
        0xc737bf73,
        0xf7cdea53,
        0xfdaa5b5f,
        0x3d6f14df,
        0x44db8678,
        0xaff381ca,
        0x68c43eb9,
        0x24342c38,
        0xa3405fc2,
        0x1dc37216,
        0xe2250cbc,
        0x3c498b28,
        0x0d9541ff,
        0xa8017139,
        0x0cb3de08,
        0xb4e49cd8,
        0x56c19064,
        0xcb84617b,
        0x32b670d5,
        0x6c5c7448,
        0xb85742d0
    ];
    // Transformations for decryption key expansion
    var U1 = [
        0x00000000,
        0x0e090d0b,
        0x1c121a16,
        0x121b171d,
        0x3824342c,
        0x362d3927,
        0x24362e3a,
        0x2a3f2331,
        0x70486858,
        0x7e416553,
        0x6c5a724e,
        0x62537f45,
        0x486c5c74,
        0x4665517f,
        0x547e4662,
        0x5a774b69,
        0xe090d0b0,
        0xee99ddbb,
        0xfc82caa6,
        0xf28bc7ad,
        0xd8b4e49c,
        0xd6bde997,
        0xc4a6fe8a,
        0xcaaff381,
        0x90d8b8e8,
        0x9ed1b5e3,
        0x8ccaa2fe,
        0x82c3aff5,
        0xa8fc8cc4,
        0xa6f581cf,
        0xb4ee96d2,
        0xbae79bd9,
        0xdb3bbb7b,
        0xd532b670,
        0xc729a16d,
        0xc920ac66,
        0xe31f8f57,
        0xed16825c,
        0xff0d9541,
        0xf104984a,
        0xab73d323,
        0xa57ade28,
        0xb761c935,
        0xb968c43e,
        0x9357e70f,
        0x9d5eea04,
        0x8f45fd19,
        0x814cf012,
        0x3bab6bcb,
        0x35a266c0,
        0x27b971dd,
        0x29b07cd6,
        0x038f5fe7,
        0x0d8652ec,
        0x1f9d45f1,
        0x119448fa,
        0x4be30393,
        0x45ea0e98,
        0x57f11985,
        0x59f8148e,
        0x73c737bf,
        0x7dce3ab4,
        0x6fd52da9,
        0x61dc20a2,
        0xad766df6,
        0xa37f60fd,
        0xb16477e0,
        0xbf6d7aeb,
        0x955259da,
        0x9b5b54d1,
        0x894043cc,
        0x87494ec7,
        0xdd3e05ae,
        0xd33708a5,
        0xc12c1fb8,
        0xcf2512b3,
        0xe51a3182,
        0xeb133c89,
        0xf9082b94,
        0xf701269f,
        0x4de6bd46,
        0x43efb04d,
        0x51f4a750,
        0x5ffdaa5b,
        0x75c2896a,
        0x7bcb8461,
        0x69d0937c,
        0x67d99e77,
        0x3daed51e,
        0x33a7d815,
        0x21bccf08,
        0x2fb5c203,
        0x058ae132,
        0x0b83ec39,
        0x1998fb24,
        0x1791f62f,
        0x764dd68d,
        0x7844db86,
        0x6a5fcc9b,
        0x6456c190,
        0x4e69e2a1,
        0x4060efaa,
        0x527bf8b7,
        0x5c72f5bc,
        0x0605bed5,
        0x080cb3de,
        0x1a17a4c3,
        0x141ea9c8,
        0x3e218af9,
        0x302887f2,
        0x223390ef,
        0x2c3a9de4,
        0x96dd063d,
        0x98d40b36,
        0x8acf1c2b,
        0x84c61120,
        0xaef93211,
        0xa0f03f1a,
        0xb2eb2807,
        0xbce2250c,
        0xe6956e65,
        0xe89c636e,
        0xfa877473,
        0xf48e7978,
        0xdeb15a49,
        0xd0b85742,
        0xc2a3405f,
        0xccaa4d54,
        0x41ecdaf7,
        0x4fe5d7fc,
        0x5dfec0e1,
        0x53f7cdea,
        0x79c8eedb,
        0x77c1e3d0,
        0x65daf4cd,
        0x6bd3f9c6,
        0x31a4b2af,
        0x3fadbfa4,
        0x2db6a8b9,
        0x23bfa5b2,
        0x09808683,
        0x07898b88,
        0x15929c95,
        0x1b9b919e,
        0xa17c0a47,
        0xaf75074c,
        0xbd6e1051,
        0xb3671d5a,
        0x99583e6b,
        0x97513360,
        0x854a247d,
        0x8b432976,
        0xd134621f,
        0xdf3d6f14,
        0xcd267809,
        0xc32f7502,
        0xe9105633,
        0xe7195b38,
        0xf5024c25,
        0xfb0b412e,
        0x9ad7618c,
        0x94de6c87,
        0x86c57b9a,
        0x88cc7691,
        0xa2f355a0,
        0xacfa58ab,
        0xbee14fb6,
        0xb0e842bd,
        0xea9f09d4,
        0xe49604df,
        0xf68d13c2,
        0xf8841ec9,
        0xd2bb3df8,
        0xdcb230f3,
        0xcea927ee,
        0xc0a02ae5,
        0x7a47b13c,
        0x744ebc37,
        0x6655ab2a,
        0x685ca621,
        0x42638510,
        0x4c6a881b,
        0x5e719f06,
        0x5078920d,
        0x0a0fd964,
        0x0406d46f,
        0x161dc372,
        0x1814ce79,
        0x322bed48,
        0x3c22e043,
        0x2e39f75e,
        0x2030fa55,
        0xec9ab701,
        0xe293ba0a,
        0xf088ad17,
        0xfe81a01c,
        0xd4be832d,
        0xdab78e26,
        0xc8ac993b,
        0xc6a59430,
        0x9cd2df59,
        0x92dbd252,
        0x80c0c54f,
        0x8ec9c844,
        0xa4f6eb75,
        0xaaffe67e,
        0xb8e4f163,
        0xb6edfc68,
        0x0c0a67b1,
        0x02036aba,
        0x10187da7,
        0x1e1170ac,
        0x342e539d,
        0x3a275e96,
        0x283c498b,
        0x26354480,
        0x7c420fe9,
        0x724b02e2,
        0x605015ff,
        0x6e5918f4,
        0x44663bc5,
        0x4a6f36ce,
        0x587421d3,
        0x567d2cd8,
        0x37a10c7a,
        0x39a80171,
        0x2bb3166c,
        0x25ba1b67,
        0x0f853856,
        0x018c355d,
        0x13972240,
        0x1d9e2f4b,
        0x47e96422,
        0x49e06929,
        0x5bfb7e34,
        0x55f2733f,
        0x7fcd500e,
        0x71c45d05,
        0x63df4a18,
        0x6dd64713,
        0xd731dcca,
        0xd938d1c1,
        0xcb23c6dc,
        0xc52acbd7,
        0xef15e8e6,
        0xe11ce5ed,
        0xf307f2f0,
        0xfd0efffb,
        0xa779b492,
        0xa970b999,
        0xbb6bae84,
        0xb562a38f,
        0x9f5d80be,
        0x91548db5,
        0x834f9aa8,
        0x8d4697a3
    ];
    var U2 = [
        0x00000000,
        0x0b0e090d,
        0x161c121a,
        0x1d121b17,
        0x2c382434,
        0x27362d39,
        0x3a24362e,
        0x312a3f23,
        0x58704868,
        0x537e4165,
        0x4e6c5a72,
        0x4562537f,
        0x74486c5c,
        0x7f466551,
        0x62547e46,
        0x695a774b,
        0xb0e090d0,
        0xbbee99dd,
        0xa6fc82ca,
        0xadf28bc7,
        0x9cd8b4e4,
        0x97d6bde9,
        0x8ac4a6fe,
        0x81caaff3,
        0xe890d8b8,
        0xe39ed1b5,
        0xfe8ccaa2,
        0xf582c3af,
        0xc4a8fc8c,
        0xcfa6f581,
        0xd2b4ee96,
        0xd9bae79b,
        0x7bdb3bbb,
        0x70d532b6,
        0x6dc729a1,
        0x66c920ac,
        0x57e31f8f,
        0x5ced1682,
        0x41ff0d95,
        0x4af10498,
        0x23ab73d3,
        0x28a57ade,
        0x35b761c9,
        0x3eb968c4,
        0x0f9357e7,
        0x049d5eea,
        0x198f45fd,
        0x12814cf0,
        0xcb3bab6b,
        0xc035a266,
        0xdd27b971,
        0xd629b07c,
        0xe7038f5f,
        0xec0d8652,
        0xf11f9d45,
        0xfa119448,
        0x934be303,
        0x9845ea0e,
        0x8557f119,
        0x8e59f814,
        0xbf73c737,
        0xb47dce3a,
        0xa96fd52d,
        0xa261dc20,
        0xf6ad766d,
        0xfda37f60,
        0xe0b16477,
        0xebbf6d7a,
        0xda955259,
        0xd19b5b54,
        0xcc894043,
        0xc787494e,
        0xaedd3e05,
        0xa5d33708,
        0xb8c12c1f,
        0xb3cf2512,
        0x82e51a31,
        0x89eb133c,
        0x94f9082b,
        0x9ff70126,
        0x464de6bd,
        0x4d43efb0,
        0x5051f4a7,
        0x5b5ffdaa,
        0x6a75c289,
        0x617bcb84,
        0x7c69d093,
        0x7767d99e,
        0x1e3daed5,
        0x1533a7d8,
        0x0821bccf,
        0x032fb5c2,
        0x32058ae1,
        0x390b83ec,
        0x241998fb,
        0x2f1791f6,
        0x8d764dd6,
        0x867844db,
        0x9b6a5fcc,
        0x906456c1,
        0xa14e69e2,
        0xaa4060ef,
        0xb7527bf8,
        0xbc5c72f5,
        0xd50605be,
        0xde080cb3,
        0xc31a17a4,
        0xc8141ea9,
        0xf93e218a,
        0xf2302887,
        0xef223390,
        0xe42c3a9d,
        0x3d96dd06,
        0x3698d40b,
        0x2b8acf1c,
        0x2084c611,
        0x11aef932,
        0x1aa0f03f,
        0x07b2eb28,
        0x0cbce225,
        0x65e6956e,
        0x6ee89c63,
        0x73fa8774,
        0x78f48e79,
        0x49deb15a,
        0x42d0b857,
        0x5fc2a340,
        0x54ccaa4d,
        0xf741ecda,
        0xfc4fe5d7,
        0xe15dfec0,
        0xea53f7cd,
        0xdb79c8ee,
        0xd077c1e3,
        0xcd65daf4,
        0xc66bd3f9,
        0xaf31a4b2,
        0xa43fadbf,
        0xb92db6a8,
        0xb223bfa5,
        0x83098086,
        0x8807898b,
        0x9515929c,
        0x9e1b9b91,
        0x47a17c0a,
        0x4caf7507,
        0x51bd6e10,
        0x5ab3671d,
        0x6b99583e,
        0x60975133,
        0x7d854a24,
        0x768b4329,
        0x1fd13462,
        0x14df3d6f,
        0x09cd2678,
        0x02c32f75,
        0x33e91056,
        0x38e7195b,
        0x25f5024c,
        0x2efb0b41,
        0x8c9ad761,
        0x8794de6c,
        0x9a86c57b,
        0x9188cc76,
        0xa0a2f355,
        0xabacfa58,
        0xb6bee14f,
        0xbdb0e842,
        0xd4ea9f09,
        0xdfe49604,
        0xc2f68d13,
        0xc9f8841e,
        0xf8d2bb3d,
        0xf3dcb230,
        0xeecea927,
        0xe5c0a02a,
        0x3c7a47b1,
        0x37744ebc,
        0x2a6655ab,
        0x21685ca6,
        0x10426385,
        0x1b4c6a88,
        0x065e719f,
        0x0d507892,
        0x640a0fd9,
        0x6f0406d4,
        0x72161dc3,
        0x791814ce,
        0x48322bed,
        0x433c22e0,
        0x5e2e39f7,
        0x552030fa,
        0x01ec9ab7,
        0x0ae293ba,
        0x17f088ad,
        0x1cfe81a0,
        0x2dd4be83,
        0x26dab78e,
        0x3bc8ac99,
        0x30c6a594,
        0x599cd2df,
        0x5292dbd2,
        0x4f80c0c5,
        0x448ec9c8,
        0x75a4f6eb,
        0x7eaaffe6,
        0x63b8e4f1,
        0x68b6edfc,
        0xb10c0a67,
        0xba02036a,
        0xa710187d,
        0xac1e1170,
        0x9d342e53,
        0x963a275e,
        0x8b283c49,
        0x80263544,
        0xe97c420f,
        0xe2724b02,
        0xff605015,
        0xf46e5918,
        0xc544663b,
        0xce4a6f36,
        0xd3587421,
        0xd8567d2c,
        0x7a37a10c,
        0x7139a801,
        0x6c2bb316,
        0x6725ba1b,
        0x560f8538,
        0x5d018c35,
        0x40139722,
        0x4b1d9e2f,
        0x2247e964,
        0x2949e069,
        0x345bfb7e,
        0x3f55f273,
        0x0e7fcd50,
        0x0571c45d,
        0x1863df4a,
        0x136dd647,
        0xcad731dc,
        0xc1d938d1,
        0xdccb23c6,
        0xd7c52acb,
        0xe6ef15e8,
        0xede11ce5,
        0xf0f307f2,
        0xfbfd0eff,
        0x92a779b4,
        0x99a970b9,
        0x84bb6bae,
        0x8fb562a3,
        0xbe9f5d80,
        0xb591548d,
        0xa8834f9a,
        0xa38d4697
    ];
    var U3 = [
        0x00000000,
        0x0d0b0e09,
        0x1a161c12,
        0x171d121b,
        0x342c3824,
        0x3927362d,
        0x2e3a2436,
        0x23312a3f,
        0x68587048,
        0x65537e41,
        0x724e6c5a,
        0x7f456253,
        0x5c74486c,
        0x517f4665,
        0x4662547e,
        0x4b695a77,
        0xd0b0e090,
        0xddbbee99,
        0xcaa6fc82,
        0xc7adf28b,
        0xe49cd8b4,
        0xe997d6bd,
        0xfe8ac4a6,
        0xf381caaf,
        0xb8e890d8,
        0xb5e39ed1,
        0xa2fe8cca,
        0xaff582c3,
        0x8cc4a8fc,
        0x81cfa6f5,
        0x96d2b4ee,
        0x9bd9bae7,
        0xbb7bdb3b,
        0xb670d532,
        0xa16dc729,
        0xac66c920,
        0x8f57e31f,
        0x825ced16,
        0x9541ff0d,
        0x984af104,
        0xd323ab73,
        0xde28a57a,
        0xc935b761,
        0xc43eb968,
        0xe70f9357,
        0xea049d5e,
        0xfd198f45,
        0xf012814c,
        0x6bcb3bab,
        0x66c035a2,
        0x71dd27b9,
        0x7cd629b0,
        0x5fe7038f,
        0x52ec0d86,
        0x45f11f9d,
        0x48fa1194,
        0x03934be3,
        0x0e9845ea,
        0x198557f1,
        0x148e59f8,
        0x37bf73c7,
        0x3ab47dce,
        0x2da96fd5,
        0x20a261dc,
        0x6df6ad76,
        0x60fda37f,
        0x77e0b164,
        0x7aebbf6d,
        0x59da9552,
        0x54d19b5b,
        0x43cc8940,
        0x4ec78749,
        0x05aedd3e,
        0x08a5d337,
        0x1fb8c12c,
        0x12b3cf25,
        0x3182e51a,
        0x3c89eb13,
        0x2b94f908,
        0x269ff701,
        0xbd464de6,
        0xb04d43ef,
        0xa75051f4,
        0xaa5b5ffd,
        0x896a75c2,
        0x84617bcb,
        0x937c69d0,
        0x9e7767d9,
        0xd51e3dae,
        0xd81533a7,
        0xcf0821bc,
        0xc2032fb5,
        0xe132058a,
        0xec390b83,
        0xfb241998,
        0xf62f1791,
        0xd68d764d,
        0xdb867844,
        0xcc9b6a5f,
        0xc1906456,
        0xe2a14e69,
        0xefaa4060,
        0xf8b7527b,
        0xf5bc5c72,
        0xbed50605,
        0xb3de080c,
        0xa4c31a17,
        0xa9c8141e,
        0x8af93e21,
        0x87f23028,
        0x90ef2233,
        0x9de42c3a,
        0x063d96dd,
        0x0b3698d4,
        0x1c2b8acf,
        0x112084c6,
        0x3211aef9,
        0x3f1aa0f0,
        0x2807b2eb,
        0x250cbce2,
        0x6e65e695,
        0x636ee89c,
        0x7473fa87,
        0x7978f48e,
        0x5a49deb1,
        0x5742d0b8,
        0x405fc2a3,
        0x4d54ccaa,
        0xdaf741ec,
        0xd7fc4fe5,
        0xc0e15dfe,
        0xcdea53f7,
        0xeedb79c8,
        0xe3d077c1,
        0xf4cd65da,
        0xf9c66bd3,
        0xb2af31a4,
        0xbfa43fad,
        0xa8b92db6,
        0xa5b223bf,
        0x86830980,
        0x8b880789,
        0x9c951592,
        0x919e1b9b,
        0x0a47a17c,
        0x074caf75,
        0x1051bd6e,
        0x1d5ab367,
        0x3e6b9958,
        0x33609751,
        0x247d854a,
        0x29768b43,
        0x621fd134,
        0x6f14df3d,
        0x7809cd26,
        0x7502c32f,
        0x5633e910,
        0x5b38e719,
        0x4c25f502,
        0x412efb0b,
        0x618c9ad7,
        0x6c8794de,
        0x7b9a86c5,
        0x769188cc,
        0x55a0a2f3,
        0x58abacfa,
        0x4fb6bee1,
        0x42bdb0e8,
        0x09d4ea9f,
        0x04dfe496,
        0x13c2f68d,
        0x1ec9f884,
        0x3df8d2bb,
        0x30f3dcb2,
        0x27eecea9,
        0x2ae5c0a0,
        0xb13c7a47,
        0xbc37744e,
        0xab2a6655,
        0xa621685c,
        0x85104263,
        0x881b4c6a,
        0x9f065e71,
        0x920d5078,
        0xd9640a0f,
        0xd46f0406,
        0xc372161d,
        0xce791814,
        0xed48322b,
        0xe0433c22,
        0xf75e2e39,
        0xfa552030,
        0xb701ec9a,
        0xba0ae293,
        0xad17f088,
        0xa01cfe81,
        0x832dd4be,
        0x8e26dab7,
        0x993bc8ac,
        0x9430c6a5,
        0xdf599cd2,
        0xd25292db,
        0xc54f80c0,
        0xc8448ec9,
        0xeb75a4f6,
        0xe67eaaff,
        0xf163b8e4,
        0xfc68b6ed,
        0x67b10c0a,
        0x6aba0203,
        0x7da71018,
        0x70ac1e11,
        0x539d342e,
        0x5e963a27,
        0x498b283c,
        0x44802635,
        0x0fe97c42,
        0x02e2724b,
        0x15ff6050,
        0x18f46e59,
        0x3bc54466,
        0x36ce4a6f,
        0x21d35874,
        0x2cd8567d,
        0x0c7a37a1,
        0x017139a8,
        0x166c2bb3,
        0x1b6725ba,
        0x38560f85,
        0x355d018c,
        0x22401397,
        0x2f4b1d9e,
        0x642247e9,
        0x692949e0,
        0x7e345bfb,
        0x733f55f2,
        0x500e7fcd,
        0x5d0571c4,
        0x4a1863df,
        0x47136dd6,
        0xdccad731,
        0xd1c1d938,
        0xc6dccb23,
        0xcbd7c52a,
        0xe8e6ef15,
        0xe5ede11c,
        0xf2f0f307,
        0xfffbfd0e,
        0xb492a779,
        0xb999a970,
        0xae84bb6b,
        0xa38fb562,
        0x80be9f5d,
        0x8db59154,
        0x9aa8834f,
        0x97a38d46
    ];
    var U4 = [
        0x00000000,
        0x090d0b0e,
        0x121a161c,
        0x1b171d12,
        0x24342c38,
        0x2d392736,
        0x362e3a24,
        0x3f23312a,
        0x48685870,
        0x4165537e,
        0x5a724e6c,
        0x537f4562,
        0x6c5c7448,
        0x65517f46,
        0x7e466254,
        0x774b695a,
        0x90d0b0e0,
        0x99ddbbee,
        0x82caa6fc,
        0x8bc7adf2,
        0xb4e49cd8,
        0xbde997d6,
        0xa6fe8ac4,
        0xaff381ca,
        0xd8b8e890,
        0xd1b5e39e,
        0xcaa2fe8c,
        0xc3aff582,
        0xfc8cc4a8,
        0xf581cfa6,
        0xee96d2b4,
        0xe79bd9ba,
        0x3bbb7bdb,
        0x32b670d5,
        0x29a16dc7,
        0x20ac66c9,
        0x1f8f57e3,
        0x16825ced,
        0x0d9541ff,
        0x04984af1,
        0x73d323ab,
        0x7ade28a5,
        0x61c935b7,
        0x68c43eb9,
        0x57e70f93,
        0x5eea049d,
        0x45fd198f,
        0x4cf01281,
        0xab6bcb3b,
        0xa266c035,
        0xb971dd27,
        0xb07cd629,
        0x8f5fe703,
        0x8652ec0d,
        0x9d45f11f,
        0x9448fa11,
        0xe303934b,
        0xea0e9845,
        0xf1198557,
        0xf8148e59,
        0xc737bf73,
        0xce3ab47d,
        0xd52da96f,
        0xdc20a261,
        0x766df6ad,
        0x7f60fda3,
        0x6477e0b1,
        0x6d7aebbf,
        0x5259da95,
        0x5b54d19b,
        0x4043cc89,
        0x494ec787,
        0x3e05aedd,
        0x3708a5d3,
        0x2c1fb8c1,
        0x2512b3cf,
        0x1a3182e5,
        0x133c89eb,
        0x082b94f9,
        0x01269ff7,
        0xe6bd464d,
        0xefb04d43,
        0xf4a75051,
        0xfdaa5b5f,
        0xc2896a75,
        0xcb84617b,
        0xd0937c69,
        0xd99e7767,
        0xaed51e3d,
        0xa7d81533,
        0xbccf0821,
        0xb5c2032f,
        0x8ae13205,
        0x83ec390b,
        0x98fb2419,
        0x91f62f17,
        0x4dd68d76,
        0x44db8678,
        0x5fcc9b6a,
        0x56c19064,
        0x69e2a14e,
        0x60efaa40,
        0x7bf8b752,
        0x72f5bc5c,
        0x05bed506,
        0x0cb3de08,
        0x17a4c31a,
        0x1ea9c814,
        0x218af93e,
        0x2887f230,
        0x3390ef22,
        0x3a9de42c,
        0xdd063d96,
        0xd40b3698,
        0xcf1c2b8a,
        0xc6112084,
        0xf93211ae,
        0xf03f1aa0,
        0xeb2807b2,
        0xe2250cbc,
        0x956e65e6,
        0x9c636ee8,
        0x877473fa,
        0x8e7978f4,
        0xb15a49de,
        0xb85742d0,
        0xa3405fc2,
        0xaa4d54cc,
        0xecdaf741,
        0xe5d7fc4f,
        0xfec0e15d,
        0xf7cdea53,
        0xc8eedb79,
        0xc1e3d077,
        0xdaf4cd65,
        0xd3f9c66b,
        0xa4b2af31,
        0xadbfa43f,
        0xb6a8b92d,
        0xbfa5b223,
        0x80868309,
        0x898b8807,
        0x929c9515,
        0x9b919e1b,
        0x7c0a47a1,
        0x75074caf,
        0x6e1051bd,
        0x671d5ab3,
        0x583e6b99,
        0x51336097,
        0x4a247d85,
        0x4329768b,
        0x34621fd1,
        0x3d6f14df,
        0x267809cd,
        0x2f7502c3,
        0x105633e9,
        0x195b38e7,
        0x024c25f5,
        0x0b412efb,
        0xd7618c9a,
        0xde6c8794,
        0xc57b9a86,
        0xcc769188,
        0xf355a0a2,
        0xfa58abac,
        0xe14fb6be,
        0xe842bdb0,
        0x9f09d4ea,
        0x9604dfe4,
        0x8d13c2f6,
        0x841ec9f8,
        0xbb3df8d2,
        0xb230f3dc,
        0xa927eece,
        0xa02ae5c0,
        0x47b13c7a,
        0x4ebc3774,
        0x55ab2a66,
        0x5ca62168,
        0x63851042,
        0x6a881b4c,
        0x719f065e,
        0x78920d50,
        0x0fd9640a,
        0x06d46f04,
        0x1dc37216,
        0x14ce7918,
        0x2bed4832,
        0x22e0433c,
        0x39f75e2e,
        0x30fa5520,
        0x9ab701ec,
        0x93ba0ae2,
        0x88ad17f0,
        0x81a01cfe,
        0xbe832dd4,
        0xb78e26da,
        0xac993bc8,
        0xa59430c6,
        0xd2df599c,
        0xdbd25292,
        0xc0c54f80,
        0xc9c8448e,
        0xf6eb75a4,
        0xffe67eaa,
        0xe4f163b8,
        0xedfc68b6,
        0x0a67b10c,
        0x036aba02,
        0x187da710,
        0x1170ac1e,
        0x2e539d34,
        0x275e963a,
        0x3c498b28,
        0x35448026,
        0x420fe97c,
        0x4b02e272,
        0x5015ff60,
        0x5918f46e,
        0x663bc544,
        0x6f36ce4a,
        0x7421d358,
        0x7d2cd856,
        0xa10c7a37,
        0xa8017139,
        0xb3166c2b,
        0xba1b6725,
        0x8538560f,
        0x8c355d01,
        0x97224013,
        0x9e2f4b1d,
        0xe9642247,
        0xe0692949,
        0xfb7e345b,
        0xf2733f55,
        0xcd500e7f,
        0xc45d0571,
        0xdf4a1863,
        0xd647136d,
        0x31dccad7,
        0x38d1c1d9,
        0x23c6dccb,
        0x2acbd7c5,
        0x15e8e6ef,
        0x1ce5ede1,
        0x07f2f0f3,
        0x0efffbfd,
        0x79b492a7,
        0x70b999a9,
        0x6bae84bb,
        0x62a38fb5,
        0x5d80be9f,
        0x548db591,
        0x4f9aa883,
        0x4697a38d
    ];
    function convertToInt32(bytes) {
        var result = [];
        for(var i = 0; i < bytes.length; i += 4)result.push(bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]);
        return result;
    }
    var AES = function AES1(key) {
        if (!(this instanceof AES)) throw Error("AES must be instanitated with `new`");
        Object.defineProperty(this, "key", {
            value: coerceArray(key, true)
        });
        this._prepare();
    };
    AES.prototype._prepare = function() {
        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
        // encryption round keys
        this._Ke = [];
        // decryption round keys
        this._Kd = [];
        for(var i = 0; i <= rounds; i++){
            this._Ke.push([
                0,
                0,
                0,
                0
            ]);
            this._Kd.push([
                0,
                0,
                0,
                0
            ]);
        }
        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;
        // convert the key into ints
        var tk = convertToInt32(this.key);
        // copy values into round key arrays
        var index;
        for(var i = 0; i < KC; i++){
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }
        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while(t < roundKeyCount){
            tt = tk[KC - 1];
            tk[0] ^= S[tt >> 16 & 0xFF] << 24 ^ S[tt >> 8 & 0xFF] << 16 ^ S[tt & 0xFF] << 8 ^ S[tt >> 24 & 0xFF] ^ rcon[rconpointer] << 24;
            rconpointer += 1;
            // key expansion (for non-256 bit)
            if (KC != 8) for(var i = 1; i < KC; i++)tk[i] ^= tk[i - 1];
            else {
                for(var i = 1; i < KC / 2; i++)tk[i] ^= tk[i - 1];
                tt = tk[KC / 2 - 1];
                tk[KC / 2] ^= S[tt & 0xFF] ^ S[tt >> 8 & 0xFF] << 8 ^ S[tt >> 16 & 0xFF] << 16 ^ S[tt >> 24 & 0xFF] << 24;
                for(var i = KC / 2 + 1; i < KC; i++)tk[i] ^= tk[i - 1];
            }
            // copy values into round key arrays
            var i = 0, r, c;
            while(i < KC && t < roundKeyCount){
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }
        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for(var r = 1; r < rounds; r++)for(var c = 0; c < 4; c++){
            tt = this._Kd[r][c];
            this._Kd[r][c] = U1[tt >> 24 & 0xFF] ^ U2[tt >> 16 & 0xFF] ^ U3[tt >> 8 & 0xFF] ^ U4[tt & 0xFF];
        }
    };
    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) throw new Error("invalid plaintext size (must be 16 bytes)");
        var rounds = this._Ke.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Ke[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T1[t[i] >> 24 & 0xff] ^ T2[t[(i + 1) % 4] >> 16 & 0xff] ^ T3[t[(i + 2) % 4] >> 8 & 0xff] ^ T4[t[(i + 3) % 4] & 0xff] ^ this._Ke[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Ke[rounds][i];
            result[4 * i] = (S[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (S[t[(i + 1) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (S[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (S[t[(i + 3) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) throw new Error("invalid ciphertext size (must be 16 bytes)");
        var rounds = this._Kd.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Kd[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T5[t[i] >> 24 & 0xff] ^ T6[t[(i + 3) % 4] >> 16 & 0xff] ^ T7[t[(i + 2) % 4] >> 8 & 0xff] ^ T8[t[(i + 1) % 4] & 0xff] ^ this._Kd[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Kd[rounds][i];
            result[4 * i] = (Si[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (Si[t[(i + 3) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (Si[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (Si[t[(i + 1) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */ var ModeOfOperationECB = function ModeOfOperationECB1(key) {
        if (!(this instanceof ModeOfOperationECB)) throw Error("AES must be instanitated with `new`");
        this.description = "Electronic Code Block";
        this.name = "ecb";
        this._aes = new AES(key);
    };
    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */ var ModeOfOperationCBC = function ModeOfOperationCBC1(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Block Chaining";
        this.name = "cbc";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastCipherblock = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            for(var j = 0; j < 16; j++)block[j] ^= this._lastCipherblock[j];
            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            for(var j = 0; j < 16; j++)plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */ var ModeOfOperationCFB = function ModeOfOperationCFB1(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Feedback";
        this.name = "cfb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 size)");
        if (!segmentSize) segmentSize = 1;
        this.segmentSize = segmentSize;
        this._shiftRegister = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if (plaintext.length % this.segmentSize != 0) throw new Error("invalid plaintext size (must be segmentSize bytes)");
        var encrypted = coerceArray(plaintext, true);
        var xorSegment;
        for(var i = 0; i < encrypted.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)encrypted[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return encrypted;
    };
    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length % this.segmentSize != 0) throw new Error("invalid ciphertext size (must be segmentSize bytes)");
        var plaintext = coerceArray(ciphertext, true);
        var xorSegment;
        for(var i = 0; i < plaintext.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)plaintext[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */ var ModeOfOperationOFB = function ModeOfOperationOFB1(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Output Feedback";
        this.name = "ofb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;
    /**
     *  Counter object for CTR common mode of operation
     */ var Counter = function Counter1(initialValue) {
        if (!(this instanceof Counter)) throw Error("Counter must be instanitated with `new`");
        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) initialValue = 1;
        if (typeof initialValue === "number") {
            this._counter = createArray(16);
            this.setValue(initialValue);
        } else this.setBytes(initialValue);
    };
    Counter.prototype.setValue = function(value) {
        if (typeof value !== "number" || parseInt(value) != value) throw new Error("invalid counter value (must be an integer)");
        for(var index = 15; index >= 0; --index){
            this._counter[index] = value % 256;
            value = value >> 8;
        }
    };
    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);
        if (bytes.length != 16) throw new Error("invalid counter bytes size (must be 16 bytes)");
        this._counter = bytes;
    };
    Counter.prototype.increment = function() {
        for(var i = 15; i >= 0; i--)if (this._counter[i] === 255) this._counter[i] = 0;
        else {
            this._counter[i]++;
            break;
        }
    };
    /**
     *  Mode Of Operation - Counter (CTR)
     */ var ModeOfOperationCTR = function ModeOfOperationCTR1(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) throw Error("AES must be instanitated with `new`");
        this.description = "Counter";
        this.name = "ctr";
        if (!(counter instanceof Counter)) counter = new Counter(counter);
        this._counter = counter;
        this._remainingCounter = null;
        this._remainingCounterIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;
    ///////////////////////
    // Padding
    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - data.length % 16;
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for(var i = data.length; i < result.length; i++)result[i] = padder;
        return result;
    }
    function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) throw new Error("PKCS#7 invalid length");
        var padder = data[data.length - 1];
        if (padder > 16) throw new Error("PKCS#7 padding byte out of range");
        var length = data.length - padder;
        for(var i = 0; i < padder; i++){
            if (data[length + i] !== padder) throw new Error("PKCS#7 invalid padding byte");
        }
        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    }
    ///////////////////////
    // Exporting
    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,
        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },
        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },
        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },
        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray
        }
    };
    module.exports = aesjs;
})(module.exports);

});

parcelRegister("7gF0P", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $015d93fce2670e19$export$83d89fbfd8236492; });
var $015d93fce2670e19$export$83d89fbfd8236492 = "json-wallets/5.5.0";

});

parcelRegister("7CcUS", function(module, exports) {

$parcel$export(module.exports, "looseArrayify", function () { return $58b619ec17091ff2$export$2cde08bde0cfd932; });
$parcel$export(module.exports, "zpad", function () { return $58b619ec17091ff2$export$67752b99d3bc61c6; });
$parcel$export(module.exports, "getPassword", function () { return $58b619ec17091ff2$export$350bd33120f7413e; });
$parcel$export(module.exports, "searchPath", function () { return $58b619ec17091ff2$export$5a5c1dbd910e2c32; });
$parcel$export(module.exports, "uuidV4", function () { return $58b619ec17091ff2$export$ec7b18ebad55a3a9; });

var $2tHqU = parcelRequire("2tHqU");

var $5RaVA = parcelRequire("5RaVA");
"use strict";
function $58b619ec17091ff2$export$2cde08bde0cfd932(hexString) {
    if (typeof hexString === "string" && hexString.substring(0, 2) !== "0x") hexString = "0x" + hexString;
    return (0, $2tHqU.arrayify)(hexString);
}
function $58b619ec17091ff2$export$67752b99d3bc61c6(value, length) {
    value = String(value);
    while(value.length < length)value = "0" + value;
    return value;
}
function $58b619ec17091ff2$export$350bd33120f7413e(password) {
    if (typeof password === "string") return (0, $5RaVA.toUtf8Bytes)(password, (0, $5RaVA.UnicodeNormalizationForm).NFKC);
    return (0, $2tHqU.arrayify)(password);
}
function $58b619ec17091ff2$export$5a5c1dbd910e2c32(object, path) {
    var currentChild = object;
    var comps = path.toLowerCase().split("/");
    for(var i = 0; i < comps.length; i++){
        // Search for a child object with a case-insensitive matching key
        var matchingChild = null;
        for(var key in currentChild)if (key.toLowerCase() === comps[i]) {
            matchingChild = currentChild[key];
            break;
        }
        // Didn't find one. :'(
        if (matchingChild === null) return null;
        // Now check this child...
        currentChild = matchingChild;
    }
    return currentChild;
}
function $58b619ec17091ff2$export$ec7b18ebad55a3a9(randomBytes) {
    var bytes = (0, $2tHqU.arrayify)(randomBytes);
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = bytes[6] & 0x0f | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = bytes[8] & 0x3f | 0x80;
    var value = (0, $2tHqU.hexlify)(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34)
    ].join("-");
}

});


parcelRegister("awZzE", function(module, exports) {

$parcel$export(module.exports, "isCrowdsaleWallet", function () { return $7aaca7def31ade42$export$724d6cf6b9fd8578; });
$parcel$export(module.exports, "isKeystoreWallet", function () { return $7aaca7def31ade42$export$67dc926b8e68b2d8; });
$parcel$export(module.exports, "getJsonWalletAddress", function () { return $7aaca7def31ade42$export$9a68ee9f8f3afd38; });

var $hFSWi = parcelRequire("hFSWi");
"use strict";
function $7aaca7def31ade42$export$724d6cf6b9fd8578(json) {
    var data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    return data.encseed && data.ethaddr;
}
function $7aaca7def31ade42$export$67dc926b8e68b2d8(json) {
    var data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    if (!data.version || parseInt(data.version) !== data.version || parseInt(data.version) !== 3) return false;
    // @TODO: Put more checks to make sure it has kdf, iv and all that good stuff
    return true;
}
function $7aaca7def31ade42$export$9a68ee9f8f3afd38(json) {
    if ($7aaca7def31ade42$export$724d6cf6b9fd8578(json)) try {
        return (0, $hFSWi.getAddress)(JSON.parse(json).ethaddr);
    } catch (error) {
        return null;
    }
    if ($7aaca7def31ade42$export$67dc926b8e68b2d8(json)) try {
        return (0, $hFSWi.getAddress)(JSON.parse(json).address);
    } catch (error) {
        return null;
    }
    return null;
}

});

parcelRegister("eEEnh", function(module, exports) {

$parcel$export(module.exports, "decryptSync", function () { return $aab41ea35a812794$export$9bd2c37889ee5e36; });
$parcel$export(module.exports, "decrypt", function () { return $aab41ea35a812794$export$e85a0c9a1067c5d3; });
$parcel$export(module.exports, "encrypt", function () { return $aab41ea35a812794$export$5b0f6292f11d1d18; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");

var $bVtKz = parcelRequire("bVtKz");

var $c1a2N = parcelRequire("c1a2N");

var $hFSWi = parcelRequire("hFSWi");

var $2tHqU = parcelRequire("2tHqU");

var $3HvNL = parcelRequire("3HvNL");

var $8Ub7X = parcelRequire("8Ub7X");

var $8f1wS = parcelRequire("8f1wS");

var $6wezB = parcelRequire("6wezB");

var $iqBKf = parcelRequire("iqBKf");

var $60XIC = parcelRequire("60XIC");

var $7CcUS = parcelRequire("7CcUS");

var $ihGvV = parcelRequire("ihGvV");

var $7gF0P = parcelRequire("7gF0P");
"use strict";
var $aab41ea35a812794$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $aab41ea35a812794$var$logger = new (0, $ihGvV.Logger)((0, $7gF0P.version));
// Exported Types
function $aab41ea35a812794$var$hasMnemonic(value) {
    return value != null && value.mnemonic && value.mnemonic.phrase;
}
var $aab41ea35a812794$export$cf9dc4fd6dde0315 = /*#__PURE__*/ function(Description) {
    (0, $i0LXg._)(KeystoreAccount, Description);
    var _super = (0, $a1vXf._)(KeystoreAccount);
    function KeystoreAccount() {
        (0, $9j09T._)(this, KeystoreAccount);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(KeystoreAccount, [
        {
            key: "isKeystoreAccount",
            value: function isKeystoreAccount(value) {
                return !!(value && value._isKeystoreAccount);
            }
        }
    ]);
    return KeystoreAccount;
}((0, $iqBKf.Description));
function $aab41ea35a812794$var$_decrypt(data, key, ciphertext) {
    var cipher = (0, $7CcUS.searchPath)(data, "crypto/cipher");
    if (cipher === "aes-128-ctr") {
        var iv = (0, $7CcUS.looseArrayify)((0, $7CcUS.searchPath)(data, "crypto/cipherparams/iv"));
        var counter = new (0, (/*@__PURE__*/$parcel$interopDefault($bVtKz))).Counter(iv);
        var aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($bVtKz))).ModeOfOperation.ctr(key, counter);
        return (0, $2tHqU.arrayify)(aesCtr.decrypt(ciphertext));
    }
    return null;
}
function $aab41ea35a812794$var$_getAccount(data, key) {
    var ciphertext = (0, $7CcUS.looseArrayify)((0, $7CcUS.searchPath)(data, "crypto/ciphertext"));
    var computedMAC = (0, $2tHqU.hexlify)((0, $8Ub7X.keccak256)((0, $2tHqU.concat)([
        key.slice(16, 32),
        ciphertext
    ]))).substring(2);
    if (computedMAC !== (0, $7CcUS.searchPath)(data, "crypto/mac").toLowerCase()) throw new Error("invalid password");
    var privateKey = $aab41ea35a812794$var$_decrypt(data, key.slice(0, 16), ciphertext);
    if (!privateKey) $aab41ea35a812794$var$logger.throwError("unsupported cipher", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "decrypt"
    });
    var mnemonicKey = key.slice(32, 64);
    var address = (0, $60XIC.computeAddress)(privateKey);
    if (data.address) {
        var check = data.address.toLowerCase();
        if (check.substring(0, 2) !== "0x") check = "0x" + check;
        if ((0, $hFSWi.getAddress)(check) !== address) throw new Error("address mismatch");
    }
    var account = {
        _isKeystoreAccount: true,
        address: address,
        privateKey: (0, $2tHqU.hexlify)(privateKey)
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    if ((0, $7CcUS.searchPath)(data, "x-ethers/version") === "0.1") {
        var mnemonicCiphertext = (0, $7CcUS.looseArrayify)((0, $7CcUS.searchPath)(data, "x-ethers/mnemonicCiphertext"));
        var mnemonicIv = (0, $7CcUS.looseArrayify)((0, $7CcUS.searchPath)(data, "x-ethers/mnemonicCounter"));
        var mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($bVtKz))).Counter(mnemonicIv);
        var mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($bVtKz))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
        var path = (0, $7CcUS.searchPath)(data, "x-ethers/path") || (0, $3HvNL.defaultPath);
        var locale = (0, $7CcUS.searchPath)(data, "x-ethers/locale") || "en";
        var entropy = (0, $2tHqU.arrayify)(mnemonicAesCtr.decrypt(mnemonicCiphertext));
        try {
            var mnemonic = (0, $3HvNL.entropyToMnemonic)(entropy, locale);
            var node = (0, $3HvNL.HDNode).fromMnemonic(mnemonic, null, locale).derivePath(path);
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
            account.mnemonic = node.mnemonic;
        } catch (error) {
            // If we don't have the locale wordlist installed to
            // read this mnemonic, just bail and don't set the
            // mnemonic
            if (error.code !== (0, $ihGvV.Logger).errors.INVALID_ARGUMENT || error.argument !== "wordlist") throw error;
        }
    }
    return new $aab41ea35a812794$export$cf9dc4fd6dde0315(account);
}
function $aab41ea35a812794$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc) {
    return (0, $2tHqU.arrayify)((0, $8f1wS.pbkdf2)(passwordBytes, salt, count, dkLen, prfFunc));
}
function $aab41ea35a812794$var$pbkdf2(passwordBytes, salt, count, dkLen, prfFunc) {
    return Promise.resolve($aab41ea35a812794$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc));
}
function $aab41ea35a812794$var$_computeKdfKey(data, password, pbkdf2Func, scryptFunc, progressCallback) {
    var passwordBytes = (0, $7CcUS.getPassword)(password);
    var kdf = (0, $7CcUS.searchPath)(data, "crypto/kdf");
    if (kdf && typeof kdf === "string") {
        var throwError = function throwError(name, value) {
            return $aab41ea35a812794$var$logger.throwArgumentError("invalid key-derivation function parameters", name, value);
        };
        if (kdf.toLowerCase() === "scrypt") {
            var salt = (0, $7CcUS.looseArrayify)((0, $7CcUS.searchPath)(data, "crypto/kdfparams/salt"));
            var N = parseInt((0, $7CcUS.searchPath)(data, "crypto/kdfparams/n"));
            var r = parseInt((0, $7CcUS.searchPath)(data, "crypto/kdfparams/r"));
            var p = parseInt((0, $7CcUS.searchPath)(data, "crypto/kdfparams/p"));
            // Check for all required parameters
            if (!N || !r || !p) throwError("kdf", kdf);
            // Make sure N is a power of 2
            if ((N & N - 1) !== 0) throwError("N", N);
            var dkLen = parseInt((0, $7CcUS.searchPath)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return scryptFunc(passwordBytes, salt, N, r, p, 64, progressCallback);
        } else if (kdf.toLowerCase() === "pbkdf2") {
            var salt1 = (0, $7CcUS.looseArrayify)((0, $7CcUS.searchPath)(data, "crypto/kdfparams/salt"));
            var prfFunc = null;
            var prf = (0, $7CcUS.searchPath)(data, "crypto/kdfparams/prf");
            if (prf === "hmac-sha256") prfFunc = "sha256";
            else if (prf === "hmac-sha512") prfFunc = "sha512";
            else throwError("prf", prf);
            var count = parseInt((0, $7CcUS.searchPath)(data, "crypto/kdfparams/c"));
            var dkLen1 = parseInt((0, $7CcUS.searchPath)(data, "crypto/kdfparams/dklen"));
            if (dkLen1 !== 32) throwError("dklen", dkLen1);
            return pbkdf2Func(passwordBytes, salt1, count, dkLen1, prfFunc);
        }
    }
    return $aab41ea35a812794$var$logger.throwArgumentError("unsupported key-derivation function", "kdf", kdf);
}
function $aab41ea35a812794$export$9bd2c37889ee5e36(json, password) {
    var data = JSON.parse(json);
    var key = $aab41ea35a812794$var$_computeKdfKey(data, password, $aab41ea35a812794$var$pbkdf2Sync, (0, (/*@__PURE__*/$parcel$interopDefault($c1a2N))).syncScrypt);
    return $aab41ea35a812794$var$_getAccount(data, key);
}
function $aab41ea35a812794$export$e85a0c9a1067c5d3(json, password, progressCallback) {
    return $aab41ea35a812794$var$__awaiter(this, void 0, void 0, function() {
        var data, key;
        return (0, $itJXR.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = JSON.parse(json);
                    return [
                        4,
                        $aab41ea35a812794$var$_computeKdfKey(data, password, $aab41ea35a812794$var$pbkdf2, (0, (/*@__PURE__*/$parcel$interopDefault($c1a2N))).scrypt, progressCallback)
                    ];
                case 1:
                    key = _state.sent();
                    return [
                        2,
                        $aab41ea35a812794$var$_getAccount(data, key)
                    ];
            }
        });
    });
}
function $aab41ea35a812794$export$5b0f6292f11d1d18(account, password, options, progressCallback) {
    try {
        // Check the address matches the private key
        if ((0, $hFSWi.getAddress)(account.address) !== (0, $60XIC.computeAddress)(account.privateKey)) throw new Error("address/privateKey mismatch");
        // Check the mnemonic (if any) matches the private key
        if ($aab41ea35a812794$var$hasMnemonic(account)) {
            var mnemonic = account.mnemonic;
            var node = (0, $3HvNL.HDNode).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path || (0, $3HvNL.defaultPath));
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
        }
    } catch (e) {
        return Promise.reject(e);
    }
    // The options are optional, so adjust the call as needed
    if (typeof options === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
    }
    if (!options) options = {};
    var privateKey = (0, $2tHqU.arrayify)(account.privateKey);
    var passwordBytes = (0, $7CcUS.getPassword)(password);
    var entropy = null;
    var path = null;
    var locale = null;
    if ($aab41ea35a812794$var$hasMnemonic(account)) {
        var srcMnemonic = account.mnemonic;
        entropy = (0, $2tHqU.arrayify)((0, $3HvNL.mnemonicToEntropy)(srcMnemonic.phrase, srcMnemonic.locale || "en"));
        path = srcMnemonic.path || (0, $3HvNL.defaultPath);
        locale = srcMnemonic.locale || "en";
    }
    var client = options.client;
    if (!client) client = "ethers.js";
    // Check/generate the salt
    var salt = null;
    if (options.salt) salt = (0, $2tHqU.arrayify)(options.salt);
    else salt = (0, $6wezB.randomBytes)(32);
    // Override initialization vector
    var iv = null;
    if (options.iv) {
        iv = (0, $2tHqU.arrayify)(options.iv);
        if (iv.length !== 16) throw new Error("invalid iv");
    } else iv = (0, $6wezB.randomBytes)(16);
    // Override the uuid
    var uuidRandom = null;
    if (options.uuid) {
        uuidRandom = (0, $2tHqU.arrayify)(options.uuid);
        if (uuidRandom.length !== 16) throw new Error("invalid uuid");
    } else uuidRandom = (0, $6wezB.randomBytes)(16);
    // Override the scrypt password-based key derivation function parameters
    var N = 131072, r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) N = options.scrypt.N;
        if (options.scrypt.r) r = options.scrypt.r;
        if (options.scrypt.p) p = options.scrypt.p;
    }
    // We take 64 bytes:
    //   - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    //   - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    return (0, (/*@__PURE__*/$parcel$interopDefault($c1a2N))).scrypt(passwordBytes, salt, N, r, p, 64, progressCallback).then(function(key) {
        key = (0, $2tHqU.arrayify)(key);
        // This will be used to encrypt the wallet (as per Web3 secret storage)
        var derivedKey = key.slice(0, 16);
        var macPrefix = key.slice(16, 32);
        // This will be used to encrypt the mnemonic phrase (if any)
        var mnemonicKey = key.slice(32, 64);
        // Encrypt the private key
        var counter = new (0, (/*@__PURE__*/$parcel$interopDefault($bVtKz))).Counter(iv);
        var aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($bVtKz))).ModeOfOperation.ctr(derivedKey, counter);
        var ciphertext = (0, $2tHqU.arrayify)(aesCtr.encrypt(privateKey));
        // Compute the message authentication code, used to check the password
        var mac = (0, $8Ub7X.keccak256)((0, $2tHqU.concat)([
            macPrefix,
            ciphertext
        ]));
        // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
        var data = {
            address: account.address.substring(2).toLowerCase(),
            id: (0, $7CcUS.uuidV4)(uuidRandom),
            version: 3,
            Crypto: {
                cipher: "aes-128-ctr",
                cipherparams: {
                    iv: (0, $2tHqU.hexlify)(iv).substring(2)
                },
                ciphertext: (0, $2tHqU.hexlify)(ciphertext).substring(2),
                kdf: "scrypt",
                kdfparams: {
                    salt: (0, $2tHqU.hexlify)(salt).substring(2),
                    n: N,
                    dklen: 32,
                    p: p,
                    r: r
                },
                mac: mac.substring(2)
            }
        };
        // If we have a mnemonic, encrypt it into the JSON wallet
        if (entropy) {
            var mnemonicIv = (0, $6wezB.randomBytes)(16);
            var mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($bVtKz))).Counter(mnemonicIv);
            var mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($bVtKz))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
            var mnemonicCiphertext = (0, $2tHqU.arrayify)(mnemonicAesCtr.encrypt(entropy));
            var now = new Date();
            var timestamp = now.getUTCFullYear() + "-" + (0, $7CcUS.zpad)(now.getUTCMonth() + 1, 2) + "-" + (0, $7CcUS.zpad)(now.getUTCDate(), 2) + "T" + (0, $7CcUS.zpad)(now.getUTCHours(), 2) + "-" + (0, $7CcUS.zpad)(now.getUTCMinutes(), 2) + "-" + (0, $7CcUS.zpad)(now.getUTCSeconds(), 2) + ".0Z";
            data["x-ethers"] = {
                client: client,
                gethFilename: "UTC--" + timestamp + "--" + data.address,
                mnemonicCounter: (0, $2tHqU.hexlify)(mnemonicIv).substring(2),
                mnemonicCiphertext: (0, $2tHqU.hexlify)(mnemonicCiphertext).substring(2),
                path: path,
                locale: locale,
                version: "0.1"
            };
        }
        return JSON.stringify(data);
    });
}

});
parcelRegister("c1a2N", function(module, exports) {
"use strict";
(function(root) {
    var MAX_VALUE = 0x7fffffff;
    // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    // See: https://github.com/dchest/scrypt-async-js
    function SHA256(m) {
        var K = new Uint32Array([
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ]);
        var h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
        var h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
        var w = new Uint32Array(64);
        function blocks(p) {
            var off = 0, len = p.length;
            while(len >= 64){
                var a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u = void 0, i = void 0, j = void 0, t1 = void 0, t2 = void 0;
                for(i = 0; i < 16; i++){
                    j = off + i * 4;
                    w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
                }
                for(i = 16; i < 64; i++){
                    u = w[i - 2];
                    t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                    u = w[i - 15];
                    t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                    w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0) | 0;
                }
                for(i = 0; i < 64; i++){
                    t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
                    t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                h0 = h0 + a | 0;
                h1 = h1 + b | 0;
                h2 = h2 + c | 0;
                h3 = h3 + d | 0;
                h4 = h4 + e | 0;
                h5 = h5 + f | 0;
                h6 = h6 + g | 0;
                h7 = h7 + h | 0;
                off += 64;
                len -= 64;
            }
        }
        blocks(m);
        var i, bytesLeft = m.length % 64, bitLenHi = m.length / 0x20000000 | 0, bitLenLo = m.length << 3, numZeros = bytesLeft < 56 ? 56 : 120, p = m.slice(m.length - bytesLeft, m.length);
        p.push(0x80);
        for(i = bytesLeft + 1; i < numZeros; i++)p.push(0);
        p.push(bitLenHi >>> 24 & 0xff);
        p.push(bitLenHi >>> 16 & 0xff);
        p.push(bitLenHi >>> 8 & 0xff);
        p.push(bitLenHi >>> 0 & 0xff);
        p.push(bitLenLo >>> 24 & 0xff);
        p.push(bitLenLo >>> 16 & 0xff);
        p.push(bitLenLo >>> 8 & 0xff);
        p.push(bitLenLo >>> 0 & 0xff);
        blocks(p);
        return [
            h0 >>> 24 & 0xff,
            h0 >>> 16 & 0xff,
            h0 >>> 8 & 0xff,
            h0 >>> 0 & 0xff,
            h1 >>> 24 & 0xff,
            h1 >>> 16 & 0xff,
            h1 >>> 8 & 0xff,
            h1 >>> 0 & 0xff,
            h2 >>> 24 & 0xff,
            h2 >>> 16 & 0xff,
            h2 >>> 8 & 0xff,
            h2 >>> 0 & 0xff,
            h3 >>> 24 & 0xff,
            h3 >>> 16 & 0xff,
            h3 >>> 8 & 0xff,
            h3 >>> 0 & 0xff,
            h4 >>> 24 & 0xff,
            h4 >>> 16 & 0xff,
            h4 >>> 8 & 0xff,
            h4 >>> 0 & 0xff,
            h5 >>> 24 & 0xff,
            h5 >>> 16 & 0xff,
            h5 >>> 8 & 0xff,
            h5 >>> 0 & 0xff,
            h6 >>> 24 & 0xff,
            h6 >>> 16 & 0xff,
            h6 >>> 8 & 0xff,
            h6 >>> 0 & 0xff,
            h7 >>> 24 & 0xff,
            h7 >>> 16 & 0xff,
            h7 >>> 8 & 0xff,
            h7 >>> 0 & 0xff
        ];
    }
    function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
        // compress password if it's longer than hash block length
        password = password.length <= 64 ? password : SHA256(password);
        var innerLen = 64 + salt.length + 4;
        var inner = new Array(innerLen);
        var outerKey = new Array(64);
        var i;
        var dk = [];
        // inner = (password ^ ipad) || salt || counter
        for(i = 0; i < 64; i++)inner[i] = 0x36;
        for(i = 0; i < password.length; i++)inner[i] ^= password[i];
        for(i = 0; i < salt.length; i++)inner[64 + i] = salt[i];
        for(i = innerLen - 4; i < innerLen; i++)inner[i] = 0;
        // outerKey = password ^ opad
        for(i = 0; i < 64; i++)outerKey[i] = 0x5c;
        for(i = 0; i < password.length; i++)outerKey[i] ^= password[i];
        // increments counter inside inner
        function incrementCounter() {
            for(var i = innerLen - 1; i >= innerLen - 4; i--){
                inner[i]++;
                if (inner[i] <= 0xff) return;
                inner[i] = 0;
            }
        }
        // output blocks = SHA256(outerKey || SHA256(inner)) ...
        while(dkLen >= 32){
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
            dkLen -= 32;
        }
        if (dkLen > 0) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
        }
        return dk;
    }
    // The following is an adaptation of scryptsy
    // See: https://www.npmjs.com/package/scryptsy
    function blockmix_salsa8(BY, Yi, r, x, _X) {
        var i;
        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
        for(i = 0; i < 2 * r; i++){
            blockxor(BY, i * 16, _X, 16);
            salsa20_8(_X, x);
            arraycopy(_X, 0, BY, Yi + i * 16, 16);
        }
        for(i = 0; i < r; i++)arraycopy(BY, Yi + i * 32, BY, i * 16, 16);
        for(i = 0; i < r; i++)arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
    }
    function R(a, b) {
        return a << b | a >>> 32 - b;
    }
    function salsa20_8(B, x) {
        arraycopy(B, 0, x, 0, 16);
        for(var i = 8; i > 0; i -= 2){
            x[4] ^= R(x[0] + x[12], 7);
            x[8] ^= R(x[4] + x[0], 9);
            x[12] ^= R(x[8] + x[4], 13);
            x[0] ^= R(x[12] + x[8], 18);
            x[9] ^= R(x[5] + x[1], 7);
            x[13] ^= R(x[9] + x[5], 9);
            x[1] ^= R(x[13] + x[9], 13);
            x[5] ^= R(x[1] + x[13], 18);
            x[14] ^= R(x[10] + x[6], 7);
            x[2] ^= R(x[14] + x[10], 9);
            x[6] ^= R(x[2] + x[14], 13);
            x[10] ^= R(x[6] + x[2], 18);
            x[3] ^= R(x[15] + x[11], 7);
            x[7] ^= R(x[3] + x[15], 9);
            x[11] ^= R(x[7] + x[3], 13);
            x[15] ^= R(x[11] + x[7], 18);
            x[1] ^= R(x[0] + x[3], 7);
            x[2] ^= R(x[1] + x[0], 9);
            x[3] ^= R(x[2] + x[1], 13);
            x[0] ^= R(x[3] + x[2], 18);
            x[6] ^= R(x[5] + x[4], 7);
            x[7] ^= R(x[6] + x[5], 9);
            x[4] ^= R(x[7] + x[6], 13);
            x[5] ^= R(x[4] + x[7], 18);
            x[11] ^= R(x[10] + x[9], 7);
            x[8] ^= R(x[11] + x[10], 9);
            x[9] ^= R(x[8] + x[11], 13);
            x[10] ^= R(x[9] + x[8], 18);
            x[12] ^= R(x[15] + x[14], 7);
            x[13] ^= R(x[12] + x[15], 9);
            x[14] ^= R(x[13] + x[12], 13);
            x[15] ^= R(x[14] + x[13], 18);
        }
        for(var i1 = 0; i1 < 16; ++i1)B[i1] += x[i1];
    }
    // naive approach... going back to loop unrolling may yield additional performance
    function blockxor(S, Si, D, len) {
        for(var i = 0; i < len; i++)D[i] ^= S[Si + i];
    }
    function arraycopy(src, srcPos, dest, destPos, length) {
        while(length--)dest[destPos++] = src[srcPos++];
    }
    function checkBufferish(o) {
        if (!o || typeof o.length !== "number") return false;
        for(var i = 0; i < o.length; i++){
            var v = o[i];
            if (typeof v !== "number" || v % 1 || v < 0 || v >= 256) return false;
        }
        return true;
    }
    function ensureInteger(value, name) {
        if (typeof value !== "number" || value % 1) throw new Error("invalid " + name);
        return value;
    }
    // N = Cpu cost, r = Memory cost, p = parallelization cost
    // callback(error, progress, key)
    function _scrypt(password, salt, N, r, p, dkLen, callback) {
        N = ensureInteger(N, "N");
        r = ensureInteger(r, "r");
        p = ensureInteger(p, "p");
        dkLen = ensureInteger(dkLen, "dkLen");
        if (N === 0 || (N & N - 1) !== 0) throw new Error("N must be power of 2");
        if (N > MAX_VALUE / 128 / r) throw new Error("N too large");
        if (r > MAX_VALUE / 128 / p) throw new Error("r too large");
        if (!checkBufferish(password)) throw new Error("password must be an array or buffer");
        password = Array.prototype.slice.call(password);
        if (!checkBufferish(salt)) throw new Error("salt must be an array or buffer");
        salt = Array.prototype.slice.call(salt);
        var b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
        var B = new Uint32Array(p * 32 * r);
        for(var i = 0; i < B.length; i++){
            var j = i * 4;
            B[i] = (b[j + 3] & 0xff) << 24 | (b[j + 2] & 0xff) << 16 | (b[j + 1] & 0xff) << 8 | (b[j + 0] & 0xff) << 0;
        }
        var XY = new Uint32Array(64 * r);
        var V = new Uint32Array(32 * r * N);
        var Yi = 32 * r;
        // scratch space
        var x = new Uint32Array(16); // salsa20_8
        var _X = new Uint32Array(16); // blockmix_salsa8
        var totalOps = p * N * 2;
        var currentOp = 0;
        var lastPercent10 = null;
        // Set this to true to abandon the scrypt on the next step
        var stop = false;
        // State information
        var state = 0;
        var i0 = 0, i1;
        var Bi;
        // How many blockmix_salsa8 can we do per step?
        var limit = callback ? parseInt(1000 / r) : 0xffffffff;
        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
        var nextTick = typeof setImmediate !== "undefined" ? setImmediate : setTimeout;
        // This is really all I changed; making scryptsy a state machine so we occasionally
        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
        var incrementalSMix = function incrementalSMix1() {
            if (stop) return callback(new Error("cancelled"), currentOp / totalOps);
            var steps;
            switch(state){
                case 0:
                    // for (var i = 0; i < p; i++)...
                    Bi = i0 * 32 * r;
                    arraycopy(B, Bi, XY, 0, Yi); // ROMix - 1
                    state = 1; // Move to ROMix 2
                    i1 = 0;
                // Fall through
                case 1:
                    // Run up to 1000 steps of the first inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(var i = 0; i < steps; i++){
                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi) // ROMix - 3
                        ;
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 4
                    }
                    // for (var i = 0; i < N; i++)
                    i1 += steps;
                    currentOp += steps;
                    if (callback) {
                        // Call the callback with the progress (optionally stopping us)
                        var percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    i1 = 0; // Move to ROMix 6
                    state = 2;
                // Fall through
                case 2:
                    // Run up to 1000 steps of the second inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(var i2 = 0; i2 < steps; i2++){
                        var offset = (2 * r - 1) * 16; // ROMix - 7
                        var j = XY[offset] & N - 1;
                        blockxor(V, j * Yi, XY, Yi); // ROMix - 8 (inner)
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 9 (outer)
                    }
                    // for (var i = 0; i < N; i++)...
                    i1 += steps;
                    currentOp += steps;
                    // Call the callback with the progress (optionally stopping us)
                    if (callback) {
                        var percent101 = parseInt(1000 * currentOp / totalOps);
                        if (percent101 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent101;
                        }
                    }
                    if (i1 < N) break;
                    arraycopy(XY, 0, B, Bi, Yi); // ROMix - 10
                    // for (var i = 0; i < p; i++)...
                    i0++;
                    if (i0 < p) {
                        state = 0;
                        break;
                    }
                    b = [];
                    for(var i3 = 0; i3 < B.length; i3++){
                        b.push(B[i3] >> 0 & 0xff);
                        b.push(B[i3] >> 8 & 0xff);
                        b.push(B[i3] >> 16 & 0xff);
                        b.push(B[i3] >> 24 & 0xff);
                    }
                    var derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);
                    // Send the result to the callback
                    if (callback) callback(null, 1.0, derivedKey);
                    // Done; don't break (which would reschedule)
                    return derivedKey;
            }
            // Schedule the next steps
            if (callback) nextTick(incrementalSMix);
        };
        // Run the smix state machine until completion
        if (!callback) while(true){
            var derivedKey = incrementalSMix();
            if (derivedKey != undefined) return derivedKey;
        }
        // Bootstrap the async incremental smix
        incrementalSMix();
    }
    var lib = {
        scrypt: function scrypt(password, salt, N, r, p, dkLen, progressCallback) {
            return new Promise(function(resolve, reject) {
                var lastProgress = 0;
                if (progressCallback) progressCallback(0);
                _scrypt(password, salt, N, r, p, dkLen, function(error, progress, key) {
                    if (error) reject(error);
                    else if (key) {
                        if (progressCallback && lastProgress !== 1) progressCallback(1);
                        resolve(new Uint8Array(key));
                    } else if (progressCallback && progress !== lastProgress) {
                        lastProgress = progress;
                        return progressCallback(progress);
                    }
                });
            });
        },
        syncScrypt: function syncScrypt(password, salt, N, r, p, dkLen) {
            return new Uint8Array(_scrypt(password, salt, N, r, p, dkLen));
        }
    };
    // node.js
    if (typeof module.exports !== "undefined") module.exports = lib;
    else if (typeof define === "function" && define.amd) define(lib);
    else if (root) {
        // If there was an existing library "scrypt", make sure it is still available
        if (root.scrypt) root._scrypt = root.scrypt;
        root.scrypt = lib;
    }
})(module.exports);

});



parcelRegister("5PqJc", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $43e672d18ebebca8$export$83d89fbfd8236492; });
var $43e672d18ebebca8$export$83d89fbfd8236492 = "wallet/5.5.0";

});


parcelRegister("koVFy", function(module, exports) {

$parcel$export(module.exports, "AddressZero", function () { return (parcelRequire("jOl1N")).AddressZero; });
$parcel$export(module.exports, "NegativeOne", function () { return (parcelRequire("3bevF")).NegativeOne; });
$parcel$export(module.exports, "Zero", function () { return (parcelRequire("3bevF")).Zero; });
$parcel$export(module.exports, "One", function () { return (parcelRequire("3bevF")).One; });
$parcel$export(module.exports, "Two", function () { return (parcelRequire("3bevF")).Two; });
$parcel$export(module.exports, "WeiPerEther", function () { return (parcelRequire("3bevF")).WeiPerEther; });
$parcel$export(module.exports, "MaxUint256", function () { return (parcelRequire("3bevF")).MaxUint256; });
$parcel$export(module.exports, "MinInt256", function () { return (parcelRequire("3bevF")).MinInt256; });
$parcel$export(module.exports, "MaxInt256", function () { return (parcelRequire("3bevF")).MaxInt256; });
$parcel$export(module.exports, "HashZero", function () { return (parcelRequire("dpMov")).HashZero; });
$parcel$export(module.exports, "EtherSymbol", function () { return (parcelRequire("kvrEq")).EtherSymbol; });

var $jOl1N = parcelRequire("jOl1N");

var $3bevF = parcelRequire("3bevF");

var $dpMov = parcelRequire("dpMov");

var $kvrEq = parcelRequire("kvrEq");
"use strict";

});
parcelRegister("jOl1N", function(module, exports) {

$parcel$export(module.exports, "AddressZero", function () { return $e6c2ff88cd0f2efe$export$badd13187c087617; });
var $e6c2ff88cd0f2efe$export$badd13187c087617 = "0x0000000000000000000000000000000000000000";

});

parcelRegister("dpMov", function(module, exports) {

$parcel$export(module.exports, "HashZero", function () { return $9c432644a6372a11$export$71c2e4e213dcb7f2; });
var $9c432644a6372a11$export$71c2e4e213dcb7f2 = "0x0000000000000000000000000000000000000000000000000000000000000000";

});

parcelRegister("kvrEq", function(module, exports) {

$parcel$export(module.exports, "EtherSymbol", function () { return $eedc26d100b172d2$export$c7e79fcb6f8ac048; });
// NFKC (composed)             // (decomposed)
var $eedc26d100b172d2$export$c7e79fcb6f8ac048 = "\u039E"; // "\uD835\uDF63";

});


parcelRegister("664kq", function(module, exports) {

$parcel$export(module.exports, "getDefaultProvider", function () { return $4706a926f618c6a4$export$4f77a1d3c1ac6642; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("fH8QX")).Provider; });
$parcel$export(module.exports, "BaseProvider", function () { return (parcelRequire("MLa0C")).BaseProvider; });
$parcel$export(module.exports, "Resolver", function () { return (parcelRequire("MLa0C")).Resolver; });
$parcel$export(module.exports, "UrlJsonRpcProvider", function () { return (parcelRequire("hz2UR")).UrlJsonRpcProvider; });
$parcel$export(module.exports, "FallbackProvider", function () { return (parcelRequire("brRHB")).FallbackProvider; });
$parcel$export(module.exports, "AlchemyProvider", function () { return (parcelRequire("4Shvs")).AlchemyProvider; });
$parcel$export(module.exports, "AlchemyWebSocketProvider", function () { return (parcelRequire("4Shvs")).AlchemyWebSocketProvider; });
$parcel$export(module.exports, "CloudflareProvider", function () { return (parcelRequire("heQ1D")).CloudflareProvider; });
$parcel$export(module.exports, "EtherscanProvider", function () { return (parcelRequire("bLfTl")).EtherscanProvider; });
$parcel$export(module.exports, "InfuraProvider", function () { return (parcelRequire("ciPnS")).InfuraProvider; });
$parcel$export(module.exports, "InfuraWebSocketProvider", function () { return (parcelRequire("ciPnS")).InfuraWebSocketProvider; });
$parcel$export(module.exports, "JsonRpcProvider", function () { return (parcelRequire("1VVvv")).JsonRpcProvider; });
$parcel$export(module.exports, "JsonRpcBatchProvider", function () { return (parcelRequire("7dSPw")).JsonRpcBatchProvider; });
$parcel$export(module.exports, "NodesmithProvider", function () { return (parcelRequire("b2S0F")).NodesmithProvider; });
$parcel$export(module.exports, "PocketProvider", function () { return (parcelRequire("f2Gxa")).PocketProvider; });
$parcel$export(module.exports, "StaticJsonRpcProvider", function () { return (parcelRequire("hz2UR")).StaticJsonRpcProvider; });
$parcel$export(module.exports, "Web3Provider", function () { return (parcelRequire("jrgO5")).Web3Provider; });
$parcel$export(module.exports, "WebSocketProvider", function () { return (parcelRequire("gc4Rx")).WebSocketProvider; });
$parcel$export(module.exports, "IpcProvider", function () { return (parcelRequire("lw1Sw")).IpcProvider; });
$parcel$export(module.exports, "JsonRpcSigner", function () { return (parcelRequire("1VVvv")).JsonRpcSigner; });
$parcel$export(module.exports, "getNetwork", function () { return (parcelRequire("aCB1f")).getNetwork; });
$parcel$export(module.exports, "isCommunityResource", function () { return (parcelRequire("hbpzV")).isCommunityResource; });
$parcel$export(module.exports, "isCommunityResourcable", function () { return (parcelRequire("hbpzV")).isCommunityResourcable; });
$parcel$export(module.exports, "showThrottleMessage", function () { return (parcelRequire("hbpzV")).showThrottleMessage; });
$parcel$export(module.exports, "Formatter", function () { return (parcelRequire("hbpzV")).Formatter; });

var $fH8QX = parcelRequire("fH8QX");

var $aCB1f = parcelRequire("aCB1f");

var $MLa0C = parcelRequire("MLa0C");

var $4Shvs = parcelRequire("4Shvs");

var $heQ1D = parcelRequire("heQ1D");

var $bLfTl = parcelRequire("bLfTl");

var $brRHB = parcelRequire("brRHB");

var $lw1Sw = parcelRequire("lw1Sw");

var $ciPnS = parcelRequire("ciPnS");

var $1VVvv = parcelRequire("1VVvv");

var $7dSPw = parcelRequire("7dSPw");

var $b2S0F = parcelRequire("b2S0F");

var $f2Gxa = parcelRequire("f2Gxa");

var $hz2UR = parcelRequire("hz2UR");

var $jrgO5 = parcelRequire("jrgO5");

var $gc4Rx = parcelRequire("gc4Rx");

var $hbpzV = parcelRequire("hbpzV");

var $ihGvV = parcelRequire("ihGvV");

var $9Bx3O = parcelRequire("9Bx3O");
"use strict";
var $4706a926f618c6a4$var$logger = new (0, $ihGvV.Logger)((0, $9Bx3O.version));
////////////////////////
// Helper Functions
function $4706a926f618c6a4$export$4f77a1d3c1ac6642(network, options) {
    if (network == null) network = "homestead";
    // If passed a URL, figure out the right type of provider based on the scheme
    if (typeof network === "string") {
        // @TODO: Add support for IpcProvider; maybe if it ends in ".ipc"?
        // Handle http and ws (and their secure variants)
        var match = network.match(/^(ws|http)s?:/i);
        if (match) switch(match[1]){
            case "http":
                return new (0, $1VVvv.JsonRpcProvider)(network);
            case "ws":
                return new (0, $gc4Rx.WebSocketProvider)(network);
            default:
                $4706a926f618c6a4$var$logger.throwArgumentError("unsupported URL scheme", "network", network);
        }
    }
    var n = (0, $aCB1f.getNetwork)(network);
    if (!n || !n._defaultProvider) $4706a926f618c6a4$var$logger.throwError("unsupported getDefaultProvider network", (0, $ihGvV.Logger).errors.NETWORK_ERROR, {
        operation: "getDefaultProvider",
        network: network
    });
    return n._defaultProvider({
        FallbackProvider: (0, $brRHB.FallbackProvider),
        AlchemyProvider: (0, $4Shvs.AlchemyProvider),
        CloudflareProvider: (0, $heQ1D.CloudflareProvider),
        EtherscanProvider: (0, $bLfTl.EtherscanProvider),
        InfuraProvider: (0, $ciPnS.InfuraProvider),
        JsonRpcProvider: (0, $1VVvv.JsonRpcProvider),
        NodesmithProvider: (0, $b2S0F.NodesmithProvider),
        PocketProvider: (0, $f2Gxa.PocketProvider),
        Web3Provider: (0, $jrgO5.Web3Provider),
        IpcProvider: (0, $lw1Sw.IpcProvider)
    }, options);
}

});
parcelRegister("aCB1f", function(module, exports) {

$parcel$export(module.exports, "getNetwork", function () { return $01fedfaa220bc7dc$export$7de4970ebfd8206d; });

var $ihGvV = parcelRequire("ihGvV");

var $jXvQ8 = parcelRequire("jXvQ8");
"use strict";
var $01fedfaa220bc7dc$var$logger = new (0, $ihGvV.Logger)((0, $jXvQ8.version));
function $01fedfaa220bc7dc$var$isRenetworkable(value) {
    return value && typeof value.renetwork === "function";
}
function $01fedfaa220bc7dc$var$ethDefaultProvider(network) {
    var func = function func(providers, options) {
        if (options == null) options = {};
        var providerList = [];
        if (providers.InfuraProvider) try {
            providerList.push(new providers.InfuraProvider(network, options.infura));
        } catch (error) {}
        if (providers.EtherscanProvider) try {
            providerList.push(new providers.EtherscanProvider(network, options.etherscan));
        } catch (error) {}
        if (providers.AlchemyProvider) try {
            providerList.push(new providers.AlchemyProvider(network, options.alchemy));
        } catch (error) {}
        if (providers.PocketProvider) {
            // These networks are currently faulty on Pocket as their
            // network does not handle the Berlin hardfork, which is
            // live on these ones.
            // @TODO: This goes away once Pocket has upgraded their nodes
            var skip = [
                "goerli",
                "ropsten",
                "rinkeby"
            ];
            try {
                var provider = new providers.PocketProvider(network);
                if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
            } catch (error) {}
        }
        if (providers.CloudflareProvider) try {
            providerList.push(new providers.CloudflareProvider(network));
        } catch (error) {}
        if (providerList.length === 0) return null;
        if (providers.FallbackProvider) {
            var quorum = 1;
            if (options.quorum != null) quorum = options.quorum;
            else if (network === "homestead") quorum = 2;
            return new providers.FallbackProvider(providerList, quorum);
        }
        return providerList[0];
    };
    func.renetwork = function(network) {
        return $01fedfaa220bc7dc$var$ethDefaultProvider(network);
    };
    return func;
}
function $01fedfaa220bc7dc$var$etcDefaultProvider(url, network) {
    var func = function func(providers, options) {
        if (providers.JsonRpcProvider) return new providers.JsonRpcProvider(url, network);
        return null;
    };
    func.renetwork = function(network) {
        return $01fedfaa220bc7dc$var$etcDefaultProvider(url, network);
    };
    return func;
}
var $01fedfaa220bc7dc$var$homestead = {
    chainId: 1,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "homestead",
    _defaultProvider: $01fedfaa220bc7dc$var$ethDefaultProvider("homestead")
};
var $01fedfaa220bc7dc$var$ropsten = {
    chainId: 3,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "ropsten",
    _defaultProvider: $01fedfaa220bc7dc$var$ethDefaultProvider("ropsten")
};
var $01fedfaa220bc7dc$var$classicMordor = {
    chainId: 63,
    name: "classicMordor",
    _defaultProvider: $01fedfaa220bc7dc$var$etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
};
var $01fedfaa220bc7dc$var$networks = {
    unspecified: {
        chainId: 0,
        name: "unspecified"
    },
    homestead: $01fedfaa220bc7dc$var$homestead,
    mainnet: $01fedfaa220bc7dc$var$homestead,
    morden: {
        chainId: 2,
        name: "morden"
    },
    ropsten: $01fedfaa220bc7dc$var$ropsten,
    testnet: $01fedfaa220bc7dc$var$ropsten,
    rinkeby: {
        chainId: 4,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "rinkeby",
        _defaultProvider: $01fedfaa220bc7dc$var$ethDefaultProvider("rinkeby")
    },
    kovan: {
        chainId: 42,
        name: "kovan",
        _defaultProvider: $01fedfaa220bc7dc$var$ethDefaultProvider("kovan")
    },
    goerli: {
        chainId: 5,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "goerli",
        _defaultProvider: $01fedfaa220bc7dc$var$ethDefaultProvider("goerli")
    },
    // ETC (See: #351)
    classic: {
        chainId: 61,
        name: "classic",
        _defaultProvider: $01fedfaa220bc7dc$var$etcDefaultProvider("https://www.ethercluster.com/etc", "classic")
    },
    classicMorden: {
        chainId: 62,
        name: "classicMorden"
    },
    classicMordor: $01fedfaa220bc7dc$var$classicMordor,
    classicTestnet: $01fedfaa220bc7dc$var$classicMordor,
    classicKotti: {
        chainId: 6,
        name: "classicKotti",
        _defaultProvider: $01fedfaa220bc7dc$var$etcDefaultProvider("https://www.ethercluster.com/kotti", "classicKotti")
    },
    xdai: {
        chainId: 100,
        name: "xdai"
    },
    matic: {
        chainId: 137,
        name: "matic"
    },
    maticmum: {
        chainId: 80001,
        name: "maticmum"
    },
    bnb: {
        chainId: 56,
        name: "bnb"
    },
    bnbt: {
        chainId: 97,
        name: "bnbt"
    }
};
function $01fedfaa220bc7dc$export$7de4970ebfd8206d(network) {
    // No network (null)
    if (network == null) return null;
    if (typeof network === "number") {
        for(var name in $01fedfaa220bc7dc$var$networks){
            var standard = $01fedfaa220bc7dc$var$networks[name];
            if (standard.chainId === network) return {
                name: standard.name,
                chainId: standard.chainId,
                ensAddress: standard.ensAddress || null,
                _defaultProvider: standard._defaultProvider || null
            };
        }
        return {
            chainId: network,
            name: "unknown"
        };
    }
    if (typeof network === "string") {
        var standard1 = $01fedfaa220bc7dc$var$networks[network];
        if (standard1 == null) return null;
        return {
            name: standard1.name,
            chainId: standard1.chainId,
            ensAddress: standard1.ensAddress,
            _defaultProvider: standard1._defaultProvider || null
        };
    }
    var standard2 = $01fedfaa220bc7dc$var$networks[network.name];
    // Not a standard network; check that it is a valid network in general
    if (!standard2) {
        if (typeof network.chainId !== "number") $01fedfaa220bc7dc$var$logger.throwArgumentError("invalid network chainId", "network", network);
        return network;
    }
    // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)
    if (network.chainId !== 0 && network.chainId !== standard2.chainId) $01fedfaa220bc7dc$var$logger.throwArgumentError("network chainId mismatch", "network", network);
    // @TODO: In the next major version add an attach function to a defaultProvider
    // class and move the _defaultProvider internal to this file (extend Network)
    var defaultProvider = network._defaultProvider || null;
    if (defaultProvider == null && standard2._defaultProvider) {
        if ($01fedfaa220bc7dc$var$isRenetworkable(standard2._defaultProvider)) defaultProvider = standard2._defaultProvider.renetwork(network);
        else defaultProvider = standard2._defaultProvider;
    }
    // Standard Network (allow overriding the ENS address)
    return {
        name: network.name,
        chainId: standard2.chainId,
        ensAddress: network.ensAddress || standard2.ensAddress || null,
        _defaultProvider: defaultProvider
    };
}

});
parcelRegister("jXvQ8", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $e87c39b9120a62d0$export$83d89fbfd8236492; });
var $e87c39b9120a62d0$export$83d89fbfd8236492 = "networks/5.5.0";

});


parcelRegister("MLa0C", function(module, exports) {

$parcel$export(module.exports, "Resolver", function () { return $092910e3d0b8a167$export$8b4c839865b08288; });
$parcel$export(module.exports, "BaseProvider", function () { return $092910e3d0b8a167$export$ff3f6dd83125ac45; });

var $feAea = parcelRequire("feAea");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");

var $fH8QX = parcelRequire("fH8QX");

var $3fxSP = parcelRequire("3fxSP");

var $7ryKd = parcelRequire("7ryKd");

var $2tHqU = parcelRequire("2tHqU");

var $dpMov = parcelRequire("dpMov");

var $ijr5h = parcelRequire("ijr5h");

var $aCB1f = parcelRequire("aCB1f");

var $iqBKf = parcelRequire("iqBKf");

var $iM01F = parcelRequire("iM01F");

var $5RaVA = parcelRequire("5RaVA");

var $l3Xj2 = parcelRequire("l3Xj2");

var $3tBj7 = parcelRequire("3tBj7");

var $ihGvV = parcelRequire("ihGvV");

var $9Bx3O = parcelRequire("9Bx3O");

var $hbpzV = parcelRequire("hbpzV");
"use strict";
var $092910e3d0b8a167$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $092910e3d0b8a167$var$logger = new (0, $ihGvV.Logger)((0, $9Bx3O.version));
//////////////////////////////
// Event Serializeing
function $092910e3d0b8a167$var$checkTopic(topic) {
    if (topic == null) return "null";
    if ((0, $2tHqU.hexDataLength)(topic) !== 32) $092910e3d0b8a167$var$logger.throwArgumentError("invalid topic", "topic", topic);
    return topic.toLowerCase();
}
function $092910e3d0b8a167$var$serializeTopics(topics) {
    // Remove trailing null AND-topics; they are redundant
    topics = topics.slice();
    while(topics.length > 0 && topics[topics.length - 1] == null)topics.pop();
    return topics.map(function(topic) {
        if (Array.isArray(topic)) {
            // Only track unique OR-topics
            var unique = {};
            topic.forEach(function(topic) {
                unique[$092910e3d0b8a167$var$checkTopic(topic)] = true;
            });
            // The order of OR-topics does not matter
            var sorted = Object.keys(unique);
            sorted.sort();
            return sorted.join("|");
        } else return $092910e3d0b8a167$var$checkTopic(topic);
    }).join("&");
}
function $092910e3d0b8a167$var$deserializeTopics(data) {
    if (data === "") return [];
    return data.split(/&/g).map(function(topic) {
        if (topic === "") return [];
        var comps = topic.split("|").map(function(topic) {
            return topic === "null" ? null : topic;
        });
        return comps.length === 1 ? comps[0] : comps;
    });
}
function $092910e3d0b8a167$var$getEventTag(eventName) {
    if (typeof eventName === "string") {
        eventName = eventName.toLowerCase();
        if ((0, $2tHqU.hexDataLength)(eventName) === 32) return "tx:" + eventName;
        if (eventName.indexOf(":") === -1) return eventName;
    } else if (Array.isArray(eventName)) return "filter:*:" + $092910e3d0b8a167$var$serializeTopics(eventName);
    else if ((0, $fH8QX.ForkEvent).isForkEvent(eventName)) {
        $092910e3d0b8a167$var$logger.warn("not implemented");
        throw new Error("not implemented");
    } else if (eventName && typeof eventName === "object") return "filter:" + (eventName.address || "*") + ":" + $092910e3d0b8a167$var$serializeTopics(eventName.topics || []);
    throw new Error("invalid event - " + eventName);
}
//////////////////////////////
// Helper Object
function $092910e3d0b8a167$var$getTime() {
    return new Date().getTime();
}
function $092910e3d0b8a167$var$stall(duration) {
    return new Promise(function(resolve) {
        setTimeout(resolve, duration);
    });
}
//////////////////////////////
// Provider Object
/**
 *  EventType
 *   - "block"
 *   - "poll"
 *   - "didPoll"
 *   - "pending"
 *   - "error"
 *   - "network"
 *   - filter
 *   - topics array
 *   - transaction hash
 */ var $092910e3d0b8a167$var$PollableEvents = [
    "block",
    "network",
    "pending",
    "poll"
];
var $092910e3d0b8a167$export$d61e24a684f9e51 = /*#__PURE__*/ function() {
    function Event(tag, listener, once) {
        (0, $9j09T._)(this, Event);
        (0, $iqBKf.defineReadOnly)(this, "tag", tag);
        (0, $iqBKf.defineReadOnly)(this, "listener", listener);
        (0, $iqBKf.defineReadOnly)(this, "once", once);
    }
    (0, $eDeHT._)(Event, [
        {
            key: "event",
            get: function get() {
                switch(this.type){
                    case "tx":
                        return this.hash;
                    case "filter":
                        return this.filter;
                }
                return this.tag;
            }
        },
        {
            key: "type",
            get: function get() {
                return this.tag.split(":")[0];
            }
        },
        {
            key: "hash",
            get: function get() {
                var comps = this.tag.split(":");
                if (comps[0] !== "tx") return null;
                return comps[1];
            }
        },
        {
            key: "filter",
            get: function get() {
                var comps = this.tag.split(":");
                if (comps[0] !== "filter") return null;
                var address = comps[1];
                var topics = $092910e3d0b8a167$var$deserializeTopics(comps[2]);
                var filter = {};
                if (topics.length > 0) filter.topics = topics;
                if (address && address !== "*") filter.address = address;
                return filter;
            }
        },
        {
            key: "pollable",
            value: function pollable() {
                return this.tag.indexOf(":") >= 0 || $092910e3d0b8a167$var$PollableEvents.indexOf(this.tag) >= 0;
            }
        }
    ]);
    return Event;
}();
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
var $092910e3d0b8a167$var$coinInfos = {
    "0": {
        symbol: "btc",
        p2pkh: 0x00,
        p2sh: 0x05,
        prefix: "bc"
    },
    "2": {
        symbol: "ltc",
        p2pkh: 0x30,
        p2sh: 0x32,
        prefix: "ltc"
    },
    "3": {
        symbol: "doge",
        p2pkh: 0x1e,
        p2sh: 0x16
    },
    "60": {
        symbol: "eth",
        ilk: "eth"
    },
    "61": {
        symbol: "etc",
        ilk: "eth"
    },
    "700": {
        symbol: "xdai",
        ilk: "eth"
    }
};
function $092910e3d0b8a167$var$bytes32ify(value) {
    return (0, $2tHqU.hexZeroPad)((0, $7ryKd.BigNumber).from(value).toHexString(), 32);
}
// Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)
function $092910e3d0b8a167$var$base58Encode(data) {
    return (0, $3fxSP.Base58).encode((0, $2tHqU.concat)([
        data,
        (0, $2tHqU.hexDataSlice)((0, $iM01F.sha256)((0, $iM01F.sha256)(data)), 0, 4)
    ]));
}
var $092910e3d0b8a167$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    new RegExp("^(ipfs)://(.*)$", "i"),
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
function $092910e3d0b8a167$var$_parseString(result) {
    try {
        return (0, $5RaVA.toUtf8String)($092910e3d0b8a167$var$_parseBytes(result));
    } catch (error) {}
    return null;
}
function $092910e3d0b8a167$var$_parseBytes(result) {
    if (result === "0x") return null;
    var offset = (0, $7ryKd.BigNumber).from((0, $2tHqU.hexDataSlice)(result, 0, 32)).toNumber();
    var length = (0, $7ryKd.BigNumber).from((0, $2tHqU.hexDataSlice)(result, offset, offset + 32)).toNumber();
    return (0, $2tHqU.hexDataSlice)(result, offset + 32, offset + 32 + length);
}
var $092910e3d0b8a167$export$8b4c839865b08288 = /*#__PURE__*/ function() {
    function Resolver(provider, address, name, resolvedAddress) {
        (0, $9j09T._)(this, Resolver);
        (0, $iqBKf.defineReadOnly)(this, "provider", provider);
        (0, $iqBKf.defineReadOnly)(this, "name", name);
        (0, $iqBKf.defineReadOnly)(this, "address", provider.formatter.address(address));
        (0, $iqBKf.defineReadOnly)(this, "_resolvedAddress", resolvedAddress);
    }
    (0, $eDeHT._)(Resolver, [
        {
            key: "_fetchBytes",
            value: function _fetchBytes(selector, parameters) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var tx, error;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // e.g. keccak256("addr(bytes32,uint256)")
                                tx = {
                                    to: this.address,
                                    data: (0, $2tHqU.hexConcat)([
                                        selector,
                                        (0, $ijr5h.namehash)(this.name),
                                        parameters || "0x"
                                    ])
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.provider.call(tx)
                                ];
                            case 2:
                                return [
                                    2,
                                    $092910e3d0b8a167$var$_parseBytes.apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                            case 3:
                                error = _state.sent();
                                if (error.code === (0, $ihGvV.Logger).errors.CALL_EXCEPTION) return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    null
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getAddress",
            value: function _getAddress(coinType, hexBytes) {
                var coinInfo = $092910e3d0b8a167$var$coinInfos[String(coinType)];
                if (coinInfo == null) $092910e3d0b8a167$var$logger.throwError("unsupported coin type: ".concat(coinType), (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "getAddress(".concat(coinType, ")")
                });
                if (coinInfo.ilk === "eth") return this.provider.formatter.address(hexBytes);
                var bytes = (0, $2tHqU.arrayify)(hexBytes);
                // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
                if (coinInfo.p2pkh != null) {
                    var p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
                    if (p2pkh) {
                        var length = parseInt(p2pkh[1], 16);
                        if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) return $092910e3d0b8a167$var$base58Encode((0, $2tHqU.concat)([
                            [
                                coinInfo.p2pkh
                            ],
                            "0x" + p2pkh[2]
                        ]));
                    }
                }
                // P2SH: OP_HASH160 <scriptHash> OP_EQUAL
                if (coinInfo.p2sh != null) {
                    var p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
                    if (p2sh) {
                        var length1 = parseInt(p2sh[1], 16);
                        if (p2sh[2].length === length1 * 2 && length1 >= 1 && length1 <= 75) return $092910e3d0b8a167$var$base58Encode((0, $2tHqU.concat)([
                            [
                                coinInfo.p2sh
                            ],
                            "0x" + p2sh[2]
                        ]));
                    }
                }
                // Bech32
                if (coinInfo.prefix != null) {
                    var length2 = bytes[1];
                    // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program
                    var _$version = bytes[0];
                    if (_$version === 0x00) {
                        if (length2 !== 20 && length2 !== 32) _$version = -1;
                    } else _$version = -1;
                    if (_$version >= 0 && bytes.length === 2 + length2 && length2 >= 1 && length2 <= 75) {
                        var words = (0, (/*@__PURE__*/$parcel$interopDefault($3tBj7))).toWords(bytes.slice(2));
                        words.unshift(_$version);
                        return (0, (/*@__PURE__*/$parcel$interopDefault($3tBj7))).encode(coinInfo.prefix, words);
                    }
                }
                return null;
            }
        },
        {
            key: "getAddress",
            value: function getAddress(coinType) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var transaction, hexBytes, error, hexBytes1, address;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (coinType == null) coinType = 60;
                                if (!(coinType === 60)) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                // keccak256("addr(bytes32)")
                                transaction = {
                                    to: this.address,
                                    data: "0x3b3b57de" + (0, $ijr5h.namehash)(this.name).substring(2)
                                };
                                return [
                                    4,
                                    this.provider.call(transaction)
                                ];
                            case 2:
                                hexBytes = _state.sent();
                                // No address
                                if (hexBytes === "0x" || hexBytes === (0, $dpMov.HashZero)) return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    this.provider.formatter.callAddress(hexBytes)
                                ];
                            case 3:
                                error = _state.sent();
                                if (error.code === (0, $ihGvV.Logger).errors.CALL_EXCEPTION) return [
                                    2,
                                    null
                                ];
                                throw error;
                            case 4:
                                return [
                                    4,
                                    this._fetchBytes("0xf1cb7e06", $092910e3d0b8a167$var$bytes32ify(coinType))
                                ];
                            case 5:
                                hexBytes1 = _state.sent();
                                // No address
                                if (hexBytes1 == null || hexBytes1 === "0x") return [
                                    2,
                                    null
                                ];
                                // Compute the address
                                address = this._getAddress(coinType, hexBytes1);
                                if (address == null) $092910e3d0b8a167$var$logger.throwError("invalid or unsupported coin data", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                                    operation: "getAddress(".concat(coinType, ")"),
                                    coinType: coinType,
                                    data: hexBytes1
                                });
                                return [
                                    2,
                                    address
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getAvatar",
            value: function getAvatar() {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var linkage, avatar, i, match, _, selector, owner, _tmp, comps, addr, tokenId, tokenOwner, _1, _2, balance, _3, tx, metadataUrl, metadata, error;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                linkage = [];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    19,
                                    ,
                                    20
                                ]);
                                return [
                                    4,
                                    this.getText("avatar")
                                ];
                            case 2:
                                avatar = _state.sent();
                                if (avatar == null) return [
                                    2,
                                    null
                                ];
                                i = 0;
                                _state.label = 3;
                            case 3:
                                if (!(i < $092910e3d0b8a167$var$matchers.length)) return [
                                    3,
                                    18
                                ];
                                match = avatar.match($092910e3d0b8a167$var$matchers[i]);
                                if (match == null) return [
                                    3,
                                    17
                                ];
                                _ = match[1];
                                switch(_){
                                    case "https":
                                        return [
                                            3,
                                            4
                                        ];
                                    case "data":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "ipfs":
                                        return [
                                            3,
                                            6
                                        ];
                                    case "erc721":
                                        return [
                                            3,
                                            7
                                        ];
                                    case "erc1155":
                                        return [
                                            3,
                                            7
                                        ];
                                }
                                return [
                                    3,
                                    17
                                ];
                            case 4:
                                linkage.push({
                                    type: "url",
                                    content: avatar
                                });
                                return [
                                    2,
                                    {
                                        linkage: linkage,
                                        url: avatar
                                    }
                                ];
                            case 5:
                                linkage.push({
                                    type: "data",
                                    content: avatar
                                });
                                return [
                                    2,
                                    {
                                        linkage: linkage,
                                        url: avatar
                                    }
                                ];
                            case 6:
                                linkage.push({
                                    type: "ipfs",
                                    content: avatar
                                });
                                return [
                                    2,
                                    {
                                        linkage: linkage,
                                        url: "https://gateway.ipfs.io/ipfs/".concat(avatar.substring(7))
                                    }
                                ];
                            case 7:
                                // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                                selector = match[1] === "erc721" ? "0xc87b56dd" : "0x0e89341c";
                                linkage.push({
                                    type: match[1],
                                    content: avatar
                                });
                                _tmp = this._resolvedAddress;
                                if (_tmp) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    this.getAddress()
                                ];
                            case 8:
                                _tmp = _state.sent();
                                _state.label = 9;
                            case 9:
                                owner = _tmp;
                                comps = (match[2] || "").split("/");
                                if (comps.length !== 2) return [
                                    2,
                                    null
                                ];
                                return [
                                    4,
                                    this.provider.formatter.address(comps[0])
                                ];
                            case 10:
                                addr = _state.sent();
                                tokenId = (0, $2tHqU.hexZeroPad)((0, $7ryKd.BigNumber).from(comps[1]).toHexString(), 32);
                                if (!(match[1] === "erc721")) return [
                                    3,
                                    12
                                ];
                                _2 = (_1 = this.provider.formatter).callAddress;
                                return [
                                    4,
                                    this.provider.call({
                                        to: addr,
                                        data: (0, $2tHqU.hexConcat)([
                                            "0x6352211e",
                                            tokenId
                                        ])
                                    })
                                ];
                            case 11:
                                tokenOwner = _2.apply(_1, [
                                    _state.sent()
                                ]);
                                if (owner !== tokenOwner) return [
                                    2,
                                    null
                                ];
                                linkage.push({
                                    type: "owner",
                                    content: tokenOwner
                                });
                                return [
                                    3,
                                    14
                                ];
                            case 12:
                                if (!(match[1] === "erc1155")) return [
                                    3,
                                    14
                                ];
                                _3 = (0, $7ryKd.BigNumber).from;
                                return [
                                    4,
                                    this.provider.call({
                                        to: addr,
                                        data: (0, $2tHqU.hexConcat)([
                                            "0x00fdd58e",
                                            (0, $2tHqU.hexZeroPad)(owner, 32),
                                            tokenId
                                        ])
                                    })
                                ];
                            case 13:
                                balance = _3.apply((0, $7ryKd.BigNumber), [
                                    _state.sent()
                                ]);
                                if (balance.isZero()) return [
                                    2,
                                    null
                                ];
                                linkage.push({
                                    type: "balance",
                                    content: balance.toString()
                                });
                                _state.label = 14;
                            case 14:
                                // Call the token contract for the metadata URL
                                tx = {
                                    to: this.provider.formatter.address(comps[0]),
                                    data: (0, $2tHqU.hexConcat)([
                                        selector,
                                        tokenId
                                    ])
                                };
                                return [
                                    4,
                                    this.provider.call(tx)
                                ];
                            case 15:
                                metadataUrl = $092910e3d0b8a167$var$_parseString.apply(void 0, [
                                    _state.sent()
                                ]);
                                if (metadataUrl == null) return [
                                    2,
                                    null
                                ];
                                linkage.push({
                                    type: "metadata-url",
                                    content: metadataUrl
                                });
                                // ERC-1155 allows a generic {id} in the URL
                                if (match[1] === "erc1155") metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
                                return [
                                    4,
                                    (0, $l3Xj2.fetchJson)(metadataUrl)
                                ];
                            case 16:
                                metadata = _state.sent();
                                // Pull the image URL out
                                if (!metadata || typeof metadata.image !== "string" || !metadata.image.match(/^https:\/\//i)) return [
                                    2,
                                    null
                                ];
                                linkage.push({
                                    type: "metadata",
                                    content: JSON.stringify(metadata)
                                });
                                linkage.push({
                                    type: "url",
                                    content: metadata.image
                                });
                                return [
                                    2,
                                    {
                                        linkage: linkage,
                                        url: metadata.image
                                    }
                                ];
                            case 17:
                                i++;
                                return [
                                    3,
                                    3
                                ];
                            case 18:
                                return [
                                    3,
                                    20
                                ];
                            case 19:
                                error = _state.sent();
                                return [
                                    3,
                                    20
                                ];
                            case 20:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getContentHash",
            value: function getContentHash() {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var hexBytes, ipfs, length, swarm;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._fetchBytes("0xbc1c58d1")
                                ];
                            case 1:
                                hexBytes = _state.sent();
                                // No contenthash
                                if (hexBytes == null || hexBytes === "0x") return [
                                    2,
                                    null
                                ];
                                // IPFS (CID: 1, Type: DAG-PB)
                                ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
                                if (ipfs) {
                                    length = parseInt(ipfs[3], 16);
                                    if (ipfs[4].length === length * 2) return [
                                        2,
                                        "ipfs://" + (0, $3fxSP.Base58).encode("0x" + ipfs[1])
                                    ];
                                }
                                // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
                                swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);
                                if (swarm) {
                                    if (swarm[1].length === 64) return [
                                        2,
                                        "bzz://" + swarm[1]
                                    ];
                                }
                                return [
                                    2,
                                    $092910e3d0b8a167$var$logger.throwError("invalid or unsupported content hash data", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                                        operation: "getContentHash()",
                                        data: hexBytes
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getText",
            value: function getText(key) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var keyBytes, hexBytes;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // The key encoded as parameter to fetchBytes
                                keyBytes = (0, $5RaVA.toUtf8Bytes)(key);
                                // The nodehash consumes the first slot, so the string pointer targets
                                // offset 64, with the length at offset 64 and data starting at offset 96
                                keyBytes = (0, $2tHqU.concat)([
                                    $092910e3d0b8a167$var$bytes32ify(64),
                                    $092910e3d0b8a167$var$bytes32ify(keyBytes.length),
                                    keyBytes
                                ]);
                                // Pad to word-size (32 bytes)
                                if (keyBytes.length % 32 !== 0) keyBytes = (0, $2tHqU.concat)([
                                    keyBytes,
                                    (0, $2tHqU.hexZeroPad)("0x", 32 - key.length % 32)
                                ]);
                                return [
                                    4,
                                    this._fetchBytes("0x59d1d43c", (0, $2tHqU.hexlify)(keyBytes))
                                ];
                            case 1:
                                hexBytes = _state.sent();
                                if (hexBytes == null || hexBytes === "0x") return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    (0, $5RaVA.toUtf8String)(hexBytes)
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return Resolver;
}();
var $092910e3d0b8a167$var$defaultFormatter = null;
var $092910e3d0b8a167$var$nextPollId = 1;
var $092910e3d0b8a167$export$ff3f6dd83125ac45 = /*#__PURE__*/ function _target(Provider1) {
    (0, $i0LXg._)(BaseProvider, Provider1);
    var _super = (0, $a1vXf._)(BaseProvider);
    function BaseProvider(network) {
        (0, $9j09T._)(this, BaseProvider);
        var _this;
        $092910e3d0b8a167$var$logger.checkNew(this instanceof BaseProvider ? this.constructor : void 0, (0, $fH8QX.Provider));
        _this = _super.call(this);
        // Events being listened to
        _this._events = [];
        _this._emitted = {
            block: -2
        };
        _this.formatter = (this instanceof BaseProvider ? this.constructor : void 0).getFormatter();
        // If network is any, this Provider allows the underlying
        // network to change dynamically, and we auto-detect the
        // current network
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "anyNetwork", network === "any");
        if (_this.anyNetwork) network = _this.detectNetwork();
        if (network instanceof Promise) {
            _this._networkPromise = network;
            // Squash any "unhandled promise" errors; that do not need to be handled
            network.catch(function(error) {});
            // Trigger initial network setting (async)
            _this._ready().catch(function(error) {});
        } else {
            var knownNetwork = (0, $iqBKf.getStatic)(this instanceof BaseProvider ? this.constructor : void 0, "getNetwork")(network);
            if (knownNetwork) {
                (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "_network", knownNetwork);
                _this.emit("network", knownNetwork, null);
            } else $092910e3d0b8a167$var$logger.throwArgumentError("invalid network", "network", network);
        }
        _this._maxInternalBlockNumber = -1024;
        _this._lastBlockNumber = -2;
        _this._pollingInterval = 4000;
        _this._fastQueryDate = 0;
        return _this;
    }
    (0, $eDeHT._)(BaseProvider, [
        {
            key: "_ready",
            value: function _ready() {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var network, error;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(this._network == null)) return [
                                    3,
                                    7
                                ];
                                network = null;
                                if (!this._networkPromise) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this._networkPromise
                                ];
                            case 2:
                                network = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                if (!(network == null)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    this.detectNetwork()
                                ];
                            case 5:
                                network = _state.sent();
                                _state.label = 6;
                            case 6:
                                // This should never happen; every Provider sub-class should have
                                // suggested a network by here (or have thrown).
                                if (!network) $092910e3d0b8a167$var$logger.throwError("no network detected", (0, $ihGvV.Logger).errors.UNKNOWN_ERROR, {});
                                // Possible this call stacked so do not call defineReadOnly again
                                if (this._network == null) {
                                    if (this.anyNetwork) this._network = network;
                                    else (0, $iqBKf.defineReadOnly)(this, "_network", network);
                                    this.emit("network", network, null);
                                }
                                _state.label = 7;
                            case 7:
                                return [
                                    2,
                                    this._network
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "ready",
            get: // This will always return the most recently established network.
            // For "any", this can change (a "network" event is emitted before
            // any change is reflected); otherwise this cannot change
            function get() {
                var _this = this;
                return (0, $l3Xj2.poll)(function() {
                    return _this._ready().then(function(network) {
                        return network;
                    }, function(error) {
                        // If the network isn't running yet, we will wait
                        if (error.code === (0, $ihGvV.Logger).errors.NETWORK_ERROR && error.event === "noNetwork") return undefined;
                        throw error;
                    });
                });
            }
        },
        {
            // Fetches the blockNumber, but will reuse any result that is less
            // than maxAge old or has been requested since the last request
            key: "_getInternalBlockNumber",
            value: function _getInternalBlockNumber(maxAge) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var _this, internalBlockNumber, result, error, reqTime, checkInternalBlockNumber;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this._ready()
                                ];
                            case 1:
                                _state.sent();
                                if (!(maxAge > 0)) return [
                                    3,
                                    7
                                ];
                                _state.label = 2;
                            case 2:
                                if (!this._internalBlockNumber) return [
                                    3,
                                    7
                                ];
                                // ..."remember" which fetch we started with
                                internalBlockNumber = this._internalBlockNumber;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    internalBlockNumber
                                ];
                            case 4:
                                result = _state.sent();
                                if ($092910e3d0b8a167$var$getTime() - result.respTime <= maxAge) return [
                                    2,
                                    result.blockNumber
                                ];
                                // Too old; fetch a new value
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                error = _state.sent();
                                // The fetch rejected; if we are the first to get the
                                // rejection, drop through so we replace it with a new
                                // fetch; all others blocked will then get that fetch
                                // which won't match the one they "remembered" and loop
                                if (this._internalBlockNumber === internalBlockNumber) return [
                                    3,
                                    7
                                ];
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    3,
                                    2
                                ];
                            case 7:
                                reqTime = $092910e3d0b8a167$var$getTime();
                                checkInternalBlockNumber = (0, $iqBKf.resolveProperties)({
                                    blockNumber: this.perform("getBlockNumber", {}),
                                    networkError: this.getNetwork().then(function(network) {
                                        return null;
                                    }, function(error) {
                                        return error;
                                    })
                                }).then(function(param) {
                                    var blockNumber = param.blockNumber, networkError = param.networkError;
                                    if (networkError) {
                                        // Unremember this bad internal block number
                                        if (_this._internalBlockNumber === checkInternalBlockNumber) _this._internalBlockNumber = null;
                                        throw networkError;
                                    }
                                    var respTime = $092910e3d0b8a167$var$getTime();
                                    blockNumber = (0, $7ryKd.BigNumber).from(blockNumber).toNumber();
                                    if (blockNumber < _this._maxInternalBlockNumber) blockNumber = _this._maxInternalBlockNumber;
                                    _this._maxInternalBlockNumber = blockNumber;
                                    _this._setFastBlockNumber(blockNumber); // @TODO: Still need this?
                                    return {
                                        blockNumber: blockNumber,
                                        reqTime: reqTime,
                                        respTime: respTime
                                    };
                                });
                                this._internalBlockNumber = checkInternalBlockNumber;
                                // Swallow unhandled exceptions; if needed they are handled else where
                                checkInternalBlockNumber.catch(function(error) {
                                    // Don't null the dead (rejected) fetch, if it has already been updated
                                    if (_this._internalBlockNumber === checkInternalBlockNumber) _this._internalBlockNumber = null;
                                });
                                return [
                                    4,
                                    checkInternalBlockNumber
                                ];
                            case 8:
                                return [
                                    2,
                                    _state.sent().blockNumber
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "poll",
            value: function poll() {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var _this, pollId, runners, blockNumber, error, i;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                pollId = $092910e3d0b8a167$var$nextPollId++;
                                // Track all running promises, so we can trigger a post-poll once they are complete
                                runners = [];
                                blockNumber = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this._getInternalBlockNumber(100 + this.pollingInterval / 2)
                                ];
                            case 2:
                                blockNumber = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                this.emit("error", error);
                                return [
                                    2
                                ];
                            case 4:
                                this._setFastBlockNumber(blockNumber);
                                // Emit a poll event after we have the latest (fast) block number
                                this.emit("poll", pollId, blockNumber);
                                // If the block has not changed, meh.
                                if (blockNumber === this._lastBlockNumber) {
                                    this.emit("didPoll", pollId);
                                    return [
                                        2
                                    ];
                                }
                                // First polling cycle, trigger a "block" events
                                if (this._emitted.block === -2) this._emitted.block = blockNumber - 1;
                                if (Math.abs(this._emitted.block - blockNumber) > 1000) {
                                    $092910e3d0b8a167$var$logger.warn("network block skew detected; skipping block events (emitted=".concat(this._emitted.block, " blockNumber").concat(blockNumber, ")"));
                                    this.emit("error", $092910e3d0b8a167$var$logger.makeError("network block skew detected", (0, $ihGvV.Logger).errors.NETWORK_ERROR, {
                                        blockNumber: blockNumber,
                                        event: "blockSkew",
                                        previousBlockNumber: this._emitted.block
                                    }));
                                    this.emit("block", blockNumber);
                                } else // Notify all listener for each block that has passed
                                for(i = this._emitted.block + 1; i <= blockNumber; i++)this.emit("block", i);
                                // The emitted block was updated, check for obsolete events
                                if (this._emitted.block !== blockNumber) {
                                    this._emitted.block = blockNumber;
                                    Object.keys(this._emitted).forEach(function(key) {
                                        // The block event does not expire
                                        if (key === "block") return;
                                        // The block we were at when we emitted this event
                                        var eventBlockNumber = _this._emitted[key];
                                        // We cannot garbage collect pending transactions or blocks here
                                        // They should be garbage collected by the Provider when setting
                                        // "pending" events
                                        if (eventBlockNumber === "pending") return;
                                        // Evict any transaction hashes or block hashes over 12 blocks
                                        // old, since they should not return null anyways
                                        if (blockNumber - eventBlockNumber > 12) delete _this._emitted[key];
                                    });
                                }
                                // First polling cycle
                                if (this._lastBlockNumber === -2) this._lastBlockNumber = blockNumber - 1;
                                // Find all transaction hashes we are waiting on
                                this._events.forEach(function(event) {
                                    switch(event.type){
                                        case "tx":
                                            {
                                                var hash = event.hash;
                                                var runner = _this.getTransactionReceipt(hash).then(function(receipt) {
                                                    if (!receipt || receipt.blockNumber == null) return null;
                                                    _this._emitted["t:" + hash] = receipt.blockNumber;
                                                    _this.emit(hash, receipt);
                                                    return null;
                                                }).catch(function(error) {
                                                    _this.emit("error", error);
                                                });
                                                runners.push(runner);
                                                break;
                                            }
                                        case "filter":
                                            {
                                                var filter = event.filter;
                                                filter.fromBlock = _this._lastBlockNumber + 1;
                                                filter.toBlock = blockNumber;
                                                var runner1 = _this.getLogs(filter).then(function(logs) {
                                                    if (logs.length === 0) return;
                                                    logs.forEach(function(log) {
                                                        _this._emitted["b:" + log.blockHash] = log.blockNumber;
                                                        _this._emitted["t:" + log.transactionHash] = log.blockNumber;
                                                        _this.emit(filter, log);
                                                    });
                                                }).catch(function(error) {
                                                    _this.emit("error", error);
                                                });
                                                runners.push(runner1);
                                                break;
                                            }
                                    }
                                });
                                this._lastBlockNumber = blockNumber;
                                // Once all events for this loop have been processed, emit "didPoll"
                                Promise.all(runners).then(function() {
                                    _this.emit("didPoll", pollId);
                                }).catch(function(error) {
                                    _this.emit("error", error);
                                });
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            // Deprecated; do not use this
            key: "resetEventsBlock",
            value: function resetEventsBlock(blockNumber) {
                this._lastBlockNumber = blockNumber - 1;
                if (this.polling) this.poll();
            }
        },
        {
            key: "network",
            get: function get() {
                return this._network;
            }
        },
        {
            // This method should query the network if the underlying network
            // can change, such as when connected to a JSON-RPC backend
            key: "detectNetwork",
            value: function detectNetwork() {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        return [
                            2,
                            $092910e3d0b8a167$var$logger.throwError("provider does not support network detection", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                                operation: "provider.detectNetwork"
                            })
                        ];
                    });
                });
            }
        },
        {
            key: "getNetwork",
            value: function getNetwork() {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var network, currentNetwork, error;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._ready()
                                ];
                            case 1:
                                network = _state.sent();
                                return [
                                    4,
                                    this.detectNetwork()
                                ];
                            case 2:
                                currentNetwork = _state.sent();
                                if (!(network.chainId !== currentNetwork.chainId)) return [
                                    3,
                                    5
                                ];
                                if (!this.anyNetwork) return [
                                    3,
                                    4
                                ];
                                this._network = currentNetwork;
                                // Reset all internal block number guards and caches
                                this._lastBlockNumber = -2;
                                this._fastBlockNumber = null;
                                this._fastBlockNumberPromise = null;
                                this._fastQueryDate = 0;
                                this._emitted.block = -2;
                                this._maxInternalBlockNumber = -1024;
                                this._internalBlockNumber = null;
                                // The "network" event MUST happen before this method resolves
                                // so any events have a chance to unregister, so we stall an
                                // additional event loop before returning from /this/ call
                                this.emit("network", currentNetwork, network);
                                return [
                                    4,
                                    $092910e3d0b8a167$var$stall(0)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    this._network
                                ];
                            case 4:
                                error = $092910e3d0b8a167$var$logger.makeError("underlying network changed", (0, $ihGvV.Logger).errors.NETWORK_ERROR, {
                                    event: "changed",
                                    network: network,
                                    detectedNetwork: currentNetwork
                                });
                                this.emit("error", error);
                                throw error;
                            case 5:
                                return [
                                    2,
                                    network
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "blockNumber",
            get: function get() {
                var _this = this;
                this._getInternalBlockNumber(100 + this.pollingInterval / 2).then(function(blockNumber) {
                    _this._setFastBlockNumber(blockNumber);
                }, function(error) {});
                return this._fastBlockNumber != null ? this._fastBlockNumber : -1;
            }
        },
        {
            key: "polling",
            get: function get() {
                return this._poller != null;
            },
            set: function set(value) {
                var _this = this;
                if (value && !this._poller) {
                    this._poller = setInterval(function() {
                        _this.poll();
                    }, this.pollingInterval);
                    if (!this._bootstrapPoll) this._bootstrapPoll = setTimeout(function() {
                        _this.poll();
                        // We block additional polls until the polling interval
                        // is done, to prevent overwhelming the poll function
                        _this._bootstrapPoll = setTimeout(function() {
                            // If polling was disabled, something may require a poke
                            // since starting the bootstrap poll and it was disabled
                            if (!_this._poller) _this.poll();
                            // Clear out the bootstrap so we can do another
                            _this._bootstrapPoll = null;
                        }, _this.pollingInterval);
                    }, 0);
                } else if (!value && this._poller) {
                    clearInterval(this._poller);
                    this._poller = null;
                }
            }
        },
        {
            key: "pollingInterval",
            get: function get() {
                return this._pollingInterval;
            },
            set: function set(value) {
                var _this = this;
                if (typeof value !== "number" || value <= 0 || parseInt(String(value)) != value) throw new Error("invalid polling interval");
                this._pollingInterval = value;
                if (this._poller) {
                    clearInterval(this._poller);
                    this._poller = setInterval(function() {
                        _this.poll();
                    }, this._pollingInterval);
                }
            }
        },
        {
            key: "_getFastBlockNumber",
            value: function _getFastBlockNumber() {
                var _this = this;
                var now = $092910e3d0b8a167$var$getTime();
                // Stale block number, request a newer value
                if (now - this._fastQueryDate > 2 * this._pollingInterval) {
                    this._fastQueryDate = now;
                    this._fastBlockNumberPromise = this.getBlockNumber().then(function(blockNumber) {
                        if (_this._fastBlockNumber == null || blockNumber > _this._fastBlockNumber) _this._fastBlockNumber = blockNumber;
                        return _this._fastBlockNumber;
                    });
                }
                return this._fastBlockNumberPromise;
            }
        },
        {
            key: "_setFastBlockNumber",
            value: function _setFastBlockNumber(blockNumber) {
                // Older block, maybe a stale request
                if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) return;
                // Update the time we updated the blocknumber
                this._fastQueryDate = $092910e3d0b8a167$var$getTime();
                // Newer block number, use  it
                if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
                    this._fastBlockNumber = blockNumber;
                    this._fastBlockNumberPromise = Promise.resolve(blockNumber);
                }
            }
        },
        {
            key: "waitForTransaction",
            value: function waitForTransaction(transactionHash, confirmations, timeout) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        return [
                            2,
                            this._waitForTransaction(transactionHash, confirmations == null ? 1 : confirmations, timeout || 0, null)
                        ];
                    });
                });
            }
        },
        {
            key: "_waitForTransaction",
            value: function _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var _this, receipt;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.getTransactionReceipt(transactionHash)
                                ];
                            case 1:
                                receipt = _state.sent();
                                // Receipt is already good
                                if ((receipt ? receipt.confirmations : 0) >= confirmations) return [
                                    2,
                                    receipt
                                ];
                                // Poll until the receipt is good...
                                return [
                                    2,
                                    new Promise(function(resolve, reject) {
                                        var cancelFuncs = [];
                                        var done = false;
                                        var alreadyDone = function alreadyDone() {
                                            if (done) return true;
                                            done = true;
                                            cancelFuncs.forEach(function(func) {
                                                func();
                                            });
                                            return false;
                                        };
                                        var minedHandler = function(receipt) {
                                            if (receipt.confirmations < confirmations) return;
                                            if (alreadyDone()) return;
                                            resolve(receipt);
                                        };
                                        _this.on(transactionHash, minedHandler);
                                        cancelFuncs.push(function() {
                                            _this.removeListener(transactionHash, minedHandler);
                                        });
                                        if (replaceable) {
                                            var lastBlockNumber = replaceable.startBlock;
                                            var scannedBlock = null;
                                            var replaceHandler = function(blockNumber) {
                                                return $092910e3d0b8a167$var$__awaiter(_this, void 0, void 0, function() {
                                                    var _this;
                                                    return (0, $itJXR.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                _this = this;
                                                                if (done) return [
                                                                    2
                                                                ];
                                                                // Wait 1 second; this is only used in the case of a fault, so
                                                                // we will trade off a little bit of latency for more consistent
                                                                // results and fewer JSON-RPC calls
                                                                return [
                                                                    4,
                                                                    $092910e3d0b8a167$var$stall(1000)
                                                                ];
                                                            case 1:
                                                                _state.sent();
                                                                this.getTransactionCount(replaceable.from).then(function(nonce) {
                                                                    return $092910e3d0b8a167$var$__awaiter(_this, void 0, void 0, function() {
                                                                        var mined, block, ti, tx, receipt, reason;
                                                                        return (0, $itJXR.__generator)(this, function(_state) {
                                                                            switch(_state.label){
                                                                                case 0:
                                                                                    if (done) return [
                                                                                        2
                                                                                    ];
                                                                                    if (!(nonce <= replaceable.nonce)) return [
                                                                                        3,
                                                                                        1
                                                                                    ];
                                                                                    lastBlockNumber = blockNumber;
                                                                                    return [
                                                                                        3,
                                                                                        9
                                                                                    ];
                                                                                case 1:
                                                                                    return [
                                                                                        4,
                                                                                        this.getTransaction(transactionHash)
                                                                                    ];
                                                                                case 2:
                                                                                    mined = _state.sent();
                                                                                    if (mined && mined.blockNumber != null) return [
                                                                                        2
                                                                                    ];
                                                                                    // First time scanning. We start a little earlier for some
                                                                                    // wiggle room here to handle the eventually consistent nature
                                                                                    // of blockchain (e.g. the getTransactionCount was for a
                                                                                    // different block)
                                                                                    if (scannedBlock == null) {
                                                                                        scannedBlock = lastBlockNumber - 3;
                                                                                        if (scannedBlock < replaceable.startBlock) scannedBlock = replaceable.startBlock;
                                                                                    }
                                                                                    _state.label = 3;
                                                                                case 3:
                                                                                    if (!(scannedBlock <= blockNumber)) return [
                                                                                        3,
                                                                                        9
                                                                                    ];
                                                                                    if (done) return [
                                                                                        2
                                                                                    ];
                                                                                    return [
                                                                                        4,
                                                                                        this.getBlockWithTransactions(scannedBlock)
                                                                                    ];
                                                                                case 4:
                                                                                    block = _state.sent();
                                                                                    ti = 0;
                                                                                    _state.label = 5;
                                                                                case 5:
                                                                                    if (!(ti < block.transactions.length)) return [
                                                                                        3,
                                                                                        8
                                                                                    ];
                                                                                    tx = block.transactions[ti];
                                                                                    // Successfully mined!
                                                                                    if (tx.hash === transactionHash) return [
                                                                                        2
                                                                                    ];
                                                                                    if (!(tx.from === replaceable.from && tx.nonce === replaceable.nonce)) return [
                                                                                        3,
                                                                                        7
                                                                                    ];
                                                                                    if (done) return [
                                                                                        2
                                                                                    ];
                                                                                    return [
                                                                                        4,
                                                                                        this.waitForTransaction(tx.hash, confirmations)
                                                                                    ];
                                                                                case 6:
                                                                                    receipt = _state.sent();
                                                                                    // Already resolved or rejected (prolly a timeout)
                                                                                    if (alreadyDone()) return [
                                                                                        2
                                                                                    ];
                                                                                    // The reason we were replaced
                                                                                    reason = "replaced";
                                                                                    if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) reason = "repriced";
                                                                                    else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) reason = "cancelled";
                                                                                    // Explain why we were replaced
                                                                                    reject($092910e3d0b8a167$var$logger.makeError("transaction was replaced", (0, $ihGvV.Logger).errors.TRANSACTION_REPLACED, {
                                                                                        cancelled: reason === "replaced" || reason === "cancelled",
                                                                                        reason: reason,
                                                                                        replacement: this._wrapTransaction(tx),
                                                                                        hash: transactionHash,
                                                                                        receipt: receipt
                                                                                    }));
                                                                                    return [
                                                                                        2
                                                                                    ];
                                                                                case 7:
                                                                                    ti++;
                                                                                    return [
                                                                                        3,
                                                                                        5
                                                                                    ];
                                                                                case 8:
                                                                                    scannedBlock++;
                                                                                    return [
                                                                                        3,
                                                                                        3
                                                                                    ];
                                                                                case 9:
                                                                                    if (done) return [
                                                                                        2
                                                                                    ];
                                                                                    this.once("block", replaceHandler);
                                                                                    return [
                                                                                        2
                                                                                    ];
                                                                            }
                                                                        });
                                                                    });
                                                                }, function(error) {
                                                                    if (done) return;
                                                                    _this.once("block", replaceHandler);
                                                                });
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                });
                                            };
                                            if (done) return;
                                            _this.once("block", replaceHandler);
                                            cancelFuncs.push(function() {
                                                _this.removeListener("block", replaceHandler);
                                            });
                                        }
                                        if (typeof timeout === "number" && timeout > 0) {
                                            var timer = setTimeout(function() {
                                                if (alreadyDone()) return;
                                                reject($092910e3d0b8a167$var$logger.makeError("timeout exceeded", (0, $ihGvV.Logger).errors.TIMEOUT, {
                                                    timeout: timeout
                                                }));
                                            }, timeout);
                                            if (timer.unref) timer.unref();
                                            cancelFuncs.push(function() {
                                                clearTimeout(timer);
                                            });
                                        }
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getBlockNumber",
            value: function getBlockNumber() {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        return [
                            2,
                            this._getInternalBlockNumber(0)
                        ];
                    });
                });
            }
        },
        {
            key: "getGasPrice",
            value: function getGasPrice() {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var result;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this.perform("getGasPrice", {})
                                ];
                            case 2:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $7ryKd.BigNumber).from(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $092910e3d0b8a167$var$logger.throwError("bad result from backend", (0, $ihGvV.Logger).errors.SERVER_ERROR, {
                                            method: "getGasPrice",
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getBalance",
            value: function getBalance(addressOrName, blockTag) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var params, result;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $iqBKf.resolveProperties)({
                                        address: this._getAddress(addressOrName),
                                        blockTag: this._getBlockTag(blockTag)
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("getBalance", params)
                                ];
                            case 3:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $7ryKd.BigNumber).from(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $092910e3d0b8a167$var$logger.throwError("bad result from backend", (0, $ihGvV.Logger).errors.SERVER_ERROR, {
                                            method: "getBalance",
                                            params: params,
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getTransactionCount",
            value: function getTransactionCount(addressOrName, blockTag) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var params, result;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $iqBKf.resolveProperties)({
                                        address: this._getAddress(addressOrName),
                                        blockTag: this._getBlockTag(blockTag)
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("getTransactionCount", params)
                                ];
                            case 3:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $7ryKd.BigNumber).from(result).toNumber()
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $092910e3d0b8a167$var$logger.throwError("bad result from backend", (0, $ihGvV.Logger).errors.SERVER_ERROR, {
                                            method: "getTransactionCount",
                                            params: params,
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getCode",
            value: function getCode(addressOrName, blockTag) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var params, result;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $iqBKf.resolveProperties)({
                                        address: this._getAddress(addressOrName),
                                        blockTag: this._getBlockTag(blockTag)
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("getCode", params)
                                ];
                            case 3:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $2tHqU.hexlify)(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $092910e3d0b8a167$var$logger.throwError("bad result from backend", (0, $ihGvV.Logger).errors.SERVER_ERROR, {
                                            method: "getCode",
                                            params: params,
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getStorageAt",
            value: function getStorageAt(addressOrName, position, blockTag) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var params, result;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $iqBKf.resolveProperties)({
                                        address: this._getAddress(addressOrName),
                                        blockTag: this._getBlockTag(blockTag),
                                        position: Promise.resolve(position).then(function(p) {
                                            return (0, $2tHqU.hexValue)(p);
                                        })
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("getStorageAt", params)
                                ];
                            case 3:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $2tHqU.hexlify)(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $092910e3d0b8a167$var$logger.throwError("bad result from backend", (0, $ihGvV.Logger).errors.SERVER_ERROR, {
                                            method: "getStorageAt",
                                            params: params,
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            // This should be called by any subclass wrapping a TransactionResponse
            key: "_wrapTransaction",
            value: function _wrapTransaction(tx, hash, startBlock) {
                var _this = this;
                if (hash != null && (0, $2tHqU.hexDataLength)(hash) !== 32) throw new Error("invalid response - sendTransaction");
                var result = tx;
                // Check the hash we expect is the same as the hash the server reported
                if (hash != null && tx.hash !== hash) $092910e3d0b8a167$var$logger.throwError("Transaction hash mismatch from Provider.sendTransaction.", (0, $ihGvV.Logger).errors.UNKNOWN_ERROR, {
                    expectedHash: tx.hash,
                    returnedHash: hash
                });
                result.wait = function(confirms, timeout) {
                    return $092910e3d0b8a167$var$__awaiter(_this, void 0, void 0, function() {
                        var replacement, receipt;
                        return (0, $itJXR.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (confirms == null) confirms = 1;
                                    if (timeout == null) timeout = 0;
                                    // Get the details to detect replacement
                                    replacement = undefined;
                                    if (confirms !== 0 && startBlock != null) replacement = {
                                        data: tx.data,
                                        from: tx.from,
                                        nonce: tx.nonce,
                                        to: tx.to,
                                        value: tx.value,
                                        startBlock: startBlock
                                    };
                                    return [
                                        4,
                                        this._waitForTransaction(tx.hash, confirms, timeout, replacement)
                                    ];
                                case 1:
                                    receipt = _state.sent();
                                    if (receipt == null && confirms === 0) return [
                                        2,
                                        null
                                    ];
                                    // No longer pending, allow the polling loop to garbage collect this
                                    this._emitted["t:" + tx.hash] = receipt.blockNumber;
                                    if (receipt.status === 0) $092910e3d0b8a167$var$logger.throwError("transaction failed", (0, $ihGvV.Logger).errors.CALL_EXCEPTION, {
                                        transactionHash: tx.hash,
                                        transaction: tx,
                                        receipt: receipt
                                    });
                                    return [
                                        2,
                                        receipt
                                    ];
                            }
                        });
                    });
                };
                return result;
            }
        },
        {
            key: "sendTransaction",
            value: function sendTransaction(signedTransaction) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var hexTx, tx, blockNumber, hash, error;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    Promise.resolve(signedTransaction).then(function(t) {
                                        return (0, $2tHqU.hexlify)(t);
                                    })
                                ];
                            case 2:
                                hexTx = _state.sent();
                                tx = this.formatter.transaction(signedTransaction);
                                if (tx.confirmations == null) tx.confirmations = 0;
                                return [
                                    4,
                                    this._getInternalBlockNumber(100 + 2 * this.pollingInterval)
                                ];
                            case 3:
                                blockNumber = _state.sent();
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    this.perform("sendTransaction", {
                                        signedTransaction: hexTx
                                    })
                                ];
                            case 5:
                                hash = _state.sent();
                                return [
                                    2,
                                    this._wrapTransaction(tx, hash, blockNumber)
                                ];
                            case 6:
                                error = _state.sent();
                                error.transaction = tx;
                                error.transactionHash = tx.hash;
                                throw error;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getTransactionRequest",
            value: function _getTransactionRequest(transaction) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var _this, values, tx, _, _1;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    transaction
                                ];
                            case 1:
                                values = _state.sent();
                                tx = {};
                                [
                                    "from",
                                    "to"
                                ].forEach(function(key) {
                                    if (values[key] == null) return;
                                    tx[key] = Promise.resolve(values[key]).then(function(v) {
                                        return v ? _this._getAddress(v) : null;
                                    });
                                });
                                [
                                    "gasLimit",
                                    "gasPrice",
                                    "maxFeePerGas",
                                    "maxPriorityFeePerGas",
                                    "value"
                                ].forEach(function(key) {
                                    if (values[key] == null) return;
                                    tx[key] = Promise.resolve(values[key]).then(function(v) {
                                        return v ? (0, $7ryKd.BigNumber).from(v) : null;
                                    });
                                });
                                [
                                    "type"
                                ].forEach(function(key) {
                                    if (values[key] == null) return;
                                    tx[key] = Promise.resolve(values[key]).then(function(v) {
                                        return v != null ? v : null;
                                    });
                                });
                                if (values.accessList) tx.accessList = this.formatter.accessList(values.accessList);
                                [
                                    "data"
                                ].forEach(function(key) {
                                    if (values[key] == null) return;
                                    tx[key] = Promise.resolve(values[key]).then(function(v) {
                                        return v ? (0, $2tHqU.hexlify)(v) : null;
                                    });
                                });
                                _1 = (_ = this.formatter).transactionRequest;
                                return [
                                    4,
                                    (0, $iqBKf.resolveProperties)(tx)
                                ];
                            case 2:
                                return [
                                    2,
                                    _1.apply(_, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getFilter",
            value: function _getFilter(filter) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var _this, result, _, _1;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    filter
                                ];
                            case 1:
                                filter = _state.sent();
                                result = {};
                                if (filter.address != null) result.address = this._getAddress(filter.address);
                                [
                                    "blockHash",
                                    "topics"
                                ].forEach(function(key) {
                                    if (filter[key] == null) return;
                                    result[key] = filter[key];
                                });
                                [
                                    "fromBlock",
                                    "toBlock"
                                ].forEach(function(key) {
                                    if (filter[key] == null) return;
                                    result[key] = _this._getBlockTag(filter[key]);
                                });
                                _1 = (_ = this.formatter).filter;
                                return [
                                    4,
                                    (0, $iqBKf.resolveProperties)(result)
                                ];
                            case 2:
                                return [
                                    2,
                                    _1.apply(_, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "call",
            value: function call(transaction, blockTag) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var params, result;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $iqBKf.resolveProperties)({
                                        transaction: this._getTransactionRequest(transaction),
                                        blockTag: this._getBlockTag(blockTag)
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("call", params)
                                ];
                            case 3:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $2tHqU.hexlify)(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $092910e3d0b8a167$var$logger.throwError("bad result from backend", (0, $ihGvV.Logger).errors.SERVER_ERROR, {
                                            method: "call",
                                            params: params,
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "estimateGas",
            value: function estimateGas(transaction) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var params, result;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $iqBKf.resolveProperties)({
                                        transaction: this._getTransactionRequest(transaction)
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("estimateGas", params)
                                ];
                            case 3:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $7ryKd.BigNumber).from(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $092910e3d0b8a167$var$logger.throwError("bad result from backend", (0, $ihGvV.Logger).errors.SERVER_ERROR, {
                                            method: "estimateGas",
                                            params: params,
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getAddress",
            value: function _getAddress(addressOrName) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var address;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    addressOrName
                                ];
                            case 1:
                                addressOrName = _state.sent();
                                if (typeof addressOrName !== "string") $092910e3d0b8a167$var$logger.throwArgumentError("invalid address or ENS name", "name", addressOrName);
                                return [
                                    4,
                                    this.resolveName(addressOrName)
                                ];
                            case 2:
                                address = _state.sent();
                                if (address == null) $092910e3d0b8a167$var$logger.throwError("ENS name not configured", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                                    operation: "resolveName(".concat(JSON.stringify(addressOrName), ")")
                                });
                                return [
                                    2,
                                    address
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getBlock",
            value: function _getBlock(blockHashOrBlockTag, includeTransactions) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var _this, blockNumber, params, error;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    blockHashOrBlockTag
                                ];
                            case 2:
                                blockHashOrBlockTag = _state.sent();
                                // If blockTag is a number (not "latest", etc), this is the block number
                                blockNumber = -128;
                                params = {
                                    includeTransactions: !!includeTransactions
                                };
                                if (!(0, $2tHqU.isHexString)(blockHashOrBlockTag, 32)) return [
                                    3,
                                    3
                                ];
                                params.blockHash = blockHashOrBlockTag;
                                return [
                                    3,
                                    6
                                ];
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    this._getBlockTag(blockHashOrBlockTag)
                                ];
                            case 4:
                                params.blockTag = _state.sent();
                                if ((0, $2tHqU.isHexString)(params.blockTag)) blockNumber = parseInt(params.blockTag.substring(2), 16);
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error = _state.sent();
                                $092910e3d0b8a167$var$logger.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    2,
                                    (0, $l3Xj2.poll)(function() {
                                        return $092910e3d0b8a167$var$__awaiter(_this, void 0, void 0, function() {
                                            var _this, block, blockNumber1, i, tx, confirmations, blockWithTxs;
                                            return (0, $itJXR.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _this = this;
                                                        return [
                                                            4,
                                                            this.perform("getBlock", params)
                                                        ];
                                                    case 1:
                                                        block = _state.sent();
                                                        // Block was not found
                                                        if (block == null) {
                                                            // For blockhashes, if we didn't say it existed, that blockhash may
                                                            // not exist. If we did see it though, perhaps from a log, we know
                                                            // it exists, and this node is just not caught up yet.
                                                            if (params.blockHash != null) {
                                                                if (this._emitted["b:" + params.blockHash] == null) return [
                                                                    2,
                                                                    null
                                                                ];
                                                            }
                                                            // For block tags, if we are asking for a future block, we return null
                                                            if (params.blockTag != null) {
                                                                if (blockNumber > this._emitted.block) return [
                                                                    2,
                                                                    null
                                                                ];
                                                            }
                                                            // Retry on the next block
                                                            return [
                                                                2,
                                                                undefined
                                                            ];
                                                        }
                                                        if (!includeTransactions) return [
                                                            3,
                                                            8
                                                        ];
                                                        blockNumber1 = null;
                                                        i = 0;
                                                        _state.label = 2;
                                                    case 2:
                                                        if (!(i < block.transactions.length)) return [
                                                            3,
                                                            7
                                                        ];
                                                        tx = block.transactions[i];
                                                        if (!(tx.blockNumber == null)) return [
                                                            3,
                                                            3
                                                        ];
                                                        tx.confirmations = 0;
                                                        return [
                                                            3,
                                                            6
                                                        ];
                                                    case 3:
                                                        if (!(tx.confirmations == null)) return [
                                                            3,
                                                            6
                                                        ];
                                                        if (!(blockNumber1 == null)) return [
                                                            3,
                                                            5
                                                        ];
                                                        return [
                                                            4,
                                                            this._getInternalBlockNumber(100 + 2 * this.pollingInterval)
                                                        ];
                                                    case 4:
                                                        blockNumber1 = _state.sent();
                                                        _state.label = 5;
                                                    case 5:
                                                        // Add the confirmations using the fast block number (pessimistic)
                                                        confirmations = blockNumber1 - tx.blockNumber + 1;
                                                        if (confirmations <= 0) confirmations = 1;
                                                        tx.confirmations = confirmations;
                                                        _state.label = 6;
                                                    case 6:
                                                        i++;
                                                        return [
                                                            3,
                                                            2
                                                        ];
                                                    case 7:
                                                        blockWithTxs = this.formatter.blockWithTransactions(block);
                                                        blockWithTxs.transactions = blockWithTxs.transactions.map(function(tx) {
                                                            return _this._wrapTransaction(tx);
                                                        });
                                                        return [
                                                            2,
                                                            blockWithTxs
                                                        ];
                                                    case 8:
                                                        return [
                                                            2,
                                                            this.formatter.block(block)
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        oncePoll: this
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getBlock",
            value: function getBlock(blockHashOrBlockTag) {
                return this._getBlock(blockHashOrBlockTag, false);
            }
        },
        {
            key: "getBlockWithTransactions",
            value: function getBlockWithTransactions(blockHashOrBlockTag) {
                return this._getBlock(blockHashOrBlockTag, true);
            }
        },
        {
            key: "getTransaction",
            value: function getTransaction(transactionHash) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var _this, params;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    transactionHash
                                ];
                            case 2:
                                transactionHash = _state.sent();
                                params = {
                                    transactionHash: this.formatter.hash(transactionHash, true)
                                };
                                return [
                                    2,
                                    (0, $l3Xj2.poll)(function() {
                                        return $092910e3d0b8a167$var$__awaiter(_this, void 0, void 0, function() {
                                            var result, tx, blockNumber, confirmations;
                                            return (0, $itJXR.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.perform("getTransaction", params)
                                                        ];
                                                    case 1:
                                                        result = _state.sent();
                                                        if (result == null) {
                                                            if (this._emitted["t:" + transactionHash] == null) return [
                                                                2,
                                                                null
                                                            ];
                                                            return [
                                                                2,
                                                                undefined
                                                            ];
                                                        }
                                                        tx = this.formatter.transactionResponse(result);
                                                        if (!(tx.blockNumber == null)) return [
                                                            3,
                                                            2
                                                        ];
                                                        tx.confirmations = 0;
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 2:
                                                        if (!(tx.confirmations == null)) return [
                                                            3,
                                                            4
                                                        ];
                                                        return [
                                                            4,
                                                            this._getInternalBlockNumber(100 + 2 * this.pollingInterval)
                                                        ];
                                                    case 3:
                                                        blockNumber = _state.sent();
                                                        // Add the confirmations using the fast block number (pessimistic)
                                                        confirmations = blockNumber - tx.blockNumber + 1;
                                                        if (confirmations <= 0) confirmations = 1;
                                                        tx.confirmations = confirmations;
                                                        _state.label = 4;
                                                    case 4:
                                                        return [
                                                            2,
                                                            this._wrapTransaction(tx)
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        oncePoll: this
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getTransactionReceipt",
            value: function getTransactionReceipt(transactionHash) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var _this, params;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    transactionHash
                                ];
                            case 2:
                                transactionHash = _state.sent();
                                params = {
                                    transactionHash: this.formatter.hash(transactionHash, true)
                                };
                                return [
                                    2,
                                    (0, $l3Xj2.poll)(function() {
                                        return $092910e3d0b8a167$var$__awaiter(_this, void 0, void 0, function() {
                                            var result, receipt, blockNumber, confirmations;
                                            return (0, $itJXR.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.perform("getTransactionReceipt", params)
                                                        ];
                                                    case 1:
                                                        result = _state.sent();
                                                        if (result == null) {
                                                            if (this._emitted["t:" + transactionHash] == null) return [
                                                                2,
                                                                null
                                                            ];
                                                            return [
                                                                2,
                                                                undefined
                                                            ];
                                                        }
                                                        // "geth-etc" returns receipts before they are ready
                                                        if (result.blockHash == null) return [
                                                            2,
                                                            undefined
                                                        ];
                                                        receipt = this.formatter.receipt(result);
                                                        if (!(receipt.blockNumber == null)) return [
                                                            3,
                                                            2
                                                        ];
                                                        receipt.confirmations = 0;
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 2:
                                                        if (!(receipt.confirmations == null)) return [
                                                            3,
                                                            4
                                                        ];
                                                        return [
                                                            4,
                                                            this._getInternalBlockNumber(100 + 2 * this.pollingInterval)
                                                        ];
                                                    case 3:
                                                        blockNumber = _state.sent();
                                                        // Add the confirmations using the fast block number (pessimistic)
                                                        confirmations = blockNumber - receipt.blockNumber + 1;
                                                        if (confirmations <= 0) confirmations = 1;
                                                        receipt.confirmations = confirmations;
                                                        _state.label = 4;
                                                    case 4:
                                                        return [
                                                            2,
                                                            receipt
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        oncePoll: this
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getLogs",
            value: function getLogs(filter) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var params, logs;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $iqBKf.resolveProperties)({
                                        filter: this._getFilter(filter)
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("getLogs", params)
                                ];
                            case 3:
                                logs = _state.sent();
                                logs.forEach(function(log) {
                                    if (log.removed == null) log.removed = false;
                                });
                                return [
                                    2,
                                    (0, $hbpzV.Formatter).arrayOf(this.formatter.filterLog.bind(this.formatter))(logs)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getEtherPrice",
            value: function getEtherPrice() {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    this.perform("getEtherPrice", {})
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getBlockTag",
            value: function _getBlockTag(blockTag) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var blockNumber;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    blockTag
                                ];
                            case 1:
                                blockTag = _state.sent();
                                if (!(typeof blockTag === "number" && blockTag < 0)) return [
                                    3,
                                    3
                                ];
                                if (blockTag % 1) $092910e3d0b8a167$var$logger.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
                                return [
                                    4,
                                    this._getInternalBlockNumber(100 + 2 * this.pollingInterval)
                                ];
                            case 2:
                                blockNumber = _state.sent();
                                blockNumber += blockTag;
                                if (blockNumber < 0) blockNumber = 0;
                                return [
                                    2,
                                    this.formatter.blockTag(blockNumber)
                                ];
                            case 3:
                                return [
                                    2,
                                    this.formatter.blockTag(blockTag)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getResolver",
            value: function getResolver(name) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var address, error;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    this._getResolver(name)
                                ];
                            case 1:
                                address = _state.sent();
                                if (address == null) return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    new $092910e3d0b8a167$export$8b4c839865b08288(this, address, name)
                                ];
                            case 2:
                                error = _state.sent();
                                if (error.code === (0, $ihGvV.Logger).errors.CALL_EXCEPTION) return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    null
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getResolver",
            value: function _getResolver(name) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var network, transaction, _, _1, error;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                network = _state.sent();
                                // No ENS...
                                if (!network.ensAddress) $092910e3d0b8a167$var$logger.throwError("network does not support ENS", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                                    operation: "ENS",
                                    network: network.name
                                });
                                // keccak256("resolver(bytes32)")
                                transaction = {
                                    to: network.ensAddress,
                                    data: "0x0178b8bf" + (0, $ijr5h.namehash)(name).substring(2)
                                };
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                _1 = (_ = this.formatter).callAddress;
                                return [
                                    4,
                                    this.call(transaction)
                                ];
                            case 3:
                                return [
                                    2,
                                    _1.apply(_, [
                                        _state.sent()
                                    ])
                                ];
                            case 4:
                                error = _state.sent();
                                if (error.code === (0, $ihGvV.Logger).errors.CALL_EXCEPTION) return [
                                    2,
                                    null
                                ];
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "resolveName",
            value: function resolveName(name) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var resolver;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    name
                                ];
                            case 1:
                                name = _state.sent();
                                // If it is already an address, nothing to resolve
                                try {
                                    return [
                                        2,
                                        Promise.resolve(this.formatter.address(name))
                                    ];
                                } catch (error) {
                                    // If is is a hexstring, the address is bad (See #694)
                                    if ((0, $2tHqU.isHexString)(name)) throw error;
                                }
                                if (typeof name !== "string") $092910e3d0b8a167$var$logger.throwArgumentError("invalid ENS name", "name", name);
                                return [
                                    4,
                                    this.getResolver(name)
                                ];
                            case 2:
                                resolver = _state.sent();
                                if (!resolver) return [
                                    2,
                                    null
                                ];
                                return [
                                    4,
                                    resolver.getAddress()
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "lookupAddress",
            value: function lookupAddress(address) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var reverseName, resolverAddress, bytes, length, name, addr;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    address
                                ];
                            case 1:
                                address = _state.sent();
                                address = this.formatter.address(address);
                                reverseName = address.substring(2).toLowerCase() + ".addr.reverse";
                                return [
                                    4,
                                    this._getResolver(reverseName)
                                ];
                            case 2:
                                resolverAddress = _state.sent();
                                if (!resolverAddress) return [
                                    2,
                                    null
                                ];
                                return [
                                    4,
                                    this.call({
                                        to: resolverAddress,
                                        data: "0x691f3431" + (0, $ijr5h.namehash)(reverseName).substring(2)
                                    })
                                ];
                            case 3:
                                bytes = (0, $2tHqU.arrayify).apply(void 0, [
                                    _state.sent()
                                ]);
                                // Strip off the dynamic string pointer (0x20)
                                if (bytes.length < 32 || !(0, $7ryKd.BigNumber).from(bytes.slice(0, 32)).eq(32)) return [
                                    2,
                                    null
                                ];
                                bytes = bytes.slice(32);
                                // Not a length-prefixed string
                                if (bytes.length < 32) return [
                                    2,
                                    null
                                ];
                                // Get the length of the string (from the length-prefix)
                                length = (0, $7ryKd.BigNumber).from(bytes.slice(0, 32)).toNumber();
                                bytes = bytes.slice(32);
                                // Length longer than available data
                                if (length > bytes.length) return [
                                    2,
                                    null
                                ];
                                name = (0, $5RaVA.toUtf8String)(bytes.slice(0, length));
                                return [
                                    4,
                                    this.resolveName(name)
                                ];
                            case 4:
                                addr = _state.sent();
                                if (addr != address) return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    name
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getAvatar",
            value: function getAvatar(nameOrAddress) {
                return $092910e3d0b8a167$var$__awaiter(this, void 0, void 0, function() {
                    var resolver, address, reverseName, resolverAddress, avatar;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                resolver = null;
                                if (!(0, $2tHqU.isHexString)(nameOrAddress)) return [
                                    3,
                                    2
                                ];
                                // Address; reverse lookup
                                address = this.formatter.address(nameOrAddress);
                                reverseName = address.substring(2).toLowerCase() + ".addr.reverse";
                                return [
                                    4,
                                    this._getResolver(reverseName)
                                ];
                            case 1:
                                resolverAddress = _state.sent();
                                if (!resolverAddress) return [
                                    2,
                                    null
                                ];
                                resolver = new $092910e3d0b8a167$export$8b4c839865b08288(this, resolverAddress, "_", address);
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    this.getResolver(nameOrAddress)
                                ];
                            case 3:
                                // ENS name; forward lookup
                                resolver = _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    resolver.getAvatar()
                                ];
                            case 5:
                                avatar = _state.sent();
                                if (avatar == null) return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    avatar.url
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "perform",
            value: function perform(method, params) {
                return $092910e3d0b8a167$var$logger.throwError(method + " not implemented", (0, $ihGvV.Logger).errors.NOT_IMPLEMENTED, {
                    operation: method
                });
            }
        },
        {
            key: "_startEvent",
            value: function _startEvent(event) {
                this.polling = this._events.filter(function(e) {
                    return e.pollable();
                }).length > 0;
            }
        },
        {
            key: "_stopEvent",
            value: function _stopEvent(event) {
                this.polling = this._events.filter(function(e) {
                    return e.pollable();
                }).length > 0;
            }
        },
        {
            key: "_addEventListener",
            value: function _addEventListener(eventName, listener, once) {
                var event = new $092910e3d0b8a167$export$d61e24a684f9e51($092910e3d0b8a167$var$getEventTag(eventName), listener, once);
                this._events.push(event);
                this._startEvent(event);
                return this;
            }
        },
        {
            key: "on",
            value: function on(eventName, listener) {
                return this._addEventListener(eventName, listener, false);
            }
        },
        {
            key: "once",
            value: function once(eventName, listener) {
                return this._addEventListener(eventName, listener, true);
            }
        },
        {
            key: "emit",
            value: function emit(eventName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _this = this;
                var result = false;
                var stopped = [];
                var eventTag = $092910e3d0b8a167$var$getEventTag(eventName);
                this._events = this._events.filter(function(event) {
                    if (event.tag !== eventTag) return true;
                    setTimeout(function() {
                        event.listener.apply(_this, args);
                    }, 0);
                    result = true;
                    if (event.once) {
                        stopped.push(event);
                        return false;
                    }
                    return true;
                });
                stopped.forEach(function(event) {
                    _this._stopEvent(event);
                });
                return result;
            }
        },
        {
            key: "listenerCount",
            value: function listenerCount(eventName) {
                if (!eventName) return this._events.length;
                var eventTag = $092910e3d0b8a167$var$getEventTag(eventName);
                return this._events.filter(function(event) {
                    return event.tag === eventTag;
                }).length;
            }
        },
        {
            key: "listeners",
            value: function listeners(eventName) {
                if (eventName == null) return this._events.map(function(event) {
                    return event.listener;
                });
                var eventTag = $092910e3d0b8a167$var$getEventTag(eventName);
                return this._events.filter(function(event) {
                    return event.tag === eventTag;
                }).map(function(event) {
                    return event.listener;
                });
            }
        },
        {
            key: "off",
            value: function off(eventName, listener) {
                var _this = this;
                if (listener == null) return this.removeAllListeners(eventName);
                var stopped = [];
                var found = false;
                var eventTag = $092910e3d0b8a167$var$getEventTag(eventName);
                this._events = this._events.filter(function(event) {
                    if (event.tag !== eventTag || event.listener != listener) return true;
                    if (found) return true;
                    found = true;
                    stopped.push(event);
                    return false;
                });
                stopped.forEach(function(event) {
                    _this._stopEvent(event);
                });
                return this;
            }
        },
        {
            key: "removeAllListeners",
            value: function removeAllListeners(eventName) {
                var _this = this;
                var stopped = [];
                if (eventName == null) {
                    stopped = this._events;
                    this._events = [];
                } else {
                    var eventTag = $092910e3d0b8a167$var$getEventTag(eventName);
                    this._events = this._events.filter(function(event) {
                        if (event.tag !== eventTag) return true;
                        stopped.push(event);
                        return false;
                    });
                }
                stopped.forEach(function(event) {
                    _this._stopEvent(event);
                });
                return this;
            }
        }
    ], [
        {
            key: "getFormatter",
            value: // @TODO: Remove this and just create a singleton formatter
            function getFormatter() {
                if ($092910e3d0b8a167$var$defaultFormatter == null) $092910e3d0b8a167$var$defaultFormatter = new (0, $hbpzV.Formatter)();
                return $092910e3d0b8a167$var$defaultFormatter;
            }
        },
        {
            key: "getNetwork",
            value: // @TODO: Remove this and just use getNetwork
            function getNetwork1(network) {
                return (0, $aCB1f.getNetwork)(network == null ? "homestead" : network);
            }
        }
    ]);
    return BaseProvider;
}((0, $fH8QX.Provider));

});
parcelRegister("ijr5h", function(module, exports) {

$parcel$export(module.exports, "isValidName", function () { return $d54f02affddde0f4$export$cce2300886e7ace6; });
$parcel$export(module.exports, "namehash", function () { return $d54f02affddde0f4$export$91d651ee363e1209; });

var $2tHqU = parcelRequire("2tHqU");

var $e2WFS = parcelRequire("e2WFS");
var $5RaVA = parcelRequire("5RaVA");

var $8Ub7X = parcelRequire("8Ub7X");

var $ihGvV = parcelRequire("ihGvV");

var $2Lbyz = parcelRequire("2Lbyz");
var $d54f02affddde0f4$var$logger = new (0, $ihGvV.Logger)((0, $2Lbyz.version));
var $d54f02affddde0f4$var$Zeros = new Uint8Array(32);
$d54f02affddde0f4$var$Zeros.fill(0);
var $d54f02affddde0f4$var$Partition = new RegExp("^((.*)\\.)?([^.]+)$");
function $d54f02affddde0f4$export$cce2300886e7ace6(name) {
    try {
        var comps = name.split(".");
        for(var i = 0; i < comps.length; i++){
            if ((0, $e2WFS.nameprep)(comps[i]).length === 0) throw new Error("empty");
        }
        return true;
    } catch (error) {}
    return false;
}
function $d54f02affddde0f4$export$91d651ee363e1209(name) {
    /* istanbul ignore if */ if (typeof name !== "string") $d54f02affddde0f4$var$logger.throwArgumentError("invalid ENS name; not a string", "name", name);
    var current = name;
    var result = $d54f02affddde0f4$var$Zeros;
    while(current.length){
        var partition = current.match($d54f02affddde0f4$var$Partition);
        if (partition == null || partition[2] === "") $d54f02affddde0f4$var$logger.throwArgumentError("invalid ENS address; missing component", "name", name);
        var label = (0, $5RaVA.toUtf8Bytes)((0, $e2WFS.nameprep)(partition[3]));
        result = (0, $8Ub7X.keccak256)((0, $2tHqU.concat)([
            result,
            (0, $8Ub7X.keccak256)(label)
        ]));
        current = partition[2] || "";
    }
    return (0, $2tHqU.hexlify)(result);
}

});
parcelRegister("e2WFS", function(module, exports) {

$parcel$export(module.exports, "nameprep", function () { return $a39ec41c21f473e1$export$94f0b6f93c619bc; });

var $5RaVA = parcelRequire("5RaVA");
"use strict";
function $a39ec41c21f473e1$var$bytes2(data) {
    if (data.length % 4 !== 0) throw new Error("bad data");
    var result = [];
    for(var i = 0; i < data.length; i += 4)result.push(parseInt(data.substring(i, i + 4), 16));
    return result;
}
function $a39ec41c21f473e1$var$createTable(data, func) {
    if (!func) func = function func(value) {
        return [
            parseInt(value, 16)
        ];
    };
    var lo = 0;
    var result = {};
    data.split(",").forEach(function(pair) {
        var comps = pair.split(":");
        lo += parseInt(comps[0], 16);
        result[lo] = func(comps[1]);
    });
    return result;
}
function $a39ec41c21f473e1$var$createRangeTable(data) {
    var hi = 0;
    return data.split(",").map(function(v) {
        var comps = v.split("-");
        if (comps.length === 1) comps[1] = "0";
        else if (comps[1] === "") comps[1] = "1";
        var lo = hi + parseInt(comps[0], 16);
        hi = parseInt(comps[1], 16);
        return {
            l: lo,
            h: hi
        };
    });
}
function $a39ec41c21f473e1$var$matchMap(value, ranges) {
    var lo = 0;
    for(var i = 0; i < ranges.length; i++){
        var range = ranges[i];
        lo += range.l;
        if (value >= lo && value <= lo + range.h && (value - lo) % (range.d || 1) === 0) {
            if (range.e && range.e.indexOf(value - lo) !== -1) continue;
            return range;
        }
    }
    return null;
}
var $a39ec41c21f473e1$var$Table_A_1_ranges = $a39ec41c21f473e1$var$createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d");
// @TODO: Make this relative...
var $a39ec41c21f473e1$var$Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map(function(v) {
    return parseInt(v, 16);
});
var $a39ec41c21f473e1$var$Table_B_2_ranges = [
    {
        h: 25,
        s: 32,
        l: 65
    },
    {
        h: 30,
        s: 32,
        e: [
            23
        ],
        l: 127
    },
    {
        h: 54,
        s: 1,
        e: [
            48
        ],
        l: 64,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 57,
        d: 2
    },
    {
        h: 44,
        s: 1,
        l: 17,
        d: 2
    },
    {
        h: 10,
        s: 1,
        e: [
            2,
            6,
            8
        ],
        l: 61,
        d: 2
    },
    {
        h: 16,
        s: 1,
        l: 68,
        d: 2
    },
    {
        h: 84,
        s: 1,
        e: [
            18,
            24,
            66
        ],
        l: 19,
        d: 2
    },
    {
        h: 26,
        s: 32,
        e: [
            17
        ],
        l: 435
    },
    {
        h: 22,
        s: 1,
        l: 71,
        d: 2
    },
    {
        h: 15,
        s: 80,
        l: 40
    },
    {
        h: 31,
        s: 32,
        l: 16
    },
    {
        h: 32,
        s: 1,
        l: 80,
        d: 2
    },
    {
        h: 52,
        s: 1,
        l: 42,
        d: 2
    },
    {
        h: 12,
        s: 1,
        l: 55,
        d: 2
    },
    {
        h: 40,
        s: 1,
        e: [
            38
        ],
        l: 15,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 48,
        d: 2
    },
    {
        h: 37,
        s: 48,
        l: 49
    },
    {
        h: 148,
        s: 1,
        l: 6351,
        d: 2
    },
    {
        h: 88,
        s: 1,
        l: 160,
        d: 2
    },
    {
        h: 15,
        s: 16,
        l: 704
    },
    {
        h: 25,
        s: 26,
        l: 854
    },
    {
        h: 25,
        s: 32,
        l: 55915
    },
    {
        h: 37,
        s: 40,
        l: 1247
    },
    {
        h: 25,
        s: -119711,
        l: 53248
    },
    {
        h: 25,
        s: -119763,
        l: 52
    },
    {
        h: 25,
        s: -119815,
        l: 52
    },
    {
        h: 25,
        s: -119867,
        e: [
            1,
            4,
            5,
            7,
            8,
            11,
            12,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -119919,
        l: 52
    },
    {
        h: 24,
        s: -119971,
        e: [
            2,
            7,
            8,
            17
        ],
        l: 52
    },
    {
        h: 24,
        s: -120023,
        e: [
            2,
            7,
            13,
            15,
            16,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -120075,
        l: 52
    },
    {
        h: 25,
        s: -120127,
        l: 52
    },
    {
        h: 25,
        s: -120179,
        l: 52
    },
    {
        h: 25,
        s: -120231,
        l: 52
    },
    {
        h: 25,
        s: -120283,
        l: 52
    },
    {
        h: 25,
        s: -120335,
        l: 52
    },
    {
        h: 24,
        s: -119543,
        e: [
            17
        ],
        l: 56
    },
    {
        h: 24,
        s: -119601,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119659,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119717,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119775,
        e: [
            17
        ],
        l: 58
    }
];
var $a39ec41c21f473e1$var$Table_B_2_lut_abs = $a39ec41c21f473e1$var$createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3");
var $a39ec41c21f473e1$var$Table_B_2_lut_rel = $a39ec41c21f473e1$var$createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7");
var $a39ec41c21f473e1$var$Table_B_2_complex = $a39ec41c21f473e1$var$createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $a39ec41c21f473e1$var$bytes2);
var $a39ec41c21f473e1$var$Table_C_ranges = $a39ec41c21f473e1$var$createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function $a39ec41c21f473e1$var$flatten(values) {
    return values.reduce(function(accum, value) {
        value.forEach(function(value) {
            accum.push(value);
        });
        return accum;
    }, []);
}
function $a39ec41c21f473e1$export$d1ae0d802533bef0(codepoint) {
    return !!$a39ec41c21f473e1$var$matchMap(codepoint, $a39ec41c21f473e1$var$Table_A_1_ranges);
}
function $a39ec41c21f473e1$export$9630a1f26a43b76c(codepoint) {
    var range = $a39ec41c21f473e1$var$matchMap(codepoint, $a39ec41c21f473e1$var$Table_B_2_ranges);
    if (range) return [
        codepoint + range.s
    ];
    var codes = $a39ec41c21f473e1$var$Table_B_2_lut_abs[codepoint];
    if (codes) return codes;
    var shift = $a39ec41c21f473e1$var$Table_B_2_lut_rel[codepoint];
    if (shift) return [
        codepoint + shift[0]
    ];
    var complex = $a39ec41c21f473e1$var$Table_B_2_complex[codepoint];
    if (complex) return complex;
    return null;
}
function $a39ec41c21f473e1$export$e07a548cae6d1553(codepoint) {
    return !!$a39ec41c21f473e1$var$matchMap(codepoint, $a39ec41c21f473e1$var$Table_C_ranges);
}
function $a39ec41c21f473e1$export$94f0b6f93c619bc(value) {
    // This allows platforms with incomplete normalize to bypass
    // it for very basic names which the built-in toLowerCase
    // will certainly handle correctly
    if (value.match(/^[a-z0-9-]*$/i) && value.length <= 59) return value.toLowerCase();
    // Get the code points (keeping the current normalization)
    var codes = (0, $5RaVA.toUtf8CodePoints)(value);
    codes = $a39ec41c21f473e1$var$flatten(codes.map(function(code) {
        // Substitute Table B.1 (Maps to Nothing)
        if ($a39ec41c21f473e1$var$Table_B_1_flags.indexOf(code) >= 0) return [];
        if (code >= 0xfe00 && code <= 0xfe0f) return [];
        // Substitute Table B.2 (Case Folding)
        var codesTableB2 = $a39ec41c21f473e1$export$9630a1f26a43b76c(code);
        if (codesTableB2) return codesTableB2;
        // No Substitution
        return [
            code
        ];
    }));
    // Normalize using form KC
    codes = (0, $5RaVA.toUtf8CodePoints)((0, $5RaVA._toUtf8String)(codes), (0, $5RaVA.UnicodeNormalizationForm).NFKC);
    // Prohibit Tables C.1.2, C.2.2, C.3, C.4, C.5, C.6, C.7, C.8, C.9
    codes.forEach(function(code) {
        if ($a39ec41c21f473e1$export$e07a548cae6d1553(code)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
    });
    // Prohibit Unassigned Code Points (Table A.1)
    codes.forEach(function(code) {
        if ($a39ec41c21f473e1$export$d1ae0d802533bef0(code)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
    });
    // IDNA extras
    var name = (0, $5RaVA._toUtf8String)(codes);
    // IDNA: 4.2.3.1
    if (name.substring(0, 1) === "-" || name.substring(2, 4) === "--" || name.substring(name.length - 1) === "-") throw new Error("invalid hyphen");
    // IDNA: 4.2.4
    if (name.length > 63) throw new Error("too long");
    return name;
}

});


parcelRegister("l3Xj2", function(module, exports) {

$parcel$export(module.exports, "_fetchData", function () { return $f557e1bd2862c3d0$export$e37fa27017c6c012; });
$parcel$export(module.exports, "fetchJson", function () { return $f557e1bd2862c3d0$export$6d71b655afe1638d; });
$parcel$export(module.exports, "poll", function () { return $f557e1bd2862c3d0$export$e0c10349b2c5e1d4; });

var $itJXR = parcelRequire("itJXR");

var $G4O4F = parcelRequire("G4O4F");

var $2tHqU = parcelRequire("2tHqU");

var $iqBKf = parcelRequire("iqBKf");

var $5RaVA = parcelRequire("5RaVA");

var $ihGvV = parcelRequire("ihGvV");

var $4sICk = parcelRequire("4sICk");

var $kuKp8 = parcelRequire("kuKp8");
"use strict";
var $f557e1bd2862c3d0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f557e1bd2862c3d0$var$logger = new (0, $ihGvV.Logger)((0, $4sICk.version));
function $f557e1bd2862c3d0$var$staller(duration) {
    return new Promise(function(resolve) {
        setTimeout(resolve, duration);
    });
}
function $f557e1bd2862c3d0$var$bodyify(value, type) {
    if (value == null) return null;
    if (typeof value === "string") return value;
    if ((0, $2tHqU.isBytesLike)(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) try {
            return (0, $5RaVA.toUtf8String)(value);
        } catch (error) {}
        return (0, $2tHqU.hexlify)(value);
    }
    return value;
}
function $f557e1bd2862c3d0$export$e37fa27017c6c012(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    var attemptLimit = typeof connection === "object" && connection.throttleLimit != null ? connection.throttleLimit : 12;
    $f557e1bd2862c3d0$var$logger.assertArgument(attemptLimit > 0 && attemptLimit % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    var throttleCallback = typeof connection === "object" ? connection.throttleCallback : null;
    var throttleSlotInterval = typeof connection === "object" && typeof connection.throttleSlotInterval === "number" ? connection.throttleSlotInterval : 100;
    $f557e1bd2862c3d0$var$logger.assertArgument(throttleSlotInterval > 0 && throttleSlotInterval % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    var headers = {};
    var url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    var options = {
        method: "GET"
    };
    var allow304 = false;
    var timeout = 120000;
    if (typeof connection === "string") url = connection;
    else if (typeof connection === "object") {
        if (connection == null || connection.url == null) $f557e1bd2862c3d0$var$logger.throwArgumentError("missing URL", "connection.url", connection);
        url = connection.url;
        if (typeof connection.timeout === "number" && connection.timeout > 0) timeout = connection.timeout;
        if (connection.headers) for(var key in connection.headers){
            headers[key.toLowerCase()] = {
                key: key,
                value: String(connection.headers[key])
            };
            if ([
                "if-none-match",
                "if-modified-since"
            ].indexOf(key.toLowerCase()) >= 0) allow304 = true;
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) $f557e1bd2862c3d0$var$logger.throwError("basic authentication requires a secure https url", (0, $ihGvV.Logger).errors.INVALID_ARGUMENT, {
                argument: "url",
                url: url,
                user: connection.user,
                password: "[REDACTED]"
            });
            var authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + (0, $G4O4F.encode)((0, $5RaVA.toUtf8Bytes)(authorization))
            };
        }
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) headers["content-type"] = {
            key: "Content-Type",
            value: "application/octet-stream"
        };
        if (headers["content-length"] == null) headers["content-length"] = {
            key: "Content-Length",
            value: String(body.length)
        };
    }
    var flatHeaders = {};
    Object.keys(headers).forEach(function(key) {
        var header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    var runningTimeout = function() {
        var timer = null;
        var promise = new Promise(function(resolve, reject) {
            if (timeout) timer = setTimeout(function() {
                if (timer == null) return;
                timer = null;
                reject($f557e1bd2862c3d0$var$logger.makeError("timeout", (0, $ihGvV.Logger).errors.TIMEOUT, {
                    requestBody: $f557e1bd2862c3d0$var$bodyify(options.body, flatHeaders["content-type"]),
                    requestMethod: options.method,
                    timeout: timeout,
                    url: url
                }));
            }, timeout);
        });
        var cancel = function cancel() {
            if (timer == null) return;
            clearTimeout(timer);
            timer = null;
        };
        return {
            promise: promise,
            cancel: cancel
        };
    }();
    var runningFetch = function() {
        return $f557e1bd2862c3d0$var$__awaiter(this, void 0, void 0, function() {
            var attempt, response, tryAgain, stall, retryAfter, error, _$body, result, error1, tryAgain1, timeout;
            return (0, $itJXR.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        attempt = 0;
                        _state.label = 1;
                    case 1:
                        if (!(attempt < attemptLimit)) return [
                            3,
                            19
                        ];
                        response = null;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4,
                            (0, $kuKp8.getUrl)(url, options)
                        ];
                    case 3:
                        response = _state.sent();
                        if (!(response.statusCode === 429 && attempt < attemptLimit)) return [
                            3,
                            7
                        ];
                        tryAgain = true;
                        if (!throttleCallback) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            throttleCallback(attempt, url)
                        ];
                    case 4:
                        tryAgain = _state.sent();
                        _state.label = 5;
                    case 5:
                        if (!tryAgain) return [
                            3,
                            7
                        ];
                        stall = 0;
                        retryAfter = response.headers["retry-after"];
                        if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) stall = parseInt(retryAfter) * 1000;
                        else stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                        //console.log("Stalling 429");
                        return [
                            4,
                            $f557e1bd2862c3d0$var$staller(stall)
                        ];
                    case 6:
                        _state.sent();
                        return [
                            3,
                            18
                        ];
                    case 7:
                        return [
                            3,
                            9
                        ];
                    case 8:
                        error = _state.sent();
                        response = error.response;
                        if (response == null) {
                            runningTimeout.cancel();
                            $f557e1bd2862c3d0$var$logger.throwError("missing response", (0, $ihGvV.Logger).errors.SERVER_ERROR, {
                                requestBody: $f557e1bd2862c3d0$var$bodyify(options.body, flatHeaders["content-type"]),
                                requestMethod: options.method,
                                serverError: error,
                                url: url
                            });
                        }
                        return [
                            3,
                            9
                        ];
                    case 9:
                        _$body = response.body;
                        if (allow304 && response.statusCode === 304) _$body = null;
                        else if (response.statusCode < 200 || response.statusCode >= 300) {
                            runningTimeout.cancel();
                            $f557e1bd2862c3d0$var$logger.throwError("bad response", (0, $ihGvV.Logger).errors.SERVER_ERROR, {
                                status: response.statusCode,
                                headers: response.headers,
                                body: $f557e1bd2862c3d0$var$bodyify(_$body, response.headers ? response.headers["content-type"] : null),
                                requestBody: $f557e1bd2862c3d0$var$bodyify(options.body, flatHeaders["content-type"]),
                                requestMethod: options.method,
                                url: url
                            });
                        }
                        if (!processFunc) return [
                            3,
                            17
                        ];
                        _state.label = 10;
                    case 10:
                        _state.trys.push([
                            10,
                            12,
                            ,
                            17
                        ]);
                        return [
                            4,
                            processFunc(_$body, response)
                        ];
                    case 11:
                        result = _state.sent();
                        runningTimeout.cancel();
                        return [
                            2,
                            result
                        ];
                    case 12:
                        error1 = _state.sent();
                        if (!(error1.throttleRetry && attempt < attemptLimit)) return [
                            3,
                            16
                        ];
                        tryAgain1 = true;
                        if (!throttleCallback) return [
                            3,
                            14
                        ];
                        return [
                            4,
                            throttleCallback(attempt, url)
                        ];
                    case 13:
                        tryAgain1 = _state.sent();
                        _state.label = 14;
                    case 14:
                        if (!tryAgain1) return [
                            3,
                            16
                        ];
                        timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                        //console.log("Stalling callback");
                        return [
                            4,
                            $f557e1bd2862c3d0$var$staller(timeout)
                        ];
                    case 15:
                        _state.sent();
                        return [
                            3,
                            18
                        ];
                    case 16:
                        runningTimeout.cancel();
                        $f557e1bd2862c3d0$var$logger.throwError("processing response error", (0, $ihGvV.Logger).errors.SERVER_ERROR, {
                            body: $f557e1bd2862c3d0$var$bodyify(_$body, response.headers ? response.headers["content-type"] : null),
                            error: error1,
                            requestBody: $f557e1bd2862c3d0$var$bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            url: url
                        });
                        return [
                            3,
                            17
                        ];
                    case 17:
                        runningTimeout.cancel();
                        // If we had a processFunc, it either returned a T or threw above.
                        // The "body" is now a Uint8Array.
                        return [
                            2,
                            _$body
                        ];
                    case 18:
                        attempt++;
                        return [
                            3,
                            1
                        ];
                    case 19:
                        return [
                            2,
                            $f557e1bd2862c3d0$var$logger.throwError("failed response", (0, $ihGvV.Logger).errors.SERVER_ERROR, {
                                requestBody: $f557e1bd2862c3d0$var$bodyify(options.body, flatHeaders["content-type"]),
                                requestMethod: options.method,
                                url: url
                            })
                        ];
                }
            });
        });
    }();
    return Promise.race([
        runningTimeout.promise,
        runningFetch
    ]);
}
function $f557e1bd2862c3d0$export$6d71b655afe1638d(connection, json, processFunc) {
    var processJsonFunc = function(value, response) {
        var result = null;
        if (value != null) try {
            result = JSON.parse((0, $5RaVA.toUtf8String)(value));
        } catch (error) {
            $f557e1bd2862c3d0$var$logger.throwError("invalid JSON", (0, $ihGvV.Logger).errors.SERVER_ERROR, {
                body: value,
                error: error
            });
        }
        if (processFunc) result = processFunc(result, response);
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    var body = null;
    if (json != null) {
        body = (0, $5RaVA.toUtf8Bytes)(json);
        // Create a connection with the content-type set for JSON
        var updated = typeof connection === "string" ? {
            url: connection
        } : (0, $iqBKf.shallowCopy)(connection);
        if (updated.headers) {
            var hasContentType = Object.keys(updated.headers).filter(function(k) {
                return k.toLowerCase() === "content-type";
            }).length !== 0;
            if (!hasContentType) {
                updated.headers = (0, $iqBKf.shallowCopy)(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        } else updated.headers = {
            "content-type": "application/json"
        };
        connection = updated;
    }
    return $f557e1bd2862c3d0$export$e37fa27017c6c012(connection, body, processJsonFunc);
}
function $f557e1bd2862c3d0$export$e0c10349b2c5e1d4(func, options) {
    if (!options) options = {};
    options = (0, $iqBKf.shallowCopy)(options);
    if (options.floor == null) options.floor = 0;
    if (options.ceiling == null) options.ceiling = 10000;
    if (options.interval == null) options.interval = 250;
    return new Promise(function(resolve, reject) {
        var timer = null;
        var done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        var cancel = function() {
            if (done) return false;
            done = true;
            if (timer) clearTimeout(timer);
            return true;
        };
        if (options.timeout) timer = setTimeout(function() {
            if (cancel()) reject(new Error("timeout"));
        }, options.timeout);
        var retryLimit = options.retryLimit;
        var attempt = 0;
        function check() {
            return func().then(function(result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) resolve(result);
                } else if (options.oncePoll) options.oncePoll.once("poll", check);
                else if (options.onceBlock) options.onceBlock.once("block", check);
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) reject(new Error("retry limit reached"));
                        return;
                    }
                    var timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) timeout = options.floor;
                    if (timeout > options.ceiling) timeout = options.ceiling;
                    setTimeout(check, timeout);
                }
                return null;
            }, function(error) {
                if (cancel()) reject(error);
            });
        }
        check();
    });
}

});
parcelRegister("G4O4F", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $07e7a6dbed0fe245$export$2f872c0f2117be69; });
$parcel$export(module.exports, "encode", function () { return $07e7a6dbed0fe245$export$c564cdbbe6da493; });

var $2tHqU = parcelRequire("2tHqU");
"use strict";
function $07e7a6dbed0fe245$export$2f872c0f2117be69(textData) {
    textData = atob(textData);
    var data = [];
    for(var i = 0; i < textData.length; i++)data.push(textData.charCodeAt(i));
    return (0, $2tHqU.arrayify)(data);
}
function $07e7a6dbed0fe245$export$c564cdbbe6da493(data) {
    data = (0, $2tHqU.arrayify)(data);
    var textData = "";
    for(var i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}

});

parcelRegister("4sICk", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $33fc62ffc86fbaaa$export$83d89fbfd8236492; });
var $33fc62ffc86fbaaa$export$83d89fbfd8236492 = "web/5.5.0";

});

parcelRegister("kuKp8", function(module, exports) {

$parcel$export(module.exports, "getUrl", function () { return $eeba9af132479cef$export$94df0e59ebebf4a7; });

var $itJXR = parcelRequire("itJXR");

var $2tHqU = parcelRequire("2tHqU");
"use strict";
var $eeba9af132479cef$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $eeba9af132479cef$export$94df0e59ebebf4a7(href, options) {
    return $eeba9af132479cef$var$__awaiter(this, void 0, void 0, function() {
        var request, response, body, headers;
        return (0, $itJXR.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options == null) options = {};
                    request = {
                        method: options.method || "GET",
                        headers: options.headers || {},
                        body: options.body || undefined
                    };
                    if (options.skipFetchSetup !== true) {
                        request.mode = "cors"; // no-cors, cors, *same-origin
                        request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
                        request.credentials = "same-origin"; // include, *same-origin, omit
                        request.redirect = "follow"; // manual, *follow, error
                        request.referrer = "client"; // no-referrer, *client
                    }
                    return [
                        4,
                        fetch(href, request)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.arrayBuffer()
                    ];
                case 2:
                    body = _state.sent();
                    headers = {};
                    if (response.headers.forEach) response.headers.forEach(function(value, key) {
                        headers[key.toLowerCase()] = value;
                    });
                    else response.headers.keys().forEach(function(key) {
                        headers[key.toLowerCase()] = response.headers.get(key);
                    });
                    return [
                        2,
                        {
                            headers: headers,
                            statusCode: response.status,
                            statusMessage: response.statusText,
                            body: (0, $2tHqU.arrayify)(new Uint8Array(body))
                        }
                    ];
            }
        });
    });
}

});


parcelRegister("3tBj7", function(module, exports) {
"use strict";
var $28810502fca3d2e9$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
// pre-compute lookup table
var $28810502fca3d2e9$var$ALPHABET_MAP = {};
for(var $28810502fca3d2e9$var$z = 0; $28810502fca3d2e9$var$z < $28810502fca3d2e9$var$ALPHABET.length; $28810502fca3d2e9$var$z++){
    var $28810502fca3d2e9$var$x = $28810502fca3d2e9$var$ALPHABET.charAt($28810502fca3d2e9$var$z);
    if ($28810502fca3d2e9$var$ALPHABET_MAP[$28810502fca3d2e9$var$x] !== undefined) throw new TypeError($28810502fca3d2e9$var$x + " is ambiguous");
    $28810502fca3d2e9$var$ALPHABET_MAP[$28810502fca3d2e9$var$x] = $28810502fca3d2e9$var$z;
}
function $28810502fca3d2e9$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $28810502fca3d2e9$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $28810502fca3d2e9$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $28810502fca3d2e9$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $28810502fca3d2e9$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $28810502fca3d2e9$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $28810502fca3d2e9$var$prefixChk(prefix);
    if (typeof chk === "string") throw new Error(chk);
    var result = prefix + "1";
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error("Non 5-bit word");
        chk = $28810502fca3d2e9$var$polymodStep(chk) ^ x;
        result += $28810502fca3d2e9$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $28810502fca3d2e9$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $28810502fca3d2e9$var$ALPHABET.charAt(v);
    }
    return result;
}
function $28810502fca3d2e9$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + " too short";
    if (str.length > LIMIT) return "Exceeds length limit";
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
    str = lowered;
    var split = str.lastIndexOf("1");
    if (split === -1) return "No separator character for " + str;
    if (split === 0) return "Missing prefix for " + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return "Data too short";
    var chk = $28810502fca3d2e9$var$prefixChk(prefix);
    if (typeof chk === "string") return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $28810502fca3d2e9$var$ALPHABET_MAP[c];
        if (v === undefined) return "Unknown character " + c;
        chk = $28810502fca3d2e9$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return "Invalid checksum for " + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $28810502fca3d2e9$var$decodeUnsafe() {
    var res = $28810502fca3d2e9$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
}
function $28810502fca3d2e9$var$decode(str) {
    var res = $28810502fca3d2e9$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
    throw new Error(res);
}
function $28810502fca3d2e9$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $28810502fca3d2e9$var$toWordsUnsafe(bytes) {
    var res = $28810502fca3d2e9$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $28810502fca3d2e9$var$toWords(bytes) {
    var res = $28810502fca3d2e9$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $28810502fca3d2e9$var$fromWordsUnsafe(words) {
    var res = $28810502fca3d2e9$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $28810502fca3d2e9$var$fromWords(words) {
    var res = $28810502fca3d2e9$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
module.exports = {
    decodeUnsafe: $28810502fca3d2e9$var$decodeUnsafe,
    decode: $28810502fca3d2e9$var$decode,
    encode: $28810502fca3d2e9$var$encode,
    toWordsUnsafe: $28810502fca3d2e9$var$toWordsUnsafe,
    toWords: $28810502fca3d2e9$var$toWords,
    fromWordsUnsafe: $28810502fca3d2e9$var$fromWordsUnsafe,
    fromWords: $28810502fca3d2e9$var$fromWords
};

});

parcelRegister("9Bx3O", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $6fe136db691b1524$export$83d89fbfd8236492; });
var $6fe136db691b1524$export$83d89fbfd8236492 = "providers/5.5.0";

});

parcelRegister("hbpzV", function(module, exports) {

$parcel$export(module.exports, "Formatter", function () { return $c8274e19905cd75a$export$a06636add2a09fd8; });
$parcel$export(module.exports, "isCommunityResourcable", function () { return $c8274e19905cd75a$export$3091239f5b20b896; });
$parcel$export(module.exports, "isCommunityResource", function () { return $c8274e19905cd75a$export$d93d5f61c2498b6; });
$parcel$export(module.exports, "showThrottleMessage", function () { return $c8274e19905cd75a$export$4c41bd49e82e82ab; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $hFSWi = parcelRequire("hFSWi");

var $7ryKd = parcelRequire("7ryKd");

var $2tHqU = parcelRequire("2tHqU");

var $jOl1N = parcelRequire("jOl1N");

var $iqBKf = parcelRequire("iqBKf");

var $60XIC = parcelRequire("60XIC");

var $ihGvV = parcelRequire("ihGvV");

var $9Bx3O = parcelRequire("9Bx3O");
"use strict";
var $c8274e19905cd75a$var$logger = new (0, $ihGvV.Logger)((0, $9Bx3O.version));
var $c8274e19905cd75a$export$a06636add2a09fd8 = /*#__PURE__*/ function _target() {
    function Formatter() {
        (0, $9j09T._)(this, Formatter);
        $c8274e19905cd75a$var$logger.checkNew(this instanceof Formatter ? this.constructor : void 0, Formatter);
        this.formats = this.getDefaultFormats();
    }
    (0, $eDeHT._)(Formatter, [
        {
            key: "getDefaultFormats",
            value: function getDefaultFormats() {
                var _this = this;
                var formats = {};
                var address = this.address.bind(this);
                var bigNumber = this.bigNumber.bind(this);
                var blockTag = this.blockTag.bind(this);
                var data = this.data.bind(this);
                var hash = this.hash.bind(this);
                var hex = this.hex.bind(this);
                var number = this.number.bind(this);
                var type = this.type.bind(this);
                var strictData = function(v) {
                    return _this.data(v, true);
                };
                formats.transaction = {
                    hash: hash,
                    type: type,
                    accessList: Formatter.allowNull(this.accessList.bind(this), null),
                    blockHash: Formatter.allowNull(hash, null),
                    blockNumber: Formatter.allowNull(number, null),
                    transactionIndex: Formatter.allowNull(number, null),
                    confirmations: Formatter.allowNull(number, null),
                    from: address,
                    // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
                    // must be set
                    gasPrice: Formatter.allowNull(bigNumber),
                    maxPriorityFeePerGas: Formatter.allowNull(bigNumber),
                    maxFeePerGas: Formatter.allowNull(bigNumber),
                    gasLimit: bigNumber,
                    to: Formatter.allowNull(address, null),
                    value: bigNumber,
                    nonce: number,
                    data: data,
                    r: Formatter.allowNull(this.uint256),
                    s: Formatter.allowNull(this.uint256),
                    v: Formatter.allowNull(number),
                    creates: Formatter.allowNull(address, null),
                    raw: Formatter.allowNull(data)
                };
                formats.transactionRequest = {
                    from: Formatter.allowNull(address),
                    nonce: Formatter.allowNull(number),
                    gasLimit: Formatter.allowNull(bigNumber),
                    gasPrice: Formatter.allowNull(bigNumber),
                    maxPriorityFeePerGas: Formatter.allowNull(bigNumber),
                    maxFeePerGas: Formatter.allowNull(bigNumber),
                    to: Formatter.allowNull(address),
                    value: Formatter.allowNull(bigNumber),
                    data: Formatter.allowNull(strictData),
                    type: Formatter.allowNull(number),
                    accessList: Formatter.allowNull(this.accessList.bind(this), null)
                };
                formats.receiptLog = {
                    transactionIndex: number,
                    blockNumber: number,
                    transactionHash: hash,
                    address: address,
                    topics: Formatter.arrayOf(hash),
                    data: data,
                    logIndex: number,
                    blockHash: hash
                };
                formats.receipt = {
                    to: Formatter.allowNull(this.address, null),
                    from: Formatter.allowNull(this.address, null),
                    contractAddress: Formatter.allowNull(address, null),
                    transactionIndex: number,
                    // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
                    root: Formatter.allowNull(hex),
                    gasUsed: bigNumber,
                    logsBloom: Formatter.allowNull(data),
                    blockHash: hash,
                    transactionHash: hash,
                    logs: Formatter.arrayOf(this.receiptLog.bind(this)),
                    blockNumber: number,
                    confirmations: Formatter.allowNull(number, null),
                    cumulativeGasUsed: bigNumber,
                    effectiveGasPrice: Formatter.allowNull(bigNumber),
                    status: Formatter.allowNull(number),
                    type: type
                };
                formats.block = {
                    hash: hash,
                    parentHash: hash,
                    number: number,
                    timestamp: number,
                    nonce: Formatter.allowNull(hex),
                    difficulty: this.difficulty.bind(this),
                    gasLimit: bigNumber,
                    gasUsed: bigNumber,
                    miner: address,
                    extraData: data,
                    transactions: Formatter.allowNull(Formatter.arrayOf(hash)),
                    baseFeePerGas: Formatter.allowNull(bigNumber)
                };
                formats.blockWithTransactions = (0, $iqBKf.shallowCopy)(formats.block);
                formats.blockWithTransactions.transactions = Formatter.allowNull(Formatter.arrayOf(this.transactionResponse.bind(this)));
                formats.filter = {
                    fromBlock: Formatter.allowNull(blockTag, undefined),
                    toBlock: Formatter.allowNull(blockTag, undefined),
                    blockHash: Formatter.allowNull(hash, undefined),
                    address: Formatter.allowNull(address, undefined),
                    topics: Formatter.allowNull(this.topics.bind(this), undefined)
                };
                formats.filterLog = {
                    blockNumber: Formatter.allowNull(number),
                    blockHash: Formatter.allowNull(hash),
                    transactionIndex: number,
                    removed: Formatter.allowNull(this.boolean.bind(this)),
                    address: address,
                    data: Formatter.allowFalsish(data, "0x"),
                    topics: Formatter.arrayOf(hash),
                    transactionHash: hash,
                    logIndex: number
                };
                return formats;
            }
        },
        {
            key: "accessList",
            value: function accessList(_accessList) {
                return (0, $60XIC.accessListify)(_accessList || []);
            }
        },
        {
            // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
            // Strict! Used on input.
            key: "number",
            value: function number(_number) {
                if (_number === "0x") return 0;
                return (0, $7ryKd.BigNumber).from(_number).toNumber();
            }
        },
        {
            key: "type",
            value: function type(number) {
                if (number === "0x" || number == null) return 0;
                return (0, $7ryKd.BigNumber).from(number).toNumber();
            }
        },
        {
            // Strict! Used on input.
            key: "bigNumber",
            value: function bigNumber(value) {
                return (0, $7ryKd.BigNumber).from(value);
            }
        },
        {
            // Requires a boolean, "true" or  "false"; returns a boolean
            key: "boolean",
            value: function boolean(value) {
                if (typeof value === "boolean") return value;
                if (typeof value === "string") {
                    value = value.toLowerCase();
                    if (value === "true") return true;
                    if (value === "false") return false;
                }
                throw new Error("invalid boolean - " + value);
            }
        },
        {
            key: "hex",
            value: function hex(value, strict) {
                if (typeof value === "string") {
                    if (!strict && value.substring(0, 2) !== "0x") value = "0x" + value;
                    if ((0, $2tHqU.isHexString)(value)) return value.toLowerCase();
                }
                return $c8274e19905cd75a$var$logger.throwArgumentError("invalid hash", "value", value);
            }
        },
        {
            key: "data",
            value: function data(value, strict) {
                var result = this.hex(value, strict);
                if (result.length % 2 !== 0) throw new Error("invalid data; odd-length - " + value);
                return result;
            }
        },
        {
            // Requires an address
            // Strict! Used on input.
            key: "address",
            value: function address(value) {
                return (0, $hFSWi.getAddress)(value);
            }
        },
        {
            key: "callAddress",
            value: function callAddress(value) {
                if (!(0, $2tHqU.isHexString)(value, 32)) return null;
                var address = (0, $hFSWi.getAddress)((0, $2tHqU.hexDataSlice)(value, 12));
                return address === (0, $jOl1N.AddressZero) ? null : address;
            }
        },
        {
            key: "contractAddress",
            value: function contractAddress(value) {
                return (0, $hFSWi.getContractAddress)(value);
            }
        },
        {
            // Strict! Used on input.
            key: "blockTag",
            value: function blockTag(_blockTag) {
                if (_blockTag == null) return "latest";
                if (_blockTag === "earliest") return "0x0";
                if (_blockTag === "latest" || _blockTag === "pending") return _blockTag;
                if (typeof _blockTag === "number" || (0, $2tHqU.isHexString)(_blockTag)) return (0, $2tHqU.hexValue)(_blockTag);
                throw new Error("invalid blockTag");
            }
        },
        {
            // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
            key: "hash",
            value: function hash(value, strict) {
                var result = this.hex(value, strict);
                if ((0, $2tHqU.hexDataLength)(result) !== 32) return $c8274e19905cd75a$var$logger.throwArgumentError("invalid hash", "value", value);
                return result;
            }
        },
        {
            // Returns the difficulty as a number, or if too large (i.e. PoA network) null
            key: "difficulty",
            value: function difficulty(value) {
                if (value == null) return null;
                var v = (0, $7ryKd.BigNumber).from(value);
                try {
                    return v.toNumber();
                } catch (error) {}
                return null;
            }
        },
        {
            key: "uint256",
            value: function uint256(value) {
                if (!(0, $2tHqU.isHexString)(value)) throw new Error("invalid uint256");
                return (0, $2tHqU.hexZeroPad)(value, 32);
            }
        },
        {
            key: "_block",
            value: function _block(value, format) {
                if (value.author != null && value.miner == null) value.miner = value.author;
                // The difficulty may need to come from _difficulty in recursed blocks
                var difficulty = value._difficulty != null ? value._difficulty : value.difficulty;
                var result = Formatter.check(format, value);
                result._difficulty = difficulty == null ? null : (0, $7ryKd.BigNumber).from(difficulty);
                return result;
            }
        },
        {
            key: "block",
            value: function block(value) {
                return this._block(value, this.formats.block);
            }
        },
        {
            key: "blockWithTransactions",
            value: function blockWithTransactions(value) {
                return this._block(value, this.formats.blockWithTransactions);
            }
        },
        {
            // Strict! Used on input.
            key: "transactionRequest",
            value: function transactionRequest(value) {
                return Formatter.check(this.formats.transactionRequest, value);
            }
        },
        {
            key: "transactionResponse",
            value: function transactionResponse(transaction) {
                // Rename gas to gasLimit
                if (transaction.gas != null && transaction.gasLimit == null) transaction.gasLimit = transaction.gas;
                // Some clients (TestRPC) do strange things like return 0x0 for the
                // 0 address; correct this to be a real address
                if (transaction.to && (0, $7ryKd.BigNumber).from(transaction.to).isZero()) transaction.to = "0x0000000000000000000000000000000000000000";
                // Rename input to data
                if (transaction.input != null && transaction.data == null) transaction.data = transaction.input;
                // If to and creates are empty, populate the creates from the transaction
                if (transaction.to == null && transaction.creates == null) transaction.creates = this.contractAddress(transaction);
                if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) transaction.accessList = [];
                var result = Formatter.check(this.formats.transaction, transaction);
                if (transaction.chainId != null) {
                    var chainId = transaction.chainId;
                    if ((0, $2tHqU.isHexString)(chainId)) chainId = (0, $7ryKd.BigNumber).from(chainId).toNumber();
                    result.chainId = chainId;
                } else {
                    var chainId1 = transaction.networkId;
                    // geth-etc returns chainId
                    if (chainId1 == null && result.v == null) chainId1 = transaction.chainId;
                    if ((0, $2tHqU.isHexString)(chainId1)) chainId1 = (0, $7ryKd.BigNumber).from(chainId1).toNumber();
                    if (typeof chainId1 !== "number" && result.v != null) {
                        chainId1 = (result.v - 35) / 2;
                        if (chainId1 < 0) chainId1 = 0;
                        chainId1 = parseInt(chainId1);
                    }
                    if (typeof chainId1 !== "number") chainId1 = 0;
                    result.chainId = chainId1;
                }
                // 0x0000... should actually be null
                if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") result.blockHash = null;
                return result;
            }
        },
        {
            key: "transaction",
            value: function transaction(value) {
                return (0, $60XIC.parse)(value);
            }
        },
        {
            key: "receiptLog",
            value: function receiptLog(value) {
                return Formatter.check(this.formats.receiptLog, value);
            }
        },
        {
            key: "receipt",
            value: function receipt(value) {
                var result = Formatter.check(this.formats.receipt, value);
                // RSK incorrectly implemented EIP-658, so we munge things a bit here for it
                if (result.root != null) {
                    if (result.root.length <= 4) {
                        // Could be 0x00, 0x0, 0x01 or 0x1
                        var _$value = (0, $7ryKd.BigNumber).from(result.root).toNumber();
                        if (_$value === 0 || _$value === 1) {
                            // Make sure if both are specified, they match
                            if (result.status != null && result.status !== _$value) $c8274e19905cd75a$var$logger.throwArgumentError("alt-root-status/status mismatch", "value", {
                                root: result.root,
                                status: result.status
                            });
                            result.status = _$value;
                            delete result.root;
                        } else $c8274e19905cd75a$var$logger.throwArgumentError("invalid alt-root-status", "value.root", result.root);
                    } else if (result.root.length !== 66) // Must be a valid bytes32
                    $c8274e19905cd75a$var$logger.throwArgumentError("invalid root hash", "value.root", result.root);
                }
                if (result.status != null) result.byzantium = true;
                return result;
            }
        },
        {
            key: "topics",
            value: function topics(value) {
                var _this = this;
                if (Array.isArray(value)) return value.map(function(v) {
                    return _this.topics(v);
                });
                else if (value != null) return this.hash(value, true);
                return null;
            }
        },
        {
            key: "filter",
            value: function filter(value) {
                return Formatter.check(this.formats.filter, value);
            }
        },
        {
            key: "filterLog",
            value: function filterLog(value) {
                return Formatter.check(this.formats.filterLog, value);
            }
        }
    ], [
        {
            key: "check",
            value: function check(format, object) {
                var result = {};
                for(var key in format)try {
                    var value = format[key](object[key]);
                    if (value !== undefined) result[key] = value;
                } catch (error) {
                    error.checkKey = key;
                    error.checkValue = object[key];
                    throw error;
                }
                return result;
            }
        },
        {
            key: "allowNull",
            value: // if value is null-ish, nullValue is returned
            function allowNull(format, nullValue) {
                return function(value) {
                    if (value == null) return nullValue;
                    return format(value);
                };
            }
        },
        {
            key: "allowFalsish",
            value: // If value is false-ish, replaceValue is returned
            function allowFalsish(format, replaceValue) {
                return function(value) {
                    if (!value) return replaceValue;
                    return format(value);
                };
            }
        },
        {
            key: "arrayOf",
            value: // Requires an Array satisfying check
            function arrayOf(format) {
                return function(array) {
                    if (!Array.isArray(array)) throw new Error("not an array");
                    var result = [];
                    array.forEach(function(value) {
                        result.push(format(value));
                    });
                    return result;
                };
            }
        }
    ]);
    return Formatter;
}();
function $c8274e19905cd75a$export$3091239f5b20b896(value) {
    return value && typeof value.isCommunityResource === "function";
}
function $c8274e19905cd75a$export$d93d5f61c2498b6(value) {
    return $c8274e19905cd75a$export$3091239f5b20b896(value) && value.isCommunityResource();
}
// Show the throttle message only once
var $c8274e19905cd75a$var$throttleMessage = false;
function $c8274e19905cd75a$export$4c41bd49e82e82ab() {
    if ($c8274e19905cd75a$var$throttleMessage) return;
    $c8274e19905cd75a$var$throttleMessage = true;
    console.log("========= NOTICE =========");
    console.log("Request-Rate Exceeded  (this message will not be repeated)");
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https://docs.ethers.io/api-keys/");
    console.log("==========================");
}

});


parcelRegister("4Shvs", function(module, exports) {

$parcel$export(module.exports, "AlchemyWebSocketProvider", function () { return $38c9c8fb08b1d0cb$export$f6c13301c7b76371; });
$parcel$export(module.exports, "AlchemyProvider", function () { return $38c9c8fb08b1d0cb$export$999cc40da3fbc6f; });

var $feAea = parcelRequire("feAea");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $iqBKf = parcelRequire("iqBKf");

var $hbpzV = parcelRequire("hbpzV");

var $gc4Rx = parcelRequire("gc4Rx");

var $ihGvV = parcelRequire("ihGvV");

var $9Bx3O = parcelRequire("9Bx3O");

var $hz2UR = parcelRequire("hz2UR");
"use strict";
var $38c9c8fb08b1d0cb$var$logger = new (0, $ihGvV.Logger)((0, $9Bx3O.version));
// This key was provided to ethers.js by Alchemy to be used by the
// default provider, but it is recommended that for your own
// production environments, that you acquire your own API key at:
//   https://dashboard.alchemyapi.io
var $38c9c8fb08b1d0cb$var$defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
var $38c9c8fb08b1d0cb$export$f6c13301c7b76371 = /*#__PURE__*/ function(WebSocketProvider) {
    (0, $i0LXg._)(AlchemyWebSocketProvider, WebSocketProvider);
    var _super = (0, $a1vXf._)(AlchemyWebSocketProvider);
    function AlchemyWebSocketProvider(network, apiKey) {
        (0, $9j09T._)(this, AlchemyWebSocketProvider);
        var _this;
        var provider = new $38c9c8fb08b1d0cb$export$999cc40da3fbc6f(network, apiKey);
        var url = provider.connection.url.replace(/^http/i, "ws").replace(".alchemyapi.", ".ws.alchemyapi.");
        _this = _super.call(this, url, provider.network);
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "apiKey", provider.apiKey);
        return _this;
    }
    (0, $eDeHT._)(AlchemyWebSocketProvider, [
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.apiKey === $38c9c8fb08b1d0cb$var$defaultApiKey;
            }
        }
    ]);
    return AlchemyWebSocketProvider;
}((0, $gc4Rx.WebSocketProvider));
var $38c9c8fb08b1d0cb$export$999cc40da3fbc6f = /*#__PURE__*/ function(UrlJsonRpcProvider) {
    (0, $i0LXg._)(AlchemyProvider, UrlJsonRpcProvider);
    var _super = (0, $a1vXf._)(AlchemyProvider);
    function AlchemyProvider() {
        (0, $9j09T._)(this, AlchemyProvider);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(AlchemyProvider, [
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.apiKey === $38c9c8fb08b1d0cb$var$defaultApiKey;
            }
        }
    ], [
        {
            key: "getWebSocketProvider",
            value: function getWebSocketProvider(network, apiKey) {
                return new $38c9c8fb08b1d0cb$export$f6c13301c7b76371(network, apiKey);
            }
        },
        {
            key: "getApiKey",
            value: function getApiKey(apiKey) {
                if (apiKey == null) return $38c9c8fb08b1d0cb$var$defaultApiKey;
                if (apiKey && typeof apiKey !== "string") $38c9c8fb08b1d0cb$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
                return apiKey;
            }
        },
        {
            key: "getUrl",
            value: function getUrl(network, apiKey) {
                var host = null;
                switch(network.name){
                    case "homestead":
                        host = "eth-mainnet.alchemyapi.io/v2/";
                        break;
                    case "ropsten":
                        host = "eth-ropsten.alchemyapi.io/v2/";
                        break;
                    case "rinkeby":
                        host = "eth-rinkeby.alchemyapi.io/v2/";
                        break;
                    case "goerli":
                        host = "eth-goerli.alchemyapi.io/v2/";
                        break;
                    case "kovan":
                        host = "eth-kovan.alchemyapi.io/v2/";
                        break;
                    case "matic":
                        host = "polygon-mainnet.g.alchemy.com/v2/";
                        break;
                    case "maticmum":
                        host = "polygon-mumbai.g.alchemy.com/v2/";
                        break;
                    default:
                        $38c9c8fb08b1d0cb$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
                }
                return {
                    allowGzip: true,
                    url: "https://" + host + apiKey,
                    throttleCallback: function(attempt, url) {
                        if (apiKey === $38c9c8fb08b1d0cb$var$defaultApiKey) (0, $hbpzV.showThrottleMessage)();
                        return Promise.resolve(true);
                    }
                };
            }
        }
    ]);
    return AlchemyProvider;
}((0, $hz2UR.UrlJsonRpcProvider));

});
parcelRegister("gc4Rx", function(module, exports) {

$parcel$export(module.exports, "WebSocketProvider", function () { return $bca189f079700522$export$bfafe629242f30bd; });

var $feAea = parcelRequire("feAea");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $15W2b = parcelRequire("15W2b");

var $711He = parcelRequire("711He");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");

var $7ryKd = parcelRequire("7ryKd");

var $iqBKf = parcelRequire("iqBKf");

var $1VVvv = parcelRequire("1VVvv");

var $9xwm2 = parcelRequire("9xwm2");

var $ihGvV = parcelRequire("ihGvV");

var $9Bx3O = parcelRequire("9Bx3O");
"use strict";
var $bca189f079700522$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bca189f079700522$var$logger = new (0, $ihGvV.Logger)((0, $9Bx3O.version));
/**
 *  Notes:
 *
 *  This provider differs a bit from the polling providers. One main
 *  difference is how it handles consistency. The polling providers
 *  will stall responses to ensure a consistent state, while this
 *  WebSocket provider assumes the connected backend will manage this.
 *
 *  For example, if a polling provider emits an event which indicates
 *  the event occurred in blockhash XXX, a call to fetch that block by
 *  its hash XXX, if not present will retry until it is present. This
 *  can occur when querying a pool of nodes that are mildly out of sync
 *  with each other.
 */ var $bca189f079700522$var$NextId = 1;
var $bca189f079700522$export$bfafe629242f30bd = /*#__PURE__*/ function(JsonRpcProvider) {
    (0, $i0LXg._)(WebSocketProvider, JsonRpcProvider);
    var _super = (0, $a1vXf._)(WebSocketProvider);
    function WebSocketProvider(url, network) {
        (0, $9j09T._)(this, WebSocketProvider);
        var _this;
        // This will be added in the future; please open an issue to expedite
        if (network === "any") $bca189f079700522$var$logger.throwError("WebSocketProvider does not support 'any' network yet", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "network:any"
        });
        _this = _super.call(this, url, network);
        _this._pollingInterval = -1;
        _this._wsReady = false;
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "_websocket", new (0, $9xwm2.WebSocket)(_this.connection.url));
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "_requests", {});
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "_subs", {});
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "_subIds", {});
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "_detectNetwork", (0, $15W2b._)(((0, $feAea._)(_this), (0, $711He._)(WebSocketProvider.prototype)), "detectNetwork", _this).call(_this));
        // Stall sending requests until the socket is open...
        _this._websocket.onopen = function() {
            _this._wsReady = true;
            Object.keys(_this._requests).forEach(function(id) {
                _this._websocket.send(_this._requests[id].payload);
            });
        };
        _this._websocket.onmessage = function(messageEvent) {
            var data = messageEvent.data;
            var result = JSON.parse(data);
            if (result.id != null) {
                var id = String(result.id);
                var request = _this._requests[id];
                delete _this._requests[id];
                if (result.result !== undefined) {
                    request.callback(null, result.result);
                    _this.emit("debug", {
                        action: "response",
                        request: JSON.parse(request.payload),
                        response: result.result,
                        provider: (0, $feAea._)(_this)
                    });
                } else {
                    var error = null;
                    if (result.error) {
                        error = new Error(result.error.message || "unknown error");
                        (0, $iqBKf.defineReadOnly)(error, "code", result.error.code || null);
                        (0, $iqBKf.defineReadOnly)(error, "response", data);
                    } else error = new Error("unknown error");
                    request.callback(error, undefined);
                    _this.emit("debug", {
                        action: "response",
                        error: error,
                        request: JSON.parse(request.payload),
                        provider: (0, $feAea._)(_this)
                    });
                }
            } else if (result.method === "eth_subscription") {
                // Subscription...
                var sub = _this._subs[result.params.subscription];
                if (sub) //this.emit.apply(this,                  );
                sub.processFunc(result.params.result);
            } else console.warn("this should not happen");
        };
        // This Provider does not actually poll, but we want to trigger
        // poll events for things that depend on them (like stalling for
        // block and transaction lookups)
        var fauxPoll = setInterval(function() {
            _this.emit("poll");
        }, 1000);
        if (fauxPoll.unref) fauxPoll.unref();
        return _this;
    }
    (0, $eDeHT._)(WebSocketProvider, [
        {
            key: "detectNetwork",
            value: function detectNetwork() {
                return this._detectNetwork;
            }
        },
        {
            key: "pollingInterval",
            get: function get() {
                return 0;
            },
            set: function set(value) {
                $bca189f079700522$var$logger.throwError("cannot set polling interval on WebSocketProvider", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "setPollingInterval"
                });
            }
        },
        {
            key: "resetEventsBlock",
            value: function resetEventsBlock(blockNumber) {
                $bca189f079700522$var$logger.throwError("cannot reset events block on WebSocketProvider", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "resetEventBlock"
                });
            }
        },
        {
            key: "poll",
            value: function poll() {
                return $bca189f079700522$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        return [
                            2,
                            null
                        ];
                    });
                });
            }
        },
        {
            key: "polling",
            set: function set(value) {
                if (!value) return;
                $bca189f079700522$var$logger.throwError("cannot set polling on WebSocketProvider", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "setPolling"
                });
            }
        },
        {
            key: "send",
            value: function send(method, params) {
                var _this = this;
                var rid = $bca189f079700522$var$NextId++;
                return new Promise(function(resolve, reject) {
                    function callback(error, result) {
                        if (error) return reject(error);
                        return resolve(result);
                    }
                    var payload = JSON.stringify({
                        method: method,
                        params: params,
                        id: rid,
                        jsonrpc: "2.0"
                    });
                    _this.emit("debug", {
                        action: "request",
                        request: JSON.parse(payload),
                        provider: _this
                    });
                    _this._requests[String(rid)] = {
                        callback: callback,
                        payload: payload
                    };
                    if (_this._wsReady) _this._websocket.send(payload);
                });
            }
        },
        {
            key: "_subscribe",
            value: function _subscribe(tag, param, processFunc) {
                return $bca189f079700522$var$__awaiter(this, void 0, void 0, function() {
                    var _this, subIdPromise, subId;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                subIdPromise = this._subIds[tag];
                                if (subIdPromise == null) {
                                    subIdPromise = Promise.all(param).then(function(param) {
                                        return _this.send("eth_subscribe", param);
                                    });
                                    this._subIds[tag] = subIdPromise;
                                }
                                return [
                                    4,
                                    subIdPromise
                                ];
                            case 1:
                                subId = _state.sent();
                                this._subs[subId] = {
                                    tag: tag,
                                    processFunc: processFunc
                                };
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_startEvent",
            value: function _startEvent(event) {
                var _this = this;
                switch(event.type){
                    case "block":
                        this._subscribe("block", [
                            "newHeads"
                        ], function(result) {
                            var blockNumber = (0, $7ryKd.BigNumber).from(result.number).toNumber();
                            _this._emitted.block = blockNumber;
                            _this.emit("block", blockNumber);
                        });
                        break;
                    case "pending":
                        this._subscribe("pending", [
                            "newPendingTransactions"
                        ], function(result) {
                            _this.emit("pending", result);
                        });
                        break;
                    case "filter":
                        this._subscribe(event.tag, [
                            "logs",
                            this._getFilter(event.filter)
                        ], function(result) {
                            if (result.removed == null) result.removed = false;
                            _this.emit(event.filter, _this.formatter.filterLog(result));
                        });
                        break;
                    case "tx":
                        {
                            var emitReceipt = function(event) {
                                var hash = event.hash;
                                _this.getTransactionReceipt(hash).then(function(receipt) {
                                    if (!receipt) return;
                                    _this.emit(hash, receipt);
                                });
                            };
                            // In case it is already mined
                            emitReceipt(event);
                            // To keep things simple, we start up a single newHeads subscription
                            // to keep an eye out for transactions we are watching for.
                            // Starting a subscription for an event (i.e. "tx") that is already
                            // running is (basically) a nop.
                            this._subscribe("tx", [
                                "newHeads"
                            ], function(result) {
                                _this._events.filter(function(e) {
                                    return e.type === "tx";
                                }).forEach(emitReceipt);
                            });
                            break;
                        }
                    // Nothing is needed
                    case "debug":
                    case "poll":
                    case "willPoll":
                    case "didPoll":
                    case "error":
                        break;
                    default:
                        console.log("unhandled:", event);
                        break;
                }
            }
        },
        {
            key: "_stopEvent",
            value: function _stopEvent(event) {
                var _this = this;
                var tag = event.tag;
                if (event.type === "tx") {
                    // There are remaining transaction event listeners
                    if (this._events.filter(function(e) {
                        return e.type === "tx";
                    }).length) return;
                    tag = "tx";
                } else if (this.listenerCount(event.event)) // There are remaining event listeners
                return;
                var subId = this._subIds[tag];
                if (!subId) return;
                delete this._subIds[tag];
                subId.then(function(subId) {
                    if (!_this._subs[subId]) return;
                    delete _this._subs[subId];
                    _this.send("eth_unsubscribe", [
                        subId
                    ]);
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                return $bca189f079700522$var$__awaiter(this, void 0, void 0, function() {
                    var _this;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if (!(this._websocket.readyState === (0, $9xwm2.WebSocket).CONNECTING)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this._websocket.onopen = function() {
                                            resolve(true);
                                        };
                                        _this._websocket.onerror = function() {
                                            resolve(false);
                                        };
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                // Hangup
                                // See: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
                                this._websocket.close(1000);
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        }
    ], [
        {
            key: "defaultUrl",
            value: function defaultUrl() {
                return "ws://localhost:8546";
            }
        }
    ]);
    return WebSocketProvider;
}((0, $1VVvv.JsonRpcProvider));

});
parcelRegister("1VVvv", function(module, exports) {

$parcel$export(module.exports, "JsonRpcSigner", function () { return $1687b90c95ae315f$export$5f7b5fca3508545a; });
$parcel$export(module.exports, "JsonRpcProvider", function () { return $1687b90c95ae315f$export$da28308012bf6748; });

var $feAea = parcelRequire("feAea");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $15W2b = parcelRequire("15W2b");

var $711He = parcelRequire("711He");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");

var $3KRXu = parcelRequire("3KRXu");

var $7ryKd = parcelRequire("7ryKd");

var $2tHqU = parcelRequire("2tHqU");

var $65WSG = parcelRequire("65WSG");

var $iqBKf = parcelRequire("iqBKf");

var $5RaVA = parcelRequire("5RaVA");

var $60XIC = parcelRequire("60XIC");

var $l3Xj2 = parcelRequire("l3Xj2");

var $ihGvV = parcelRequire("ihGvV");

var $9Bx3O = parcelRequire("9Bx3O");

var $MLa0C = parcelRequire("MLa0C");
"use strict";
var $1687b90c95ae315f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1687b90c95ae315f$var$logger = new (0, $ihGvV.Logger)((0, $9Bx3O.version));
var $1687b90c95ae315f$var$errorGas = [
    "call",
    "estimateGas"
];
function $1687b90c95ae315f$var$checkError(method, error, params) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call" && error.code === (0, $ihGvV.Logger).errors.SERVER_ERROR) {
        var e = error.error;
        if (e && e.message.match("reverted") && (0, $2tHqU.isHexString)(e.data)) return e.data;
        $1687b90c95ae315f$var$logger.throwError("missing revert data in call exception", (0, $ihGvV.Logger).errors.CALL_EXCEPTION, {
            error: error,
            data: "0x"
        });
    }
    var message = error.message;
    if (error.code === (0, $ihGvV.Logger).errors.SERVER_ERROR && error.error && typeof error.error.message === "string") message = error.error.message;
    else if (typeof error.body === "string") message = error.body;
    else if (typeof error.responseText === "string") message = error.responseText;
    message = (message || "").toLowerCase();
    var transaction = params.transaction || params.signedTransaction;
    // "insufficient funds for gas * price + value + cost(data)"
    if (message.match(/insufficient funds|base fee exceeds gas limit/)) $1687b90c95ae315f$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $ihGvV.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "nonce too low"
    if (message.match(/nonce too low/)) $1687b90c95ae315f$var$logger.throwError("nonce has already been used", (0, $ihGvV.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/replacement transaction underpriced/)) $1687b90c95ae315f$var$logger.throwError("replacement fee too low", (0, $ihGvV.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/only replay-protected/)) $1687b90c95ae315f$var$logger.throwError("legacy pre-eip-155 transactions not supported", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
        error: error,
        method: method,
        transaction: transaction
    });
    if ($1687b90c95ae315f$var$errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted/)) $1687b90c95ae315f$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $ihGvV.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
function $1687b90c95ae315f$var$timer(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $1687b90c95ae315f$var$getResult(payload) {
    if (payload.error) {
        // @TODO: not any
        var error = new Error(payload.error.message);
        error.code = payload.error.code;
        error.data = payload.error.data;
        throw error;
    }
    return payload.result;
}
function $1687b90c95ae315f$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
var $1687b90c95ae315f$var$_constructorGuard = {};
var $1687b90c95ae315f$export$5f7b5fca3508545a = /*#__PURE__*/ function _target(Signer) {
    (0, $i0LXg._)(JsonRpcSigner, Signer);
    var _super = (0, $a1vXf._)(JsonRpcSigner);
    function JsonRpcSigner(constructorGuard, provider, addressOrIndex) {
        (0, $9j09T._)(this, JsonRpcSigner);
        var _this;
        $1687b90c95ae315f$var$logger.checkNew(this instanceof JsonRpcSigner ? this.constructor : void 0, JsonRpcSigner);
        _this = _super.call(this);
        if (constructorGuard !== $1687b90c95ae315f$var$_constructorGuard) throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "provider", provider);
        if (addressOrIndex == null) addressOrIndex = 0;
        if (typeof addressOrIndex === "string") {
            (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "_address", _this.provider.formatter.address(addressOrIndex));
            (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "_index", null);
        } else if (typeof addressOrIndex === "number") {
            (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "_index", addressOrIndex);
            (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "_address", null);
        } else $1687b90c95ae315f$var$logger.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
        return _this;
    }
    (0, $eDeHT._)(JsonRpcSigner, [
        {
            key: "connect",
            value: function connect(provider) {
                return $1687b90c95ae315f$var$logger.throwError("cannot alter JSON-RPC Signer connection", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "connect"
                });
            }
        },
        {
            key: "connectUnchecked",
            value: function connectUnchecked() {
                return new $1687b90c95ae315f$var$UncheckedJsonRpcSigner($1687b90c95ae315f$var$_constructorGuard, this.provider, this._address || this._index);
            }
        },
        {
            key: "getAddress",
            value: function getAddress() {
                var _this = this;
                if (this._address) return Promise.resolve(this._address);
                return this.provider.send("eth_accounts", []).then(function(accounts) {
                    if (accounts.length <= _this._index) $1687b90c95ae315f$var$logger.throwError("unknown account #" + _this._index, (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "getAddress"
                    });
                    return _this.provider.formatter.address(accounts[_this._index]);
                });
            }
        },
        {
            key: "sendUncheckedTransaction",
            value: function sendUncheckedTransaction(transaction) {
                var _this = this;
                transaction = (0, $iqBKf.shallowCopy)(transaction);
                var fromAddress = this.getAddress().then(function(address) {
                    if (address) address = address.toLowerCase();
                    return address;
                });
                // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
                // wishes to use this, it is easy to specify explicitly, otherwise
                // we look it up for them.
                if (transaction.gasLimit == null) {
                    var estimate = (0, $iqBKf.shallowCopy)(transaction);
                    estimate.from = fromAddress;
                    transaction.gasLimit = this.provider.estimateGas(estimate);
                }
                if (transaction.to != null) transaction.to = Promise.resolve(transaction.to).then(function(to) {
                    return $1687b90c95ae315f$var$__awaiter(_this, void 0, void 0, function() {
                        var address;
                        return (0, $itJXR.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (to == null) return [
                                        2,
                                        null
                                    ];
                                    return [
                                        4,
                                        this.provider.resolveName(to)
                                    ];
                                case 1:
                                    address = _state.sent();
                                    if (address == null) $1687b90c95ae315f$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                                    return [
                                        2,
                                        address
                                    ];
                            }
                        });
                    });
                });
                return (0, $iqBKf.resolveProperties)({
                    tx: (0, $iqBKf.resolveProperties)(transaction),
                    sender: fromAddress
                }).then(function(param) {
                    var tx = param.tx, sender = param.sender;
                    if (tx.from != null) {
                        if (tx.from.toLowerCase() !== sender) $1687b90c95ae315f$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
                    } else tx.from = sender;
                    var hexTx = _this.provider.constructor.hexlifyTransaction(tx, {
                        from: true
                    });
                    return _this.provider.send("eth_sendTransaction", [
                        hexTx
                    ]).then(function(hash) {
                        return hash;
                    }, function(error) {
                        return $1687b90c95ae315f$var$checkError("sendTransaction", error, hexTx);
                    });
                });
            }
        },
        {
            key: "signTransaction",
            value: function signTransaction(transaction) {
                return $1687b90c95ae315f$var$logger.throwError("signing transactions is unsupported", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "signTransaction"
                });
            }
        },
        {
            key: "sendTransaction",
            value: function sendTransaction(transaction) {
                return $1687b90c95ae315f$var$__awaiter(this, void 0, void 0, function() {
                    var _this, blockNumber, hash, error;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval)
                                ];
                            case 1:
                                blockNumber = _state.sent();
                                return [
                                    4,
                                    this.sendUncheckedTransaction(transaction)
                                ];
                            case 2:
                                hash = _state.sent();
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    (0, $l3Xj2.poll)(function() {
                                        return $1687b90c95ae315f$var$__awaiter(_this, void 0, void 0, function() {
                                            var tx;
                                            return (0, $itJXR.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.provider.getTransaction(hash)
                                                        ];
                                                    case 1:
                                                        tx = _state.sent();
                                                        if (tx === null) return [
                                                            2,
                                                            undefined
                                                        ];
                                                        return [
                                                            2,
                                                            this.provider._wrapTransaction(tx, hash, blockNumber)
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        oncePoll: this.provider
                                    })
                                ];
                            case 4:
                                // Unfortunately, JSON-RPC only provides and opaque transaction hash
                                // for a response, and we need the actual transaction, so we poll
                                // for it; it should show up very quickly
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                error = _state.sent();
                                error.transactionHash = hash;
                                throw error;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "signMessage",
            value: function signMessage(message) {
                return $1687b90c95ae315f$var$__awaiter(this, void 0, void 0, function() {
                    var data, address;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                data = typeof message === "string" ? (0, $5RaVA.toUtf8Bytes)(message) : message;
                                return [
                                    4,
                                    this.getAddress()
                                ];
                            case 1:
                                address = _state.sent();
                                return [
                                    4,
                                    this.provider.send("personal_sign", [
                                        (0, $2tHqU.hexlify)(data),
                                        address.toLowerCase()
                                    ])
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_legacySignMessage",
            value: function _legacySignMessage(message) {
                return $1687b90c95ae315f$var$__awaiter(this, void 0, void 0, function() {
                    var data, address;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                data = typeof message === "string" ? (0, $5RaVA.toUtf8Bytes)(message) : message;
                                return [
                                    4,
                                    this.getAddress()
                                ];
                            case 1:
                                address = _state.sent();
                                return [
                                    4,
                                    this.provider.send("eth_sign", [
                                        address.toLowerCase(),
                                        (0, $2tHqU.hexlify)(data)
                                    ])
                                ];
                            case 2:
                                // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_signTypedData",
            value: function _signTypedData(domain, types, value) {
                return $1687b90c95ae315f$var$__awaiter(this, void 0, void 0, function() {
                    var _this, populated, address;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    (0, $65WSG.TypedDataEncoder).resolveNames(domain, types, value, function(name) {
                                        return _this.provider.resolveName(name);
                                    })
                                ];
                            case 1:
                                populated = _state.sent();
                                return [
                                    4,
                                    this.getAddress()
                                ];
                            case 2:
                                address = _state.sent();
                                return [
                                    4,
                                    this.provider.send("eth_signTypedData_v4", [
                                        address.toLowerCase(),
                                        JSON.stringify((0, $65WSG.TypedDataEncoder).getPayload(populated.domain, types, populated.value))
                                    ])
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "unlock",
            value: function unlock(password) {
                return $1687b90c95ae315f$var$__awaiter(this, void 0, void 0, function() {
                    var provider, address;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                provider = this.provider;
                                return [
                                    4,
                                    this.getAddress()
                                ];
                            case 1:
                                address = _state.sent();
                                return [
                                    2,
                                    provider.send("personal_unlockAccount", [
                                        address.toLowerCase(),
                                        password,
                                        null
                                    ])
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return JsonRpcSigner;
}((0, $3KRXu.Signer));
var $1687b90c95ae315f$var$UncheckedJsonRpcSigner = /*#__PURE__*/ function(JsonRpcSigner) {
    (0, $i0LXg._)(UncheckedJsonRpcSigner, JsonRpcSigner);
    var _super = (0, $a1vXf._)(UncheckedJsonRpcSigner);
    function UncheckedJsonRpcSigner() {
        (0, $9j09T._)(this, UncheckedJsonRpcSigner);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(UncheckedJsonRpcSigner, [
        {
            key: "sendTransaction",
            value: function sendTransaction(transaction) {
                var _this = this;
                return this.sendUncheckedTransaction(transaction).then(function(hash) {
                    return {
                        hash: hash,
                        nonce: null,
                        gasLimit: null,
                        gasPrice: null,
                        data: null,
                        value: null,
                        chainId: null,
                        confirmations: 0,
                        from: null,
                        wait: function(confirmations) {
                            return _this.provider.waitForTransaction(hash, confirmations);
                        }
                    };
                });
            }
        }
    ]);
    return UncheckedJsonRpcSigner;
}($1687b90c95ae315f$export$5f7b5fca3508545a);
var $1687b90c95ae315f$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true
};
var $1687b90c95ae315f$export$da28308012bf6748 = /*#__PURE__*/ function _target(BaseProvider) {
    (0, $i0LXg._)(JsonRpcProvider, BaseProvider);
    var _super = (0, $a1vXf._)(JsonRpcProvider);
    function JsonRpcProvider(url, network) {
        (0, $9j09T._)(this, JsonRpcProvider);
        var _this;
        $1687b90c95ae315f$var$logger.checkNew(this instanceof JsonRpcProvider ? this.constructor : void 0, JsonRpcProvider);
        var networkOrReady = network;
        // The network is unknown, query the JSON-RPC for it
        if (networkOrReady == null) networkOrReady = new Promise(function(resolve, reject) {
            setTimeout(function() {
                _this.detectNetwork().then(function(network) {
                    resolve(network);
                }, function(error) {
                    reject(error);
                });
            }, 0);
        });
        _this = _super.call(this, networkOrReady);
        // Default URL
        if (!url) url = (0, $iqBKf.getStatic)(_this.constructor, "defaultUrl")();
        if (typeof url === "string") (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "connection", Object.freeze({
            url: url
        }));
        else (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "connection", Object.freeze((0, $iqBKf.shallowCopy)(url)));
        _this._nextId = 42;
        return _this;
    }
    (0, $eDeHT._)(JsonRpcProvider, [
        {
            key: "_cache",
            get: function get() {
                if (this._eventLoopCache == null) this._eventLoopCache = {};
                return this._eventLoopCache;
            }
        },
        {
            key: "detectNetwork",
            value: function detectNetwork() {
                var _this = this;
                if (!this._cache["detectNetwork"]) {
                    this._cache["detectNetwork"] = this._uncachedDetectNetwork();
                    // Clear this cache at the beginning of the next event loop
                    setTimeout(function() {
                        _this._cache["detectNetwork"] = null;
                    }, 0);
                }
                return this._cache["detectNetwork"];
            }
        },
        {
            key: "_uncachedDetectNetwork",
            value: function _uncachedDetectNetwork() {
                return $1687b90c95ae315f$var$__awaiter(this, void 0, void 0, function() {
                    var chainId, error, error1, getNetwork;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $1687b90c95ae315f$var$timer(0)
                                ];
                            case 1:
                                _state.sent();
                                chainId = null;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    9
                                ]);
                                return [
                                    4,
                                    this.send("eth_chainId", [])
                                ];
                            case 3:
                                chainId = _state.sent();
                                return [
                                    3,
                                    9
                                ];
                            case 4:
                                error = _state.sent();
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    this.send("net_version", [])
                                ];
                            case 6:
                                chainId = _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                error1 = _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                return [
                                    3,
                                    9
                                ];
                            case 9:
                                if (chainId != null) {
                                    getNetwork = (0, $iqBKf.getStatic)(this.constructor, "getNetwork");
                                    try {
                                        return [
                                            2,
                                            getNetwork((0, $7ryKd.BigNumber).from(chainId).toNumber())
                                        ];
                                    } catch (error) {
                                        return [
                                            2,
                                            $1687b90c95ae315f$var$logger.throwError("could not detect network", (0, $ihGvV.Logger).errors.NETWORK_ERROR, {
                                                chainId: chainId,
                                                event: "invalidNetwork",
                                                serverError: error
                                            })
                                        ];
                                    }
                                }
                                return [
                                    2,
                                    $1687b90c95ae315f$var$logger.throwError("could not detect network", (0, $ihGvV.Logger).errors.NETWORK_ERROR, {
                                        event: "noNetwork"
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getSigner",
            value: function getSigner(addressOrIndex) {
                return new $1687b90c95ae315f$export$5f7b5fca3508545a($1687b90c95ae315f$var$_constructorGuard, this, addressOrIndex);
            }
        },
        {
            key: "getUncheckedSigner",
            value: function getUncheckedSigner(addressOrIndex) {
                return this.getSigner(addressOrIndex).connectUnchecked();
            }
        },
        {
            key: "listAccounts",
            value: function listAccounts() {
                var _this = this;
                return this.send("eth_accounts", []).then(function(accounts) {
                    return accounts.map(function(a) {
                        return _this.formatter.address(a);
                    });
                });
            }
        },
        {
            key: "send",
            value: function send(method, params) {
                var _this = this;
                var request = {
                    method: method,
                    params: params,
                    id: this._nextId++,
                    jsonrpc: "2.0"
                };
                this.emit("debug", {
                    action: "request",
                    request: (0, $iqBKf.deepCopy)(request),
                    provider: this
                });
                // We can expand this in the future to any call, but for now these
                // are the biggest wins and do not require any serializing parameters.
                var cache = [
                    "eth_chainId",
                    "eth_blockNumber"
                ].indexOf(method) >= 0;
                if (cache && this._cache[method]) return this._cache[method];
                var result = (0, $l3Xj2.fetchJson)(this.connection, JSON.stringify(request), $1687b90c95ae315f$var$getResult).then(function(result) {
                    _this.emit("debug", {
                        action: "response",
                        request: request,
                        response: result,
                        provider: _this
                    });
                    return result;
                }, function(error) {
                    _this.emit("debug", {
                        action: "response",
                        error: error,
                        request: request,
                        provider: _this
                    });
                    throw error;
                });
                // Cache the fetch, but clear it on the next event loop
                if (cache) {
                    this._cache[method] = result;
                    setTimeout(function() {
                        _this._cache[method] = null;
                    }, 0);
                }
                return result;
            }
        },
        {
            key: "prepareRequest",
            value: function prepareRequest(method, params) {
                switch(method){
                    case "getBlockNumber":
                        return [
                            "eth_blockNumber",
                            []
                        ];
                    case "getGasPrice":
                        return [
                            "eth_gasPrice",
                            []
                        ];
                    case "getBalance":
                        return [
                            "eth_getBalance",
                            [
                                $1687b90c95ae315f$var$getLowerCase(params.address),
                                params.blockTag
                            ]
                        ];
                    case "getTransactionCount":
                        return [
                            "eth_getTransactionCount",
                            [
                                $1687b90c95ae315f$var$getLowerCase(params.address),
                                params.blockTag
                            ]
                        ];
                    case "getCode":
                        return [
                            "eth_getCode",
                            [
                                $1687b90c95ae315f$var$getLowerCase(params.address),
                                params.blockTag
                            ]
                        ];
                    case "getStorageAt":
                        return [
                            "eth_getStorageAt",
                            [
                                $1687b90c95ae315f$var$getLowerCase(params.address),
                                params.position,
                                params.blockTag
                            ]
                        ];
                    case "sendTransaction":
                        return [
                            "eth_sendRawTransaction",
                            [
                                params.signedTransaction
                            ]
                        ];
                    case "getBlock":
                        if (params.blockTag) return [
                            "eth_getBlockByNumber",
                            [
                                params.blockTag,
                                !!params.includeTransactions
                            ]
                        ];
                        else if (params.blockHash) return [
                            "eth_getBlockByHash",
                            [
                                params.blockHash,
                                !!params.includeTransactions
                            ]
                        ];
                        return null;
                    case "getTransaction":
                        return [
                            "eth_getTransactionByHash",
                            [
                                params.transactionHash
                            ]
                        ];
                    case "getTransactionReceipt":
                        return [
                            "eth_getTransactionReceipt",
                            [
                                params.transactionHash
                            ]
                        ];
                    case "call":
                        {
                            var hexlifyTransaction = (0, $iqBKf.getStatic)(this.constructor, "hexlifyTransaction");
                            return [
                                "eth_call",
                                [
                                    hexlifyTransaction(params.transaction, {
                                        from: true
                                    }),
                                    params.blockTag
                                ]
                            ];
                        }
                    case "estimateGas":
                        {
                            var hexlifyTransaction1 = (0, $iqBKf.getStatic)(this.constructor, "hexlifyTransaction");
                            return [
                                "eth_estimateGas",
                                [
                                    hexlifyTransaction1(params.transaction, {
                                        from: true
                                    })
                                ]
                            ];
                        }
                    case "getLogs":
                        if (params.filter && params.filter.address != null) params.filter.address = $1687b90c95ae315f$var$getLowerCase(params.filter.address);
                        return [
                            "eth_getLogs",
                            [
                                params.filter
                            ]
                        ];
                    default:
                        break;
                }
                return null;
            }
        },
        {
            key: "perform",
            value: function perform(method, params) {
                return $1687b90c95ae315f$var$__awaiter(this, void 0, void 0, function() {
                    var tx, feeData, args, error;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(method === "call" || method === "estimateGas")) return [
                                    3,
                                    2
                                ];
                                tx = params.transaction;
                                if (!(tx && tx.type != null && (0, $7ryKd.BigNumber).from(tx.type).isZero())) return [
                                    3,
                                    2
                                ];
                                if (!(tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.getFeeData()
                                ];
                            case 1:
                                feeData = _state.sent();
                                if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
                                    // Network doesn't know about EIP-1559 (and hence type)
                                    params = (0, $iqBKf.shallowCopy)(params);
                                    params.transaction = (0, $iqBKf.shallowCopy)(tx);
                                    delete params.transaction.type;
                                }
                                _state.label = 2;
                            case 2:
                                args = this.prepareRequest(method, params);
                                if (args == null) $1687b90c95ae315f$var$logger.throwError(method + " not implemented", (0, $ihGvV.Logger).errors.NOT_IMPLEMENTED, {
                                    operation: method
                                });
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    this.send(args[0], args[1])
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                error = _state.sent();
                                return [
                                    2,
                                    $1687b90c95ae315f$var$checkError(method, error, params)
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_startEvent",
            value: function _startEvent(event) {
                if (event.tag === "pending") this._startPending();
                (0, $15W2b._)((0, $711He._)(JsonRpcProvider.prototype), "_startEvent", this).call(this, event);
            }
        },
        {
            key: "_startPending",
            value: function _startPending() {
                if (this._pendingFilter != null) return;
                var self = this;
                var pendingFilter = this.send("eth_newPendingTransactionFilter", []);
                this._pendingFilter = pendingFilter;
                pendingFilter.then(function(filterId) {
                    function poll() {
                        self.send("eth_getFilterChanges", [
                            filterId
                        ]).then(function(hashes) {
                            if (self._pendingFilter != pendingFilter) return null;
                            var seq = Promise.resolve();
                            hashes.forEach(function(hash) {
                                // @TODO: This should be garbage collected at some point... How? When?
                                self._emitted["t:" + hash.toLowerCase()] = "pending";
                                seq = seq.then(function() {
                                    return self.getTransaction(hash).then(function(tx) {
                                        self.emit("pending", tx);
                                        return null;
                                    });
                                });
                            });
                            return seq.then(function() {
                                return $1687b90c95ae315f$var$timer(1000);
                            });
                        }).then(function() {
                            if (self._pendingFilter != pendingFilter) {
                                self.send("eth_uninstallFilter", [
                                    filterId
                                ]);
                                return;
                            }
                            setTimeout(function() {
                                poll();
                            }, 0);
                            return null;
                        }).catch(function(error) {});
                    }
                    poll();
                    return filterId;
                }).catch(function(error) {});
            }
        },
        {
            key: "_stopEvent",
            value: function _stopEvent(event) {
                if (event.tag === "pending" && this.listenerCount("pending") === 0) this._pendingFilter = null;
                (0, $15W2b._)((0, $711He._)(JsonRpcProvider.prototype), "_stopEvent", this).call(this, event);
            }
        }
    ], [
        {
            key: "defaultUrl",
            value: function defaultUrl() {
                return "http://localhost:8545";
            }
        },
        {
            key: "hexlifyTransaction",
            value: // Convert an ethers.js transaction into a JSON-RPC transaction
            //  - gasLimit => gas
            //  - All values hexlified
            //  - All numeric values zero-striped
            //  - All addresses are lowercased
            // NOTE: This allows a TransactionRequest, but all values should be resolved
            //       before this is called
            // @TODO: This will likely be removed in future versions and prepareRequest
            //        will be the preferred method for this.
            function hexlifyTransaction(transaction, allowExtra) {
                // Check only allowed properties are given
                var allowed = (0, $iqBKf.shallowCopy)($1687b90c95ae315f$var$allowedTransactionKeys);
                if (allowExtra) {
                    for(var key in allowExtra)if (allowExtra[key]) allowed[key] = true;
                }
                (0, $iqBKf.checkProperties)(transaction, allowed);
                var result = {};
                // Some nodes (INFURA ropsten; INFURA mainnet is fine) do not like leading zeros.
                [
                    "gasLimit",
                    "gasPrice",
                    "type",
                    "maxFeePerGas",
                    "maxPriorityFeePerGas",
                    "nonce",
                    "value"
                ].forEach(function(key) {
                    if (transaction[key] == null) return;
                    var value = (0, $2tHqU.hexValue)(transaction[key]);
                    if (key === "gasLimit") key = "gas";
                    result[key] = value;
                });
                [
                    "from",
                    "to",
                    "data"
                ].forEach(function(key) {
                    if (transaction[key] == null) return;
                    result[key] = (0, $2tHqU.hexlify)(transaction[key]);
                });
                if (transaction.accessList) result["accessList"] = (0, $60XIC.accessListify)(transaction.accessList);
                return result;
            }
        }
    ]);
    return JsonRpcProvider;
}((0, $MLa0C.BaseProvider));

});

parcelRegister("9xwm2", function(module, exports) {

$parcel$export(module.exports, "WebSocket", function () { return $6f204b0ee4bbaf0e$export$3909fb301d3dc8c9; });

var $ihGvV = parcelRequire("ihGvV");

var $9Bx3O = parcelRequire("9Bx3O");
"use strict";
var $6f204b0ee4bbaf0e$export$3909fb301d3dc8c9 = null;
try {
    $6f204b0ee4bbaf0e$export$3909fb301d3dc8c9 = WebSocket;
    if ($6f204b0ee4bbaf0e$export$3909fb301d3dc8c9 == null) throw new Error("inject please");
} catch (error) {
    var $6f204b0ee4bbaf0e$var$logger = new (0, $ihGvV.Logger)((0, $9Bx3O.version));
    $6f204b0ee4bbaf0e$export$3909fb301d3dc8c9 = function WS() {
        $6f204b0ee4bbaf0e$var$logger.throwError("WebSockets not supported in this environment", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new WebSocket()"
        });
    };
}

});


parcelRegister("hz2UR", function(module, exports) {

$parcel$export(module.exports, "StaticJsonRpcProvider", function () { return $cc97f79e9da36456$export$b3d647c1c29df44d; });
$parcel$export(module.exports, "UrlJsonRpcProvider", function () { return $cc97f79e9da36456$export$664128d6239ccf96; });

var $feAea = parcelRequire("feAea");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $15W2b = parcelRequire("15W2b");

var $711He = parcelRequire("711He");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");

var $iqBKf = parcelRequire("iqBKf");

var $ihGvV = parcelRequire("ihGvV");

var $9Bx3O = parcelRequire("9Bx3O");

var $1VVvv = parcelRequire("1VVvv");
"use strict";
var $cc97f79e9da36456$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $cc97f79e9da36456$var$logger = new (0, $ihGvV.Logger)((0, $9Bx3O.version));
var $cc97f79e9da36456$export$b3d647c1c29df44d = /*#__PURE__*/ function(JsonRpcProvider) {
    (0, $i0LXg._)(StaticJsonRpcProvider, JsonRpcProvider);
    var _super = (0, $a1vXf._)(StaticJsonRpcProvider);
    function StaticJsonRpcProvider() {
        (0, $9j09T._)(this, StaticJsonRpcProvider);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(StaticJsonRpcProvider, [
        {
            key: "detectNetwork",
            value: function detectNetwork() {
                var _this = this;
                var _super = Object.create(null, {
                    detectNetwork: {
                        get: function() {
                            return (0, $15W2b._)((0, $711He._)(StaticJsonRpcProvider.prototype), "detectNetwork", _this);
                        }
                    }
                });
                return $cc97f79e9da36456$var$__awaiter(this, void 0, void 0, function() {
                    var network;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                network = this.network;
                                if (!(network == null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _super.detectNetwork.call(this)
                                ];
                            case 1:
                                network = _state.sent();
                                if (!network) $cc97f79e9da36456$var$logger.throwError("no network detected", (0, $ihGvV.Logger).errors.UNKNOWN_ERROR, {});
                                // If still not set, set it
                                if (this._network == null) {
                                    // A static network does not support "any"
                                    (0, $iqBKf.defineReadOnly)(this, "_network", network);
                                    this.emit("network", network, null);
                                }
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    network
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return StaticJsonRpcProvider;
}((0, $1VVvv.JsonRpcProvider));
var $cc97f79e9da36456$export$664128d6239ccf96 = /*#__PURE__*/ function _target(StaticJsonRpcProvider) {
    (0, $i0LXg._)(UrlJsonRpcProvider, StaticJsonRpcProvider);
    var _super = (0, $a1vXf._)(UrlJsonRpcProvider);
    function UrlJsonRpcProvider(network, apiKey) {
        (0, $9j09T._)(this, UrlJsonRpcProvider);
        var _this;
        $cc97f79e9da36456$var$logger.checkAbstract(this instanceof UrlJsonRpcProvider ? this.constructor : void 0, UrlJsonRpcProvider);
        // Normalize the Network and API Key
        network = (0, $iqBKf.getStatic)(this instanceof UrlJsonRpcProvider ? this.constructor : void 0, "getNetwork")(network);
        apiKey = (0, $iqBKf.getStatic)(this instanceof UrlJsonRpcProvider ? this.constructor : void 0, "getApiKey")(apiKey);
        var connection = (0, $iqBKf.getStatic)(this instanceof UrlJsonRpcProvider ? this.constructor : void 0, "getUrl")(network, apiKey);
        _this = _super.call(this, connection, network);
        if (typeof apiKey === "string") (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "apiKey", apiKey);
        else if (apiKey != null) Object.keys(apiKey).forEach(function(key) {
            (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), key, apiKey[key]);
        });
        return _this;
    }
    (0, $eDeHT._)(UrlJsonRpcProvider, [
        {
            key: "_startPending",
            value: function _startPending() {
                $cc97f79e9da36456$var$logger.warn("WARNING: API provider does not support pending filters");
            }
        },
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return false;
            }
        },
        {
            key: "getSigner",
            value: function getSigner(address) {
                return $cc97f79e9da36456$var$logger.throwError("API provider does not support signing", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "getSigner"
                });
            }
        },
        {
            key: "listAccounts",
            value: function listAccounts() {
                return Promise.resolve([]);
            }
        }
    ], [
        {
            key: "getApiKey",
            value: // Return a defaultApiKey if null, otherwise validate the API key
            function getApiKey(apiKey) {
                return apiKey;
            }
        },
        {
            key: "getUrl",
            value: // Returns the url or connection for the given network and API key. The
            // API key will have been sanitized by the getApiKey first, so any validation
            // or transformations can be done there.
            function getUrl(network, apiKey) {
                return $cc97f79e9da36456$var$logger.throwError("not implemented; sub-classes must override getUrl", (0, $ihGvV.Logger).errors.NOT_IMPLEMENTED, {
                    operation: "getUrl"
                });
            }
        }
    ]);
    return UrlJsonRpcProvider;
}($cc97f79e9da36456$export$b3d647c1c29df44d);

});


parcelRegister("heQ1D", function(module, exports) {

$parcel$export(module.exports, "CloudflareProvider", function () { return $c8cc19a4c6302775$export$7113381f8f264fc0; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $15W2b = parcelRequire("15W2b");

var $711He = parcelRequire("711He");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");

var $hz2UR = parcelRequire("hz2UR");

var $ihGvV = parcelRequire("ihGvV");

var $9Bx3O = parcelRequire("9Bx3O");
"use strict";
var $c8cc19a4c6302775$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c8cc19a4c6302775$var$logger = new (0, $ihGvV.Logger)((0, $9Bx3O.version));
var $c8cc19a4c6302775$export$7113381f8f264fc0 = /*#__PURE__*/ function(UrlJsonRpcProvider) {
    (0, $i0LXg._)(CloudflareProvider, UrlJsonRpcProvider);
    var _super = (0, $a1vXf._)(CloudflareProvider);
    function CloudflareProvider() {
        (0, $9j09T._)(this, CloudflareProvider);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(CloudflareProvider, [
        {
            key: "perform",
            value: function perform(method, params) {
                var _this = this;
                var _super = Object.create(null, {
                    perform: {
                        get: function() {
                            return (0, $15W2b._)((0, $711He._)(CloudflareProvider.prototype), "perform", _this);
                        }
                    }
                });
                return $c8cc19a4c6302775$var$__awaiter(this, void 0, void 0, function() {
                    var block;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(method === "getBlockNumber")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _super.perform.call(this, "getBlock", {
                                        blockTag: "latest"
                                    })
                                ];
                            case 1:
                                block = _state.sent();
                                return [
                                    2,
                                    block.number
                                ];
                            case 2:
                                return [
                                    2,
                                    _super.perform.call(this, method, params)
                                ];
                        }
                    });
                });
            }
        }
    ], [
        {
            key: "getApiKey",
            value: function getApiKey(apiKey) {
                if (apiKey != null) $c8cc19a4c6302775$var$logger.throwArgumentError("apiKey not supported for cloudflare", "apiKey", apiKey);
                return null;
            }
        },
        {
            key: "getUrl",
            value: function getUrl(network, apiKey) {
                var host = null;
                switch(network.name){
                    case "homestead":
                        host = "https://cloudflare-eth.com/";
                        break;
                    default:
                        $c8cc19a4c6302775$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
                }
                return host;
            }
        }
    ]);
    return CloudflareProvider;
}((0, $hz2UR.UrlJsonRpcProvider));

});

parcelRegister("bLfTl", function(module, exports) {

$parcel$export(module.exports, "EtherscanProvider", function () { return $8900693e7cefd52d$export$dd1d942a536c7912; });

var $feAea = parcelRequire("feAea");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $15W2b = parcelRequire("15W2b");

var $711He = parcelRequire("711He");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");

var $2tHqU = parcelRequire("2tHqU");

var $iqBKf = parcelRequire("iqBKf");

var $60XIC = parcelRequire("60XIC");

var $l3Xj2 = parcelRequire("l3Xj2");

var $hbpzV = parcelRequire("hbpzV");

var $ihGvV = parcelRequire("ihGvV");

var $9Bx3O = parcelRequire("9Bx3O");

var $MLa0C = parcelRequire("MLa0C");
"use strict";
var $8900693e7cefd52d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8900693e7cefd52d$var$logger = new (0, $ihGvV.Logger)((0, $9Bx3O.version));
// The transaction has already been sanitized by the calls in Provider
function $8900693e7cefd52d$var$getTransactionPostData(transaction) {
    var result = {};
    for(var key in transaction){
        if (transaction[key] == null) continue;
        var value = transaction[key];
        if (key === "type" && value === 0) continue;
        // Quantity-types require no leading zero, unless 0
        if (({
            type: true,
            gasLimit: true,
            gasPrice: true,
            maxFeePerGs: true,
            maxPriorityFeePerGas: true,
            nonce: true,
            value: true
        })[key]) value = (0, $2tHqU.hexValue)((0, $2tHqU.hexlify)(value));
        else if (key === "accessList") value = "[" + (0, $60XIC.accessListify)(value).map(function(set) {
            return '{address:"'.concat(set.address, '",storageKeys:["').concat(set.storageKeys.join('","'), '"]}');
        }).join(",") + "]";
        else value = (0, $2tHqU.hexlify)(value);
        result[key] = value;
    }
    return result;
}
function $8900693e7cefd52d$var$getResult(result) {
    // getLogs, getHistory have weird success responses
    if (result.status == 0 && (result.message === "No records found" || result.message === "No transactions found")) return result.result;
    if (result.status != 1 || result.message != "OK") {
        var error = new Error("invalid response");
        error.result = JSON.stringify(result);
        if ((result.result || "").toLowerCase().indexOf("rate limit") >= 0) error.throttleRetry = true;
        throw error;
    }
    return result.result;
}
function $8900693e7cefd52d$var$getJsonResult(result) {
    // This response indicates we are being throttled
    if (result && result.status == 0 && result.message == "NOTOK" && (result.result || "").toLowerCase().indexOf("rate limit") >= 0) {
        var error = new Error("throttled response");
        error.result = JSON.stringify(result);
        error.throttleRetry = true;
        throw error;
    }
    if (result.jsonrpc != "2.0") {
        // @TODO: not any
        var error1 = new Error("invalid response");
        error1.result = JSON.stringify(result);
        throw error1;
    }
    if (result.error) {
        // @TODO: not any
        var error2 = new Error(result.error.message || "unknown error");
        if (result.error.code) error2.code = result.error.code;
        if (result.error.data) error2.data = result.error.data;
        throw error2;
    }
    return result.result;
}
// The blockTag was normalized as a string by the Provider pre-perform operations
function $8900693e7cefd52d$var$checkLogTag(blockTag) {
    if (blockTag === "pending") throw new Error("pending not supported");
    if (blockTag === "latest") return blockTag;
    return parseInt(blockTag.substring(2), 16);
}
var $8900693e7cefd52d$var$defaultApiKey = "9D13ZE7XSBTJ94N9BNJ2MA33VMAY2YPIRB";
function $8900693e7cefd52d$var$checkError(method, error, transaction) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call" && error.code === (0, $ihGvV.Logger).errors.SERVER_ERROR) {
        var e = error.error;
        // Etherscan keeps changing their string
        if (e && (e.message.match(/reverted/i) || e.message.match(/VM execution error/i))) {
            // Etherscan prefixes the data like "Reverted 0x1234"
            var data = e.data;
            if (data) data = "0x" + data.replace(/^.*0x/i, "");
            if ((0, $2tHqU.isHexString)(data)) return data;
            $8900693e7cefd52d$var$logger.throwError("missing revert data in call exception", (0, $ihGvV.Logger).errors.CALL_EXCEPTION, {
                error: error,
                data: "0x"
            });
        }
    }
    // Get the message from any nested error structure
    var message = error.message;
    if (error.code === (0, $ihGvV.Logger).errors.SERVER_ERROR) {
        if (error.error && typeof error.error.message === "string") message = error.error.message;
        else if (typeof error.body === "string") message = error.body;
        else if (typeof error.responseText === "string") message = error.responseText;
    }
    message = (message || "").toLowerCase();
    // "Insufficient funds. The account you tried to send transaction from does not have enough funds. Required 21464000000000 and got: 0"
    if (message.match(/insufficient funds/)) $8900693e7cefd52d$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $ihGvV.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction with the same hash was already imported."
    if (message.match(/same hash was already imported|transaction nonce is too low|nonce too low/)) $8900693e7cefd52d$var$logger.throwError("nonce has already been used", (0, $ihGvV.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction gas price is too low. There is another transaction with same nonce in the queue. Try increasing the gas price or incrementing the nonce."
    if (message.match(/another transaction with same nonce/)) $8900693e7cefd52d$var$logger.throwError("replacement fee too low", (0, $ihGvV.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    if (message.match(/execution failed due to an exception|execution reverted/)) $8900693e7cefd52d$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $ihGvV.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
var $8900693e7cefd52d$export$dd1d942a536c7912 = /*#__PURE__*/ function _target(BaseProvider) {
    (0, $i0LXg._)(EtherscanProvider, BaseProvider);
    var _super = (0, $a1vXf._)(EtherscanProvider);
    function EtherscanProvider(network, apiKey) {
        (0, $9j09T._)(this, EtherscanProvider);
        var _this;
        $8900693e7cefd52d$var$logger.checkNew(this instanceof EtherscanProvider ? this.constructor : void 0, EtherscanProvider);
        _this = _super.call(this, network);
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "baseUrl", _this.getBaseUrl());
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "apiKey", apiKey || $8900693e7cefd52d$var$defaultApiKey);
        return _this;
    }
    (0, $eDeHT._)(EtherscanProvider, [
        {
            key: "getBaseUrl",
            value: function getBaseUrl() {
                switch(this.network ? this.network.name : "invalid"){
                    case "homestead":
                        return "https://api.etherscan.io";
                    case "ropsten":
                        return "https://api-ropsten.etherscan.io";
                    case "rinkeby":
                        return "https://api-rinkeby.etherscan.io";
                    case "kovan":
                        return "https://api-kovan.etherscan.io";
                    case "goerli":
                        return "https://api-goerli.etherscan.io";
                    default:
                }
                return $8900693e7cefd52d$var$logger.throwArgumentError("unsupported network", "network", name);
            }
        },
        {
            key: "getUrl",
            value: function getUrl(module, params) {
                var query = Object.keys(params).reduce(function(accum, key) {
                    var value = params[key];
                    if (value != null) accum += "&".concat(key, "=").concat(value);
                    return accum;
                }, "");
                var apiKey = this.apiKey ? "&apikey=".concat(this.apiKey) : "";
                return "".concat(this.baseUrl, "/api?module=").concat(module).concat(query).concat(apiKey);
            }
        },
        {
            key: "getPostUrl",
            value: function getPostUrl() {
                return "".concat(this.baseUrl, "/api");
            }
        },
        {
            key: "getPostData",
            value: function getPostData(module, params) {
                params.module = module;
                params.apikey = this.apiKey;
                return params;
            }
        },
        {
            key: "fetch",
            value: function fetch(module, params, post) {
                return $8900693e7cefd52d$var$__awaiter(this, void 0, void 0, function() {
                    var _this, url, payload, procFunc, connection, payloadStr, result;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                url = post ? this.getPostUrl() : this.getUrl(module, params);
                                payload = post ? this.getPostData(module, params) : null;
                                procFunc = module === "proxy" ? $8900693e7cefd52d$var$getJsonResult : $8900693e7cefd52d$var$getResult;
                                this.emit("debug", {
                                    action: "request",
                                    request: url,
                                    provider: this
                                });
                                connection = {
                                    url: url,
                                    throttleSlotInterval: 1000,
                                    throttleCallback: function(attempt, url) {
                                        if (_this.isCommunityResource()) (0, $hbpzV.showThrottleMessage)();
                                        return Promise.resolve(true);
                                    }
                                };
                                payloadStr = null;
                                if (payload) {
                                    connection.headers = {
                                        "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                                    };
                                    payloadStr = Object.keys(payload).map(function(key) {
                                        return "".concat(key, "=").concat(payload[key]);
                                    }).join("&");
                                }
                                return [
                                    4,
                                    (0, $l3Xj2.fetchJson)(connection, payloadStr, procFunc || $8900693e7cefd52d$var$getJsonResult)
                                ];
                            case 1:
                                result = _state.sent();
                                this.emit("debug", {
                                    action: "response",
                                    request: url,
                                    response: (0, $iqBKf.deepCopy)(result),
                                    provider: this
                                });
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "detectNetwork",
            value: function detectNetwork() {
                return $8900693e7cefd52d$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        return [
                            2,
                            this.network
                        ];
                    });
                });
            }
        },
        {
            key: "perform",
            value: function perform(method, params) {
                var _this = this;
                var _super = Object.create(null, {
                    perform: {
                        get: function() {
                            return (0, $15W2b._)((0, $711He._)(EtherscanProvider.prototype), "perform", _this);
                        }
                    }
                });
                return $8900693e7cefd52d$var$__awaiter(this, void 0, void 0, function() {
                    var postData, error, postData1, error1, args, topic0, logs, blocks, i, log, block;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                switch(method){
                                    case "getBlockNumber":
                                        return [
                                            3,
                                            1
                                        ];
                                    case "getGasPrice":
                                        return [
                                            3,
                                            2
                                        ];
                                    case "getBalance":
                                        return [
                                            3,
                                            3
                                        ];
                                    case "getTransactionCount":
                                        return [
                                            3,
                                            4
                                        ];
                                    case "getCode":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "getStorageAt":
                                        return [
                                            3,
                                            6
                                        ];
                                    case "sendTransaction":
                                        return [
                                            3,
                                            7
                                        ];
                                    case "getBlock":
                                        return [
                                            3,
                                            8
                                        ];
                                    case "getTransaction":
                                        return [
                                            3,
                                            9
                                        ];
                                    case "getTransactionReceipt":
                                        return [
                                            3,
                                            10
                                        ];
                                    case "call":
                                        return [
                                            3,
                                            11
                                        ];
                                    case "estimateGas":
                                        return [
                                            3,
                                            15
                                        ];
                                    case "getLogs":
                                        return [
                                            3,
                                            19
                                        ];
                                    case "getEtherPrice":
                                        return [
                                            3,
                                            26
                                        ];
                                }
                                return [
                                    3,
                                    28
                                ];
                            case 1:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_blockNumber"
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_gasPrice"
                                    })
                                ];
                            case 3:
                                // Returns base-10 result
                                return [
                                    2,
                                    this.fetch("account", {
                                        action: "balance",
                                        address: params.address,
                                        tag: params.blockTag
                                    })
                                ];
                            case 4:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getTransactionCount",
                                        address: params.address,
                                        tag: params.blockTag
                                    })
                                ];
                            case 5:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getCode",
                                        address: params.address,
                                        tag: params.blockTag
                                    })
                                ];
                            case 6:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getStorageAt",
                                        address: params.address,
                                        position: params.position,
                                        tag: params.blockTag
                                    })
                                ];
                            case 7:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_sendRawTransaction",
                                        hex: params.signedTransaction
                                    }, true).catch(function(error) {
                                        return $8900693e7cefd52d$var$checkError("sendTransaction", error, params.signedTransaction);
                                    })
                                ];
                            case 8:
                                if (params.blockTag) return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getBlockByNumber",
                                        tag: params.blockTag,
                                        boolean: params.includeTransactions ? "true" : "false"
                                    })
                                ];
                                throw new Error("getBlock by blockHash not implemented");
                            case 9:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getTransactionByHash",
                                        txhash: params.transactionHash
                                    })
                                ];
                            case 10:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getTransactionReceipt",
                                        txhash: params.transactionHash
                                    })
                                ];
                            case 11:
                                if (params.blockTag !== "latest") throw new Error("EtherscanProvider does not support blockTag for call");
                                postData = $8900693e7cefd52d$var$getTransactionPostData(params.transaction);
                                postData.module = "proxy";
                                postData.action = "eth_call";
                                _state.label = 12;
                            case 12:
                                _state.trys.push([
                                    12,
                                    14,
                                    ,
                                    15
                                ]);
                                return [
                                    4,
                                    this.fetch("proxy", postData, true)
                                ];
                            case 13:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 14:
                                error = _state.sent();
                                return [
                                    2,
                                    $8900693e7cefd52d$var$checkError("call", error, params.transaction)
                                ];
                            case 15:
                                postData1 = $8900693e7cefd52d$var$getTransactionPostData(params.transaction);
                                postData1.module = "proxy";
                                postData1.action = "eth_estimateGas";
                                _state.label = 16;
                            case 16:
                                _state.trys.push([
                                    16,
                                    18,
                                    ,
                                    19
                                ]);
                                return [
                                    4,
                                    this.fetch("proxy", postData1, true)
                                ];
                            case 17:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 18:
                                error1 = _state.sent();
                                return [
                                    2,
                                    $8900693e7cefd52d$var$checkError("estimateGas", error1, params.transaction)
                                ];
                            case 19:
                                args = {
                                    action: "getLogs"
                                };
                                if (params.filter.fromBlock) args.fromBlock = $8900693e7cefd52d$var$checkLogTag(params.filter.fromBlock);
                                if (params.filter.toBlock) args.toBlock = $8900693e7cefd52d$var$checkLogTag(params.filter.toBlock);
                                if (params.filter.address) args.address = params.filter.address;
                                // @TODO: We can handle slightly more complicated logs using the logs API
                                if (params.filter.topics && params.filter.topics.length > 0) {
                                    if (params.filter.topics.length > 1) $8900693e7cefd52d$var$logger.throwError("unsupported topic count", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                                        topics: params.filter.topics
                                    });
                                    if (params.filter.topics.length === 1) {
                                        topic0 = params.filter.topics[0];
                                        if (typeof topic0 !== "string" || topic0.length !== 66) $8900693e7cefd52d$var$logger.throwError("unsupported topic format", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
                                            topic0: topic0
                                        });
                                        args.topic0 = topic0;
                                    }
                                }
                                return [
                                    4,
                                    this.fetch("logs", args)
                                ];
                            case 20:
                                logs = _state.sent();
                                // Cache txHash => blockHash
                                blocks = {};
                                i = 0;
                                _state.label = 21;
                            case 21:
                                if (!(i < logs.length)) return [
                                    3,
                                    25
                                ];
                                log = logs[i];
                                if (log.blockHash != null) return [
                                    3,
                                    24
                                ];
                                if (!(blocks[log.blockNumber] == null)) return [
                                    3,
                                    23
                                ];
                                return [
                                    4,
                                    this.getBlock(log.blockNumber)
                                ];
                            case 22:
                                block = _state.sent();
                                if (block) blocks[log.blockNumber] = block.hash;
                                _state.label = 23;
                            case 23:
                                log.blockHash = blocks[log.blockNumber];
                                _state.label = 24;
                            case 24:
                                i++;
                                return [
                                    3,
                                    21
                                ];
                            case 25:
                                return [
                                    2,
                                    logs
                                ];
                            case 26:
                                if (this.network.name !== "homestead") return [
                                    2,
                                    0.0
                                ];
                                return [
                                    4,
                                    this.fetch("stats", {
                                        action: "ethprice"
                                    })
                                ];
                            case 27:
                                return [
                                    2,
                                    parseFloat.apply(void 0, [
                                        _state.sent().ethusd
                                    ])
                                ];
                            case 28:
                                return [
                                    3,
                                    29
                                ];
                            case 29:
                                return [
                                    2,
                                    _super.perform.call(this, method, params)
                                ];
                        }
                    });
                });
            }
        },
        {
            // Note: The `page` page parameter only allows pagination within the
            //       10,000 window available without a page and offset parameter
            //       Error: Result window is too large, PageNo x Offset size must
            //              be less than or equal to 10000
            key: "getHistory",
            value: function getHistory(addressOrName, startBlock, endBlock) {
                return $8900693e7cefd52d$var$__awaiter(this, void 0, void 0, function() {
                    var _this, params, _tmp, result;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _tmp = {
                                    action: "txlist"
                                };
                                return [
                                    4,
                                    this.resolveName(addressOrName)
                                ];
                            case 1:
                                params = (_tmp.address = _state.sent(), _tmp.startblock = startBlock == null ? 0 : startBlock, _tmp.endblock = endBlock == null ? 99999999 : endBlock, _tmp.sort = "asc", _tmp);
                                return [
                                    4,
                                    this.fetch("account", params)
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result.map(function(tx) {
                                        [
                                            "contractAddress",
                                            "to"
                                        ].forEach(function(key) {
                                            if (tx[key] == "") delete tx[key];
                                        });
                                        if (tx.creates == null && tx.contractAddress != null) tx.creates = tx.contractAddress;
                                        var item = _this.formatter.transactionResponse(tx);
                                        if (tx.timeStamp) item.timestamp = parseInt(tx.timeStamp);
                                        return item;
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.apiKey === $8900693e7cefd52d$var$defaultApiKey;
            }
        }
    ]);
    return EtherscanProvider;
}((0, $MLa0C.BaseProvider));

});

parcelRegister("brRHB", function(module, exports) {

$parcel$export(module.exports, "FallbackProvider", function () { return $855bdf7fba384049$export$cb1d0beacb55feb7; });

var $feAea = parcelRequire("feAea");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $jquDQ = parcelRequire("jquDQ");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");

var $itJXR = parcelRequire("itJXR");

var $fH8QX = parcelRequire("fH8QX");

var $7ryKd = parcelRequire("7ryKd");

var $2tHqU = parcelRequire("2tHqU");

var $iqBKf = parcelRequire("iqBKf");

var $3ktt3 = parcelRequire("3ktt3");

var $l3Xj2 = parcelRequire("l3Xj2");

var $MLa0C = parcelRequire("MLa0C");

var $hbpzV = parcelRequire("hbpzV");

var $ihGvV = parcelRequire("ihGvV");

var $9Bx3O = parcelRequire("9Bx3O");
"use strict";
var $855bdf7fba384049$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $855bdf7fba384049$var$logger = new (0, $ihGvV.Logger)((0, $9Bx3O.version));
function $855bdf7fba384049$var$now() {
    return new Date().getTime();
}
// Returns to network as long as all agree, or null if any is null.
// Throws an error if any two networks do not match.
function $855bdf7fba384049$var$checkNetworks(networks) {
    var result = null;
    for(var i = 0; i < networks.length; i++){
        var network = networks[i];
        // Null! We do not know our network; bail.
        if (network == null) return null;
        if (result) // Make sure the network matches the previous networks
        {
            if (!(result.name === network.name && result.chainId === network.chainId && (result.ensAddress === network.ensAddress || result.ensAddress == null && network.ensAddress == null))) $855bdf7fba384049$var$logger.throwArgumentError("provider mismatch", "networks", networks);
        } else result = network;
    }
    return result;
}
function $855bdf7fba384049$var$median(values, maxDelta) {
    values = values.slice().sort();
    var middle = Math.floor(values.length / 2);
    // Odd length; take the middle
    if (values.length % 2) return values[middle];
    // Even length; take the average of the two middle
    var a = values[middle - 1], b = values[middle];
    if (maxDelta != null && Math.abs(a - b) > maxDelta) return null;
    return (a + b) / 2;
}
function $855bdf7fba384049$var$serialize(value) {
    if (value === null) return "null";
    else if (typeof value === "number" || typeof value === "boolean") return JSON.stringify(value);
    else if (typeof value === "string") return value;
    else if ((0, $7ryKd.BigNumber).isBigNumber(value)) return value.toString();
    else if (Array.isArray(value)) return JSON.stringify(value.map(function(i) {
        return $855bdf7fba384049$var$serialize(i);
    }));
    else if (typeof value === "object") {
        var keys = Object.keys(value);
        keys.sort();
        return "{" + keys.map(function(key) {
            var v = value[key];
            if (typeof v === "function") v = "[function]";
            else v = $855bdf7fba384049$var$serialize(v);
            return JSON.stringify(key) + ":" + v;
        }).join(",") + "}";
    }
    throw new Error("unknown value type: " + (typeof value === "undefined" ? "undefined" : (0, $jquDQ._)(value)));
}
// Next request ID to use for emitting debug info
var $855bdf7fba384049$var$nextRid = 1;
function $855bdf7fba384049$var$stall(duration) {
    var cancel = null;
    var timer = null;
    var promise = new Promise(function(resolve) {
        cancel = function cancel() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            resolve();
        };
        timer = setTimeout(cancel, duration);
    });
    var wait = function(func) {
        promise = promise.then(func);
        return promise;
    };
    function getPromise() {
        return promise;
    }
    return {
        cancel: cancel,
        getPromise: getPromise,
        wait: wait
    };
}
var $855bdf7fba384049$var$ForwardErrors = [
    (0, $ihGvV.Logger).errors.CALL_EXCEPTION,
    (0, $ihGvV.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $ihGvV.Logger).errors.NONCE_EXPIRED,
    (0, $ihGvV.Logger).errors.REPLACEMENT_UNDERPRICED,
    (0, $ihGvV.Logger).errors.UNPREDICTABLE_GAS_LIMIT
];
var $855bdf7fba384049$var$ForwardProperties = [
    "address",
    "args",
    "errorArgs",
    "errorSignature",
    "method",
    "transaction"
];
function $855bdf7fba384049$var$exposeDebugConfig(config, now) {
    var result = {
        weight: config.weight
    };
    Object.defineProperty(result, "provider", {
        get: function() {
            return config.provider;
        }
    });
    if (config.start) result.start = config.start;
    if (now) result.duration = now - config.start;
    if (config.done) {
        if (config.error) result.error = config.error;
        else result.result = config.result || null;
    }
    return result;
}
function $855bdf7fba384049$var$normalizedTally(normalize, quorum) {
    return function(configs) {
        // Count the votes for each result
        var tally = {};
        configs.forEach(function(c) {
            var value = normalize(c.result);
            if (!tally[value]) tally[value] = {
                count: 0,
                result: c.result
            };
            tally[value].count++;
        });
        // Check for a quorum on any given result
        var keys = Object.keys(tally);
        for(var i = 0; i < keys.length; i++){
            var check = tally[keys[i]];
            if (check.count >= quorum) return check.result;
        }
        // No quroum
        return undefined;
    };
}
function $855bdf7fba384049$var$getProcessFunc(provider, method, params) {
    var normalize = $855bdf7fba384049$var$serialize;
    switch(method){
        case "getBlockNumber":
            // Return the median value, unless there is (median + 1) is also
            // present, in which case that is probably true and the median
            // is going to be stale soon. In the event of a malicious node,
            // the lie will be true soon enough.
            return function(configs) {
                var values = configs.map(function(c) {
                    return c.result;
                });
                // Get the median block number
                var blockNumber = $855bdf7fba384049$var$median(configs.map(function(c) {
                    return c.result;
                }), 2);
                if (blockNumber == null) return undefined;
                blockNumber = Math.ceil(blockNumber);
                // If the next block height is present, its prolly safe to use
                if (values.indexOf(blockNumber + 1) >= 0) blockNumber++;
                // Don't ever roll back the blockNumber
                if (blockNumber >= provider._highestBlockNumber) provider._highestBlockNumber = blockNumber;
                return provider._highestBlockNumber;
            };
        case "getGasPrice":
            // Return the middle (round index up) value, similar to median
            // but do not average even entries and choose the higher.
            // Malicious actors must compromise 50% of the nodes to lie.
            return function(configs) {
                var values = configs.map(function(c) {
                    return c.result;
                });
                values.sort();
                return values[Math.floor(values.length / 2)];
            };
        case "getEtherPrice":
            // Returns the median price. Malicious actors must compromise at
            // least 50% of the nodes to lie (in a meaningful way).
            return function(configs) {
                return $855bdf7fba384049$var$median(configs.map(function(c) {
                    return c.result;
                }));
            };
        // No additional normalizing required; serialize is enough
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorageAt":
        case "call":
        case "estimateGas":
        case "getLogs":
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getTransaction":
        case "getTransactionReceipt":
            normalize = function normalize(tx) {
                if (tx == null) return null;
                tx = (0, $iqBKf.shallowCopy)(tx);
                tx.confirmations = -1;
                return $855bdf7fba384049$var$serialize(tx);
            };
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getBlock":
            // We drop the confirmations from transactions as it is approximate
            if (params.includeTransactions) normalize = function normalize(block) {
                if (block == null) return null;
                block = (0, $iqBKf.shallowCopy)(block);
                block.transactions = block.transactions.map(function(tx) {
                    tx = (0, $iqBKf.shallowCopy)(tx);
                    tx.confirmations = -1;
                    return tx;
                });
                return $855bdf7fba384049$var$serialize(block);
            };
            else normalize = function normalize(block) {
                if (block == null) return null;
                return $855bdf7fba384049$var$serialize(block);
            };
            break;
        default:
            throw new Error("unknown method: " + method);
    }
    // Return the result if and only if the expected quorum is
    // satisfied and agreed upon for the final result.
    return $855bdf7fba384049$var$normalizedTally(normalize, provider.quorum);
}
// If we are doing a blockTag query, we need to make sure the backend is
// caught up to the FallbackProvider, before sending a request to it.
function $855bdf7fba384049$var$waitForSync(config, blockNumber) {
    return $855bdf7fba384049$var$__awaiter(this, void 0, void 0, function() {
        var provider;
        return (0, $itJXR.__generator)(this, function(_state) {
            provider = config.provider;
            if (provider.blockNumber != null && provider.blockNumber >= blockNumber || blockNumber === -1) return [
                2,
                provider
            ];
            return [
                2,
                (0, $l3Xj2.poll)(function() {
                    return new Promise(function(resolve, reject) {
                        setTimeout(function() {
                            // We are synced
                            if (provider.blockNumber >= blockNumber) return resolve(provider);
                            // We're done; just quit
                            if (config.cancelled) return resolve(null);
                            // Try again, next block
                            return resolve(undefined);
                        }, 0);
                    });
                }, {
                    oncePoll: provider
                })
            ];
        });
    });
}
function $855bdf7fba384049$var$getRunner(config, currentBlockNumber, method, params) {
    return $855bdf7fba384049$var$__awaiter(this, void 0, void 0, function() {
        var provider, filter;
        return (0, $itJXR.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    provider = config.provider;
                    switch(method){
                        case "getBlockNumber":
                            return [
                                3,
                                1
                            ];
                        case "getGasPrice":
                            return [
                                3,
                                1
                            ];
                        case "getEtherPrice":
                            return [
                                3,
                                2
                            ];
                        case "getBalance":
                            return [
                                3,
                                3
                            ];
                        case "getTransactionCount":
                            return [
                                3,
                                3
                            ];
                        case "getCode":
                            return [
                                3,
                                3
                            ];
                        case "getStorageAt":
                            return [
                                3,
                                6
                            ];
                        case "getBlock":
                            return [
                                3,
                                9
                            ];
                        case "call":
                            return [
                                3,
                                12
                            ];
                        case "estimateGas":
                            return [
                                3,
                                12
                            ];
                        case "getTransaction":
                            return [
                                3,
                                15
                            ];
                        case "getTransactionReceipt":
                            return [
                                3,
                                15
                            ];
                        case "getLogs":
                            return [
                                3,
                                16
                            ];
                    }
                    return [
                        3,
                        19
                    ];
                case 1:
                    return [
                        2,
                        provider[method]()
                    ];
                case 2:
                    if (provider.getEtherPrice) return [
                        2,
                        provider.getEtherPrice()
                    ];
                    return [
                        3,
                        19
                    ];
                case 3:
                    if (!(params.blockTag && (0, $2tHqU.isHexString)(params.blockTag))) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        $855bdf7fba384049$var$waitForSync(config, currentBlockNumber)
                    ];
                case 4:
                    provider = _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        2,
                        provider[method](params.address, params.blockTag || "latest")
                    ];
                case 6:
                    if (!(params.blockTag && (0, $2tHqU.isHexString)(params.blockTag))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        $855bdf7fba384049$var$waitForSync(config, currentBlockNumber)
                    ];
                case 7:
                    provider = _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2,
                        provider.getStorageAt(params.address, params.position, params.blockTag || "latest")
                    ];
                case 9:
                    if (!(params.blockTag && (0, $2tHqU.isHexString)(params.blockTag))) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        $855bdf7fba384049$var$waitForSync(config, currentBlockNumber)
                    ];
                case 10:
                    provider = _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        2,
                        provider[params.includeTransactions ? "getBlockWithTransactions" : "getBlock"](params.blockTag || params.blockHash)
                    ];
                case 12:
                    if (!(params.blockTag && (0, $2tHqU.isHexString)(params.blockTag))) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        $855bdf7fba384049$var$waitForSync(config, currentBlockNumber)
                    ];
                case 13:
                    provider = _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        2,
                        provider[method](params.transaction)
                    ];
                case 15:
                    return [
                        2,
                        provider[method](params.transactionHash)
                    ];
                case 16:
                    filter = params.filter;
                    if (!(filter.fromBlock && (0, $2tHqU.isHexString)(filter.fromBlock) || filter.toBlock && (0, $2tHqU.isHexString)(filter.toBlock))) return [
                        3,
                        18
                    ];
                    return [
                        4,
                        $855bdf7fba384049$var$waitForSync(config, currentBlockNumber)
                    ];
                case 17:
                    provider = _state.sent();
                    _state.label = 18;
                case 18:
                    return [
                        2,
                        provider.getLogs(filter)
                    ];
                case 19:
                    return [
                        2,
                        $855bdf7fba384049$var$logger.throwError("unknown method error", (0, $ihGvV.Logger).errors.UNKNOWN_ERROR, {
                            method: method,
                            params: params
                        })
                    ];
            }
        });
    });
}
var $855bdf7fba384049$export$cb1d0beacb55feb7 = /*#__PURE__*/ function _target(BaseProvider) {
    (0, $i0LXg._)(FallbackProvider, BaseProvider);
    var _super = (0, $a1vXf._)(FallbackProvider);
    function FallbackProvider(providers, quorum) {
        (0, $9j09T._)(this, FallbackProvider);
        var _this;
        $855bdf7fba384049$var$logger.checkNew(this instanceof FallbackProvider ? this.constructor : void 0, FallbackProvider);
        if (providers.length === 0) $855bdf7fba384049$var$logger.throwArgumentError("missing providers", "providers", providers);
        var providerConfigs = providers.map(function(configOrProvider, index) {
            if ((0, $fH8QX.Provider).isProvider(configOrProvider)) {
                var stallTimeout = (0, $hbpzV.isCommunityResource)(configOrProvider) ? 2000 : 750;
                var priority = 1;
                return Object.freeze({
                    provider: configOrProvider,
                    weight: 1,
                    stallTimeout: stallTimeout,
                    priority: priority
                });
            }
            var config = (0, $iqBKf.shallowCopy)(configOrProvider);
            if (config.priority == null) config.priority = 1;
            if (config.stallTimeout == null) config.stallTimeout = (0, $hbpzV.isCommunityResource)(configOrProvider) ? 2000 : 750;
            if (config.weight == null) config.weight = 1;
            var weight = config.weight;
            if (weight % 1 || weight > 512 || weight < 1) $855bdf7fba384049$var$logger.throwArgumentError("invalid weight; must be integer in [1, 512]", "providers[".concat(index, "].weight"), weight);
            return Object.freeze(config);
        });
        var total = providerConfigs.reduce(function(accum, c) {
            return accum + c.weight;
        }, 0);
        if (quorum == null) quorum = total / 2;
        else if (quorum > total) $855bdf7fba384049$var$logger.throwArgumentError("quorum will always fail; larger than total weight", "quorum", quorum);
        // Are all providers' networks are known
        var networkOrReady = $855bdf7fba384049$var$checkNetworks(providerConfigs.map(function(c) {
            return c.provider.network;
        }));
        // Not all networks are known; we must stall
        if (networkOrReady == null) networkOrReady = new Promise(function(resolve, reject) {
            setTimeout(function() {
                _this.detectNetwork().then(resolve, reject);
            }, 0);
        });
        _this = _super.call(this, networkOrReady);
        // Preserve a copy, so we do not get mutated
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "providerConfigs", Object.freeze(providerConfigs));
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "quorum", quorum);
        _this._highestBlockNumber = -1;
        return _this;
    }
    (0, $eDeHT._)(FallbackProvider, [
        {
            key: "detectNetwork",
            value: function detectNetwork() {
                return $855bdf7fba384049$var$__awaiter(this, void 0, void 0, function() {
                    var networks;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(this.providerConfigs.map(function(c) {
                                        return c.provider.getNetwork();
                                    }))
                                ];
                            case 1:
                                networks = _state.sent();
                                return [
                                    2,
                                    $855bdf7fba384049$var$checkNetworks(networks)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "perform",
            value: function perform(method, params) {
                return $855bdf7fba384049$var$__awaiter(this, void 0, void 0, function() {
                    var _this, _loop, _this1, results, i, result, processFunc, configs, currentBlockNumber, i1, first, _ret;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this, _loop = function() {
                                    var _this2, _loop, t0, inflightWeight, waiting, results, result, errors;
                                    return (0, $itJXR.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _this2 = _this, _loop = function() {
                                                    var config = configs[i1++];
                                                    var rid = $855bdf7fba384049$var$nextRid++;
                                                    config.start = $855bdf7fba384049$var$now();
                                                    config.staller = $855bdf7fba384049$var$stall(config.stallTimeout);
                                                    config.staller.wait(function() {
                                                        config.staller = null;
                                                    });
                                                    config.runner = $855bdf7fba384049$var$getRunner(config, currentBlockNumber, method, params).then(function(result) {
                                                        config.done = true;
                                                        config.result = result;
                                                        if (_this1.listenerCount("debug")) _this1.emit("debug", {
                                                            action: "request",
                                                            rid: rid,
                                                            backend: $855bdf7fba384049$var$exposeDebugConfig(config, $855bdf7fba384049$var$now()),
                                                            request: {
                                                                method: method,
                                                                params: (0, $iqBKf.deepCopy)(params)
                                                            },
                                                            provider: _this1
                                                        });
                                                    }, function(error) {
                                                        config.done = true;
                                                        config.error = error;
                                                        if (_this1.listenerCount("debug")) _this1.emit("debug", {
                                                            action: "request",
                                                            rid: rid,
                                                            backend: $855bdf7fba384049$var$exposeDebugConfig(config, $855bdf7fba384049$var$now()),
                                                            request: {
                                                                method: method,
                                                                params: (0, $iqBKf.deepCopy)(params)
                                                            },
                                                            provider: _this1
                                                        });
                                                    });
                                                    if (_this2.listenerCount("debug")) _this2.emit("debug", {
                                                        action: "request",
                                                        rid: rid,
                                                        backend: $855bdf7fba384049$var$exposeDebugConfig(config, null),
                                                        request: {
                                                            method: method,
                                                            params: (0, $iqBKf.deepCopy)(params)
                                                        },
                                                        provider: _this2
                                                    });
                                                    inflightWeight += config.weight;
                                                };
                                                t0 = $855bdf7fba384049$var$now();
                                                // Compute the inflight weight (exclude anything past)
                                                inflightWeight = configs.filter(function(c) {
                                                    return c.runner && t0 - c.start < c.stallTimeout;
                                                }).reduce(function(accum, c) {
                                                    return accum + c.weight;
                                                }, 0);
                                                // Start running enough to meet quorum
                                                while(inflightWeight < _this.quorum && i1 < configs.length)_loop();
                                                // Wait for anything meaningful to finish or stall out
                                                waiting = [];
                                                configs.forEach(function(c) {
                                                    if (c.done || !c.runner) return;
                                                    waiting.push(c.runner);
                                                    if (c.staller) waiting.push(c.staller.getPromise());
                                                });
                                                if (!waiting.length) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    Promise.race(waiting)
                                                ];
                                            case 1:
                                                _state.sent();
                                                _state.label = 2;
                                            case 2:
                                                // Check the quorum and process the results; the process function
                                                // may additionally decide the quorum is not met
                                                results = configs.filter(function(c) {
                                                    return c.done && c.error == null;
                                                });
                                                if (!(results.length >= _this.quorum)) return [
                                                    3,
                                                    5
                                                ];
                                                result = processFunc(results);
                                                if (result !== undefined) {
                                                    // Shut down any stallers
                                                    configs.forEach(function(c) {
                                                        if (c.staller) c.staller.cancel();
                                                        c.cancelled = true;
                                                    });
                                                    return [
                                                        2,
                                                        {
                                                            v: result
                                                        }
                                                    ];
                                                }
                                                if (!!first) return [
                                                    3,
                                                    4
                                                ];
                                                return [
                                                    4,
                                                    $855bdf7fba384049$var$stall(100).getPromise()
                                                ];
                                            case 3:
                                                _state.sent();
                                                _state.label = 4;
                                            case 4:
                                                first = false;
                                                _state.label = 5;
                                            case 5:
                                                // No result, check for errors that should be forwarded
                                                errors = configs.reduce(function(accum, c) {
                                                    if (!c.done || c.error == null) return accum;
                                                    var code = c.error.code;
                                                    if ($855bdf7fba384049$var$ForwardErrors.indexOf(code) >= 0) {
                                                        if (!accum[code]) accum[code] = {
                                                            error: c.error,
                                                            weight: 0
                                                        };
                                                        accum[code].weight += c.weight;
                                                    }
                                                    return accum;
                                                }, {});
                                                Object.keys(errors).forEach(function(errorCode) {
                                                    var tally = errors[errorCode];
                                                    if (tally.weight < _this1.quorum) return;
                                                    // Shut down any stallers
                                                    configs.forEach(function(c) {
                                                        if (c.staller) c.staller.cancel();
                                                        c.cancelled = true;
                                                    });
                                                    var e = tally.error;
                                                    var props = {};
                                                    $855bdf7fba384049$var$ForwardProperties.forEach(function(name) {
                                                        if (e[name] == null) return;
                                                        props[name] = e[name];
                                                    });
                                                    $855bdf7fba384049$var$logger.throwError(e.reason || e.message, errorCode, props);
                                                });
                                                // All configs have run to completion; we will never get more data
                                                if (configs.filter(function(c) {
                                                    return !c.done;
                                                }).length === 0) return [
                                                    2,
                                                    "break"
                                                ];
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                _this1 = this;
                                if (!(method === "sendTransaction")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    Promise.all(this.providerConfigs.map(function(c) {
                                        return c.provider.sendTransaction(params.signedTransaction).then(function(result) {
                                            return result.hash;
                                        }, function(error) {
                                            return error;
                                        });
                                    }))
                                ];
                            case 1:
                                results = _state.sent();
                                // Any success is good enough (other errors are likely "already seen" errors
                                for(i = 0; i < results.length; i++){
                                    result = results[i];
                                    if (typeof result === "string") return [
                                        2,
                                        result
                                    ];
                                }
                                // They were all an error; pick the first error
                                throw results[0];
                            case 2:
                                if (!(this._highestBlockNumber === -1 && method !== "getBlockNumber")) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this.getBlockNumber()
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                processFunc = $855bdf7fba384049$var$getProcessFunc(this, method, params);
                                // Shuffle the providers and then sort them by their priority; we
                                // shallowCopy them since we will store the result in them too
                                configs = (0, $3ktt3.shuffled)(this.providerConfigs.map((0, $iqBKf.shallowCopy)));
                                configs.sort(function(a, b) {
                                    return a.priority - b.priority;
                                });
                                currentBlockNumber = this._highestBlockNumber;
                                i1 = 0;
                                first = true;
                                _state.label = 5;
                            case 5:
                                if (!true) return [
                                    3,
                                    7
                                ];
                                return [
                                    5,
                                    (0, $itJXR.__values)(_loop())
                                ];
                            case 6:
                                _ret = _state.sent();
                                if ((0, $jquDQ._)(_ret) === "object") return [
                                    2,
                                    _ret.v
                                ];
                                if (_ret === "break") return [
                                    3,
                                    7
                                ];
                                return [
                                    3,
                                    5
                                ];
                            case 7:
                                // Shut down any stallers; shouldn't be any
                                configs.forEach(function(c) {
                                    if (c.staller) c.staller.cancel();
                                    c.cancelled = true;
                                });
                                return [
                                    2,
                                    $855bdf7fba384049$var$logger.throwError("failed to meet quorum", (0, $ihGvV.Logger).errors.SERVER_ERROR, {
                                        method: method,
                                        params: params,
                                        //results: configs.map((c) => c.result),
                                        //errors: configs.map((c) => c.error),
                                        results: configs.map(function(c) {
                                            return $855bdf7fba384049$var$exposeDebugConfig(c);
                                        }),
                                        provider: this
                                    })
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return FallbackProvider;
}((0, $MLa0C.BaseProvider));

});
parcelRegister("3ktt3", function(module, exports) {

$parcel$export(module.exports, "shuffled", function () { return $26ca1904f1feb9de$export$e6c7296801b9b341; });
"use strict";
function $26ca1904f1feb9de$export$e6c7296801b9b341(array) {
    array = array.slice();
    for(var i = array.length - 1; i > 0; i--){
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
    return array;
}

});


parcelRegister("lw1Sw", function(module, exports) {

$parcel$export(module.exports, "IpcProvider", function () { return $fa9e0b1f599fca12$export$fbe151f90a1ece01; });
"use strict";
var $fa9e0b1f599fca12$export$fbe151f90a1ece01 = null;

});

parcelRegister("ciPnS", function(module, exports) {

$parcel$export(module.exports, "InfuraWebSocketProvider", function () { return $8f4f064eefbc2f58$export$dd168a807d60da4f; });
$parcel$export(module.exports, "InfuraProvider", function () { return $8f4f064eefbc2f58$export$60ff1a559b5c6ebd; });

var $feAea = parcelRequire("feAea");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $iqBKf = parcelRequire("iqBKf");

var $gc4Rx = parcelRequire("gc4Rx");

var $hbpzV = parcelRequire("hbpzV");

var $ihGvV = parcelRequire("ihGvV");

var $9Bx3O = parcelRequire("9Bx3O");

var $hz2UR = parcelRequire("hz2UR");
"use strict";
var $8f4f064eefbc2f58$var$logger = new (0, $ihGvV.Logger)((0, $9Bx3O.version));
var $8f4f064eefbc2f58$var$defaultProjectId = "84842078b09946638c03157f83405213";
var $8f4f064eefbc2f58$export$dd168a807d60da4f = /*#__PURE__*/ function(WebSocketProvider) {
    (0, $i0LXg._)(InfuraWebSocketProvider, WebSocketProvider);
    var _super = (0, $a1vXf._)(InfuraWebSocketProvider);
    function InfuraWebSocketProvider(network, apiKey) {
        (0, $9j09T._)(this, InfuraWebSocketProvider);
        var _this;
        var provider = new $8f4f064eefbc2f58$export$60ff1a559b5c6ebd(network, apiKey);
        var connection = provider.connection;
        if (connection.password) $8f4f064eefbc2f58$var$logger.throwError("INFURA WebSocket project secrets unsupported", (0, $ihGvV.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "InfuraProvider.getWebSocketProvider()"
        });
        var url = connection.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
        _this = _super.call(this, url, network);
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "apiKey", provider.projectId);
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "projectId", provider.projectId);
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "projectSecret", provider.projectSecret);
        return _this;
    }
    (0, $eDeHT._)(InfuraWebSocketProvider, [
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.projectId === $8f4f064eefbc2f58$var$defaultProjectId;
            }
        }
    ]);
    return InfuraWebSocketProvider;
}((0, $gc4Rx.WebSocketProvider));
var $8f4f064eefbc2f58$export$60ff1a559b5c6ebd = /*#__PURE__*/ function(UrlJsonRpcProvider) {
    (0, $i0LXg._)(InfuraProvider, UrlJsonRpcProvider);
    var _super = (0, $a1vXf._)(InfuraProvider);
    function InfuraProvider() {
        (0, $9j09T._)(this, InfuraProvider);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(InfuraProvider, [
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.projectId === $8f4f064eefbc2f58$var$defaultProjectId;
            }
        }
    ], [
        {
            key: "getWebSocketProvider",
            value: function getWebSocketProvider(network, apiKey) {
                return new $8f4f064eefbc2f58$export$dd168a807d60da4f(network, apiKey);
            }
        },
        {
            key: "getApiKey",
            value: function getApiKey(apiKey) {
                var apiKeyObj = {
                    apiKey: $8f4f064eefbc2f58$var$defaultProjectId,
                    projectId: $8f4f064eefbc2f58$var$defaultProjectId,
                    projectSecret: null
                };
                if (apiKey == null) return apiKeyObj;
                if (typeof apiKey === "string") apiKeyObj.projectId = apiKey;
                else if (apiKey.projectSecret != null) {
                    $8f4f064eefbc2f58$var$logger.assertArgument(typeof apiKey.projectId === "string", "projectSecret requires a projectId", "projectId", apiKey.projectId);
                    $8f4f064eefbc2f58$var$logger.assertArgument(typeof apiKey.projectSecret === "string", "invalid projectSecret", "projectSecret", "[REDACTED]");
                    apiKeyObj.projectId = apiKey.projectId;
                    apiKeyObj.projectSecret = apiKey.projectSecret;
                } else if (apiKey.projectId) apiKeyObj.projectId = apiKey.projectId;
                apiKeyObj.apiKey = apiKeyObj.projectId;
                return apiKeyObj;
            }
        },
        {
            key: "getUrl",
            value: function getUrl(network, apiKey) {
                var host = null;
                switch(network ? network.name : "unknown"){
                    case "homestead":
                        host = "mainnet.infura.io";
                        break;
                    case "ropsten":
                        host = "ropsten.infura.io";
                        break;
                    case "rinkeby":
                        host = "rinkeby.infura.io";
                        break;
                    case "kovan":
                        host = "kovan.infura.io";
                        break;
                    case "goerli":
                        host = "goerli.infura.io";
                        break;
                    case "matic":
                        host = "polygon-mainnet.infura.io";
                        break;
                    case "maticmum":
                        host = "polygon-mumbai.infura.io";
                        break;
                    default:
                        $8f4f064eefbc2f58$var$logger.throwError("unsupported network", (0, $ihGvV.Logger).errors.INVALID_ARGUMENT, {
                            argument: "network",
                            value: network
                        });
                }
                var connection = {
                    allowGzip: true,
                    url: "https://" + host + "/v3/" + apiKey.projectId,
                    throttleCallback: function(attempt, url) {
                        if (apiKey.projectId === $8f4f064eefbc2f58$var$defaultProjectId) (0, $hbpzV.showThrottleMessage)();
                        return Promise.resolve(true);
                    }
                };
                if (apiKey.projectSecret != null) {
                    connection.user = "";
                    connection.password = apiKey.projectSecret;
                }
                return connection;
            }
        }
    ]);
    return InfuraProvider;
}((0, $hz2UR.UrlJsonRpcProvider));

});

parcelRegister("7dSPw", function(module, exports) {

$parcel$export(module.exports, "JsonRpcBatchProvider", function () { return $542447681748dfbc$export$5a16092bf20edf97; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $iqBKf = parcelRequire("iqBKf");

var $l3Xj2 = parcelRequire("l3Xj2");

var $1VVvv = parcelRequire("1VVvv");
var $542447681748dfbc$export$5a16092bf20edf97 = /*#__PURE__*/ function(JsonRpcProvider) {
    "use strict";
    (0, $i0LXg._)(JsonRpcBatchProvider, JsonRpcProvider);
    var _super = (0, $a1vXf._)(JsonRpcBatchProvider);
    function JsonRpcBatchProvider() {
        (0, $9j09T._)(this, JsonRpcBatchProvider);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(JsonRpcBatchProvider, [
        {
            key: "send",
            value: function send(method, params) {
                var _this = this;
                var request = {
                    method: method,
                    params: params,
                    id: this._nextId++,
                    jsonrpc: "2.0"
                };
                if (this._pendingBatch == null) this._pendingBatch = [];
                var inflightRequest = {
                    request: request,
                    resolve: null,
                    reject: null
                };
                var promise = new Promise(function(resolve, reject) {
                    inflightRequest.resolve = resolve;
                    inflightRequest.reject = reject;
                });
                this._pendingBatch.push(inflightRequest);
                if (!this._pendingBatchAggregator) // Schedule batch for next event loop + short duration
                this._pendingBatchAggregator = setTimeout(function() {
                    // Get teh current batch and clear it, so new requests
                    // go into the next batch
                    var batch = _this._pendingBatch;
                    _this._pendingBatch = null;
                    _this._pendingBatchAggregator = null;
                    // Get the request as an array of requests
                    var request = batch.map(function(inflight) {
                        return inflight.request;
                    });
                    _this.emit("debug", {
                        action: "requestBatch",
                        request: (0, $iqBKf.deepCopy)(request),
                        provider: _this
                    });
                    return (0, $l3Xj2.fetchJson)(_this.connection, JSON.stringify(request)).then(function(result) {
                        _this.emit("debug", {
                            action: "response",
                            request: request,
                            response: result,
                            provider: _this
                        });
                        // For each result, feed it to the correct Promise, depending
                        // on whether it was a success or error
                        batch.forEach(function(inflightRequest, index) {
                            var payload = result[index];
                            if (payload.error) {
                                var error = new Error(payload.error.message);
                                error.code = payload.error.code;
                                error.data = payload.error.data;
                                inflightRequest.reject(error);
                            } else inflightRequest.resolve(payload.result);
                        });
                    }, function(error) {
                        _this.emit("debug", {
                            action: "response",
                            error: error,
                            request: request,
                            provider: _this
                        });
                        batch.forEach(function(inflightRequest) {
                            inflightRequest.reject(error);
                        });
                    });
                }, 10);
                return promise;
            }
        }
    ]);
    return JsonRpcBatchProvider;
}((0, $1VVvv.JsonRpcProvider));

});

parcelRegister("b2S0F", function(module, exports) {

$parcel$export(module.exports, "NodesmithProvider", function () { return $80a9c6ce7e52d358$export$8235cbce3ce273bd; });
/* istanbul ignore file */ 
var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $hz2UR = parcelRequire("hz2UR");

var $ihGvV = parcelRequire("ihGvV");

var $9Bx3O = parcelRequire("9Bx3O");
"use strict";
var $80a9c6ce7e52d358$var$logger = new (0, $ihGvV.Logger)((0, $9Bx3O.version));
// Special API key provided by Nodesmith for ethers.js
var $80a9c6ce7e52d358$var$defaultApiKey = "ETHERS_JS_SHARED";
var $80a9c6ce7e52d358$export$8235cbce3ce273bd = /*#__PURE__*/ function(UrlJsonRpcProvider) {
    (0, $i0LXg._)(NodesmithProvider, UrlJsonRpcProvider);
    var _super = (0, $a1vXf._)(NodesmithProvider);
    function NodesmithProvider() {
        (0, $9j09T._)(this, NodesmithProvider);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(NodesmithProvider, null, [
        {
            key: "getApiKey",
            value: function getApiKey(apiKey) {
                if (apiKey && typeof apiKey !== "string") $80a9c6ce7e52d358$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
                return apiKey || $80a9c6ce7e52d358$var$defaultApiKey;
            }
        },
        {
            key: "getUrl",
            value: function getUrl(network, apiKey) {
                $80a9c6ce7e52d358$var$logger.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
                var host = null;
                switch(network.name){
                    case "homestead":
                        host = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
                        break;
                    case "ropsten":
                        host = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
                        break;
                    case "rinkeby":
                        host = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
                        break;
                    case "goerli":
                        host = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
                        break;
                    case "kovan":
                        host = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
                        break;
                    default:
                        $80a9c6ce7e52d358$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
                }
                return host + "?apiKey=" + apiKey;
            }
        }
    ]);
    return NodesmithProvider;
}((0, $hz2UR.UrlJsonRpcProvider));

});

parcelRegister("f2Gxa", function(module, exports) {

$parcel$export(module.exports, "PocketProvider", function () { return $af38094573b53bf9$export$58bb47e42f6b092e; });

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $iqBKf = parcelRequire("iqBKf");

var $ihGvV = parcelRequire("ihGvV");

var $9Bx3O = parcelRequire("9Bx3O");

var $hz2UR = parcelRequire("hz2UR");
"use strict";
var $af38094573b53bf9$var$logger = new (0, $ihGvV.Logger)((0, $9Bx3O.version));
// These are load-balancer-based application IDs
var $af38094573b53bf9$var$defaultApplicationIds = {
    homestead: "6004bcd10040261633ade990",
    ropsten: "6004bd4d0040261633ade991",
    rinkeby: "6004bda20040261633ade994",
    goerli: "6004bd860040261633ade992"
};
var $af38094573b53bf9$export$58bb47e42f6b092e = /*#__PURE__*/ function _target(UrlJsonRpcProvider) {
    (0, $i0LXg._)(PocketProvider, UrlJsonRpcProvider);
    var _super = (0, $a1vXf._)(PocketProvider);
    function PocketProvider(network, apiKey) {
        (0, $9j09T._)(this, PocketProvider);
        // We need a bit of creativity in the constructor because
        // Pocket uses different default API keys based on the network
        if (apiKey == null) {
            var n = (0, $iqBKf.getStatic)(this instanceof PocketProvider ? this.constructor : void 0, "getNetwork")(network);
            if (n) {
                var applicationId = $af38094573b53bf9$var$defaultApplicationIds[n.name];
                if (applicationId) apiKey = {
                    applicationId: applicationId,
                    loadBalancer: true
                };
            }
            // If there was any issue above, we don't know this network
            if (apiKey == null) $af38094573b53bf9$var$logger.throwError("unsupported network", (0, $ihGvV.Logger).errors.INVALID_ARGUMENT, {
                argument: "network",
                value: network
            });
        }
        return _super.call(this, network, apiKey);
    }
    (0, $eDeHT._)(PocketProvider, [
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.applicationId === $af38094573b53bf9$var$defaultApplicationIds[this.network.name];
            }
        }
    ], [
        {
            key: "getApiKey",
            value: function getApiKey(apiKey) {
                // Most API Providers allow null to get the default configuration, but
                // Pocket requires the network to decide the default provider, so we
                // rely on hijacking the constructor to add a sensible default for us
                if (apiKey == null) $af38094573b53bf9$var$logger.throwArgumentError("PocketProvider.getApiKey does not support null apiKey", "apiKey", apiKey);
                var apiKeyObj = {
                    applicationId: null,
                    loadBalancer: false,
                    applicationSecretKey: null
                };
                // Parse applicationId and applicationSecretKey
                if (typeof apiKey === "string") apiKeyObj.applicationId = apiKey;
                else if (apiKey.applicationSecretKey != null) {
                    $af38094573b53bf9$var$logger.assertArgument(typeof apiKey.applicationId === "string", "applicationSecretKey requires an applicationId", "applicationId", apiKey.applicationId);
                    $af38094573b53bf9$var$logger.assertArgument(typeof apiKey.applicationSecretKey === "string", "invalid applicationSecretKey", "applicationSecretKey", "[REDACTED]");
                    apiKeyObj.applicationId = apiKey.applicationId;
                    apiKeyObj.applicationSecretKey = apiKey.applicationSecretKey;
                    apiKeyObj.loadBalancer = !!apiKey.loadBalancer;
                } else if (apiKey.applicationId) {
                    $af38094573b53bf9$var$logger.assertArgument(typeof apiKey.applicationId === "string", "apiKey.applicationId must be a string", "apiKey.applicationId", apiKey.applicationId);
                    apiKeyObj.applicationId = apiKey.applicationId;
                    apiKeyObj.loadBalancer = !!apiKey.loadBalancer;
                } else $af38094573b53bf9$var$logger.throwArgumentError("unsupported PocketProvider apiKey", "apiKey", apiKey);
                return apiKeyObj;
            }
        },
        {
            key: "getUrl",
            value: function getUrl(network, apiKey) {
                var host = null;
                switch(network ? network.name : "unknown"){
                    case "homestead":
                        host = "eth-mainnet.gateway.pokt.network";
                        break;
                    case "ropsten":
                        host = "eth-ropsten.gateway.pokt.network";
                        break;
                    case "rinkeby":
                        host = "eth-rinkeby.gateway.pokt.network";
                        break;
                    case "goerli":
                        host = "eth-goerli.gateway.pokt.network";
                        break;
                    default:
                        $af38094573b53bf9$var$logger.throwError("unsupported network", (0, $ihGvV.Logger).errors.INVALID_ARGUMENT, {
                            argument: "network",
                            value: network
                        });
                }
                var url = null;
                if (apiKey.loadBalancer) url = "https://".concat(host, "/v1/lb/").concat(apiKey.applicationId);
                else url = "https://".concat(host, "/v1/").concat(apiKey.applicationId);
                var connection = {
                    url: url
                };
                // Initialize empty headers
                connection.headers = {};
                // Apply application secret key
                if (apiKey.applicationSecretKey != null) {
                    connection.user = "";
                    connection.password = apiKey.applicationSecretKey;
                }
                return connection;
            }
        }
    ]);
    return PocketProvider;
}((0, $hz2UR.UrlJsonRpcProvider));

});

parcelRegister("jrgO5", function(module, exports) {

$parcel$export(module.exports, "Web3Provider", function () { return $e26d936dda009747$export$d05096c9fd9d936d; });

var $feAea = parcelRequire("feAea");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $iqBKf = parcelRequire("iqBKf");

var $ihGvV = parcelRequire("ihGvV");

var $9Bx3O = parcelRequire("9Bx3O");

var $1VVvv = parcelRequire("1VVvv");
"use strict";
var $e26d936dda009747$var$logger = new (0, $ihGvV.Logger)((0, $9Bx3O.version));
var $e26d936dda009747$var$_nextId = 1;
function $e26d936dda009747$var$buildWeb3LegacyFetcher(provider, sendFunc) {
    var fetcher = "Web3LegacyFetcher";
    return function(method, params) {
        var _this = this;
        var request = {
            method: method,
            params: params,
            id: $e26d936dda009747$var$_nextId++,
            jsonrpc: "2.0"
        };
        return new Promise(function(resolve, reject) {
            _this.emit("debug", {
                action: "request",
                fetcher: fetcher,
                request: (0, $iqBKf.deepCopy)(request),
                provider: _this
            });
            sendFunc(request, function(error, response) {
                if (error) {
                    _this.emit("debug", {
                        action: "response",
                        fetcher: fetcher,
                        error: error,
                        request: request,
                        provider: _this
                    });
                    return reject(error);
                }
                _this.emit("debug", {
                    action: "response",
                    fetcher: fetcher,
                    request: request,
                    response: response,
                    provider: _this
                });
                if (response.error) {
                    var _$error = new Error(response.error.message);
                    _$error.code = response.error.code;
                    _$error.data = response.error.data;
                    return reject(_$error);
                }
                resolve(response.result);
            });
        });
    };
}
function $e26d936dda009747$var$buildEip1193Fetcher(provider) {
    return function(method, params) {
        var _this = this;
        if (params == null) params = [];
        var request = {
            method: method,
            params: params
        };
        this.emit("debug", {
            action: "request",
            fetcher: "Eip1193Fetcher",
            request: (0, $iqBKf.deepCopy)(request),
            provider: this
        });
        return provider.request(request).then(function(response) {
            _this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                response: response,
                provider: _this
            });
            return response;
        }, function(error) {
            _this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                error: error,
                provider: _this
            });
            throw error;
        });
    };
}
var $e26d936dda009747$export$d05096c9fd9d936d = /*#__PURE__*/ function _target(JsonRpcProvider) {
    (0, $i0LXg._)(Web3Provider, JsonRpcProvider);
    var _super = (0, $a1vXf._)(Web3Provider);
    function Web3Provider(provider, network) {
        (0, $9j09T._)(this, Web3Provider);
        var _this;
        $e26d936dda009747$var$logger.checkNew(this instanceof Web3Provider ? this.constructor : void 0, Web3Provider);
        if (provider == null) $e26d936dda009747$var$logger.throwArgumentError("missing provider", "provider", provider);
        var path = null;
        var jsonRpcFetchFunc = null;
        var subprovider = null;
        if (typeof provider === "function") {
            path = "unknown:";
            jsonRpcFetchFunc = provider;
        } else {
            path = provider.host || provider.path || "";
            if (!path && provider.isMetaMask) path = "metamask";
            subprovider = provider;
            if (provider.request) {
                if (path === "") path = "eip-1193:";
                jsonRpcFetchFunc = $e26d936dda009747$var$buildEip1193Fetcher(provider);
            } else if (provider.sendAsync) jsonRpcFetchFunc = $e26d936dda009747$var$buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
            else if (provider.send) jsonRpcFetchFunc = $e26d936dda009747$var$buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
            else $e26d936dda009747$var$logger.throwArgumentError("unsupported provider", "provider", provider);
            if (!path) path = "unknown:";
        }
        _this = _super.call(this, path, network);
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "jsonRpcFetchFunc", jsonRpcFetchFunc);
        (0, $iqBKf.defineReadOnly)((0, $feAea._)(_this), "provider", subprovider);
        return _this;
    }
    (0, $eDeHT._)(Web3Provider, [
        {
            key: "send",
            value: function send(method, params) {
                return this.jsonRpcFetchFunc(method, params);
            }
        }
    ]);
    return Web3Provider;
}((0, $1VVvv.JsonRpcProvider));

});


parcelRegister("aLhZE", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", function () { return (parcelRequire("6yv4j")).AbiCoder; });
$parcel$export(module.exports, "defaultAbiCoder", function () { return (parcelRequire("6yv4j")).defaultAbiCoder; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("bsEDm")).Fragment; });
$parcel$export(module.exports, "ConstructorFragment", function () { return (parcelRequire("bsEDm")).ConstructorFragment; });
$parcel$export(module.exports, "ErrorFragment", function () { return (parcelRequire("bsEDm")).ErrorFragment; });
$parcel$export(module.exports, "EventFragment", function () { return (parcelRequire("bsEDm")).EventFragment; });
$parcel$export(module.exports, "FunctionFragment", function () { return (parcelRequire("bsEDm")).FunctionFragment; });
$parcel$export(module.exports, "ParamType", function () { return (parcelRequire("bsEDm")).ParamType; });
$parcel$export(module.exports, "FormatTypes", function () { return (parcelRequire("bsEDm")).FormatTypes; });
$parcel$export(module.exports, "checkResultErrors", function () { return (parcelRequire("jG7Zp")).checkResultErrors; });
$parcel$export(module.exports, "Logger", function () { return (parcelRequire("ihGvV")).Logger; });
$parcel$export(module.exports, "RLP", function () { return (parcelRequire("8gMN8")); });
$parcel$export(module.exports, "_fetchData", function () { return (parcelRequire("l3Xj2"))._fetchData; });
$parcel$export(module.exports, "fetchJson", function () { return (parcelRequire("l3Xj2")).fetchJson; });
$parcel$export(module.exports, "poll", function () { return (parcelRequire("l3Xj2")).poll; });
$parcel$export(module.exports, "checkProperties", function () { return (parcelRequire("iqBKf")).checkProperties; });
$parcel$export(module.exports, "deepCopy", function () { return (parcelRequire("iqBKf")).deepCopy; });
$parcel$export(module.exports, "defineReadOnly", function () { return (parcelRequire("iqBKf")).defineReadOnly; });
$parcel$export(module.exports, "getStatic", function () { return (parcelRequire("iqBKf")).getStatic; });
$parcel$export(module.exports, "resolveProperties", function () { return (parcelRequire("iqBKf")).resolveProperties; });
$parcel$export(module.exports, "shallowCopy", function () { return (parcelRequire("iqBKf")).shallowCopy; });
$parcel$export(module.exports, "arrayify", function () { return (parcelRequire("2tHqU")).arrayify; });
$parcel$export(module.exports, "concat", function () { return (parcelRequire("2tHqU")).concat; });
$parcel$export(module.exports, "stripZeros", function () { return (parcelRequire("2tHqU")).stripZeros; });
$parcel$export(module.exports, "zeroPad", function () { return (parcelRequire("2tHqU")).zeroPad; });
$parcel$export(module.exports, "isBytes", function () { return (parcelRequire("2tHqU")).isBytes; });
$parcel$export(module.exports, "isBytesLike", function () { return (parcelRequire("2tHqU")).isBytesLike; });
$parcel$export(module.exports, "defaultPath", function () { return (parcelRequire("3HvNL")).defaultPath; });
$parcel$export(module.exports, "HDNode", function () { return (parcelRequire("3HvNL")).HDNode; });
$parcel$export(module.exports, "SigningKey", function () { return (parcelRequire("9WpJo")).SigningKey; });
$parcel$export(module.exports, "Interface", function () { return (parcelRequire("hrmiK")).Interface; });
$parcel$export(module.exports, "LogDescription", function () { return (parcelRequire("hrmiK")).LogDescription; });
$parcel$export(module.exports, "TransactionDescription", function () { return (parcelRequire("hrmiK")).TransactionDescription; });
$parcel$export(module.exports, "base58", function () { return (parcelRequire("3fxSP")).Base58; });
$parcel$export(module.exports, "base64", function () { return (parcelRequire("fll5z")); });
$parcel$export(module.exports, "hexlify", function () { return (parcelRequire("2tHqU")).hexlify; });
$parcel$export(module.exports, "isHexString", function () { return (parcelRequire("2tHqU")).isHexString; });
$parcel$export(module.exports, "hexConcat", function () { return (parcelRequire("2tHqU")).hexConcat; });
$parcel$export(module.exports, "hexStripZeros", function () { return (parcelRequire("2tHqU")).hexStripZeros; });
$parcel$export(module.exports, "hexValue", function () { return (parcelRequire("2tHqU")).hexValue; });
$parcel$export(module.exports, "hexZeroPad", function () { return (parcelRequire("2tHqU")).hexZeroPad; });
$parcel$export(module.exports, "hexDataLength", function () { return (parcelRequire("2tHqU")).hexDataLength; });
$parcel$export(module.exports, "hexDataSlice", function () { return (parcelRequire("2tHqU")).hexDataSlice; });
$parcel$export(module.exports, "nameprep", function () { return (parcelRequire("e2WFS")).nameprep; });
$parcel$export(module.exports, "_toEscapedUtf8String", function () { return (parcelRequire("5RaVA"))._toEscapedUtf8String; });
$parcel$export(module.exports, "toUtf8Bytes", function () { return (parcelRequire("5RaVA")).toUtf8Bytes; });
$parcel$export(module.exports, "toUtf8CodePoints", function () { return (parcelRequire("5RaVA")).toUtf8CodePoints; });
$parcel$export(module.exports, "toUtf8String", function () { return (parcelRequire("5RaVA")).toUtf8String; });
$parcel$export(module.exports, "Utf8ErrorFuncs", function () { return (parcelRequire("5RaVA")).Utf8ErrorFuncs; });
$parcel$export(module.exports, "formatBytes32String", function () { return (parcelRequire("geK60")).formatBytes32String; });
$parcel$export(module.exports, "parseBytes32String", function () { return (parcelRequire("geK60")).parseBytes32String; });
$parcel$export(module.exports, "hashMessage", function () { return (parcelRequire("axO07")).hashMessage; });
$parcel$export(module.exports, "namehash", function () { return (parcelRequire("ijr5h")).namehash; });
$parcel$export(module.exports, "isValidName", function () { return (parcelRequire("ijr5h")).isValidName; });
$parcel$export(module.exports, "id", function () { return (parcelRequire("9QZv3")).id; });
$parcel$export(module.exports, "_TypedDataEncoder", function () { return (parcelRequire("65WSG")).TypedDataEncoder; });
$parcel$export(module.exports, "getAddress", function () { return (parcelRequire("hFSWi")).getAddress; });
$parcel$export(module.exports, "getIcapAddress", function () { return (parcelRequire("hFSWi")).getIcapAddress; });
$parcel$export(module.exports, "getContractAddress", function () { return (parcelRequire("hFSWi")).getContractAddress; });
$parcel$export(module.exports, "getCreate2Address", function () { return (parcelRequire("hFSWi")).getCreate2Address; });
$parcel$export(module.exports, "isAddress", function () { return (parcelRequire("hFSWi")).isAddress; });
$parcel$export(module.exports, "formatEther", function () { return (parcelRequire("bUcg3")).formatEther; });
$parcel$export(module.exports, "parseEther", function () { return (parcelRequire("bUcg3")).parseEther; });
$parcel$export(module.exports, "formatUnits", function () { return (parcelRequire("bUcg3")).formatUnits; });
$parcel$export(module.exports, "parseUnits", function () { return (parcelRequire("bUcg3")).parseUnits; });
$parcel$export(module.exports, "commify", function () { return (parcelRequire("bUcg3")).commify; });
$parcel$export(module.exports, "computeHmac", function () { return (parcelRequire("iM01F")).computeHmac; });
$parcel$export(module.exports, "keccak256", function () { return (parcelRequire("8Ub7X")).keccak256; });
$parcel$export(module.exports, "ripemd160", function () { return (parcelRequire("iM01F")).ripemd160; });
$parcel$export(module.exports, "sha256", function () { return (parcelRequire("iM01F")).sha256; });
$parcel$export(module.exports, "sha512", function () { return (parcelRequire("iM01F")).sha512; });
$parcel$export(module.exports, "randomBytes", function () { return (parcelRequire("6wezB")).randomBytes; });
$parcel$export(module.exports, "shuffled", function () { return (parcelRequire("3ktt3")).shuffled; });
$parcel$export(module.exports, "solidityPack", function () { return (parcelRequire("bYpCT")).pack; });
$parcel$export(module.exports, "solidityKeccak256", function () { return (parcelRequire("bYpCT")).keccak256; });
$parcel$export(module.exports, "soliditySha256", function () { return (parcelRequire("bYpCT")).sha256; });
$parcel$export(module.exports, "splitSignature", function () { return (parcelRequire("2tHqU")).splitSignature; });
$parcel$export(module.exports, "joinSignature", function () { return (parcelRequire("2tHqU")).joinSignature; });
$parcel$export(module.exports, "accessListify", function () { return (parcelRequire("60XIC")).accessListify; });
$parcel$export(module.exports, "parseTransaction", function () { return (parcelRequire("60XIC")).parse; });
$parcel$export(module.exports, "serializeTransaction", function () { return (parcelRequire("60XIC")).serialize; });
$parcel$export(module.exports, "TransactionTypes", function () { return (parcelRequire("60XIC")).TransactionTypes; });
$parcel$export(module.exports, "getJsonWalletAddress", function () { return (parcelRequire("awZzE")).getJsonWalletAddress; });
$parcel$export(module.exports, "computeAddress", function () { return (parcelRequire("60XIC")).computeAddress; });
$parcel$export(module.exports, "recoverAddress", function () { return (parcelRequire("60XIC")).recoverAddress; });
$parcel$export(module.exports, "computePublicKey", function () { return (parcelRequire("9WpJo")).computePublicKey; });
$parcel$export(module.exports, "recoverPublicKey", function () { return (parcelRequire("9WpJo")).recoverPublicKey; });
$parcel$export(module.exports, "verifyMessage", function () { return (parcelRequire("ldEQw")).verifyMessage; });
$parcel$export(module.exports, "verifyTypedData", function () { return (parcelRequire("ldEQw")).verifyTypedData; });
$parcel$export(module.exports, "getAccountPath", function () { return (parcelRequire("3HvNL")).getAccountPath; });
$parcel$export(module.exports, "mnemonicToEntropy", function () { return (parcelRequire("3HvNL")).mnemonicToEntropy; });
$parcel$export(module.exports, "entropyToMnemonic", function () { return (parcelRequire("3HvNL")).entropyToMnemonic; });
$parcel$export(module.exports, "isValidMnemonic", function () { return (parcelRequire("3HvNL")).isValidMnemonic; });
$parcel$export(module.exports, "mnemonicToSeed", function () { return (parcelRequire("3HvNL")).mnemonicToSeed; });
$parcel$export(module.exports, "SupportedAlgorithm", function () { return (parcelRequire("ipnM1")).SupportedAlgorithm; });
$parcel$export(module.exports, "UnicodeNormalizationForm", function () { return (parcelRequire("5RaVA")).UnicodeNormalizationForm; });
$parcel$export(module.exports, "Utf8ErrorReason", function () { return (parcelRequire("5RaVA")).Utf8ErrorReason; });
$parcel$export(module.exports, "Indexed", function () { return (parcelRequire("hrmiK")).Indexed; });

var $6yv4j = parcelRequire("6yv4j");
var $jG7Zp = parcelRequire("jG7Zp");
var $bsEDm = parcelRequire("bsEDm");
var $hrmiK = parcelRequire("hrmiK");

var $hFSWi = parcelRequire("hFSWi");

var $fll5z = parcelRequire("fll5z");

var $3fxSP = parcelRequire("3fxSP");

var $2tHqU = parcelRequire("2tHqU");

var $65WSG = parcelRequire("65WSG");
var $axO07 = parcelRequire("axO07");
var $9QZv3 = parcelRequire("9QZv3");
var $ijr5h = parcelRequire("ijr5h");

var $3HvNL = parcelRequire("3HvNL");

var $awZzE = parcelRequire("awZzE");

var $8Ub7X = parcelRequire("8Ub7X");

var $ihGvV = parcelRequire("ihGvV");

var $iM01F = parcelRequire("iM01F");
var $ipnM1 = parcelRequire("ipnM1");

var $bYpCT = parcelRequire("bYpCT");

var $6wezB = parcelRequire("6wezB");
var $3ktt3 = parcelRequire("3ktt3");

var $iqBKf = parcelRequire("iqBKf");

var $8gMN8 = parcelRequire("8gMN8");

var $9WpJo = parcelRequire("9WpJo");

var $5RaVA = parcelRequire("5RaVA");
var $geK60 = parcelRequire("geK60");
var $e2WFS = parcelRequire("e2WFS");

var $60XIC = parcelRequire("60XIC");

var $bUcg3 = parcelRequire("bUcg3");

var $ldEQw = parcelRequire("ldEQw");

var $l3Xj2 = parcelRequire("l3Xj2");
"use strict";

});
parcelRegister("fll5z", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return (parcelRequire("G4O4F")).decode; });
$parcel$export(module.exports, "encode", function () { return (parcelRequire("G4O4F")).encode; });

var $G4O4F = parcelRequire("G4O4F");
"use strict";

});

parcelRegister("bYpCT", function(module, exports) {

$parcel$export(module.exports, "pack", function () { return $8b792d2a063acfe8$export$2a703dbb0cb35339; });
$parcel$export(module.exports, "keccak256", function () { return $8b792d2a063acfe8$export$f8151fce47ad1c35; });
$parcel$export(module.exports, "sha256", function () { return $8b792d2a063acfe8$export$bced8d2aada2d1c9; });

var $7ryKd = parcelRequire("7ryKd");

var $2tHqU = parcelRequire("2tHqU");

var $8Ub7X = parcelRequire("8Ub7X");

var $iM01F = parcelRequire("iM01F");

var $5RaVA = parcelRequire("5RaVA");

var $ihGvV = parcelRequire("ihGvV");

var $6GALz = parcelRequire("6GALz");
"use strict";
var $8b792d2a063acfe8$var$regexBytes = new RegExp("^bytes([0-9]+)$");
var $8b792d2a063acfe8$var$regexNumber = new RegExp("^(u?int)([0-9]*)$");
var $8b792d2a063acfe8$var$regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
var $8b792d2a063acfe8$var$Zeros = "0000000000000000000000000000000000000000000000000000000000000000";
var $8b792d2a063acfe8$var$logger = new (0, $ihGvV.Logger)((0, $6GALz.version));
function $8b792d2a063acfe8$var$_pack(type, value, isArray) {
    switch(type){
        case "address":
            if (isArray) return (0, $2tHqU.zeroPad)(value, 32);
            return (0, $2tHqU.arrayify)(value);
        case "string":
            return (0, $5RaVA.toUtf8Bytes)(value);
        case "bytes":
            return (0, $2tHqU.arrayify)(value);
        case "bool":
            value = value ? "0x01" : "0x00";
            if (isArray) return (0, $2tHqU.zeroPad)(value, 32);
            return (0, $2tHqU.arrayify)(value);
    }
    var match = type.match($8b792d2a063acfe8$var$regexNumber);
    if (match) {
        //let signed = (match[1] === "int")
        var size = parseInt(match[2] || "256");
        if (match[2] && String(size) !== match[2] || size % 8 !== 0 || size === 0 || size > 256) $8b792d2a063acfe8$var$logger.throwArgumentError("invalid number type", "type", type);
        if (isArray) size = 256;
        value = (0, $7ryKd.BigNumber).from(value).toTwos(size);
        return (0, $2tHqU.zeroPad)(value, size / 8);
    }
    match = type.match($8b792d2a063acfe8$var$regexBytes);
    if (match) {
        var size1 = parseInt(match[1]);
        if (String(size1) !== match[1] || size1 === 0 || size1 > 32) $8b792d2a063acfe8$var$logger.throwArgumentError("invalid bytes type", "type", type);
        if ((0, $2tHqU.arrayify)(value).byteLength !== size1) $8b792d2a063acfe8$var$logger.throwArgumentError("invalid value for ".concat(type), "value", value);
        if (isArray) return (0, $2tHqU.arrayify)((value + $8b792d2a063acfe8$var$Zeros).substring(0, 66));
        return value;
    }
    match = type.match($8b792d2a063acfe8$var$regexArray);
    if (match && Array.isArray(value)) {
        var baseType = match[1];
        var count = parseInt(match[2] || String(value.length));
        if (count != value.length) $8b792d2a063acfe8$var$logger.throwArgumentError("invalid array length for ".concat(type), "value", value);
        var result = [];
        value.forEach(function(value) {
            result.push($8b792d2a063acfe8$var$_pack(baseType, value, true));
        });
        return (0, $2tHqU.concat)(result);
    }
    return $8b792d2a063acfe8$var$logger.throwArgumentError("invalid type", "type", type);
}
function $8b792d2a063acfe8$export$2a703dbb0cb35339(types, values) {
    if (types.length != values.length) $8b792d2a063acfe8$var$logger.throwArgumentError("wrong number of values; expected ${ types.length }", "values", values);
    var tight = [];
    types.forEach(function(type, index) {
        tight.push($8b792d2a063acfe8$var$_pack(type, values[index]));
    });
    return (0, $2tHqU.hexlify)((0, $2tHqU.concat)(tight));
}
function $8b792d2a063acfe8$export$f8151fce47ad1c35(types, values) {
    return (0, $8Ub7X.keccak256)($8b792d2a063acfe8$export$2a703dbb0cb35339(types, values));
}
function $8b792d2a063acfe8$export$bced8d2aada2d1c9(types, values) {
    return (0, $iM01F.sha256)($8b792d2a063acfe8$export$2a703dbb0cb35339(types, values));
}

});
parcelRegister("6GALz", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $4de32f502ed0c48a$export$83d89fbfd8236492; });
var $4de32f502ed0c48a$export$83d89fbfd8236492 = "solidity/5.5.0";

});


parcelRegister("geK60", function(module, exports) {

$parcel$export(module.exports, "formatBytes32String", function () { return $bd21b5d96944b424$export$b97e949c0076e971; });
$parcel$export(module.exports, "parseBytes32String", function () { return $bd21b5d96944b424$export$49340cb8f3954db8; });

var $dpMov = parcelRequire("dpMov");

var $2tHqU = parcelRequire("2tHqU");

var $5RaVA = parcelRequire("5RaVA");
"use strict";
function $bd21b5d96944b424$export$b97e949c0076e971(text) {
    // Get the bytes
    var bytes = (0, $5RaVA.toUtf8Bytes)(text);
    // Check we have room for null-termination
    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
    // Zero-pad (implicitly null-terminates)
    return (0, $2tHqU.hexlify)((0, $2tHqU.concat)([
        bytes,
        (0, $dpMov.HashZero)
    ]).slice(0, 32));
}
function $bd21b5d96944b424$export$49340cb8f3954db8(bytes) {
    var data = (0, $2tHqU.arrayify)(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
    if (data[31] !== 0) throw new Error("invalid bytes32 string - no null terminator");
    // Find the null termination
    var length = 31;
    while(data[length - 1] === 0)length--;
    // Determine the string value
    return (0, $5RaVA.toUtf8String)(data.slice(0, length));
}

});

parcelRegister("bUcg3", function(module, exports) {

$parcel$export(module.exports, "commify", function () { return $8aae6ed8f35aa572$export$de1294767e6ef661; });
$parcel$export(module.exports, "formatUnits", function () { return $8aae6ed8f35aa572$export$bd39b96f71da1885; });
$parcel$export(module.exports, "parseUnits", function () { return $8aae6ed8f35aa572$export$203ae30b4f6490b3; });
$parcel$export(module.exports, "formatEther", function () { return $8aae6ed8f35aa572$export$11bc63b4c03ea518; });
$parcel$export(module.exports, "parseEther", function () { return $8aae6ed8f35aa572$export$642c4e67bbdc0bc7; });

var $5TPG5 = parcelRequire("5TPG5");

var $ihGvV = parcelRequire("ihGvV");

var $bRwUu = parcelRequire("bRwUu");
"use strict";
var $8aae6ed8f35aa572$var$logger = new (0, $ihGvV.Logger)((0, $bRwUu.version));
var $8aae6ed8f35aa572$var$names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
];
function $8aae6ed8f35aa572$export$de1294767e6ef661(value) {
    var comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || comps[1] && !comps[1].match(/^[0-9]*$/) || value === "." || value === "-.") $8aae6ed8f35aa572$var$logger.throwArgumentError("invalid value", "value", value);
    // Make sure we have at least one whole digit (0 if none)
    var whole = comps[0];
    var negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while(whole.substring(0, 1) === "0")whole = whole.substring(1);
    if (whole === "") whole = "0";
    var suffix = "";
    if (comps.length === 2) suffix = "." + (comps[1] || "0");
    while(suffix.length > 2 && suffix[suffix.length - 1] === "0")suffix = suffix.substring(0, suffix.length - 1);
    var formatted = [];
    while(whole.length)if (whole.length <= 3) {
        formatted.unshift(whole);
        break;
    } else {
        var index = whole.length - 3;
        formatted.unshift(whole.substring(index));
        whole = whole.substring(0, index);
    }
    return negative + formatted.join(",") + suffix;
}
function $8aae6ed8f35aa572$export$bd39b96f71da1885(value, unitName) {
    if (typeof unitName === "string") {
        var index = $8aae6ed8f35aa572$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $5TPG5.formatFixed)(value, unitName != null ? unitName : 18);
}
function $8aae6ed8f35aa572$export$203ae30b4f6490b3(value, unitName) {
    if (typeof value !== "string") $8aae6ed8f35aa572$var$logger.throwArgumentError("value must be a string", "value", value);
    if (typeof unitName === "string") {
        var index = $8aae6ed8f35aa572$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $5TPG5.parseFixed)(value, unitName != null ? unitName : 18);
}
function $8aae6ed8f35aa572$export$11bc63b4c03ea518(wei) {
    return $8aae6ed8f35aa572$export$bd39b96f71da1885(wei, 18);
}
function $8aae6ed8f35aa572$export$642c4e67bbdc0bc7(ether) {
    return $8aae6ed8f35aa572$export$203ae30b4f6490b3(ether, 18);
}

});
parcelRegister("bRwUu", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $8a2e2c3471e2e2d5$export$83d89fbfd8236492; });
var $8a2e2c3471e2e2d5$export$83d89fbfd8236492 = "units/5.5.0";

});



parcelRegister("kBXZw", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $f015cc60c8c953f2$export$83d89fbfd8236492; });
var $f015cc60c8c953f2$export$83d89fbfd8236492 = "ethers/5.5.1";

});



parcelRegister("dpFzc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParsedMessageRegExp = module.exports.ParsedMessage = void 0;

var $8FieW = parcelRequire("8FieW");
Object.defineProperty(module.exports, "ParsedMessage", {
    enumerable: true,
    get: function get() {
        return $8FieW.ParsedMessage;
    }
});

var $9Uhnm = parcelRequire("9Uhnm");
Object.defineProperty(module.exports, "ParsedMessageRegExp", {
    enumerable: true,
    get: function get() {
        return $9Uhnm.ParsedMessage;
    }
});

});
parcelRegister("8FieW", function(module, exports) {

var $9j09T = parcelRequire("9j09T");

var $fyOZQ = parcelRequire("fyOZQ");
"use strict";
var $64f04d23e08278a6$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParsedMessage = void 0;

var $64f04d23e08278a6$var$api_1 = $64f04d23e08278a6$var$__importDefault((parcelRequire("gZMnA")));

var $64f04d23e08278a6$var$node_exports_1 = $64f04d23e08278a6$var$__importDefault((parcelRequire("gCVMI")));
var $64f04d23e08278a6$var$GRAMMAR = '\nsign-in-with-ethereum =\n    domain %s" wants you to sign in with your Ethereum account:" LF\n    address LF\n    LF\n    [ statement LF ]\n    LF\n    %s"URI: " URI LF\n    %s"Version: " version LF\n    %s"Chain ID: " chain-id LF\n    %s"Nonce: " nonce LF\n    %s"Issued At: " issued-at\n    [ LF %s"Expiration Time: " expiration-time ]\n    [ LF %s"Not Before: " not-before ]\n    [ LF %s"Request ID: " request-id ]\n    [ LF %s"Resources:"\n    resources ]\n\ndomain = authority\n\naddress = "0x" 40*40HEXDIG\n    ; Must also conform to captilization\n    ; checksum encoding specified in EIP-55\n    ; where applicable (EOAs).\n\nstatement = 1*( reserved / unreserved / " " )\n    ; The purpose is to exclude LF (line breaks).\n\nversion = "1"\n\nnonce = 8*( ALPHA / DIGIT )\n\nissued-at = date-time\nexpiration-time = date-time\nnot-before = date-time\n\nrequest-id = *pchar\n\nchain-id = 1*DIGIT\n    ; See EIP-155 for valid CHAIN_IDs.\n\nresources = *( LF resource )\n\nresource = "- " URI\n\n; ------------------------------------------------------------------------------\n; RFC 3986\n\nURI           = scheme ":" hier-part [ "?" query ] [ "#" fragment ]\n\nhier-part     = "//" authority path-abempty\n              / path-absolute\n              / path-rootless\n              / path-empty\n\nscheme        = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )\n\nauthority     = [ userinfo "@" ] host [ ":" port ]\nuserinfo      = *( unreserved / pct-encoded / sub-delims / ":" )\nhost          = IP-literal / IPv4address / reg-name\nport          = *DIGIT\n\nIP-literal    = "[" ( IPv6address / IPvFuture  ) "]"\n\nIPvFuture     = "v" 1*HEXDIG "." 1*( unreserved / sub-delims / ":" )\n\nIPv6address   =                            6( h16 ":" ) ls32\n              /                       "::" 5( h16 ":" ) ls32\n              / [               h16 ] "::" 4( h16 ":" ) ls32\n              / [ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32\n              / [ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32\n              / [ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32\n              / [ *4( h16 ":" ) h16 ] "::"              ls32\n              / [ *5( h16 ":" ) h16 ] "::"              h16\n              / [ *6( h16 ":" ) h16 ] "::"\n\nh16           = 1*4HEXDIG\nls32          = ( h16 ":" h16 ) / IPv4address\nIPv4address   = dec-octet "." dec-octet "." dec-octet "." dec-octet\ndec-octet     = DIGIT                 ; 0-9\n                 / %x31-39 DIGIT         ; 10-99\n                 / "1" 2DIGIT            ; 100-199\n                 / "2" %x30-34 DIGIT     ; 200-249\n                 / "25" %x30-35          ; 250-255\n\nreg-name      = *( unreserved / pct-encoded / sub-delims )\n\npath-abempty  = *( "/" segment )\npath-absolute = "/" [ segment-nz *( "/" segment ) ]\npath-rootless = segment-nz *( "/" segment )\npath-empty    = 0pchar\n\nsegment       = *pchar\nsegment-nz    = 1*pchar\n\npchar         = unreserved / pct-encoded / sub-delims / ":" / "@"\n\nquery         = *( pchar / "/" / "?" )\n\nfragment      = *( pchar / "/" / "?" )\n\npct-encoded   = "%" HEXDIG HEXDIG\n\nunreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"\nreserved      = gen-delims / sub-delims\ngen-delims    = ":" / "/" / "?" / "#" / "[" / "]" / "@"\nsub-delims    = "!" / "$" / "&" / "\'" / "(" / ")"\n              / "*" / "+" / "," / ";" / "="\n\n; ------------------------------------------------------------------------------\n; RFC 3339\n\ndate-fullyear   = 4DIGIT\ndate-month      = 2DIGIT  ; 01-12\ndate-mday       = 2DIGIT  ; 01-28, 01-29, 01-30, 01-31 based on\n                          ; month/year\ntime-hour       = 2DIGIT  ; 00-23\ntime-minute     = 2DIGIT  ; 00-59\ntime-second     = 2DIGIT  ; 00-58, 00-59, 00-60 based on leap second\n                          ; rules\ntime-secfrac    = "." 1*DIGIT\ntime-numoffset  = ("+" / "-") time-hour ":" time-minute\ntime-offset     = "Z" / time-numoffset\n\npartial-time    = time-hour ":" time-minute ":" time-second\n                  [time-secfrac]\nfull-date       = date-fullyear "-" date-month "-" date-mday\nfull-time       = partial-time time-offset\n\ndate-time       = full-date "T" full-time\n\n; ------------------------------------------------------------------------------\n; RFC 5234\n\nALPHA          =  %x41-5A / %x61-7A   ; A-Z / a-z\nLF             =  %x0A\n                  ; linefeed\nDIGIT          =  %x30-39\n                  ; 0-9\nHEXDIG         =  DIGIT / "A" / "B" / "C" / "D" / "E" / "F"\n';
var $64f04d23e08278a6$var$ParsedMessage = function ParsedMessage(msg) {
    (0, $9j09T._)(this, ParsedMessage);
    var api = new $64f04d23e08278a6$var$api_1.default($64f04d23e08278a6$var$GRAMMAR);
    api.generate();
    if (api.errors.length) {
        console.error(api.errorsToAscii());
        console.error(api.linesToAscii());
        console.log(api.displayAttributeErrors());
        throw new Error("ABNF grammar has errors");
    }
    var grammarObj = api.toObject();
    var parser = new $64f04d23e08278a6$var$node_exports_1.default.parser();
    parser.ast = new $64f04d23e08278a6$var$node_exports_1.default.ast();
    var id = $64f04d23e08278a6$var$node_exports_1.default.ids;
    var domain = function domain(state, chars, phraseIndex, phraseLength, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.domain = $64f04d23e08278a6$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
        return ret;
    };
    parser.ast.callbacks.domain = domain;
    var address = function address(state, chars, phraseIndex, phraseLength, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.address = $64f04d23e08278a6$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
        return ret;
    };
    parser.ast.callbacks.address = address;
    var statement = function statement(state, chars, phraseIndex, phraseLength, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.statement = $64f04d23e08278a6$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
        return ret;
    };
    parser.ast.callbacks.statement = statement;
    var uri = function uri(state, chars, phraseIndex, phraseLength, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            if (!data.uri) data.uri = $64f04d23e08278a6$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
        }
        return ret;
    };
    parser.ast.callbacks.uri = uri;
    var version = function version(state, chars, phraseIndex, phraseLength, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.version = $64f04d23e08278a6$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
        return ret;
    };
    parser.ast.callbacks.version = version;
    var chainId = function chainId(state, chars, phraseIndex, phraseLength, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.chainId = parseInt($64f04d23e08278a6$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength));
        return ret;
    };
    parser.ast.callbacks["chain-id"] = chainId;
    var nonce = function nonce(state, chars, phraseIndex, phraseLength, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.nonce = $64f04d23e08278a6$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
        return ret;
    };
    parser.ast.callbacks.nonce = nonce;
    var issuedAt = function issuedAt(state, chars, phraseIndex, phraseLength, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.issuedAt = $64f04d23e08278a6$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
        return ret;
    };
    parser.ast.callbacks["issued-at"] = issuedAt;
    var expirationTime = function expirationTime(state, chars, phraseIndex, phraseLength, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.expirationTime = $64f04d23e08278a6$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
        return ret;
    };
    parser.ast.callbacks["expiration-time"] = expirationTime;
    var notBefore = function notBefore(state, chars, phraseIndex, phraseLength, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.notBefore = $64f04d23e08278a6$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
        return ret;
    };
    parser.ast.callbacks["not-before"] = notBefore;
    var requestId = function requestId(state, chars, phraseIndex, phraseLength, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.requestId = $64f04d23e08278a6$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
        return ret;
    };
    parser.ast.callbacks["request-id"] = requestId;
    var resources = function resources(state, chars, phraseIndex, phraseLength, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.resources = $64f04d23e08278a6$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength).slice(3).split("\n- ");
        return ret;
    };
    parser.ast.callbacks.resources = resources;
    var result = parser.parse(grammarObj, "sign-in-with-ethereum", msg);
    if (!result.success) throw new Error("Invalid message: ".concat(JSON.stringify(result)));
    var elements = {};
    parser.ast.translate(elements);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(elements)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $fyOZQ._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            this[key] = value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
module.exports.ParsedMessage = $64f04d23e08278a6$var$ParsedMessage;

});
parcelRegister("gZMnA", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module is Application Programming Interface (API) for **APG** - the ABNF Parser Generator.
//
// *Note on teminology.*
// APG is a parser generator.
// However, it really only generates a "grammar object" (see below) from the defining SABNF grammar.
// The generated parser is incomplete at this stage.
// Remaining, it is the job of the user to develop the generated parser from the grammar object and the **APG** Library (**apg-lib**).
//
// The following terminology my help clear up any confusion between the idea of a "generated parser" versus a "generated grammar object".
// - The generating parser: **APG** is an **APG** parser (yes, there is a circular dependence between **apg-api** and **apg-lib**). We'll call it the generating parser.
// - The target parser: **APG**'s goal is to generate a parser. We'll call it the target parser.
// - The target grammar: this is the (ASCII) SABNF grammar defining the target parser.
// - The target grammar object: **APG** parses the SABNF grammar and generates the JavaScript source for a target grammar object constructor function
// and/or an actual grammar object.
// - The final target parser: The user then develops the final target parser using the generated target grammar
// object and the **APG** parsing library, **apg-lib**.
// Throws execeptions on fatal errors.
//
// src: the input SABNF grammar<br>
// may be one of:
// - Buffer of bytes
// - JavaScript string
// - Array of integer character codes

var $fyOZQ = parcelRequire("fyOZQ");

var $8uCnf = parcelRequire("8uCnf");
var $c5f7defe5887f0f7$require$Buffer = $8uCnf.Buffer;






module.exports = function api(src) {
    var thisFileName = "api.js: ";
    var thisObject = this;
    /* PRIVATE PROPERTIES */ var apglib = (parcelRequire("gCVMI"));
    var converter = (parcelRequire("eHmQA"));
    var scanner = (parcelRequire("8Toi2"));
    var parser = new (parcelRequire("gC7CD"))();
    var _require = (parcelRequire("2TSYG")), attributes = _require.attributes, showAttributes = _require.showAttributes, showAttributeErrors = _require.showAttributeErrors, showRuleDependencies = _require.showRuleDependencies;
    var showRules = (parcelRequire("b8Ggz"));
    /* PRIVATE MEMBERS (FUNCTIONS) */ /* Convert a phrase (array of character codes) to HTML. */ var abnfToHtml = function abnfToHtml(chars, beg, len) {
        var NORMAL = 0;
        var CONTROL = 1;
        var INVALID = 2;
        var CONTROL_BEG = '<span class="'.concat(apglib.style.CLASS_CTRLCHAR, '">');
        var CONTROL_END = "</span>";
        var INVALID_BEG = '<span class="'.concat(apglib.style.CLASS_NOMATCH, '">');
        var INVALID_END = "</span>";
        var end;
        var html = "";
        var TRUE = true;
        while(TRUE){
            if (!Array.isArray(chars) || chars.length === 0) break;
            if (typeof beg !== "number") throw new Error("abnfToHtml: beg must be type number");
            if (beg >= chars.length) break;
            if (typeof len !== "number" || beg + len >= chars.length) end = chars.length;
            else end = beg + len;
            var state = NORMAL;
            for(var i = beg; i < end; i += 1){
                var ch = chars[i];
                if (ch >= 32 && ch <= 126) {
                    /* normal - printable ASCII characters */ if (state === CONTROL) {
                        html += CONTROL_END;
                        state = NORMAL;
                    } else if (state === INVALID) {
                        html += INVALID_END;
                        state = NORMAL;
                    }
                    /* handle reserved HTML entity characters */ switch(ch){
                        case 32:
                            html += "&nbsp;";
                            break;
                        case 60:
                            html += "&lt;";
                            break;
                        case 62:
                            html += "&gt;";
                            break;
                        case 38:
                            html += "&amp;";
                            break;
                        case 34:
                            html += "&quot;";
                            break;
                        case 39:
                            html += "&#039;";
                            break;
                        case 92:
                            html += "&#092;";
                            break;
                        default:
                            html += String.fromCharCode(ch);
                            break;
                    }
                } else if (ch === 9 || ch === 10 || ch === 13) {
                    /* control characters */ if (state === NORMAL) {
                        html += CONTROL_BEG;
                        state = CONTROL;
                    } else if (state === INVALID) {
                        html += INVALID_END + CONTROL_BEG;
                        state = CONTROL;
                    }
                    if (ch === 9) html += "TAB";
                    if (ch === 10) html += "LF";
                    if (ch === 13) html += "CR";
                } else {
                    /* invalid characters */ if (state === NORMAL) {
                        html += INVALID_BEG;
                        state = INVALID;
                    } else if (state === CONTROL) {
                        html += CONTROL_END + INVALID_BEG;
                        state = INVALID;
                    }
                    /* display character as hexadecimal value */ html += "\\x".concat(apglib.utils.charToHex(ch));
                }
            }
            if (state === INVALID) html += INVALID_END;
            if (state === CONTROL) html += CONTROL_END;
            break;
        }
        return html;
    };
    /* Convert a phrase (array of character codes) to ASCII text. */ var abnfToAscii = function abnfToAscii(chars, beg, len) {
        var str = "";
        for(var i = beg; i < beg + len; i += 1){
            var ch = chars[i];
            if (ch >= 32 && ch <= 126) str += String.fromCharCode(ch);
            else switch(ch){
                case 9:
                    str += "\\t";
                    break;
                case 10:
                    str += "\\n";
                    break;
                case 13:
                    str += "\\r";
                    break;
                default:
                    str += "\\unknown";
                    break;
            }
        }
        return str;
    };
    /* translate lines (SABNF grammar) to ASCII text */ var linesToAscii = function linesToAscii(lines) {
        var str = "Annotated Input Grammar";
        lines.forEach(function(val) {
            str += "\n";
            str += "line no: ".concat(val.lineNo);
            str += " : char index: ".concat(val.beginChar);
            str += " : length: ".concat(val.length);
            str += " : abnf: ".concat(abnfToAscii(thisObject.chars, val.beginChar, val.length));
        });
        str += "\n";
        return str;
    };
    /* translate lines (SABNF grammar) to HTML */ var linesToHtml = function linesToHtml(lines) {
        var html = "";
        html += '<table class="'.concat(apglib.style.CLASS_GRAMMAR, '">\n');
        var title = "Annotated Input Grammar";
        html += "<caption>".concat(title, "</caption>\n");
        html += "<tr>";
        html += "<th>line<br>no.</th><th>first<br>char</th><th><br>length</th><th><br>text</th>";
        html += "</tr>\n";
        lines.forEach(function(val) {
            html += "<tr>";
            html += "<td>".concat(val.lineNo);
            html += "</td><td>".concat(val.beginChar);
            html += "</td><td>".concat(val.length);
            html += "</td><td>".concat(abnfToHtml(thisObject.chars, val.beginChar, val.length));
            html += "</td>";
            html += "</tr>\n";
        });
        html += "</table>\n";
        return html;
    };
    /* Format the error messages to HTML, for page display. */ var errorsToHtml = function errorsToHtml(errors, lines, chars, title) {
        var _apglib = (0, $fyOZQ._)(apglib, 1), style = _apglib[0];
        var html = "";
        var errorArrow = '<span class="'.concat(style.CLASS_NOMATCH, '">&raquo;</span>');
        html += '<p><table class="'.concat(style.CLASS_GRAMMAR, '">\n');
        if (title && typeof title === "string") html += "<caption>".concat(title, "</caption>\n");
        html += "<tr><th>line<br>no.</th><th>line<br>offset</th><th>error<br>offset</th><th><br>text</th></tr>\n";
        errors.forEach(function(val) {
            var line;
            var relchar;
            var beg;
            var end;
            var text;
            var prefix = "";
            var suffix = "";
            if (lines.length === 0) {
                text = errorArrow;
                relchar = 0;
            } else {
                line = lines[val.line];
                beg = line.beginChar;
                if (val.char > beg) prefix = abnfToHtml(chars, beg, val.char - beg);
                beg = val.char;
                end = line.beginChar + line.length;
                if (beg < end) suffix = abnfToHtml(chars, beg, end - beg);
                text = prefix + errorArrow + suffix;
                relchar = val.char - line.beginChar;
                html += "<tr>";
                html += "<td>".concat(val.line, "</td><td>").concat(line.beginChar, "</td><td>").concat(relchar, "</td><td>").concat(text, "</td>");
                html += "</tr>\n";
                html += "<tr>";
                html += '<td colspan="3"></td><td>&uarr;:&nbsp;'.concat(apglib.utils.stringToAsciiHtml(val.msg), "</td>");
                html += "</tr>\n";
            }
        });
        html += "</table></p>\n";
        return html;
    };
    /* Display an array of errors in ASCII text */ var errorsToAscii = function errorsToAscii(errors, lines, chars) {
        var str;
        var line;
        var beg;
        var len;
        str = "";
        errors.forEach(function(error) {
            line = lines[error.line];
            str += "".concat(line.lineNo, ": ");
            str += "".concat(line.beginChar, ": ");
            str += "".concat(error.char - line.beginChar, ": ");
            beg = line.beginChar;
            len = error.char - line.beginChar;
            str += abnfToAscii(chars, beg, len);
            str += " >> ";
            beg = error.char;
            len = line.beginChar + line.length - error.char;
            str += abnfToAscii(chars, beg, len);
            str += "\n";
            str += "".concat(line.lineNo, ": ");
            str += "".concat(line.beginChar, ": ");
            str += "".concat(error.char - line.beginChar, ": ");
            str += "error: ";
            str += error.msg;
            str += "\n";
        });
        return str;
    };
    var isScanned = false;
    var isParsed = false;
    var isTranslated = false;
    var haveAttributes = false;
    var attributeErrors = 0;
    var lineMap;
    /* PUBLIC PROPERTIES */ // The input SABNF grammar as a JavaScript string.
    // this.sabnf;
    // The input SABNF grammar as an array of character codes.
    // this.chars;
    // An array of line objects, defining each line of the input SABNF grammar
    // - lineNo : the zero-based line number
    // - beginChar : offset (into `this.chars`) of the first character in the line
    // - length : the number of characters in the line
    // - textLength : the number of characters of text in the line, excluding the line ending characters
    // - endType : "CRLF", "LF", "CR" or "none" if the last line has no line ending characters
    // - invalidChars : `true` if the line contains invalid characters, `false` otherwise
    // this.lines;
    // An array of rule names and data.
    // - name : the rule name
    // - lower : the rule name in lower case
    // - index : the index of the rule (ordered by appearance in SABNF grammar)
    // - isBkr : `true` if this rule has been back referenced, `false` otherwise
    // - opcodes : array of opcodes for this rule
    // - attrs : the rule attributes
    // - ctrl : system data
    // this.rules;
    // An array of UDT names and data.
    // this.udts;
    // An array of errors, if any.
    // - line : the line number containing the error
    // - char : the character offset of the error
    // - msg : the error message
    this.errors = [];
    /* CONSTRUCTOR */ if ($c5f7defe5887f0f7$require$Buffer.isBuffer(src)) this.chars = converter.decode("BINARY", src);
    else if (Array.isArray(src)) this.chars = src.slice();
    else if (typeof src === "string") this.chars = converter.decode("STRING", src);
    else throw new Error("".concat(thisFileName, "input source is not a string, byte Buffer or character array"));
    this.sabnf = converter.encode("STRING", this.chars);
    /* PUBLIC MEMBERS (FUNCTIONS) */ // Scan the input SABNF grammar for invalid characters and catalog the lines via `this.lines`.
    // - strict : (optional) if `true`, all lines, including the last must end with CRLF (\r\n),
    // if `false` (in any JavaScript sense) then line endings may be any mix of CRLF, LF, CR, or end-of-file.
    // - trace (*) : (optional) a parser trace object, which will trace the parser that does the scan
    this.scan = function scan(strict, trace) {
        this.lines = scanner(this.chars, this.errors, strict, trace);
        isScanned = true;
    };
    // Parse the input SABNF grammar for correct syntax.
    // - strict : (optional) if `true`, the input grammar must be strict ABNF, conforming to [RFC 5234](https://tools.ietf.org/html/rfc5234)
    // and [RFC 7405](https://tools.ietf.org/html/rfc7405). No superset features allowed.
    // - trace (\*) : (optional) a parser trace object, which will trace the syntax parser
    //
    // <i>(*)NOTE: the trace option was used primarily during development.
    // Error detection and reporting is now fairly robust and tracing should be unnecessary. Use at your own peril.</i>
    this.parse = function parse(strict, trace) {
        if (!isScanned) throw new Error("".concat(thisFileName, "grammar not scanned"));
        parser.syntax(this.chars, this.lines, this.errors, strict, trace);
        isParsed = true;
    };
    // Translate the SABNF grammar syntax into the opcodes that will guide the parser for this grammar.
    this.translate = function translate() {
        if (!isParsed) throw new Error("".concat(thisFileName, "grammar not scanned and parsed"));
        var ret = parser.semantic(this.chars, this.lines, this.errors);
        if (this.errors.length === 0) {
            this.rules = ret.rules;
            this.udts = ret.udts;
            lineMap = ret.lineMap;
            isTranslated = true;
        }
    };
    // Compute the attributes of each rule.
    this.attributes = function attrs() {
        if (!isTranslated) throw new Error("".concat(thisFileName, "grammar not scanned, parsed and translated"));
        attributeErrors = attributes(this.rules, this.udts, lineMap, this.errors);
        haveAttributes = true;
        return attributeErrors;
    };
    // This function will perform the full suite of steps required to generate a parser grammar object
    // from the input SABNF grammar.
    this.generate = function generate(strict) {
        this.lines = scanner(this.chars, this.errors, strict);
        if (this.errors.length) return;
        parser.syntax(this.chars, this.lines, this.errors, strict);
        if (this.errors.length) return;
        var ret = parser.semantic(this.chars, this.lines, this.errors);
        if (this.errors.length) return;
        this.rules = ret.rules;
        this.udts = ret.udts;
        lineMap = ret.lineMap;
        attributeErrors = attributes(this.rules, this.udts, lineMap, this.errors);
        haveAttributes = true;
    };
    // Display the rules.
    // Must scan, parse and translate before calling this function, otherwise there are no rules to display.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - none of above, index order (default)
    this.displayRules = function displayRules() {
        var order = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "index";
        if (!isTranslated) throw new Error("".concat(thisFileName, "grammar not scanned, parsed and translated"));
        return showRules(this.rules, this.udts, order);
    };
    // Display the rule dependencies.
    // Must scan, parse, translate and compute attributes before calling this function.
    // Otherwise the rule dependencies are not known.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - "type" or "t", ordered by type (alphabetical within each type/group)
    //      - none of above, index order (default)
    this.displayRuleDependencies = function displayRuleDependencies() {
        var order = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "index";
        if (!haveAttributes) throw new Error("".concat(thisFileName, "no attributes - must be preceeded by call to attributes()"));
        return showRuleDependencies(order);
    };
    // Display the attributes.
    // Must scan, parse, translate and compute attributes before calling this function.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - "type" or "t", ordered by type (alphabetical within each type/group)
    //      - none of above, type order (default)
    this.displayAttributes = function displayAttributes() {
        var order = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "index";
        if (!haveAttributes) throw new Error("".concat(thisFileName, "no attributes - must be preceeded by call to attributes()"));
        if (attributeErrors) showAttributeErrors(order);
        return showAttributes(order);
    };
    this.displayAttributeErrors = function displayAttributeErrors() {
        if (!haveAttributes) throw new Error("".concat(thisFileName, "no attributes - must be preceeded by call to attributes()"));
        return showAttributeErrors();
    };
    // Returns a parser grammar object constructor function as a JavaScript string.
    // This object can then be used to construct a parser.
    this.toSource = function toSource(name) {
        if (!haveAttributes) throw new Error("".concat(thisFileName, "can't generate parser source - must be preceeded by call to attributes()"));
        if (attributeErrors) throw new Error("".concat(thisFileName, "can't generate parser source - attributes have ").concat(attributeErrors, " errors"));
        return parser.generateSource(this.chars, this.lines, this.rules, this.udts, name);
    };
    // Returns a parser grammar object.
    // This grammar object may be used by the application to construct a parser.
    this.toObject = function toObject() {
        if (!haveAttributes) throw new Error("".concat(thisFileName, "can't generate parser source - must be preceeded by call to attributes()"));
        if (attributeErrors) throw new Error("".concat(thisFileName, "can't generate parser source - attributes have ").concat(attributeErrors, " errors"));
        return parser.generateObject(this.sabnf, this.rules, this.udts);
    };
    // Display errors in text format, suitable for `console.log()`.
    this.errorsToAscii = function errorsToAsciiFunc() {
        return errorsToAscii(this.errors, this.lines, this.chars);
    };
    // Display errors in HTML format, suitable for web page display.
    // (`apg-lib.css` required for proper styling)
    this.errorsToHtml = function errorsToHtmlFunc(title) {
        return errorsToHtml(this.errors, this.lines, this.chars, title);
    };
    // Generate an annotated the SABNF grammar display in text format.
    this.linesToAscii = function linesToAsciiFunc() {
        return linesToAscii(this.lines);
    };
    // Generate an annotated the SABNF grammar display in HTML format.
    // (`apg-lib.css` required for proper styling)
    this.linesToHtml = function linesToHtmlFunc() {
        return linesToHtml(this.lines);
    };
// This function was only used by apg.html which has been abandoned.
/*
    this.getAttributesObject = function () {
        return null;
    };
    */ };

});
parcelRegister("gCVMI", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module serves to export all library objects and object constructors with the `require("apg-lib")` statement.
// For example, to create a new parser in your program,
// ````
// let apglib = require("../apg-lib/node-exports");
// let my-parser = new apglib.parser();
// ````









module.exports = {
    ast: (parcelRequire("irvQn")),
    circular: (parcelRequire("hxsyk")),
    ids: (parcelRequire("dPnGd")),
    parser: (parcelRequire("ggoVV")),
    stats: (parcelRequire("14FDf")),
    trace: (parcelRequire("kVLFA")),
    utils: (parcelRequire("iKY5M")),
    emitcss: (parcelRequire("66fYd")),
    style: (parcelRequire("9dZeY"))
};

});
parcelRegister("irvQn", function(module, exports) {
/* eslint-disable guard-for-in */ /* eslint-disable no-restricted-syntax */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module is used by the parser to build an [Abstract Syntax Tree](https://en.wikipedia.org/wiki/Abstract_syntax_tree) (AST).
// The AST can be thought of as a subset of the full parse tree.
// Each node of the AST holds the phrase that was matched at the corresponding, named parse tree node.
// It is built as the parser successfully matches phrases to the rule names
// (`RNM` operators) and `UDT`s as it parses an input string.
// The user controls which `RNM` or `UDT` names to keep on the AST.
// The user can also associate callback functions with some or all of the retained
// AST nodes to be used to translate the node phrases. That is, associate semantic
// actions to the matched phrases.
// Translating the AST rather that attempting to apply semantic actions during
// the parsing process, has the advantage that there is no backtracking and that the phrases
// are known while traversing down tree as will as up.
//
// Let `ast` be an `ast.js` object. To identify a node to be kept on the AST:
// ```
// ast.callbacks["rulename"] = true; (all nodes default to false)
// ```
// To associate a callback function with a node:
// ```
// ast.callbacks["rulename"] = fn
// ```
// `rulename` is any `RNM` or `UDT` name defined by the associated grammar
// and `fn` is a user-written callback function.
// (See [`apg-examples`](https://github.com/ldthomas/apg-js2-examples/tree/master/ast) for examples of how to create an AST,
// define the nodes and callback functions and attach it to a parser.)


module.exports = function exportsAst() {
    var id = (parcelRequire("dPnGd"));
    var utils = (parcelRequire("iKY5M"));
    var thisFileName = "ast.js: ";
    var that = this;
    var rules = null;
    var udts = null;
    var chars = null;
    var nodeCount = 0;
    var nodesDefined = [];
    var nodeCallbacks = [];
    var stack = [];
    var records = [];
    this.callbacks = [];
    this.astObject = "astObject";
    /* called by the parser to initialize the AST with the rules, UDTs and the input characters */ this.init = function init(rulesIn, udtsIn, charsIn) {
        stack.length = 0;
        records.length = 0;
        nodesDefined.length = 0;
        nodeCount = 0;
        rules = rulesIn;
        udts = udtsIn;
        chars = charsIn;
        var i;
        var list = [];
        for(i = 0; i < rules.length; i += 1)list.push(rules[i].lower);
        for(i = 0; i < udts.length; i += 1)list.push(udts[i].lower);
        nodeCount = rules.length + udts.length;
        for(i = 0; i < nodeCount; i += 1){
            nodesDefined[i] = false;
            nodeCallbacks[i] = null;
        }
        for(var index in that.callbacks){
            var lower = index.toLowerCase();
            i = list.indexOf(lower);
            if (i < 0) throw new Error("".concat(thisFileName, "init: node '").concat(index, "' not a rule or udt name"));
            if (typeof that.callbacks[index] === "function") {
                nodesDefined[i] = true;
                nodeCallbacks[i] = that.callbacks[index];
            }
            if (that.callbacks[index] === true) nodesDefined[i] = true;
        }
    };
    /* AST node definitions - called by the parser's `RNM` operator */ this.ruleDefined = function ruleDefined(index) {
        return nodesDefined[index] !== false;
    };
    /* AST node definitions - called by the parser's `UDT` operator */ this.udtDefined = function udtDefined(index) {
        return nodesDefined[rules.length + index] !== false;
    };
    /* called by the parser's `RNM` & `UDT` operators */ /* builds a record for the downward traversal of the node */ this.down = function down(callbackIndex, name) {
        var thisIndex = records.length;
        stack.push(thisIndex);
        records.push({
            name: name,
            thisIndex: thisIndex,
            thatIndex: null,
            state: id.SEM_PRE,
            callbackIndex: callbackIndex,
            phraseIndex: null,
            phraseLength: null,
            stack: stack.length
        });
        return thisIndex;
    };
    /* called by the parser's `RNM` & `UDT` operators */ /* builds a record for the upward traversal of the node */ this.up = function up(callbackIndex, name, phraseIndex, phraseLength) {
        var thisIndex = records.length;
        var thatIndex = stack.pop();
        records.push({
            name: name,
            thisIndex: thisIndex,
            thatIndex: thatIndex,
            state: id.SEM_POST,
            callbackIndex: callbackIndex,
            phraseIndex: phraseIndex,
            phraseLength: phraseLength,
            stack: stack.length
        });
        records[thatIndex].thatIndex = thisIndex;
        records[thatIndex].phraseIndex = phraseIndex;
        records[thatIndex].phraseLength = phraseLength;
        return thisIndex;
    };
    // Called by the user to translate the AST.
    // Translate means to associate or apply some semantic action to the
    // phrases that were syntactically matched to the AST nodes according
    // to the defining grammar.
    // ```
    // data - optional user-defined data
    //        passed to the callback functions by the translator
    // ```
    this.translate = function translate(data) {
        var ret;
        var callback;
        var record;
        for(var i = 0; i < records.length; i += 1){
            record = records[i];
            callback = nodeCallbacks[record.callbackIndex];
            if (record.state === id.SEM_PRE) {
                if (callback !== null) {
                    ret = callback(id.SEM_PRE, chars, record.phraseIndex, record.phraseLength, data);
                    if (ret === id.SEM_SKIP) i = record.thatIndex;
                }
            } else if (callback !== null) callback(id.SEM_POST, chars, record.phraseIndex, record.phraseLength, data);
        }
    };
    /* called by the parser to reset the length of the records array */ /* necessary on backtracking */ this.setLength = function setLength(length) {
        records.length = length;
        if (length > 0) stack.length = records[length - 1].stack;
        else stack.length = 0;
    };
    /* called by the parser to get the length of the records array */ this.getLength = function getLength() {
        return records.length;
    };
    /* helper for XML display */ function indent(n) {
        var ret = "";
        for(var i = 0; i < n; i += 1)ret += " ";
        return ret;
    }
    // Generate an `XML` version of the AST.
    // Useful if you want to use a special or favorite XML parser to translate the
    // AST.
    // ```
    // mode - the display mode of the captured phrases
    //      - default mode is "ascii"
    //      - can be: "ascii"
    //                "decimal"
    //                "hexadecimal"
    //                "unicode"
    // ```
    this.toXml = function toSml(modeArg) {
        var display = utils.charsToDec;
        var caption = "decimal integer character codes";
        if (typeof modeArg === "string" && modeArg.length >= 3) {
            var mode = modeArg.slice(0, 3).toLowerCase();
            if (mode === "asc") {
                display = utils.charsToAscii;
                caption = "ASCII for printing characters, hex for non-printing";
            } else if (mode === "hex") {
                display = utils.charsToHex;
                caption = "hexadecimal integer character codes";
            } else if (mode === "uni") {
                display = utils.charsToUnicode;
                caption = "Unicode UTF-32 integer character codes";
            }
        }
        var xml = "";
        var depth = 0;
        xml += '<?xml version="1.0" encoding="utf-8"?>\n';
        xml += '<root nodes="'.concat(records.length / 2, '" characters="').concat(chars.length, '">\n');
        xml += "<!-- input string, ".concat(caption, " -->\n");
        xml += indent(depth + 2);
        xml += display(chars);
        xml += "\n";
        records.forEach(function(rec) {
            if (rec.state === id.SEM_PRE) {
                depth += 1;
                xml += indent(depth);
                xml += '<node name="'.concat(rec.name, '" index="').concat(rec.phraseIndex, '" length="').concat(rec.phraseLength, '">\n');
                xml += indent(depth + 2);
                xml += display(chars, rec.phraseIndex, rec.phraseLength);
                xml += "\n";
            } else {
                xml += indent(depth);
                xml += '</node><!-- name="'.concat(rec.name, '" -->\n');
                depth -= 1;
            }
        });
        xml += "</root>\n";
        return xml;
    };
    /* generate a JavaScript object version of the AST */ /* for the phrase-matching engine apg-exp */ this.phrases = function phrases() {
        var obj = {};
        var i;
        var record;
        for(i = 0; i < records.length; i += 1){
            record = records[i];
            if (record.state === id.SEM_PRE) {
                if (!Array.isArray(obj[record.name])) obj[record.name] = [];
                obj[record.name].push({
                    index: record.phraseIndex,
                    length: record.phraseLength
                });
            }
        }
        return obj;
    };
};

});
parcelRegister("dPnGd", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module exposes a list of named identifiers, shared across the parser generator
// and the parsers that are generated.
module.exports = {
    // Identifies the operator type. Used by the generator
    // to indicate operator types in the grammar object.
    // Used by the [parser](./parser.html) when interpreting the grammar object.
    /* the original ABNF operators */ ALT: 1 /* alternation */ ,
    CAT: 2 /* concatenation */ ,
    REP: 3 /* repetition */ ,
    RNM: 4 /* rule name */ ,
    TRG: 5 /* terminal range */ ,
    TBS: 6 /* terminal binary string, case sensitive */ ,
    TLS: 7 /* terminal literal string, case insensitive */ ,
    /* the super set, SABNF operators */ UDT: 11 /* user-defined terminal */ ,
    AND: 12 /* positive look ahead */ ,
    NOT: 13 /* negative look ahead */ ,
    BKR: 14 /* back reference to a previously matched rule name */ ,
    BKA: 15 /* positive look behind */ ,
    BKN: 16 /* negative look behind */ ,
    ABG: 17 /* anchor - begin of string */ ,
    AEN: 18 /* anchor - end of string */ ,
    // Used by the parser and the user's `RNM` and `UDT` callback functions.
    // Identifies the parser state as it traverses the parse tree nodes.
    // - *ACTIVE* - indicates the downward direction through the parse tree node.
    // - *MATCH* - indicates the upward direction and a phrase, of length \> 0, has been successfully matched
    // - *EMPTY* - indicates the upward direction and a phrase, of length = 0, has been successfully matched
    // - *NOMATCH* - indicates the upward direction and the parser failed to match any phrase at all
    ACTIVE: 100,
    MATCH: 101,
    EMPTY: 102,
    NOMATCH: 103,
    // Used by [`AST` translator](./ast.html) (semantic analysis) and the user's callback functions
    // to indicate the direction of flow through the `AST` nodes.
    // - *SEM_PRE* - indicates the downward (pre-branch) direction through the `AST` node.
    // - *SEM_POST* - indicates the upward (post-branch) direction through the `AST` node.
    SEM_PRE: 200,
    SEM_POST: 201,
    // Used by the user's callback functions to indicate to the `AST` translator (semantic analysis) how to proceed.
    // - *SEM_OK* - normal return value
    // - *SEM_SKIP* - if a callback function returns this value from the SEM_PRE state,
    // the translator will skip processing all `AST` nodes in the branch below the current node.
    // Ignored if returned from the SEM_POST state.
    SEM_OK: 300,
    SEM_SKIP: 301,
    // Used in attribute generation to distinguish the necessary attribute categories.
    // - *ATTR_N* - non-recursive
    // - *ATTR_R* - recursive
    // - *ATTR_MR* - belongs to a mutually-recursive set
    ATTR_N: 400,
    ATTR_R: 401,
    ATTR_MR: 402,
    // Look around values indicate whether the parser is in look ahead or look behind mode.
    // Used by the tracing facility to indicate the look around mode in the trace records display.
    // - *LOOKAROUND_NONE* - the parser is in normal parsing mode
    // - *LOOKAROUND_AHEAD* - the parse is in look-ahead mode, phrase matching for operator `AND(&)` or `NOT(!)`
    // - *LOOKAROUND_BEHIND* - the parse is in look-behind mode, phrase matching for operator `BKA(&&)` or `BKN(!!)`
    LOOKAROUND_NONE: 500,
    LOOKAROUND_AHEAD: 501,
    LOOKAROUND_BEHIND: 502,
    // Back reference rule mode indicators
    // - *BKR_MODE_UM* - the back reference is using universal mode
    // - *BKR_MODE_PM* - the back reference is using parent frame mode
    // - *BKR_MODE_CS* - the back reference is using case-sensitive phrase matching
    // - *BKR_MODE_CI* - the back reference is using case-insensitive phrase matching
    BKR_MODE_UM: 601,
    BKR_MODE_PM: 602,
    BKR_MODE_CS: 603,
    BKR_MODE_CI: 604
};

});

parcelRegister("iKY5M", function(module, exports) {
/* eslint-disable func-names */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module exports a variety of utility functions that support
// [`apg`](https://github.com/ldthomas/apg-js2), [`apg-lib`](https://github.com/ldthomas/apg-js2-lib)
// and the generated parser applications.

var $9dZeY = parcelRequire("9dZeY");

var $eHmQA = parcelRequire("eHmQA");

var $66fYd = parcelRequire("66fYd");

var $dPnGd = parcelRequire("dPnGd");
var thisFileName = "utilities.js: ";
var thisThis = this;
/* translate (implied) phrase beginning character and length to actual first and last character indexes */ /* used by multiple phrase handling functions */ var getBounds = function getBounds(length, begArg, len) {
    var end;
    var beg = begArg;
    var TRUE = true;
    while(TRUE){
        if (length <= 0) {
            beg = 0;
            end = 0;
            break;
        }
        if (typeof beg !== "number") {
            beg = 0;
            end = length;
            break;
        }
        if (beg >= length) {
            beg = length;
            end = length;
            break;
        }
        if (typeof len !== "number") {
            end = length;
            break;
        }
        end = beg + len;
        if (end > length) {
            end = length;
            break;
        }
        break;
    }
    return {
        beg: beg,
        end: end
    };
};
// Generates a complete, minimal HTML5 page, inserting the user's HTML text on the page.
// - *html* - the page text in HTML format
// - *title* - the HTML page `<title>` - defaults to `htmlToPage`.
exports.htmlToPage = function(html, titleArg) {
    var title;
    if (typeof html !== "string") throw new Error("".concat(thisFileName, "htmlToPage: input HTML is not a string"));
    if (typeof titleArg !== "string") title = "htmlToPage";
    else title = titleArg;
    var page = "";
    page += "<!DOCTYPE html>\n";
    page += '<html lang="en">\n';
    page += "<head>\n";
    page += '<meta charset="utf-8">\n';
    page += "<title>".concat(title, "</title>\n");
    page += "<style>\n";
    page += $66fYd();
    page += "</style>\n";
    page += "</head>\n<body>\n";
    page += "<p>".concat(new Date(), "</p>\n");
    page += html;
    page += "</body>\n</html>\n";
    return page;
};
// Formats the returned object from `parser.parse()`
// into an HTML table.
// ```
// return {
//   success : sysData.success,
//   state : sysData.state,
//   length : charsLength,
//   matched : sysData.phraseLength,
//   maxMatched : maxMatched,
//   maxTreeDepth : maxTreeDepth,
//   nodeHits : nodeHits,
//   inputLength : chars.length,
//   subBegin : charsBegin,
//   subEnd : charsEnd,
//   subLength : charsLength
// };
// ```
exports.parserResultToHtml = function(result, caption) {
    var cap = null;
    if (typeof caption === "string" && caption !== "") cap = caption;
    var success;
    var state;
    if (result.success === true) success = '<span class="'.concat($9dZeY.CLASS_MATCH, '">true</span>');
    else success = '<span class="'.concat($9dZeY.CLASS_NOMATCH, '">false</span>');
    if (result.state === $dPnGd.EMPTY) state = '<span class="'.concat($9dZeY.CLASS_EMPTY, '">EMPTY</span>');
    else if (result.state === $dPnGd.MATCH) state = '<span class="'.concat($9dZeY.CLASS_MATCH, '">MATCH</span>');
    else if (result.state === $dPnGd.NOMATCH) state = '<span class="'.concat($9dZeY.CLASS_NOMATCH, '">NOMATCH</span>');
    else state = '<span class="'.concat($9dZeY.CLASS_NOMATCH, '">unrecognized</span>');
    var html = "";
    html += '<table class="'.concat($9dZeY.CLASS_STATE, '">\n');
    if (cap) html += "<caption>".concat(cap, "</caption>\n");
    html += "<tr><th>state item</th><th>value</th><th>description</th></tr>\n";
    html += "<tr><td>parser success</td><td>".concat(success, "</td>\n");
    html += '<td><span class="'.concat($9dZeY.CLASS_MATCH, '">true</span> if the parse succeeded,\n');
    html += ' <span class="'.concat($9dZeY.CLASS_NOMATCH, '">false</span> otherwise');
    html += "<br><i>NOTE: for success, entire string must be matched</i></td></tr>\n";
    html += "<tr><td>parser state</td><td>".concat(state, "</td>\n");
    html += '<td><span class="'.concat($9dZeY.CLASS_EMPTY, '">EMPTY</span>, ');
    html += '<span class="'.concat($9dZeY.CLASS_MATCH, '">MATCH</span> or \n');
    html += '<span class="'.concat($9dZeY.CLASS_NOMATCH, '">NOMATCH</span></td></tr>\n');
    html += "<tr><td>string length</td><td>".concat(result.length, "</td><td>length of the input (sub)string</td></tr>\n");
    html += "<tr><td>matched length</td><td>".concat(result.matched, "</td><td>number of input string characters matched</td></tr>\n");
    html += "<tr><td>max matched</td><td>".concat(result.maxMatched, "</td><td>maximum number of input string characters matched</td></tr>\n");
    html += "<tr><td>max tree depth</td><td>".concat(result.maxTreeDepth, "</td><td>maximum depth of the parse tree reached</td></tr>\n");
    html += "<tr><td>node hits</td><td>".concat(result.nodeHits, "</td><td>number of parse tree node hits (opcode function calls)</td></tr>\n");
    html += "<tr><td>input length</td><td>".concat(result.inputLength, "</td><td>length of full input string</td></tr>\n");
    html += "<tr><td>sub-string begin</td><td>".concat(result.subBegin, "</td><td>sub-string first character index</td></tr>\n");
    html += "<tr><td>sub-string end</td><td>".concat(result.subEnd, "</td><td>sub-string end-of-string index</td></tr>\n");
    html += "<tr><td>sub-string length</td><td>".concat(result.subLength, "</td><td>sub-string length</td></tr>\n");
    html += "</table>\n";
    return html;
};
// Translates a sub-array of integer character codes into a string.
// Very useful in callback functions to translate the matched phrases into strings.
exports.charsToString = function(chars, phraseIndex, phraseLength) {
    var beg;
    var end;
    if (typeof phraseIndex === "number") {
        if (phraseIndex >= chars.length) return "";
        beg = phraseIndex < 0 ? 0 : phraseIndex;
    } else beg = 0;
    if (typeof phraseLength === "number") {
        if (phraseLength <= 0) return "";
        end = phraseLength > chars.length - beg ? chars.length : beg + phraseLength;
    } else end = chars.length;
    if (beg < end) return $eHmQA.encode("UTF16LE", chars.slice(beg, end)).toString("utf16le");
    return "";
};
// Translates a string into an array of integer character codes.
exports.stringToChars = function(string) {
    return $eHmQA.decode("STRING", string);
};
// Translates an opcode identifier into a human-readable string.
exports.opcodeToString = function(type) {
    var ret = "unknown";
    switch(type){
        case $dPnGd.ALT:
            ret = "ALT";
            break;
        case $dPnGd.CAT:
            ret = "CAT";
            break;
        case $dPnGd.RNM:
            ret = "RNM";
            break;
        case $dPnGd.UDT:
            ret = "UDT";
            break;
        case $dPnGd.AND:
            ret = "AND";
            break;
        case $dPnGd.NOT:
            ret = "NOT";
            break;
        case $dPnGd.REP:
            ret = "REP";
            break;
        case $dPnGd.TRG:
            ret = "TRG";
            break;
        case $dPnGd.TBS:
            ret = "TBS";
            break;
        case $dPnGd.TLS:
            ret = "TLS";
            break;
        case $dPnGd.BKR:
            ret = "BKR";
            break;
        case $dPnGd.BKA:
            ret = "BKA";
            break;
        case $dPnGd.BKN:
            ret = "BKN";
            break;
        case $dPnGd.ABG:
            ret = "ABG";
            break;
        case $dPnGd.AEN:
            ret = "AEN";
            break;
        default:
            throw new Error("unrecognized opcode");
    }
    return ret;
};
// Translates an state identifier into a human-readable string.
exports.stateToString = function(state) {
    var ret = "unknown";
    switch(state){
        case $dPnGd.ACTIVE:
            ret = "ACTIVE";
            break;
        case $dPnGd.MATCH:
            ret = "MATCH";
            break;
        case $dPnGd.EMPTY:
            ret = "EMPTY";
            break;
        case $dPnGd.NOMATCH:
            ret = "NOMATCH";
            break;
        default:
            throw new Error("unrecognized state");
    }
    return ret;
};
// Array which translates all 128, 7-bit ASCII character codes to their respective HTML format.
exports.asciiChars = [
    "NUL",
    "SOH",
    "STX",
    "ETX",
    "EOT",
    "ENQ",
    "ACK",
    "BEL",
    "BS",
    "TAB",
    "LF",
    "VT",
    "FF",
    "CR",
    "SO",
    "SI",
    "DLE",
    "DC1",
    "DC2",
    "DC3",
    "DC4",
    "NAK",
    "SYN",
    "ETB",
    "CAN",
    "EM",
    "SUB",
    "ESC",
    "FS",
    "GS",
    "RS",
    "US",
    "&nbsp;",
    "!",
    "&#34;",
    "#",
    "$",
    "%",
    "&#38;",
    "&#39;",
    "(",
    ")",
    "*",
    "+",
    ",",
    "-",
    ".",
    "/",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    ":",
    ";",
    "&#60;",
    "=",
    "&#62;",
    "?",
    "@",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "[",
    "&#92;",
    "]",
    "^",
    "_",
    "`",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "{",
    "|",
    "}",
    "~",
    "DEL"
];
// Translates a single character to hexadecimal with leading zeros for 2, 4, or 8 digit display.
exports.charToHex = function(char) {
    var ch = char.toString(16).toUpperCase();
    switch(ch.length){
        case 1:
        case 3:
        case 7:
            ch = "0".concat(ch);
            break;
        case 2:
        case 6:
            ch = "00".concat(ch);
            break;
        case 4:
            break;
        case 5:
            ch = "000".concat(ch);
            break;
        default:
            throw new Error("unrecognized option");
    }
    return ch;
};
// Translates a sub-array of character codes to decimal display format.
exports.charsToDec = function(chars, beg, len) {
    var ret = "";
    if (!Array.isArray(chars)) throw new Error("".concat(thisFileName, "charsToDec: input must be an array of integers"));
    var bounds = getBounds(chars.length, beg, len);
    if (bounds.end > bounds.beg) {
        ret += chars[bounds.beg];
        for(var i = bounds.beg + 1; i < bounds.end; i += 1)ret += ",".concat(chars[i]);
    }
    return ret;
};
// Translates a sub-array of character codes to hexadecimal display format.
exports.charsToHex = function(chars, beg, len) {
    var ret = "";
    if (!Array.isArray(chars)) throw new Error("".concat(thisFileName, "charsToHex: input must be an array of integers"));
    var bounds = getBounds(chars.length, beg, len);
    if (bounds.end > bounds.beg) {
        ret += "\\x".concat(thisThis.charToHex(chars[bounds.beg]));
        for(var i = bounds.beg + 1; i < bounds.end; i += 1)ret += ",\\x".concat(thisThis.charToHex(chars[i]));
    }
    return ret;
};
exports.charsToHtmlEntities = function(chars, beg, len) {
    var ret = "";
    if (!Array.isArray(chars)) throw new Error("".concat(thisFileName, "charsToHex: input must be an array of integers"));
    var bounds = getBounds(chars.length, beg, len);
    if (bounds.end > bounds.beg) for(var i = bounds.beg; i < bounds.end; i += 1)ret += "&#x".concat(chars[i].toString(16), ";");
    return ret;
};
// Translates a sub-array of character codes to Unicode display format.
function isUnicode(char) {
    if (char >= 0xd800 && char <= 0xdfff) return false;
    if (char > 0x10ffff) return false;
    return true;
}
exports.charsToUnicode = function(chars, beg, len) {
    var ret = "";
    if (!Array.isArray(chars)) throw new Error("".concat(thisFileName, "charsToUnicode: input must be an array of integers"));
    var bounds = getBounds(chars.length, beg, len);
    if (bounds.end > bounds.beg) {
        for(var i = bounds.beg; i < bounds.end; i += 1)if (isUnicode(chars[i])) ret += "&#".concat(chars[i], ";");
        else ret += " U+".concat(thisThis.charToHex(chars[i]));
    }
    return ret;
};
// Translates a sub-array of character codes to JavaScript Unicode display format (`\uXXXX`).
exports.charsToJsUnicode = function(chars, beg, len) {
    var ret = "";
    if (!Array.isArray(chars)) throw new Error("".concat(thisFileName, "charsToJsUnicode: input must be an array of integers"));
    var bounds = getBounds(chars.length, beg, len);
    if (bounds.end > bounds.beg) {
        ret += "\\u".concat(thisThis.charToHex(chars[bounds.beg]));
        for(var i = bounds.beg + 1; i < bounds.end; i += 1)ret += ",\\u".concat(thisThis.charToHex(chars[i]));
    }
    return ret;
};
// Translates a sub-array of character codes to printing ASCII character display format.
exports.charsToAscii = function(chars, beg, len) {
    var ret = "";
    if (!Array.isArray(chars)) throw new Error("".concat(thisFileName, "charsToAscii: input must be an array of integers"));
    var bounds = getBounds(chars.length, beg, len);
    for(var i = bounds.beg; i < bounds.end; i += 1){
        var char = chars[i];
        if (char >= 32 && char <= 126) ret += String.fromCharCode(char);
        else ret += "\\x".concat(thisThis.charToHex(char));
    }
    return ret;
};
// Translates a sub-array of character codes to HTML display format.
exports.charsToAsciiHtml = function(chars, beg, len) {
    if (!Array.isArray(chars)) throw new Error("".concat(thisFileName, "charsToAsciiHtml: input must be an array of integers"));
    var html = "";
    var char;
    var bounds = getBounds(chars.length, beg, len);
    for(var i = bounds.beg; i < bounds.end; i += 1){
        char = chars[i];
        if (char < 32 || char === 127) /* control characters */ html += '<span class="'.concat($9dZeY.CLASS_CTRLCHAR, '">').concat(thisThis.asciiChars[char], "</span>");
        else if (char > 127) /* non-ASCII */ html += '<span class="'.concat($9dZeY.CLASS_CTRLCHAR, '">U+').concat(thisThis.charToHex(char), "</span>");
        else /* printing ASCII, 32 <= char <= 126 */ html += thisThis.asciiChars[char];
    }
    return html;
};
// Translates a JavaScript string to HTML display format.
exports.stringToAsciiHtml = function(str) {
    var chars = $eHmQA.decode("STRING", str);
    return this.charsToAsciiHtml(chars);
};

});
parcelRegister("9dZeY", function(module, exports) {
module.exports = {
    // Generated by apglib/style.js 
    CLASS_MONOSPACE: "apg-mono",
    CLASS_ACTIVE: "apg-active",
    CLASS_EMPTY: "apg-empty",
    CLASS_MATCH: "apg-match",
    CLASS_NOMATCH: "apg-nomatch",
    CLASS_LOOKAHEAD: "apg-lh-match",
    CLASS_LOOKBEHIND: "apg-lb-match",
    CLASS_REMAINDER: "apg-remainder",
    CLASS_CTRLCHAR: "apg-ctrl-char",
    CLASS_LINEEND: "apg-line-end",
    CLASS_ERROR: "apg-error",
    CLASS_PHRASE: "apg-phrase",
    CLASS_EMPTYPHRASE: "apg-empty-phrase",
    CLASS_STATE: "apg-state",
    CLASS_STATS: "apg-stats",
    CLASS_TRACE: "apg-trace",
    CLASS_GRAMMAR: "apg-grammar",
    CLASS_RULES: "apg-rules",
    CLASS_RULESLINK: "apg-rules-link",
    CLASS_ATTRIBUTES: "apg-attrs"
};

});

parcelRegister("eHmQA", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module exposes the public encoding, decoding and conversion functions.
// Its private functions provide the disassembling and interpetation of the source and destination encoding types.
// In the case of Unicode encodings, private functions determine the presence of Byte Order Marks (BOMs), if any.
//
// Throws "TypeError" exceptions on input errors.
//

var $jquDQ = parcelRequire("jquDQ");

var $8uCnf = parcelRequire("8uCnf");
var $ab36cdcf92ca8b9e$require$Buffer = $8uCnf.Buffer;
"use strict;";
var $ab36cdcf92ca8b9e$var$thisThis = undefined;

var $8iHgp = parcelRequire("8iHgp");
/* types */ var $ab36cdcf92ca8b9e$var$UTF8 = "UTF8";
var $ab36cdcf92ca8b9e$var$UTF16 = "UTF16";
var $ab36cdcf92ca8b9e$var$UTF16BE = "UTF16BE";
var $ab36cdcf92ca8b9e$var$UTF16LE = "UTF16LE";
var $ab36cdcf92ca8b9e$var$UTF32 = "UTF32";
var $ab36cdcf92ca8b9e$var$UTF32BE = "UTF32BE";
var $ab36cdcf92ca8b9e$var$UTF32LE = "UTF32LE";
var $ab36cdcf92ca8b9e$var$UINT7 = "UINT7";
var $ab36cdcf92ca8b9e$var$ASCII = "ASCII";
var $ab36cdcf92ca8b9e$var$BINARY = "BINARY";
var $ab36cdcf92ca8b9e$var$UINT8 = "UINT8";
var $ab36cdcf92ca8b9e$var$UINT16 = "UINT16";
var $ab36cdcf92ca8b9e$var$UINT16LE = "UINT16LE";
var $ab36cdcf92ca8b9e$var$UINT16BE = "UINT16BE";
var $ab36cdcf92ca8b9e$var$UINT32 = "UINT32";
var $ab36cdcf92ca8b9e$var$UINT32LE = "UINT32LE";
var $ab36cdcf92ca8b9e$var$UINT32BE = "UINT32BE";
var $ab36cdcf92ca8b9e$var$ESCAPED = "ESCAPED";
var $ab36cdcf92ca8b9e$var$STRING = "STRING";
/* private functions */ // Find the UTF8 BOM, if any.
var $ab36cdcf92ca8b9e$var$bom8 = function bom8(src) {
    src.type = $ab36cdcf92ca8b9e$var$UTF8;
    var buf = src.data;
    src.bom = 0;
    if (buf.length >= 3) {
        if (buf[0] === 0xef && buf[1] === 0xbb && buf[2] === 0xbf) src.bom = 3;
    }
};
// Find the UTF16 BOM, if any, and determine the UTF16 type.
// Defaults to UTF16BE.
// Throws TypeError exception if BOM does not match the specified type.
var $ab36cdcf92ca8b9e$var$bom16 = function bom16(src) {
    var buf = src.data;
    src.bom = 0;
    switch(src.type){
        case $ab36cdcf92ca8b9e$var$UTF16:
            src.type = $ab36cdcf92ca8b9e$var$UTF16BE;
            if (buf.length >= 2) {
                if (buf[0] === 0xfe && buf[1] === 0xff) src.bom = 2;
                else if (buf[0] === 0xff && buf[1] === 0xfe) {
                    src.type = $ab36cdcf92ca8b9e$var$UTF16LE;
                    src.bom = 2;
                }
            }
            break;
        case $ab36cdcf92ca8b9e$var$UTF16BE:
            src.type = $ab36cdcf92ca8b9e$var$UTF16BE;
            if (buf.length >= 2) {
                if (buf[0] === 0xfe && buf[1] === 0xff) src.bom = 2;
                else if (buf[0] === 0xff && buf[1] === 0xfe) throw new TypeError('src type: "'.concat($ab36cdcf92ca8b9e$var$UTF16BE, '" specified but BOM is for "').concat($ab36cdcf92ca8b9e$var$UTF16LE, '"'));
            }
            break;
        case $ab36cdcf92ca8b9e$var$UTF16LE:
            src.type = $ab36cdcf92ca8b9e$var$UTF16LE;
            if (buf.length >= 0) {
                if (buf[0] === 0xfe && buf[1] === 0xff) throw new TypeError('src type: "'.concat($ab36cdcf92ca8b9e$var$UTF16LE, '" specified but BOM is for "').concat($ab36cdcf92ca8b9e$var$UTF16BE, '"'));
                else if (buf[0] === 0xff && buf[1] === 0xfe) src.bom = 2;
            }
            break;
        default:
            throw new TypeError('UTF16 BOM: src type "'.concat(src.type, '" unrecognized'));
    }
};
// Find the UTF32 BOM, if any, and determine the UTF32 type.
// Defaults to UTF32BE.
// Throws exception if BOM does not match the specified type.
var $ab36cdcf92ca8b9e$var$bom32 = function bom32(src) {
    var buf = src.data;
    src.bom = 0;
    switch(src.type){
        case $ab36cdcf92ca8b9e$var$UTF32:
            src.type = $ab36cdcf92ca8b9e$var$UTF32BE;
            if (buf.length >= 4) {
                if (buf[0] === 0 && buf[1] === 0 && buf[2] === 0xfe && buf[3] === 0xff) src.bom = 4;
                if (buf[0] === 0xff && buf[1] === 0xfe && buf[2] === 0 && buf[3] === 0) {
                    src.type = $ab36cdcf92ca8b9e$var$UTF32LE;
                    src.bom = 4;
                }
            }
            break;
        case $ab36cdcf92ca8b9e$var$UTF32BE:
            src.type = $ab36cdcf92ca8b9e$var$UTF32BE;
            if (buf.length >= 4) {
                if (buf[0] === 0 && buf[1] === 0 && buf[2] === 0xfe && buf[3] === 0xff) src.bom = 4;
                if (buf[0] === 0xff && buf[1] === 0xfe && buf[2] === 0 && buf[3] === 0) throw new TypeError("src type: ".concat($ab36cdcf92ca8b9e$var$UTF32BE, " specified but BOM is for ").concat($ab36cdcf92ca8b9e$var$UTF32LE, '"'));
            }
            break;
        case $ab36cdcf92ca8b9e$var$UTF32LE:
            src.type = $ab36cdcf92ca8b9e$var$UTF32LE;
            if (buf.length >= 4) {
                if (buf[0] === 0 && buf[1] === 0 && buf[2] === 0xfe && buf[3] === 0xff) throw new TypeError('src type: "'.concat($ab36cdcf92ca8b9e$var$UTF32LE, '" specified but BOM is for "').concat($ab36cdcf92ca8b9e$var$UTF32BE, '"'));
                if (buf[0] === 0xff && buf[1] === 0xfe && buf[2] === 0 && buf[3] === 0) src.bom = 4;
            }
            break;
        default:
            throw new TypeError('UTF32 BOM: src type "'.concat(src.type, '" unrecognized'));
    }
};
// Validates the source encoding type and matching data.
// If the BASE64: prefix is present, the base 64 decoding is done here as the initial step.
// - For type STRING, data must be a JavaScript string.
// - For type BASE64:*, data may be a string or Buffer.
// - For all other types, data must be a Buffer.
// - The BASE64: prefix is not allowed for type STRING.
var $ab36cdcf92ca8b9e$var$validateSrc = function validateSrc(type, data) {
    function getType(typeArg) {
        var ret = {
            type: "",
            base64: false
        };
        var rx = /^(base64:)?([a-zA-Z0-9]+)$/i;
        var result = rx.exec(typeArg);
        if (result) {
            if (result[2]) ret.type = result[2].toUpperCase();
            if (result[1]) ret.base64 = true;
        }
        return ret;
    }
    if (typeof type !== "string" || type === "") throw new TypeError('type: "'.concat(type, '" not recognized'));
    var ret = getType(type.toUpperCase());
    if (ret.base64) {
        /* handle base 64 */ if (ret.type === $ab36cdcf92ca8b9e$var$STRING) throw new TypeError('type: "'.concat(type, ' "BASE64:" prefix not allowed with type ').concat($ab36cdcf92ca8b9e$var$STRING));
        if ($ab36cdcf92ca8b9e$require$Buffer.isBuffer(data)) ret.data = $8iHgp.base64.decode(data);
        else if (typeof data === "string") {
            var buf = $ab36cdcf92ca8b9e$require$Buffer.from(data, "ascii");
            ret.data = $8iHgp.base64.decode(buf);
        } else throw new TypeError('type: "'.concat(type, " unrecognized data type: typeof(data): ").concat(typeof data === "undefined" ? "undefined" : (0, $jquDQ._)(data)));
    } else ret.data = data;
    switch(ret.type){
        case $ab36cdcf92ca8b9e$var$UTF8:
            $ab36cdcf92ca8b9e$var$bom8(ret);
            break;
        case $ab36cdcf92ca8b9e$var$UTF16:
        case $ab36cdcf92ca8b9e$var$UTF16BE:
        case $ab36cdcf92ca8b9e$var$UTF16LE:
            $ab36cdcf92ca8b9e$var$bom16(ret);
            break;
        case $ab36cdcf92ca8b9e$var$UTF32:
        case $ab36cdcf92ca8b9e$var$UTF32BE:
        case $ab36cdcf92ca8b9e$var$UTF32LE:
            $ab36cdcf92ca8b9e$var$bom32(ret);
            break;
        case $ab36cdcf92ca8b9e$var$UINT16:
            ret.type = $ab36cdcf92ca8b9e$var$UINT16BE;
            break;
        case $ab36cdcf92ca8b9e$var$UINT32:
            ret.type = $ab36cdcf92ca8b9e$var$UINT32BE;
            break;
        case $ab36cdcf92ca8b9e$var$ASCII:
            ret.type = $ab36cdcf92ca8b9e$var$UINT7;
            break;
        case $ab36cdcf92ca8b9e$var$BINARY:
            ret.type = $ab36cdcf92ca8b9e$var$UINT8;
            break;
        case $ab36cdcf92ca8b9e$var$UINT7:
        case $ab36cdcf92ca8b9e$var$UINT8:
        case $ab36cdcf92ca8b9e$var$UINT16LE:
        case $ab36cdcf92ca8b9e$var$UINT16BE:
        case $ab36cdcf92ca8b9e$var$UINT32LE:
        case $ab36cdcf92ca8b9e$var$UINT32BE:
        case $ab36cdcf92ca8b9e$var$STRING:
        case $ab36cdcf92ca8b9e$var$ESCAPED:
            break;
        default:
            throw new TypeError('type: "'.concat(type, '" not recognized'));
    }
    if (ret.type === $ab36cdcf92ca8b9e$var$STRING) {
        if (typeof ret.data !== "string") throw new TypeError('type: "'.concat(type, '" but data is not a string'));
    } else if (!$ab36cdcf92ca8b9e$require$Buffer.isBuffer(ret.data)) throw new TypeError('type: "'.concat(type, '" but data is not a Buffer'));
    return ret;
};
// Disassembles and validates the destination type.
// `chars` must be an Array of integers.
// The :BASE64 suffix is not allowed for type STRING.
var $ab36cdcf92ca8b9e$var$validateDst = function validateDst(type, chars) {
    function getType(typeArg) {
        var fix;
        var rem;
        var ret = {
            crlf: false,
            lf: false,
            base64: false,
            type: ""
        };
        /* prefix, if any */ var TRUE = true;
        while(TRUE){
            rem = typeArg;
            fix = typeArg.slice(0, 5);
            if (fix === "CRLF:") {
                ret.crlf = true;
                rem = typeArg.slice(5);
                break;
            }
            fix = typeArg.slice(0, 3);
            if (fix === "LF:") {
                ret.lf = true;
                rem = typeArg.slice(3);
                break;
            }
            break;
        }
        /* suffix, if any */ fix = rem.split(":");
        if (fix.length === 1) // eslint-disable-next-line prefer-destructuring
        ret.type = fix[0];
        else if (fix.length === 2 && fix[1] === "BASE64") {
            ret.base64 = true;
            // eslint-disable-next-line prefer-destructuring
            ret.type = fix[0];
        }
        return ret;
    }
    if (!Array.isArray(chars)) throw new TypeError('dst chars: not array: "'.concat(typeof chars === "undefined" ? "undefined" : (0, $jquDQ._)(chars)));
    if (typeof type !== "string") throw new TypeError('dst type: not string: "'.concat(typeof type === "undefined" ? "undefined" : (0, $jquDQ._)(type)));
    var ret = getType(type.toUpperCase());
    switch(ret.type){
        case $ab36cdcf92ca8b9e$var$UTF8:
        case $ab36cdcf92ca8b9e$var$UTF16BE:
        case $ab36cdcf92ca8b9e$var$UTF16LE:
        case $ab36cdcf92ca8b9e$var$UTF32BE:
        case $ab36cdcf92ca8b9e$var$UTF32LE:
        case $ab36cdcf92ca8b9e$var$UINT7:
        case $ab36cdcf92ca8b9e$var$UINT8:
        case $ab36cdcf92ca8b9e$var$UINT16LE:
        case $ab36cdcf92ca8b9e$var$UINT16BE:
        case $ab36cdcf92ca8b9e$var$UINT32LE:
        case $ab36cdcf92ca8b9e$var$UINT32BE:
        case $ab36cdcf92ca8b9e$var$ESCAPED:
            break;
        case $ab36cdcf92ca8b9e$var$STRING:
            if (ret.base64) throw new TypeError('":BASE64" suffix not allowed with type '.concat($ab36cdcf92ca8b9e$var$STRING));
            break;
        case $ab36cdcf92ca8b9e$var$ASCII:
            ret.type = $ab36cdcf92ca8b9e$var$UINT7;
            break;
        case $ab36cdcf92ca8b9e$var$BINARY:
            ret.type = $ab36cdcf92ca8b9e$var$UINT8;
            break;
        case $ab36cdcf92ca8b9e$var$UTF16:
            ret.type = $ab36cdcf92ca8b9e$var$UTF16BE;
            break;
        case $ab36cdcf92ca8b9e$var$UTF32:
            ret.type = $ab36cdcf92ca8b9e$var$UTF32BE;
            break;
        case $ab36cdcf92ca8b9e$var$UINT16:
            ret.type = $ab36cdcf92ca8b9e$var$UINT16BE;
            break;
        case $ab36cdcf92ca8b9e$var$UINT32:
            ret.type = $ab36cdcf92ca8b9e$var$UINT32BE;
            break;
        default:
            throw new TypeError('dst type unrecognized: "'.concat(type, '" : must have form [crlf:|lf:]type[:base64]'));
    }
    return ret;
};
// Select and call the requested encoding function.
var $ab36cdcf92ca8b9e$var$encode = function encode(type, chars) {
    switch(type){
        case $ab36cdcf92ca8b9e$var$UTF8:
            return $8iHgp.utf8.encode(chars);
        case $ab36cdcf92ca8b9e$var$UTF16BE:
            return $8iHgp.utf16be.encode(chars);
        case $ab36cdcf92ca8b9e$var$UTF16LE:
            return $8iHgp.utf16le.encode(chars);
        case $ab36cdcf92ca8b9e$var$UTF32BE:
            return $8iHgp.utf32be.encode(chars);
        case $ab36cdcf92ca8b9e$var$UTF32LE:
            return $8iHgp.utf32le.encode(chars);
        case $ab36cdcf92ca8b9e$var$UINT7:
            return $8iHgp.uint7.encode(chars);
        case $ab36cdcf92ca8b9e$var$UINT8:
            return $8iHgp.uint8.encode(chars);
        case $ab36cdcf92ca8b9e$var$UINT16BE:
            return $8iHgp.uint16be.encode(chars);
        case $ab36cdcf92ca8b9e$var$UINT16LE:
            return $8iHgp.uint16le.encode(chars);
        case $ab36cdcf92ca8b9e$var$UINT32BE:
            return $8iHgp.uint32be.encode(chars);
        case $ab36cdcf92ca8b9e$var$UINT32LE:
            return $8iHgp.uint32le.encode(chars);
        case $ab36cdcf92ca8b9e$var$STRING:
            return $8iHgp.string.encode(chars);
        case $ab36cdcf92ca8b9e$var$ESCAPED:
            return $8iHgp.escaped.encode(chars);
        default:
            throw new TypeError('encode type "'.concat(type, '" not recognized'));
    }
};
// Select and call the requested decoding function.
// `src` contains BOM information as well as the source type and data.
var $ab36cdcf92ca8b9e$var$decode = function decode(src) {
    switch(src.type){
        case $ab36cdcf92ca8b9e$var$UTF8:
            return $8iHgp.utf8.decode(src.data, src.bom);
        case $ab36cdcf92ca8b9e$var$UTF16LE:
            return $8iHgp.utf16le.decode(src.data, src.bom);
        case $ab36cdcf92ca8b9e$var$UTF16BE:
            return $8iHgp.utf16be.decode(src.data, src.bom);
        case $ab36cdcf92ca8b9e$var$UTF32BE:
            return $8iHgp.utf32be.decode(src.data, src.bom);
        case $ab36cdcf92ca8b9e$var$UTF32LE:
            return $8iHgp.utf32le.decode(src.data, src.bom);
        case $ab36cdcf92ca8b9e$var$UINT7:
            return $8iHgp.uint7.decode(src.data);
        case $ab36cdcf92ca8b9e$var$UINT8:
            return $8iHgp.uint8.decode(src.data);
        case $ab36cdcf92ca8b9e$var$UINT16BE:
            return $8iHgp.uint16be.decode(src.data);
        case $ab36cdcf92ca8b9e$var$UINT16LE:
            return $8iHgp.uint16le.decode(src.data);
        case $ab36cdcf92ca8b9e$var$UINT32BE:
            return $8iHgp.uint32be.decode(src.data);
        case $ab36cdcf92ca8b9e$var$UINT32LE:
            return $8iHgp.uint32le.decode(src.data);
        case $ab36cdcf92ca8b9e$var$STRING:
            return $8iHgp.string.decode(src.data);
        case $ab36cdcf92ca8b9e$var$ESCAPED:
            return $8iHgp.escaped.decode(src.data);
        default:
            throw new TypeError('decode type "'.concat(src.type, '" not recognized'));
    }
};
// The public decoding function. Returns an array of integers.
module.exports.decode = function exportsDecode(type, data) {
    var src = $ab36cdcf92ca8b9e$var$validateSrc(type, data);
    return $ab36cdcf92ca8b9e$var$decode(src);
};
// The public encoding function. Returns a Buffer-typed byte array.
module.exports.encode = function exportsEncode(type, chars) {
    var c;
    var buf;
    var dst = $ab36cdcf92ca8b9e$var$validateDst(type, chars);
    if (dst.crlf) {
        /* prefix with CRLF line end conversion, don't contaminate caller's chars array */ c = $8iHgp.lineEnds.crlf(chars);
        buf = $ab36cdcf92ca8b9e$var$encode(dst.type, c);
    } else if (dst.lf) {
        /* prefix with LF line end conversion, don't contaminate caller's chars array */ c = $8iHgp.lineEnds.lf(chars);
        buf = $ab36cdcf92ca8b9e$var$encode(dst.type, c);
    } else buf = $ab36cdcf92ca8b9e$var$encode(dst.type, chars);
    if (dst.base64) /* post base 64 encoding */ buf = $8iHgp.base64.encode(buf);
    return buf;
};
// Converts data of type `srcType` to data of type `dstType`.
// `srcData` may be a JavaScript String, or node.js Buffer, depending on the corresponding type.
module.exports.convert = function convert(srcType, srcData, dstType) {
    return $ab36cdcf92ca8b9e$var$thisThis.encode(dstType, $ab36cdcf92ca8b9e$var$thisThis.decode(srcType, srcData));
};

});
parcelRegister("8iHgp", function(module, exports) {
/* eslint-disable prefer-destructuring */ /* eslint-disable no-plusplus */ /* eslint-disable no-bitwise */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module contains the actual encoding and decoding algorithms.
// Throws "RangeError" exceptions on characters or bytes out of range for the given encoding.

var $8uCnf = parcelRequire("8uCnf");
var $60b190684094cead$require$Buffer = $8uCnf.Buffer;
"use strict;";
var $60b190684094cead$var$thisThis = module.exports;
/* decoding error codes */ var $60b190684094cead$var$NON_SHORTEST = 0xfffffffc;
var $60b190684094cead$var$TRAILING = 0xfffffffd;
var $60b190684094cead$var$RANGE = 0xfffffffe;
var $60b190684094cead$var$ILL_FORMED = 0xffffffff;
/* mask[n] = 2**n - 1, ie. mask[n] = n bits on. e.g. mask[6] = %b111111 */ var $60b190684094cead$var$mask = [
    0,
    1,
    3,
    7,
    15,
    31,
    63,
    127,
    255,
    511,
    1023
];
/* ascii[n] = 'HH', where 0xHH = n, eg. ascii[254] = 'FE' */ var $60b190684094cead$var$ascii = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0A",
    "0B",
    "0C",
    "0D",
    "0E",
    "0F",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1A",
    "1B",
    "1C",
    "1D",
    "1E",
    "1F",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2A",
    "2B",
    "2C",
    "2D",
    "2E",
    "2F",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3A",
    "3B",
    "3C",
    "3D",
    "3E",
    "3F",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4A",
    "4B",
    "4C",
    "4D",
    "4E",
    "4F",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5A",
    "5B",
    "5C",
    "5D",
    "5E",
    "5F",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6A",
    "6B",
    "6C",
    "6D",
    "6E",
    "6F",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7A",
    "7B",
    "7C",
    "7D",
    "7E",
    "7F",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8A",
    "8B",
    "8C",
    "8D",
    "8E",
    "8F",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9A",
    "9B",
    "9C",
    "9D",
    "9E",
    "9F",
    "A0",
    "A1",
    "A2",
    "A3",
    "A4",
    "A5",
    "A6",
    "A7",
    "A8",
    "A9",
    "AA",
    "AB",
    "AC",
    "AD",
    "AE",
    "AF",
    "B0",
    "B1",
    "B2",
    "B3",
    "B4",
    "B5",
    "B6",
    "B7",
    "B8",
    "B9",
    "BA",
    "BB",
    "BC",
    "BD",
    "BE",
    "BF",
    "C0",
    "C1",
    "C2",
    "C3",
    "C4",
    "C5",
    "C6",
    "C7",
    "C8",
    "C9",
    "CA",
    "CB",
    "CC",
    "CD",
    "CE",
    "CF",
    "D0",
    "D1",
    "D2",
    "D3",
    "D4",
    "D5",
    "D6",
    "D7",
    "D8",
    "D9",
    "DA",
    "DB",
    "DC",
    "DD",
    "DE",
    "DF",
    "E0",
    "E1",
    "E2",
    "E3",
    "E4",
    "E5",
    "E6",
    "E7",
    "E8",
    "E9",
    "EA",
    "EB",
    "EC",
    "ED",
    "EE",
    "EF",
    "F0",
    "F1",
    "F2",
    "F3",
    "F4",
    "F5",
    "F6",
    "F7",
    "F8",
    "F9",
    "FA",
    "FB",
    "FC",
    "FD",
    "FE",
    "FF"
];
/* vector of base 64 characters */ var $60b190684094cead$var$base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".split("");
/* vector of base 64 character codes */ var $60b190684094cead$var$base64codes = [];
$60b190684094cead$var$base64chars.forEach(function(char) {
    $60b190684094cead$var$base64codes.push(char.charCodeAt(0));
});
// The UTF8 algorithms.
module.exports.utf8 = {
    encode: function(chars) {
        var bytes = [];
        chars.forEach(function(char) {
            if (char >= 0 && char <= 0x7f) bytes.push(char);
            else if (char <= 0x7ff) {
                bytes.push(0xc0 + (char >> 6 & $60b190684094cead$var$mask[5]));
                bytes.push(0x80 + (char & $60b190684094cead$var$mask[6]));
            } else if (char < 0xd800 || char > 0xdfff && char <= 0xffff) {
                bytes.push(0xe0 + (char >> 12 & $60b190684094cead$var$mask[4]));
                bytes.push(0x80 + (char >> 6 & $60b190684094cead$var$mask[6]));
                bytes.push(0x80 + (char & $60b190684094cead$var$mask[6]));
            } else if (char >= 0x10000 && char <= 0x10ffff) {
                var u = char >> 16 & $60b190684094cead$var$mask[5];
                bytes.push(0xf0 + (u >> 2));
                bytes.push(0x80 + ((u & $60b190684094cead$var$mask[2]) << 4) + (char >> 12 & $60b190684094cead$var$mask[4]));
                bytes.push(0x80 + (char >> 6 & $60b190684094cead$var$mask[6]));
                bytes.push(0x80 + (char & $60b190684094cead$var$mask[6]));
            } else throw new RangeError("utf8.encode: character out of range: char: ".concat(char));
        });
        return $60b190684094cead$require$Buffer.from(bytes);
    },
    decode: function(buf, bom) {
        /* bytes functions return error for non-shortest forms & values out of range */ function bytes2(b1, b2) {
            /* U+0080..U+07FF */ /* 00000000 00000yyy yyxxxxxx | 110yyyyy 10xxxxxx */ if ((b2 & 0xc0) !== 0x80) return $60b190684094cead$var$TRAILING;
            var x = ((b1 & $60b190684094cead$var$mask[5]) << 6) + (b2 & $60b190684094cead$var$mask[6]);
            if (x < 0x80) return $60b190684094cead$var$NON_SHORTEST;
            return x;
        }
        function bytes3(b1, b2, b3) {
            /* U+0800..U+FFFF */ /* 00000000 zzzzyyyy yyxxxxxx | 1110zzzz 10yyyyyy 10xxxxxx */ if ((b3 & 0xc0) !== 0x80 || (b2 & 0xc0) !== 0x80) return $60b190684094cead$var$TRAILING;
            var x = ((b1 & $60b190684094cead$var$mask[4]) << 12) + ((b2 & $60b190684094cead$var$mask[6]) << 6) + (b3 & $60b190684094cead$var$mask[6]);
            if (x < 0x800) return $60b190684094cead$var$NON_SHORTEST;
            if (x >= 0xd800 && x <= 0xdfff) return $60b190684094cead$var$RANGE;
            return x;
        }
        function bytes4(b1, b2, b3, b4) {
            /* U+10000..U+10FFFF */ /* 000uuuuu zzzzyyyy yyxxxxxx | 11110uuu 10uuzzzz 10yyyyyy 10xxxxxx */ if ((b4 & 0xc0) !== 0x80 || (b3 & 0xc0) !== 0x80 || (b2 & 0xc0) !== 0x80) return $60b190684094cead$var$TRAILING;
            var x = (((b1 & $60b190684094cead$var$mask[3]) << 2) + (b2 >> 4 & $60b190684094cead$var$mask[2]) << 16) + ((b2 & $60b190684094cead$var$mask[4]) << 12) + ((b3 & $60b190684094cead$var$mask[6]) << 6) + (b4 & $60b190684094cead$var$mask[6]);
            if (x < 0x10000) return $60b190684094cead$var$NON_SHORTEST;
            if (x > 0x10ffff) return $60b190684094cead$var$RANGE;
            return x;
        }
        var c;
        var b1;
        var i1;
        var i2;
        var i3;
        var inc;
        var len = buf.length;
        var i = bom ? 3 : 0;
        var chars = [];
        while(i < len){
            b1 = buf[i];
            c = $60b190684094cead$var$ILL_FORMED;
            var TRUE = true;
            while(TRUE){
                if (b1 >= 0 && b1 <= 0x7f) {
                    /* U+0000..U+007F 00..7F */ c = b1;
                    inc = 1;
                    break;
                }
                i1 = i + 1;
                if (i1 < len && b1 >= 0xc2 && b1 <= 0xdf) {
                    /* U+0080..U+07FF C2..DF 80..BF */ c = bytes2(b1, buf[i1]);
                    inc = 2;
                    break;
                }
                i2 = i + 2;
                if (i2 < len && b1 >= 0xe0 && b1 <= 0xef) {
                    /* U+0800..U+FFFF */ c = bytes3(b1, buf[i1], buf[i2]);
                    inc = 3;
                    break;
                }
                i3 = i + 3;
                if (i3 < len && b1 >= 0xf0 && b1 <= 0xf4) {
                    /* U+10000..U+10FFFF */ c = bytes4(b1, buf[i1], buf[i2], buf[i3]);
                    inc = 4;
                    break;
                }
                break;
            }
            if (c > 0x10ffff) {
                var at = "byte[".concat(i, "]");
                if (c === $60b190684094cead$var$ILL_FORMED) throw new RangeError("utf8.decode: ill-formed UTF8 byte sequence found at: ".concat(at));
                if (c === $60b190684094cead$var$TRAILING) throw new RangeError("utf8.decode: illegal trailing byte found at: ".concat(at));
                if (c === $60b190684094cead$var$RANGE) throw new RangeError("utf8.decode: code point out of range found at: ".concat(at));
                if (c === $60b190684094cead$var$NON_SHORTEST) throw new RangeError("utf8.decode: non-shortest form found at: ".concat(at));
                throw new RangeError("utf8.decode: unrecognized error found at: ".concat(at));
            }
            chars.push(c);
            i += inc;
        }
        return chars;
    }
};
// The UTF16BE algorithms.
module.exports.utf16be = {
    encode: function(chars) {
        var bytes = [];
        var char;
        var h;
        var l;
        for(var i = 0; i < chars.length; i += 1){
            char = chars[i];
            if (char >= 0 && char <= 0xd7ff || char >= 0xe000 && char <= 0xffff) {
                bytes.push(char >> 8 & $60b190684094cead$var$mask[8]);
                bytes.push(char & $60b190684094cead$var$mask[8]);
            } else if (char >= 0x10000 && char <= 0x10ffff) {
                l = char - 0x10000;
                h = 0xd800 + (l >> 10);
                l = 0xdc00 + (l & $60b190684094cead$var$mask[10]);
                bytes.push(h >> 8 & $60b190684094cead$var$mask[8]);
                bytes.push(h & $60b190684094cead$var$mask[8]);
                bytes.push(l >> 8 & $60b190684094cead$var$mask[8]);
                bytes.push(l & $60b190684094cead$var$mask[8]);
            } else throw new RangeError("utf16be.encode: UTF16BE value out of range: char[".concat(i, "]: ").concat(char));
        }
        return $60b190684094cead$require$Buffer.from(bytes);
    },
    decode: function(buf, bom) {
        /* assumes caller has insured that buf is a Buffer of bytes */ if (buf.length % 2 > 0) throw new RangeError("utf16be.decode: data length must be even multiple of 2: length: ".concat(buf.length));
        var chars = [];
        var len = buf.length;
        var i = bom ? 2 : 0;
        var j = 0;
        var c;
        var inc;
        var i1;
        var i3;
        var high;
        var low;
        while(i < len){
            var TRUE = true;
            while(TRUE){
                i1 = i + 1;
                if (i1 < len) {
                    high = (buf[i] << 8) + buf[i1];
                    if (high < 0xd800 || high > 0xdfff) {
                        c = high;
                        inc = 2;
                        break;
                    }
                    i3 = i + 3;
                    if (i3 < len) {
                        low = (buf[i + 2] << 8) + buf[i3];
                        if (high <= 0xdbff && low >= 0xdc00 && low <= 0xdfff) {
                            c = 0x10000 + (high - 0xd800 << 10) + (low - 0xdc00);
                            inc = 4;
                            break;
                        }
                    }
                }
                /* if we fall through to here, it is an ill-formed sequence */ throw new RangeError("utf16be.decode: ill-formed UTF16BE byte sequence found: byte[".concat(i, "]"));
            }
            chars[j++] = c;
            i += inc;
        }
        return chars;
    }
};
// The UTF16LE algorithms.
module.exports.utf16le = {
    encode: function(chars) {
        var bytes = [];
        var char;
        var h;
        var l;
        for(var i = 0; i < chars.length; i += 1){
            char = chars[i];
            if (char >= 0 && char <= 0xd7ff || char >= 0xe000 && char <= 0xffff) {
                bytes.push(char & $60b190684094cead$var$mask[8]);
                bytes.push(char >> 8 & $60b190684094cead$var$mask[8]);
            } else if (char >= 0x10000 && char <= 0x10ffff) {
                l = char - 0x10000;
                h = 0xd800 + (l >> 10);
                l = 0xdc00 + (l & $60b190684094cead$var$mask[10]);
                bytes.push(h & $60b190684094cead$var$mask[8]);
                bytes.push(h >> 8 & $60b190684094cead$var$mask[8]);
                bytes.push(l & $60b190684094cead$var$mask[8]);
                bytes.push(l >> 8 & $60b190684094cead$var$mask[8]);
            } else throw new RangeError("utf16le.encode: UTF16LE value out of range: char[".concat(i, "]: ").concat(char));
        }
        return $60b190684094cead$require$Buffer.from(bytes);
    },
    decode: function(buf, bom) {
        /* assumes caller has insured that buf is a Buffer of bytes */ if (buf.length % 2 > 0) throw new RangeError("utf16le.decode: data length must be even multiple of 2: length: ".concat(buf.length));
        var chars = [];
        var len = buf.length;
        var i = bom ? 2 : 0;
        var j = 0;
        var c;
        var inc;
        var i1;
        var i3;
        var high;
        var low;
        while(i < len){
            var TRUE = true;
            while(TRUE){
                i1 = i + 1;
                if (i1 < len) {
                    high = (buf[i1] << 8) + buf[i];
                    if (high < 0xd800 || high > 0xdfff) {
                        c = high;
                        inc = 2;
                        break;
                    }
                    i3 = i + 3;
                    if (i3 < len) {
                        low = (buf[i3] << 8) + buf[i + 2];
                        if (high <= 0xdbff && low >= 0xdc00 && low <= 0xdfff) {
                            c = 0x10000 + (high - 0xd800 << 10) + (low - 0xdc00);
                            inc = 4;
                            break;
                        }
                    }
                }
                /* if we fall through to here, it is an ill-formed sequence */ throw new RangeError("utf16le.decode: ill-formed UTF16LE byte sequence found: byte[".concat(i, "]"));
            }
            chars[j++] = c;
            i += inc;
        }
        return chars;
    }
};
// The UTF32BE algorithms.
module.exports.utf32be = {
    encode: function(chars) {
        var buf = $60b190684094cead$require$Buffer.alloc(chars.length * 4);
        var i = 0;
        chars.forEach(function(char) {
            if (char >= 0xd800 && char <= 0xdfff || char > 0x10ffff) throw new RangeError("utf32be.encode: UTF32BE character code out of range: char[".concat(i / 4, "]: ").concat(char));
            buf[i++] = char >> 24 & $60b190684094cead$var$mask[8];
            buf[i++] = char >> 16 & $60b190684094cead$var$mask[8];
            buf[i++] = char >> 8 & $60b190684094cead$var$mask[8];
            buf[i++] = char & $60b190684094cead$var$mask[8];
        });
        return buf;
    },
    decode: function(buf, bom) {
        /* caller to insure buf is a Buffer of bytes */ if (buf.length % 4 > 0) throw new RangeError("utf32be.decode: UTF32BE byte length must be even multiple of 4: length: ".concat(buf.length));
        var chars = [];
        var i = bom ? 4 : 0;
        for(; i < buf.length; i += 4){
            var char = (buf[i] << 24) + (buf[i + 1] << 16) + (buf[i + 2] << 8) + buf[i + 3];
            if (char >= 0xd800 && char <= 0xdfff || char > 0x10ffff) throw new RangeError("utf32be.decode: UTF32BE character code out of range: char[".concat(i / 4, "]: ").concat(char));
            chars.push(char);
        }
        return chars;
    }
};
// The UTF32LE algorithms.
module.exports.utf32le = {
    encode: function(chars) {
        var buf = $60b190684094cead$require$Buffer.alloc(chars.length * 4);
        var i = 0;
        chars.forEach(function(char) {
            if (char >= 0xd800 && char <= 0xdfff || char > 0x10ffff) throw new RangeError("utf32le.encode: UTF32LE character code out of range: char[".concat(i / 4, "]: ").concat(char));
            buf[i++] = char & $60b190684094cead$var$mask[8];
            buf[i++] = char >> 8 & $60b190684094cead$var$mask[8];
            buf[i++] = char >> 16 & $60b190684094cead$var$mask[8];
            buf[i++] = char >> 24 & $60b190684094cead$var$mask[8];
        });
        return buf;
    },
    decode: function(buf, bom) {
        /* caller to insure buf is a Buffer of bytes */ if (buf.length % 4 > 0) throw new RangeError("utf32be.decode: UTF32LE byte length must be even multiple of 4: length: ".concat(buf.length));
        var chars = [];
        var i = bom ? 4 : 0;
        for(; i < buf.length; i += 4){
            var char = (buf[i + 3] << 24) + (buf[i + 2] << 16) + (buf[i + 1] << 8) + buf[i];
            if (char >= 0xd800 && char <= 0xdfff || char > 0x10ffff) throw new RangeError("utf32le.encode: UTF32LE character code out of range: char[".concat(i / 4, "]: ").concat(char));
            chars.push(char);
        }
        return chars;
    }
};
// The UINT7 algorithms. ASCII or 7-bit unsigned integers.
module.exports.uint7 = {
    encode: function(chars) {
        var buf = $60b190684094cead$require$Buffer.alloc(chars.length);
        for(var i = 0; i < chars.length; i += 1){
            if (chars[i] > 0x7f) throw new RangeError("uint7.encode: UINT7 character code out of range: char[".concat(i, "]: ").concat(chars[i]));
            buf[i] = chars[i];
        }
        return buf;
    },
    decode: function(buf) {
        var chars = [];
        for(var i = 0; i < buf.length; i += 1){
            if (buf[i] > 0x7f) throw new RangeError("uint7.decode: UINT7 character code out of range: byte[".concat(i, "]: ").concat(buf[i]));
            chars[i] = buf[i];
        }
        return chars;
    }
};
// The UINT8 algorithms. BINARY, Latin 1 or 8-bit unsigned integers.
module.exports.uint8 = {
    encode: function(chars) {
        var buf = $60b190684094cead$require$Buffer.alloc(chars.length);
        for(var i = 0; i < chars.length; i += 1){
            if (chars[i] > 0xff) throw new RangeError("uint8.encode: UINT8 character code out of range: char[".concat(i, "]: ").concat(chars[i]));
            buf[i] = chars[i];
        }
        return buf;
    },
    decode: function(buf) {
        var chars = [];
        for(var i = 0; i < buf.length; i += 1)chars[i] = buf[i];
        return chars;
    }
};
// The UINT16BE algorithms. Big-endian 16-bit unsigned integers.
module.exports.uint16be = {
    encode: function(chars) {
        var buf = $60b190684094cead$require$Buffer.alloc(chars.length * 2);
        var i = 0;
        chars.forEach(function(char) {
            if (char > 0xffff) throw new RangeError("uint16be.encode: UINT16BE character code out of range: char[".concat(i / 2, "]: ").concat(char));
            buf[i++] = char >> 8 & $60b190684094cead$var$mask[8];
            buf[i++] = char & $60b190684094cead$var$mask[8];
        });
        return buf;
    },
    decode: function(buf) {
        if (buf.length % 2 > 0) throw new RangeError("uint16be.decode: UINT16BE byte length must be even multiple of 2: length: ".concat(buf.length));
        var chars = [];
        for(var i = 0; i < buf.length; i += 2)chars.push((buf[i] << 8) + buf[i + 1]);
        return chars;
    }
};
// The UINT16LE algorithms. Little-endian 16-bit unsigned integers.
module.exports.uint16le = {
    encode: function(chars) {
        var buf = $60b190684094cead$require$Buffer.alloc(chars.length * 2);
        var i = 0;
        chars.forEach(function(char) {
            if (char > 0xffff) throw new RangeError("uint16le.encode: UINT16LE character code out of range: char[".concat(i / 2, "]: ").concat(char));
            buf[i++] = char & $60b190684094cead$var$mask[8];
            buf[i++] = char >> 8 & $60b190684094cead$var$mask[8];
        });
        return buf;
    },
    decode: function(buf) {
        if (buf.length % 2 > 0) throw new RangeError("uint16le.decode: UINT16LE byte length must be even multiple of 2: length: ".concat(buf.length));
        var chars = [];
        for(var i = 0; i < buf.length; i += 2)chars.push((buf[i + 1] << 8) + buf[i]);
        return chars;
    }
};
// The UINT32BE algorithms. Big-endian 32-bit unsigned integers.
module.exports.uint32be = {
    encode: function(chars) {
        var buf = $60b190684094cead$require$Buffer.alloc(chars.length * 4);
        var i = 0;
        chars.forEach(function(char) {
            buf[i++] = char >> 24 & $60b190684094cead$var$mask[8];
            buf[i++] = char >> 16 & $60b190684094cead$var$mask[8];
            buf[i++] = char >> 8 & $60b190684094cead$var$mask[8];
            buf[i++] = char & $60b190684094cead$var$mask[8];
        });
        return buf;
    },
    decode: function(buf) {
        if (buf.length % 4 > 0) throw new RangeError("uint32be.decode: UINT32BE byte length must be even multiple of 4: length: ".concat(buf.length));
        var chars = [];
        for(var i = 0; i < buf.length; i += 4)chars.push((buf[i] << 24) + (buf[i + 1] << 16) + (buf[i + 2] << 8) + buf[i + 3]);
        return chars;
    }
};
// The UINT32LE algorithms. Little-endian 32-bit unsigned integers.
module.exports.uint32le = {
    encode: function(chars) {
        var buf = $60b190684094cead$require$Buffer.alloc(chars.length * 4);
        var i = 0;
        chars.forEach(function(char) {
            buf[i++] = char & $60b190684094cead$var$mask[8];
            buf[i++] = char >> 8 & $60b190684094cead$var$mask[8];
            buf[i++] = char >> 16 & $60b190684094cead$var$mask[8];
            buf[i++] = char >> 24 & $60b190684094cead$var$mask[8];
        });
        return buf;
    },
    decode: function(buf) {
        /* caller to insure buf is a Buffer of bytes */ if (buf.length % 4 > 0) throw new RangeError("uint32le.decode: UINT32LE byte length must be even multiple of 4: length: ".concat(buf.length));
        var chars = [];
        for(var i = 0; i < buf.length; i += 4)chars.push((buf[i + 3] << 24) + (buf[i + 2] << 16) + (buf[i + 1] << 8) + buf[i]);
        return chars;
    }
};
// The STRING algorithms. Converts JavaScript strings to Array of 32-bit integers and vice versa.
// Uses the node.js Buffer's native "utf16le" capabilites.
module.exports.string = {
    encode: function(chars) {
        return $60b190684094cead$var$thisThis.utf16le.encode(chars).toString("utf16le");
    },
    decode: function(str) {
        return $60b190684094cead$var$thisThis.utf16le.decode($60b190684094cead$require$Buffer.from(str, "utf16le"), 0);
    }
};
// The ESCAPED algorithms.
// Note that ESCAPED format contains only ASCII characters.
// The characters are always in the form of a Buffer of bytes.
module.exports.escaped = {
    // Encodes an Array of 32-bit integers into ESCAPED format.
    encode: function(chars) {
        var bytes = [];
        for(var i = 0; i < chars.length; i += 1){
            var char = chars[i];
            if (char === 96) {
                bytes.push(char);
                bytes.push(char);
            } else if (char === 10) bytes.push(char);
            else if (char >= 32 && char <= 126) bytes.push(char);
            else {
                var str = "";
                if (char >= 0 && char <= 31) str += "`x".concat($60b190684094cead$var$ascii[char]);
                else if (char >= 127 && char <= 255) str += "`x".concat($60b190684094cead$var$ascii[char]);
                else if (char >= 0x100 && char <= 0xffff) str += "`u".concat($60b190684094cead$var$ascii[char >> 8 & $60b190684094cead$var$mask[8]]).concat($60b190684094cead$var$ascii[char & $60b190684094cead$var$mask[8]]);
                else if (char >= 0x10000 && char <= 0xffffffff) {
                    str += "`u{";
                    var digit = char >> 24 & $60b190684094cead$var$mask[8];
                    if (digit > 0) str += $60b190684094cead$var$ascii[digit];
                    str += "".concat($60b190684094cead$var$ascii[char >> 16 & $60b190684094cead$var$mask[8]] + $60b190684094cead$var$ascii[char >> 8 & $60b190684094cead$var$mask[8]] + $60b190684094cead$var$ascii[char & $60b190684094cead$var$mask[8]], "}");
                } else throw new Error("escape.encode(char): char > 0xffffffff not allowed");
                var buf = $60b190684094cead$require$Buffer.from(str);
                buf.forEach(function(b) {
                    bytes.push(b);
                });
            }
        }
        return $60b190684094cead$require$Buffer.from(bytes);
    },
    // Decodes ESCAPED format from a Buffer of bytes to an Array of 32-bit integers.
    decode: function(buf) {
        function isHex(hex) {
            if (hex >= 48 && hex <= 57 || hex >= 65 && hex <= 70 || hex >= 97 && hex <= 102) return true;
            return false;
        }
        function getx(i, len, bufArg) {
            var ret = {
                char: null,
                nexti: i + 2,
                error: true
            };
            if (i + 1 < len) {
                if (isHex(bufArg[i]) && isHex(bufArg[i + 1])) {
                    var str = String.fromCodePoint(bufArg[i], bufArg[i + 1]);
                    ret.char = parseInt(str, 16);
                    if (!Number.isNaN(ret.char)) ret.error = false;
                }
            }
            return ret;
        }
        function getu(i, len, bufArg) {
            var ret = {
                char: null,
                nexti: i + 4,
                error: true
            };
            if (i + 3 < len) {
                if (isHex(bufArg[i]) && isHex(bufArg[i + 1]) && isHex(bufArg[i + 2]) && isHex(bufArg[i + 3])) {
                    var str = String.fromCodePoint(bufArg[i], bufArg[i + 1], bufArg[i + 2], bufArg[i + 3]);
                    ret.char = parseInt(str, 16);
                    if (!Number.isNaN(ret.char)) ret.error = false;
                }
            }
            return ret;
        }
        function getU(i, len, bufArg) {
            var ret = {
                char: null,
                nexti: i + 4,
                error: true
            };
            var str = "";
            while(i < len && isHex(bufArg[i])){
                str += String.fromCodePoint(bufArg[i]);
                // eslint-disable-next-line no-param-reassign
                i += 1;
            }
            ret.char = parseInt(str, 16);
            if (bufArg[i] === 125 && !Number.isNaN(ret.char)) ret.error = false;
            ret.nexti = i + 1;
            return ret;
        }
        var chars = [];
        var len = buf.length;
        var i1;
        var ret;
        var error;
        var i = 0;
        while(i < len){
            var TRUE = true;
            while(TRUE){
                error = true;
                if (buf[i] !== 96) {
                    /* unescaped character */ chars.push(buf[i]);
                    i += 1;
                    error = false;
                    break;
                }
                i1 = i + 1;
                if (i1 >= len) break;
                if (buf[i1] === 96) {
                    /* escaped grave accent */ chars.push(96);
                    i += 2;
                    error = false;
                    break;
                }
                if (buf[i1] === 120) {
                    ret = getx(i1 + 1, len, buf);
                    if (ret.error) break;
                    /* escaped hex */ chars.push(ret.char);
                    i = ret.nexti;
                    error = false;
                    break;
                }
                if (buf[i1] === 117) {
                    if (buf[i1 + 1] === 123) {
                        ret = getU(i1 + 2, len, buf);
                        if (ret.error) break;
                        /* escaped utf-32 */ chars.push(ret.char);
                        i = ret.nexti;
                        error = false;
                        break;
                    }
                    ret = getu(i1 + 1, len, buf);
                    if (ret.error) break;
                    /* escaped utf-16 */ chars.push(ret.char);
                    i = ret.nexti;
                    error = false;
                    break;
                }
                break;
            }
            if (error) throw new Error("escaped.decode: ill-formed escape sequence at buf[".concat(i, "]"));
        }
        return chars;
    }
};
// The line end conversion algorigthms.
var $60b190684094cead$var$CR = 13;
var $60b190684094cead$var$LF = 10;
module.exports.lineEnds = {
    crlf: function(chars) {
        var lfchars = [];
        var i = 0;
        while(i < chars.length)switch(chars[i]){
            case $60b190684094cead$var$CR:
                if (i + 1 < chars.length && chars[i + 1] === $60b190684094cead$var$LF) i += 2;
                else i += 1;
                lfchars.push($60b190684094cead$var$CR);
                lfchars.push($60b190684094cead$var$LF);
                break;
            case $60b190684094cead$var$LF:
                lfchars.push($60b190684094cead$var$CR);
                lfchars.push($60b190684094cead$var$LF);
                i += 1;
                break;
            default:
                lfchars.push(chars[i]);
                i += 1;
                break;
        }
        if (lfchars.length > 0 && lfchars[lfchars.length - 1] !== $60b190684094cead$var$LF) {
            lfchars.push($60b190684094cead$var$CR);
            lfchars.push($60b190684094cead$var$LF);
        }
        return lfchars;
    },
    lf: function(chars) {
        var lfchars = [];
        var i = 0;
        while(i < chars.length)switch(chars[i]){
            case $60b190684094cead$var$CR:
                if (i + 1 < chars.length && chars[i + 1] === $60b190684094cead$var$LF) i += 2;
                else i += 1;
                lfchars.push($60b190684094cead$var$LF);
                break;
            case $60b190684094cead$var$LF:
                lfchars.push($60b190684094cead$var$LF);
                i += 1;
                break;
            default:
                lfchars.push(chars[i]);
                i += 1;
                break;
        }
        if (lfchars.length > 0 && lfchars[lfchars.length - 1] !== $60b190684094cead$var$LF) lfchars.push($60b190684094cead$var$LF);
        return lfchars;
    }
};
// The base 64 algorithms.
module.exports.base64 = {
    encode: function(buf) {
        if (buf.length === 0) return $60b190684094cead$require$Buffer.alloc(0);
        var i;
        var j;
        var n;
        var tail = buf.length % 3;
        tail = tail > 0 ? 3 - tail : 0;
        var units = (buf.length + tail) / 3;
        var base64 = $60b190684094cead$require$Buffer.alloc(units * 4);
        if (tail > 0) units -= 1;
        i = 0;
        j = 0;
        for(var u = 0; u < units; u += 1){
            n = buf[i++] << 16;
            n += buf[i++] << 8;
            n += buf[i++];
            base64[j++] = $60b190684094cead$var$base64codes[n >> 18 & $60b190684094cead$var$mask[6]];
            base64[j++] = $60b190684094cead$var$base64codes[n >> 12 & $60b190684094cead$var$mask[6]];
            base64[j++] = $60b190684094cead$var$base64codes[n >> 6 & $60b190684094cead$var$mask[6]];
            base64[j++] = $60b190684094cead$var$base64codes[n & $60b190684094cead$var$mask[6]];
        }
        if (tail === 0) return base64;
        if (tail === 1) {
            n = buf[i++] << 16;
            n += buf[i] << 8;
            base64[j++] = $60b190684094cead$var$base64codes[n >> 18 & $60b190684094cead$var$mask[6]];
            base64[j++] = $60b190684094cead$var$base64codes[n >> 12 & $60b190684094cead$var$mask[6]];
            base64[j++] = $60b190684094cead$var$base64codes[n >> 6 & $60b190684094cead$var$mask[6]];
            base64[j] = $60b190684094cead$var$base64codes[64];
            return base64;
        }
        if (tail === 2) {
            n = buf[i] << 16;
            base64[j++] = $60b190684094cead$var$base64codes[n >> 18 & $60b190684094cead$var$mask[6]];
            base64[j++] = $60b190684094cead$var$base64codes[n >> 12 & $60b190684094cead$var$mask[6]];
            base64[j++] = $60b190684094cead$var$base64codes[64];
            base64[j] = $60b190684094cead$var$base64codes[64];
            return base64;
        }
        return undefined;
    },
    decode: function(codes) {
        /* remove white space and ctrl characters, validate & translate characters */ function validate(buf) {
            var chars = [];
            var tail = 0;
            for(var i = 0; i < buf.length; i += 1){
                var char = buf[i];
                var TRUE = true;
                while(TRUE){
                    if (char === 32 || char === 9 || char === 10 || char === 13) break;
                    if (char >= 65 && char <= 90) {
                        chars.push(char - 65);
                        break;
                    }
                    if (char >= 97 && char <= 122) {
                        chars.push(char - 71);
                        break;
                    }
                    if (char >= 48 && char <= 57) {
                        chars.push(char + 4);
                        break;
                    }
                    if (char === 43) {
                        chars.push(62);
                        break;
                    }
                    if (char === 47) {
                        chars.push(63);
                        break;
                    }
                    if (char === 61) {
                        chars.push(64);
                        tail += 1;
                        break;
                    }
                    /* invalid character */ throw new RangeError("base64.decode: invalid character buf[".concat(i, "]: ").concat(char));
                }
            }
            /* validate length */ if (chars.length % 4 > 0) throw new RangeError("base64.decode: string length not integral multiple of 4: ".concat(chars.length));
            /* validate tail */ switch(tail){
                case 0:
                    break;
                case 1:
                    if (chars[chars.length - 1] !== 64) throw new RangeError("base64.decode: one tail character found: not last character");
                    break;
                case 2:
                    if (chars[chars.length - 1] !== 64 || chars[chars.length - 2] !== 64) throw new RangeError("base64.decode: two tail characters found: not last characters");
                    break;
                default:
                    throw new RangeError("base64.decode: more than two tail characters found: ".concat(tail));
            }
            return {
                tail: tail,
                buf: $60b190684094cead$require$Buffer.from(chars)
            };
        }
        if (codes.length === 0) return $60b190684094cead$require$Buffer.alloc(0);
        var val = validate(codes);
        var tail = val.tail;
        var base64 = val.buf;
        var i;
        var j;
        var n;
        var units = base64.length / 4;
        var buf = $60b190684094cead$require$Buffer.alloc(units * 3 - tail);
        if (tail > 0) units -= 1;
        j = 0;
        i = 0;
        for(var u = 0; u < units; u += 1){
            n = base64[i++] << 18;
            n += base64[i++] << 12;
            n += base64[i++] << 6;
            n += base64[i++];
            buf[j++] = n >> 16 & $60b190684094cead$var$mask[8];
            buf[j++] = n >> 8 & $60b190684094cead$var$mask[8];
            buf[j++] = n & $60b190684094cead$var$mask[8];
        }
        if (tail === 1) {
            n = base64[i++] << 18;
            n += base64[i++] << 12;
            n += base64[i] << 6;
            buf[j++] = n >> 16 & $60b190684094cead$var$mask[8];
            buf[j] = n >> 8 & $60b190684094cead$var$mask[8];
        }
        if (tail === 2) {
            n = base64[i++] << 18;
            n += base64[i++] << 12;
            buf[j] = n >> 16 & $60b190684094cead$var$mask[8];
        }
        return buf;
    },
    // Converts a base 64 Buffer of bytes to a JavaScript string with line breaks.
    toString: function(buf) {
        if (buf.length % 4 > 0) throw new RangeError("base64.toString: input buffer length not multiple of 4: ".concat(buf.length));
        var str = "";
        var lineLen = 0;
        function buildLine(c1, c2, c3, c4) {
            switch(lineLen){
                case 76:
                    str += "\r\n".concat(c1).concat(c2).concat(c3).concat(c4);
                    lineLen = 4;
                    break;
                case 75:
                    str += "".concat(c1, "\r\n").concat(c2).concat(c3).concat(c4);
                    lineLen = 3;
                    break;
                case 74:
                    str += "".concat(c1 + c2, "\r\n").concat(c3).concat(c4);
                    lineLen = 2;
                    break;
                case 73:
                    str += "".concat(c1 + c2 + c3, "\r\n").concat(c4);
                    lineLen = 1;
                    break;
                default:
                    str += c1 + c2 + c3 + c4;
                    lineLen += 4;
                    break;
            }
        }
        function validate(c) {
            if (c >= 65 && c <= 90) return true;
            if (c >= 97 && c <= 122) return true;
            if (c >= 48 && c <= 57) return true;
            if (c === 43) return true;
            if (c === 47) return true;
            if (c === 61) return true;
            return false;
        }
        for(var i = 0; i < buf.length; i += 4){
            for(var j = i; j < i + 4; j += 1){
                if (!validate(buf[j])) throw new RangeError("base64.toString: buf[".concat(j, "]: ").concat(buf[j], " : not valid base64 character code"));
            }
            buildLine(String.fromCharCode(buf[i]), String.fromCharCode(buf[i + 1]), String.fromCharCode(buf[i + 2]), String.fromCharCode(buf[i + 3]));
        }
        return str;
    }
};

});


parcelRegister("66fYd", function(module, exports) {
// This module has been developed programmatically in the `apg-lib` build process.
// It is used to build web pages programatically on the fly without the need for <script> or <style> tags.
module.exports = function emittcss() {
    return "/* This file automatically generated by jsonToless() and LESS. */\n.apg-mono {\n  font-family: monospace;\n}\n.apg-active {\n  font-weight: bold;\n  color: #000000;\n}\n.apg-match {\n  font-weight: bold;\n  color: #264BFF;\n}\n.apg-empty {\n  font-weight: bold;\n  color: #0fbd0f;\n}\n.apg-nomatch {\n  font-weight: bold;\n  color: #FF4000;\n}\n.apg-lh-match {\n  font-weight: bold;\n  color: #1A97BA;\n}\n.apg-lb-match {\n  font-weight: bold;\n  color: #5F1687;\n}\n.apg-remainder {\n  font-weight: bold;\n  color: #999999;\n}\n.apg-ctrl-char {\n  font-weight: bolder;\n  font-style: italic;\n  font-size: 0.6em;\n}\n.apg-line-end {\n  font-weight: bold;\n  color: #000000;\n}\n.apg-error {\n  font-weight: bold;\n  color: #FF4000;\n}\n.apg-phrase {\n  color: #000000;\n  background-color: #8caae6;\n}\n.apg-empty-phrase {\n  color: #0fbd0f;\n}\ntable.apg-state {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: left;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-state th,\ntable.apg-state td {\n  text-align: left;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-state th:nth-last-child(2),\ntable.apg-state td:nth-last-child(2) {\n  text-align: right;\n}\ntable.apg-state caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-stats {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-stats th,\ntable.apg-stats td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-stats caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-trace {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-trace caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-trace th,\ntable.apg-trace td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-trace th:last-child,\ntable.apg-trace th:nth-last-child(2),\ntable.apg-trace td:last-child,\ntable.apg-trace td:nth-last-child(2) {\n  text-align: left;\n}\ntable.apg-grammar {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-grammar caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-grammar th,\ntable.apg-grammar td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-grammar th:last-child,\ntable.apg-grammar td:last-child {\n  text-align: left;\n}\ntable.apg-rules {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-rules caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-rules th,\ntable.apg-rules td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-rules a {\n  color: #003399 !important;\n}\ntable.apg-rules a:hover {\n  color: #8caae6 !important;\n}\ntable.apg-attrs {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: center;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-attrs caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-attrs th,\ntable.apg-attrs td {\n  text-align: center;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-attrs th:nth-child(1),\ntable.apg-attrs th:nth-child(2),\ntable.apg-attrs th:nth-child(3) {\n  text-align: right;\n}\ntable.apg-attrs td:nth-child(1),\ntable.apg-attrs td:nth-child(2),\ntable.apg-attrs td:nth-child(3) {\n  text-align: right;\n}\ntable.apg-attrs a {\n  color: #003399 !important;\n}\ntable.apg-attrs a:hover {\n  color: #8caae6 !important;\n}\n";
};

});



parcelRegister("hxsyk", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module acts as a "circular buffer". It is used to keep track
// only the last N records in an array of records. If more than N records
// are saved, each additional record overwrites the previously oldest record.
// This module deals only with the record indexes and does not save
// any actual records. It is used by [`trace.js`](./trace.html) for limiting the number of
// trace records saved.
module.exports = function exportsCircularBuffer() {
    "use strict;";
    var thisFileName = "circular-buffer.js: ";
    var itemIndex = -1;
    var maxListSize = 0;
    // Initialize buffer.<br>
    // *size* is `maxListSize`, the maximum number of records saved before overwriting begins.
    this.init = function init(size) {
        if (typeof size !== "number" || size <= 0) throw new Error("".concat(thisFileName, "init: circular buffer size must an integer > 0"));
        maxListSize = Math.ceil(size);
        itemIndex = -1;
    };
    // Call this to increment the number of records collected.<br>
    // Returns the array index number to store the next record in.
    this.increment = function increment() {
        itemIndex += 1;
        return (itemIndex + maxListSize) % maxListSize;
    };
    // Returns `maxListSize` - the maximum number of records to keep in the buffer.
    this.maxSize = function maxSize() {
        return maxListSize;
    };
    // Returns the highest number of items saved.<br>
    // (The number of items is the actual number of records processed
    // even though only `maxListSize` records are actually retained.)
    this.items = function items() {
        return itemIndex + 1;
    };
    // Returns the record number associated with this item index.
    this.getListIndex = function getListIndex(item) {
        if (itemIndex === -1) return -1;
        if (item < 0 || item > itemIndex) return -1;
        if (itemIndex - item >= maxListSize) return -1;
        return (item + maxListSize) % maxListSize;
    };
    // The iterator over the circular buffer.
    // The user's function, `fn`, will be called with arguments `fn(listIndex, itemIndex)`
    // where `listIndex` is the saved record index and `itemIndex` is the actual item index.
    this.forEach = function forEach(fn) {
        if (itemIndex === -1) /* no records have been collected */ return;
        if (itemIndex < maxListSize) {
            /* fewer than maxListSize records have been collected - number of items = number of records */ for(var i = 0; i <= itemIndex; i += 1)fn(i, i);
            return;
        }
        /* start with the oldest record saved and finish with the most recent record saved */ for(var i1 = itemIndex - maxListSize + 1; i1 <= itemIndex; i1 += 1){
            var listIndex = (i1 + maxListSize) % maxListSize;
            fn(listIndex, i1);
        }
    };
};

});

parcelRegister("ggoVV", function(module, exports) {
/* eslint-disable func-names */ /* eslint-disable no-restricted-syntax */ /* eslint-disable new-cap */ /* eslint-disable guard-for-in */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This is the primary object of `apg-lib`. Calling its `parse()` member function
// walks the parse tree of opcodes, matching phrases from the input string as it goes.
// The working code for all of the operators, `ALT`, `CAT`, etc. is in this module.

var $jquDQ = parcelRequire("jquDQ");


module.exports = function parser() {
    var id = (parcelRequire("dPnGd"));
    var utils = (parcelRequire("iKY5M"));
    var thisFileName = "parser.js: ";
    var thisThis = this;
    var opExecute;
    this.ast = null;
    this.stats = null;
    this.trace = null;
    this.callbacks = [];
    var opcodes = null;
    var chars = null;
    var charsBegin;
    var charsLength;
    var charsEnd;
    var lookAround;
    var treeDepth = 0;
    var maxTreeDepth = 0;
    var nodeHits = 0;
    var ruleCallbacks = null;
    var udtCallbacks = null;
    var rules = null;
    var udts = null;
    var syntaxData = null;
    var maxMatched = 0;
    var limitTreeDepth = Infinity;
    var limitNodeHits = Infinity;
    // Evaluates any given rule. This can be called from the syntax callback
    // functions to evaluate any rule in the grammar's rule list. Great caution
    // should be used. Use of this function will alter the language that the
    // parser accepts.
    var evaluateRule = function evaluateRule(ruleIndex, phraseIndex, sysData) {
        var functionName = "".concat(thisFileName, "evaluateRule(): ");
        if (ruleIndex >= rules.length) throw new Error("".concat(functionName, "rule index: ").concat(ruleIndex, " out of range"));
        if (phraseIndex >= charsEnd) throw new Error("".concat(functionName, "phrase index: ").concat(phraseIndex, " out of range"));
        var length = opcodes.length;
        opcodes.push({
            type: id.RNM,
            index: ruleIndex
        });
        opExecute(length, phraseIndex, sysData);
        opcodes.pop();
    };
    // Evaluates any given UDT. This can be called from the syntax callback
    // functions to evaluate any UDT in the grammar's UDT list. Great caution
    // should be used. Use of this function will alter the language that the
    // parser accepts.
    var evaluateUdt = function evaluateUdt(udtIndex, phraseIndex, sysData) {
        var functionName = "".concat(thisFileName, "evaluateUdt(): ");
        if (udtIndex >= udts.length) throw new Error("".concat(functionName, "udt index: ").concat(udtIndex, " out of range"));
        if (phraseIndex >= charsEnd) throw new Error("".concat(functionName, "phrase index: ").concat(phraseIndex, " out of range"));
        var length = opcodes.length;
        opcodes.push({
            type: id.UDT,
            empty: udts[udtIndex].empty,
            index: udtIndex
        });
        opExecute(length, phraseIndex, sysData);
        opcodes.pop();
    };
    /* Clears this object of any/all data that has been initialized or added to it. */ /* Called by parse() on initialization, allowing this object to be re-used for multiple parsing calls. */ var clear = function clear() {
        treeDepth = 0;
        maxTreeDepth = 0;
        nodeHits = 0;
        maxMatched = 0;
        lookAround = [
            {
                lookAround: id.LOOKAROUND_NONE,
                anchor: 0,
                charsEnd: 0,
                charsLength: 0
            }
        ];
        rules = null;
        udts = null;
        chars = null;
        charsBegin = 0;
        charsLength = 0;
        charsEnd = 0;
        ruleCallbacks = null;
        udtCallbacks = null;
        syntaxData = null;
        opcodes = null;
    };
    /* object for maintaining a stack of back reference frames */ var backRef = function backRef() {
        var stack = [];
        var init = function init() {
            var obj = {};
            rules.forEach(function(rule) {
                if (rule.isBkr) obj[rule.lower] = null;
            });
            if (udts.length > 0) udts.forEach(function(udt) {
                if (udt.isBkr) obj[udt.lower] = null;
            });
            stack.push(obj);
        };
        var copy = function copy() {
            var top = stack[stack.length - 1];
            var obj = {};
            /* // eslint-disable-next-line no-restricted-syntax */ for(var name in top)obj[name] = top[name];
            return obj;
        };
        this.push = function push() {
            stack.push(copy());
        };
        this.pop = function pop(lengthArg) {
            var length = lengthArg;
            if (!length) length = stack.length - 1;
            if (length < 1 || length > stack.length) throw new Error("".concat(thisFileName, "backRef.pop(): bad length: ").concat(length));
            stack.length = length;
            return stack[stack.length - 1];
        };
        this.length = function length() {
            return stack.length;
        };
        this.savePhrase = function savePhrase(name, index, length) {
            stack[stack.length - 1][name] = {
                phraseIndex: index,
                phraseLength: length
            };
        };
        this.getPhrase = function(name) {
            return stack[stack.length - 1][name];
        };
        /* constructor */ init();
    };
    // The system data structure that relays system information to and from the rule and UDT callback functions.
    // - *state* - the state of the parser, ACTIVE, MATCH, EMPTY or NOMATCH (see the `identifiers` object in
    // [`apg-lib`](https://github.com/ldthomas/apg-js2-lib))
    // - *phraseLength* - the number of characters matched if the state is MATCHED or EMPTY
    // - *lookaround* - the top of the stack holds the current look around state,
    // LOOKAROUND_NONE, LOOKAROUND_AHEAD or LOOKAROUND_BEHIND,
    // - *uFrame* - the "universal" back reference frame.
    // Holds the last matched phrase for each of the back referenced rules and UDTs.
    // - *pFrame* - the stack of "parent" back reference frames.
    // Holds the matched phrase from the parent frame of each back referenced rules and UDTs.
    // - *evaluateRule* - a reference to this object's `evaluateRule()` function.
    // Can be called from a callback function (use with extreme caution!)
    // - *evaluateUdt* - a reference to this object's `evaluateUdt()` function.
    // Can be called from a callback function (use with extreme caution!)
    var systemData = function systemData() {
        var thisData = this;
        this.state = id.ACTIVE;
        this.phraseLength = 0;
        this.ruleIndex = 0;
        this.udtIndex = 0;
        this.lookAround = lookAround[lookAround.length - 1];
        this.uFrame = new backRef();
        this.pFrame = new backRef();
        this.evaluateRule = evaluateRule;
        this.evaluateUdt = evaluateUdt;
        /* refresh the parser state for the next operation */ this.refresh = function refresh() {
            thisData.state = id.ACTIVE;
            thisData.phraseLength = 0;
            thisData.lookAround = lookAround[lookAround.length - 1];
        };
    };
    /* some look around helper functions */ var lookAroundValue = function lookAroundValue() {
        return lookAround[lookAround.length - 1];
    };
    /* return true if parser is in look around (ahead or behind) state */ var inLookAround = function inLookAround() {
        return lookAround.length > 1;
    };
    /* return true if parser is in look behind state */ var inLookBehind = function inLookBehind() {
        return lookAround[lookAround.length - 1].lookAround === id.LOOKAROUND_BEHIND;
    };
    /* called by parse() to initialize the AST object, if one has been defined */ var initializeAst = function initializeAst() {
        var functionName = "".concat(thisFileName, "initializeAst(): ");
        var TRUE = true;
        while(TRUE){
            if (thisThis.ast === undefined) {
                thisThis.ast = null;
                break;
            }
            if (thisThis.ast === null) break;
            if (thisThis.ast.astObject !== "astObject") throw new Error("".concat(functionName, "ast object not recognized"));
            break;
        }
        if (thisThis.ast !== null) thisThis.ast.init(rules, udts, chars);
    };
    /* called by parse() to initialize the trace object, if one has been defined */ var initializeTrace = function initializeTrace() {
        var functionName = "".concat(thisFileName, "initializeTrace(): ");
        var TRUE = true;
        while(TRUE){
            if (thisThis.trace === undefined) {
                thisThis.trace = null;
                break;
            }
            if (thisThis.trace === null) break;
            if (thisThis.trace.traceObject !== "traceObject") throw new Error("".concat(functionName, "trace object not recognized"));
            break;
        }
        if (thisThis.trace !== null) thisThis.trace.init(rules, udts, chars);
    };
    /* called by parse() to initialize the statistics object, if one has been defined */ var initializeStats = function initializeStats() {
        var functionName = "".concat(thisFileName, "initializeStats(): ");
        var TRUE = true;
        while(TRUE){
            if (thisThis.stats === undefined) {
                thisThis.stats = null;
                break;
            }
            if (thisThis.stats === null) break;
            if (thisThis.stats.statsObject !== "statsObject") throw new Error("".concat(functionName, "stats object not recognized"));
            break;
        }
        if (thisThis.stats !== null) thisThis.stats.init(rules, udts);
    };
    /* called by parse() to initialize the rules & udts from the grammar object */ /* (the grammar object generated previously by apg) */ var initializeGrammar = function initializeGrammar(grammar) {
        var functionName = "".concat(thisFileName, "initializeGrammar(): ");
        if (!grammar) throw new Error("".concat(functionName, "grammar object undefined"));
        if (grammar.grammarObject !== "grammarObject") throw new Error("".concat(functionName, "bad grammar object"));
        rules = grammar.rules;
        udts = grammar.udts;
    };
    /* called by parse() to initialize the start rule */ var initializeStartRule = function initializeStartRule(startRule) {
        var functionName = "".concat(thisFileName, "initializeStartRule(): ");
        var start = null;
        if (typeof startRule === "number") {
            if (startRule >= rules.length) throw new Error("".concat(functionName, "start rule index too large: max: ").concat(rules.length, ": index: ").concat(startRule));
            start = startRule;
        } else if (typeof startRule === "string") {
            var lower = startRule.toLowerCase();
            for(var i = 0; i < rules.length; i += 1)if (lower === rules[i].lower) {
                start = rules[i].index;
                break;
            }
            if (start === null) throw new Error("".concat(functionName, "start rule name '").concat(startRule, "' not recognized"));
        } else throw new Error("".concat(functionName, "type of start rule '").concat(typeof startRule === "undefined" ? "undefined" : (0, $jquDQ._)(startRule), "' not recognized"));
        return start;
    };
    /* called by parse() to initialize the array of characters codes representing the input string */ var initializeInputChars = function initializeInputChars(inputArg, begArg, lenArg) {
        var functionName = "".concat(thisFileName, "initializeInputChars(): ");
        /* varify and normalize input */ var input = inputArg;
        var beg = begArg;
        var len = lenArg;
        if (input === undefined) throw new Error("".concat(functionName, "input string is undefined"));
        if (input === null) throw new Error("".concat(functionName, "input string is null"));
        if (typeof input === "string") input = utils.stringToChars(input);
        else if (!Array.isArray(input)) throw new Error("".concat(functionName, "input string is not a string or array"));
        if (input.length > 0) {
            if (typeof input[0] !== "number") throw new Error("".concat(functionName, "input string not an array of integers"));
        }
        /* verify and normalize beginning index */ if (typeof beg !== "number") beg = 0;
        else {
            beg = Math.floor(beg);
            if (beg < 0 || beg > input.length) throw new Error("".concat(functionName, "input beginning index out of range: ").concat(beg));
        }
        /* verify and normalize input length */ if (typeof len !== "number") len = input.length - beg;
        else {
            len = Math.floor(len);
            if (len < 0 || len > input.length - beg) throw new Error("".concat(functionName, "input length out of range: ").concat(len));
        }
        chars = input;
        charsBegin = beg;
        charsLength = len;
        charsEnd = charsBegin + charsLength;
    };
    /* called by parse() to initialize the user-written, syntax callback functions, if any */ var initializeCallbacks = function initializeCallbacks() {
        var functionName = "".concat(thisFileName, "initializeCallbacks(): ");
        var i;
        ruleCallbacks = [];
        udtCallbacks = [];
        for(i = 0; i < rules.length; i += 1)ruleCallbacks[i] = null;
        for(i = 0; i < udts.length; i += 1)udtCallbacks[i] = null;
        var func;
        var list = [];
        for(i = 0; i < rules.length; i += 1)list.push(rules[i].lower);
        for(i = 0; i < udts.length; i += 1)list.push(udts[i].lower);
        for(var index in thisThis.callbacks){
            i = list.indexOf(index.toLowerCase());
            if (i < 0) throw new Error("".concat(functionName, "syntax callback '").concat(index, "' not a rule or udt name"));
            func = thisThis.callbacks[index];
            if (!func) func = null;
            if (typeof func === "function" || func === null) {
                if (i < rules.length) ruleCallbacks[i] = func;
                else udtCallbacks[i - rules.length] = func;
            } else throw new Error("".concat(functionName, "syntax callback[").concat(index, "] must be function reference or 'false' (false/null/undefined/etc.)"));
        }
        /* make sure all udts have been defined - the parser can't work without them */ for(i = 0; i < udts.length; i += 1){
            if (udtCallbacks[i] === null) throw new Error("".concat(functionName, "all UDT callbacks must be defined. UDT callback[").concat(udts[i].lower, "] not a function reference"));
        }
    };
    // Set the maximum parse tree depth allowed. The default is `Infinity`.
    // A limit is not normally needed, but can be used to protect against an
    // exponentual or "catastrophically backtracking" grammar.
    // <ul>
    // <li>
    // depth - max allowed parse tree depth. An exception is thrown if exceeded.
    // </li>
    // </ul>
    this.setMaxTreeDepth = function(depth) {
        if (typeof depth !== "number") throw new Error("parser: max tree depth must be integer > 0: ".concat(depth));
        limitTreeDepth = Math.floor(depth);
        if (limitTreeDepth <= 0) throw new Error("parser: max tree depth must be integer > 0: ".concat(depth));
    };
    // Set the maximum number of node hits (parser unit steps or opcode function calls) allowed.
    // The default is `Infinity`.
    // A limit is not normally needed, but can be used to protect against an
    // exponentual or "catastrophically backtracking" grammar.
    // <ul>
    // <li>
    // hits - maximum number of node hits or parser unit steps allowed.
    // An exception thrown if exceeded.
    // </li>
    // </ul>
    this.setMaxNodeHits = function(hits) {
        if (typeof hits !== "number") throw new Error("parser: max node hits must be integer > 0: ".concat(hits));
        limitNodeHits = Math.floor(hits);
        if (limitNodeHits <= 0) throw new Error("parser: max node hits must be integer > 0: ".concat(hits));
    };
    /* the main parser function */ var privateParse = function privateParse(grammar, startRuleArg, callbackData) {
        var success;
        var functionName = "".concat(thisFileName, "parse(): ");
        initializeGrammar(grammar);
        var startRule = initializeStartRule(startRuleArg);
        initializeCallbacks();
        initializeTrace();
        initializeStats();
        initializeAst();
        var sysData = new systemData();
        if (!(callbackData === undefined || callbackData === null)) syntaxData = callbackData;
        /* create a dummy opcode for the start rule */ opcodes = [
            {
                type: id.RNM,
                index: startRule
            }
        ];
        /* execute the start rule */ opExecute(0, charsBegin, sysData);
        opcodes = null;
        /* test and return the sysData */ switch(sysData.state){
            case id.ACTIVE:
                throw new Error("".concat(functionName, "final state should never be 'ACTIVE'"));
            case id.NOMATCH:
                success = false;
                break;
            case id.EMPTY:
            case id.MATCH:
                if (sysData.phraseLength === charsLength) success = true;
                else success = false;
                break;
            default:
                throw new Error("unrecognized state");
        }
        return {
            success: success,
            state: sysData.state,
            length: charsLength,
            matched: sysData.phraseLength,
            maxMatched: maxMatched,
            maxTreeDepth: maxTreeDepth,
            nodeHits: nodeHits,
            inputLength: chars.length,
            subBegin: charsBegin,
            subEnd: charsEnd,
            subLength: charsLength
        };
    };
    // This form allows parsing of a sub-string of the full input string.
    // <ul>
    // <li>*inputIndex* - index of the first character in the sub-string</li>
    // <li>*inputLength* - length of the sub-string</li>
    // </ul>
    // All other parameters as for the above function `parse()`.
    this.parseSubstring = function parseSubstring(grammar, startRule, inputChars, inputIndex, inputLength, callbackData) {
        clear();
        initializeInputChars(inputChars, inputIndex, inputLength);
        return privateParse(grammar, startRule, callbackData);
    };
    // This is the main function, called to parse an input string.
    // <ul>
    // <li>*grammar* - an instantiated grammar object - the output of `apg` for a
    // specific SABNF grammar</li>
    // <li>*startRule* - the rule name or rule index to be used as the root of the
    // parse tree. This is usually the first rule, index = 0, of the grammar
    // but can be any rule defined in the above grammar object.</li>
    // <li>*inputChars* - the input string. Can be a string or an array of integer character codes representing the
    // string.</li>
    // <li>*callbackData* - user-defined data object to be passed to the user's
    // callback functions.
    // This is not used by the parser in any way, merely passed on to the user.
    // May be `null` or omitted.</li>
    // </ul>
    this.parse = function parse(grammar, startRule, inputChars, callbackData) {
        clear();
        initializeInputChars(inputChars, 0, inputChars.length);
        return privateParse(grammar, startRule, callbackData);
    };
    // The `ALT` operator.<br>
    // Executes its child nodes, from left to right, until it finds a match.
    // Fails if *all* of its child nodes fail.
    var opALT = function opALT(opIndex, phraseIndex, sysData) {
        var op = opcodes[opIndex];
        for(var i = 0; i < op.children.length; i += 1){
            opExecute(op.children[i], phraseIndex, sysData);
            if (sysData.state !== id.NOMATCH) break;
        }
    };
    // The `CAT` operator.<br>
    // Executes all of its child nodes, from left to right,
    // concatenating the matched phrases.
    // Fails if *any* child nodes fail.
    var opCAT = function opCAT(opIndex, phraseIndex, sysData) {
        var success;
        var astLength;
        var catCharIndex;
        var catPhrase;
        var op = opcodes[opIndex];
        var ulen = sysData.uFrame.length();
        var plen = sysData.pFrame.length();
        if (thisThis.ast) astLength = thisThis.ast.getLength();
        success = true;
        catCharIndex = phraseIndex;
        catPhrase = 0;
        for(var i = 0; i < op.children.length; i += 1){
            opExecute(op.children[i], catCharIndex, sysData);
            if (sysData.state === id.NOMATCH) {
                success = false;
                break;
            } else {
                catCharIndex += sysData.phraseLength;
                catPhrase += sysData.phraseLength;
            }
        }
        if (success) {
            sysData.state = catPhrase === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = catPhrase;
        } else {
            sysData.state = id.NOMATCH;
            sysData.phraseLength = 0;
            /* reset the back referencing frames on failure */ sysData.uFrame.pop(ulen);
            sysData.pFrame.pop(plen);
            if (thisThis.ast) thisThis.ast.setLength(astLength);
        }
    };
    // The `REP` operator.<br>
    // Repeatedly executes its single child node,
    // concatenating each of the matched phrases found.
    // The number of repetitions executed and its final sysData depends
    // on its `min` & `max` repetition values.
    var opREP = function opREP(opIndex, phraseIndex, sysData) {
        var astLength;
        var repCharIndex;
        var repPhrase;
        var repCount;
        var op = opcodes[opIndex];
        repCharIndex = phraseIndex;
        repPhrase = 0;
        repCount = 0;
        var ulen = sysData.uFrame.length();
        var plen = sysData.pFrame.length();
        if (thisThis.ast) astLength = thisThis.ast.getLength();
        var TRUE = true;
        while(TRUE){
            if (repCharIndex >= charsEnd) break;
            opExecute(opIndex + 1, repCharIndex, sysData);
            if (sysData.state === id.NOMATCH) break;
            if (sysData.state === id.EMPTY) break;
            repCount += 1;
            repPhrase += sysData.phraseLength;
            repCharIndex += sysData.phraseLength;
            if (repCount === op.max) break;
        }
        /* evaluate the match count according to the min, max values */ if (sysData.state === id.EMPTY) {
            sysData.state = repPhrase === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = repPhrase;
        } else if (repCount >= op.min) {
            sysData.state = repPhrase === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = repPhrase;
        } else {
            sysData.state = id.NOMATCH;
            sysData.phraseLength = 0;
            /* reset the back referencing frames on failure */ sysData.uFrame.pop(ulen);
            sysData.pFrame.pop(plen);
            if (thisThis.ast) thisThis.ast.setLength(astLength);
        }
    };
    // Validate the callback function's returned sysData values.
    // It's the user's responsibility to get them right
    // but `RNM` fails if not.
    var validateRnmCallbackResult = function validateRnmCallbackResult(rule, sysData, charsLeft, down) {
        if (sysData.phraseLength > charsLeft) {
            var str = "".concat(thisFileName, "opRNM(").concat(rule.name, "): callback function error: ");
            str += "sysData.phraseLength: ".concat(sysData.phraseLength);
            str += " must be <= remaining chars: ".concat(charsLeft);
            throw new Error(str);
        }
        switch(sysData.state){
            case id.ACTIVE:
                if (down !== true) throw new Error("".concat(thisFileName, "opRNM(").concat(rule.name, "): callback function return error. ACTIVE state not allowed."));
                break;
            case id.EMPTY:
                sysData.phraseLength = 0;
                break;
            case id.MATCH:
                if (sysData.phraseLength === 0) sysData.state = id.EMPTY;
                break;
            case id.NOMATCH:
                sysData.phraseLength = 0;
                break;
            default:
                throw new Error("".concat(thisFileName, "opRNM(").concat(rule.name, "): callback function return error. Unrecognized return state: ").concat(sysData.state));
        }
    };
    // The `RNM` operator.<br>
    // This operator will acts as a root node for a parse tree branch below and
    // returns the matched phrase to its parent.
    // However, its larger responsibility is handling user-defined callback functions, back references and `AST` nodes.
    // Note that the `AST` is a separate object, but `RNM` calls its functions to create its nodes.
    // See [`ast.js`](./ast.html) for usage.
    var opRNM = function opRNM(opIndex, phraseIndex, sysData) {
        var astLength;
        var astDefined;
        var savedOpcodes;
        var ulen;
        var plen;
        var saveFrame;
        var op = opcodes[opIndex];
        var rule = rules[op.index];
        var callback = ruleCallbacks[rule.index];
        var notLookAround = !inLookAround();
        /* ignore AST and back references in lookaround */ if (notLookAround) {
            /* begin AST and back references */ astDefined = thisThis.ast && thisThis.ast.ruleDefined(op.index);
            if (astDefined) {
                astLength = thisThis.ast.getLength();
                thisThis.ast.down(op.index, rules[op.index].name);
            }
            ulen = sysData.uFrame.length();
            plen = sysData.pFrame.length();
            sysData.uFrame.push();
            sysData.pFrame.push();
            saveFrame = sysData.pFrame;
            sysData.pFrame = new backRef();
        }
        if (callback === null) {
            /* no callback - just execute the rule */ savedOpcodes = opcodes;
            opcodes = rule.opcodes;
            opExecute(0, phraseIndex, sysData);
            opcodes = savedOpcodes;
        } else {
            /* call user's callback */ var charsLeft = charsEnd - phraseIndex;
            sysData.ruleIndex = rule.index;
            callback(sysData, chars, phraseIndex, syntaxData);
            validateRnmCallbackResult(rule, sysData, charsLeft, true);
            if (sysData.state === id.ACTIVE) {
                savedOpcodes = opcodes;
                opcodes = rule.opcodes;
                opExecute(0, phraseIndex, sysData);
                opcodes = savedOpcodes;
                sysData.ruleIndex = rule.index;
                callback(sysData, chars, phraseIndex, syntaxData);
                validateRnmCallbackResult(rule, sysData, charsLeft, false);
            } /* implied else clause: just accept the callback sysData - RNM acting as UDT */ 
        }
        if (notLookAround) {
            /* end AST */ if (astDefined) {
                if (sysData.state === id.NOMATCH) thisThis.ast.setLength(astLength);
                else thisThis.ast.up(op.index, rule.name, phraseIndex, sysData.phraseLength);
            }
            /* end back reference */ sysData.pFrame = saveFrame;
            if (sysData.state === id.NOMATCH) {
                sysData.uFrame.pop(ulen);
                sysData.pFrame.pop(plen);
            } else if (rule.isBkr) {
                /* save phrase on both the parent and universal frames */ /* BKR operator will decide which to use later */ sysData.pFrame.savePhrase(rule.lower, phraseIndex, sysData.phraseLength);
                sysData.uFrame.savePhrase(rule.lower, phraseIndex, sysData.phraseLength);
            }
        }
    };
    // Validate the callback function's returned sysData values.
    // It's the user's responsibility to get it right but `UDT` fails if not.
    var validateUdtCallbackResult = function validateUdtCallbackResult(udt, sysData, charsLeft) {
        if (sysData.phraseLength > charsLeft) {
            var str = "".concat(thisFileName, "opUDT(").concat(udt.name, "): callback function error: ");
            str += "sysData.phraseLength: ".concat(sysData.phraseLength);
            str += " must be <= remaining chars: ".concat(charsLeft);
            throw new Error(str);
        }
        switch(sysData.state){
            case id.ACTIVE:
                throw new Error("".concat(thisFileName, "opUDT(").concat(udt.name, "): callback function return error. ACTIVE state not allowed."));
            case id.EMPTY:
                if (udt.empty === false) throw new Error("".concat(thisFileName, "opUDT(").concat(udt.name, "): callback function return error. May not return EMPTY."));
                else sysData.phraseLength = 0;
                break;
            case id.MATCH:
                if (sysData.phraseLength === 0) {
                    if (udt.empty === false) throw new Error("".concat(thisFileName, "opUDT(").concat(udt.name, "): callback function return error. May not return EMPTY."));
                    else sysData.state = id.EMPTY;
                }
                break;
            case id.NOMATCH:
                sysData.phraseLength = 0;
                break;
            default:
                throw new Error("".concat(thisFileName, "opUDT(").concat(udt.name, "): callback function return error. Unrecognized return state: ").concat(sysData.state));
        }
    };
    // The `UDT` operator.<br>
    // Simply calls the user's callback function, but operates like `RNM` with regard to the `AST`
    // and back referencing.
    // There is some ambiguity here. `UDT`s act as terminals for phrase recognition but as named rules
    // for `AST` nodes and back referencing.
    // See [`ast.js`](./ast.html) for usage.
    var opUDT = function opUDT(opIndex, phraseIndex, sysData) {
        var astLength;
        var astIndex;
        var astDefined;
        var ulen;
        var plen;
        var saveFrame;
        var op = opcodes[opIndex];
        var udt = udts[op.index];
        sysData.UdtIndex = udt.index;
        var notLookAround = !inLookAround();
        /* ignore AST and back references in lookaround */ if (notLookAround) {
            /* begin AST and back reference */ astDefined = thisThis.ast && thisThis.ast.udtDefined(op.index);
            if (astDefined) {
                astIndex = rules.length + op.index;
                astLength = thisThis.ast.getLength();
                thisThis.ast.down(astIndex, udt.name);
            }
            /* NOTE: push and pop of the back reference frame is normally not necessary */ /* only in the case that the UDT calls evaluateRule() or evaluateUdt() */ ulen = sysData.uFrame.length();
            plen = sysData.pFrame.length();
            sysData.uFrame.push();
            sysData.pFrame.push();
            saveFrame = sysData.pFrame;
            sysData.pFrame = new backRef();
        }
        /* call the UDT */ var charsLeft = charsEnd - phraseIndex;
        udtCallbacks[op.index](sysData, chars, phraseIndex, syntaxData);
        validateUdtCallbackResult(udt, sysData, charsLeft);
        if (notLookAround) {
            /* end AST */ if (astDefined) {
                if (sysData.state === id.NOMATCH) thisThis.ast.setLength(astLength);
                else thisThis.ast.up(astIndex, udt.name, phraseIndex, sysData.phraseLength);
            }
            /* end back reference */ sysData.pFrame = saveFrame;
            if (sysData.state === id.NOMATCH) {
                sysData.uFrame.pop(ulen);
                sysData.pFrame.pop(plen);
            } else if (udt.isBkr) {
                /* save phrase on both the parent and universal frames */ /* BKR operator will decide which to use later */ sysData.pFrame.savePhrase(udt.lower, phraseIndex, sysData.phraseLength);
                sysData.uFrame.savePhrase(udt.lower, phraseIndex, sysData.phraseLength);
            }
        }
    };
    // The `AND` operator.<br>
    // This is the positive `look ahead` operator.
    // Executes its single child node, returning the EMPTY state
    // if it succeedsand NOMATCH if it fails.
    // *Always* backtracks on any matched phrase and returns EMPTY on success.
    var opAND = function opAND(opIndex, phraseIndex, sysData) {
        lookAround.push({
            lookAround: id.LOOKAROUND_AHEAD,
            anchor: phraseIndex,
            charsEnd: charsEnd,
            charsLength: charsLength
        });
        charsEnd = chars.length;
        charsLength = chars.length - charsBegin;
        opExecute(opIndex + 1, phraseIndex, sysData);
        var pop = lookAround.pop();
        charsEnd = pop.charsEnd;
        charsLength = pop.charsLength;
        sysData.phraseLength = 0;
        switch(sysData.state){
            case id.EMPTY:
                sysData.state = id.EMPTY;
                break;
            case id.MATCH:
                sysData.state = id.EMPTY;
                break;
            case id.NOMATCH:
                sysData.state = id.NOMATCH;
                break;
            default:
                throw new Error("opAND: invalid state ".concat(sysData.state));
        }
    };
    // The `NOT` operator.<br>
    // This is the negative `look ahead` operator.
    // Executes its single child node, returning the EMPTY state
    // if it *fails* and NOMATCH if it succeeds.
    // *Always* backtracks on any matched phrase and returns EMPTY
    // on success (failure of its child node).
    var opNOT = function opNOT(opIndex, phraseIndex, sysData) {
        lookAround.push({
            lookAround: id.LOOKAROUND_AHEAD,
            anchor: phraseIndex,
            charsEnd: charsEnd,
            charsLength: charsLength
        });
        charsEnd = chars.length;
        charsLength = chars.length - charsBegin;
        opExecute(opIndex + 1, phraseIndex, sysData);
        var pop = lookAround.pop();
        charsEnd = pop.charsEnd;
        charsLength = pop.charsLength;
        sysData.phraseLength = 0;
        switch(sysData.state){
            case id.EMPTY:
            case id.MATCH:
                sysData.state = id.NOMATCH;
                break;
            case id.NOMATCH:
                sysData.state = id.EMPTY;
                break;
            default:
                throw new Error("opNOT: invalid state ".concat(sysData.state));
        }
    };
    // The `TRG` operator.<br>
    // Succeeds if the single first character of the phrase is
    // within the `min - max` range.
    var opTRG = function opTRG(opIndex, phraseIndex, sysData) {
        var op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        if (phraseIndex < charsEnd) {
            if (op.min <= chars[phraseIndex] && chars[phraseIndex] <= op.max) {
                sysData.state = id.MATCH;
                sysData.phraseLength = 1;
            }
        }
    };
    // The `TBS` operator.<br>
    // Matches its pre-defined phrase against the input string.
    // All characters must match exactly.
    // Case-sensitive literal strings (`'string'` & `%s"string"`) are translated to `TBS`
    // operators by `apg`.
    // Phrase length of zero is not allowed.
    // Empty phrases can only be defined with `TLS` operators.
    var opTBS = function opTBS(opIndex, phraseIndex, sysData) {
        var i;
        var op = opcodes[opIndex];
        var len = op.string.length;
        sysData.state = id.NOMATCH;
        if (phraseIndex + len <= charsEnd) {
            for(i = 0; i < len; i += 1){
                if (chars[phraseIndex + i] !== op.string[i]) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        } /* implied else NOMATCH */ 
    };
    // The `TLS` operator.<br>
    // Matches its pre-defined phrase against the input string.
    // A case-insensitive match is attempted for ASCII alphbetical characters.
    // `TLS` is the only operator that explicitly allows empty phrases.
    // `apg` will fail for empty `TBS`, case-sensitive strings (`''`) or
    // zero repetitions (`0*0RuleName` or `0RuleName`).
    var opTLS = function opTLS(opIndex, phraseIndex, sysData) {
        var i;
        var code;
        var op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        var len = op.string.length;
        if (len === 0) {
            /* EMPTY match allowed for TLS */ sysData.state = id.EMPTY;
            return;
        }
        if (phraseIndex + len <= charsEnd) {
            for(i = 0; i < len; i += 1){
                code = chars[phraseIndex + i];
                if (code >= 65 && code <= 90) code += 32;
                if (code !== op.string[i]) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        } /* implied else NOMATCH */ 
    };
    // The `ABG` operator.<br>
    // This is an "anchor" for the beginning of the string, similar to the familiar regex `^` anchor.
    // An anchor matches a position rather than a phrase.
    // Returns EMPTY if `phraseIndex` is 0, NOMATCH otherwise.
    var opABG = function opABG(opIndex, phraseIndex, sysData) {
        sysData.state = id.NOMATCH;
        sysData.phraseLength = 0;
        sysData.state = phraseIndex === 0 ? id.EMPTY : id.NOMATCH;
    };
    // The `AEN` operator.<br>
    // This is an "anchor" for the end of the string, similar to the familiar regex `$` anchor.
    // An anchor matches a position rather than a phrase.
    // Returns EMPTY if `phraseIndex` equals the input string length, NOMATCH otherwise.
    var opAEN = function opAEN(opIndex, phraseIndex, sysData) {
        sysData.state = id.NOMATCH;
        sysData.phraseLength = 0;
        sysData.state = phraseIndex === chars.length ? id.EMPTY : id.NOMATCH;
    };
    // The `BKR` operator.<br>
    // The back reference operator.
    // Matches the last matched phrase of the named rule or UDT against the input string.
    // For ASCII alphbetical characters the match may be case sensitive (`%s`) or insensitive (`%i`),
    // depending on the back reference definition.
    // For `universal` mode (`%u`) matches the last phrase found anywhere in the grammar.
    // For `parent frame` mode (`%p`) matches the last phrase found in the parent rule only.
    var opBKR = function opBKR(opIndex, phraseIndex, sysData) {
        var i;
        var code;
        var lmcode;
        var lower;
        var op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        if (op.index < rules.length) lower = rules[op.index].lower;
        else lower = udts[op.index - rules.length].lower;
        var frame = op.bkrMode === id.BKR_MODE_PM ? sysData.pFrame.getPhrase(lower) : sysData.uFrame.getPhrase(lower);
        var insensitive = op.bkrCase === id.BKR_MODE_CI;
        if (frame === null) return;
        var lmIndex = frame.phraseIndex;
        var len = frame.phraseLength;
        if (len === 0) {
            sysData.state = id.EMPTY;
            return;
        }
        if (phraseIndex + len <= charsEnd) {
            if (insensitive) {
                /* case-insensitive match */ for(i = 0; i < len; i += 1){
                    code = chars[phraseIndex + i];
                    lmcode = chars[lmIndex + i];
                    if (code >= 65 && code <= 90) code += 32;
                    if (lmcode >= 65 && lmcode <= 90) lmcode += 32;
                    if (code !== lmcode) return;
                }
                sysData.state = id.MATCH;
                sysData.phraseLength = len;
            } else /* case-sensitive match */ for(i = 0; i < len; i += 1){
                code = chars[phraseIndex + i];
                lmcode = chars[lmIndex + i];
                if (code !== lmcode) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        }
    };
    // The `BKA` operator.<br>
    // This is the positive `look behind` operator.
    // It's child node is parsed right-to-left.
    // Returns the EMPTY state if a match is found, NOMATCH otherwise.
    // Like the look ahead operators, it always backtracks to `phraseIndex`.
    var opBKA = function opBKA(opIndex, phraseIndex, sysData) {
        lookAround.push({
            lookAround: id.LOOKAROUND_BEHIND,
            anchor: phraseIndex
        });
        opExecute(opIndex + 1, phraseIndex, sysData);
        lookAround.pop();
        sysData.phraseLength = 0;
        switch(sysData.state){
            case id.EMPTY:
                sysData.state = id.EMPTY;
                break;
            case id.MATCH:
                sysData.state = id.EMPTY;
                break;
            case id.NOMATCH:
                sysData.state = id.NOMATCH;
                break;
            default:
                throw new Error("opBKA: invalid state ".concat(sysData.state));
        }
    };
    // The `BKN` operator.<br>
    // This is the negative `look behind` operator.
    // It's child node is parsed right-to-left.
    // Returns the EMPTY state if a match is *not* found, NOMATCH otherwise.
    // Like the look ahead operators, it always backtracks to `phraseIndex`.
    var opBKN = function opBKN(opIndex, phraseIndex, sysData) {
        // let op;
        // op = opcodes[opIndex];
        lookAround.push({
            lookAround: id.LOOKAROUND_BEHIND,
            anchor: phraseIndex
        });
        opExecute(opIndex + 1, phraseIndex, sysData);
        lookAround.pop();
        sysData.phraseLength = 0;
        switch(sysData.state){
            case id.EMPTY:
            case id.MATCH:
                sysData.state = id.NOMATCH;
                break;
            case id.NOMATCH:
                sysData.state = id.EMPTY;
                break;
            default:
                throw new Error("opBKN: invalid state ".concat(sysData.state));
        }
    };
    // The right-to-left `CAT` operator.<br>
    // Called for `CAT` operators when in look behind mode.
    // Calls its child nodes from right to left concatenating matched phrases right to left.
    var opCATBehind = function opCATBehind(opIndex, phraseIndex, sysData) {
        var success;
        var astLength;
        var catCharIndex;
        var catMatched;
        var op = opcodes[opIndex];
        var ulen = sysData.uFrame.length();
        var plen = sysData.pFrame.length();
        if (thisThis.ast) astLength = thisThis.ast.getLength();
        success = true;
        catCharIndex = phraseIndex;
        catMatched = 0;
        // catPhrase = 0;
        for(var i = op.children.length - 1; i >= 0; i -= 1){
            opExecute(op.children[i], catCharIndex, sysData);
            catCharIndex -= sysData.phraseLength;
            catMatched += sysData.phraseLength;
            // catPhrase += sysData.phraseLength;
            if (sysData.state === id.NOMATCH) {
                success = false;
                break;
            }
        }
        if (success) {
            sysData.state = catMatched === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = catMatched;
        } else {
            sysData.state = id.NOMATCH;
            sysData.phraseLength = 0;
            sysData.uFrame.pop(ulen);
            sysData.pFrame.pop(plen);
            if (thisThis.ast) thisThis.ast.setLength(astLength);
        }
    };
    // The right-to-left `REP` operator.<br>
    // Called for `REP` operators in look behind mode.
    // Makes repeated calls to its child node, concatenating matched phrases right to left.
    var opREPBehind = function opREPBehind(opIndex, phraseIndex, sysData) {
        var astLength;
        var repCharIndex;
        var repPhrase;
        var repCount;
        var op = opcodes[opIndex];
        repCharIndex = phraseIndex;
        repPhrase = 0;
        repCount = 0;
        var ulen = sysData.uFrame.length();
        var plen = sysData.pFrame.length();
        if (thisThis.ast) astLength = thisThis.ast.getLength();
        var TRUE = true;
        while(TRUE){
            if (repCharIndex <= 0) break;
            opExecute(opIndex + 1, repCharIndex, sysData);
            if (sysData.state === id.NOMATCH) break;
            if (sysData.state === id.EMPTY) break;
            repCount += 1;
            repPhrase += sysData.phraseLength;
            repCharIndex -= sysData.phraseLength;
            if (repCount === op.max) break;
        }
        /* evaluate the match count according to the min, max values */ if (sysData.state === id.EMPTY) {
            sysData.state = repPhrase === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = repPhrase;
        } else if (repCount >= op.min) {
            sysData.state = repPhrase === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = repPhrase;
        } else {
            sysData.state = id.NOMATCH;
            sysData.phraseLength = 0;
            sysData.uFrame.pop(ulen);
            sysData.pFrame.pop(plen);
            if (thisThis.ast) thisThis.ast.setLength(astLength);
        }
    };
    // The right-to-left `TRG` operator.<br>
    // Called for `TRG` operators in look behind mode.
    // Matches a single character at `phraseIndex - 1` to the `min` - `max` range.
    var opTRGBehind = function opTRGBehind(opIndex, phraseIndex, sysData) {
        var op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        sysData.phraseLength = 0;
        if (phraseIndex > 0) {
            var char = chars[phraseIndex - 1];
            if (op.min <= char && char <= op.max) {
                sysData.state = id.MATCH;
                sysData.phraseLength = 1;
            }
        }
    };
    // The right-to-left `TBS` operator.<br>
    // Called for `TBS` operators in look behind mode.
    // Matches the `TBS` phrase to the left of `phraseIndex`.
    var opTBSBehind = function opTBSBehind(opIndex, phraseIndex, sysData) {
        var i;
        var op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        var len = op.string.length;
        var beg = phraseIndex - len;
        if (beg >= 0) {
            for(i = 0; i < len; i += 1){
                if (chars[beg + i] !== op.string[i]) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        }
    };
    // The right-to-left `TLS` operator.<br>
    // Called for `TLS` operators in look behind mode.
    // Matches the `TLS` phrase to the left of `phraseIndex`.
    var opTLSBehind = function opTLSBehind(opIndex, phraseIndex, sysData) {
        var char;
        var op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        var len = op.string.length;
        if (len === 0) {
            /* EMPTY match allowed for TLS */ sysData.state = id.EMPTY;
            return;
        }
        var beg = phraseIndex - len;
        if (beg >= 0) {
            for(var i = 0; i < len; i += 1){
                char = chars[beg + i];
                if (char >= 65 && char <= 90) char += 32;
                if (char !== op.string[i]) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        }
    };
    // The right-to-left back reference operator.<br>
    // Matches the back referenced phrase to the left of `phraseIndex`.
    var opBKRBehind = function opBKRBehind(opIndex, phraseIndex, sysData) {
        var i;
        var code;
        var lmcode;
        var lower;
        var op = opcodes[opIndex];
        /* NOMATCH default */ sysData.state = id.NOMATCH;
        sysData.phraseLength = 0;
        if (op.index < rules.length) lower = rules[op.index].lower;
        else lower = udts[op.index - rules.length].lower;
        var frame = op.bkrMode === id.BKR_MODE_PM ? sysData.pFrame.getPhrase(lower) : sysData.uFrame.getPhrase(lower);
        var insensitive = op.bkrCase === id.BKR_MODE_CI;
        if (frame === null) return;
        var lmIndex = frame.phraseIndex;
        var len = frame.phraseLength;
        if (len === 0) {
            sysData.state = id.EMPTY;
            sysData.phraseLength = 0;
            return;
        }
        var beg = phraseIndex - len;
        if (beg >= 0) {
            if (insensitive) {
                /* case-insensitive match */ for(i = 0; i < len; i += 1){
                    code = chars[beg + i];
                    lmcode = chars[lmIndex + i];
                    if (code >= 65 && code <= 90) code += 32;
                    if (lmcode >= 65 && lmcode <= 90) lmcode += 32;
                    if (code !== lmcode) return;
                }
                sysData.state = id.MATCH;
                sysData.phraseLength = len;
            } else /* case-sensitive match */ for(i = 0; i < len; i += 1){
                code = chars[beg + i];
                lmcode = chars[lmIndex + i];
                if (code !== lmcode) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        }
    };
    // Generalized execution function.<br>
    // Having a single, generalized function, allows a single location
    // for tracing and statistics gathering functions to be called.
    // Tracing and statistics are handled in separate objects.
    // However, the parser calls their API to build the object data records.
    // See [`trace.js`](./trace.html) and [`stats.js`](./stats.html) for their
    // usage.
    opExecute = function opExecuteFunc(opIndex, phraseIndex, sysData) {
        var ret = true;
        var op = opcodes[opIndex];
        nodeHits += 1;
        if (nodeHits > limitNodeHits) throw new Error("parser: maximum number of node hits exceeded: ".concat(limitNodeHits));
        treeDepth += 1;
        if (treeDepth > maxTreeDepth) {
            maxTreeDepth = treeDepth;
            if (maxTreeDepth > limitTreeDepth) throw new Error("parser: maximum parse tree depth exceeded: ".concat(limitTreeDepth));
        }
        sysData.refresh();
        if (thisThis.trace !== null) {
            /* collect the trace record for down the parse tree */ var lk = lookAroundValue();
            thisThis.trace.down(op, sysData.state, phraseIndex, sysData.phraseLength, lk.anchor, lk.lookAround);
        }
        if (inLookBehind()) switch(op.type){
            case id.ALT:
                opALT(opIndex, phraseIndex, sysData);
                break;
            case id.CAT:
                opCATBehind(opIndex, phraseIndex, sysData);
                break;
            case id.REP:
                opREPBehind(opIndex, phraseIndex, sysData);
                break;
            case id.RNM:
                opRNM(opIndex, phraseIndex, sysData);
                break;
            case id.UDT:
                opUDT(opIndex, phraseIndex, sysData);
                break;
            case id.AND:
                opAND(opIndex, phraseIndex, sysData);
                break;
            case id.NOT:
                opNOT(opIndex, phraseIndex, sysData);
                break;
            case id.TRG:
                opTRGBehind(opIndex, phraseIndex, sysData);
                break;
            case id.TBS:
                opTBSBehind(opIndex, phraseIndex, sysData);
                break;
            case id.TLS:
                opTLSBehind(opIndex, phraseIndex, sysData);
                break;
            case id.BKR:
                opBKRBehind(opIndex, phraseIndex, sysData);
                break;
            case id.BKA:
                opBKA(opIndex, phraseIndex, sysData);
                break;
            case id.BKN:
                opBKN(opIndex, phraseIndex, sysData);
                break;
            case id.ABG:
                opABG(opIndex, phraseIndex, sysData);
                break;
            case id.AEN:
                opAEN(opIndex, phraseIndex, sysData);
                break;
            default:
                ret = false;
                break;
        }
        else switch(op.type){
            case id.ALT:
                opALT(opIndex, phraseIndex, sysData);
                break;
            case id.CAT:
                opCAT(opIndex, phraseIndex, sysData);
                break;
            case id.REP:
                opREP(opIndex, phraseIndex, sysData);
                break;
            case id.RNM:
                opRNM(opIndex, phraseIndex, sysData);
                break;
            case id.UDT:
                opUDT(opIndex, phraseIndex, sysData);
                break;
            case id.AND:
                opAND(opIndex, phraseIndex, sysData);
                break;
            case id.NOT:
                opNOT(opIndex, phraseIndex, sysData);
                break;
            case id.TRG:
                opTRG(opIndex, phraseIndex, sysData);
                break;
            case id.TBS:
                opTBS(opIndex, phraseIndex, sysData);
                break;
            case id.TLS:
                opTLS(opIndex, phraseIndex, sysData);
                break;
            case id.BKR:
                opBKR(opIndex, phraseIndex, sysData);
                break;
            case id.BKA:
                opBKA(opIndex, phraseIndex, sysData);
                break;
            case id.BKN:
                opBKN(opIndex, phraseIndex, sysData);
                break;
            case id.ABG:
                opABG(opIndex, phraseIndex, sysData);
                break;
            case id.AEN:
                opAEN(opIndex, phraseIndex, sysData);
                break;
            default:
                ret = false;
                break;
        }
        if (!inLookAround() && phraseIndex + sysData.phraseLength > maxMatched) maxMatched = phraseIndex + sysData.phraseLength;
        if (thisThis.stats !== null) /* collect the statistics */ thisThis.stats.collect(op, sysData);
        if (thisThis.trace !== null) {
            /* collect the trace record for up the parse tree */ var lk1 = lookAroundValue();
            thisThis.trace.up(op, sysData.state, phraseIndex, sysData.phraseLength, lk1.anchor, lk1.lookAround);
        }
        treeDepth -= 1;
        return ret;
    };
};

});

parcelRegister("14FDf", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module is the constructor for the statistics gathering object.
// The statistics are nothing more than keeping a count of the
// number of times each node in the parse tree is traversed.
//
// Counts are collected for each of the individual types of operators.
// Additionally, counts are collected for each of the individually named
// `RNM` and `UDT` operators.



module.exports = function statsFunc() {
    var id = (parcelRequire("dPnGd"));
    var utils = (parcelRequire("iKY5M"));
    var style = (parcelRequire("9dZeY"));
    var thisFileName = "stats.js: ";
    var rules = [];
    var udts = [];
    var stats = [];
    var totals;
    var ruleStats = [];
    var udtStats = [];
    this.statsObject = "statsObject";
    var nameId = "stats";
    /* `Array.sort()` callback function for sorting `RNM` and `UDT` operators alphabetically by name. */ var sortAlpha = function sortAlpha(lhs, rhs) {
        if (lhs.lower < rhs.lower) return -1;
        if (lhs.lower > rhs.lower) return 1;
        return 0;
    };
    /* `Array.sort()` callback function for sorting `RNM` and `UDT` operators by hit count. */ var sortHits = function sortHits(lhs, rhs) {
        if (lhs.total < rhs.total) return 1;
        if (lhs.total > rhs.total) return -1;
        return sortAlpha(lhs, rhs);
    };
    /* `Array.sort()` callback function for sorting `RNM` and `UDT` operators by index */ /* (in the order in which they appear in the SABNF grammar). */ var sortIndex = function sortIndex(lhs, rhs) {
        if (lhs.index < rhs.index) return -1;
        if (lhs.index > rhs.index) return 1;
        return 0;
    };
    var EmptyStat = function EmptyStat() {
        this.empty = 0;
        this.match = 0;
        this.nomatch = 0;
        this.total = 0;
    };
    /* Zero out all stats */ var clear = function clear() {
        stats.length = 0;
        totals = new EmptyStat();
        stats[id.ALT] = new EmptyStat();
        stats[id.CAT] = new EmptyStat();
        stats[id.REP] = new EmptyStat();
        stats[id.RNM] = new EmptyStat();
        stats[id.TRG] = new EmptyStat();
        stats[id.TBS] = new EmptyStat();
        stats[id.TLS] = new EmptyStat();
        stats[id.UDT] = new EmptyStat();
        stats[id.AND] = new EmptyStat();
        stats[id.NOT] = new EmptyStat();
        stats[id.BKR] = new EmptyStat();
        stats[id.BKA] = new EmptyStat();
        stats[id.BKN] = new EmptyStat();
        stats[id.ABG] = new EmptyStat();
        stats[id.AEN] = new EmptyStat();
        ruleStats.length = 0;
        for(var i = 0; i < rules.length; i += 1)ruleStats.push({
            empty: 0,
            match: 0,
            nomatch: 0,
            total: 0,
            name: rules[i].name,
            lower: rules[i].lower,
            index: rules[i].index
        });
        if (udts.length > 0) {
            udtStats.length = 0;
            for(var i1 = 0; i1 < udts.length; i1 += 1)udtStats.push({
                empty: 0,
                match: 0,
                nomatch: 0,
                total: 0,
                name: udts[i1].name,
                lower: udts[i1].lower,
                index: udts[i1].index
            });
        }
    };
    /* increment the designated operator hit count by one */ var incStat = function incStat(stat, state) {
        stat.total += 1;
        switch(state){
            case id.EMPTY:
                stat.empty += 1;
                break;
            case id.MATCH:
                stat.match += 1;
                break;
            case id.NOMATCH:
                stat.nomatch += 1;
                break;
            default:
                throw new Error("".concat(thisFileName, "collect(): incStat(): unrecognized state: ").concat(state));
        }
    };
    /* helper for toHtml() */ var displayRow = function displayRow(name, stat) {
        var html = "";
        html += "<tr>";
        html += '<td class="'.concat(style.CLASS_ACTIVE, '">').concat(name, "</td>");
        html += '<td class="'.concat(style.CLASS_EMPTY, '">').concat(stat.empty, "</td>");
        html += '<td class="'.concat(style.CLASS_MATCH, '">').concat(stat.match, "</td>");
        html += '<td class="'.concat(style.CLASS_NOMATCH, '">').concat(stat.nomatch, "</td>");
        html += '<td class="'.concat(style.CLASS_ACTIVE, '">').concat(stat.total, "</td>");
        html += "</tr>\n";
        return html;
    };
    var displayOpsOnly = function displayOpsOnly() {
        var html = "";
        html += displayRow("ALT", stats[id.ALT]);
        html += displayRow("CAT", stats[id.CAT]);
        html += displayRow("REP", stats[id.REP]);
        html += displayRow("RNM", stats[id.RNM]);
        html += displayRow("TRG", stats[id.TRG]);
        html += displayRow("TBS", stats[id.TBS]);
        html += displayRow("TLS", stats[id.TLS]);
        html += displayRow("UDT", stats[id.UDT]);
        html += displayRow("AND", stats[id.AND]);
        html += displayRow("NOT", stats[id.NOT]);
        html += displayRow("BKR", stats[id.BKR]);
        html += displayRow("BKA", stats[id.BKA]);
        html += displayRow("BKN", stats[id.BKN]);
        html += displayRow("ABG", stats[id.ABG]);
        html += displayRow("AEN", stats[id.AEN]);
        html += displayRow("totals", totals);
        return html;
    };
    /* helper for toHtml() */ var displayRules = function displayRules() {
        var html = "";
        html += "<tr><th></th><th></th><th></th><th></th><th></th></tr>\n";
        html += "<tr><th>rules</th><th></th><th></th><th></th><th></th></tr>\n";
        for(var i = 0; i < rules.length; i += 1)if (ruleStats[i].total > 0) {
            html += "<tr>";
            html += '<td class="'.concat(style.CLASS_ACTIVE, '">').concat(ruleStats[i].name, "</td>");
            html += '<td class="'.concat(style.CLASS_EMPTY, '">').concat(ruleStats[i].empty, "</td>");
            html += '<td class="'.concat(style.CLASS_MATCH, '">').concat(ruleStats[i].match, "</td>");
            html += '<td class="'.concat(style.CLASS_NOMATCH, '">').concat(ruleStats[i].nomatch, "</td>");
            html += '<td class="'.concat(style.CLASS_ACTIVE, '">').concat(ruleStats[i].total, "</td>");
            html += "</tr>\n";
        }
        if (udts.length > 0) {
            html += "<tr><th></th><th></th><th></th><th></th><th></th></tr>\n";
            html += "<tr><th>udts</th><th></th><th></th><th></th><th></th></tr>\n";
            for(var i1 = 0; i1 < udts.length; i1 += 1)if (udtStats[i1].total > 0) {
                html += "<tr>";
                html += '<td class="'.concat(style.CLASS_ACTIVE, '">').concat(udtStats[i1].name, "</td>");
                html += '<td class="'.concat(style.CLASS_EMPTY, '">').concat(udtStats[i1].empty, "</td>");
                html += '<td class="'.concat(style.CLASS_MATCH, '">').concat(udtStats[i1].match, "</td>");
                html += '<td class="'.concat(style.CLASS_NOMATCH, '">').concat(udtStats[i1].nomatch, "</td>");
                html += '<td class="'.concat(style.CLASS_ACTIVE, '">').concat(udtStats[i1].total, "</td>");
                html += "</tr>\n";
            }
        }
        return html;
    };
    /* called only by the parser to validate a stats object */ this.validate = function validate(name) {
        var ret = false;
        if (typeof name === "string" && nameId === name) ret = true;
        return ret;
    };
    /* no verification of input - only called by parser() */ this.init = function init(inputRules, inputUdts) {
        rules = inputRules;
        udts = inputUdts;
        clear();
    };
    /* This function is the main interaction with the parser. */ /* The parser calls it after each node has been traversed. */ this.collect = function collect(op, result) {
        incStat(totals, result.state, result.phraseLength);
        incStat(stats[op.type], result.state, result.phraseLength);
        if (op.type === id.RNM) incStat(ruleStats[op.index], result.state, result.phraseLength);
        if (op.type === id.UDT) incStat(udtStats[op.index], result.state, result.phraseLength);
    };
    // Display the statistics as an HTML table.
    // - *type*
    //   - "ops" - (default) display only the total hit counts for all operator types.
    //   - "index" - additionally, display the hit counts for the individual `RNM` and `UDT` operators ordered by index.
    //   - "hits" - additionally, display the hit counts for the individual `RNM` and `UDT` operators by hit count.
    //   - "alpha" - additionally, display the hit counts for the individual `RNM` and `UDT` operators by name alphabetically.
    // - *caption* - optional caption for the table
    this.toHtml = function toHtml(type, caption) {
        var html = "";
        html += '<table class="'.concat(style.CLASS_STATS, '">\n');
        if (typeof caption === "string") html += "<caption>".concat(caption, "</caption>\n");
        html += '<tr><th class="'.concat(style.CLASS_ACTIVE, '">ops</th>\n');
        html += '<th class="'.concat(style.CLASS_EMPTY, '">EMPTY</th>\n');
        html += '<th class="'.concat(style.CLASS_MATCH, '">MATCH</th>\n');
        html += '<th class="'.concat(style.CLASS_NOMATCH, '">NOMATCH</th>\n');
        html += '<th class="'.concat(style.CLASS_ACTIVE, '">totals</th></tr>\n');
        var test = true;
        while(test){
            if (type === undefined) {
                html += displayOpsOnly();
                break;
            }
            if (type === null) {
                html += displayOpsOnly();
                break;
            }
            if (type === "ops") {
                html += displayOpsOnly();
                break;
            }
            if (type === "index") {
                ruleStats.sort(sortIndex);
                if (udtStats.length > 0) udtStats.sort(sortIndex);
                html += displayOpsOnly();
                html += displayRules();
                break;
            }
            if (type === "hits") {
                ruleStats.sort(sortHits);
                if (udtStats.length > 0) udtStats.sort(sortIndex);
                html += displayOpsOnly();
                html += displayRules();
                break;
            }
            if (type === "alpha") {
                ruleStats.sort(sortAlpha);
                if (udtStats.length > 0) udtStats.sort(sortAlpha);
                html += displayOpsOnly();
                html += displayRules();
                break;
            }
            break;
        }
        html += "</table>\n";
        return html;
    };
    // Display the stats table in a complete HTML5 page.
    this.toHtmlPage = function toHtmlPage(type, caption, title) {
        return utils.htmlToPage(this.toHtml(type, caption), title);
    };
};

});

parcelRegister("kVLFA", function(module, exports) {
/* eslint-disable func-names */ /* eslint-disable prefer-destructuring */ /* eslint-disable no-restricted-syntax */ /* eslint-disable guard-for-in */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module provides a means of tracing the parser through the parse tree as it goes.
// It is the primary debugging facility for debugging both the SABNF grammar syntax
// and the input strings that are supposed to be valid grammar sentences.
// It is also a very informative and educational tool for understanding
// how a parser actually operates for a given language.
//
// Tracing is the process of generating and saving a record of information for each passage
// of the parser through a parse tree node. And since it traverses each node twice, once down the tree
// and once coming back up, there are two records for each node.
// This, obviously, has the potential of generating lots of records.
// And since these records are normally displayed on a web page
// it is important to have a means to limit the actual number of records generated to
// probably no more that a few thousand. This is almost always enough to find any errors.
// The problem is to get the *right* few thousand records.
// Therefore, this module has a number of ways of limiting and/or filtering, the number and type of records.
// Considerable effort has been made to make this filtering of the trace output as simple
// and intuitive as possible.
//
// However, the ability to filter the trace records, or for that matter even understand what they are
// and the information they contain, does require a minimum amount of understanding of the APG parsing
// method. The parse tree nodes are all represented by APG operators. They break down into two natural groups.
// - The `RNM` operators and `UDT` operators are named phrases.
// These are names chosen by the writer of the SABNF grammar to represent special phrases of interest.
// - All others collect, concatenate and otherwise manipulate various intermediate phrases along the way.
//
// There are separate means of filtering which of these operators in each of these two groups get traced.
// Let `trace` be an instantiated `trace.js` object.
// Prior to parsing the string, filtering the rules and UDTs can be defined as follows:
// ```
// trace.filter.rules["rulename"] = true;
//     /* trace rule name "rulename" */
// trace.filter.rules["udtname"]  = true;
//     /* trace UDT name "udtname" */
// trace.filter.rules["<ALL>"]    = true;
//     /* trace all rules and UDTs (the default) */
// trace.filter.rules["<NONE>"]   = true;
//     /* trace no rules or UDTS */
// ```
// If any rule or UDT name other than "&lt;ALL>" or "&lt;NONE>" is specified, all other names are turned off.
// Therefore, to be selective of rule names, a filter statement is required for each rule/UDT name desired.
//
// Filtering of the other operators follows a similar procedure.
// ```
// trace.filter.operators["TRG"] = true;
//     /* trace the terminal range, TRG, operators */
// trace.filter.operators["CAT"]  = true;
//     /* trace the concatenations, CAT, operators */
// trace.filter.operators["<ALL>"]    = true;
//     /* trace all operators */
// trace.filter.operators["<NONE>"]   = true;
//     /* trace no operators (the default) */
// ```
// If any operator name other than "&lt;ALL>" or "&lt;NONE>" is specified, all other names are turned off.
// Therefore, to be selective of operator names, a filter statement is required for each name desired.
//
// There is, additionally, a means for limiting the total number of filtered or saved trace records.
// See the function, `setMaxRecords(max)` below. This will result in only the last `max` records being saved.
//
// (See [`apg-examples`](https://github.com/ldthomas/apg-js-examples) for examples of using `trace.js`.)




module.exports = function exportTrace() {
    var utils = (parcelRequire("iKY5M"));
    var style = (parcelRequire("9dZeY"));
    var circular = new (parcelRequire("hxsyk"))();
    var id = (parcelRequire("dPnGd"));
    var thisFileName = "trace.js: ";
    var that = this;
    var MODE_HEX = 16;
    var MODE_DEC = 10;
    var MODE_ASCII = 8;
    var MODE_UNICODE = 32;
    var MAX_PHRASE = 80;
    var MAX_TLS = 5;
    var records = [];
    var maxRecords = 5000;
    var lastRecord = -1;
    var filteredRecords = 0;
    var treeDepth = 0;
    var recordStack = [];
    var chars = null;
    var rules = null;
    var udts = null;
    var operatorFilter = [];
    var ruleFilter = [];
    /* special trace table phrases */ var PHRASE_END = '<span class="'.concat(style.CLASS_LINEEND, '">&bull;</span>');
    var PHRASE_CONTINUE = '<span class="'.concat(style.CLASS_LINEEND, '">&hellip;</span>');
    var PHRASE_EMPTY = '<span class="'.concat(style.CLASS_EMPTY, '">&#120634;</span>');
    /* filter the non-RNM & non-UDT operators */ var initOperatorFilter = function initOperatorFilter() {
        var setOperators = function setOperators(set) {
            operatorFilter[id.ALT] = set;
            operatorFilter[id.CAT] = set;
            operatorFilter[id.REP] = set;
            operatorFilter[id.TLS] = set;
            operatorFilter[id.TBS] = set;
            operatorFilter[id.TRG] = set;
            operatorFilter[id.AND] = set;
            operatorFilter[id.NOT] = set;
            operatorFilter[id.BKR] = set;
            operatorFilter[id.BKA] = set;
            operatorFilter[id.BKN] = set;
            operatorFilter[id.ABG] = set;
            operatorFilter[id.AEN] = set;
        };
        var items = 0;
        // eslint-disable-next-line no-unused-vars
        for(var name in that.filter.operators)items += 1;
        if (items === 0) {
            /* case 1: no operators specified: default: do not trace any operators */ setOperators(false);
            return;
        }
        for(var name1 in that.filter.operators){
            var upper = name1.toUpperCase();
            if (upper === "<ALL>") {
                /* case 2: <all> operators specified: trace all operators ignore all other operator commands */ setOperators(true);
                return;
            }
            if (upper === "<NONE>") {
                /* case 3: <none> operators specified: trace NO operators ignore all other operator commands */ setOperators(false);
                return;
            }
        }
        setOperators(false);
        for(var name2 in that.filter.operators){
            var upper1 = name2.toUpperCase();
            /* case 4: one or more individual operators specified: trace 'true' operators only */ if (upper1 === "ALT") operatorFilter[id.ALT] = that.filter.operators[name2] === true;
            else if (upper1 === "CAT") operatorFilter[id.CAT] = that.filter.operators[name2] === true;
            else if (upper1 === "REP") operatorFilter[id.REP] = that.filter.operators[name2] === true;
            else if (upper1 === "AND") operatorFilter[id.AND] = that.filter.operators[name2] === true;
            else if (upper1 === "NOT") operatorFilter[id.NOT] = that.filter.operators[name2] === true;
            else if (upper1 === "TLS") operatorFilter[id.TLS] = that.filter.operators[name2] === true;
            else if (upper1 === "TBS") operatorFilter[id.TBS] = that.filter.operators[name2] === true;
            else if (upper1 === "TRG") operatorFilter[id.TRG] = that.filter.operators[name2] === true;
            else if (upper1 === "BKR") operatorFilter[id.BKR] = that.filter.operators[name2] === true;
            else if (upper1 === "BKA") operatorFilter[id.BKA] = that.filter.operators[name2] === true;
            else if (upper1 === "BKN") operatorFilter[id.BKN] = that.filter.operators[name2] === true;
            else if (upper1 === "ABG") operatorFilter[id.ABG] = that.filter.operators[name2] === true;
            else if (upper1 === "AEN") operatorFilter[id.AEN] = that.filter.operators[name2] === true;
            else throw new Error("".concat(thisFileName, "initOpratorFilter: '").concat(name2, "' not a valid operator name.") + " Must be <all>, <none>, alt, cat, rep, tls, tbs, trg, and, not, bkr, bka or bkn");
        }
    };
    /* filter the rule and `UDT` named operators */ var initRuleFilter = function initRuleFilter() {
        var setRules = function setRules(set) {
            operatorFilter[id.RNM] = set;
            operatorFilter[id.UDT] = set;
            var count = rules.length + udts.length;
            ruleFilter.length = 0;
            for(var i = 0; i < count; i += 1)ruleFilter.push(set);
        };
        var items;
        var i;
        var list = [];
        for(i = 0; i < rules.length; i += 1)list.push(rules[i].lower);
        for(i = 0; i < udts.length; i += 1)list.push(udts[i].lower);
        ruleFilter.length = 0;
        items = 0;
        // eslint-disable-next-line no-unused-vars
        for(var name in that.filter.rules)items += 1;
        if (items === 0) {
            /* case 1: default to all rules & udts */ setRules(true);
            return;
        }
        for(var name1 in that.filter.rules){
            var lower = name1.toLowerCase();
            if (lower === "<all>") {
                /* case 2: trace all rules ignore all other rule commands */ setRules(true);
                return;
            }
            if (lower === "<none>") {
                /* case 3: trace no rules */ setRules(false);
                return;
            }
        }
        /* case 4: trace only individually specified rules */ setRules(false);
        operatorFilter[id.RNM] = true;
        operatorFilter[id.UDT] = true;
        for(var name2 in that.filter.rules){
            var lower1 = name2.toLowerCase();
            i = list.indexOf(lower1);
            if (i < 0) throw new Error("".concat(thisFileName, "initRuleFilter: '").concat(name2, "' not a valid rule or udt name"));
            ruleFilter[i] = that.filter.rules[name2] === true;
        }
    };
    /* used by other APG components to verify that they have a valid trace object */ this.traceObject = "traceObject";
    this.filter = {
        operators: [],
        rules: []
    };
    // Set the maximum number of records to keep (default = 5000).
    // Each record number larger than `maxRecords`
    // will result in deleting the previously oldest record.
    // - `max`: maximum number of records to retain (default = 5000)
    // - `last`: last record number to retain, (default = -1 for (unknown) actual last record)
    this.setMaxRecords = function(max, last) {
        lastRecord = -1;
        if (typeof max === "number" && max > 0) maxRecords = Math.ceil(max);
        else {
            maxRecords = 0;
            return;
        }
        if (typeof last === "number") {
            lastRecord = Math.floor(last);
            if (lastRecord < 0) lastRecord = -1;
        }
    };
    // Returns `maxRecords` to the caller.
    this.getMaxRecords = function() {
        return maxRecords;
    };
    // Returns `lastRecord` to the caller.
    this.getLastRecord = function() {
        return lastRecord;
    };
    /* Called only by the `parser.js` object. No verification of input. */ this.init = function(rulesIn, udtsIn, charsIn) {
        records.length = 0;
        recordStack.length = 0;
        filteredRecords = 0;
        treeDepth = 0;
        chars = charsIn;
        rules = rulesIn;
        udts = udtsIn;
        initOperatorFilter();
        initRuleFilter();
        circular.init(maxRecords);
    };
    /* returns true if this records passes through the designated filter, false if the record is to be skipped */ var filterOps = function filterOps(op) {
        var ret = false;
        if (op.type === id.RNM) {
            if (operatorFilter[op.type] && ruleFilter[op.index]) ret = true;
            else ret = false;
        } else if (op.type === id.UDT) {
            if (operatorFilter[op.type] && ruleFilter[rules.length + op.index]) ret = true;
            else ret = false;
        } else ret = operatorFilter[op.type];
        return ret;
    };
    var filterRecords = function filterRecords(record) {
        if (lastRecord === -1) return true;
        if (record <= lastRecord) return true;
        return false;
    };
    /* Collect the "down" record. */ this.down = function(op, state, offset, length, anchor, lookAround) {
        if (filterRecords(filteredRecords) && filterOps(op)) {
            recordStack.push(filteredRecords);
            records[circular.increment()] = {
                dirUp: false,
                depth: treeDepth,
                thisLine: filteredRecords,
                thatLine: undefined,
                opcode: op,
                state: state,
                phraseIndex: offset,
                phraseLength: length,
                lookAnchor: anchor,
                lookAround: lookAround
            };
            filteredRecords += 1;
            treeDepth += 1;
        }
    };
    /* Collect the "up" record. */ this.up = function(op, state, offset, length, anchor, lookAround) {
        if (filterRecords(filteredRecords) && filterOps(op)) {
            var thisLine = filteredRecords;
            var thatLine = recordStack.pop();
            var thatRecord = circular.getListIndex(thatLine);
            if (thatRecord !== -1) records[thatRecord].thatLine = thisLine;
            treeDepth -= 1;
            records[circular.increment()] = {
                dirUp: true,
                depth: treeDepth,
                thisLine: thisLine,
                thatLine: thatLine,
                opcode: op,
                state: state,
                phraseIndex: offset,
                phraseLength: length,
                lookAnchor: anchor,
                lookAround: lookAround
            };
            filteredRecords += 1;
        }
    };
    /* convert the trace records to a tree of nodes */ var toTreeObj = function toTreeObj() {
        /* private helper functions */ function nodeOpcode(node, opcode) {
            var name;
            var casetype;
            var modetype;
            if (opcode) {
                node.op = {
                    id: opcode.type,
                    name: utils.opcodeToString(opcode.type)
                };
                node.opData = undefined;
                switch(opcode.type){
                    case id.RNM:
                        node.opData = rules[opcode.index].name;
                        break;
                    case id.UDT:
                        node.opData = udts[opcode.index].name;
                        break;
                    case id.BKR:
                        if (opcode.index < rules.length) name = rules[opcode.index].name;
                        else name = udts[opcode.index - rules.length].name;
                        casetype = opcode.bkrCase === id.BKR_MODE_CI ? "%i" : "%s";
                        modetype = opcode.bkrMode === id.BKR_MODE_UM ? "%u" : "%p";
                        node.opData = "\\\\".concat(casetype).concat(modetype).concat(name);
                        break;
                    case id.TLS:
                        node.opData = [];
                        for(var i = 0; i < opcode.string.length; i += 1)node.opData.push(opcode.string[i]);
                        break;
                    case id.TBS:
                        node.opData = [];
                        for(var i1 = 0; i1 < opcode.string.length; i1 += 1)node.opData.push(opcode.string[i1]);
                        break;
                    case id.TRG:
                        node.opData = [
                            opcode.min,
                            opcode.max
                        ];
                        break;
                    case id.REP:
                        node.opData = [
                            opcode.min,
                            opcode.max
                        ];
                        break;
                    default:
                        throw new Error("unrecognized opcode");
                }
            } else {
                node.op = {
                    id: undefined,
                    name: undefined
                };
                node.opData = undefined;
            }
        }
        function nodePhrase(state, index, length) {
            if (state === id.MATCH) return {
                index: index,
                length: length
            };
            if (state === id.NOMATCH) return {
                index: index,
                length: 0
            };
            if (state === id.EMPTY) return {
                index: index,
                length: 0
            };
            return null;
        }
        var nodeId = -1;
        function nodeDown(parent, record, depth) {
            var node = {
                // eslint-disable-next-line no-plusplus
                id: nodeId++,
                branch: -1,
                parent: parent,
                up: false,
                down: false,
                depth: depth,
                children: []
            };
            if (record) {
                node.down = true;
                node.state = {
                    id: record.state,
                    name: utils.stateToString(record.state)
                };
                node.phrase = null;
                nodeOpcode(node, record.opcode);
            } else {
                node.state = {
                    id: undefined,
                    name: undefined
                };
                node.phrase = nodePhrase();
                nodeOpcode(node, undefined);
            }
            return node;
        }
        function nodeUp(node, record) {
            if (record) {
                node.up = true;
                node.state = {
                    id: record.state,
                    name: utils.stateToString(record.state)
                };
                node.phrase = nodePhrase(record.state, record.phraseIndex, record.phraseLength);
                if (!node.down) nodeOpcode(node, record.opcode);
            }
        }
        /* walk the final tree: label branches and count leaf nodes */ var leafNodes = 0;
        var depth = -1;
        var branchCount = 1;
        function walk(node) {
            depth += 1;
            node.branch = branchCount;
            if (depth > treeDepth) treeDepth = depth;
            if (node.children.length === 0) leafNodes += 1;
            else for(var i = 0; i < node.children.length; i += 1){
                if (i > 0) branchCount += 1;
                node.children[i].leftMost = false;
                node.children[i].rightMost = false;
                if (node.leftMost) node.children[i].leftMost = i === 0;
                if (node.rightMost) node.children[i].rightMost = i === node.children.length - 1;
                walk(node.children[i]);
            }
            depth -= 1;
        }
        function display(node, offset) {
            var name;
            var obj = {};
            obj.id = node.id;
            obj.branch = node.branch;
            obj.leftMost = node.leftMost;
            obj.rightMost = node.rightMost;
            name = node.state.name ? node.state.name : "ACTIVE";
            obj.state = {
                id: node.state.id,
                name: name
            };
            name = node.op.name ? node.op.name : "?";
            obj.op = {
                id: node.op.id,
                name: name
            };
            if (typeof node.opData === "string") obj.opData = node.opData;
            else if (Array.isArray(node.opData)) {
                obj.opData = [];
                for(var i = 0; i < node.opData.length; i += 1)obj.opData[i] = node.opData[i];
            } else obj.opData = undefined;
            if (node.phrase) obj.phrase = {
                index: node.phrase.index,
                length: node.phrase.length
            };
            else obj.phrase = null;
            obj.depth = node.depth;
            obj.children = [];
            for(var i1 = 0; i1 < node.children.length; i1 += 1){
                var c = i1 !== node.children.length - 1;
                obj.children[i1] = display(node.children[i1], offset, c);
            }
            return obj;
        }
        /* construct the tree beginning here */ var branch = [];
        var root;
        var node;
        var parent;
        var record;
        var firstRecord = true;
        /* push a dummy node so the root node will have a non-null parent */ var dummy = nodeDown(null, null, -1);
        branch.push(dummy);
        node = dummy;
        circular.forEach(function(lineIndex) {
            record = records[lineIndex];
            if (firstRecord) {
                firstRecord = false;
                if (record.depth > 0) {
                    /* push some dummy nodes to fill in for missing records */ var num = record.dirUp ? record.depth + 1 : record.depth;
                    for(var i = 0; i < num; i += 1){
                        parent = node;
                        node = nodeDown(node, null, i);
                        branch.push(node);
                        parent.children.push(node);
                    }
                }
            }
            if (record.dirUp) {
                /* handle the next record up */ node = branch.pop();
                nodeUp(node, record);
                node = branch[branch.length - 1];
            } else {
                /* handle the next record down */ parent = node;
                node = nodeDown(node, record, record.depth);
                branch.push(node);
                parent.children.push(node);
            }
        });
        /* if not at root, walk it up to root */ while(branch.length > 1){
            node = branch.pop();
            nodeUp(node, null);
        }
        /* maybe redundant or paranoid tests: these should never happen */ if (dummy.children.length === 0) throw new Error("trace.toTree(): parse tree has no nodes");
        if (branch.length === 0) throw new Error("trace.toTree(): integrity check: dummy root node disappeared?");
        /* if no record for start rule: find the pseudo root node (first dummy node above a real node) */ root = dummy.children[0];
        var prev = root;
        while(root && !root.down && !root.up){
            prev = root;
            root = root.children[0];
        }
        root = prev;
        /* walk the tree of nodes: label brances and count leaves */ root.leftMost = true;
        root.rightMost = true;
        walk(root);
        root.branch = 0;
        /* generate the exported object */ var obj = {};
        obj.string = [];
        for(var i = 0; i < chars.length; i += 1)obj.string[i] = chars[i];
        /* generate the exported rule names */ obj.rules = [];
        for(var i1 = 0; i1 < rules.length; i1 += 1)obj.rules[i1] = rules[i1].name;
        /* generate the exported UDT names */ obj.udts = [];
        for(var i2 = 0; i2 < udts.length; i2 += 1)obj.udts[i2] = udts[i2].name;
        /* generate the ids */ obj.id = {};
        obj.id.ALT = {
            id: id.ALT,
            name: "ALT"
        };
        obj.id.CAT = {
            id: id.CAT,
            name: "CAT"
        };
        obj.id.REP = {
            id: id.REP,
            name: "REP"
        };
        obj.id.RNM = {
            id: id.RNM,
            name: "RNM"
        };
        obj.id.TLS = {
            id: id.TLS,
            name: "TLS"
        };
        obj.id.TBS = {
            id: id.TBS,
            name: "TBS"
        };
        obj.id.TRG = {
            id: id.TRG,
            name: "TRG"
        };
        obj.id.UDT = {
            id: id.UDT,
            name: "UDT"
        };
        obj.id.AND = {
            id: id.AND,
            name: "AND"
        };
        obj.id.NOT = {
            id: id.NOT,
            name: "NOT"
        };
        obj.id.BKR = {
            id: id.BKR,
            name: "BKR"
        };
        obj.id.BKA = {
            id: id.BKA,
            name: "BKA"
        };
        obj.id.BKN = {
            id: id.BKN,
            name: "BKN"
        };
        obj.id.ABG = {
            id: id.ABG,
            name: "ABG"
        };
        obj.id.AEN = {
            id: id.AEN,
            name: "AEN"
        };
        obj.id.ACTIVE = {
            id: id.ACTIVE,
            name: "ACTIVE"
        };
        obj.id.MATCH = {
            id: id.MATCH,
            name: "MATCH"
        };
        obj.id.EMPTY = {
            id: id.EMPTY,
            name: "EMPTY"
        };
        obj.id.NOMATCH = {
            id: id.NOMATCH,
            name: "NOMATCH"
        };
        /* generate the max tree depth */ obj.treeDepth = treeDepth;
        /* generate the number of leaf nodes (branches) */ obj.leafNodes = leafNodes;
        /* generate the types of the left- and right-most branches */ var branchesIncomplete;
        if (root.down) {
            if (root.up) branchesIncomplete = "none";
            else branchesIncomplete = "right";
        } else if (root.up) branchesIncomplete = "left";
        else branchesIncomplete = "both";
        obj.branchesIncomplete = branchesIncomplete;
        obj.tree = display(root, root.depth, false);
        return obj;
    };
    // Returns the trace records as JSON parse tree object.
    // - stringify: if `true`, the object is 'stringified' before returning, otherwise, the object itself is returned.
    this.toTree = function(stringify) {
        var obj = toTreeObj();
        if (stringify) return JSON.stringify(obj);
        return obj;
    };
    // Translate the trace records to HTML format and create a complete HTML page for browser display.
    this.toHtmlPage = function(mode, caption, title) {
        return utils.htmlToPage(this.toHtml(mode, caption), title);
    };
    /* From here on down, these are just helper functions for `toHtml()`. */ var htmlHeader = function htmlHeader(mode, caption) {
        /* open the page */ /* write the HTML5 header with table style */ /* open the <table> tag */ var modeName;
        switch(mode){
            case MODE_HEX:
                modeName = "hexadecimal";
                break;
            case MODE_DEC:
                modeName = "decimal";
                break;
            case MODE_ASCII:
                modeName = "ASCII";
                break;
            case MODE_UNICODE:
                modeName = "UNICODE";
                break;
            default:
                throw new Error("".concat(thisFileName, "htmlHeader: unrecognized mode: ").concat(mode));
        }
        var header = "";
        header += "<p>display mode: ".concat(modeName, "</p>\n");
        header += '<table class="'.concat(style.CLASS_TRACE, '">\n');
        if (typeof caption === "string") header += "<caption>".concat(caption, "</caption>");
        return header;
    };
    var htmlFooter = function htmlFooter() {
        var footer = "";
        /* close the </table> tag */ footer += "</table>\n";
        /* display a table legend */ footer += '<p class="'.concat(style.CLASS_MONOSPACE, '">legend:<br>\n');
        footer += "(a)&nbsp;-&nbsp;line number<br>\n";
        footer += "(b)&nbsp;-&nbsp;matching line number<br>\n";
        footer += "(c)&nbsp;-&nbsp;phrase offset<br>\n";
        footer += "(d)&nbsp;-&nbsp;phrase length<br>\n";
        footer += "(e)&nbsp;-&nbsp;tree depth<br>\n";
        footer += "(f)&nbsp;-&nbsp;operator state<br>\n";
        footer += '&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="'.concat(style.CLASS_ACTIVE, '">&darr;</span>&nbsp;&nbsp;phrase opened<br>\n');
        footer += '&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="'.concat(style.CLASS_MATCH, '">&uarr;M</span> phrase matched<br>\n');
        footer += '&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="'.concat(style.CLASS_EMPTY, '">&uarr;E</span> empty phrase matched<br>\n');
        footer += '&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="'.concat(style.CLASS_NOMATCH, '">&uarr;N</span> phrase not matched<br>\n');
        footer += "operator&nbsp;-&nbsp;ALT, CAT, REP, RNM, TRG, TLS, TBS<sup>&dagger;</sup>, UDT, AND, NOT, BKA, BKN, BKR, ABG, AEN<sup>&Dagger;</sup><br>\n";
        footer += "phrase&nbsp;&nbsp;&nbsp;-&nbsp;up to ".concat(MAX_PHRASE, " characters of the phrase being matched<br>\n");
        footer += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="'.concat(style.CLASS_MATCH, '">matched characters</span><br>\n');
        footer += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="'.concat(style.CLASS_LOOKAHEAD, '">matched characters in look ahead mode</span><br>\n');
        footer += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="'.concat(style.CLASS_LOOKBEHIND, '">matched characters in look behind mode</span><br>\n');
        footer += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="'.concat(style.CLASS_REMAINDER, '">remainder characters(not yet examined by parser)</span><br>\n');
        footer += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="'.concat(style.CLASS_CTRLCHAR, '">control characters, TAB, LF, CR, etc. (ASCII mode only)</span><br>\n');
        footer += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;".concat(PHRASE_EMPTY, " empty string<br>\n");
        footer += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;".concat(PHRASE_END, " end of input string<br>\n");
        footer += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;".concat(PHRASE_CONTINUE, " input string display truncated<br>\n");
        footer += "</p>\n";
        footer += '<p class="'.concat(style.CLASS_MONOSPACE, '">\n');
        footer += "<sup>&dagger;</sup>original ABNF operators:<br>\n";
        footer += "ALT - alternation<br>\n";
        footer += "CAT - concatenation<br>\n";
        footer += "REP - repetition<br>\n";
        footer += "RNM - rule name<br>\n";
        footer += "TRG - terminal range<br>\n";
        footer += "TLS - terminal literal string (case insensitive)<br>\n";
        footer += "TBS - terminal binary string (case sensitive)<br>\n";
        footer += "<br>\n";
        footer += "<sup>&Dagger;</sup>super set SABNF operators:<br>\n";
        footer += "UDT - user-defined terminal<br>\n";
        footer += "AND - positive look ahead<br>\n";
        footer += "NOT - negative look ahead<br>\n";
        footer += "BKA - positive look behind<br>\n";
        footer += "BKN - negative look behind<br>\n";
        footer += "BKR - back reference<br>\n";
        footer += "ABG - anchor - begin of input string<br>\n";
        footer += "AEN - anchor - end of input string<br>\n";
        footer += "</p>\n";
        return footer;
    };
    this.indent = function(depth) {
        var html = "";
        for(var i = 0; i < depth; i += 1)html += ".";
        return html;
    };
    /* format the TRG operator */ var displayTrg = function displayTrg(mode, op) {
        var html = "";
        if (op.type === id.TRG) {
            if (mode === MODE_HEX || mode === MODE_UNICODE) {
                var hex = op.min.toString(16).toUpperCase();
                if (hex.length % 2 !== 0) hex = "0".concat(hex);
                html += mode === MODE_HEX ? "%x" : "U+";
                html += hex;
                hex = op.max.toString(16).toUpperCase();
                if (hex.length % 2 !== 0) hex = "0".concat(hex);
                html += "&ndash;".concat(hex);
            } else html = "%d".concat(op.min.toString(10), "&ndash;").concat(op.max.toString(10));
        }
        return html;
    };
    /* format the REP operator */ var displayRep = function displayRep(mode, op) {
        var html = "";
        if (op.type === id.REP) {
            if (mode === MODE_HEX) {
                var hex = op.min.toString(16).toUpperCase();
                if (hex.length % 2 !== 0) hex = "0".concat(hex);
                html = "x".concat(hex);
                if (op.max < Infinity) {
                    hex = op.max.toString(16).toUpperCase();
                    if (hex.length % 2 !== 0) hex = "0".concat(hex);
                } else hex = "inf";
                html += "&ndash;".concat(hex);
            } else if (op.max < Infinity) html = "".concat(op.min.toString(10), "&ndash;").concat(op.max.toString(10));
            else html = "".concat(op.min.toString(10), "&ndash;inf");
        }
        return html;
    };
    /* format the TBS operator */ var displayTbs = function displayTbs(mode, op) {
        var html = "";
        if (op.type === id.TBS) {
            var len = Math.min(op.string.length, MAX_TLS * 2);
            if (mode === MODE_HEX || mode === MODE_UNICODE) {
                html += mode === MODE_HEX ? "%x" : "U+";
                for(var i = 0; i < len; i += 1){
                    var hex = void 0;
                    if (i > 0) html += ".";
                    hex = op.string[i].toString(16).toUpperCase();
                    if (hex.length % 2 !== 0) hex = "0".concat(hex);
                    html += hex;
                }
            } else {
                html = "%d";
                for(var i1 = 0; i1 < len; i1 += 1){
                    if (i1 > 0) html += ".";
                    html += op.string[i1].toString(10);
                }
            }
            if (len < op.string.length) html += PHRASE_CONTINUE;
        }
        return html;
    };
    /* format the TLS operator */ var displayTls = function displayTls(mode, op) {
        var html = "";
        if (op.type === id.TLS) {
            var len = Math.min(op.string.length, MAX_TLS);
            if (mode === MODE_HEX || mode === MODE_DEC) {
                var charu;
                var charl;
                var base;
                if (mode === MODE_HEX) {
                    html = "%x";
                    base = 16;
                } else {
                    html = "%d";
                    base = 10;
                }
                for(var i = 0; i < len; i += 1){
                    if (i > 0) html += ".";
                    charl = op.string[i];
                    if (charl >= 97 && charl <= 122) {
                        charu = charl - 32;
                        html += "".concat(charu.toString(base), "/").concat(charl.toString(base)).toUpperCase();
                    } else if (charl >= 65 && charl <= 90) {
                        charu = charl;
                        charl += 32;
                        html += "".concat(charu.toString(base), "/").concat(charl.toString(base)).toUpperCase();
                    } else html += charl.toString(base).toUpperCase();
                }
                if (len < op.string.length) html += PHRASE_CONTINUE;
            } else {
                html = '"';
                for(var i1 = 0; i1 < len; i1 += 1)html += utils.asciiChars[op.string[i1]];
                if (len < op.string.length) html += PHRASE_CONTINUE;
                html += '"';
            }
        }
        return html;
    };
    var subPhrase = function subPhrase(mode, charsArg, index, length, prev) {
        if (length === 0) return "";
        var phrase = "";
        var comma = prev ? "," : "";
        switch(mode){
            case MODE_HEX:
                phrase = comma + utils.charsToHex(charsArg, index, length);
                break;
            case MODE_DEC:
                if (prev) return ",".concat(utils.charsToDec(charsArg, index, length));
                phrase = comma + utils.charsToDec(charsArg, index, length);
                break;
            case MODE_UNICODE:
                phrase = utils.charsToUnicode(charsArg, index, length);
                break;
            case MODE_ASCII:
            default:
                phrase = utils.charsToAsciiHtml(charsArg, index, length);
                break;
        }
        return phrase;
    };
    /* display phrases matched in look-behind mode */ var displayBehind = function displayBehind(mode, charsArg, state, index, length, anchor) {
        var html = "";
        var beg1;
        var len1;
        var beg2;
        var len2;
        var lastchar = PHRASE_END;
        var spanBehind = '<span class="'.concat(style.CLASS_LOOKBEHIND, '">');
        var spanRemainder = '<span class="'.concat(style.CLASS_REMAINDER, '">');
        var spanend = "</span>";
        var prev = false;
        switch(state){
            case id.EMPTY:
                html += PHRASE_EMPTY;
            /* // eslint-disable-next-line no-fallthrough */ case id.NOMATCH:
            case id.MATCH:
            case id.ACTIVE:
                beg1 = index - length;
                len1 = anchor - beg1;
                beg2 = anchor;
                len2 = charsArg.length - beg2;
                break;
            default:
                throw new Error("unrecognized state");
        }
        lastchar = PHRASE_END;
        if (len1 > MAX_PHRASE) {
            len1 = MAX_PHRASE;
            lastchar = PHRASE_CONTINUE;
            len2 = 0;
        } else if (len1 + len2 > MAX_PHRASE) {
            lastchar = PHRASE_CONTINUE;
            len2 = MAX_PHRASE - len1;
        }
        if (len1 > 0) {
            html += spanBehind;
            html += subPhrase(mode, charsArg, beg1, len1, prev);
            html += spanend;
            prev = true;
        }
        if (len2 > 0) {
            html += spanRemainder;
            html += subPhrase(mode, charsArg, beg2, len2, prev);
            html += spanend;
        }
        return html + lastchar;
    };
    var displayForward = function displayForward(mode, charsArg, state, index, length, spanAhead) {
        var html = "";
        var beg1;
        var len1;
        var beg2;
        var len2;
        var lastchar = PHRASE_END;
        var spanRemainder = '<span class="'.concat(style.CLASS_REMAINDER, '">');
        var spanend = "</span>";
        var prev = false;
        switch(state){
            case id.EMPTY:
                html += PHRASE_EMPTY;
            /* // eslint-disable-next-line no-fallthrough */ case id.NOMATCH:
            case id.ACTIVE:
                beg1 = index;
                len1 = 0;
                beg2 = index;
                len2 = charsArg.length - beg2;
                break;
            case id.MATCH:
                beg1 = index;
                len1 = length;
                beg2 = index + len1;
                len2 = charsArg.length - beg2;
                break;
            default:
                throw new Error("unrecognized state");
        }
        lastchar = PHRASE_END;
        if (len1 > MAX_PHRASE) {
            len1 = MAX_PHRASE;
            lastchar = PHRASE_CONTINUE;
            len2 = 0;
        } else if (len1 + len2 > MAX_PHRASE) {
            lastchar = PHRASE_CONTINUE;
            len2 = MAX_PHRASE - len1;
        }
        if (len1 > 0) {
            html += spanAhead;
            html += subPhrase(mode, charsArg, beg1, len1, prev);
            html += spanend;
            prev = true;
        }
        if (len2 > 0) {
            html += spanRemainder;
            html += subPhrase(mode, charsArg, beg2, len2, prev);
            html += spanend;
        }
        return html + lastchar;
    };
    /* display phrases matched in look-ahead mode */ var displayAhead = function displayAhead(mode, charsArg, state, index, length) {
        var spanAhead = '<span class="'.concat(style.CLASS_LOOKAHEAD, '">');
        return displayForward(mode, charsArg, state, index, length, spanAhead);
    };
    /* display phrases matched in normal parsing mode */ var displayNone = function displayNone(mode, charsArg, state, index, length) {
        var spanAhead = '<span class="'.concat(style.CLASS_MATCH, '">');
        return displayForward(mode, charsArg, state, index, length, spanAhead);
    };
    /* Returns the filtered records, formatted as an HTML table. */ var htmlTable = function htmlTable(mode) {
        if (rules === null) return "";
        var html = "";
        var thisLine;
        var thatLine;
        var lookAhead;
        var lookBehind;
        var lookAround;
        var anchor;
        html += "<tr><th>(a)</th><th>(b)</th><th>(c)</th><th>(d)</th><th>(e)</th><th>(f)</th>";
        html += "<th>operator</th><th>phrase</th></tr>\n";
        circular.forEach(function(lineIndex) {
            var line = records[lineIndex];
            thisLine = line.thisLine;
            thatLine = line.thatLine !== undefined ? line.thatLine : "--";
            lookAhead = false;
            lookBehind = false;
            lookAround = false;
            if (line.lookAround === id.LOOKAROUND_AHEAD) {
                lookAhead = true;
                lookAround = true;
                anchor = line.lookAnchor;
            }
            if (line.opcode.type === id.AND || line.opcode.type === id.NOT) {
                lookAhead = true;
                lookAround = true;
                anchor = line.phraseIndex;
            }
            if (line.lookAround === id.LOOKAROUND_BEHIND) {
                lookBehind = true;
                lookAround = true;
                anchor = line.lookAnchor;
            }
            if (line.opcode.type === id.BKA || line.opcode.type === id.BKN) {
                lookBehind = true;
                lookAround = true;
                anchor = line.phraseIndex;
            }
            html += "<tr>";
            html += "<td>".concat(thisLine, "</td><td>").concat(thatLine, "</td>");
            html += "<td>".concat(line.phraseIndex, "</td>");
            html += "<td>".concat(line.phraseLength, "</td>");
            html += "<td>".concat(line.depth, "</td>");
            html += "<td>";
            switch(line.state){
                case id.ACTIVE:
                    html += '<span class="'.concat(style.CLASS_ACTIVE, '">&darr;&nbsp;</span>');
                    break;
                case id.MATCH:
                    html += '<span class="'.concat(style.CLASS_MATCH, '">&uarr;M</span>');
                    break;
                case id.NOMATCH:
                    html += '<span class="'.concat(style.CLASS_NOMATCH, '">&uarr;N</span>');
                    break;
                case id.EMPTY:
                    html += '<span class="'.concat(style.CLASS_EMPTY, '">&uarr;E</span>');
                    break;
                default:
                    html += '<span class="'.concat(style.CLASS_ACTIVE, '">--</span>');
                    break;
            }
            html += "</td>";
            html += "<td>";
            html += that.indent(line.depth);
            if (lookAhead) html += '<span class="'.concat(style.CLASS_LOOKAHEAD, '">');
            else if (lookBehind) html += '<span class="'.concat(style.CLASS_LOOKBEHIND, '">');
            html += utils.opcodeToString(line.opcode.type);
            if (line.opcode.type === id.RNM) html += "(".concat(rules[line.opcode.index].name, ") ");
            if (line.opcode.type === id.BKR) {
                var casetype = line.opcode.bkrCase === id.BKR_MODE_CI ? "%i" : "%s";
                var modetype = line.opcode.bkrMode === id.BKR_MODE_UM ? "%u" : "%p";
                html += "(\\".concat(casetype).concat(modetype).concat(rules[line.opcode.index].name, ") ");
            }
            if (line.opcode.type === id.UDT) html += "(".concat(udts[line.opcode.index].name, ") ");
            if (line.opcode.type === id.TRG) html += "(".concat(displayTrg(mode, line.opcode), ") ");
            if (line.opcode.type === id.TBS) html += "(".concat(displayTbs(mode, line.opcode), ") ");
            if (line.opcode.type === id.TLS) html += "(".concat(displayTls(mode, line.opcode), ") ");
            if (line.opcode.type === id.REP) html += "(".concat(displayRep(mode, line.opcode), ") ");
            if (lookAround) html += "</span>";
            html += "</td>";
            html += "<td>";
            if (lookBehind) html += displayBehind(mode, chars, line.state, line.phraseIndex, line.phraseLength, anchor);
            else if (lookAhead) html += displayAhead(mode, chars, line.state, line.phraseIndex, line.phraseLength);
            else html += displayNone(mode, chars, line.state, line.phraseIndex, line.phraseLength);
            html += "</td></tr>\n";
        });
        html += "<tr><th>(a)</th><th>(b)</th><th>(c)</th><th>(d)</th><th>(e)</th><th>(f)</th>";
        html += "<th>operator</th><th>phrase</th></tr>\n";
        html += "</table>\n";
        return html;
    };
    // Translate the trace records to HTML format.
    // - *modearg* - can be `"ascii"`, `"decimal"`, `"hexadecimal"` or `"unicode"`.
    // Determines the format of the string character code display.
    // - *caption* - optional caption for the HTML table.
    this.toHtml = function(modearg, caption) {
        /* writes the trace records as a table in a complete html page */ var mode = MODE_ASCII;
        if (typeof modearg === "string" && modearg.length >= 3) {
            var modein = modearg.toLowerCase().slice(0, 3);
            if (modein === "hex") mode = MODE_HEX;
            else if (modein === "dec") mode = MODE_DEC;
            else if (modein === "uni") mode = MODE_UNICODE;
        }
        var html = "";
        html += htmlHeader(mode, caption);
        html += htmlTable(mode);
        html += htmlFooter();
        return html;
    };
};

});


parcelRegister("8Toi2", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module reads the input grammar file and does a preliminary analysis
// before attempting to parse it into a grammar object.
// See:<br>
// `./dist/scanner-grammar.bnf`<br>
// for the grammar file this parser is based on.
//
// It has two primary functions.
// - verify the character codes - no non-printing ASCII characters
// - catalog the lines - create an array with a line object for each line.
// The object carries information about the line number and character length which is used
// by the parser generator primarily for error reporting.



module.exports = function exfn(chars, errors, strict, trace) {
    var thisFileName = "scanner.js: ";
    var apglib = (parcelRequire("gCVMI"));
    var grammar = new (parcelRequire("jTZXm"))();
    var callbacks = (parcelRequire("h3tFG")).callbacks;
    /* Scan the grammar for character code errors and catalog the lines. */ var lines = [];
    // eslint-disable-next-line new-cap
    var parser = new apglib.parser();
    // eslint-disable-next-line new-cap
    parser.ast = new apglib.ast();
    parser.ast.callbacks = callbacks;
    if (trace) {
        if (trace.traceObject !== "traceObject") throw new TypeError("".concat(thisFileName, "trace argument is not a trace object"));
        parser.trace = trace;
    }
    /* parse the input SABNF grammar */ var test = parser.parse(grammar, "file", chars);
    if (test.success !== true) {
        errors.push({
            line: 0,
            char: 0,
            msg: "syntax analysis error analyzing input SABNF grammar"
        });
        return;
    }
    var data = {
        lines: lines,
        lineNo: 0,
        errors: errors,
        strict: !!strict
    };
    /* translate (analyze) the input SABNF grammar */ parser.ast.translate(data);
    // eslint-disable-next-line consistent-return
    return lines;
};

});
parcelRegister("jTZXm", function(module, exports) {
// copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved<br>
//   license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)<br>
//
// Generated by apg-js, Version 4.0.0 [apg-js](https://github.com/ldthomas/apg-js)
module.exports = function grammar() {
    // ```
    // SUMMARY
    //      rules = 10
    //       udts = 0
    //    opcodes = 31
    //        ---   ABNF original opcodes
    //        ALT = 5
    //        CAT = 2
    //        REP = 4
    //        RNM = 11
    //        TLS = 0
    //        TBS = 4
    //        TRG = 5
    //        ---   SABNF superset opcodes
    //        UDT = 0
    //        AND = 0
    //        NOT = 0
    //        BKA = 0
    //        BKN = 0
    //        BKR = 0
    //        ABG = 0
    //        AEN = 0
    // characters = [0 - 4294967295]
    // ```
    /* OBJECT IDENTIFIER (for internal parser use) */ this.grammarObject = "grammarObject";
    /* RULES */ this.rules = [];
    this.rules[0] = {
        name: "file",
        lower: "file",
        index: 0,
        isBkr: false
    };
    this.rules[1] = {
        name: "line",
        lower: "line",
        index: 1,
        isBkr: false
    };
    this.rules[2] = {
        name: "line-text",
        lower: "line-text",
        index: 2,
        isBkr: false
    };
    this.rules[3] = {
        name: "last-line",
        lower: "last-line",
        index: 3,
        isBkr: false
    };
    this.rules[4] = {
        name: "valid",
        lower: "valid",
        index: 4,
        isBkr: false
    };
    this.rules[5] = {
        name: "invalid",
        lower: "invalid",
        index: 5,
        isBkr: false
    };
    this.rules[6] = {
        name: "end",
        lower: "end",
        index: 6,
        isBkr: false
    };
    this.rules[7] = {
        name: "CRLF",
        lower: "crlf",
        index: 7,
        isBkr: false
    };
    this.rules[8] = {
        name: "LF",
        lower: "lf",
        index: 8,
        isBkr: false
    };
    this.rules[9] = {
        name: "CR",
        lower: "cr",
        index: 9,
        isBkr: false
    };
    /* UDTS */ this.udts = [];
    /* OPCODES */ /* file */ this.rules[0].opcodes = [];
    this.rules[0].opcodes[0] = {
        type: 2,
        children: [
            1,
            3
        ]
    }; // CAT
    this.rules[0].opcodes[1] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[0].opcodes[2] = {
        type: 4,
        index: 1
    }; // RNM(line)
    this.rules[0].opcodes[3] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[0].opcodes[4] = {
        type: 4,
        index: 3
    }; // RNM(last-line)
    /* line */ this.rules[1].opcodes = [];
    this.rules[1].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[1].opcodes[1] = {
        type: 4,
        index: 2
    }; // RNM(line-text)
    this.rules[1].opcodes[2] = {
        type: 4,
        index: 6
    }; // RNM(end)
    /* line-text */ this.rules[2].opcodes = [];
    this.rules[2].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[2].opcodes[1] = {
        type: 1,
        children: [
            2,
            3
        ]
    }; // ALT
    this.rules[2].opcodes[2] = {
        type: 4,
        index: 4
    }; // RNM(valid)
    this.rules[2].opcodes[3] = {
        type: 4,
        index: 5
    }; // RNM(invalid)
    /* last-line */ this.rules[3].opcodes = [];
    this.rules[3].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[3].opcodes[1] = {
        type: 1,
        children: [
            2,
            3
        ]
    }; // ALT
    this.rules[3].opcodes[2] = {
        type: 4,
        index: 4
    }; // RNM(valid)
    this.rules[3].opcodes[3] = {
        type: 4,
        index: 5
    }; // RNM(invalid)
    /* valid */ this.rules[4].opcodes = [];
    this.rules[4].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[4].opcodes[1] = {
        type: 5,
        min: 32,
        max: 126
    }; // TRG
    this.rules[4].opcodes[2] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    /* invalid */ this.rules[5].opcodes = [];
    this.rules[5].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[5].opcodes[1] = {
        type: 5,
        min: 0,
        max: 8
    }; // TRG
    this.rules[5].opcodes[2] = {
        type: 5,
        min: 11,
        max: 12
    }; // TRG
    this.rules[5].opcodes[3] = {
        type: 5,
        min: 14,
        max: 31
    }; // TRG
    this.rules[5].opcodes[4] = {
        type: 5,
        min: 127,
        max: 4294967295
    }; // TRG
    /* end */ this.rules[6].opcodes = [];
    this.rules[6].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3
        ]
    }; // ALT
    this.rules[6].opcodes[1] = {
        type: 4,
        index: 7
    }; // RNM(CRLF)
    this.rules[6].opcodes[2] = {
        type: 4,
        index: 8
    }; // RNM(LF)
    this.rules[6].opcodes[3] = {
        type: 4,
        index: 9
    }; // RNM(CR)
    /* CRLF */ this.rules[7].opcodes = [];
    this.rules[7].opcodes[0] = {
        type: 6,
        string: [
            13,
            10
        ]
    }; // TBS
    /* LF */ this.rules[8].opcodes = [];
    this.rules[8].opcodes[0] = {
        type: 6,
        string: [
            10
        ]
    }; // TBS
    /* CR */ this.rules[9].opcodes = [];
    this.rules[9].opcodes[0] = {
        type: 6,
        string: [
            13
        ]
    }; // TBS
    // The `toString()` function will display the original grammar file(s) that produced these opcodes.
    this.toString = function toString() {
        var str = "";
        str += "file = *line [last-line]\n";
        str += "line = line-text end\n";
        str += "line-text = *(valid/invalid)\n";
        str += "last-line = 1*(valid/invalid)\n";
        str += "valid = %d32-126 / %d9\n";
        str += "invalid = %d0-8 / %d11-12 /%d14-31 / %x7f-ffffffff\n";
        str += "end = CRLF / LF / CR\n";
        str += "CRLF = %d13.10\n";
        str += "LF = %d10\n";
        str += "CR = %d13\n";
        return str;
    };
};

});

parcelRegister("h3tFG", function(module, exports) {

$parcel$export(module.exports, "callbacks", function () { return $c6a9bb9574ea5cc7$export$b89c5c1b934d8237; }, function (v) { return $c6a9bb9574ea5cc7$export$b89c5c1b934d8237 = v; });
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // These are the AST translation callback functions used by the scanner
// to analyze the characters and lines.
var $c6a9bb9574ea5cc7$export$b89c5c1b934d8237;

var $dPnGd = parcelRequire("dPnGd");

var $iKY5M = parcelRequire("iKY5M");
function $c6a9bb9574ea5cc7$var$semLine(state, chars, phraseIndex, phraseCount, data) {
    if (state === $dPnGd.SEM_PRE) {
        data.endLength = 0;
        data.textLength = 0;
        data.invalidCount = 0;
    } else data.lines.push({
        lineNo: data.lines.length,
        beginChar: phraseIndex,
        length: phraseCount,
        textLength: data.textLength,
        endType: data.endType,
        invalidChars: data.invalidCount
    });
    return $dPnGd.SEM_OK;
}
function $c6a9bb9574ea5cc7$var$semLineText(state, chars, phraseIndex, phraseCount, data) {
    if (state === $dPnGd.SEM_PRE) data.textLength = phraseCount;
    return $dPnGd.SEM_OK;
}
function $c6a9bb9574ea5cc7$var$semLastLine(state, chars, phraseIndex, phraseCount, data) {
    if (state === $dPnGd.SEM_PRE) {
        data.endLength = 0;
        data.textLength = 0;
        data.invalidCount = 0;
    } else if (data.strict) {
        data.lines.push({
            lineNo: data.lines.length,
            beginChar: phraseIndex,
            length: phraseCount,
            textLength: phraseCount,
            endType: "none",
            invalidChars: data.invalidCount
        });
        data.errors.push({
            line: data.lineNo,
            char: phraseIndex + phraseCount,
            msg: "no line end on last line - strict ABNF specifies CRLF(\\r\\n, \\x0D\\x0A)"
        });
    } else {
        /* add a line ender */ chars.push(10);
        data.lines.push({
            lineNo: data.lines.length,
            beginChar: phraseIndex,
            length: phraseCount + 1,
            textLength: phraseCount,
            endType: "LF",
            invalidChars: data.invalidCount
        });
    }
    return $dPnGd.SEM_OK;
}
function $c6a9bb9574ea5cc7$var$semInvalid(state, chars, phraseIndex, phraseCount, data) {
    if (state === $dPnGd.SEM_PRE) data.errors.push({
        line: data.lineNo,
        char: phraseIndex,
        msg: "invalid character found '\\x".concat($iKY5M.charToHex(chars[phraseIndex]), "'")
    });
    return $dPnGd.SEM_OK;
}
function $c6a9bb9574ea5cc7$var$semEnd(state, chars, phraseIndex, phraseCount, data) {
    if (state === $dPnGd.SEM_POST) data.lineNo += 1;
    return $dPnGd.SEM_OK;
}
function $c6a9bb9574ea5cc7$var$semLF(state, chars, phraseIndex, phraseCount, data) {
    if (state === $dPnGd.SEM_PRE) {
        data.endType = "LF";
        if (data.strict) data.errors.push({
            line: data.lineNo,
            char: phraseIndex,
            msg: "line end character LF(\\n, \\x0A) - strict ABNF specifies CRLF(\\r\\n, \\x0D\\x0A)"
        });
    }
    return $dPnGd.SEM_OK;
}
function $c6a9bb9574ea5cc7$var$semCR(state, chars, phraseIndex, phraseCount, data) {
    if (state === $dPnGd.SEM_PRE) {
        data.endType = "CR";
        if (data.strict) data.errors.push({
            line: data.lineNo,
            char: phraseIndex,
            msg: "line end character CR(\\r, \\x0D) - strict ABNF specifies CRLF(\\r\\n, \\x0D\\x0A)"
        });
    }
    return $dPnGd.SEM_OK;
}
function $c6a9bb9574ea5cc7$var$semCRLF(state, chars, phraseIndex, phraseCount, data) {
    if (state === $dPnGd.SEM_PRE) data.endType = "CRLF";
    return $dPnGd.SEM_OK;
}
var $c6a9bb9574ea5cc7$var$callbacks = [];
$c6a9bb9574ea5cc7$var$callbacks.line = $c6a9bb9574ea5cc7$var$semLine;
$c6a9bb9574ea5cc7$var$callbacks["line-text"] = $c6a9bb9574ea5cc7$var$semLineText;
$c6a9bb9574ea5cc7$var$callbacks["last-line"] = $c6a9bb9574ea5cc7$var$semLastLine;
$c6a9bb9574ea5cc7$var$callbacks.invalid = $c6a9bb9574ea5cc7$var$semInvalid;
$c6a9bb9574ea5cc7$var$callbacks.end = $c6a9bb9574ea5cc7$var$semEnd;
$c6a9bb9574ea5cc7$var$callbacks.lf = $c6a9bb9574ea5cc7$var$semLF;
$c6a9bb9574ea5cc7$var$callbacks.cr = $c6a9bb9574ea5cc7$var$semCR;
$c6a9bb9574ea5cc7$var$callbacks.crlf = $c6a9bb9574ea5cc7$var$semCRLF;
$c6a9bb9574ea5cc7$export$b89c5c1b934d8237 = $c6a9bb9574ea5cc7$var$callbacks;

});


parcelRegister("gC7CD", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module converts an input SABNF grammar text file into a
// grammar object that can be used with `apg-lib` in an application parser.
// **apg** is, in fact itself, an ABNF parser that generates an SABNF parser.
// It is based on the grammar<br>
// `./dist/abnf-for-sabnf-grammar.bnf`.<br>
// In its syntax phase, **apg** analyzes the user's input SABNF grammar for correct syntax, generating an AST as it goes.
// In its semantic phase, **apg** translates the AST to generate the parser for the input grammar.




module.exports = function exportParser() {
    var thisFileName = "parser: ";
    var ApgLib = (parcelRequire("gCVMI"));
    var id = ApgLib.ids;
    var syn = new (parcelRequire("erbS6"))();
    var sem = new (parcelRequire("7ya1D"))();
    var sabnfGrammar = new (parcelRequire("Rbd5i"))();
    // eslint-disable-next-line new-cap
    var parser = new ApgLib.parser();
    // eslint-disable-next-line new-cap
    parser.ast = new ApgLib.ast();
    parser.callbacks = syn.callbacks;
    parser.ast.callbacks = sem.callbacks;
    /* find the line containing the given character index */ var findLine = function findLine(lines, charIndex, charLength) {
        if (charIndex < 0 || charIndex >= charLength) /* return error if out of range */ return -1;
        for(var i = 0; i < lines.length; i += 1){
            if (charIndex >= lines[i].beginChar && charIndex < lines[i].beginChar + lines[i].length) return i;
        }
        /* should never reach here */ return -1;
    };
    var translateIndex = function translateIndex(map, index) {
        var ret = -1;
        if (index < map.length) {
            for(var i = index; i < map.length; i += 1)if (map[i] !== null) {
                ret = map[i];
                break;
            }
        }
        return ret;
    };
    /* helper function when removing redundant opcodes */ var reduceOpcodes = function reduceOpcodes(rules) {
        rules.forEach(function(rule) {
            var opcodes = [];
            var map = [];
            var reducedIndex = 0;
            rule.opcodes.forEach(function(op) {
                if (op.type === id.ALT && op.children.length === 1) map.push(null);
                else if (op.type === id.CAT && op.children.length === 1) map.push(null);
                else if (op.type === id.REP && op.min === 1 && op.max === 1) map.push(null);
                else {
                    map.push(reducedIndex);
                    opcodes.push(op);
                    reducedIndex += 1;
                }
            });
            map.push(reducedIndex);
            /* translate original opcode indexes to the reduced set. */ opcodes.forEach(function(op) {
                if (op.type === id.ALT || op.type === id.CAT) for(var i = 0; i < op.children.length; i += 1)op.children[i] = translateIndex(map, op.children[i]);
            });
            rule.opcodes = opcodes;
        });
    };
    /* Parse the grammar - the syntax phase. */ /* SABNF grammar syntax errors are caught and reported here. */ this.syntax = function syntax(chars, lines, errors, strict, trace) {
        if (trace) {
            if (trace.traceObject !== "traceObject") throw new TypeError("".concat(thisFileName, "trace argument is not a trace object"));
            parser.trace = trace;
        }
        var data = {};
        data.errors = errors;
        data.strict = !!strict;
        data.lines = lines;
        data.findLine = findLine;
        data.charsLength = chars.length;
        data.ruleCount = 0;
        var result = parser.parse(sabnfGrammar, "file", chars, data);
        if (!result.success) errors.push({
            line: 0,
            char: 0,
            msg: "syntax analysis of input grammar failed"
        });
    };
    /* Parse the grammar - the semantic phase, translates the AST. */ /* SABNF grammar syntax errors are caught and reported here. */ this.semantic = function semantic(chars, lines, errors) {
        var data = {};
        data.errors = errors;
        data.lines = lines;
        data.findLine = findLine;
        data.charsLength = chars.length;
        parser.ast.translate(data);
        if (errors.length) return null;
        /* Remove unneeded operators. */ /* ALT operators with a single alternate */ /* CAT operators with a single phrase to concatenate */ /* REP(1,1) operators (`1*1RuleName` or `1RuleName` is the same as just `RuleName`.) */ reduceOpcodes(data.rules);
        return {
            rules: data.rules,
            udts: data.udts,
            lineMap: data.rulesLineMap
        };
    };
    // Generate a grammar constructor function.
    // An object instantiated from this constructor is used with the `apg-lib` `parser()` function.
    this.generateSource = function generateSource(chars, lines, rules, udts, name) {
        var source = "";
        var i;
        var bkrname;
        var bkrlower;
        var opcodeCount = 0;
        var charCodeMin = Infinity;
        var charCodeMax = 0;
        var ruleNames = [];
        var udtNames = [];
        var alt = 0;
        var cat = 0;
        var rnm = 0;
        var udt = 0;
        var rep = 0;
        var and = 0;
        var not = 0;
        var tls = 0;
        var tbs = 0;
        var trg = 0;
        var bkr = 0;
        var bka = 0;
        var bkn = 0;
        var abg = 0;
        var aen = 0;
        rules.forEach(function(rule) {
            ruleNames.push(rule.lower);
            opcodeCount += rule.opcodes.length;
            rule.opcodes.forEach(function(op) {
                switch(op.type){
                    case id.ALT:
                        alt += 1;
                        break;
                    case id.CAT:
                        cat += 1;
                        break;
                    case id.RNM:
                        rnm += 1;
                        break;
                    case id.UDT:
                        udt += 1;
                        break;
                    case id.REP:
                        rep += 1;
                        break;
                    case id.AND:
                        and += 1;
                        break;
                    case id.NOT:
                        not += 1;
                        break;
                    case id.BKA:
                        bka += 1;
                        break;
                    case id.BKN:
                        bkn += 1;
                        break;
                    case id.BKR:
                        bkr += 1;
                        break;
                    case id.ABG:
                        abg += 1;
                        break;
                    case id.AEN:
                        aen += 1;
                        break;
                    case id.TLS:
                        tls += 1;
                        for(i = 0; i < op.string.length; i += 1){
                            if (op.string[i] < charCodeMin) charCodeMin = op.string[i];
                            if (op.string[i] > charCodeMax) charCodeMax = op.string[i];
                        }
                        break;
                    case id.TBS:
                        tbs += 1;
                        for(i = 0; i < op.string.length; i += 1){
                            if (op.string[i] < charCodeMin) charCodeMin = op.string[i];
                            if (op.string[i] > charCodeMax) charCodeMax = op.string[i];
                        }
                        break;
                    case id.TRG:
                        trg += 1;
                        if (op.min < charCodeMin) charCodeMin = op.min;
                        if (op.max > charCodeMax) charCodeMax = op.max;
                        break;
                    default:
                        throw new Error("generateSource: unrecognized opcode");
                }
            });
        });
        ruleNames.sort();
        if (udts.length > 0) {
            udts.forEach(function(udtFunc) {
                udtNames.push(udtFunc.lower);
            });
            udtNames.sort();
        }
        var funcname = "module.exports";
        if (name && typeof name === "string") funcname = "let ".concat(name);
        source += "// copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved<br>\n";
        source += "//   license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)<br>\n";
        source += "//\n";
        source += "// Generated by apg-js, Version 4.0.0 [apg-js](https://github.com/ldthomas/apg-js)\n";
        source += "".concat(funcname, " = function grammar(){\n");
        source += "  // ```\n";
        source += "  // SUMMARY\n";
        source += "  //      rules = ".concat(rules.length, "\n");
        source += "  //       udts = ".concat(udts.length, "\n");
        source += "  //    opcodes = ".concat(opcodeCount, "\n");
        source += "  //        ---   ABNF original opcodes\n";
        source += "  //        ALT = ".concat(alt, "\n");
        source += "  //        CAT = ".concat(cat, "\n");
        source += "  //        REP = ".concat(rep, "\n");
        source += "  //        RNM = ".concat(rnm, "\n");
        source += "  //        TLS = ".concat(tls, "\n");
        source += "  //        TBS = ".concat(tbs, "\n");
        source += "  //        TRG = ".concat(trg, "\n");
        source += "  //        ---   SABNF superset opcodes\n";
        source += "  //        UDT = ".concat(udt, "\n");
        source += "  //        AND = ".concat(and, "\n");
        source += "  //        NOT = ".concat(not, "\n");
        source += "  //        BKA = ".concat(bka, "\n");
        source += "  //        BKN = ".concat(bkn, "\n");
        source += "  //        BKR = ".concat(bkr, "\n");
        source += "  //        ABG = ".concat(abg, "\n");
        source += "  //        AEN = ".concat(aen, "\n");
        source += "  // characters = [";
        if (tls + tbs + trg === 0) source += " none defined ]";
        else source += "".concat(charCodeMin, " - ").concat(charCodeMax, "]");
        if (udt > 0) source += " + user defined";
        source += "\n";
        source += "  // ```\n";
        source += "  /* OBJECT IDENTIFIER (for internal parser use) */\n";
        source += "  this.grammarObject = 'grammarObject';\n";
        source += "\n";
        source += "  /* RULES */\n";
        source += "  this.rules = [];\n";
        rules.forEach(function(rule, ii) {
            var thisRule = "  this.rules[";
            thisRule += ii;
            thisRule += "] = {name: '";
            thisRule += rule.name;
            thisRule += "', lower: '";
            thisRule += rule.lower;
            thisRule += "', index: ";
            thisRule += rule.index;
            thisRule += ", isBkr: ";
            thisRule += rule.isBkr;
            thisRule += "};\n";
            source += thisRule;
        });
        source += "\n";
        source += "  /* UDTS */\n";
        source += "  this.udts = [];\n";
        if (udts.length > 0) udts.forEach(function(udtFunc, ii) {
            var thisUdt = "  this.udts[";
            thisUdt += ii;
            thisUdt += "] = {name: '";
            thisUdt += udtFunc.name;
            thisUdt += "', lower: '";
            thisUdt += udtFunc.lower;
            thisUdt += "', index: ";
            thisUdt += udtFunc.index;
            thisUdt += ", empty: ";
            thisUdt += udtFunc.empty;
            thisUdt += ", isBkr: ";
            thisUdt += udtFunc.isBkr;
            thisUdt += "};\n";
            source += thisUdt;
        });
        source += "\n";
        source += "  /* OPCODES */\n";
        rules.forEach(function(rule, ruleIndex) {
            if (ruleIndex > 0) source += "\n";
            source += "  /* ".concat(rule.name, " */\n");
            source += "  this.rules[".concat(ruleIndex, "].opcodes = [];\n");
            rule.opcodes.forEach(function(op, opIndex) {
                var prefix;
                switch(op.type){
                    case id.ALT:
                        source += "  this.rules[".concat(ruleIndex, "].opcodes[").concat(opIndex, "] = {type: ").concat(op.type, ", children: [").concat(op.children.toString(), "]};// ALT\n");
                        break;
                    case id.CAT:
                        source += "  this.rules[".concat(ruleIndex, "].opcodes[").concat(opIndex, "] = {type: ").concat(op.type, ", children: [").concat(op.children.toString(), "]};// CAT\n");
                        break;
                    case id.RNM:
                        source += "  this.rules[".concat(ruleIndex, "].opcodes[").concat(opIndex, "] = {type: ").concat(op.type, ", index: ").concat(op.index, "};// RNM(").concat(rules[op.index].name, ")\n");
                        break;
                    case id.BKR:
                        if (op.index >= rules.length) {
                            bkrname = udts[op.index - rules.length].name;
                            bkrlower = udts[op.index - rules.length].lower;
                        } else {
                            bkrname = rules[op.index].name;
                            bkrlower = rules[op.index].lower;
                        }
                        prefix = "%i";
                        if (op.bkrCase === id.BKR_MODE_CS) prefix = "%s";
                        if (op.bkrMode === id.BKR_MODE_UM) prefix += "%u";
                        else prefix += "%p";
                        bkrname = prefix + bkrname;
                        source += "  this.rules[".concat(ruleIndex, "].opcodes[").concat(opIndex, "] = {type: ").concat(op.type, ", index: ").concat(op.index, ", lower: '").concat(bkrlower, "'") + ", bkrCase: ".concat(op.bkrCase, ", bkrMode: ").concat(op.bkrMode, "};// BKR(\\").concat(bkrname, ")\n");
                        break;
                    case id.UDT:
                        source += "  this.rules[".concat(ruleIndex, "].opcodes[").concat(opIndex, "] = {type: ").concat(op.type, ", empty: ").concat(op.empty, ", index: ").concat(op.index, "};// UDT(").concat(udts[op.index].name, ")\n");
                        break;
                    case id.REP:
                        source += "  this.rules[".concat(ruleIndex, "].opcodes[").concat(opIndex, "] = {type: ").concat(op.type, ", min: ").concat(op.min, ", max: ").concat(op.max, "};// REP\n");
                        break;
                    case id.AND:
                        source += "  this.rules[".concat(ruleIndex, "].opcodes[").concat(opIndex, "] = {type: ").concat(op.type, "};// AND\n");
                        break;
                    case id.NOT:
                        source += "  this.rules[".concat(ruleIndex, "].opcodes[").concat(opIndex, "] = {type: ").concat(op.type, "};// NOT\n");
                        break;
                    case id.ABG:
                        source += "  this.rules[".concat(ruleIndex, "].opcodes[").concat(opIndex, "] = {type: ").concat(op.type, "};// ABG(%^)\n");
                        break;
                    case id.AEN:
                        source += "  this.rules[".concat(ruleIndex, "].opcodes[").concat(opIndex, "] = {type: ").concat(op.type, "};// AEN(%$)\n");
                        break;
                    case id.BKA:
                        source += "  this.rules[".concat(ruleIndex, "].opcodes[").concat(opIndex, "] = {type: ").concat(op.type, "};// BKA\n");
                        break;
                    case id.BKN:
                        source += "  this.rules[".concat(ruleIndex, "].opcodes[").concat(opIndex, "] = {type: ").concat(op.type, "};// BKN\n");
                        break;
                    case id.TLS:
                        source += "  this.rules[".concat(ruleIndex, "].opcodes[").concat(opIndex, "] = {type: ").concat(op.type, ", string: [").concat(op.string.toString(), "]};// TLS\n");
                        break;
                    case id.TBS:
                        source += "  this.rules[".concat(ruleIndex, "].opcodes[").concat(opIndex, "] = {type: ").concat(op.type, ", string: [").concat(op.string.toString(), "]};// TBS\n");
                        break;
                    case id.TRG:
                        source += "  this.rules[".concat(ruleIndex, "].opcodes[").concat(opIndex, "] = {type: ").concat(op.type, ", min: ").concat(op.min, ", max: ").concat(op.max, "};// TRG\n");
                        break;
                    default:
                        throw new Error("parser.js: ~143: unrecognized opcode");
                }
            });
        });
        source += "\n";
        source += "  // The `toString()` function will display the original grammar file(s) that produced these opcodes.\n";
        source += "  this.toString = function toString(){\n";
        source += '    let str = "";\n';
        var str;
        lines.forEach(function(line) {
            var end = line.beginChar + line.length;
            str = "";
            source += '    str += "';
            for(var ii = line.beginChar; ii < end; ii += 1){
                switch(chars[ii]){
                    case 9:
                        str = " ";
                        break;
                    case 10:
                        str = "\\n";
                        break;
                    case 13:
                        str = "\\r";
                        break;
                    case 34:
                        str = '\\"';
                        break;
                    case 92:
                        str = "\\\\";
                        break;
                    default:
                        str = String.fromCharCode(chars[ii]);
                        break;
                }
                source += str;
            }
            source += '";\n';
        });
        source += "    return str;\n";
        source += "  }\n";
        source += "}\n";
        return source;
    };
    // Generate a grammar file object.
    // Returns the same object as instantiating the constructor function returned by<br>
    // `this.generateSource()`.<br>
    this.generateObject = function generateObject(stringArg, rules, udts) {
        var obj = {};
        var ruleNames = [];
        var udtNames = [];
        var string = stringArg.slice(0);
        obj.grammarObject = "grammarObject";
        rules.forEach(function(rule) {
            ruleNames.push(rule.lower);
        });
        ruleNames.sort();
        if (udts.length > 0) {
            udts.forEach(function(udtFunc) {
                udtNames.push(udtFunc.lower);
            });
            udtNames.sort();
        }
        obj.callbacks = [];
        ruleNames.forEach(function(name) {
            obj.callbacks[name] = false;
        });
        if (udts.length > 0) udtNames.forEach(function(name) {
            obj.callbacks[name] = false;
        });
        obj.rules = rules;
        obj.udts = udts;
        obj.toString = function toStringFunc() {
            return string;
        };
        return obj;
    };
};

});
parcelRegister("erbS6", function(module, exports) {
/* eslint-disable func-names */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module has all of the callback functions for the syntax phase of the generation.
// See:<br>
// `./dist/abnf-for-sabnf-grammar.bnf`<br>
// for the grammar file these callback functions are based on.

module.exports = function exfn() {
    var thisFileName = "syntax-callbacks.js: ";
    var apglib = (parcelRequire("gCVMI"));
    var id = apglib.ids;
    var topAlt;
    /* syntax, RNM, callback functions */ var synFile = function synFile(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                data.altStack = [];
                data.repCount = 0;
                break;
            case id.EMPTY:
                data.errors.push({
                    line: 0,
                    char: 0,
                    msg: "grammar file is empty"
                });
                break;
            case id.MATCH:
                if (data.ruleCount === 0) data.errors.push({
                    line: 0,
                    char: 0,
                    msg: "no rules defined"
                });
                break;
            case id.NOMATCH:
                throw new Error("".concat(thisFileName, "synFile: grammar file NOMATCH: design error: should never happen."));
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    // eslint-disable-next-line func-names
    var synRule = function synRule(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                data.altStack.length = 0;
                topAlt = {
                    groupOpen: null,
                    groupError: false,
                    optionOpen: null,
                    optionError: false,
                    tlsOpen: null,
                    clsOpen: null,
                    prosValOpen: null,
                    basicError: false
                };
                data.altStack.push(topAlt);
                break;
            case id.EMPTY:
                throw new Error("".concat(thisFileName, "synRule: EMPTY: rule cannot be empty"));
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.ruleCount += 1;
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synRuleError = function synRuleError(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Unrecognized SABNF line. Invalid rule, comment or blank line."
                });
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synRuleNameError = function synRuleNameError(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Rule names must be alphanum and begin with alphabetic character."
                });
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synDefinedAsError = function synDefinedAsError(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Expected '=' or '=/'. Not found."
                });
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synAndOp = function synAndOp(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "AND operator(&) found - strict ABNF specified."
                });
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synNotOp = function synNotOp(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "NOT operator(!) found - strict ABNF specified."
                });
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synBkaOp = function synBkaOp(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Positive look-behind operator(&&) found - strict ABNF specified."
                });
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synBknOp = function synBknOp(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Negative look-behind operator(!!) found - strict ABNF specified."
                });
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synAbgOp = function synAbgOp(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Beginning of string anchor(%^) found - strict ABNF specified."
                });
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synAenOp = function synAenOp(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "End of string anchor(%$) found - strict ABNF specified."
                });
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synBkrOp = function synBkrOp(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) {
                    var name = apglib.utils.charsToString(chars, phraseIndex, result.phraseLength);
                    data.errors.push({
                        line: data.findLine(data.lines, phraseIndex, data.charsLength),
                        char: phraseIndex,
                        msg: "Back reference operator(".concat(name, ") found - strict ABNF specified.")
                    });
                }
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synUdtOp = function synUdtOp(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) {
                    var name = apglib.utils.charsToString(chars, phraseIndex, result.phraseLength);
                    data.errors.push({
                        line: data.findLine(data.lines, phraseIndex, data.charsLength),
                        char: phraseIndex,
                        msg: "UDT operator found(".concat(name, ") - strict ABNF specified.")
                    });
                }
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synTlsOpen = function synTlsOpen(result, chars, phraseIndex) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                topAlt.tlsOpen = phraseIndex;
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synTlsString = function synTlsString(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                data.stringTabChar = false;
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.stringTabChar !== false) data.errors.push({
                    line: data.findLine(data.lines, data.stringTabChar),
                    char: data.stringTabChar,
                    msg: "Tab character (\\t, x09) not allowed in literal string (see 'quoted-string' definition, RFC 7405.)"
                });
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synStringTab = function synStringTab(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.stringTabChar = phraseIndex;
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synTlsClose = function synTlsClose(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.tlsOpen),
                    char: topAlt.tlsOpen,
                    msg: 'Case-insensitive literal string("...") opened but not closed.'
                });
                topAlt.basicError = true;
                topAlt.tlsOpen = null;
                break;
            case id.MATCH:
                topAlt.tlsOpen = null;
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synClsOpen = function synClsOpen(result, chars, phraseIndex) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                topAlt.clsOpen = phraseIndex;
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synClsString = function synClsString(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                data.stringTabChar = false;
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.stringTabChar !== false) data.errors.push({
                    line: data.findLine(data.lines, data.stringTabChar),
                    char: data.stringTabChar,
                    msg: "Tab character (\\t, x09) not allowed in literal string."
                });
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synClsClose = function synClsClose(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.clsOpen),
                    char: topAlt.clsOpen,
                    msg: "Case-sensitive literal string('...') opened but not closed."
                });
                topAlt.clsOpen = null;
                topAlt.basicError = true;
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, topAlt.clsOpen),
                    char: topAlt.clsOpen,
                    msg: "Case-sensitive string operator('...') found - strict ABNF specified."
                });
                topAlt.clsOpen = null;
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synProsValOpen = function synProsValOpen(result, chars, phraseIndex) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                topAlt.prosValOpen = phraseIndex;
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synProsValString = function synProsValString(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                data.stringTabChar = false;
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.stringTabChar !== false) data.errors.push({
                    line: data.findLine(data.lines, data.stringTabChar),
                    char: data.stringTabChar,
                    msg: "Tab character (\\t, x09) not allowed in prose value string."
                });
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synProsValClose = function synProsValClose(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.prosValOpen),
                    char: topAlt.prosValOpen,
                    msg: "Prose value operator(<...>) opened but not closed."
                });
                topAlt.basicError = true;
                topAlt.prosValOpen = null;
                break;
            case id.MATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.prosValOpen),
                    char: topAlt.prosValOpen,
                    msg: "Prose value operator(<...>) found. The ABNF syntax is valid, but a parser cannot be generated from this grammar."
                });
                topAlt.prosValOpen = null;
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synGroupOpen = function synGroupOpen(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                topAlt = {
                    groupOpen: phraseIndex,
                    groupError: false,
                    optionOpen: null,
                    optionError: false,
                    tlsOpen: null,
                    clsOpen: null,
                    prosValOpen: null,
                    basicError: false
                };
                data.altStack.push(topAlt);
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synGroupClose = function synGroupClose(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.groupOpen),
                    char: topAlt.groupOpen,
                    msg: 'Group "(...)" opened but not closed.'
                });
                topAlt = data.altStack.pop();
                topAlt.groupError = true;
                break;
            case id.MATCH:
                topAlt = data.altStack.pop();
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synOptionOpen = function synOptionOpen(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                topAlt = {
                    groupOpen: null,
                    groupError: false,
                    optionOpen: phraseIndex,
                    optionError: false,
                    tlsOpen: null,
                    clsOpen: null,
                    prosValOpen: null,
                    basicError: false
                };
                data.altStack.push(topAlt);
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synOptionClose = function synOptionClose(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.optionOpen),
                    char: topAlt.optionOpen,
                    msg: 'Option "[...]" opened but not closed.'
                });
                topAlt = data.altStack.pop();
                topAlt.optionError = true;
                break;
            case id.MATCH:
                topAlt = data.altStack.pop();
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synBasicElementError = function synBasicElementError(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (topAlt.basicError === false) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Unrecognized SABNF element."
                });
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synLineEnd = function synLineEnd(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (result.phraseLength === 1 && data.strict) {
                    var end = chars[phraseIndex] === 13 ? "CR" : "LF";
                    data.errors.push({
                        line: data.findLine(data.lines, phraseIndex, data.charsLength),
                        char: phraseIndex,
                        msg: "Line end '".concat(end, "' found - strict ABNF specified, only CRLF allowed.")
                    });
                }
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synLineEndError = function synLineEndError(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Unrecognized grammar element or characters."
                });
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    var synRepetition = function synRepetition(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.repCount += 1;
                break;
            case id.MATCH:
                data.repCount += 1;
                break;
            default:
                throw new Error("".concat(thisFileName, "synFile: unrecognized case."));
        }
    };
    // Define the list of callback functions.
    this.callbacks = [];
    this.callbacks.andop = synAndOp;
    this.callbacks.basicelementerr = synBasicElementError;
    this.callbacks.clsclose = synClsClose;
    this.callbacks.clsopen = synClsOpen;
    this.callbacks.clsstring = synClsString;
    this.callbacks.definedaserror = synDefinedAsError;
    this.callbacks.file = synFile;
    this.callbacks.groupclose = synGroupClose;
    this.callbacks.groupopen = synGroupOpen;
    this.callbacks.lineenderror = synLineEndError;
    this.callbacks.lineend = synLineEnd;
    this.callbacks.notop = synNotOp;
    this.callbacks.optionclose = synOptionClose;
    this.callbacks.optionopen = synOptionOpen;
    this.callbacks.prosvalclose = synProsValClose;
    this.callbacks.prosvalopen = synProsValOpen;
    this.callbacks.prosvalstring = synProsValString;
    this.callbacks.repetition = synRepetition;
    this.callbacks.rule = synRule;
    this.callbacks.ruleerror = synRuleError;
    this.callbacks.rulenameerror = synRuleNameError;
    this.callbacks.stringtab = synStringTab;
    this.callbacks.tlsclose = synTlsClose;
    this.callbacks.tlsopen = synTlsOpen;
    this.callbacks.tlsstring = synTlsString;
    this.callbacks.udtop = synUdtOp;
    this.callbacks.bkaop = synBkaOp;
    this.callbacks.bknop = synBknOp;
    this.callbacks.bkrop = synBkrOp;
    this.callbacks.abgop = synAbgOp;
    this.callbacks.aenop = synAenOp;
};

});

parcelRegister("7ya1D", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module has all of the AST translation callback functions for the semantic analysis
// phase of the generator.
// See:<br>
// `./dist/abnf-for-sabnf-grammar.bnf`<br>
// for the grammar file these callback functions are based on.

module.exports = function exfn() {
    var apglib = (parcelRequire("gCVMI"));
    var id = apglib.ids;
    /* Some helper functions. */ var NameList = function NameList() {
        this.names = [];
        /* Adds a new rule name object to the list. Returns -1 if the name already exists. */ /* Returns the added name object if the name does not already exist. */ this.add = function add(name) {
            var ret = -1;
            var find = this.get(name);
            if (find === -1) {
                ret = {
                    name: name,
                    lower: name.toLowerCase(),
                    index: this.names.length
                };
                this.names.push(ret);
            }
            return ret;
        };
        /* Brute-force look up. */ this.get = function get(name) {
            var ret = -1;
            var lower = name.toLowerCase();
            for(var i = 0; i < this.names.length; i += 1)if (this.names[i].lower === lower) {
                ret = this.names[i];
                break;
            }
            return ret;
        };
    };
    /* converts text decimal numbers from, e.g. %d99, to an integer */ var decnum = function decnum(chars, beg, len) {
        var num = 0;
        for(var i = beg; i < beg + len; i += 1)num = 10 * num + chars[i] - 48;
        return num;
    };
    /* converts text binary numbers from, e.g. %b10, to an integer */ var binnum = function binnum(chars, beg, len) {
        var num = 0;
        for(var i = beg; i < beg + len; i += 1)num = 2 * num + chars[i] - 48;
        return num;
    };
    /* converts text hexadecimal numbers from, e.g. %xff, to an integer */ var hexnum = function hexnum(chars, beg, len) {
        var num = 0;
        for(var i = beg; i < beg + len; i += 1){
            var digit = chars[i];
            if (digit >= 48 && digit <= 57) digit -= 48;
            else if (digit >= 65 && digit <= 70) digit -= 55;
            else if (digit >= 97 && digit <= 102) digit -= 87;
            else throw new Error("hexnum out of range");
            num = 16 * num + digit;
        }
        return num;
    };
    // This is the prototype for all semantic analysis callback functions.
    // ````
    // state - the translator state
    //   id.SEM_PRE for downward (pre-branch) traversal of the AST
    //   id.SEM_POST for upward (post branch) traversal of the AST
    // chars - the array of character codes for the input string
    // phraseIndex - index into the chars array to the first
    //               character of the phrase
    // phraseCount - the number of characters in the phrase
    // data - user-defined data passed to the translator
    //        for use by the callback functions.
    // @return id.SEM_OK, normal return.
    //         id.SEM_SKIP in state id.SEM_PRE will
    //         skip the branch below.
    //         Any thing else is an error which will
    //         stop the translation.
    // ````
    /*
  function semCallbackPrototype(state, chars, phraseIndex, phraseCount, data) {
    let ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
    } else if (state === id.SEM_POST) {
    }
    return ret;
  }
  */ // The AST callback functions.
    function semFile(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.ruleNames = new NameList();
            data.udtNames = new NameList();
            data.rules = [];
            data.udts = [];
            data.rulesLineMap = [];
            data.opcodes = [];
            data.altStack = [];
            data.topStack = null;
            data.topRule = null;
        } else if (state === id.SEM_POST) {
            /* validate RNM rule names and set opcode rule index */ var nameObj;
            data.rules.forEach(function(rule) {
                rule.isBkr = false;
                rule.opcodes.forEach(function(op) {
                    if (op.type === id.RNM) {
                        nameObj = data.ruleNames.get(op.index.name);
                        if (nameObj === -1) {
                            data.errors.push({
                                line: data.findLine(data.lines, op.index.phraseIndex, data.charsLength),
                                char: op.index.phraseIndex,
                                msg: "Rule name '".concat(op.index.name, "' used but not defined.")
                            });
                            op.index = -1;
                        } else op.index = nameObj.index;
                    }
                });
            });
            /* validate BKR rule names and set opcode rule index */ data.udts.forEach(function(udt) {
                udt.isBkr = false;
            });
            data.rules.forEach(function(rule) {
                rule.opcodes.forEach(function(op) {
                    if (op.type === id.BKR) {
                        rule.hasBkr = true;
                        nameObj = data.ruleNames.get(op.index.name);
                        if (nameObj !== -1) {
                            data.rules[nameObj.index].isBkr = true;
                            op.index = nameObj.index;
                        } else {
                            nameObj = data.udtNames.get(op.index.name);
                            if (nameObj !== -1) {
                                data.udts[nameObj.index].isBkr = true;
                                op.index = data.rules.length + nameObj.index;
                            } else {
                                data.errors.push({
                                    line: data.findLine(data.lines, op.index.phraseIndex, data.charsLength),
                                    char: op.index.phraseIndex,
                                    msg: "Back reference name '".concat(op.index.name, "' refers to undefined rule or unamed UDT.")
                                });
                                op.index = -1;
                            }
                        }
                    }
                });
            });
        }
        return ret;
    }
    function semRule(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.altStack.length = 0;
            data.topStack = null;
            data.rulesLineMap.push({
                line: data.findLine(data.lines, phraseIndex, data.charsLength),
                char: phraseIndex
            });
        }
        return ret;
    }
    function semRuleLookup(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.ruleName = "";
            data.definedas = "";
        } else if (state === id.SEM_POST) {
            var ruleName;
            if (data.definedas === "=") {
                ruleName = data.ruleNames.add(data.ruleName);
                if (ruleName === -1) {
                    data.definedas = null;
                    data.errors.push({
                        line: data.findLine(data.lines, phraseIndex, data.charsLength),
                        char: phraseIndex,
                        msg: "Rule name '".concat(data.ruleName, "' previously defined.")
                    });
                } else {
                    /* start a new rule */ data.topRule = {
                        name: ruleName.name,
                        lower: ruleName.lower,
                        opcodes: [],
                        index: ruleName.index
                    };
                    data.rules.push(data.topRule);
                    data.opcodes = data.topRule.opcodes;
                }
            } else {
                ruleName = data.ruleNames.get(data.ruleName);
                if (ruleName === -1) {
                    data.definedas = null;
                    data.errors.push({
                        line: data.findLine(data.lines, phraseIndex, data.charsLength),
                        char: phraseIndex,
                        msg: "Rule name '".concat(data.ruleName, "' for incremental alternate not previously defined.")
                    });
                } else {
                    data.topRule = data.rules[ruleName.index];
                    data.opcodes = data.topRule.opcodes;
                }
            }
        }
        return ret;
    }
    function semAlternation(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            var TRUE = true;
            while(TRUE){
                if (data.definedas === null) {
                    /* rule error - skip opcode generation */ ret = id.SEM_SKIP;
                    break;
                }
                if (data.topStack === null) {
                    /* top-level ALT */ if (data.definedas === "=") {
                        /* "=" new rule */ data.topStack = {
                            alt: {
                                type: id.ALT,
                                children: []
                            },
                            cat: null
                        };
                        data.altStack.push(data.topStack);
                        data.opcodes.push(data.topStack.alt);
                        break;
                    }
                    /* "=/" incremental alternate */ data.topStack = {
                        alt: data.opcodes[0],
                        cat: null
                    };
                    data.altStack.push(data.topStack);
                    break;
                }
                /* lower-level ALT */ data.topStack = {
                    alt: {
                        type: id.ALT,
                        children: []
                    },
                    cat: null
                };
                data.altStack.push(data.topStack);
                data.opcodes.push(data.topStack.alt);
                break;
            }
        } else if (state === id.SEM_POST) {
            data.altStack.pop();
            if (data.altStack.length > 0) data.topStack = data.altStack[data.altStack.length - 1];
            else data.topStack = null;
        }
        return ret;
    }
    function semConcatenation(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.topStack.alt.children.push(data.opcodes.length);
            data.topStack.cat = {
                type: id.CAT,
                children: []
            };
            data.opcodes.push(data.topStack.cat);
        } else if (state === id.SEM_POST) data.topStack.cat = null;
        return ret;
    }
    function semRepetition(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.topStack.cat.children.push(data.opcodes.length);
        return ret;
    }
    function semOptionOpen(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.REP,
            min: 0,
            max: 1,
            char: phraseIndex
        });
        return ret;
    }
    function semRuleName(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.ruleName = apglib.utils.charsToString(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semDefined(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.definedas = "=";
        return ret;
    }
    function semIncAlt(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.definedas = "=/";
        return ret;
    }
    function semRepOp(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.min = 0;
            data.max = Infinity;
            data.topRep = {
                type: id.REP,
                min: 0,
                max: Infinity
            };
            data.opcodes.push(data.topRep);
        } else if (state === id.SEM_POST) {
            if (data.min > data.max) data.errors.push({
                line: data.findLine(data.lines, phraseIndex, data.charsLength),
                char: phraseIndex,
                msg: "repetition min cannot be greater than max: min: ".concat(data.min, ": max: ").concat(data.max)
            });
            data.topRep.min = data.min;
            data.topRep.max = data.max;
        }
        return ret;
    }
    function semRepMin(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.min = decnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semRepMax(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.max = decnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semRepMinMax(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            data.max = decnum(chars, phraseIndex, phraseCount);
            data.min = data.max;
        }
        return ret;
    }
    function semAndOp(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.AND
        });
        return ret;
    }
    function semNotOp(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.NOT
        });
        return ret;
    }
    function semRnmOp(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.RNM,
            /* NOTE: this is temporary info, index will be replaced with integer later. */ /* Probably not the best coding practice but here you go. */ index: {
                phraseIndex: phraseIndex,
                name: apglib.utils.charsToString(chars, phraseIndex, phraseCount)
            }
        });
        return ret;
    }
    function semAbgOp(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.ABG
        });
        return ret;
    }
    function semAenOp(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.AEN
        });
        return ret;
    }
    function semBkaOp(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.BKA
        });
        return ret;
    }
    function semBknOp(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.BKN
        });
        return ret;
    }
    function semBkrOp(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.ci = true; /* default to case insensitive */ 
            data.cs = false;
            data.um = true;
            data.pm = false;
        } else if (state === id.SEM_POST) data.opcodes.push({
            type: id.BKR,
            bkrCase: data.cs === true ? id.BKR_MODE_CS : id.BKR_MODE_CI,
            bkrMode: data.pm === true ? id.BKR_MODE_PM : id.BKR_MODE_UM,
            /* NOTE: this is temporary info, index will be replaced with integer later. */ /* Probably not the best coding practice but here you go. */ index: {
                phraseIndex: data.bkrname.phraseIndex,
                name: apglib.utils.charsToString(chars, data.bkrname.phraseIndex, data.bkrname.phraseLength)
            }
        });
        return ret;
    }
    function semBkrCi(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.ci = true;
        return ret;
    }
    function semBkrCs(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.cs = true;
        return ret;
    }
    function semBkrUm(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.um = true;
        return ret;
    }
    function semBkrPm(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.pm = true;
        return ret;
    }
    function semBkrName(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.bkrname = {
            phraseIndex: phraseIndex,
            phraseLength: phraseCount
        };
        return ret;
    }
    function semUdtEmpty(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            var name = apglib.utils.charsToString(chars, phraseIndex, phraseCount);
            var udtName = data.udtNames.add(name);
            if (udtName === -1) {
                udtName = data.udtNames.get(name);
                if (udtName === -1) throw new Error("semUdtEmpty: name look up error");
            } else data.udts.push({
                name: udtName.name,
                lower: udtName.lower,
                index: udtName.index,
                empty: true
            });
            data.opcodes.push({
                type: id.UDT,
                empty: true,
                index: udtName.index
            });
        }
        return ret;
    }
    function semUdtNonEmpty(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            var name = apglib.utils.charsToString(chars, phraseIndex, phraseCount);
            var udtName = data.udtNames.add(name);
            if (udtName === -1) {
                udtName = data.udtNames.get(name);
                if (udtName === -1) throw new Error("semUdtNonEmpty: name look up error");
            } else data.udts.push({
                name: udtName.name,
                lower: udtName.lower,
                index: udtName.index,
                empty: false
            });
            data.opcodes.push({
                type: id.UDT,
                empty: false,
                index: udtName.index,
                syntax: null,
                semantic: null
            });
        }
        return ret;
    }
    function semTlsOp(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.tlscase = true; /* default to case insensitive */ 
        return ret;
    }
    function semTlsCase(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            if (phraseCount > 0 && (chars[phraseIndex + 1] === 83 || chars[phraseIndex + 1] === 115)) data.tlscase = false; /* set to case sensitive */ 
        }
        return ret;
    }
    function semTlsString(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            if (data.tlscase) {
                var str = chars.slice(phraseIndex, phraseIndex + phraseCount);
                for(var i = 0; i < str.length; i += 1)if (str[i] >= 65 && str[i] <= 90) str[i] += 32;
                data.opcodes.push({
                    type: id.TLS,
                    string: str
                });
            } else data.opcodes.push({
                type: id.TBS,
                string: chars.slice(phraseIndex, phraseIndex + phraseCount)
            });
        }
        return ret;
    }
    function semClsOp(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            if (phraseCount <= 2) /* only TLS is allowed to be empty */ data.opcodes.push({
                type: id.TLS,
                string: []
            });
            else data.opcodes.push({
                type: id.TBS,
                string: chars.slice(phraseIndex + 1, phraseIndex + phraseCount - 1)
            });
        }
        return ret;
    }
    function semTbsOp(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.tbsstr = [];
        else if (state === id.SEM_POST) data.opcodes.push({
            type: id.TBS,
            string: data.tbsstr
        });
        return ret;
    }
    function semTrgOp(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.min = 0;
            data.max = 0;
        } else if (state === id.SEM_POST) {
            if (data.min > data.max) data.errors.push({
                line: data.findLine(data.lines, phraseIndex, data.charsLength),
                char: phraseIndex,
                msg: "TRG, (%dmin-max), min cannot be greater than max: min: ".concat(data.min, ": max: ").concat(data.max)
            });
            data.opcodes.push({
                type: id.TRG,
                min: data.min,
                max: data.max
            });
        }
        return ret;
    }
    function semDmin(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.min = decnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semDmax(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.max = decnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semBmin(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.min = binnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semBmax(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.max = binnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semXmin(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.min = hexnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semXmax(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.max = hexnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semDstring(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.tbsstr.push(decnum(chars, phraseIndex, phraseCount));
        return ret;
    }
    function semBstring(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.tbsstr.push(binnum(chars, phraseIndex, phraseCount));
        return ret;
    }
    function semXstring(state, chars, phraseIndex, phraseCount, data) {
        var ret = id.SEM_OK;
        if (state === id.SEM_POST) data.tbsstr.push(hexnum(chars, phraseIndex, phraseCount));
        return ret;
    }
    // Define the callback functions to the AST object.
    this.callbacks = [];
    this.callbacks.abgop = semAbgOp;
    this.callbacks.aenop = semAenOp;
    this.callbacks.alternation = semAlternation;
    this.callbacks.andop = semAndOp;
    this.callbacks.bmax = semBmax;
    this.callbacks.bmin = semBmin;
    this.callbacks.bkaop = semBkaOp;
    this.callbacks.bknop = semBknOp;
    this.callbacks.bkrop = semBkrOp;
    this.callbacks["bkr-name"] = semBkrName;
    this.callbacks.bstring = semBstring;
    this.callbacks.clsop = semClsOp;
    this.callbacks.ci = semBkrCi;
    this.callbacks.cs = semBkrCs;
    this.callbacks.um = semBkrUm;
    this.callbacks.pm = semBkrPm;
    this.callbacks.concatenation = semConcatenation;
    this.callbacks.defined = semDefined;
    this.callbacks.dmax = semDmax;
    this.callbacks.dmin = semDmin;
    this.callbacks.dstring = semDstring;
    this.callbacks.file = semFile;
    this.callbacks.incalt = semIncAlt;
    this.callbacks.notop = semNotOp;
    this.callbacks.optionopen = semOptionOpen;
    this.callbacks["rep-max"] = semRepMax;
    this.callbacks["rep-min"] = semRepMin;
    this.callbacks["rep-min-max"] = semRepMinMax;
    this.callbacks.repetition = semRepetition;
    this.callbacks.repop = semRepOp;
    this.callbacks.rnmop = semRnmOp;
    this.callbacks.rule = semRule;
    this.callbacks.rulelookup = semRuleLookup;
    this.callbacks.rulename = semRuleName;
    this.callbacks.tbsop = semTbsOp;
    this.callbacks.tlscase = semTlsCase;
    this.callbacks.tlsstring = semTlsString;
    this.callbacks.tlsop = semTlsOp;
    this.callbacks.trgop = semTrgOp;
    this.callbacks["udt-empty"] = semUdtEmpty;
    this.callbacks["udt-non-empty"] = semUdtNonEmpty;
    this.callbacks.xmax = semXmax;
    this.callbacks.xmin = semXmin;
    this.callbacks.xstring = semXstring;
};

});

parcelRegister("Rbd5i", function(module, exports) {
// copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved<br>
//   license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)<br>
//
// Generated by apg-js, Version 4.0.0 [apg-js](https://github.com/ldthomas/apg-js)
module.exports = function grammar() {
    // ```
    // SUMMARY
    //      rules = 95
    //       udts = 0
    //    opcodes = 372
    //        ---   ABNF original opcodes
    //        ALT = 43
    //        CAT = 48
    //        REP = 34
    //        RNM = 149
    //        TLS = 2
    //        TBS = 61
    //        TRG = 35
    //        ---   SABNF superset opcodes
    //        UDT = 0
    //        AND = 0
    //        NOT = 0
    //        BKA = 0
    //        BKN = 0
    //        BKR = 0
    //        ABG = 0
    //        AEN = 0
    // characters = [9 - 126]
    // ```
    /* OBJECT IDENTIFIER (for internal parser use) */ this.grammarObject = "grammarObject";
    /* RULES */ this.rules = [];
    this.rules[0] = {
        name: "File",
        lower: "file",
        index: 0,
        isBkr: false
    };
    this.rules[1] = {
        name: "BlankLine",
        lower: "blankline",
        index: 1,
        isBkr: false
    };
    this.rules[2] = {
        name: "Rule",
        lower: "rule",
        index: 2,
        isBkr: false
    };
    this.rules[3] = {
        name: "RuleLookup",
        lower: "rulelookup",
        index: 3,
        isBkr: false
    };
    this.rules[4] = {
        name: "RuleNameTest",
        lower: "rulenametest",
        index: 4,
        isBkr: false
    };
    this.rules[5] = {
        name: "RuleName",
        lower: "rulename",
        index: 5,
        isBkr: false
    };
    this.rules[6] = {
        name: "RuleNameError",
        lower: "rulenameerror",
        index: 6,
        isBkr: false
    };
    this.rules[7] = {
        name: "DefinedAsTest",
        lower: "definedastest",
        index: 7,
        isBkr: false
    };
    this.rules[8] = {
        name: "DefinedAsError",
        lower: "definedaserror",
        index: 8,
        isBkr: false
    };
    this.rules[9] = {
        name: "DefinedAs",
        lower: "definedas",
        index: 9,
        isBkr: false
    };
    this.rules[10] = {
        name: "Defined",
        lower: "defined",
        index: 10,
        isBkr: false
    };
    this.rules[11] = {
        name: "IncAlt",
        lower: "incalt",
        index: 11,
        isBkr: false
    };
    this.rules[12] = {
        name: "RuleError",
        lower: "ruleerror",
        index: 12,
        isBkr: false
    };
    this.rules[13] = {
        name: "LineEndError",
        lower: "lineenderror",
        index: 13,
        isBkr: false
    };
    this.rules[14] = {
        name: "Alternation",
        lower: "alternation",
        index: 14,
        isBkr: false
    };
    this.rules[15] = {
        name: "Concatenation",
        lower: "concatenation",
        index: 15,
        isBkr: false
    };
    this.rules[16] = {
        name: "Repetition",
        lower: "repetition",
        index: 16,
        isBkr: false
    };
    this.rules[17] = {
        name: "Modifier",
        lower: "modifier",
        index: 17,
        isBkr: false
    };
    this.rules[18] = {
        name: "Predicate",
        lower: "predicate",
        index: 18,
        isBkr: false
    };
    this.rules[19] = {
        name: "BasicElement",
        lower: "basicelement",
        index: 19,
        isBkr: false
    };
    this.rules[20] = {
        name: "BasicElementErr",
        lower: "basicelementerr",
        index: 20,
        isBkr: false
    };
    this.rules[21] = {
        name: "Group",
        lower: "group",
        index: 21,
        isBkr: false
    };
    this.rules[22] = {
        name: "GroupError",
        lower: "grouperror",
        index: 22,
        isBkr: false
    };
    this.rules[23] = {
        name: "GroupOpen",
        lower: "groupopen",
        index: 23,
        isBkr: false
    };
    this.rules[24] = {
        name: "GroupClose",
        lower: "groupclose",
        index: 24,
        isBkr: false
    };
    this.rules[25] = {
        name: "Option",
        lower: "option",
        index: 25,
        isBkr: false
    };
    this.rules[26] = {
        name: "OptionError",
        lower: "optionerror",
        index: 26,
        isBkr: false
    };
    this.rules[27] = {
        name: "OptionOpen",
        lower: "optionopen",
        index: 27,
        isBkr: false
    };
    this.rules[28] = {
        name: "OptionClose",
        lower: "optionclose",
        index: 28,
        isBkr: false
    };
    this.rules[29] = {
        name: "RnmOp",
        lower: "rnmop",
        index: 29,
        isBkr: false
    };
    this.rules[30] = {
        name: "BkrOp",
        lower: "bkrop",
        index: 30,
        isBkr: false
    };
    this.rules[31] = {
        name: "bkrModifier",
        lower: "bkrmodifier",
        index: 31,
        isBkr: false
    };
    this.rules[32] = {
        name: "cs",
        lower: "cs",
        index: 32,
        isBkr: false
    };
    this.rules[33] = {
        name: "ci",
        lower: "ci",
        index: 33,
        isBkr: false
    };
    this.rules[34] = {
        name: "um",
        lower: "um",
        index: 34,
        isBkr: false
    };
    this.rules[35] = {
        name: "pm",
        lower: "pm",
        index: 35,
        isBkr: false
    };
    this.rules[36] = {
        name: "bkr-name",
        lower: "bkr-name",
        index: 36,
        isBkr: false
    };
    this.rules[37] = {
        name: "rname",
        lower: "rname",
        index: 37,
        isBkr: false
    };
    this.rules[38] = {
        name: "uname",
        lower: "uname",
        index: 38,
        isBkr: false
    };
    this.rules[39] = {
        name: "ename",
        lower: "ename",
        index: 39,
        isBkr: false
    };
    this.rules[40] = {
        name: "UdtOp",
        lower: "udtop",
        index: 40,
        isBkr: false
    };
    this.rules[41] = {
        name: "udt-non-empty",
        lower: "udt-non-empty",
        index: 41,
        isBkr: false
    };
    this.rules[42] = {
        name: "udt-empty",
        lower: "udt-empty",
        index: 42,
        isBkr: false
    };
    this.rules[43] = {
        name: "RepOp",
        lower: "repop",
        index: 43,
        isBkr: false
    };
    this.rules[44] = {
        name: "AltOp",
        lower: "altop",
        index: 44,
        isBkr: false
    };
    this.rules[45] = {
        name: "CatOp",
        lower: "catop",
        index: 45,
        isBkr: false
    };
    this.rules[46] = {
        name: "StarOp",
        lower: "starop",
        index: 46,
        isBkr: false
    };
    this.rules[47] = {
        name: "AndOp",
        lower: "andop",
        index: 47,
        isBkr: false
    };
    this.rules[48] = {
        name: "NotOp",
        lower: "notop",
        index: 48,
        isBkr: false
    };
    this.rules[49] = {
        name: "BkaOp",
        lower: "bkaop",
        index: 49,
        isBkr: false
    };
    this.rules[50] = {
        name: "BknOp",
        lower: "bknop",
        index: 50,
        isBkr: false
    };
    this.rules[51] = {
        name: "AbgOp",
        lower: "abgop",
        index: 51,
        isBkr: false
    };
    this.rules[52] = {
        name: "AenOp",
        lower: "aenop",
        index: 52,
        isBkr: false
    };
    this.rules[53] = {
        name: "TrgOp",
        lower: "trgop",
        index: 53,
        isBkr: false
    };
    this.rules[54] = {
        name: "TbsOp",
        lower: "tbsop",
        index: 54,
        isBkr: false
    };
    this.rules[55] = {
        name: "TlsOp",
        lower: "tlsop",
        index: 55,
        isBkr: false
    };
    this.rules[56] = {
        name: "TlsCase",
        lower: "tlscase",
        index: 56,
        isBkr: false
    };
    this.rules[57] = {
        name: "TlsOpen",
        lower: "tlsopen",
        index: 57,
        isBkr: false
    };
    this.rules[58] = {
        name: "TlsClose",
        lower: "tlsclose",
        index: 58,
        isBkr: false
    };
    this.rules[59] = {
        name: "TlsString",
        lower: "tlsstring",
        index: 59,
        isBkr: false
    };
    this.rules[60] = {
        name: "StringTab",
        lower: "stringtab",
        index: 60,
        isBkr: false
    };
    this.rules[61] = {
        name: "ClsOp",
        lower: "clsop",
        index: 61,
        isBkr: false
    };
    this.rules[62] = {
        name: "ClsOpen",
        lower: "clsopen",
        index: 62,
        isBkr: false
    };
    this.rules[63] = {
        name: "ClsClose",
        lower: "clsclose",
        index: 63,
        isBkr: false
    };
    this.rules[64] = {
        name: "ClsString",
        lower: "clsstring",
        index: 64,
        isBkr: false
    };
    this.rules[65] = {
        name: "ProsVal",
        lower: "prosval",
        index: 65,
        isBkr: false
    };
    this.rules[66] = {
        name: "ProsValOpen",
        lower: "prosvalopen",
        index: 66,
        isBkr: false
    };
    this.rules[67] = {
        name: "ProsValString",
        lower: "prosvalstring",
        index: 67,
        isBkr: false
    };
    this.rules[68] = {
        name: "ProsValClose",
        lower: "prosvalclose",
        index: 68,
        isBkr: false
    };
    this.rules[69] = {
        name: "rep-min",
        lower: "rep-min",
        index: 69,
        isBkr: false
    };
    this.rules[70] = {
        name: "rep-min-max",
        lower: "rep-min-max",
        index: 70,
        isBkr: false
    };
    this.rules[71] = {
        name: "rep-max",
        lower: "rep-max",
        index: 71,
        isBkr: false
    };
    this.rules[72] = {
        name: "rep-num",
        lower: "rep-num",
        index: 72,
        isBkr: false
    };
    this.rules[73] = {
        name: "dString",
        lower: "dstring",
        index: 73,
        isBkr: false
    };
    this.rules[74] = {
        name: "xString",
        lower: "xstring",
        index: 74,
        isBkr: false
    };
    this.rules[75] = {
        name: "bString",
        lower: "bstring",
        index: 75,
        isBkr: false
    };
    this.rules[76] = {
        name: "Dec",
        lower: "dec",
        index: 76,
        isBkr: false
    };
    this.rules[77] = {
        name: "Hex",
        lower: "hex",
        index: 77,
        isBkr: false
    };
    this.rules[78] = {
        name: "Bin",
        lower: "bin",
        index: 78,
        isBkr: false
    };
    this.rules[79] = {
        name: "dmin",
        lower: "dmin",
        index: 79,
        isBkr: false
    };
    this.rules[80] = {
        name: "dmax",
        lower: "dmax",
        index: 80,
        isBkr: false
    };
    this.rules[81] = {
        name: "bmin",
        lower: "bmin",
        index: 81,
        isBkr: false
    };
    this.rules[82] = {
        name: "bmax",
        lower: "bmax",
        index: 82,
        isBkr: false
    };
    this.rules[83] = {
        name: "xmin",
        lower: "xmin",
        index: 83,
        isBkr: false
    };
    this.rules[84] = {
        name: "xmax",
        lower: "xmax",
        index: 84,
        isBkr: false
    };
    this.rules[85] = {
        name: "dnum",
        lower: "dnum",
        index: 85,
        isBkr: false
    };
    this.rules[86] = {
        name: "bnum",
        lower: "bnum",
        index: 86,
        isBkr: false
    };
    this.rules[87] = {
        name: "xnum",
        lower: "xnum",
        index: 87,
        isBkr: false
    };
    this.rules[88] = {
        name: "alphanum",
        lower: "alphanum",
        index: 88,
        isBkr: false
    };
    this.rules[89] = {
        name: "owsp",
        lower: "owsp",
        index: 89,
        isBkr: false
    };
    this.rules[90] = {
        name: "wsp",
        lower: "wsp",
        index: 90,
        isBkr: false
    };
    this.rules[91] = {
        name: "space",
        lower: "space",
        index: 91,
        isBkr: false
    };
    this.rules[92] = {
        name: "comment",
        lower: "comment",
        index: 92,
        isBkr: false
    };
    this.rules[93] = {
        name: "LineEnd",
        lower: "lineend",
        index: 93,
        isBkr: false
    };
    this.rules[94] = {
        name: "LineContinue",
        lower: "linecontinue",
        index: 94,
        isBkr: false
    };
    /* UDTS */ this.udts = [];
    /* OPCODES */ /* File */ this.rules[0].opcodes = [];
    this.rules[0].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[0].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[0].opcodes[2] = {
        type: 4,
        index: 1
    }; // RNM(BlankLine)
    this.rules[0].opcodes[3] = {
        type: 4,
        index: 2
    }; // RNM(Rule)
    this.rules[0].opcodes[4] = {
        type: 4,
        index: 12
    }; // RNM(RuleError)
    /* BlankLine */ this.rules[1].opcodes = [];
    this.rules[1].opcodes[0] = {
        type: 2,
        children: [
            1,
            5,
            7
        ]
    }; // CAT
    this.rules[1].opcodes[1] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[1].opcodes[2] = {
        type: 1,
        children: [
            3,
            4
        ]
    }; // ALT
    this.rules[1].opcodes[3] = {
        type: 6,
        string: [
            32
        ]
    }; // TBS
    this.rules[1].opcodes[4] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    this.rules[1].opcodes[5] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[1].opcodes[6] = {
        type: 4,
        index: 92
    }; // RNM(comment)
    this.rules[1].opcodes[7] = {
        type: 4,
        index: 93
    }; // RNM(LineEnd)
    /* Rule */ this.rules[2].opcodes = [];
    this.rules[2].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3,
            4
        ]
    }; // CAT
    this.rules[2].opcodes[1] = {
        type: 4,
        index: 3
    }; // RNM(RuleLookup)
    this.rules[2].opcodes[2] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[2].opcodes[3] = {
        type: 4,
        index: 14
    }; // RNM(Alternation)
    this.rules[2].opcodes[4] = {
        type: 1,
        children: [
            5,
            8
        ]
    }; // ALT
    this.rules[2].opcodes[5] = {
        type: 2,
        children: [
            6,
            7
        ]
    }; // CAT
    this.rules[2].opcodes[6] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[2].opcodes[7] = {
        type: 4,
        index: 93
    }; // RNM(LineEnd)
    this.rules[2].opcodes[8] = {
        type: 2,
        children: [
            9,
            10
        ]
    }; // CAT
    this.rules[2].opcodes[9] = {
        type: 4,
        index: 13
    }; // RNM(LineEndError)
    this.rules[2].opcodes[10] = {
        type: 4,
        index: 93
    }; // RNM(LineEnd)
    /* RuleLookup */ this.rules[3].opcodes = [];
    this.rules[3].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3
        ]
    }; // CAT
    this.rules[3].opcodes[1] = {
        type: 4,
        index: 4
    }; // RNM(RuleNameTest)
    this.rules[3].opcodes[2] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[3].opcodes[3] = {
        type: 4,
        index: 7
    }; // RNM(DefinedAsTest)
    /* RuleNameTest */ this.rules[4].opcodes = [];
    this.rules[4].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[4].opcodes[1] = {
        type: 4,
        index: 5
    }; // RNM(RuleName)
    this.rules[4].opcodes[2] = {
        type: 4,
        index: 6
    }; // RNM(RuleNameError)
    /* RuleName */ this.rules[5].opcodes = [];
    this.rules[5].opcodes[0] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* RuleNameError */ this.rules[6].opcodes = [];
    this.rules[6].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[6].opcodes[1] = {
        type: 1,
        children: [
            2,
            3
        ]
    }; // ALT
    this.rules[6].opcodes[2] = {
        type: 5,
        min: 33,
        max: 60
    }; // TRG
    this.rules[6].opcodes[3] = {
        type: 5,
        min: 62,
        max: 126
    }; // TRG
    /* DefinedAsTest */ this.rules[7].opcodes = [];
    this.rules[7].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[7].opcodes[1] = {
        type: 4,
        index: 9
    }; // RNM(DefinedAs)
    this.rules[7].opcodes[2] = {
        type: 4,
        index: 8
    }; // RNM(DefinedAsError)
    /* DefinedAsError */ this.rules[8].opcodes = [];
    this.rules[8].opcodes[0] = {
        type: 3,
        min: 1,
        max: 2
    }; // REP
    this.rules[8].opcodes[1] = {
        type: 5,
        min: 33,
        max: 126
    }; // TRG
    /* DefinedAs */ this.rules[9].opcodes = [];
    this.rules[9].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[9].opcodes[1] = {
        type: 4,
        index: 11
    }; // RNM(IncAlt)
    this.rules[9].opcodes[2] = {
        type: 4,
        index: 10
    }; // RNM(Defined)
    /* Defined */ this.rules[10].opcodes = [];
    this.rules[10].opcodes[0] = {
        type: 6,
        string: [
            61
        ]
    }; // TBS
    /* IncAlt */ this.rules[11].opcodes = [];
    this.rules[11].opcodes[0] = {
        type: 6,
        string: [
            61,
            47
        ]
    }; // TBS
    /* RuleError */ this.rules[12].opcodes = [];
    this.rules[12].opcodes[0] = {
        type: 2,
        children: [
            1,
            6
        ]
    }; // CAT
    this.rules[12].opcodes[1] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[12].opcodes[2] = {
        type: 1,
        children: [
            3,
            4,
            5
        ]
    }; // ALT
    this.rules[12].opcodes[3] = {
        type: 5,
        min: 32,
        max: 126
    }; // TRG
    this.rules[12].opcodes[4] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    this.rules[12].opcodes[5] = {
        type: 4,
        index: 94
    }; // RNM(LineContinue)
    this.rules[12].opcodes[6] = {
        type: 4,
        index: 93
    }; // RNM(LineEnd)
    /* LineEndError */ this.rules[13].opcodes = [];
    this.rules[13].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[13].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[13].opcodes[2] = {
        type: 5,
        min: 32,
        max: 126
    }; // TRG
    this.rules[13].opcodes[3] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    this.rules[13].opcodes[4] = {
        type: 4,
        index: 94
    }; // RNM(LineContinue)
    /* Alternation */ this.rules[14].opcodes = [];
    this.rules[14].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[14].opcodes[1] = {
        type: 4,
        index: 15
    }; // RNM(Concatenation)
    this.rules[14].opcodes[2] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[14].opcodes[3] = {
        type: 2,
        children: [
            4,
            5,
            6
        ]
    }; // CAT
    this.rules[14].opcodes[4] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[14].opcodes[5] = {
        type: 4,
        index: 44
    }; // RNM(AltOp)
    this.rules[14].opcodes[6] = {
        type: 4,
        index: 15
    }; // RNM(Concatenation)
    /* Concatenation */ this.rules[15].opcodes = [];
    this.rules[15].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[15].opcodes[1] = {
        type: 4,
        index: 16
    }; // RNM(Repetition)
    this.rules[15].opcodes[2] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[15].opcodes[3] = {
        type: 2,
        children: [
            4,
            5
        ]
    }; // CAT
    this.rules[15].opcodes[4] = {
        type: 4,
        index: 45
    }; // RNM(CatOp)
    this.rules[15].opcodes[5] = {
        type: 4,
        index: 16
    }; // RNM(Repetition)
    /* Repetition */ this.rules[16].opcodes = [];
    this.rules[16].opcodes[0] = {
        type: 2,
        children: [
            1,
            3
        ]
    }; // CAT
    this.rules[16].opcodes[1] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[16].opcodes[2] = {
        type: 4,
        index: 17
    }; // RNM(Modifier)
    this.rules[16].opcodes[3] = {
        type: 1,
        children: [
            4,
            5,
            6,
            7
        ]
    }; // ALT
    this.rules[16].opcodes[4] = {
        type: 4,
        index: 21
    }; // RNM(Group)
    this.rules[16].opcodes[5] = {
        type: 4,
        index: 25
    }; // RNM(Option)
    this.rules[16].opcodes[6] = {
        type: 4,
        index: 19
    }; // RNM(BasicElement)
    this.rules[16].opcodes[7] = {
        type: 4,
        index: 20
    }; // RNM(BasicElementErr)
    /* Modifier */ this.rules[17].opcodes = [];
    this.rules[17].opcodes[0] = {
        type: 1,
        children: [
            1,
            5
        ]
    }; // ALT
    this.rules[17].opcodes[1] = {
        type: 2,
        children: [
            2,
            3
        ]
    }; // CAT
    this.rules[17].opcodes[2] = {
        type: 4,
        index: 18
    }; // RNM(Predicate)
    this.rules[17].opcodes[3] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[17].opcodes[4] = {
        type: 4,
        index: 43
    }; // RNM(RepOp)
    this.rules[17].opcodes[5] = {
        type: 4,
        index: 43
    }; // RNM(RepOp)
    /* Predicate */ this.rules[18].opcodes = [];
    this.rules[18].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[18].opcodes[1] = {
        type: 4,
        index: 49
    }; // RNM(BkaOp)
    this.rules[18].opcodes[2] = {
        type: 4,
        index: 50
    }; // RNM(BknOp)
    this.rules[18].opcodes[3] = {
        type: 4,
        index: 47
    }; // RNM(AndOp)
    this.rules[18].opcodes[4] = {
        type: 4,
        index: 48
    }; // RNM(NotOp)
    /* BasicElement */ this.rules[19].opcodes = [];
    this.rules[19].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10
        ]
    }; // ALT
    this.rules[19].opcodes[1] = {
        type: 4,
        index: 40
    }; // RNM(UdtOp)
    this.rules[19].opcodes[2] = {
        type: 4,
        index: 29
    }; // RNM(RnmOp)
    this.rules[19].opcodes[3] = {
        type: 4,
        index: 53
    }; // RNM(TrgOp)
    this.rules[19].opcodes[4] = {
        type: 4,
        index: 54
    }; // RNM(TbsOp)
    this.rules[19].opcodes[5] = {
        type: 4,
        index: 55
    }; // RNM(TlsOp)
    this.rules[19].opcodes[6] = {
        type: 4,
        index: 61
    }; // RNM(ClsOp)
    this.rules[19].opcodes[7] = {
        type: 4,
        index: 30
    }; // RNM(BkrOp)
    this.rules[19].opcodes[8] = {
        type: 4,
        index: 51
    }; // RNM(AbgOp)
    this.rules[19].opcodes[9] = {
        type: 4,
        index: 52
    }; // RNM(AenOp)
    this.rules[19].opcodes[10] = {
        type: 4,
        index: 65
    }; // RNM(ProsVal)
    /* BasicElementErr */ this.rules[20].opcodes = [];
    this.rules[20].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[20].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4,
            5
        ]
    }; // ALT
    this.rules[20].opcodes[2] = {
        type: 5,
        min: 33,
        max: 40
    }; // TRG
    this.rules[20].opcodes[3] = {
        type: 5,
        min: 42,
        max: 46
    }; // TRG
    this.rules[20].opcodes[4] = {
        type: 5,
        min: 48,
        max: 92
    }; // TRG
    this.rules[20].opcodes[5] = {
        type: 5,
        min: 94,
        max: 126
    }; // TRG
    /* Group */ this.rules[21].opcodes = [];
    this.rules[21].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3
        ]
    }; // CAT
    this.rules[21].opcodes[1] = {
        type: 4,
        index: 23
    }; // RNM(GroupOpen)
    this.rules[21].opcodes[2] = {
        type: 4,
        index: 14
    }; // RNM(Alternation)
    this.rules[21].opcodes[3] = {
        type: 1,
        children: [
            4,
            5
        ]
    }; // ALT
    this.rules[21].opcodes[4] = {
        type: 4,
        index: 24
    }; // RNM(GroupClose)
    this.rules[21].opcodes[5] = {
        type: 4,
        index: 22
    }; // RNM(GroupError)
    /* GroupError */ this.rules[22].opcodes = [];
    this.rules[22].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[22].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4,
            5
        ]
    }; // ALT
    this.rules[22].opcodes[2] = {
        type: 5,
        min: 33,
        max: 40
    }; // TRG
    this.rules[22].opcodes[3] = {
        type: 5,
        min: 42,
        max: 46
    }; // TRG
    this.rules[22].opcodes[4] = {
        type: 5,
        min: 48,
        max: 92
    }; // TRG
    this.rules[22].opcodes[5] = {
        type: 5,
        min: 94,
        max: 126
    }; // TRG
    /* GroupOpen */ this.rules[23].opcodes = [];
    this.rules[23].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[23].opcodes[1] = {
        type: 6,
        string: [
            40
        ]
    }; // TBS
    this.rules[23].opcodes[2] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    /* GroupClose */ this.rules[24].opcodes = [];
    this.rules[24].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[24].opcodes[1] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[24].opcodes[2] = {
        type: 6,
        string: [
            41
        ]
    }; // TBS
    /* Option */ this.rules[25].opcodes = [];
    this.rules[25].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3
        ]
    }; // CAT
    this.rules[25].opcodes[1] = {
        type: 4,
        index: 27
    }; // RNM(OptionOpen)
    this.rules[25].opcodes[2] = {
        type: 4,
        index: 14
    }; // RNM(Alternation)
    this.rules[25].opcodes[3] = {
        type: 1,
        children: [
            4,
            5
        ]
    }; // ALT
    this.rules[25].opcodes[4] = {
        type: 4,
        index: 28
    }; // RNM(OptionClose)
    this.rules[25].opcodes[5] = {
        type: 4,
        index: 26
    }; // RNM(OptionError)
    /* OptionError */ this.rules[26].opcodes = [];
    this.rules[26].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[26].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4,
            5
        ]
    }; // ALT
    this.rules[26].opcodes[2] = {
        type: 5,
        min: 33,
        max: 40
    }; // TRG
    this.rules[26].opcodes[3] = {
        type: 5,
        min: 42,
        max: 46
    }; // TRG
    this.rules[26].opcodes[4] = {
        type: 5,
        min: 48,
        max: 92
    }; // TRG
    this.rules[26].opcodes[5] = {
        type: 5,
        min: 94,
        max: 126
    }; // TRG
    /* OptionOpen */ this.rules[27].opcodes = [];
    this.rules[27].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[27].opcodes[1] = {
        type: 6,
        string: [
            91
        ]
    }; // TBS
    this.rules[27].opcodes[2] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    /* OptionClose */ this.rules[28].opcodes = [];
    this.rules[28].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[28].opcodes[1] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[28].opcodes[2] = {
        type: 6,
        string: [
            93
        ]
    }; // TBS
    /* RnmOp */ this.rules[29].opcodes = [];
    this.rules[29].opcodes[0] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* BkrOp */ this.rules[30].opcodes = [];
    this.rules[30].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            4
        ]
    }; // CAT
    this.rules[30].opcodes[1] = {
        type: 6,
        string: [
            92
        ]
    }; // TBS
    this.rules[30].opcodes[2] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[30].opcodes[3] = {
        type: 4,
        index: 31
    }; // RNM(bkrModifier)
    this.rules[30].opcodes[4] = {
        type: 4,
        index: 36
    }; // RNM(bkr-name)
    /* bkrModifier */ this.rules[31].opcodes = [];
    this.rules[31].opcodes[0] = {
        type: 1,
        children: [
            1,
            7,
            13,
            19
        ]
    }; // ALT
    this.rules[31].opcodes[1] = {
        type: 2,
        children: [
            2,
            3
        ]
    }; // CAT
    this.rules[31].opcodes[2] = {
        type: 4,
        index: 32
    }; // RNM(cs)
    this.rules[31].opcodes[3] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[31].opcodes[4] = {
        type: 1,
        children: [
            5,
            6
        ]
    }; // ALT
    this.rules[31].opcodes[5] = {
        type: 4,
        index: 34
    }; // RNM(um)
    this.rules[31].opcodes[6] = {
        type: 4,
        index: 35
    }; // RNM(pm)
    this.rules[31].opcodes[7] = {
        type: 2,
        children: [
            8,
            9
        ]
    }; // CAT
    this.rules[31].opcodes[8] = {
        type: 4,
        index: 33
    }; // RNM(ci)
    this.rules[31].opcodes[9] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[31].opcodes[10] = {
        type: 1,
        children: [
            11,
            12
        ]
    }; // ALT
    this.rules[31].opcodes[11] = {
        type: 4,
        index: 34
    }; // RNM(um)
    this.rules[31].opcodes[12] = {
        type: 4,
        index: 35
    }; // RNM(pm)
    this.rules[31].opcodes[13] = {
        type: 2,
        children: [
            14,
            15
        ]
    }; // CAT
    this.rules[31].opcodes[14] = {
        type: 4,
        index: 34
    }; // RNM(um)
    this.rules[31].opcodes[15] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[31].opcodes[16] = {
        type: 1,
        children: [
            17,
            18
        ]
    }; // ALT
    this.rules[31].opcodes[17] = {
        type: 4,
        index: 32
    }; // RNM(cs)
    this.rules[31].opcodes[18] = {
        type: 4,
        index: 33
    }; // RNM(ci)
    this.rules[31].opcodes[19] = {
        type: 2,
        children: [
            20,
            21
        ]
    }; // CAT
    this.rules[31].opcodes[20] = {
        type: 4,
        index: 35
    }; // RNM(pm)
    this.rules[31].opcodes[21] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[31].opcodes[22] = {
        type: 1,
        children: [
            23,
            24
        ]
    }; // ALT
    this.rules[31].opcodes[23] = {
        type: 4,
        index: 32
    }; // RNM(cs)
    this.rules[31].opcodes[24] = {
        type: 4,
        index: 33
    }; // RNM(ci)
    /* cs */ this.rules[32].opcodes = [];
    this.rules[32].opcodes[0] = {
        type: 6,
        string: [
            37,
            115
        ]
    }; // TBS
    /* ci */ this.rules[33].opcodes = [];
    this.rules[33].opcodes[0] = {
        type: 6,
        string: [
            37,
            105
        ]
    }; // TBS
    /* um */ this.rules[34].opcodes = [];
    this.rules[34].opcodes[0] = {
        type: 6,
        string: [
            37,
            117
        ]
    }; // TBS
    /* pm */ this.rules[35].opcodes = [];
    this.rules[35].opcodes[0] = {
        type: 6,
        string: [
            37,
            112
        ]
    }; // TBS
    /* bkr-name */ this.rules[36].opcodes = [];
    this.rules[36].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3
        ]
    }; // ALT
    this.rules[36].opcodes[1] = {
        type: 4,
        index: 38
    }; // RNM(uname)
    this.rules[36].opcodes[2] = {
        type: 4,
        index: 39
    }; // RNM(ename)
    this.rules[36].opcodes[3] = {
        type: 4,
        index: 37
    }; // RNM(rname)
    /* rname */ this.rules[37].opcodes = [];
    this.rules[37].opcodes[0] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* uname */ this.rules[38].opcodes = [];
    this.rules[38].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[38].opcodes[1] = {
        type: 6,
        string: [
            117,
            95
        ]
    }; // TBS
    this.rules[38].opcodes[2] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* ename */ this.rules[39].opcodes = [];
    this.rules[39].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[39].opcodes[1] = {
        type: 6,
        string: [
            101,
            95
        ]
    }; // TBS
    this.rules[39].opcodes[2] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* UdtOp */ this.rules[40].opcodes = [];
    this.rules[40].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[40].opcodes[1] = {
        type: 4,
        index: 42
    }; // RNM(udt-empty)
    this.rules[40].opcodes[2] = {
        type: 4,
        index: 41
    }; // RNM(udt-non-empty)
    /* udt-non-empty */ this.rules[41].opcodes = [];
    this.rules[41].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[41].opcodes[1] = {
        type: 6,
        string: [
            117,
            95
        ]
    }; // TBS
    this.rules[41].opcodes[2] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* udt-empty */ this.rules[42].opcodes = [];
    this.rules[42].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[42].opcodes[1] = {
        type: 6,
        string: [
            101,
            95
        ]
    }; // TBS
    this.rules[42].opcodes[2] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* RepOp */ this.rules[43].opcodes = [];
    this.rules[43].opcodes[0] = {
        type: 1,
        children: [
            1,
            5,
            8,
            11,
            12
        ]
    }; // ALT
    this.rules[43].opcodes[1] = {
        type: 2,
        children: [
            2,
            3,
            4
        ]
    }; // CAT
    this.rules[43].opcodes[2] = {
        type: 4,
        index: 69
    }; // RNM(rep-min)
    this.rules[43].opcodes[3] = {
        type: 4,
        index: 46
    }; // RNM(StarOp)
    this.rules[43].opcodes[4] = {
        type: 4,
        index: 71
    }; // RNM(rep-max)
    this.rules[43].opcodes[5] = {
        type: 2,
        children: [
            6,
            7
        ]
    }; // CAT
    this.rules[43].opcodes[6] = {
        type: 4,
        index: 69
    }; // RNM(rep-min)
    this.rules[43].opcodes[7] = {
        type: 4,
        index: 46
    }; // RNM(StarOp)
    this.rules[43].opcodes[8] = {
        type: 2,
        children: [
            9,
            10
        ]
    }; // CAT
    this.rules[43].opcodes[9] = {
        type: 4,
        index: 46
    }; // RNM(StarOp)
    this.rules[43].opcodes[10] = {
        type: 4,
        index: 71
    }; // RNM(rep-max)
    this.rules[43].opcodes[11] = {
        type: 4,
        index: 46
    }; // RNM(StarOp)
    this.rules[43].opcodes[12] = {
        type: 4,
        index: 70
    }; // RNM(rep-min-max)
    /* AltOp */ this.rules[44].opcodes = [];
    this.rules[44].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[44].opcodes[1] = {
        type: 6,
        string: [
            47
        ]
    }; // TBS
    this.rules[44].opcodes[2] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    /* CatOp */ this.rules[45].opcodes = [];
    this.rules[45].opcodes[0] = {
        type: 4,
        index: 90
    }; // RNM(wsp)
    /* StarOp */ this.rules[46].opcodes = [];
    this.rules[46].opcodes[0] = {
        type: 6,
        string: [
            42
        ]
    }; // TBS
    /* AndOp */ this.rules[47].opcodes = [];
    this.rules[47].opcodes[0] = {
        type: 6,
        string: [
            38
        ]
    }; // TBS
    /* NotOp */ this.rules[48].opcodes = [];
    this.rules[48].opcodes[0] = {
        type: 6,
        string: [
            33
        ]
    }; // TBS
    /* BkaOp */ this.rules[49].opcodes = [];
    this.rules[49].opcodes[0] = {
        type: 6,
        string: [
            38,
            38
        ]
    }; // TBS
    /* BknOp */ this.rules[50].opcodes = [];
    this.rules[50].opcodes[0] = {
        type: 6,
        string: [
            33,
            33
        ]
    }; // TBS
    /* AbgOp */ this.rules[51].opcodes = [];
    this.rules[51].opcodes[0] = {
        type: 6,
        string: [
            37,
            94
        ]
    }; // TBS
    /* AenOp */ this.rules[52].opcodes = [];
    this.rules[52].opcodes[0] = {
        type: 6,
        string: [
            37,
            36
        ]
    }; // TBS
    /* TrgOp */ this.rules[53].opcodes = [];
    this.rules[53].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[53].opcodes[1] = {
        type: 6,
        string: [
            37
        ]
    }; // TBS
    this.rules[53].opcodes[2] = {
        type: 1,
        children: [
            3,
            8,
            13
        ]
    }; // ALT
    this.rules[53].opcodes[3] = {
        type: 2,
        children: [
            4,
            5,
            6,
            7
        ]
    }; // CAT
    this.rules[53].opcodes[4] = {
        type: 4,
        index: 76
    }; // RNM(Dec)
    this.rules[53].opcodes[5] = {
        type: 4,
        index: 79
    }; // RNM(dmin)
    this.rules[53].opcodes[6] = {
        type: 6,
        string: [
            45
        ]
    }; // TBS
    this.rules[53].opcodes[7] = {
        type: 4,
        index: 80
    }; // RNM(dmax)
    this.rules[53].opcodes[8] = {
        type: 2,
        children: [
            9,
            10,
            11,
            12
        ]
    }; // CAT
    this.rules[53].opcodes[9] = {
        type: 4,
        index: 77
    }; // RNM(Hex)
    this.rules[53].opcodes[10] = {
        type: 4,
        index: 83
    }; // RNM(xmin)
    this.rules[53].opcodes[11] = {
        type: 6,
        string: [
            45
        ]
    }; // TBS
    this.rules[53].opcodes[12] = {
        type: 4,
        index: 84
    }; // RNM(xmax)
    this.rules[53].opcodes[13] = {
        type: 2,
        children: [
            14,
            15,
            16,
            17
        ]
    }; // CAT
    this.rules[53].opcodes[14] = {
        type: 4,
        index: 78
    }; // RNM(Bin)
    this.rules[53].opcodes[15] = {
        type: 4,
        index: 81
    }; // RNM(bmin)
    this.rules[53].opcodes[16] = {
        type: 6,
        string: [
            45
        ]
    }; // TBS
    this.rules[53].opcodes[17] = {
        type: 4,
        index: 82
    }; // RNM(bmax)
    /* TbsOp */ this.rules[54].opcodes = [];
    this.rules[54].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[54].opcodes[1] = {
        type: 6,
        string: [
            37
        ]
    }; // TBS
    this.rules[54].opcodes[2] = {
        type: 1,
        children: [
            3,
            10,
            17
        ]
    }; // ALT
    this.rules[54].opcodes[3] = {
        type: 2,
        children: [
            4,
            5,
            6
        ]
    }; // CAT
    this.rules[54].opcodes[4] = {
        type: 4,
        index: 76
    }; // RNM(Dec)
    this.rules[54].opcodes[5] = {
        type: 4,
        index: 73
    }; // RNM(dString)
    this.rules[54].opcodes[6] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[54].opcodes[7] = {
        type: 2,
        children: [
            8,
            9
        ]
    }; // CAT
    this.rules[54].opcodes[8] = {
        type: 6,
        string: [
            46
        ]
    }; // TBS
    this.rules[54].opcodes[9] = {
        type: 4,
        index: 73
    }; // RNM(dString)
    this.rules[54].opcodes[10] = {
        type: 2,
        children: [
            11,
            12,
            13
        ]
    }; // CAT
    this.rules[54].opcodes[11] = {
        type: 4,
        index: 77
    }; // RNM(Hex)
    this.rules[54].opcodes[12] = {
        type: 4,
        index: 74
    }; // RNM(xString)
    this.rules[54].opcodes[13] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[54].opcodes[14] = {
        type: 2,
        children: [
            15,
            16
        ]
    }; // CAT
    this.rules[54].opcodes[15] = {
        type: 6,
        string: [
            46
        ]
    }; // TBS
    this.rules[54].opcodes[16] = {
        type: 4,
        index: 74
    }; // RNM(xString)
    this.rules[54].opcodes[17] = {
        type: 2,
        children: [
            18,
            19,
            20
        ]
    }; // CAT
    this.rules[54].opcodes[18] = {
        type: 4,
        index: 78
    }; // RNM(Bin)
    this.rules[54].opcodes[19] = {
        type: 4,
        index: 75
    }; // RNM(bString)
    this.rules[54].opcodes[20] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[54].opcodes[21] = {
        type: 2,
        children: [
            22,
            23
        ]
    }; // CAT
    this.rules[54].opcodes[22] = {
        type: 6,
        string: [
            46
        ]
    }; // TBS
    this.rules[54].opcodes[23] = {
        type: 4,
        index: 75
    }; // RNM(bString)
    /* TlsOp */ this.rules[55].opcodes = [];
    this.rules[55].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3,
            4
        ]
    }; // CAT
    this.rules[55].opcodes[1] = {
        type: 4,
        index: 56
    }; // RNM(TlsCase)
    this.rules[55].opcodes[2] = {
        type: 4,
        index: 57
    }; // RNM(TlsOpen)
    this.rules[55].opcodes[3] = {
        type: 4,
        index: 59
    }; // RNM(TlsString)
    this.rules[55].opcodes[4] = {
        type: 4,
        index: 58
    }; // RNM(TlsClose)
    /* TlsCase */ this.rules[56].opcodes = [];
    this.rules[56].opcodes[0] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[56].opcodes[1] = {
        type: 1,
        children: [
            2,
            3
        ]
    }; // ALT
    this.rules[56].opcodes[2] = {
        type: 7,
        string: [
            37,
            105
        ]
    }; // TLS
    this.rules[56].opcodes[3] = {
        type: 7,
        string: [
            37,
            115
        ]
    }; // TLS
    /* TlsOpen */ this.rules[57].opcodes = [];
    this.rules[57].opcodes[0] = {
        type: 6,
        string: [
            34
        ]
    }; // TBS
    /* TlsClose */ this.rules[58].opcodes = [];
    this.rules[58].opcodes[0] = {
        type: 6,
        string: [
            34
        ]
    }; // TBS
    /* TlsString */ this.rules[59].opcodes = [];
    this.rules[59].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[59].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[59].opcodes[2] = {
        type: 5,
        min: 32,
        max: 33
    }; // TRG
    this.rules[59].opcodes[3] = {
        type: 5,
        min: 35,
        max: 126
    }; // TRG
    this.rules[59].opcodes[4] = {
        type: 4,
        index: 60
    }; // RNM(StringTab)
    /* StringTab */ this.rules[60].opcodes = [];
    this.rules[60].opcodes[0] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    /* ClsOp */ this.rules[61].opcodes = [];
    this.rules[61].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3
        ]
    }; // CAT
    this.rules[61].opcodes[1] = {
        type: 4,
        index: 62
    }; // RNM(ClsOpen)
    this.rules[61].opcodes[2] = {
        type: 4,
        index: 64
    }; // RNM(ClsString)
    this.rules[61].opcodes[3] = {
        type: 4,
        index: 63
    }; // RNM(ClsClose)
    /* ClsOpen */ this.rules[62].opcodes = [];
    this.rules[62].opcodes[0] = {
        type: 6,
        string: [
            39
        ]
    }; // TBS
    /* ClsClose */ this.rules[63].opcodes = [];
    this.rules[63].opcodes[0] = {
        type: 6,
        string: [
            39
        ]
    }; // TBS
    /* ClsString */ this.rules[64].opcodes = [];
    this.rules[64].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[64].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[64].opcodes[2] = {
        type: 5,
        min: 32,
        max: 38
    }; // TRG
    this.rules[64].opcodes[3] = {
        type: 5,
        min: 40,
        max: 126
    }; // TRG
    this.rules[64].opcodes[4] = {
        type: 4,
        index: 60
    }; // RNM(StringTab)
    /* ProsVal */ this.rules[65].opcodes = [];
    this.rules[65].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3
        ]
    }; // CAT
    this.rules[65].opcodes[1] = {
        type: 4,
        index: 66
    }; // RNM(ProsValOpen)
    this.rules[65].opcodes[2] = {
        type: 4,
        index: 67
    }; // RNM(ProsValString)
    this.rules[65].opcodes[3] = {
        type: 4,
        index: 68
    }; // RNM(ProsValClose)
    /* ProsValOpen */ this.rules[66].opcodes = [];
    this.rules[66].opcodes[0] = {
        type: 6,
        string: [
            60
        ]
    }; // TBS
    /* ProsValString */ this.rules[67].opcodes = [];
    this.rules[67].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[67].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[67].opcodes[2] = {
        type: 5,
        min: 32,
        max: 61
    }; // TRG
    this.rules[67].opcodes[3] = {
        type: 5,
        min: 63,
        max: 126
    }; // TRG
    this.rules[67].opcodes[4] = {
        type: 4,
        index: 60
    }; // RNM(StringTab)
    /* ProsValClose */ this.rules[68].opcodes = [];
    this.rules[68].opcodes[0] = {
        type: 6,
        string: [
            62
        ]
    }; // TBS
    /* rep-min */ this.rules[69].opcodes = [];
    this.rules[69].opcodes[0] = {
        type: 4,
        index: 72
    }; // RNM(rep-num)
    /* rep-min-max */ this.rules[70].opcodes = [];
    this.rules[70].opcodes[0] = {
        type: 4,
        index: 72
    }; // RNM(rep-num)
    /* rep-max */ this.rules[71].opcodes = [];
    this.rules[71].opcodes[0] = {
        type: 4,
        index: 72
    }; // RNM(rep-num)
    /* rep-num */ this.rules[72].opcodes = [];
    this.rules[72].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[72].opcodes[1] = {
        type: 5,
        min: 48,
        max: 57
    }; // TRG
    /* dString */ this.rules[73].opcodes = [];
    this.rules[73].opcodes[0] = {
        type: 4,
        index: 85
    }; // RNM(dnum)
    /* xString */ this.rules[74].opcodes = [];
    this.rules[74].opcodes[0] = {
        type: 4,
        index: 87
    }; // RNM(xnum)
    /* bString */ this.rules[75].opcodes = [];
    this.rules[75].opcodes[0] = {
        type: 4,
        index: 86
    }; // RNM(bnum)
    /* Dec */ this.rules[76].opcodes = [];
    this.rules[76].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[76].opcodes[1] = {
        type: 6,
        string: [
            68
        ]
    }; // TBS
    this.rules[76].opcodes[2] = {
        type: 6,
        string: [
            100
        ]
    }; // TBS
    /* Hex */ this.rules[77].opcodes = [];
    this.rules[77].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[77].opcodes[1] = {
        type: 6,
        string: [
            88
        ]
    }; // TBS
    this.rules[77].opcodes[2] = {
        type: 6,
        string: [
            120
        ]
    }; // TBS
    /* Bin */ this.rules[78].opcodes = [];
    this.rules[78].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[78].opcodes[1] = {
        type: 6,
        string: [
            66
        ]
    }; // TBS
    this.rules[78].opcodes[2] = {
        type: 6,
        string: [
            98
        ]
    }; // TBS
    /* dmin */ this.rules[79].opcodes = [];
    this.rules[79].opcodes[0] = {
        type: 4,
        index: 85
    }; // RNM(dnum)
    /* dmax */ this.rules[80].opcodes = [];
    this.rules[80].opcodes[0] = {
        type: 4,
        index: 85
    }; // RNM(dnum)
    /* bmin */ this.rules[81].opcodes = [];
    this.rules[81].opcodes[0] = {
        type: 4,
        index: 86
    }; // RNM(bnum)
    /* bmax */ this.rules[82].opcodes = [];
    this.rules[82].opcodes[0] = {
        type: 4,
        index: 86
    }; // RNM(bnum)
    /* xmin */ this.rules[83].opcodes = [];
    this.rules[83].opcodes[0] = {
        type: 4,
        index: 87
    }; // RNM(xnum)
    /* xmax */ this.rules[84].opcodes = [];
    this.rules[84].opcodes[0] = {
        type: 4,
        index: 87
    }; // RNM(xnum)
    /* dnum */ this.rules[85].opcodes = [];
    this.rules[85].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[85].opcodes[1] = {
        type: 5,
        min: 48,
        max: 57
    }; // TRG
    /* bnum */ this.rules[86].opcodes = [];
    this.rules[86].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[86].opcodes[1] = {
        type: 5,
        min: 48,
        max: 49
    }; // TRG
    /* xnum */ this.rules[87].opcodes = [];
    this.rules[87].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[87].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[87].opcodes[2] = {
        type: 5,
        min: 48,
        max: 57
    }; // TRG
    this.rules[87].opcodes[3] = {
        type: 5,
        min: 65,
        max: 70
    }; // TRG
    this.rules[87].opcodes[4] = {
        type: 5,
        min: 97,
        max: 102
    }; // TRG
    /* alphanum */ this.rules[88].opcodes = [];
    this.rules[88].opcodes[0] = {
        type: 2,
        children: [
            1,
            4
        ]
    }; // CAT
    this.rules[88].opcodes[1] = {
        type: 1,
        children: [
            2,
            3
        ]
    }; // ALT
    this.rules[88].opcodes[2] = {
        type: 5,
        min: 97,
        max: 122
    }; // TRG
    this.rules[88].opcodes[3] = {
        type: 5,
        min: 65,
        max: 90
    }; // TRG
    this.rules[88].opcodes[4] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[88].opcodes[5] = {
        type: 1,
        children: [
            6,
            7,
            8,
            9
        ]
    }; // ALT
    this.rules[88].opcodes[6] = {
        type: 5,
        min: 97,
        max: 122
    }; // TRG
    this.rules[88].opcodes[7] = {
        type: 5,
        min: 65,
        max: 90
    }; // TRG
    this.rules[88].opcodes[8] = {
        type: 5,
        min: 48,
        max: 57
    }; // TRG
    this.rules[88].opcodes[9] = {
        type: 6,
        string: [
            45
        ]
    }; // TBS
    /* owsp */ this.rules[89].opcodes = [];
    this.rules[89].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[89].opcodes[1] = {
        type: 4,
        index: 91
    }; // RNM(space)
    /* wsp */ this.rules[90].opcodes = [];
    this.rules[90].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[90].opcodes[1] = {
        type: 4,
        index: 91
    }; // RNM(space)
    /* space */ this.rules[91].opcodes = [];
    this.rules[91].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[91].opcodes[1] = {
        type: 6,
        string: [
            32
        ]
    }; // TBS
    this.rules[91].opcodes[2] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    this.rules[91].opcodes[3] = {
        type: 4,
        index: 92
    }; // RNM(comment)
    this.rules[91].opcodes[4] = {
        type: 4,
        index: 94
    }; // RNM(LineContinue)
    /* comment */ this.rules[92].opcodes = [];
    this.rules[92].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[92].opcodes[1] = {
        type: 6,
        string: [
            59
        ]
    }; // TBS
    this.rules[92].opcodes[2] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[92].opcodes[3] = {
        type: 1,
        children: [
            4,
            5
        ]
    }; // ALT
    this.rules[92].opcodes[4] = {
        type: 5,
        min: 32,
        max: 126
    }; // TRG
    this.rules[92].opcodes[5] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    /* LineEnd */ this.rules[93].opcodes = [];
    this.rules[93].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3
        ]
    }; // ALT
    this.rules[93].opcodes[1] = {
        type: 6,
        string: [
            13,
            10
        ]
    }; // TBS
    this.rules[93].opcodes[2] = {
        type: 6,
        string: [
            10
        ]
    }; // TBS
    this.rules[93].opcodes[3] = {
        type: 6,
        string: [
            13
        ]
    }; // TBS
    /* LineContinue */ this.rules[94].opcodes = [];
    this.rules[94].opcodes[0] = {
        type: 2,
        children: [
            1,
            5
        ]
    }; // CAT
    this.rules[94].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[94].opcodes[2] = {
        type: 6,
        string: [
            13,
            10
        ]
    }; // TBS
    this.rules[94].opcodes[3] = {
        type: 6,
        string: [
            10
        ]
    }; // TBS
    this.rules[94].opcodes[4] = {
        type: 6,
        string: [
            13
        ]
    }; // TBS
    this.rules[94].opcodes[5] = {
        type: 1,
        children: [
            6,
            7
        ]
    }; // ALT
    this.rules[94].opcodes[6] = {
        type: 6,
        string: [
            32
        ]
    }; // TBS
    this.rules[94].opcodes[7] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    // The `toString()` function will display the original grammar file(s) that produced these opcodes.
    this.toString = function toString() {
        var str = "";
        str += ";\n";
        str += "; ABNF for JavaScript APG 2.0 SABNF\n";
        str += "; RFC 5234 with some restrictions and additions.\n";
        str += "; Updated 11/24/2015 for RFC 7405 case-sensitive literal string notation\n";
        str += ';  - accepts %s"string" as a case-sensitive string\n';
        str += ';  - accepts %i"string" as a case-insensitive string\n';
        str += ';  - accepts "string" as a case-insensitive string\n';
        str += ";\n";
        str += "; Some restrictions:\n";
        str += ";   1. Rules must begin at first character of each line.\n";
        str += ";      Indentations on first rule and rules thereafter are not allowed.\n";
        str += ";   2. Relaxed line endings. CRLF, LF or CR are accepted as valid line ending.\n";
        str += ";   3. Prose values, i.e. <prose value>, are accepted as valid grammar syntax.\n";
        str += ";      However, a working parser cannot be generated from them.\n";
        str += ";\n";
        str += "; Super set (SABNF) additions:\n";
        str += ";   1. Look-ahead (syntactic predicate) operators are accepted as element prefixes.\n";
        str += ";      & is the positive look-ahead operator, succeeds and backtracks if the look-ahead phrase is found\n";
        str += ";      ! is the negative look-ahead operator, succeeds and backtracks if the look-ahead phrase is NOT found\n";
        str += ";      e.g. &%d13 or &rule or !(A / B)\n";
        str += ";   2. User-Defined Terminals (UDT) of the form, u_name and e_name are accepted.\n";
        str += ";      'name' is alpha followed by alpha/num/hyphen just like a rule name.\n";
        str += ";      u_name may be used as an element but no rule definition is given.\n";
        str += ";      e.g. rule = A / u_myUdt\n";
        str += ';           A = "a"\n';
        str += ";      would be a valid grammar.\n";
        str += ";   3. Case-sensitive, single-quoted strings are accepted.\n";
        str += ";      e.g. 'abc' would be equivalent to %d97.98.99\n";
        str += ';      (kept for backward compatibility, but superseded by %s"abc")  \n';
        str += "; New 12/26/2015\n";
        str += ";   4. Look-behind operators are accepted as element prefixes.\n";
        str += ";      && is the positive look-behind operator, succeeds and backtracks if the look-behind phrase is found\n";
        str += ";      !! is the negative look-behind operator, succeeds and backtracks if the look-behind phrase is NOT found\n";
        str += ";      e.g. &&%d13 or &&rule or !!(A / B)\n";
        str += ";   5. Back reference operators, i.e. \\rulename, are accepted.\n";
        str += ";      A back reference operator acts like a TLS or TBS terminal except that the phrase it attempts\n";
        str += ";      to match is a phrase previously matched by the rule 'rulename'.\n";
        str += ";      There are two modes of previous phrase matching - the parent-frame mode and the universal mode.\n";
        str += ";      In universal mode, \\rulename matches the last match to 'rulename' regardless of where it was found.\n";
        str += ";      In parent-frame mode, \\rulename matches only the last match found on the parent's frame or parse tree level.\n";
        str += ";      Back reference modifiers can be used to specify case and mode.\n";
        str += ";      \\A defaults to case-insensitive and universal mode, e.g. \\A === \\%i%uA\n";
        str += ";      Modifiers %i and %s determine case-insensitive and case-sensitive mode, respectively.\n";
        str += ";      Modifiers %u and %p determine universal mode and parent frame mode, respectively.\n";
        str += ";      Case and mode modifiers can appear in any order, e.g. \\%s%pA === \\%p%sA. \n";
        str += ";   7. String begin anchor, ABG(%^) matches the beginning of the input string location.\n";
        str += ";      Returns EMPTY or NOMATCH. Never consumes any characters.\n";
        str += ";   8. String end anchor, AEN(%$) matches the end of the input string location.\n";
        str += ";      Returns EMPTY or NOMATCH. Never consumes any characters.\n";
        str += ";\n";
        str += "File            = *(BlankLine / Rule / RuleError)\n";
        str += "BlankLine       = *(%d32/%d9) [comment] LineEnd\n";
        str += "Rule            = RuleLookup owsp Alternation ((owsp LineEnd)\n";
        str += "                / (LineEndError LineEnd))\n";
        str += "RuleLookup      = RuleNameTest owsp DefinedAsTest\n";
        str += "RuleNameTest    = RuleName/RuleNameError\n";
        str += "RuleName        = alphanum\n";
        str += "RuleNameError   = 1*(%d33-60/%d62-126)\n";
        str += "DefinedAsTest   = DefinedAs / DefinedAsError\n";
        str += "DefinedAsError  = 1*2%d33-126\n";
        str += "DefinedAs       = IncAlt / Defined\n";
        str += "Defined         = %d61\n";
        str += "IncAlt          = %d61.47\n";
        str += "RuleError       = 1*(%d32-126 / %d9  / LineContinue) LineEnd\n";
        str += "LineEndError    = 1*(%d32-126 / %d9  / LineContinue)\n";
        str += "Alternation     = Concatenation *(owsp AltOp Concatenation)\n";
        str += "Concatenation   = Repetition *(CatOp Repetition)\n";
        str += "Repetition      = [Modifier] (Group / Option / BasicElement / BasicElementErr)\n";
        str += "Modifier        = (Predicate [RepOp])\n";
        str += "                / RepOp\n";
        str += "Predicate       = BkaOp\n";
        str += "                / BknOp\n";
        str += "                / AndOp\n";
        str += "                / NotOp\n";
        str += "BasicElement    = UdtOp\n";
        str += "                / RnmOp\n";
        str += "                / TrgOp\n";
        str += "                / TbsOp\n";
        str += "                / TlsOp\n";
        str += "                / ClsOp\n";
        str += "                / BkrOp\n";
        str += "                / AbgOp\n";
        str += "                / AenOp\n";
        str += "                / ProsVal\n";
        str += "BasicElementErr = 1*(%d33-40/%d42-46/%d48-92/%d94-126)\n";
        str += "Group           = GroupOpen  Alternation (GroupClose / GroupError)\n";
        str += "GroupError      = 1*(%d33-40/%d42-46/%d48-92/%d94-126) ; same as BasicElementErr\n";
        str += "GroupOpen       = %d40 owsp\n";
        str += "GroupClose      = owsp %d41\n";
        str += "Option          = OptionOpen Alternation (OptionClose / OptionError)\n";
        str += "OptionError     = 1*(%d33-40/%d42-46/%d48-92/%d94-126) ; same as BasicElementErr\n";
        str += "OptionOpen      = %d91 owsp\n";
        str += "OptionClose     = owsp %d93\n";
        str += "RnmOp           = alphanum\n";
        str += "BkrOp           = %d92 [bkrModifier] bkr-name\n";
        str += "bkrModifier     = (cs [um / pm]) / (ci [um / pm]) / (um [cs /ci]) / (pm [cs / ci])\n";
        str += "cs              = '%s'\n";
        str += "ci              = '%i'\n";
        str += "um              = '%u'\n";
        str += "pm              = '%p'\n";
        str += "bkr-name        = uname / ename / rname\n";
        str += "rname           = alphanum\n";
        str += "uname           = %d117.95 alphanum\n";
        str += "ename           = %d101.95 alphanum\n";
        str += "UdtOp           = udt-empty\n";
        str += "                / udt-non-empty\n";
        str += "udt-non-empty   = %d117.95 alphanum\n";
        str += "udt-empty       = %d101.95 alphanum\n";
        str += "RepOp           = (rep-min StarOp rep-max)\n";
        str += "                / (rep-min StarOp)\n";
        str += "                / (StarOp rep-max)\n";
        str += "                / StarOp\n";
        str += "                / rep-min-max\n";
        str += "AltOp           = %d47 owsp\n";
        str += "CatOp           = wsp\n";
        str += "StarOp          = %d42\n";
        str += "AndOp           = %d38\n";
        str += "NotOp           = %d33\n";
        str += "BkaOp           = %d38.38\n";
        str += "BknOp           = %d33.33\n";
        str += "AbgOp           = %d37.94\n";
        str += "AenOp           = %d37.36\n";
        str += "TrgOp           = %d37 ((Dec dmin %d45 dmax) / (Hex xmin %d45 xmax) / (Bin bmin %d45 bmax))\n";
        str += "TbsOp           = %d37 ((Dec dString *(%d46 dString)) / (Hex xString *(%d46 xString)) / (Bin bString *(%d46 bString)))\n";
        str += "TlsOp           = TlsCase TlsOpen TlsString TlsClose\n";
        str += 'TlsCase         = ["%i" / "%s"]\n';
        str += "TlsOpen         = %d34\n";
        str += "TlsClose        = %d34\n";
        str += "TlsString       = *(%d32-33/%d35-126/StringTab)\n";
        str += "StringTab       = %d9\n";
        str += "ClsOp           = ClsOpen ClsString ClsClose\n";
        str += "ClsOpen         = %d39\n";
        str += "ClsClose        = %d39\n";
        str += "ClsString       = *(%d32-38/%d40-126/StringTab)\n";
        str += "ProsVal         = ProsValOpen ProsValString ProsValClose\n";
        str += "ProsValOpen     = %d60\n";
        str += "ProsValString   = *(%d32-61/%d63-126/StringTab)\n";
        str += "ProsValClose    = %d62\n";
        str += "rep-min         = rep-num\n";
        str += "rep-min-max     = rep-num\n";
        str += "rep-max         = rep-num\n";
        str += "rep-num         = 1*(%d48-57)\n";
        str += "dString         = dnum\n";
        str += "xString         = xnum\n";
        str += "bString         = bnum\n";
        str += "Dec             = (%d68/%d100)\n";
        str += "Hex             = (%d88/%d120)\n";
        str += "Bin             = (%d66/%d98)\n";
        str += "dmin            = dnum\n";
        str += "dmax            = dnum\n";
        str += "bmin            = bnum\n";
        str += "bmax            = bnum\n";
        str += "xmin            = xnum\n";
        str += "xmax            = xnum\n";
        str += "dnum            = 1*(%d48-57)\n";
        str += "bnum            = 1*%d48-49\n";
        str += "xnum            = 1*(%d48-57 / %d65-70 / %d97-102)\n";
        str += ";\n";
        str += "; Basics\n";
        str += "alphanum        = (%d97-122/%d65-90) *(%d97-122/%d65-90/%d48-57/%d45)\n";
        str += "owsp            = *space\n";
        str += "wsp             = 1*space\n";
        str += "space           = %d32\n";
        str += "                / %d9\n";
        str += "                / comment\n";
        str += "                / LineContinue\n";
        str += "comment         = %d59 *(%d32-126 / %d9)\n";
        str += "LineEnd         = %d13.10\n";
        str += "                / %d10\n";
        str += "                / %d13\n";
        str += "LineContinue    = (%d13.10 / %d10 / %d13) (%d32 / %d9)\n";
        return str;
    };
};

});


parcelRegister("2TSYG", function(module, exports) {
/* eslint-disable class-methods-use-this */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // Attributes Validation
//
// It is well known that recursive-descent parsers will fail if a rule is left recursive.
// Besides left recursion, there are a couple of other fatal attributes that need to be disclosed as well.
// There are several non-fatal attributes that are of interest also.
// This module will determine six different attributes listed here with simple examples.
//
// **fatal attributes**<br>
// left recursion<br>
// S = S "x" / "y"
//
// cyclic<br>
// S = S
//
// infinite<br>
// S = "y" S
//
// **non-fatal attributes** (but nice to know)<br>
// nested recursion<br>
// S = "a" S "b" / "y"
//
// right recursion<br>
// S = "x" S / "y"
//
// empty string<br>
// S = "x" S / ""
//
// Note that these are “aggregate” attributes, in that if the attribute is true it only means that it can be true,
// not that it will always be true for every input string.
// In the simple examples above the attributes may be obvious and definite – always true or false.
// However, for a large grammar with possibly hundreds of rules and parse tree branches,
// it can be obscure which branches lead to which attributes.
// Furthermore, different input strings will lead the parser down different branches.
// One input string may parse perfectly while another will hit a left-recursive branch and bottom out the call stack.
//
// It is for this reason that the APG parser generator computes these attributes.
// When using the API the attributes call is optional but generating a parser without checking the attributes - proceed at your own peril.
//
// Additionally, the attribute phase will identify rule dependencies and mutually-recursive groups. For example,
//
// S = "a" A "b" / "y"<br>
// A = "x"
//
// S is dependent on A but A is not dependent on S.
//
// S = "a" A "b" / "c"<br>
// A = "x" S "y" / "z"
//
// S and A are dependent on one another and are mutually recursive.

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");



module.exports = function exportAttributes() {
    var id = (parcelRequire("dPnGd"));
    var _require = (parcelRequire("hZnr5")), ruleAttributes = _require.ruleAttributes, showAttributes = _require.showAttributes, showAttributeErrors = _require.showAttributeErrors;
    var _require1 = (parcelRequire("b1kNj")), ruleDependencies = _require1.ruleDependencies, showRuleDependencies = _require1.showRuleDependencies;
    var State = /*#__PURE__*/ function() {
        "use strict";
        function State(rules, udts) {
            (0, $9j09T._)(this, State);
            this.rules = rules;
            this.udts = udts;
            this.ruleCount = rules.length;
            this.udtCount = udts.length;
            this.startRule = 0;
            this.dependenciesComplete = false;
            this.attributesComplete = false;
            this.isMutuallyRecursive = false;
            this.ruleIndexes = this.indexArray(this.ruleCount);
            this.ruleAlphaIndexes = this.indexArray(this.ruleCount);
            this.ruleTypeIndexes = this.indexArray(this.ruleCount);
            this.udtIndexes = this.indexArray(this.udtCount);
            this.udtAlphaIndexes = this.indexArray(this.udtCount);
            this.attrsErrorCount = 0;
            this.attrs = [];
            this.attrsErrors = [];
            this.attrsWorking = [];
            this.ruleDeps = [];
            for(var i = 0; i < this.ruleCount; i += 1){
                this.attrs.push(this.attrGen(this.rules[i]));
                this.attrsWorking.push(this.attrGen(this.rules[i]));
                this.ruleDeps.push(this.rdGen(rules[i], this.ruleCount, this.udtCount));
            }
            this.compRulesAlpha = this.compRulesAlpha.bind(this);
            this.compUdtsAlpha = this.compUdtsAlpha.bind(this);
            this.compRulesType = this.compRulesType.bind(this);
            this.compRulesGroup = this.compRulesGroup.bind(this);
        }
        (0, $eDeHT._)(State, [
            {
                // eslint-disable-next-line class-methods-use-this
                key: "attrGen",
                value: function attrGen(rule) {
                    return {
                        left: false,
                        nested: false,
                        right: false,
                        empty: false,
                        finite: false,
                        cyclic: false,
                        leaf: false,
                        isOpen: false,
                        isComplete: false,
                        rule: rule
                    };
                }
            },
            {
                // eslint-disable-next-line class-methods-use-this
                key: "attrInit",
                value: function attrInit(attr) {
                    attr.left = false;
                    attr.nested = false;
                    attr.right = false;
                    attr.empty = false;
                    attr.finite = false;
                    attr.cyclic = false;
                    attr.leaf = false;
                    attr.isOpen = false;
                    attr.isComplete = false;
                }
            },
            {
                key: "attrCopy",
                value: function attrCopy(dst, src) {
                    dst.left = src.left;
                    dst.nested = src.nested;
                    dst.right = src.right;
                    dst.empty = src.empty;
                    dst.finite = src.finite;
                    dst.cyclic = src.cyclic;
                    dst.leaf = src.leaf;
                    dst.isOpen = src.isOpen;
                    dst.isComplete = src.isComplete;
                    dst.rule = src.rule;
                }
            },
            {
                key: "rdGen",
                value: function rdGen(rule, ruleCount, udtCount) {
                    var ret = {
                        rule: rule,
                        recursiveType: id.ATTR_N,
                        groupNumber: -1,
                        refersTo: this.falseArray(ruleCount),
                        refersToUdt: this.falseArray(udtCount),
                        referencedBy: this.falseArray(ruleCount)
                    };
                    return ret;
                }
            },
            {
                key: "typeToString",
                value: function typeToString(recursiveType) {
                    switch(recursiveType){
                        case id.ATTR_N:
                            return " N";
                        case id.ATTR_R:
                            return " R";
                        case id.ATTR_MR:
                            return "MR";
                        default:
                            return "UNKNOWN";
                    }
                }
            },
            {
                key: "falseArray",
                value: function falseArray(length) {
                    var ret = [];
                    if (length > 0) for(var i = 0; i < length; i += 1)ret.push(false);
                    return ret;
                }
            },
            {
                key: "falsifyArray",
                value: function falsifyArray(a) {
                    for(var i = 0; i < a.length; i += 1)a[i] = false;
                }
            },
            {
                key: "indexArray",
                value: function indexArray(length) {
                    var ret = [];
                    if (length > 0) for(var i = 0; i < length; i += 1)ret.push(i);
                    return ret;
                }
            },
            {
                key: "compRulesAlpha",
                value: function compRulesAlpha(left, right) {
                    if (this.rules[left].lower < this.rules[right].lower) return -1;
                    if (this.rules[left].lower > this.rules[right].lower) return 1;
                    return 0;
                }
            },
            {
                key: "compUdtsAlpha",
                value: function compUdtsAlpha(left, right) {
                    if (this.udts[left].lower < this.udts[right].lower) return -1;
                    if (this.udts[left].lower > this.udts[right].lower) return 1;
                    return 0;
                }
            },
            {
                key: "compRulesType",
                value: function compRulesType(left, right) {
                    if (this.ruleDeps[left].recursiveType < this.ruleDeps[right].recursiveType) return -1;
                    if (this.ruleDeps[left].recursiveType > this.ruleDeps[right].recursiveType) return 1;
                    return 0;
                }
            },
            {
                key: "compRulesGroup",
                value: function compRulesGroup(left, right) {
                    if (this.ruleDeps[left].recursiveType === id.ATTR_MR && this.ruleDeps[right].recursiveType === id.ATTR_MR) {
                        if (this.ruleDeps[left].groupNumber < this.ruleDeps[right].groupNumber) return -1;
                        if (this.ruleDeps[left].groupNumber > this.ruleDeps[right].groupNumber) return 1;
                    }
                    return 0;
                }
            }
        ]);
        return State;
    }();
    // eslint-disable-next-line no-unused-vars
    var attributes = function attributes() {
        var rules = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], udts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], lineMap = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], errors = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
        // let i = 0;
        // Initialize the state. The state of the computation get passed around to multiple functions in multiple files.
        var state = new State(rules, udts);
        // Determine all rule dependencies
        //  - which rules each rule refers to
        //  - which rules reference each rule
        ruleDependencies(state);
        // Determine the attributes for each rule.
        ruleAttributes(state);
        if (state.attrsErrorCount) errors.push({
            line: 0,
            char: 0,
            msg: "".concat(state.attrsErrorCount, " attribute errors")
        });
        // Return the number of attribute errors to the caller.
        return state.attrsErrorCount;
    };
    /* Destructuring assignment - see MDN Web Docs */ return {
        attributes: attributes,
        showAttributes: showAttributes,
        showAttributeErrors: showAttributeErrors,
        showRuleDependencies: showRuleDependencies
    };
}();

});
parcelRegister("hZnr5", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module does the heavy lifting for attribute generation.

module.exports = function exportRuleAttributes() {
    var id = (parcelRequire("dPnGd"));
    var thisFile = "rule-attributes.js";
    var state = null;
    function isEmptyOnly(attr) {
        if (attr.left || attr.nested || attr.right || attr.cyclic) return false;
        return attr.empty;
    }
    function isRecursive(attr) {
        if (attr.left || attr.nested || attr.right || attr.cyclic) return true;
        return false;
    }
    function isCatNested(attrs, count) {
        var i = 0;
        var j = 0;
        var k = 0;
        /* 1. if any child is nested, CAT is nested */ for(i = 0; i < count; i += 1){
            if (attrs[i].nested) return true;
        }
        /* 2.) the left-most right recursive child
               is followed by at least one non-empty child */ for(i = 0; i < count; i += 1){
            if (attrs[i].right && !attrs[i].leaf) for(j = i + 1; j < count; j += 1){
                if (!isEmptyOnly(attrs[j])) return true;
            }
        }
        /* 3.) the right-most left recursive child
               is preceded by at least one non-empty child */ for(i = count - 1; i >= 0; i -= 1){
            if (attrs[i].left && !attrs[i].leaf) for(j = i - 1; j >= 0; j -= 1){
                if (!isEmptyOnly(attrs[j])) return true;
            }
        }
        /* 4. there is at lease one recursive child between
              the left-most and right-most non-recursive, non-empty children */ for(i = 0; i < count; i += 1){
            if (!attrs[i].empty && !isRecursive(attrs[i])) for(j = i + 1; j < count; j += 1){
                if (isRecursive(attrs[j])) for(k = j + 1; k < count; k += 1){
                    if (!attrs[k].empty && !isRecursive(attrs[k])) return true;
                }
            }
        }
        /* none of the above */ return false;
    }
    function isCatCyclic(attrs, count) {
        /* if all children are cyclic, CAT is cyclic */ for(var i = 0; i < count; i += 1){
            if (!attrs[i].cyclic) return false;
        }
        return true;
    }
    function isCatLeft(attrs, count) {
        /* if the left-most non-empty is left, CAT is left */ for(var i = 0; i < count; i += 1){
            if (attrs[i].left) return true;
            if (!attrs[i].empty) return false;
        /* keep looking */ }
        return false; /* all left-most are empty */ 
    }
    function isCatRight(attrs, count) {
        /* if the right-most non-empty is right, CAT is right */ for(var i = count - 1; i >= 0; i -= 1){
            if (attrs[i].right) return true;
            if (!attrs[i].empty) return false;
        /* keep looking */ }
        return false;
    }
    function isCatEmpty(attrs, count) {
        /* if all children are empty, CAT is empty */ for(var i = 0; i < count; i += 1){
            if (!attrs[i].empty) return false;
        }
        return true;
    }
    function isCatFinite(attrs, count) {
        /* if all children are finite, CAT is finite */ for(var i = 0; i < count; i += 1){
            if (!attrs[i].finite) return false;
        }
        return true;
    }
    function cat(stateArg, opcodes, opIndex, iAttr) {
        var i = 0;
        var opCat = opcodes[opIndex];
        var count = opCat.children.length;
        /* generate an empty array of child attributes */ var childAttrs = [];
        for(i = 0; i < count; i += 1)childAttrs.push(stateArg.attrGen());
        for(i = 0; i < count; i += 1)// eslint-disable-next-line no-use-before-define
        opEval(stateArg, opcodes, opCat.children[i], childAttrs[i]);
        iAttr.left = isCatLeft(childAttrs, count);
        iAttr.right = isCatRight(childAttrs, count);
        iAttr.nested = isCatNested(childAttrs, count);
        iAttr.empty = isCatEmpty(childAttrs, count);
        iAttr.finite = isCatFinite(childAttrs, count);
        iAttr.cyclic = isCatCyclic(childAttrs, count);
    }
    function alt(stateArg, opcodes, opIndex, iAttr) {
        var i = 0;
        var opAlt = opcodes[opIndex];
        var count = opAlt.children.length;
        /* generate an empty array of child attributes */ var childAttrs = [];
        for(i = 0; i < count; i += 1)childAttrs.push(stateArg.attrGen());
        for(i = 0; i < count; i += 1)// eslint-disable-next-line no-use-before-define
        opEval(stateArg, opcodes, opAlt.children[i], childAttrs[i]);
        /* if any child attribute is true, ALT is true */ iAttr.left = false;
        iAttr.right = false;
        iAttr.nested = false;
        iAttr.empty = false;
        iAttr.finite = false;
        iAttr.cyclic = false;
        for(i = 0; i < count; i += 1){
            if (childAttrs[i].left) iAttr.left = true;
            if (childAttrs[i].nested) iAttr.nested = true;
            if (childAttrs[i].right) iAttr.right = true;
            if (childAttrs[i].empty) iAttr.empty = true;
            if (childAttrs[i].finite) iAttr.finite = true;
            if (childAttrs[i].cyclic) iAttr.cyclic = true;
        }
    }
    function bkr(stateArg, opcodes, opIndex, iAttr) {
        var opBkr = opcodes[opIndex];
        if (opBkr.index >= stateArg.ruleCount) {
            /* use UDT values */ iAttr.empty = stateArg.udts[opBkr.index - stateArg.ruleCount].empty;
            iAttr.finite = true;
        } else {
            /* use the empty and finite values from the back referenced rule */ // eslint-disable-next-line no-use-before-define
            ruleAttrsEval(stateArg, opBkr.index, iAttr);
            /* however, this is a terminal node like TLS */ iAttr.left = false;
            iAttr.nested = false;
            iAttr.right = false;
            iAttr.cyclic = false;
        }
    }
    function opEval(stateArg, opcodes, opIndex, iAttr) {
        stateArg.attrInit(iAttr);
        var opi = opcodes[opIndex];
        switch(opi.type){
            case id.ALT:
                alt(stateArg, opcodes, opIndex, iAttr);
                break;
            case id.CAT:
                cat(stateArg, opcodes, opIndex, iAttr);
                break;
            case id.REP:
                opEval(stateArg, opcodes, opIndex + 1, iAttr);
                if (opi.min === 0) {
                    iAttr.empty = true;
                    iAttr.finite = true;
                }
                break;
            case id.RNM:
                // eslint-disable-next-line no-use-before-define
                ruleAttrsEval(stateArg, opcodes[opIndex].index, iAttr);
                break;
            case id.BKR:
                bkr(stateArg, opcodes, opIndex, iAttr);
                break;
            case id.AND:
            case id.NOT:
            case id.BKA:
            case id.BKN:
                opEval(stateArg, opcodes, opIndex + 1, iAttr);
                iAttr.empty = true;
                break;
            case id.TLS:
                iAttr.empty = !opcodes[opIndex].string.length;
                iAttr.finite = true;
                iAttr.cyclic = false;
                break;
            case id.TBS:
            case id.TRG:
                iAttr.empty = false;
                iAttr.finite = true;
                iAttr.cyclic = false;
                break;
            case id.UDT:
                iAttr.empty = opi.empty;
                iAttr.finite = true;
                iAttr.cyclic = false;
                break;
            case id.ABG:
            case id.AEN:
                iAttr.empty = true;
                iAttr.finite = true;
                iAttr.cyclic = false;
                break;
            default:
                throw new Error("unknown opcode type: ".concat(opi));
        }
    }
    // The main logic for handling rules that:
    //  - have already be evaluated
    //  - have not been evaluated and is the first occurrence on this branch
    //  - second occurrence on this branch for the start rule
    //  - second occurrence on this branch for non-start rules
    function ruleAttrsEval(stateArg, ruleIndex, iAttr) {
        var attri = stateArg.attrsWorking[ruleIndex];
        if (attri.isComplete) /* just use the completed values */ stateArg.attrCopy(iAttr, attri);
        else if (!attri.isOpen) {
            /* open the rule and traverse it */ attri.isOpen = true;
            opEval(stateArg, attri.rule.opcodes, 0, iAttr);
            /* complete this rule's attributes */ attri.left = iAttr.left;
            attri.right = iAttr.right;
            attri.nested = iAttr.nested;
            attri.empty = iAttr.empty;
            attri.finite = iAttr.finite;
            attri.cyclic = iAttr.cyclic;
            attri.leaf = false;
            attri.isOpen = false;
            attri.isComplete = true;
        } else if (ruleIndex === stateArg.startRule) /* use recursive leaf values */ {
            if (ruleIndex === stateArg.startRule) {
                iAttr.left = true;
                iAttr.right = true;
                iAttr.cyclic = true;
                iAttr.leaf = true;
            }
        } else /* non-start rule terminal leaf */ iAttr.finite = true;
    }
    // The main driver for the attribute generation.
    var ruleAttributes = function(stateArg) {
        state = stateArg;
        var i = 0;
        var j = 0;
        var iAttr = state.attrGen();
        for(i = 0; i < state.ruleCount; i += 1){
            /* initialize working attributes */ for(j = 0; j < state.ruleCount; j += 1)state.attrInit(state.attrsWorking[j]);
            state.startRule = i;
            ruleAttrsEval(state, i, iAttr);
            /* save off the working attributes for this rule */ state.attrCopy(state.attrs[i], state.attrsWorking[i]);
        }
        state.attributesComplete = true;
        var attri = null;
        for(i = 0; i < state.ruleCount; i += 1){
            attri = state.attrs[i];
            if (attri.left || !attri.finite || attri.cyclic) {
                var temp = state.attrGen(attri.rule);
                state.attrCopy(temp, attri);
                state.attrsErrors.push(temp);
                state.attrsErrorCount += 1;
            }
        }
    };
    var truth = function(val) {
        return val ? "t" : "f";
    };
    var tError = function(val) {
        return val ? "e" : "f";
    };
    var fError = function(val) {
        return val ? "t" : "e";
    };
    var showAttr = function(seq, index, attr, dep) {
        var str = "".concat(seq, ":").concat(index, ":");
        str += "".concat(tError(attr.left), " ");
        str += "".concat(truth(attr.nested), " ");
        str += "".concat(truth(attr.right), " ");
        str += "".concat(tError(attr.cyclic), " ");
        str += "".concat(fError(attr.finite), " ");
        str += "".concat(truth(attr.empty), ":");
        str += "".concat(state.typeToString(dep.recursiveType), ":");
        str += dep.recursiveType === id.ATTR_MR ? dep.groupNumber : "-";
        str += ":".concat(attr.rule.name, "\n");
        return str;
    };
    var showLegend = function() {
        var str = "LEGEND - t=true, f=false, e=error\n";
        str += "sequence:rule index:left nested right cyclic finite empty:type:group number:rule name\n";
        return str;
    };
    var showAttributeErrors = function() {
        var attri = null;
        var depi = null;
        var str = "";
        str += "RULE ATTRIBUTES WITH ERRORS\n";
        str += showLegend();
        if (state.attrsErrorCount) for(var i = 0; i < state.attrsErrorCount; i += 1){
            attri = state.attrsErrors[i];
            depi = state.ruleDeps[attri.rule.index];
            str += showAttr(i, attri.rule.index, attri, depi);
        }
        else str += "<none>\n";
        return str;
    };
    var show = function(type) {
        var i = 0;
        var ii = 0;
        var attri = null;
        var depi = null;
        var str = "";
        var ruleIndexes = state.ruleIndexes;
        // let udtIndexes = state.udtIndexes;
        if (type === 97) ruleIndexes = state.ruleAlphaIndexes;
        else if (type === 116) ruleIndexes = state.ruleTypeIndexes;
        /* show all attributes */ for(i = 0; i < state.ruleCount; i += 1){
            ii = ruleIndexes[i];
            attri = state.attrs[ii];
            depi = state.ruleDeps[ii];
            str += showAttr(i, ii, attri, depi);
        }
        return str;
    };
    // Display the rule attributes.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - "type" or "t", ordered by type (alphabetical within each type/group)
    //      - none of above, index order (default)
    var showAttributes = function() {
        var order = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "index";
        if (!state.attributesComplete) throw new Error("".concat(thisFile, ":showAttributes: attributes not available"));
        var str = "";
        var leader = "RULE ATTRIBUTES\n";
        if (order.charCodeAt(0) === 97) {
            str += "alphabetical by rule name\n";
            str += leader;
            str += showLegend();
            str += show(97);
        } else if (order.charCodeAt(0) === 116) {
            str += "ordered by rule type\n";
            str += leader;
            str += showLegend();
            str += show(116);
        } else {
            str += "ordered by rule index\n";
            str += leader;
            str += showLegend();
            str += show();
        }
        return str;
    };
    /* Destructuring assignment - see MDN Web Docs */ return {
        ruleAttributes: ruleAttributes,
        showAttributes: showAttributes,
        showAttributeErrors: showAttributeErrors
    };
}();

});

parcelRegister("b1kNj", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // Determine rule dependencies and types.
// For each rule, determine which other rules it refers to
// and which of the other rules refer back to it.
//
// Rule types are:
//  - non-recursive - the rule never refers to itself, even indirectly
//  - recursive - the rule refers to itself, possibly indirectly
//  - mutually-recursive - belongs to a group of two or more rules, each of which refers to every other rule in the group, including itself.

module.exports = function() {
    var id = (parcelRequire("dPnGd"));
    var state = null; /* keep a global reference to the state for the show functions */ 
    /* scan the opcodes of the indexed rule and discover which rules it references and which rule refer back to it */ var scan = function(ruleCount, ruleDeps, index, isScanned) {
        var i = 0;
        var j = 0;
        var rdi = ruleDeps[index];
        isScanned[index] = true;
        var op = rdi.rule.opcodes;
        for(i = 0; i < op.length; i += 1){
            var opi = op[i];
            if (opi.type === id.RNM) {
                rdi.refersTo[opi.index] = true;
                if (!isScanned[opi.index]) scan(ruleCount, ruleDeps, opi.index, isScanned);
                for(j = 0; j < ruleCount; j += 1)if (ruleDeps[opi.index].refersTo[j]) rdi.refersTo[j] = true;
            } else if (opi.type === id.UDT) rdi.refersToUdt[opi.index] = true;
            else if (opi.type === id.BKR) {
                if (opi.index < ruleCount) {
                    rdi.refersTo[opi.index] = true;
                    if (!isScanned[opi.index]) scan(ruleCount, ruleDeps, opi.index, isScanned);
                } else rdi.refersToUdt[ruleCount - opi.index] = true;
            }
        }
    };
    // Determine the rule dependencies, types and mutually recursive groups.
    var ruleDependencies = function(stateArg) {
        state = stateArg; /* make it global */ 
        var i = 0;
        var j = 0;
        var groupCount = 0;
        var rdi = null;
        var rdj = null;
        var newGroup = false;
        state.dependenciesComplete = false;
        /* make a working array of rule scanned markers */ var isScanned = state.falseArray(state.ruleCount);
        /* discover the rule dependencies */ for(i = 0; i < state.ruleCount; i += 1){
            state.falsifyArray(isScanned);
            scan(state.ruleCount, state.ruleDeps, i, isScanned);
        }
        /* discover all rules referencing each rule */ for(i = 0; i < state.ruleCount; i += 1)for(j = 0; j < state.ruleCount; j += 1){
            if (i !== j) {
                if (state.ruleDeps[j].refersTo[i]) state.ruleDeps[i].referencedBy[j] = true;
            }
        }
        /* find the non-recursive and recursive types */ for(i = 0; i < state.ruleCount; i += 1){
            state.ruleDeps[i].recursiveType = id.ATTR_N;
            if (state.ruleDeps[i].refersTo[i]) state.ruleDeps[i].recursiveType = id.ATTR_R;
        }
        /* find the mutually-recursive groups, if any */ groupCount = -1;
        for(i = 0; i < state.ruleCount; i += 1){
            rdi = state.ruleDeps[i];
            if (rdi.recursiveType === id.ATTR_R) {
                newGroup = true;
                for(j = 0; j < state.ruleCount; j += 1)if (i !== j) {
                    rdj = state.ruleDeps[j];
                    if (rdj.recursiveType === id.ATTR_R) {
                        if (rdi.refersTo[j] && rdj.refersTo[i]) {
                            if (newGroup) {
                                groupCount += 1;
                                rdi.recursiveType = id.ATTR_MR;
                                rdi.groupNumber = groupCount;
                                newGroup = false;
                            }
                            rdj.recursiveType = id.ATTR_MR;
                            rdj.groupNumber = groupCount;
                        }
                    }
                }
            }
        }
        state.isMutuallyRecursive = groupCount > -1;
        /* sort the rules/UDTS */ state.ruleAlphaIndexes.sort(state.compRulesAlpha);
        state.ruleTypeIndexes.sort(state.compRulesAlpha);
        state.ruleTypeIndexes.sort(state.compRulesType);
        if (state.isMutuallyRecursive) state.ruleTypeIndexes.sort(state.compRulesGroup);
        if (state.udtCount) state.udtAlphaIndexes.sort(state.compUdtsAlpha);
        state.dependenciesComplete = true;
    };
    var show = function() {
        var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        var i = 0;
        var j = 0;
        var count = 0;
        var startSeg = 0;
        var maxRule = state.ruleCount - 1;
        var maxUdt = state.udtCount - 1;
        var lineLength = 100;
        var str = "";
        var pre = "";
        var toArrow = "=> ";
        var byArrow = "<= ";
        var first = false;
        var rdi = null;
        var ruleIndexes = state.ruleIndexes;
        var udtIndexes = state.udtIndexes;
        if (type === 97) {
            ruleIndexes = state.ruleAlphaIndexes;
            udtIndexes = state.udtAlphaIndexes;
        } else if (type === 116) {
            ruleIndexes = state.ruleTypeIndexes;
            udtIndexes = state.udtAlphaIndexes;
        }
        for(i = 0; i < state.ruleCount; i += 1){
            rdi = state.ruleDeps[ruleIndexes[i]];
            pre = "".concat(ruleIndexes[i], ":").concat(state.typeToString(rdi.recursiveType), ":");
            if (state.isMutuallyRecursive) {
                pre += rdi.groupNumber > -1 ? rdi.groupNumber : "-";
                pre += ":";
            }
            pre += " ";
            str += "".concat(pre + state.rules[ruleIndexes[i]].name, "\n");
            first = true;
            count = 0;
            startSeg = str.length;
            str += pre;
            for(j = 0; j < state.ruleCount; j += 1){
                if (rdi.refersTo[ruleIndexes[j]]) {
                    if (first) {
                        str += toArrow;
                        first = false;
                        str += state.ruleDeps[ruleIndexes[j]].rule.name;
                    } else str += ", ".concat(state.ruleDeps[ruleIndexes[j]].rule.name);
                    count += 1;
                }
                if (str.length - startSeg > lineLength && j !== maxRule) {
                    str += "\n".concat(pre).concat(toArrow);
                    startSeg = str.length;
                }
            }
            if (state.udtCount) for(j = 0; j < state.udtCount; j += 1){
                if (rdi.refersToUdt[udtIndexes[j]]) {
                    if (first) {
                        str += toArrow;
                        first = false;
                        str += state.udts[udtIndexes[j]].name;
                    } else str += ", ".concat(state.udts[udtIndexes[j]].name);
                    count += 1;
                }
                if (str.length - startSeg > lineLength && j !== maxUdt) {
                    str += "\n".concat(pre).concat(toArrow);
                    startSeg = str.length;
                }
            }
            if (count === 0) str += "=> <none>\n";
            if (first === false) str += "\n";
            first = true;
            count = 0;
            startSeg = str.length;
            str += pre;
            for(j = 0; j < state.ruleCount; j += 1){
                if (rdi.referencedBy[ruleIndexes[j]]) {
                    if (first) {
                        str += byArrow;
                        first = false;
                        str += state.ruleDeps[ruleIndexes[j]].rule.name;
                    } else str += ", ".concat(state.ruleDeps[ruleIndexes[j]].rule.name);
                    count += 1;
                }
                if (str.length - startSeg > lineLength && j !== maxRule) {
                    str += "\n".concat(pre).concat(toArrow);
                    startSeg = str.length;
                }
            }
            if (count === 0) str += "<= <none>\n";
            if (first === false) str += "\n";
            str += "\n";
        }
        return str;
    };
    // Display the rule dependencies.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - "type" or "t", ordered by type (alphabetical within each type/group)
    //      - none of above, index order (default)
    var showRuleDependencies = function() {
        var order = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "index";
        var str = "RULE DEPENDENCIES(index:type:[group number:])\n";
        str += "=> refers to rule names\n";
        str += "<= referenced by rule names\n";
        if (!state.dependenciesComplete) return str;
        if (order.charCodeAt(0) === 97) {
            str += "alphabetical by rule name\n";
            str += show(97);
        } else if (order.charCodeAt(0) === 116) {
            str += "ordered by rule type\n";
            str += show(116);
        } else {
            str += "ordered by rule index\n";
            str += show(null);
        }
        return str;
    };
    /* Destructuring assignment - see MDN Web Docs */ return {
        ruleDependencies: ruleDependencies,
        showRuleDependencies: showRuleDependencies
    };
}();

});


parcelRegister("b8Ggz", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ module.exports = function exfn() {
    var thisFileName = "show-rules.js";
    // Display the rules.
    // This function may be called before the attributes calculation.
    // Sorting is done independently from the attributes.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - none of above, index order (default)
    var showRules = function showRules() {
        var rulesIn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], udtsIn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], order = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "index";
        var thisFuncName = "showRules";
        var alphaArray = [];
        var udtAlphaArray = [];
        var indexArray = [];
        var udtIndexArray = [];
        var rules = rulesIn;
        var udts = udtsIn;
        var ruleCount = rulesIn.length;
        var udtCount = udtsIn.length;
        var str = "RULE/UDT NAMES";
        var i;
        function compRulesAlpha(left, right) {
            if (rules[left].lower < rules[right].lower) return -1;
            if (rules[left].lower > rules[right].lower) return 1;
            return 0;
        }
        function compUdtsAlpha(left, right) {
            if (udts[left].lower < udts[right].lower) return -1;
            if (udts[left].lower > udts[right].lower) return 1;
            return 0;
        }
        if (!(Array.isArray(rulesIn) && rulesIn.length)) throw new Error("".concat(thisFileName, ":").concat(thisFuncName, ": rules arg must be array with length > 0"));
        if (!Array.isArray(udtsIn)) throw new Error("".concat(thisFileName, ":").concat(thisFuncName, ": udts arg must be array"));
        for(i = 0; i < ruleCount; i += 1)indexArray.push(i);
        alphaArray = indexArray.slice(0);
        alphaArray.sort(compRulesAlpha);
        if (udtCount) {
            for(i = 0; i < udtCount; i += 1)udtIndexArray.push(i);
            udtAlphaArray = udtIndexArray.slice(0);
            udtAlphaArray.sort(compUdtsAlpha);
        }
        if (order.charCodeAt(0) === 97) {
            str += " - alphabetical by rule/UDT name\n";
            for(i = 0; i < ruleCount; i += 1)str += "".concat(i, ": ").concat(alphaArray[i], ": ").concat(rules[alphaArray[i]].name, "\n");
            if (udtCount) for(i = 0; i < udtCount; i += 1)str += "".concat(i, ": ").concat(udtAlphaArray[i], ": ").concat(udts[udtAlphaArray[i]].name, "\n");
        } else {
            str += " - ordered by rule/UDT index\n";
            for(i = 0; i < ruleCount; i += 1)str += "".concat(i, ": ").concat(rules[i].name, "\n");
            if (udtCount) for(i = 0; i < udtCount; i += 1)str += "".concat(i, ": ").concat(udts[i].name, "\n");
        }
        return str;
    };
    return showRules;
}();

});



parcelRegister("9Uhnm", function(module, exports) {

var $9j09T = parcelRequire("9j09T");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParsedMessage = void 0;
var $7366d27882265cf0$var$DOMAIN = "(?<domain>([^?#]*)) wants you to sign in with your Ethereum account:";
var $7366d27882265cf0$var$ADDRESS = "\\n(?<address>0x[a-zA-Z0-9]{40})\\n\\n";
var $7366d27882265cf0$var$STATEMENT = "((?<statement>[^\\n]+)\\n)?";
var $7366d27882265cf0$var$URI = "(([^:?#]+):)?(([^?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))";
var $7366d27882265cf0$var$URI_LINE = "\\nURI: (?<uri>".concat($7366d27882265cf0$var$URI, "?)");
var $7366d27882265cf0$var$VERSION = "\\nVersion: (?<version>1)";
var $7366d27882265cf0$var$CHAIN_ID = "\\nChain ID: (?<chainId>[0-9]+)";
var $7366d27882265cf0$var$NONCE = "\\nNonce: (?<nonce>[a-zA-Z0-9]{8,})";
var $7366d27882265cf0$var$DATETIME = "([0-9]+)-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])[Tt]([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9]|60)(.[0-9]+)?(([Zz])|([+|-]([01][0-9]|2[0-3]):[0-5][0-9]))";
var $7366d27882265cf0$var$ISSUED_AT = "\\nIssued At: (?<issuedAt>".concat($7366d27882265cf0$var$DATETIME, ")");
var $7366d27882265cf0$var$EXPIRATION_TIME = "(\\nExpiration Time: (?<expirationTime>".concat($7366d27882265cf0$var$DATETIME, "))?");
var $7366d27882265cf0$var$NOT_BEFORE = "(\\nNot Before: (?<notBefore>".concat($7366d27882265cf0$var$DATETIME, "))?");
var $7366d27882265cf0$var$REQUEST_ID = "(\\nRequest ID: (?<requestId>[-._~!$&'()*+,;=:@%a-zA-Z0-9]*))?";
var $7366d27882265cf0$var$RESOURCES = "(\\nResources:(?<resources>(\\n- ".concat($7366d27882265cf0$var$URI, "?)+))?");
var $7366d27882265cf0$var$MESSAGE = "^".concat($7366d27882265cf0$var$DOMAIN).concat($7366d27882265cf0$var$ADDRESS).concat($7366d27882265cf0$var$STATEMENT).concat($7366d27882265cf0$var$URI_LINE).concat($7366d27882265cf0$var$VERSION).concat($7366d27882265cf0$var$CHAIN_ID).concat($7366d27882265cf0$var$NONCE).concat($7366d27882265cf0$var$ISSUED_AT).concat($7366d27882265cf0$var$EXPIRATION_TIME).concat($7366d27882265cf0$var$NOT_BEFORE).concat($7366d27882265cf0$var$REQUEST_ID).concat($7366d27882265cf0$var$RESOURCES, "$");
var $7366d27882265cf0$var$ParsedMessage = function ParsedMessage(msg) {
    (0, $9j09T._)(this, ParsedMessage);
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var REGEX = new RegExp($7366d27882265cf0$var$MESSAGE, "g");
    var match = REGEX.exec(msg);
    if (!match) throw new Error("Message did not match the regular expression.");
    this.match = match;
    this.domain = (_a = match === null || match === void 0 ? void 0 : match.groups) === null || _a === void 0 ? void 0 : _a.domain;
    this.address = (_b = match === null || match === void 0 ? void 0 : match.groups) === null || _b === void 0 ? void 0 : _b.address;
    this.statement = (_c = match === null || match === void 0 ? void 0 : match.groups) === null || _c === void 0 ? void 0 : _c.statement;
    this.uri = (_d = match === null || match === void 0 ? void 0 : match.groups) === null || _d === void 0 ? void 0 : _d.uri;
    this.version = (_e = match === null || match === void 0 ? void 0 : match.groups) === null || _e === void 0 ? void 0 : _e.version;
    this.nonce = (_f = match === null || match === void 0 ? void 0 : match.groups) === null || _f === void 0 ? void 0 : _f.nonce;
    this.chainId = parseInt((_g = match === null || match === void 0 ? void 0 : match.groups) === null || _g === void 0 ? void 0 : _g.chainId);
    this.issuedAt = (_h = match === null || match === void 0 ? void 0 : match.groups) === null || _h === void 0 ? void 0 : _h.issuedAt;
    this.expirationTime = (_j = match === null || match === void 0 ? void 0 : match.groups) === null || _j === void 0 ? void 0 : _j.expirationTime;
    this.notBefore = (_k = match === null || match === void 0 ? void 0 : match.groups) === null || _k === void 0 ? void 0 : _k.notBefore;
    this.requestId = (_l = match === null || match === void 0 ? void 0 : match.groups) === null || _l === void 0 ? void 0 : _l.requestId;
    this.resources = (_o = (_m = match === null || match === void 0 ? void 0 : match.groups) === null || _m === void 0 ? void 0 : _m.resources) === null || _o === void 0 ? void 0 : _o.split("\n- ").slice(1);
};
module.exports.ParsedMessage = $7366d27882265cf0$var$ParsedMessage;

});




var $2BGKp = parcelRequire("2BGKp");

var $bhrDl = parcelRequire("bhrDl");

var $ldRsu = parcelRequire("ldRsu");

var $jYOnC = parcelRequire("jYOnC");

var $5uUMW = parcelRequire("5uUMW");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $bhrDl = parcelRequire("bhrDl");

var $hGG5A = parcelRequire("hGG5A");
function $5e943273f046bbc2$var$checkPasswordLength(value, el) {
    if (el == null) return;
    var minLength = Number(el.getAttribute("data-min-length"));
    var codePoints = Array.from(value);
    if (codePoints.length >= minLength) el.classList.add("good-txt");
    else el.classList.add("error-txt");
}
function $5e943273f046bbc2$var$checkPasswordUppercase(value, el) {
    if (el == null) return;
    if (/[A-Z]/.test(value)) el.classList.add("good-txt");
    else el.classList.add("error-txt");
}
function $5e943273f046bbc2$var$checkPasswordLowercase(value, el) {
    if (el == null) return;
    if (/[a-z]/.test(value)) el.classList.add("good-txt");
    else el.classList.add("error-txt");
}
function $5e943273f046bbc2$var$checkPasswordAlphabet(value, el) {
    if (el == null) return;
    if (/[a-zA-Z]/.test(value)) el.classList.add("good-txt");
    else el.classList.add("error-txt");
}
function $5e943273f046bbc2$var$checkPasswordDigit(value, el) {
    if (el == null) return;
    if (/[0-9]/.test(value)) el.classList.add("good-txt");
    else el.classList.add("error-txt");
}
function $5e943273f046bbc2$var$checkPasswordSymbol(value, el) {
    if (el == null) return;
    if (/[^a-zA-Z0-9]/.test(value)) el.classList.add("good-txt");
    else el.classList.add("error-txt");
}
function $5e943273f046bbc2$var$checkPasswordStrength(value, currentMeter, currentMeterDescription, requiredMeter, strengthTarget) {
    currentMeter.value = 0;
    currentMeterDescription.textContent = "";
    if (value === "") return;
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($hGG5A)))(value);
    var score = Math.min(5, Math.max(1, result.score + 1));
    currentMeter.value = score;
    currentMeterDescription.textContent = currentMeterDescription.getAttribute("data-desc-" + score);
    if (requiredMeter != null && strengthTarget != null) {
        if (currentMeter.value >= requiredMeter.value) strengthTarget.classList.add("good-txt");
        else strengthTarget.classList.add("error-txt");
    }
}
var $5e943273f046bbc2$export$8e2d40fd8c4736e0 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(PasswordPolicyController, Controller);
    var _super = (0, $a1vXf._)(PasswordPolicyController);
    function PasswordPolicyController() {
        (0, $9j09T._)(this, PasswordPolicyController);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(PasswordPolicyController, [
        {
            key: "check",
            value: function check() {
                var value = this.inputTarget.value;
                for(var i = 0; i < this.itemTargets.length; i++)this.itemTargets[i].classList.remove("error-txt", "good-txt");
                if (this.hasLengthTarget) $5e943273f046bbc2$var$checkPasswordLength(value, this.lengthTarget);
                if (this.hasUppercaseTarget) $5e943273f046bbc2$var$checkPasswordUppercase(value, this.uppercaseTarget);
                if (this.hasLowercaseTarget) $5e943273f046bbc2$var$checkPasswordLowercase(value, this.lowercaseTarget);
                if (this.hasAlphabetTarget) $5e943273f046bbc2$var$checkPasswordAlphabet(value, this.alphabetTarget);
                if (this.hasDigitTarget) $5e943273f046bbc2$var$checkPasswordDigit(value, this.digitTarget);
                if (this.hasSymbolTarget) $5e943273f046bbc2$var$checkPasswordSymbol(value, this.symbolTarget);
                if (this.hasStrengthTarget && this.hasRequiredMeterTarget) $5e943273f046bbc2$var$checkPasswordStrength(value, this.currentMeterTarget, this.currentMeterDescriptionTarget, this.requiredMeterTarget, this.strengthTarget);
                else $5e943273f046bbc2$var$checkPasswordStrength(value, this.currentMeterTarget, this.currentMeterDescriptionTarget, null, null);
            }
        }
    ]);
    return PasswordPolicyController;
}((0, $bhrDl.Controller));
$5e943273f046bbc2$export$8e2d40fd8c4736e0.targets = [
    "input",
    "currentMeter",
    "currentMeterDescription",
    "item",
    "length",
    "uppercase",
    "lowercase",
    "alphabet",
    "digit",
    "symbol",
    "strength",
    "requiredMeter"
];



var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $bhrDl = parcelRequire("bhrDl");
var $98e86993763fcb41$export$3283bc632b8824ef = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(ClickToSwitchController, Controller);
    var _super = (0, $a1vXf._)(ClickToSwitchController);
    function ClickToSwitchController() {
        (0, $9j09T._)(this, ClickToSwitchController);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(ClickToSwitchController, [
        {
            key: "click",
            value: function click() {
                // Do not call prevent default intentionally.
                this.clickToHideTarget.classList.add("hidden");
                this.clickToShowTarget.classList.remove("hidden");
            }
        }
    ]);
    return ClickToSwitchController;
}((0, $bhrDl.Controller));
$98e86993763fcb41$export$3283bc632b8824ef.targets = [
    "clickToShow",
    "clickToHide"
];



var $9IQW1 = parcelRequire("9IQW1");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $bhrDl = parcelRequire("bhrDl");
var $967ab8208c310f6b$export$d0f0bcf1b33aa228 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(AccountDeletionController, Controller);
    var _super = (0, $a1vXf._)(AccountDeletionController);
    function AccountDeletionController() {
        (0, $9j09T._)(this, AccountDeletionController);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(AccountDeletionController, [
        {
            key: "delete",
            value: function _delete() {
                var input = this.inputTarget;
                var button = this.buttonTarget;
                var inputText = input.value;
                button.disabled = inputText !== "DELETE";
            }
        }
    ]);
    return AccountDeletionController;
}((0, $bhrDl.Controller));
$967ab8208c310f6b$export$d0f0bcf1b33aa228.targets = [
    "input",
    "button"
];



var $iUEzK = parcelRequire("iUEzK");

var $fB9zd = parcelRequire("fB9zd");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $bhrDl = parcelRequire("bhrDl");
function $9f556643ce100801$var$swapElementsName(firstElement, secondElement) {
    var originalName = firstElement.name;
    firstElement.name = secondElement.name;
    secondElement.name = originalName;
}
function $9f556643ce100801$var$buildE164Value(countryCallingCode, rawValue) {
    var trimmedValue = rawValue.replace(/[^+0-9]/g, "");
    var prefix = trimmedValue.slice(0, countryCallingCode.length);
    if (prefix === countryCallingCode) return trimmedValue;
    return "".concat(countryCallingCode).concat(trimmedValue);
}
var $9f556643ce100801$export$31a0a1ef286c12be = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(IntlTelInputController, Controller);
    var _super = (0, $a1vXf._)(IntlTelInputController);
    function IntlTelInputController() {
        (0, $9j09T._)(this, IntlTelInputController);
        var _this;
        _this = _super.apply(this, arguments);
        // When we call window.intlTelInput,
        // disconnect will be called immediately, followed by a connect.
        // We have to detect this situation, otherwise we will stick in a infinite loop.
        // The initialization sequence looks like connect,disconnect,connect
        // Therefore, the first time we enter connect, we expect 1 disconnect and 1 connect to be followed.
        // Here we use two booleans to keep track of that.
        _this.ignoreConnect = false;
        _this.ignoreDisconnect = false;
        return _this;
    }
    (0, $eDeHT._)(IntlTelInputController, [
        {
            key: "input",
            value: function input(fromConnect) {
                var instance = this.instance;
                if (instance == null) return;
                // If it is a valid number, then getNumber() returns a E.164 number already.
                // Otherwise we build a value that is a prefix of a E164 number.
                var isValid = instance.isPossibleNumber();
                if (isValid) {
                    var s = instance.getNumber();
                    if (typeof s === "string") {
                        this.hiddenInputElement.value = s;
                        // Emit the custom event "input" to cooperate with RetainFormFormController
                        this.dispatch("input", {
                            detail: {
                                value: s
                            }
                        });
                    }
                } else {
                    var _instance_getSelectedCountryData = instance.getSelectedCountryData(), iso2 = _instance_getSelectedCountryData.iso2, dialCode = _instance_getSelectedCountryData.dialCode;
                    if (fromConnect === true && iso2 != null && dialCode != null) {
                        var countryCallingCode = "+".concat(dialCode);
                        this.inputElement.value = this.inputElement.value.replace(countryCallingCode, "");
                        instance.setCountry(iso2);
                    }
                    if (dialCode != null) {
                        var countryCallingCode1 = "+".concat(dialCode);
                        var value = this.inputElement.value;
                        var s1 = $9f556643ce100801$var$buildE164Value(countryCallingCode1, value);
                        this.hiddenInputElement.value = s1;
                        // Emit the custom event "input" to cooperate with RetainFormFormController
                        this.dispatch("input", {
                            detail: {
                                value: s1
                            }
                        });
                    }
                }
            }
        },
        {
            key: "inputElement",
            get: function get() {
                return this.element;
            }
        },
        {
            key: "connect",
            value: function connect() {
                var _document_querySelector, _document_querySelector1, _document_querySelector2;
                if (this.ignoreConnect) {
                    this.ignoreConnect = false;
                    return;
                }
                var _document_querySelector_getAttribute, _JSON_parse;
                var onlyCountries = (_JSON_parse = JSON.parse((_document_querySelector_getAttribute = (_document_querySelector = document.querySelector("meta[name=x-intl-tel-input-only-countries]")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.getAttribute("content")) !== null && _document_querySelector_getAttribute !== void 0 ? _document_querySelector_getAttribute : "null")) !== null && _JSON_parse !== void 0 ? _JSON_parse : [];
                var _document_querySelector_getAttribute1, _JSON_parse1;
                var preferredCountries = (_JSON_parse1 = JSON.parse((_document_querySelector_getAttribute1 = (_document_querySelector1 = document.querySelector("meta[name=x-intl-tel-input-preferred-countries]")) === null || _document_querySelector1 === void 0 ? void 0 : _document_querySelector1.getAttribute("content")) !== null && _document_querySelector_getAttribute1 !== void 0 ? _document_querySelector_getAttribute1 : "null")) !== null && _JSON_parse1 !== void 0 ? _JSON_parse1 : [];
                var _document_querySelector_getAttribute2;
                var initialCountry = (_document_querySelector_getAttribute2 = (_document_querySelector2 = document.querySelector("meta[name=x-geoip-country-code]")) === null || _document_querySelector2 === void 0 ? void 0 : _document_querySelector2.getAttribute("content")) !== null && _document_querySelector_getAttribute2 !== void 0 ? _document_querySelector_getAttribute2 : "";
                // The detected country is not allowed.
                if (onlyCountries.indexOf(initialCountry) < 0) initialCountry = "";
                var form = this.inputElement.form;
                // Create hidden input to the form
                var hiddenInput = document.createElement("input");
                hiddenInput.type = "hidden";
                hiddenInput.name = "x_login_id_hidden";
                form === null || form === void 0 ? void 0 : form.appendChild(hiddenInput);
                // Save the reference of input and hidden input elements
                this.hiddenInputElement = hiddenInput;
                $9f556643ce100801$var$swapElementsName(this.inputElement, hiddenInput);
                var customContainer = this.classValue;
                this.ignoreConnect = true;
                this.ignoreDisconnect = true;
                this.instance = window.intlTelInput(this.inputElement, {
                    autoPlaceholder: "aggressive",
                    onlyCountries: onlyCountries,
                    preferredCountries: preferredCountries,
                    initialCountry: initialCountry,
                    customContainer: customContainer,
                    useFullscreenPopup: false
                });
                this.input(true);
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _hiddenInput_parentNode, _this_instance;
                if (this.ignoreDisconnect) {
                    this.ignoreDisconnect = false;
                    return;
                }
                // When we disconnect, we store the value in the value attribute.
                // Next time when we connect again, the value is used to initialize the input.
                var input = this.inputElement;
                var value = this.hiddenInputElement.value;
                input.setAttribute("value", value);
                input.value = value;
                var hiddenInput = this.hiddenInputElement;
                $9f556643ce100801$var$swapElementsName(input, hiddenInput);
                (_hiddenInput_parentNode = hiddenInput.parentNode) === null || _hiddenInput_parentNode === void 0 ? void 0 : _hiddenInput_parentNode.removeChild(hiddenInput);
                (_this_instance = this.instance) === null || _this_instance === void 0 ? void 0 : _this_instance.destroy();
                this.instance = null;
            }
        }
    ]);
    return IntlTelInputController;
}((0, $bhrDl.Controller));
$9f556643ce100801$export$31a0a1ef286c12be.values = {
    class: String
};



var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $bhrDl = parcelRequire("bhrDl");
var $3e120f2118d76ac8$export$b1a468160bc49f70 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(SelectEmptyValueController, Controller);
    var _super = (0, $a1vXf._)(SelectEmptyValueController);
    function SelectEmptyValueController() {
        (0, $9j09T._)(this, SelectEmptyValueController);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(SelectEmptyValueController, [
        {
            key: "toggleClass",
            value: function toggleClass() {
                var selectElement = this.element;
                if (selectElement.value === "") selectElement.classList.add("empty");
                else selectElement.classList.remove("empty");
            }
        },
        {
            key: "connect",
            value: function connect() {
                this.toggleClass();
            }
        }
    ]);
    return SelectEmptyValueController;
}((0, $bhrDl.Controller));
var $3e120f2118d76ac8$export$968691de411f5320 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(GenderSelectController, Controller);
    var _super = (0, $a1vXf._)(GenderSelectController);
    function GenderSelectController() {
        (0, $9j09T._)(this, GenderSelectController);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(GenderSelectController, [
        {
            key: "toggle",
            value: function toggle(fromListener) {
                var selectElement = this.selectTarget;
                var inputElement = this.inputTarget;
                if (selectElement.value === "other") {
                    inputElement.classList.remove("hidden");
                    if (fromListener) inputElement.value = "";
                } else inputElement.classList.add("hidden");
            }
        },
        {
            key: "onChange",
            value: function onChange() {
                this.toggle(true);
            }
        },
        {
            key: "connect",
            value: function connect() {
                this.toggle(false);
            }
        }
    ]);
    return GenderSelectController;
}((0, $bhrDl.Controller));
$3e120f2118d76ac8$export$968691de411f5320.targets = [
    "select",
    "input"
];



var $jpnpo = parcelRequire("jpnpo");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $kbgOD = parcelRequire("kbgOD");

var $i1q4Z = parcelRequire("i1q4Z");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");

var $ldRsu = parcelRequire("ldRsu");

var $8WPOm = parcelRequire("8WPOm");

var $fB9zd = parcelRequire("fB9zd");

var $bhrDl = parcelRequire("bhrDl");
function $4549ab881969af81$var$destroyCropper(img) {
    // The namespace .cropper is known by reading the source code.
    // It could change anytime!
    var cropper = img.cropper;
    if (cropper instanceof Cropper) cropper.destroy();
}
function $4549ab881969af81$var$initCropper(img) {
    new Cropper(img, {
        // Make crop region not able to move outside the image.
        viewMode: 1,
        // We want to crop a square image.
        aspectRatio: 1,
        movable: false,
        rotatable: false,
        scalable: false,
        zoomable: false,
        zoomOnTouch: false,
        zoomOnWheel: false
    });
}
function $4549ab881969af81$var$getCropper(img) {
    var cropper = img.cropper;
    return cropper;
}
var $4549ab881969af81$export$53e562c37b02f57d = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(ImagePickerController, Controller);
    var _super = (0, $a1vXf._)(ImagePickerController);
    function ImagePickerController() {
        (0, $9j09T._)(this, ImagePickerController);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(ImagePickerController, [
        {
            key: "onChange",
            value: function onChange(e) {
                var _target_files;
                var target = this.inputFileTarget;
                var file = (_target_files = target.files) === null || _target_files === void 0 ? void 0 : _target_files[0];
                if (file == null) return;
                var imgCropper = this.imgCropperTarget;
                (0, $fB9zd.hideErrorMessage)("error-message-invalid-selected-image");
                imgCropper.classList.remove("hidden");
                var buttonFile = this.buttonFileTarget;
                buttonFile.classList.add("hidden");
                var buttonRemove = this.buttonRemoveTarget;
                buttonRemove.classList.add("hidden");
                var imgPreview = this.imgPreviewTarget;
                imgPreview.classList.add("hidden");
                var buttonSave = this.buttonSaveTarget;
                buttonSave.classList.remove("hidden");
                var reader = new FileReader();
                reader.addEventListener("load", function() {
                    if (typeof reader.result === "string") {
                        imgCropper.src = reader.result;
                        $4549ab881969af81$var$destroyCropper(imgCropper);
                        $4549ab881969af81$var$initCropper(imgCropper);
                    }
                });
                reader.readAsDataURL(file);
            }
        },
        {
            key: "onError",
            value: function onError() {
                var target = this.imgCropperTarget;
                var src = target.src;
                // It is a file from the file system and it does not load.
                // It is probably the file is broken.
                if (/^data:/.test(src)) {
                    var buttonFile = this.buttonFileTarget;
                    buttonFile.classList.remove("hidden");
                    var buttonSave = this.buttonSaveTarget;
                    buttonSave.classList.add("hidden");
                    (0, $fB9zd.showErrorMessage)("error-message-invalid-selected-image");
                }
            }
        },
        {
            key: "onClickFile",
            value: function onClickFile(e) {
                e.preventDefault();
                e.stopPropagation();
                var inputFile = this.inputFileTarget;
                inputFile.click();
            }
        },
        {
            key: "onClickSave",
            value: function onClickSave(e) {
                e.preventDefault();
                e.stopPropagation();
                var imgCropper = this.imgCropperTarget;
                var cropper = $4549ab881969af81$var$getCropper(imgCropper);
                if (cropper == null) return;
                var maxDimensions = 1024;
                var dimensionsOptions = function() {
                    var imageData = cropper.getImageData();
                    var cropBoxData = cropper.getCropBoxData();
                    // assume the cropped area is square
                    if (imageData.naturalWidth > 0 && imageData.width > 0 && cropBoxData.width > 0) {
                        var imageScale = imageData.naturalWidth / imageData.width;
                        var croppedImageWidth = Math.floor(cropBoxData.width * imageScale);
                        var resultDimensions = Math.min(croppedImageWidth, maxDimensions);
                        return {
                            width: resultDimensions,
                            height: resultDimensions
                        };
                    }
                    // last resort when any of the image or crop box data is unavailable
                    return {
                        maxWidth: maxDimensions,
                        maxHeight: maxDimensions
                    };
                }();
                var canvas = cropper.getCroppedCanvas((0, $i1q4Z._)((0, $kbgOD._)({}, dimensionsOptions), {
                    imageSmoothingQuality: "high"
                }));
                var _this = this;
                canvas.toBlob(function() {
                    var _ref = (0, $jpnpo._)(function(blob) {
                        var inputValue, formUpload, revert, resp, body, upload_url, formData, uploadResp, uploadRespBody, url, e;
                        return (0, $itJXR.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (blob == null) return [
                                        2
                                    ];
                                    inputValue = _this.inputValueTarget;
                                    formUpload = _this.formUploadTarget;
                                    revert = (0, $8WPOm.disableAllButtons)();
                                    (0, $8WPOm.showProgressBar)();
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4,
                                        (0, $ldRsu.default)("/api/images/upload", {
                                            method: "POST",
                                            headers: {
                                                Accept: "text/vnd.turbo-stream.html, application/json"
                                            },
                                            onDownloadProgress: (0, $8WPOm.progressEventHandler),
                                            onUploadProgress: (0, $8WPOm.progressEventHandler)
                                        })
                                    ];
                                case 2:
                                    resp = _state.sent();
                                    body = resp.data;
                                    upload_url = body.result.upload_url;
                                    formData = new FormData();
                                    formData.append("file", blob);
                                    return [
                                        4,
                                        (0, $ldRsu.default)(upload_url, {
                                            method: "POST",
                                            data: formData,
                                            headers: {
                                                Accept: "text/vnd.turbo-stream.html, application/json"
                                            },
                                            onDownloadProgress: (0, $8WPOm.progressEventHandler),
                                            onUploadProgress: (0, $8WPOm.progressEventHandler)
                                        })
                                    ];
                                case 3:
                                    uploadResp = _state.sent();
                                    uploadRespBody = uploadResp.data;
                                    url = uploadRespBody.result.url;
                                    inputValue.value = url;
                                    formUpload.submit();
                                    return [
                                        3,
                                        6
                                    ];
                                case 4:
                                    e = _state.sent();
                                    // revert is only called for error branch because
                                    // The success branch also loads a new page.
                                    // Keeping the buttons in disabled state reduce flickering in the UI.
                                    revert();
                                    (0, $fB9zd.handleAxiosError)(e);
                                    return [
                                        3,
                                        6
                                    ];
                                case 5:
                                    (0, $8WPOm.hideProgressBar)();
                                    return [
                                        7
                                    ];
                                case 6:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(blob) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        }
    ]);
    return ImagePickerController;
}((0, $bhrDl.Controller));
$4549ab881969af81$export$53e562c37b02f57d.targets = [
    "inputFile",
    "buttonFile",
    "buttonSave",
    "buttonRemove",
    "imgCropper",
    "imgPreview",
    "inputValue",
    "formUpload"
];



var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $bhrDl = parcelRequire("bhrDl");

var $2BGKp = parcelRequire("2BGKp");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $fYvNR = parcelRequire("fYvNR");

var $a1vXf = parcelRequire("a1vXf");
function $c5ea3a18e25ed7dc$export$d1fa2f47db032cbd(index) {
    return Math.pow(2, index) * 1000;
}
var $c5ea3a18e25ed7dc$export$f88a093e01236ed0 = /*#__PURE__*/ function(EventTarget1) {
    "use strict";
    (0, $i0LXg._)(RetryEventTarget, EventTarget1);
    var _super = (0, $a1vXf._)(RetryEventTarget);
    function RetryEventTarget(options) {
        (0, $9j09T._)(this, RetryEventTarget);
        var _this;
        var _this_options_abortController_signal, _this_options_abortController, _this_options;
        _this = _super.call(this);
        _this.options = options;
        _this.index = 0;
        _this.handle = null;
        (_this_options = _this.options) === null || _this_options === void 0 ? void 0 : (_this_options_abortController = _this_options.abortController) === null || _this_options_abortController === void 0 ? void 0 : (_this_options_abortController_signal = _this_options_abortController.signal) === null || _this_options_abortController_signal === void 0 ? void 0 : _this_options_abortController_signal.addEventListener("abort", function() {
            _this._cancelSchedule();
        });
        return _this;
    }
    (0, $eDeHT._)(RetryEventTarget, [
        {
            key: "_cancelSchedule",
            value: function _cancelSchedule() {
                if (this.handle != null) {
                    clearTimeout(this.handle);
                    this.handle = null;
                }
            }
        },
        {
            key: "_dispatchRetry",
            value: function _dispatchRetry() {
                this.dispatchEvent(new CustomEvent("retry"));
            }
        },
        {
            key: "scheduleRetry",
            value: function scheduleRetry() {
                var _this = this;
                var _this_options, _this_options1;
                var _this_options_maxIndex;
                var maxIndex = (_this_options_maxIndex = (_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.maxIndex) !== null && _this_options_maxIndex !== void 0 ? _this_options_maxIndex : 2;
                var _this_options_indexToMillis;
                var indexToMillis = (_this_options_indexToMillis = (_this_options1 = this.options) === null || _this_options1 === void 0 ? void 0 : _this_options1.indexToMillis) !== null && _this_options_indexToMillis !== void 0 ? _this_options_indexToMillis : $c5ea3a18e25ed7dc$export$d1fa2f47db032cbd;
                var oldIndex = this.index;
                var newIndex = oldIndex < maxIndex ? oldIndex + 1 : maxIndex;
                this.index = newIndex;
                this._cancelSchedule();
                var delay = indexToMillis(oldIndex);
                this.handle = setTimeout(function() {
                    _this._dispatchRetry();
                }, delay);
            }
        },
        {
            key: "markSuccess",
            value: function markSuccess() {
                this.index = 0;
                this._cancelSchedule();
            }
        }
    ]);
    return RetryEventTarget;
}((0, $fYvNR._)(EventTarget));


function $260533b4e9b5e7fd$var$refreshPage() {
    var url = window.location.pathname;
    if (window.location.search !== "") url += window.location.search;
    if (window.location.hash !== "") url += window.location.hash;
    (0, $2BGKp.visit)(url, {
        action: "replace"
    });
}
var $260533b4e9b5e7fd$export$873a738f46b480f6 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(WebSocketController, Controller);
    var _super = (0, $a1vXf._)(WebSocketController);
    function WebSocketController() {
        (0, $9j09T._)(this, WebSocketController);
        var _this;
        _this = _super.apply(this, arguments);
        _this.ws = null;
        _this.abortController = null;
        _this.retryEventTarget = null;
        _this.dispose = function() {
            if (_this.ws != null) {
                _this.ws.onclose = function() {};
                _this.ws.close();
            }
            _this.ws = null;
        };
        _this.refreshIfNeeded = function() {
            var ele = document.querySelector('[data-is-refresh-link="true"]');
            if (ele) // if there is refresh link in the page, don't refresh automatically
            return;
            var btn = document.querySelector('[data-submit-when-refresh="true"]');
            if (btn instanceof HTMLElement) {
                btn.click();
                return;
            }
            $260533b4e9b5e7fd$var$refreshPage();
        };
        _this.connectWebSocket = function(isReconnect) {
            var scheme = window.location.protocol === "https:" ? "wss:" : "ws:";
            var host = window.location.host;
            var meta = document.querySelector('meta[name="x-authgear-page-loaded-at"]');
            var sessionUpdatedAfter = "";
            if (meta != null) sessionUpdatedAfter = meta.content || "";
            // We only pass session_updated_after in case of reconnection.
            // If we also pass session_updated_after in first connection,
            // we will receive a refresh message which will refresh the page immediately.
            // This will cause the page to load twice.
            var url = "".concat(scheme, "//").concat(host, "/_internals/ws") + (isReconnect && sessionUpdatedAfter != "" ? "?session_updated_after=".concat(sessionUpdatedAfter) : "");
            _this.ws = new WebSocket(url);
            _this.ws.onopen = function(e) {
                var _this_retryEventTarget;
                console.log("ws onopen", e);
                (_this_retryEventTarget = _this.retryEventTarget) === null || _this_retryEventTarget === void 0 ? void 0 : _this_retryEventTarget.markSuccess();
            };
            _this.ws.onclose = function(e) {
                var _this_retryEventTarget;
                console.log("ws onclose", e);
                // Close code 1000 means we do not need to reconnect.
                if (e.code === 1000) return;
                (_this_retryEventTarget = _this.retryEventTarget) === null || _this_retryEventTarget === void 0 ? void 0 : _this_retryEventTarget.scheduleRetry();
            };
            _this.ws.onerror = function(e) {
                console.error("ws onerror", e);
            };
            _this.ws.onmessage = function(e) {
                console.log("ws onmessage", e);
                var message = JSON.parse(e.data);
                switch(message.kind){
                    case "refresh":
                        _this.refreshIfNeeded();
                }
            };
        };
        return _this;
    }
    (0, $eDeHT._)(WebSocketController, [
        {
            key: "connect",
            value: function connect() {
                var _this = this;
                if (this.disabledValue) return;
                this.abortController = new AbortController();
                this.retryEventTarget = new (0, $c5ea3a18e25ed7dc$export$f88a093e01236ed0)({
                    abortController: this.abortController
                });
                this.retryEventTarget.addEventListener("retry", function() {
                    _this.dispose();
                    _this.connectWebSocket(true);
                });
                this.connectWebSocket(false);
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.dispose();
                if (this.abortController != null) this.abortController.abort();
                this.abortController = null;
                this.retryEventTarget = null;
            }
        }
    ]);
    return WebSocketController;
}((0, $bhrDl.Controller));
$260533b4e9b5e7fd$export$873a738f46b480f6.values = {
    disabled: Boolean
};



var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $bhrDl = parcelRequire("bhrDl");

var $2BGKp = parcelRequire("2BGKp");

function $858985dec7133fe7$var$refreshPage() {
    var url = window.location.pathname;
    if (window.location.search !== "") url += window.location.search;
    if (window.location.hash !== "") url += window.location.hash;
    (0, $2BGKp.visit)(url, {
        action: "replace"
    });
}
var $858985dec7133fe7$export$6305564e8c07011f = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(AuthflowWebsocketController, Controller);
    var _super = (0, $a1vXf._)(AuthflowWebsocketController);
    function AuthflowWebsocketController() {
        (0, $9j09T._)(this, AuthflowWebsocketController);
        var _this;
        _this = _super.apply(this, arguments);
        _this.ws = null;
        _this.abortController = null;
        _this.retryEventTarget = null;
        _this.dispose = function() {
            if (_this.ws != null) {
                _this.ws.onclose = function() {};
                _this.ws.close();
            }
            _this.ws = null;
        };
        _this.refreshIfNeeded = function() {
            $858985dec7133fe7$var$refreshPage();
        };
        _this.connectWebSocket = function() {
            var url = _this.urlValue;
            _this.ws = new WebSocket(url);
            _this.ws.onopen = function(e) {
                var _this_retryEventTarget;
                console.info("authflow_websocket onopen", e);
                (_this_retryEventTarget = _this.retryEventTarget) === null || _this_retryEventTarget === void 0 ? void 0 : _this_retryEventTarget.markSuccess();
            };
            _this.ws.onclose = function(e) {
                var _this_retryEventTarget;
                console.info("authflow_websocket onclose", e);
                // Close code 1000 means we do not need to reconnect.
                if (e.code === 1000) return;
                (_this_retryEventTarget = _this.retryEventTarget) === null || _this_retryEventTarget === void 0 ? void 0 : _this_retryEventTarget.scheduleRetry();
            };
            _this.ws.onerror = function(e) {
                console.error("authflow_websocket onerror", e);
            };
            _this.ws.onmessage = function(e) {
                console.info("authflow_websocket onmessage", e);
                var message = JSON.parse(e.data);
                switch(message.kind){
                    case "refresh":
                        _this.refreshIfNeeded();
                }
            };
        };
        return _this;
    }
    (0, $eDeHT._)(AuthflowWebsocketController, [
        {
            key: "connect",
            value: function connect() {
                var _this = this;
                this.abortController = new AbortController();
                this.retryEventTarget = new (0, $c5ea3a18e25ed7dc$export$f88a093e01236ed0)({
                    abortController: this.abortController
                });
                this.retryEventTarget.addEventListener("retry", function() {
                    _this.dispose();
                    _this.connectWebSocket();
                });
                this.connectWebSocket();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.dispose();
                if (this.abortController != null) this.abortController.abort();
                this.abortController = null;
                this.retryEventTarget = null;
            }
        }
    ]);
    return AuthflowWebsocketController;
}((0, $bhrDl.Controller));
$858985dec7133fe7$export$6305564e8c07011f.values = {
    url: String
};



var $jpnpo = parcelRequire("jpnpo");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");

var $bhrDl = parcelRequire("bhrDl");

var $2BGKp = parcelRequire("2BGKp");

var $ldRsu = parcelRequire("ldRsu");
function $ad122db40346eba6$var$refreshPage() {
    var url = window.location.pathname;
    if (window.location.search !== "") url += window.location.search;
    if (window.location.hash !== "") url += window.location.hash;
    (0, $2BGKp.visit)(url, {
        action: "replace"
    });
}
var $ad122db40346eba6$var$TIMEOUT = 3000;
var $ad122db40346eba6$export$c36e5e28cd33a95 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(AuthflowPollingController, Controller);
    var _super = (0, $a1vXf._)(AuthflowPollingController);
    function AuthflowPollingController() {
        (0, $9j09T._)(this, AuthflowPollingController);
        var _this;
        _this = _super.apply(this, arguments);
        _this.setTimeoutHandle = null;
        return _this;
    }
    (0, $eDeHT._)(AuthflowPollingController, [
        {
            key: "connect",
            value: function connect() {
                this.poll();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.cancel();
            }
        },
        {
            key: "poll",
            value: function poll() {
                var recur = true;
                var _this = this;
                this.setTimeoutHandle = window.setTimeout(/*#__PURE__*/ (0, $jpnpo._)(function() {
                    var _response_data_result_action_data, _response_data_result_action, _response_data_result, _response_data, response, e;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    3,
                                    4
                                ]);
                                return [
                                    4,
                                    (0, $ldRsu.default)("/api/v1/authentication_flows/states", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        data: {
                                            state_token: _this.statetokenValue
                                        }
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                console.info("authflow_polling poll success");
                                if (((_response_data = response.data) === null || _response_data === void 0 ? void 0 : (_response_data_result = _response_data.result) === null || _response_data_result === void 0 ? void 0 : (_response_data_result_action = _response_data_result.action) === null || _response_data_result_action === void 0 ? void 0 : (_response_data_result_action_data = _response_data_result_action.data) === null || _response_data_result_action_data === void 0 ? void 0 : _response_data_result_action_data.can_check) === true) {
                                    recur = false;
                                    $ad122db40346eba6$var$refreshPage();
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                e = _state.sent();
                                console.error("authflow_polling error", e);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                if (recur) _this.poll();
                                else _this.cancel();
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }), $ad122db40346eba6$var$TIMEOUT);
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                if (this.setTimeoutHandle != null) window.clearTimeout(this.setTimeoutHandle);
            }
        }
    ]);
    return AuthflowPollingController;
}((0, $bhrDl.Controller));
$ad122db40346eba6$export$c36e5e28cd33a95.values = {
    statetoken: String
};



var $13ALN = parcelRequire("13ALN");

var $3kulJ = parcelRequire("3kulJ");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $bhrDl = parcelRequire("bhrDl");
var $7e7dbfcbf1eb3f62$export$d507f25e63650365 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(ModalController, Controller);
    var _super = (0, $a1vXf._)(ModalController);
    function ModalController() {
        (0, $9j09T._)(this, ModalController);
        var _this;
        _this = _super.apply(this, arguments);
        _this.submitButton = null;
        _this.confirmed = false;
        _this.closeModal = function() {
            _this.confirmed = false;
            _this.modalEleTarget.classList.add("closed");
        };
        return _this;
    }
    (0, $eDeHT._)(ModalController, [
        {
            key: "onClickModalAction",
            value: function onClickModalAction(e) {
                var _this_submitButton;
                this.confirmed = true;
                (_this_submitButton = this.submitButton) === null || _this_submitButton === void 0 ? void 0 : _this_submitButton.click();
            }
        },
        {
            key: "onClickModalCancel",
            value: function onClickModalCancel(e) {
                this.closeModal();
            }
        },
        {
            key: "confirmFormSubmit",
            value: function confirmFormSubmit(e) {
                if (this.confirmed) {
                    // close the modal and perform the default behaviour
                    this.closeModal();
                    return;
                }
                e.preventDefault();
                this.submitButton = e.currentTarget;
                var button = this.submitButton;
                var modalTitleEle = this.modalTitleEleTarget;
                var modalBodyEle = this.modalBodyEleTarget;
                var modalActionBtnEle = this.modalActionBtnEleTarget;
                var modalCancelBtnEle = this.modalCancelBtnEleTarget;
                modalTitleEle.innerText = button.dataset["modalTitle"] || "";
                modalBodyEle.innerText = button.dataset["modalBody"] || "";
                modalActionBtnEle.innerText = button.dataset["modalActionLabel"] || "";
                modalCancelBtnEle.innerText = button.dataset["modalCancelLabel"] || "";
                this.modalEleTarget.classList.remove("closed");
            }
        }
    ]);
    return ModalController;
}((0, $bhrDl.Controller));
$7e7dbfcbf1eb3f62$export$d507f25e63650365.targets = [
    "modalEle",
    "modalTitleEle",
    "modalBodyEle",
    "modalActionBtnEle",
    "modalCancelBtnEle"
];



var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $bhrDl = parcelRequire("bhrDl");
var $514e8b9423d166d2$export$e5ebe865d6ee37f8 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(BackButtonController, Controller);
    var _super = (0, $a1vXf._)(BackButtonController);
    function BackButtonController() {
        (0, $9j09T._)(this, BackButtonController);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(BackButtonController, [
        {
            key: "connect",
            value: function connect() {
                this.element.classList.remove("invisible");
            }
        }
    ]);
    return BackButtonController;
}((0, $bhrDl.Controller));



var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $bhrDl = parcelRequire("bhrDl");
var $10b0af16b46e080f$export$f720643190922065 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(SimpleModalController, Controller);
    var _super = (0, $a1vXf._)(SimpleModalController);
    function SimpleModalController() {
        (0, $9j09T._)(this, SimpleModalController);
        var _this;
        _this = _super.apply(this, arguments);
        _this.closeModal = function(e) {
            e.preventDefault();
            var targetModalID = e.params.id;
            _this.changeModalVisibility(targetModalID, false);
        };
        _this.showModal = function(e) {
            e.preventDefault();
            var targetModalID = e.params.id;
            _this.changeModalVisibility(targetModalID, true);
        };
        return _this;
    }
    (0, $eDeHT._)(SimpleModalController, [
        {
            key: "changeModalVisibility",
            value: function changeModalVisibility(modalID, show) {
                for(var i = 0; i < this.modalTargets.length; i++){
                    var curModalID = this.modalTargets[i].getAttribute("data-simple-modal-id");
                    if (modalID !== curModalID) continue;
                    if (show) this.modalTargets[i].classList.remove("closed");
                    else this.modalTargets[i].classList.add("closed");
                }
            }
        }
    ]);
    return SimpleModalController;
}((0, $bhrDl.Controller));
$10b0af16b46e080f$export$f720643190922065.targets = [
    "modal"
];



var $jpnpo = parcelRequire("jpnpo");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $kbgOD = parcelRequire("kbgOD");

var $i1q4Z = parcelRequire("i1q4Z");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");

var $bhrDl = parcelRequire("bhrDl");

var $ldRsu = parcelRequire("ldRsu");

var $fB9zd = parcelRequire("fB9zd");
// Credit to https://developer.mozilla.org/en-US/docs/Glossary/Base64
function $6f61f55004c23ccb$var$b64ToUint6(nChr) {
    return nChr > 64 && nChr < 91 ? nChr - 65 : nChr > 96 && nChr < 123 ? nChr - 71 : nChr > 47 && nChr < 58 ? nChr + 4 : nChr === 43 ? 62 : nChr === 47 ? 63 : 0;
}
function $6f61f55004c23ccb$export$8f0c237d3e8188bc(sBase64, nBlocksSize) {
    var sB64Enc = sBase64.replace(/[^A-Za-z0-9\+\/]/g, ""), nInLen = sB64Enc.length, nOutLen = nBlocksSize ? Math.ceil((nInLen * 3 + 1 >> 2) / nBlocksSize) * nBlocksSize : nInLen * 3 + 1 >> 2, taBytes = new Uint8Array(nOutLen);
    for(var nMod3, nMod4, nUint24 = 0, nOutIdx = 0, nInIdx = 0; nInIdx < nInLen; nInIdx++){
        nMod4 = nInIdx & 3;
        nUint24 |= $6f61f55004c23ccb$var$b64ToUint6(sB64Enc.charCodeAt(nInIdx)) << 6 * (3 - nMod4);
        if (nMod4 === 3 || nInLen - nInIdx === 1) {
            for(nMod3 = 0; nMod3 < 3 && nOutIdx < nOutLen; nMod3++, nOutIdx++)taBytes[nOutIdx] = nUint24 >>> (16 >>> nMod3 & 24) & 255;
            nUint24 = 0;
        }
    }
    return taBytes;
}
/* Base64 string to array encoding */ function $6f61f55004c23ccb$var$uint6ToB64(nUint6) {
    return nUint6 < 26 ? nUint6 + 65 : nUint6 < 52 ? nUint6 + 71 : nUint6 < 62 ? nUint6 - 4 : nUint6 === 62 ? 43 : nUint6 === 63 ? 47 : 65;
}
function $6f61f55004c23ccb$export$314edafa085027ab(aBytes) {
    var nMod3 = 2, sB64Enc = "";
    for(var nLen = aBytes.length, nUint24 = 0, nIdx = 0; nIdx < nLen; nIdx++){
        nMod3 = nIdx % 3;
        if (nIdx > 0 && nIdx * 4 / 3 % 76 === 0) sB64Enc += "\r\n";
        nUint24 |= aBytes[nIdx] << (16 >>> nMod3 & 24);
        if (nMod3 === 2 || aBytes.length - nIdx === 1) {
            sB64Enc += String.fromCodePoint($6f61f55004c23ccb$var$uint6ToB64(nUint24 >>> 18 & 63), $6f61f55004c23ccb$var$uint6ToB64(nUint24 >>> 12 & 63), $6f61f55004c23ccb$var$uint6ToB64(nUint24 >>> 6 & 63), $6f61f55004c23ccb$var$uint6ToB64(nUint24 & 63));
            nUint24 = 0;
        }
    }
    return sB64Enc.substr(0, sB64Enc.length - 2 + nMod3) + (nMod3 === 2 ? "" : nMod3 === 1 ? "=" : "==");
}


function $dde6367c51df3420$export$9500be174f822578(base64url) {
    var base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
    if (base64.length % 4 !== 0) {
        var count = 4 - base64.length % 4;
        base64 += "=".repeat(count);
    }
    return base64;
}
function $dde6367c51df3420$export$a8d7e00373552942(base64) {
    return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function $dde6367c51df3420$export$9c3cebc506633257(str) {
    return str.replace(/\r/g, "").replace(/\n/g, "");
}



function $10747cf896bc087a$var$passkeyIsAvailable() {
    return typeof window.PublicKeyCredential !== "undefined" && typeof window.navigator.credentials !== "undefined";
}
function $10747cf896bc087a$var$deserializeCreationOptions(creationOptions) {
    var base64URLChallenge = creationOptions.publicKey.challenge;
    var challenge = (0, $6f61f55004c23ccb$export$8f0c237d3e8188bc)((0, $dde6367c51df3420$export$9500be174f822578)(base64URLChallenge));
    creationOptions.publicKey.challenge = challenge;
    var base64URLUserID = creationOptions.publicKey.user.id;
    var userID = (0, $6f61f55004c23ccb$export$8f0c237d3e8188bc)((0, $dde6367c51df3420$export$9500be174f822578)(base64URLUserID));
    creationOptions.publicKey.user.id = userID;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (creationOptions.publicKey.excludeCredentials != null) try {
        for(var _iterator = creationOptions.publicKey.excludeCredentials[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var c = _step.value;
            c.id = (0, $6f61f55004c23ccb$export$8f0c237d3e8188bc)((0, $dde6367c51df3420$export$9500be174f822578)(c.id));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return creationOptions;
}
function $10747cf896bc087a$var$deserializeRequestOptions(requestOptions) {
    var base64URLChallenge = requestOptions.publicKey.challenge;
    var challenge = (0, $6f61f55004c23ccb$export$8f0c237d3e8188bc)((0, $dde6367c51df3420$export$9500be174f822578)(base64URLChallenge));
    requestOptions.publicKey.challenge = challenge;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (requestOptions.publicKey.allowCredentials) try {
        for(var _iterator = requestOptions.publicKey.allowCredentials[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var c = _step.value;
            c.id = (0, $6f61f55004c23ccb$export$8f0c237d3e8188bc)((0, $dde6367c51df3420$export$9500be174f822578)(c.id));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return requestOptions;
}
function $10747cf896bc087a$var$serializeAttestationResponse(credential) {
    var response = credential.response;
    var attestationObject = (0, $dde6367c51df3420$export$9c3cebc506633257)((0, $dde6367c51df3420$export$a8d7e00373552942)((0, $6f61f55004c23ccb$export$314edafa085027ab)(new Uint8Array(response.attestationObject))));
    var clientDataJSON = (0, $dde6367c51df3420$export$9c3cebc506633257)((0, $dde6367c51df3420$export$a8d7e00373552942)((0, $6f61f55004c23ccb$export$314edafa085027ab)(new Uint8Array(response.clientDataJSON))));
    var transports = [];
    if (typeof response.getTransports === "function") transports = response.getTransports();
    var clientExtensionResults = credential.getClientExtensionResults();
    return {
        id: credential.id,
        rawId: credential.id,
        type: credential.type,
        response: {
            attestationObject: attestationObject,
            clientDataJSON: clientDataJSON,
            transports: transports
        },
        clientExtensionResults: clientExtensionResults
    };
}
function $10747cf896bc087a$var$serializeAssertionResponse(credential) {
    var response = credential.response;
    var authenticatorData = (0, $dde6367c51df3420$export$9c3cebc506633257)((0, $dde6367c51df3420$export$a8d7e00373552942)((0, $6f61f55004c23ccb$export$314edafa085027ab)(new Uint8Array(response.authenticatorData))));
    var clientDataJSON = (0, $dde6367c51df3420$export$9c3cebc506633257)((0, $dde6367c51df3420$export$a8d7e00373552942)((0, $6f61f55004c23ccb$export$314edafa085027ab)(new Uint8Array(response.clientDataJSON))));
    var signature = (0, $dde6367c51df3420$export$9c3cebc506633257)((0, $dde6367c51df3420$export$a8d7e00373552942)((0, $6f61f55004c23ccb$export$314edafa085027ab)(new Uint8Array(response.signature))));
    var userHandle = response.userHandle == null ? undefined : (0, $dde6367c51df3420$export$9c3cebc506633257)((0, $dde6367c51df3420$export$a8d7e00373552942)((0, $6f61f55004c23ccb$export$314edafa085027ab)(new Uint8Array(response.userHandle))));
    var clientExtensionResults = credential.getClientExtensionResults();
    return {
        id: credential.id,
        rawId: credential.id,
        type: credential.type,
        response: {
            authenticatorData: authenticatorData,
            clientDataJSON: clientDataJSON,
            signature: signature,
            userHandle: userHandle
        },
        clientExtensionResults: clientExtensionResults
    };
}
function $10747cf896bc087a$var$isEmptyAllowCredentialsError(err) {
    return err instanceof DOMException && /allowCredentials/i.test(err.message);
}
function $10747cf896bc087a$var$isSafariCancel(err) {
    return err instanceof DOMException && err.name === "NotAllowedError" && // "This request has been cancelled by the user."
    /cancel/i.test(err.message);
}
function $10747cf896bc087a$var$isSafariTimeout(err) {
    return err instanceof DOMException && err.name === "HierarchyRequestError" && // "The operation would yield an incorrect node tree."
    /node tree/i.test(err.message);
}
function $10747cf896bc087a$var$isSafariAndroidError(err) {
    // This happens when the user chooses to use Android phone to scan QR code.
    // And the passkey is not found on that Android phone.
    // If security key is used, the error message is shown in the modal dialog and the dialog will not close.
    // Thus we cannot detect security key error.
    return err instanceof DOMException && err.name === "NotAllowedError" && // "Operation failed."
    /operation.*fail/i.test(err.message);
}
function $10747cf896bc087a$var$isChromeCancelOrTimeout(err) {
    return err instanceof DOMException && err.name === "NotAllowedError" && // "The operation either timed out or was not allowed. See: https://www.w3.org/TR/webauthn-2/#sctn-privacy-considerations-client."
    /time.*out/i.test(err.message);
}
function $10747cf896bc087a$var$isFirefoxCancel(err) {
    return err instanceof DOMException && err.name === "AbortError" && // "The operation was aborted. "
    /operation.*abort/i.test(err.message);
}
function $10747cf896bc087a$var$isAbortControllerError(err) {
    return err instanceof DOMException && err.name === "AbortError";
}
function $10747cf896bc087a$var$isFirefoxSecurityKeyError(err) {
    return err instanceof DOMException && err.name === "InvalidStateError" && // "An attempt was made to use an object that is not, or is no longer, usable"
    /no.*usable/i.test(err.message);
}
function $10747cf896bc087a$var$isSafariDuplicateError(err) {
    return err instanceof DOMException && err.name === "InvalidStateError" && // "At least one credential matches an entry of the excludeCredentials list in the platform attached authenticator."
    /excludeCredentials/i.test(err.message);
}
function $10747cf896bc087a$var$isChromeDuplicateError(err) {
    return err instanceof DOMException && err.name === "InvalidStateError" && // "The user attempted to register an authenticator that contains one of the credentials already registered with the relying party."
    /already register/i.test(err.message);
}
function $10747cf896bc087a$var$handleError(err1) {
    console.error(err1);
    var errorThatCanSimplyBeIgnored = [
        $10747cf896bc087a$var$isSafariCancel,
        $10747cf896bc087a$var$isSafariTimeout,
        $10747cf896bc087a$var$isChromeCancelOrTimeout,
        $10747cf896bc087a$var$isFirefoxCancel,
        // Firefox timeout was not observed.
        $10747cf896bc087a$var$isAbortControllerError
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = errorThatCanSimplyBeIgnored[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var p = _step.value;
            if (p(err1)) return;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if ($10747cf896bc087a$var$isSafariAndroidError(err1)) {
        (0, $fB9zd.showErrorMessage)("error-message-no-passkey");
        return;
    }
    if ($10747cf896bc087a$var$isFirefoxSecurityKeyError(err1)) {
        (0, $fB9zd.showErrorMessage)("error-message-no-passkey");
        return;
    }
    if ($10747cf896bc087a$var$isEmptyAllowCredentialsError(err1)) (0, $fB9zd.showErrorMessage)("error-message-passkey-empty-allow-credentials");
    if ($10747cf896bc087a$var$isSafariDuplicateError(err1) || $10747cf896bc087a$var$isChromeDuplicateError(err1)) (0, $fB9zd.showErrorMessage)("error-message-passkey-duplicate");
    return false;
}
var $10747cf896bc087a$export$58aebb7fd963a6e5 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(PasskeyCreationController, Controller);
    var _super = (0, $a1vXf._)(PasskeyCreationController);
    function PasskeyCreationController() {
        (0, $9j09T._)(this, PasskeyCreationController);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(PasskeyCreationController, [
        {
            key: "connect",
            value: function connect() {
                // Disable the button if PublicKeyCredential is unavailable.
                if (!$10747cf896bc087a$var$passkeyIsAvailable()) {
                    this.buttonTarget.disabled = true;
                    return;
                }
            }
        },
        {
            key: "create",
            value: function create(e) {
                e.preventDefault();
                e.stopPropagation();
                this._create();
            }
        },
        {
            key: "_create",
            value: function _create() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var resp, options, rawResponse, response, responseString, e, e1;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    (0, $ldRsu.default)("/_internals/passkey/creation_options", {
                                        method: "post"
                                    })
                                ];
                            case 1:
                                resp = _state.sent();
                                options = $10747cf896bc087a$var$deserializeCreationOptions(resp.data.result);
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    window.navigator.credentials.create(options)
                                ];
                            case 3:
                                rawResponse = _state.sent();
                                if (rawResponse instanceof PublicKeyCredential) {
                                    response = $10747cf896bc087a$var$serializeAttestationResponse(rawResponse);
                                    responseString = JSON.stringify(response);
                                    _this.inputTarget.value = responseString;
                                    // It seems that we should use form.submit() to submit the form.
                                    // but form.submit() does NOT trigger submit event,
                                    // which is essential for XHR form submission to work.
                                    // Therefore, we emulate form submission here by clicking the submit button.
                                    _this.submitTarget.click();
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e = _state.sent();
                                $10747cf896bc087a$var$handleError(e);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e1 = _state.sent();
                                (0, $fB9zd.handleAxiosError)(e1);
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PasskeyCreationController;
}((0, $bhrDl.Controller));
$10747cf896bc087a$export$58aebb7fd963a6e5.targets = [
    "button",
    "submit",
    "input"
];
var $10747cf896bc087a$export$4f73e5135a0b306 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(PasskeyRequestController, Controller);
    var _super = (0, $a1vXf._)(PasskeyRequestController);
    function PasskeyRequestController() {
        (0, $9j09T._)(this, PasskeyRequestController);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(PasskeyRequestController, [
        {
            key: "connect",
            value: function connect() {
                // Disable the button if PublicKeyCredential is unavailable.
                if (!$10747cf896bc087a$var$passkeyIsAvailable()) {
                    this.buttonTarget.disabled = true;
                    return;
                }
                if (this.autoValue === "true") this._use();
            }
        },
        {
            key: "use",
            value: function use(e) {
                e.preventDefault();
                e.stopPropagation();
                this._use();
            }
        },
        {
            key: "_use",
            value: function _use() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var params, resp, options, rawResponse, response, responseString, e, e1;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    6,
                                    ,
                                    7
                                ]);
                                params = new URLSearchParams();
                                params.set("allow_credentials", _this.allowCredentialsValue);
                                return [
                                    4,
                                    (0, $ldRsu.default)("/_internals/passkey/request_options", {
                                        method: "post",
                                        data: params
                                    })
                                ];
                            case 1:
                                resp = _state.sent();
                                options = $10747cf896bc087a$var$deserializeRequestOptions(resp.data.result);
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    window.navigator.credentials.get(options)
                                ];
                            case 3:
                                rawResponse = _state.sent();
                                if (rawResponse instanceof PublicKeyCredential) {
                                    response = $10747cf896bc087a$var$serializeAssertionResponse(rawResponse);
                                    responseString = JSON.stringify(response);
                                    _this.inputTarget.value = responseString;
                                    // It seems that we should use form.submit() to submit the form.
                                    // but form.submit() does NOT trigger submit event,
                                    // which is essential for XHR form submission to work.
                                    // Therefore, we emulate form submission here by clicking the submit button.
                                    _this.submitTarget.click();
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e = _state.sent();
                                $10747cf896bc087a$var$handleError(e);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e1 = _state.sent();
                                (0, $fB9zd.handleAxiosError)(e1);
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PasskeyRequestController;
}((0, $bhrDl.Controller));
$10747cf896bc087a$export$4f73e5135a0b306.targets = [
    "button",
    "submit",
    "input"
];
$10747cf896bc087a$export$4f73e5135a0b306.values = {
    auto: String,
    allowCredentials: String
};
var $10747cf896bc087a$export$b131e57e56d01eab = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(AuthflowPasskeyRequestController, Controller);
    var _super = (0, $a1vXf._)(AuthflowPasskeyRequestController);
    function AuthflowPasskeyRequestController() {
        (0, $9j09T._)(this, AuthflowPasskeyRequestController);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(AuthflowPasskeyRequestController, [
        {
            key: "connect",
            value: function connect() {
                // Disable the button if PublicKeyCredential is unavailable.
                if (!$10747cf896bc087a$var$passkeyIsAvailable()) {
                    this.buttonTarget.disabled = true;
                    return;
                }
                if (this.autoValue === "true") this._use();
            }
        },
        {
            key: "use",
            value: function use(e) {
                e.preventDefault();
                e.stopPropagation();
                this._use();
            }
        },
        {
            key: "_use",
            value: function _use() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var optionsJSON, options, rawResponse, response, responseString, e;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                optionsJSON = JSON.parse(_this.optionsValue);
                                options = $10747cf896bc087a$var$deserializeRequestOptions(optionsJSON);
                                return [
                                    4,
                                    window.navigator.credentials.get(options)
                                ];
                            case 1:
                                rawResponse = _state.sent();
                                if (rawResponse instanceof PublicKeyCredential) {
                                    response = $10747cf896bc087a$var$serializeAssertionResponse(rawResponse);
                                    responseString = JSON.stringify(response);
                                    _this.inputTarget.value = responseString;
                                    // It seems that we should use form.submit() to submit the form.
                                    // but form.submit() does NOT trigger submit event,
                                    // which is essential for XHR form submission to work.
                                    // Therefore, we emulate form submission here by clicking the submit button.
                                    _this.submitTarget.click();
                                }
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                $10747cf896bc087a$var$handleError(e);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AuthflowPasskeyRequestController;
}((0, $bhrDl.Controller));
$10747cf896bc087a$export$b131e57e56d01eab.targets = [
    "button",
    "submit",
    "input"
];
$10747cf896bc087a$export$b131e57e56d01eab.values = {
    options: String,
    auto: String
};
var $10747cf896bc087a$export$38c3ed2085643c70 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(AuthflowPasskeyCreationController, Controller);
    var _super = (0, $a1vXf._)(AuthflowPasskeyCreationController);
    function AuthflowPasskeyCreationController() {
        (0, $9j09T._)(this, AuthflowPasskeyCreationController);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(AuthflowPasskeyCreationController, [
        {
            key: "connect",
            value: function connect() {
                // Disable the button if PublicKeyCredential is unavailable.
                if (!$10747cf896bc087a$var$passkeyIsAvailable()) {
                    this.buttonTarget.disabled = true;
                    return;
                }
            }
        },
        {
            key: "create",
            value: function create(e) {
                e.preventDefault();
                e.stopPropagation();
                this._create();
            }
        },
        {
            key: "_create",
            value: function _create() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var optionsJSON, options, rawResponse, response, responseString, e;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                optionsJSON = JSON.parse(_this.optionsValue);
                                options = $10747cf896bc087a$var$deserializeCreationOptions(optionsJSON);
                                return [
                                    4,
                                    window.navigator.credentials.create(options)
                                ];
                            case 1:
                                rawResponse = _state.sent();
                                if (rawResponse instanceof PublicKeyCredential) {
                                    response = $10747cf896bc087a$var$serializeAttestationResponse(rawResponse);
                                    responseString = JSON.stringify(response);
                                    _this.inputTarget.value = responseString;
                                    // It seems that we should use form.submit() to submit the form.
                                    // but form.submit() does NOT trigger submit event,
                                    // which is essential for XHR form submission to work.
                                    // Therefore, we emulate form submission here by clicking the submit button.
                                    _this.submitTarget.click();
                                }
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                $10747cf896bc087a$var$handleError(e);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AuthflowPasskeyCreationController;
}((0, $bhrDl.Controller));
$10747cf896bc087a$export$38c3ed2085643c70.targets = [
    "button",
    "submit",
    "input"
];
$10747cf896bc087a$export$38c3ed2085643c70.values = {
    options: String
};
var $10747cf896bc087a$export$61efde872c211e81 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(PasskeyAutofillController, Controller);
    var _super = (0, $a1vXf._)(PasskeyAutofillController);
    function PasskeyAutofillController() {
        (0, $9j09T._)(this, PasskeyAutofillController);
        var _this;
        _this = _super.apply(this, arguments);
        _this.abortController = null;
        _this.retryEventTarget = null;
        return _this;
    }
    (0, $eDeHT._)(PasskeyAutofillController, [
        {
            key: "connect",
            value: function connect() {
                var _this = this;
                if (!$10747cf896bc087a$var$passkeyIsAvailable()) return;
                this.abortController = new AbortController();
                this.retryEventTarget = new (0, $c5ea3a18e25ed7dc$export$f88a093e01236ed0)({
                    abortController: this.abortController
                });
                this.retryEventTarget.addEventListener("retry", function() {
                    _this.setupAutofill();
                });
                this.setupAutofill();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this_abortController;
                (_this_abortController = this.abortController) === null || _this_abortController === void 0 ? void 0 : _this_abortController.abort();
                this.abortController = null;
                this.retryEventTarget = null;
            }
        },
        {
            key: "setupAutofill",
            value: function setupAutofill() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var available, _this_retryEventTarget, params, resp, options, t0, _this_abortController, _this_retryEventTarget1, signal, rawResponse, response, responseString, e, _this_retryEventTarget2, t1, e1, _this_retryEventTarget3;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(typeof PublicKeyCredential.isConditionalMediationAvailable === "function")) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    PublicKeyCredential.isConditionalMediationAvailable()
                                ];
                            case 1:
                                available = _state.sent();
                                if (!available) return [
                                    3,
                                    9
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    8,
                                    ,
                                    9
                                ]);
                                params = new URLSearchParams();
                                params.set("conditional", "true");
                                return [
                                    4,
                                    (0, $ldRsu.default)("/_internals/passkey/request_options", {
                                        method: "post",
                                        data: params
                                    })
                                ];
                            case 3:
                                resp = _state.sent();
                                (_this_retryEventTarget = _this.retryEventTarget) === null || _this_retryEventTarget === void 0 ? void 0 : _this_retryEventTarget.markSuccess();
                                options = $10747cf896bc087a$var$deserializeRequestOptions(resp.data.result);
                                t0 = new Date().getTime();
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                signal = (_this_abortController = _this.abortController) === null || _this_abortController === void 0 ? void 0 : _this_abortController.signal;
                                return [
                                    4,
                                    window.navigator.credentials.get((0, $i1q4Z._)((0, $kbgOD._)({}, options), {
                                        signal: signal
                                    }))
                                ];
                            case 5:
                                rawResponse = _state.sent();
                                if (rawResponse instanceof PublicKeyCredential) {
                                    response = $10747cf896bc087a$var$serializeAssertionResponse(rawResponse);
                                    responseString = JSON.stringify(response);
                                    _this.inputTarget.value = responseString;
                                    // It seems that we should use form.submit() to submit the form.
                                    // but form.submit() does NOT trigger submit event,
                                    // which is essential for XHR form submission to work.
                                    // Therefore, we emulate form submission here by clicking the submit button.
                                    _this.submitTarget.click();
                                }
                                (_this_retryEventTarget1 = _this.retryEventTarget) === null || _this_retryEventTarget1 === void 0 ? void 0 : _this_retryEventTarget1.scheduleRetry();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e = _state.sent();
                                t1 = new Date().getTime();
                                if (e instanceof DOMException && e.name === "NotAllowedError" && t1 - t0 < 500) console.warn("passkey autofill weird error detected", e);
                                if (e instanceof DOMException && e.name === "AbortError") ;
                                else (_this_retryEventTarget2 = _this.retryEventTarget) === null || _this_retryEventTarget2 === void 0 ? void 0 : _this_retryEventTarget2.scheduleRetry();
                                $10747cf896bc087a$var$handleError(e);
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                e1 = _state.sent();
                                (0, $fB9zd.handleAxiosError)(e1);
                                (_this_retryEventTarget3 = _this.retryEventTarget) === null || _this_retryEventTarget3 === void 0 ? void 0 : _this_retryEventTarget3.scheduleRetry();
                                return [
                                    3,
                                    9
                                ];
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PasskeyAutofillController;
}((0, $bhrDl.Controller));
$10747cf896bc087a$export$61efde872c211e81.targets = [
    "submit",
    "input"
];



var $jpnpo = parcelRequire("jpnpo");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");

var $bhrDl = parcelRequire("bhrDl");

var $fB9zd = parcelRequire("fB9zd");
var $a86b41915ff3d72d$exports = {};
var $5fd94ee8b3d1ab6a$exports = {};
/*
  https://github.com/banksean wrapped Makoto Matsumoto and Takuji Nishimura's code in a namespace
  so it's better encapsulated. Now you can have multiple random number generators
  and they won't stomp all over eachother's state.

  If you want to use this as a substitute for Math.random(), use the random()
  method like so:

  var m = new MersenneTwister();
  var randomNumber = m.random();

  You can also call the other genrand_{foo}() methods on the instance.

  If you want to use a specific seed in order to get a repeatable random
  sequence, pass an integer into the constructor:

  var m = new MersenneTwister(123);

  and that will always produce the same random sequence.

  Sean McCullough (banksean@gmail.com)
*/ /*
   A C-program for MT19937, with initialization improved 2002/1/26.
   Coded by Takuji Nishimura and Makoto Matsumoto.

   Before using, initialize the state by using init_seed(seed)
   or init_by_array(init_key, key_length).

   Copyright (C) 1997 - 2002, Makoto Matsumoto and Takuji Nishimura,
   All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions
   are met:

     1. Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer.

     2. Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution.

     3. The names of its contributors may not be used to endorse or promote
        products derived from this software without specific prior written
        permission.

   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
   "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
   LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
   A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
   CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
   EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
   PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
   PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
   SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.


   Any feedback is very welcome.
   http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html
   email: m-mat @ math.sci.hiroshima-u.ac.jp (remove space)
*/ var $5fd94ee8b3d1ab6a$var$MersenneTwister = function MersenneTwister(seed) {
    if (seed == undefined) seed = new Date().getTime();
    /* Period parameters */ this.N = 624;
    this.M = 397;
    this.MATRIX_A = 0x9908b0df; /* constant vector a */ 
    this.UPPER_MASK = 0x80000000; /* most significant w-r bits */ 
    this.LOWER_MASK = 0x7fffffff; /* least significant r bits */ 
    this.mt = new Array(this.N); /* the array for the state vector */ 
    this.mti = this.N + 1; /* mti==N+1 means mt[N] is not initialized */ 
    if (seed.constructor == Array) this.init_by_array(seed, seed.length);
    else this.init_seed(seed);
};
/* initializes mt[N] with a seed */ /* origin name init_genrand */ $5fd94ee8b3d1ab6a$var$MersenneTwister.prototype.init_seed = function(s) {
    this.mt[0] = s >>> 0;
    for(this.mti = 1; this.mti < this.N; this.mti++){
        var s = this.mt[this.mti - 1] ^ this.mt[this.mti - 1] >>> 30;
        this.mt[this.mti] = (((s & 0xffff0000) >>> 16) * 1812433253 << 16) + (s & 0x0000ffff) * 1812433253 + this.mti;
        /* See Knuth TAOCP Vol2. 3rd Ed. P.106 for multiplier. */ /* In the previous versions, MSBs of the seed affect   */ /* only MSBs of the array mt[].                        */ /* 2002/01/09 modified by Makoto Matsumoto             */ this.mt[this.mti] >>>= 0;
    /* for >32 bit machines */ }
};
/* initialize by an array with array-length */ /* init_key is the array for initializing keys */ /* key_length is its length */ /* slight change for C++, 2004/2/26 */ $5fd94ee8b3d1ab6a$var$MersenneTwister.prototype.init_by_array = function(init_key, key_length) {
    var i, j, k;
    this.init_seed(19650218);
    i = 1;
    j = 0;
    k = this.N > key_length ? this.N : key_length;
    for(; k; k--){
        var s = this.mt[i - 1] ^ this.mt[i - 1] >>> 30;
        this.mt[i] = (this.mt[i] ^ (((s & 0xffff0000) >>> 16) * 1664525 << 16) + (s & 0x0000ffff) * 1664525) + init_key[j] + j; /* non linear */ 
        this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */ 
        i++;
        j++;
        if (i >= this.N) {
            this.mt[0] = this.mt[this.N - 1];
            i = 1;
        }
        if (j >= key_length) j = 0;
    }
    for(k = this.N - 1; k; k--){
        var s = this.mt[i - 1] ^ this.mt[i - 1] >>> 30;
        this.mt[i] = (this.mt[i] ^ (((s & 0xffff0000) >>> 16) * 1566083941 << 16) + (s & 0x0000ffff) * 1566083941) - i; /* non linear */ 
        this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */ 
        i++;
        if (i >= this.N) {
            this.mt[0] = this.mt[this.N - 1];
            i = 1;
        }
    }
    this.mt[0] = 0x80000000; /* MSB is 1; assuring non-zero initial array */ 
};
/* generates a random number on [0,0xffffffff]-interval */ /* origin name genrand_int32 */ $5fd94ee8b3d1ab6a$var$MersenneTwister.prototype.random_int = function() {
    var y;
    var mag01 = new Array(0x0, this.MATRIX_A);
    /* mag01[x] = x * MATRIX_A  for x=0,1 */ if (this.mti >= this.N) {
        var kk;
        if (this.mti == this.N + 1) /* if init_seed() has not been called, */ this.init_seed(5489); /* a default initial seed is used */ 
        for(kk = 0; kk < this.N - this.M; kk++){
            y = this.mt[kk] & this.UPPER_MASK | this.mt[kk + 1] & this.LOWER_MASK;
            this.mt[kk] = this.mt[kk + this.M] ^ y >>> 1 ^ mag01[y & 0x1];
        }
        for(; kk < this.N - 1; kk++){
            y = this.mt[kk] & this.UPPER_MASK | this.mt[kk + 1] & this.LOWER_MASK;
            this.mt[kk] = this.mt[kk + (this.M - this.N)] ^ y >>> 1 ^ mag01[y & 0x1];
        }
        y = this.mt[this.N - 1] & this.UPPER_MASK | this.mt[0] & this.LOWER_MASK;
        this.mt[this.N - 1] = this.mt[this.M - 1] ^ y >>> 1 ^ mag01[y & 0x1];
        this.mti = 0;
    }
    y = this.mt[this.mti++];
    /* Tempering */ y ^= y >>> 11;
    y ^= y << 7 & 0x9d2c5680;
    y ^= y << 15 & 0xefc60000;
    y ^= y >>> 18;
    return y >>> 0;
};
/* generates a random number on [0,0x7fffffff]-interval */ /* origin name genrand_int31 */ $5fd94ee8b3d1ab6a$var$MersenneTwister.prototype.random_int31 = function() {
    return this.random_int() >>> 1;
};
/* generates a random number on [0,1]-real-interval */ /* origin name genrand_real1 */ $5fd94ee8b3d1ab6a$var$MersenneTwister.prototype.random_incl = function() {
    return this.random_int() * (1.0 / 4294967295.0);
/* divided by 2^32-1 */ };
/* generates a random number on [0,1)-real-interval */ $5fd94ee8b3d1ab6a$var$MersenneTwister.prototype.random = function() {
    return this.random_int() * (1.0 / 4294967296.0);
/* divided by 2^32 */ };
/* generates a random number on (0,1)-real-interval */ /* origin name genrand_real3 */ $5fd94ee8b3d1ab6a$var$MersenneTwister.prototype.random_excl = function() {
    return (this.random_int() + 0.5) * (1.0 / 4294967296.0);
/* divided by 2^32 */ };
/* generates a random number on [0,1) with 53-bit resolution*/ /* origin name genrand_res53 */ $5fd94ee8b3d1ab6a$var$MersenneTwister.prototype.random_long = function() {
    var a = this.random_int() >>> 5, b = this.random_int() >>> 6;
    return (a * 67108864.0 + b) * (1.0 / 9007199254740992.0);
};
/* These real versions are due to Isaku Wada, 2002/01/09 added */ $5fd94ee8b3d1ab6a$exports = $5fd94ee8b3d1ab6a$var$MersenneTwister;


var $cf62dc05d4a0d4b5$exports = {};
function $cf62dc05d4a0d4b5$var$newPaper(diameter, color) {
    var container = document.createElement("div");
    container.style.borderRadius = "50px";
    container.style.overflow = "hidden";
    container.style.padding = "0px";
    container.style.margin = "0px";
    container.style.width = "" + diameter + "px";
    container.style.height = "" + diameter + "px";
    container.style.display = "inline-block";
    container.style.background = color;
    return {
        container: container
    };
}
$cf62dc05d4a0d4b5$exports = $cf62dc05d4a0d4b5$var$newPaper;


var $fd346a0462072c01$exports = {};
$fd346a0462072c01$exports = [
    "#01888C",
    "#FC7500",
    "#034F5D",
    "#F73F01",
    "#FC1960",
    "#C7144C",
    "#F3C100",
    "#1598F2",
    "#2465E1",
    "#F19E02"
];


var $a86b41915ff3d72d$var$shapeCount = 4;
var $a86b41915ff3d72d$var$svgns = "http://www.w3.org/2000/svg";
$a86b41915ff3d72d$exports = $a86b41915ff3d72d$var$generateIdenticon;
var $a86b41915ff3d72d$var$generator;
function $a86b41915ff3d72d$var$generateIdenticon(diameter, seed) {
    $a86b41915ff3d72d$var$generator = new $5fd94ee8b3d1ab6a$exports(seed);
    var remainingColors = $a86b41915ff3d72d$var$hueShift($fd346a0462072c01$exports.slice(), $a86b41915ff3d72d$var$generator);
    var elements = $cf62dc05d4a0d4b5$exports(diameter, $a86b41915ff3d72d$var$genColor(remainingColors));
    var container = elements.container;
    var svg = document.createElementNS($a86b41915ff3d72d$var$svgns, "svg");
    svg.setAttributeNS(null, "x", "0");
    svg.setAttributeNS(null, "y", "0");
    svg.setAttributeNS(null, "width", diameter);
    svg.setAttributeNS(null, "height", diameter);
    container.appendChild(svg);
    for(var i = 0; i < $a86b41915ff3d72d$var$shapeCount - 1; i++)$a86b41915ff3d72d$var$genShape(remainingColors, diameter, i, $a86b41915ff3d72d$var$shapeCount - 1, svg);
    return container;
}
function $a86b41915ff3d72d$var$genShape(remainingColors, diameter, i, total, svg) {
    var center = diameter / 2;
    var shape = document.createElementNS($a86b41915ff3d72d$var$svgns, "rect");
    shape.setAttributeNS(null, "x", "0");
    shape.setAttributeNS(null, "y", "0");
    shape.setAttributeNS(null, "width", diameter);
    shape.setAttributeNS(null, "height", diameter);
    var firstRot = $a86b41915ff3d72d$var$generator.random();
    var angle = Math.PI * 2 * firstRot;
    var velocity = diameter / total * $a86b41915ff3d72d$var$generator.random() + i * diameter / total;
    var tx = Math.cos(angle) * velocity;
    var ty = Math.sin(angle) * velocity;
    var translate = "translate(" + tx + " " + ty + ")";
    // Third random is a shape rotation on top of all of that.
    var secondRot = $a86b41915ff3d72d$var$generator.random();
    var rot = firstRot * 360 + secondRot * 180;
    var rotate = "rotate(" + rot.toFixed(1) + " " + center + " " + center + ")";
    var transform = translate + " " + rotate;
    shape.setAttributeNS(null, "transform", transform);
    var fill = $a86b41915ff3d72d$var$genColor(remainingColors);
    shape.setAttributeNS(null, "fill", fill);
    svg.appendChild(shape);
}
function $a86b41915ff3d72d$var$genColor(colors) {
    var rand = $a86b41915ff3d72d$var$generator.random();
    var idx = Math.floor(colors.length * $a86b41915ff3d72d$var$generator.random());
    var color = colors.splice(idx, 1)[0];
    return color;
}
var $a86b41915ff3d72d$var$wobble = 30;
function $a86b41915ff3d72d$var$hueShift(colors, generator) {
    var amount = generator.random() * 30 - $a86b41915ff3d72d$var$wobble / 2;
    var rotate = function(hex) {
        return $a86b41915ff3d72d$var$colorRotate(hex, amount);
    };
    return colors.map(rotate);
}
function $a86b41915ff3d72d$var$colorRotate(hex, degrees) {
    var hsl = $a86b41915ff3d72d$var$hexToHSL(hex);
    var hue = hsl.h;
    hue = (hue + degrees) % 360;
    hue = hue < 0 ? 360 + hue : hue;
    hsl.h = hue;
    return $a86b41915ff3d72d$var$HSLToHex(hsl);
}
function $a86b41915ff3d72d$var$hexToHSL(hex) {
    // Convert hex to RGB first
    var r = "0x" + hex[1] + hex[2];
    var g = "0x" + hex[3] + hex[4];
    var b = "0x" + hex[5] + hex[6];
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta == 0) h = 0;
    else if (cmax == r) h = (g - b) / delta % 6;
    else if (cmax == g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return {
        h: h,
        s: s,
        l: l
    };
}
function $a86b41915ff3d72d$var$HSLToHex(hsl) {
    var h = hsl.h, s = hsl.s, l = hsl.l;
    s /= 100;
    l /= 100;
    var c = (1 - Math.abs(2 * l - 1)) * s, x = c * (1 - Math.abs(h / 60 % 2 - 1)), m = l - c / 2, r = 0, g = 0, b = 0;
    if (0 <= h && h < 60) {
        r = c;
        g = x;
        b = 0;
    } else if (60 <= h && h < 120) {
        r = x;
        g = c;
        b = 0;
    } else if (120 <= h && h < 180) {
        r = 0;
        g = c;
        b = x;
    } else if (180 <= h && h < 240) {
        r = 0;
        g = x;
        b = c;
    } else if (240 <= h && h < 300) {
        r = x;
        g = 0;
        b = c;
    } else if (300 <= h && h < 360) {
        r = c;
        g = 0;
        b = x;
    }
    // Having obtained RGB, convert channels to hex
    r = Math.round((r + m) * 255).toString(16);
    g = Math.round((g + m) * 255).toString(16);
    b = Math.round((b + m) * 255).toString(16);
    // Prepend 0s, if necessary
    if (r.length == 1) r = "0" + r;
    if (g.length == 1) g = "0" + g;
    if (b.length == 1) b = "0" + b;
    return "#" + r + g + b;
}



var $ldRsu = parcelRequire("ldRsu");
var $ab76d2d77b7d74b2$exports = {};
"use strict";
var $ab76d2d77b7d74b2$var$__createBinding = $ab76d2d77b7d74b2$exports && $ab76d2d77b7d74b2$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ab76d2d77b7d74b2$var$__exportStar = $ab76d2d77b7d74b2$exports && $ab76d2d77b7d74b2$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ab76d2d77b7d74b2$var$__createBinding(exports1, m, p);
};
Object.defineProperty($ab76d2d77b7d74b2$exports, "__esModule", {
    value: true
});

$ab76d2d77b7d74b2$var$__exportStar((parcelRequire("fY3DL")), $ab76d2d77b7d74b2$exports);


var $f160a5bd0d79cd52$exports = {};
"use strict";
/**
 * Returns a Promise that resolves to the value of window.ethereum if it is
 * set within the given timeout, or null.
 * The Promise will not reject, but an error will be thrown if invalid options
 * are provided.
 *
 * @param options - Options bag.
 * @param options.mustBeMetaMask - Whether to only look for MetaMask providers.
 * Default: false
 * @param options.silent - Whether to silence console errors. Does not affect
 * thrown errors. Default: false
 * @param options.timeout - Milliseconds to wait for 'ethereum#initialized' to
 * be dispatched. Default: 3000
 * @returns A Promise that resolves with the Provider if it is detected within
 * given timeout, otherwise null.
 */ function $f160a5bd0d79cd52$var$detectEthereumProvider() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_mustBeMetaMask = _ref.mustBeMetaMask, mustBeMetaMask = _ref_mustBeMetaMask === void 0 ? false : _ref_mustBeMetaMask, _ref_silent = _ref.silent, silent = _ref_silent === void 0 ? false : _ref_silent, _ref_timeout = _ref.timeout, timeout = _ref_timeout === void 0 ? 3000 : _ref_timeout;
    _validateInputs();
    var handled = false;
    return new Promise(function(resolve) {
        if (window.ethereum) handleEthereum();
        else {
            window.addEventListener("ethereum#initialized", handleEthereum, {
                once: true
            });
            setTimeout(function() {
                handleEthereum();
            }, timeout);
        }
        function handleEthereum() {
            if (handled) return;
            handled = true;
            window.removeEventListener("ethereum#initialized", handleEthereum);
            var ethereum = window.ethereum;
            if (ethereum && (!mustBeMetaMask || ethereum.isMetaMask)) resolve(ethereum);
            else {
                var message = mustBeMetaMask && ethereum ? "Non-MetaMask window.ethereum detected." : "Unable to detect window.ethereum.";
                !silent && console.error("@metamask/detect-provider:", message);
                resolve(null);
            }
        }
    });
    function _validateInputs() {
        if (typeof mustBeMetaMask !== "boolean") throw new Error("@metamask/detect-provider: Expected option 'mustBeMetaMask' to be a boolean.");
        if (typeof silent !== "boolean") throw new Error("@metamask/detect-provider: Expected option 'silent' to be a boolean.");
        if (typeof timeout !== "number") throw new Error("@metamask/detect-provider: Expected option 'timeout' to be a number.");
    }
}
$f160a5bd0d79cd52$exports = $f160a5bd0d79cd52$var$detectEthereumProvider;


parcelRequire("cQsQJ");
var $3Y82Z = parcelRequire("3Y82Z");

var $fyOZQ = parcelRequire("fyOZQ");

var $2BGKp = parcelRequire("2BGKp");
function $9b764ba337151058$export$c55554607af84c4f(u, newSearchParams) {
    var currentURL = new URL(window.location.href);
    var newURL = new URL(u, currentURL);
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Preserve query except q_*
        for(var _iterator = currentURL.searchParams[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $fyOZQ._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            console.log("louis#key", key);
            console.log("louis#value", value);
            if (!key.startsWith("q_")) searchParams.set(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    if (newSearchParams != null) try {
        for(var _iterator1 = newSearchParams[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _step_value1 = (0, $fyOZQ._)(_step1.value, 2), key1 = _step_value1[0], value1 = _step_value1[1];
            searchParams.set(key1, value1);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var search = searchParams.toString();
    if (search !== "") newURL.search = "?" + search;
    (0, $2BGKp.visit)(newURL);
}


var $8781d986c8adc58b$var$WalletProvider;
(function(WalletProvider) {
    WalletProvider["MetaMask"] = "metamask";
})($8781d986c8adc58b$var$WalletProvider || ($8781d986c8adc58b$var$WalletProvider = {}));
function $8781d986c8adc58b$var$deserializeNonceResponse(data) {
    return {
        nonce: data.nonce,
        expireAt: new Date(data.expire_at)
    };
}
function $8781d986c8adc58b$var$createSIWEMessage(address, chainId, nonce, expiry) {
    var message = new (0, $ab76d2d77b7d74b2$exports.SiweMessage)({
        domain: window.location.host,
        address: address,
        uri: window.location.origin,
        version: "1",
        chainId: chainId,
        nonce: nonce,
        expirationTime: expiry
    });
    return message.prepareMessage();
}
function $8781d986c8adc58b$var$truncateAddress(address) {
    return address.slice(0, 6) + "..." + address.slice(address.length - 4);
}
function $8781d986c8adc58b$var$isProviderMetaMask(provider) {
    return (provider === null || provider === void 0 ? void 0 : provider.isMetaMask) === true;
}
function $8781d986c8adc58b$var$getProvider(type) {
    return $8781d986c8adc58b$var$_getProvider.apply(this, arguments);
}
function $8781d986c8adc58b$var$_getProvider() {
    $8781d986c8adc58b$var$_getProvider = (0, $jpnpo._)(function(type) {
        var provider;
        return (0, $itJXR.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, (/*@__PURE__*/$parcel$interopDefault($f160a5bd0d79cd52$exports)))({
                            mustBeMetaMask: type === "metamask"
                        })
                    ];
                case 1:
                    provider = _state.sent();
                    if (provider) // https://github.com/ethers-io/ethers.js/issues/866
                    return [
                        2,
                        new (0, $3Y82Z).providers.Web3Provider(provider, "any")
                    ];
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return $8781d986c8adc58b$var$_getProvider.apply(this, arguments);
}
function $8781d986c8adc58b$var$isMetaMaskError(err) {
    return typeof err === "object" && err !== null && "code" in err && "message" in err;
}
function $8781d986c8adc58b$var$parseWalletError(err) {
    if ($8781d986c8adc58b$var$isMetaMaskError(err)) switch(err.code){
        // User rejection, no need to show error message
        case 4001:
            return null;
        // Unauthorized
        case 4100:
            return "error-message-metamask-unauthorized";
        // Request method not supported
        case 4200:
            return "error-message-metamask-unsupported-method";
        // Disconnected from chains
        case 4900:
        case 4901:
            return "error-message-metamask-disconnected";
        default:
            return "error-message-failed-to-connect-wallet";
    }
    return "error-message-failed-to-connect-wallet";
}
function $8781d986c8adc58b$var$handleError(err) {
    console.error(err);
    var parsedErrorId = $8781d986c8adc58b$var$parseWalletError(err);
    if (parsedErrorId) (0, $fB9zd.showErrorMessage)(parsedErrorId);
    return;
}
var $8781d986c8adc58b$export$b8773302f66f36da = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(WalletIconController, Controller);
    var _super = (0, $a1vXf._)(WalletIconController);
    function WalletIconController() {
        (0, $9j09T._)(this, WalletIconController);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(WalletIconController, [
        {
            key: "generateIcon",
            value: function generateIcon() {
                // Metamask uses 8 characters from the address as seed
                var addr = this.addressValue.slice(2, 10);
                var seed = parseInt(addr, 16);
                var icon = (0, (/*@__PURE__*/$parcel$interopDefault($a86b41915ff3d72d$exports)))(this.sizeValue, seed);
                var child = icon.firstChild;
                if (child instanceof SVGElement) {
                    child.style.borderRadius = "50%";
                    return child;
                }
                return null;
            }
        },
        {
            key: "sizeValueChanged",
            value: function sizeValueChanged() {
                this.renderIcon();
            }
        },
        {
            key: "addressValueChanged",
            value: function addressValueChanged() {
                this.renderIcon();
            }
        },
        {
            key: "onAddressUpdate",
            value: function onAddressUpdate(param) {
                var address = param.detail.address;
                this.addressValue = address;
            }
        },
        {
            key: "renderIcon",
            value: function renderIcon() {
                var icon = this.generateIcon();
                if (icon) {
                    // Clear previous icons if exists
                    this.iconContainerTarget.innerHTML = "";
                    this.iconContainerTarget.appendChild(icon);
                }
            }
        }
    ]);
    return WalletIconController;
}((0, $bhrDl.Controller));
$8781d986c8adc58b$export$b8773302f66f36da.targets = [
    "iconContainer"
];
$8781d986c8adc58b$export$b8773302f66f36da.values = {
    address: String,
    size: Number
};
var $8781d986c8adc58b$export$94be79847e452b18 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(WalletConfirmationController, Controller);
    var _super = (0, $a1vXf._)(WalletConfirmationController);
    function WalletConfirmationController() {
        (0, $9j09T._)(this, WalletConfirmationController);
        var _this;
        _this = _super.apply(this, arguments);
        _this.onAccountChanged = function() {
            _this._getAccount();
        };
        return _this;
    }
    (0, $eDeHT._)(WalletConfirmationController, [
        {
            key: "provider",
            get: function get() {
                return this._provider;
            },
            set: function set(p) {
                var _this__provider, _this__provider_provider_off, _this__provider1, _this__provider_provider;
                if ($8781d986c8adc58b$var$isProviderMetaMask(p === null || p === void 0 ? void 0 : p.provider)) p.provider.on("accountsChanged", this.onAccountChanged);
                else if ($8781d986c8adc58b$var$isProviderMetaMask((_this__provider = this._provider) === null || _this__provider === void 0 ? void 0 : _this__provider.provider) && p === null) (_this__provider1 = this._provider) === null || _this__provider1 === void 0 ? void 0 : (_this__provider_provider_off = (_this__provider_provider = _this__provider1.provider).off) === null || _this__provider_provider_off === void 0 ? void 0 : _this__provider_provider_off.call(_this__provider_provider, "accountsChanged", this.onAccountChanged);
                this._provider = p;
            }
        },
        {
            key: "connect",
            value: function connect() {
                var _this = this;
                $8781d986c8adc58b$var$getProvider(this.providerValue).then(function(provider) {
                    if (!provider) {
                        var searchParams = new URLSearchParams();
                        searchParams.set("q_provider", _this.providerValue);
                        (0, $9b764ba337151058$export$c55554607af84c4f)("/errors/missing_web3_wallet", searchParams);
                        return;
                    }
                    _this.provider = provider;
                    _this._getAccount();
                }).catch(function(err) {
                    $8781d986c8adc58b$var$handleError(err);
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.provider = null;
            }
        },
        {
            key: "_getAccount",
            value: function _getAccount() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var signer, account;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.provider) return [
                                    2
                                ];
                                _this.displayedTarget.textContent = "-";
                                return [
                                    4,
                                    _this.provider.send("eth_requestAccounts", [])
                                ];
                            case 1:
                                _state.sent();
                                // Get account from the signer to ensure the requested account is the correct one
                                signer = _this.provider.getSigner();
                                return [
                                    4,
                                    signer.getAddress()
                                ];
                            case 2:
                                account = _state.sent();
                                _this.displayedTarget.textContent = $8781d986c8adc58b$var$truncateAddress(account);
                                _this.dispatch("addressUpdate", {
                                    detail: {
                                        address: account
                                    }
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "performSIWE",
            value: function performSIWE() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var nonceResp, nonce, signer, address, chainId, siweMessage, signature, e;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.provider) return [
                                    2
                                ];
                                // Ensure at least one account is connected if user has rejected the initial request
                                return [
                                    4,
                                    _this._getAccount()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    (0, $ldRsu.default)("/_internals/siwe/nonce", {
                                        method: "get"
                                    })
                                ];
                            case 3:
                                nonceResp = _state.sent();
                                nonce = $8781d986c8adc58b$var$deserializeNonceResponse(nonceResp.data.result);
                                signer = _this.provider.getSigner();
                                return [
                                    4,
                                    signer.getAddress()
                                ];
                            case 4:
                                address = _state.sent();
                                return [
                                    4,
                                    signer.getChainId()
                                ];
                            case 5:
                                chainId = _state.sent();
                                siweMessage = $8781d986c8adc58b$var$createSIWEMessage(address, chainId, nonce.nonce, nonce.expireAt.toISOString());
                                return [
                                    4,
                                    signer.signMessage(siweMessage)
                                ];
                            case 6:
                                signature = _state.sent();
                                _this.messageTarget.value = siweMessage;
                                _this.signatureTarget.value = signature;
                                _this.submitTarget.click();
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                e = _state.sent();
                                (0, $fB9zd.handleAxiosError)(e);
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return WalletConfirmationController;
}((0, $bhrDl.Controller));
$8781d986c8adc58b$export$94be79847e452b18.targets = [
    "button",
    "displayed",
    "message",
    "signature",
    "submit"
];
$8781d986c8adc58b$export$94be79847e452b18.values = {
    provider: String
};



var $lO6YM = parcelRequire("lO6YM");

var $61wmM = parcelRequire("61wmM");

var $h6hDM = parcelRequire("h6hDM");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $i0LXg = parcelRequire("i0LXg");

var $a1vXf = parcelRequire("a1vXf");

var $bhrDl = parcelRequire("bhrDl");
function $0c2e9438e1ae6e25$var$mutationObserverIsAvailable() {
    return typeof window.MutationObserver !== "undefined";
}
var $0c2e9438e1ae6e25$export$6ef038e04f1ea122 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $i0LXg._)(MirrorButtonController, Controller);
    var _super = (0, $a1vXf._)(MirrorButtonController);
    function MirrorButtonController() {
        (0, $9j09T._)(this, MirrorButtonController);
        var _this;
        _this = _super.apply(this, arguments);
        _this.observer = null;
        _this.target = null;
        return _this;
    }
    (0, $eDeHT._)(MirrorButtonController, [
        {
            key: "connect",
            value: function connect() {
                var _this = this;
                if ($0c2e9438e1ae6e25$var$mutationObserverIsAvailable()) {
                    var target = document.querySelector(this.selectorValue);
                    if (target instanceof HTMLButtonElement) {
                        this.target = target;
                        var callback = function(mutationRecords, _observer) {
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = mutationRecords[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var mutationRecord = _step.value;
                                    if (mutationRecord.type === "attributes") _this.mirror();
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        };
                        this.observer = new MutationObserver(callback);
                        this.observer.observe(target, {
                            attributes: true
                        });
                        this.mirror();
                    }
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this_observer;
                (_this_observer = this.observer) === null || _this_observer === void 0 ? void 0 : _this_observer.disconnect();
                this.observer = null;
            }
        },
        {
            key: "mirror",
            value: function mirror() {
                var element = this.element;
                var target = this.target;
                if (element instanceof HTMLButtonElement && target != null) element.disabled = target.disabled;
            }
        },
        {
            key: "click",
            value: function click(e) {
                var target = this.target;
                if (target != null) {
                    e.preventDefault();
                    target.click();
                }
            }
        }
    ]);
    return MirrorButtonController;
}((0, $bhrDl.Controller));
$0c2e9438e1ae6e25$export$6ef038e04f1ea122.values = {
    selector: String
};


var $8b034d7367ec2256$var$_document_querySelector;
// FIXME(css): Build CSS files one by one with another tool
// webpack bundles all CSS files into one bundle.
(0, $ldRsu.default).defaults.withCredentials = true;
var $8b034d7367ec2256$var$sentryDSN = ($8b034d7367ec2256$var$_document_querySelector = document.querySelector("meta[name=x-sentry-dsn]")) === null || $8b034d7367ec2256$var$_document_querySelector === void 0 ? void 0 : $8b034d7367ec2256$var$_document_querySelector.getAttribute("content");
if ($8b034d7367ec2256$var$sentryDSN != null && $8b034d7367ec2256$var$sentryDSN !== "") (0, $lO6YM.init)({
    dsn: $8b034d7367ec2256$var$sentryDSN,
    integrations: [
        new (0, $61wmM.BrowserTracing)()
    ]
});
(0, $2BGKp.start)();
var $8b034d7367ec2256$var$Stimulus = (0, $bhrDl.Application).start();
$8b034d7367ec2256$var$Stimulus.register("xhr-submit-form", (0, $3kulJ.XHRSubmitFormController));
$8b034d7367ec2256$var$Stimulus.register("password-visibility-toggle", (0, $5uUMW.PasswordVisibilityToggleController));
$8b034d7367ec2256$var$Stimulus.register("password-policy", (0, $5e943273f046bbc2$export$8e2d40fd8c4736e0));
$8b034d7367ec2256$var$Stimulus.register("click-to-switch", (0, $98e86993763fcb41$export$3283bc632b8824ef));
$8b034d7367ec2256$var$Stimulus.register("copy-button", (0, $jYOnC.CopyButtonController));
$8b034d7367ec2256$var$Stimulus.register("prevent-double-tap", (0, $9IQW1.PreventDoubleTapController));
$8b034d7367ec2256$var$Stimulus.register("account-deletion", (0, $967ab8208c310f6b$export$d0f0bcf1b33aa228));
$8b034d7367ec2256$var$Stimulus.register("resend-button", (0, $iUEzK.ResendButtonController));
$8b034d7367ec2256$var$Stimulus.register("message-bar", (0, $fB9zd.MessageBarController));
$8b034d7367ec2256$var$Stimulus.register("intl-tel-input", (0, $9f556643ce100801$export$31a0a1ef286c12be));
$8b034d7367ec2256$var$Stimulus.register("select-empty-value", (0, $3e120f2118d76ac8$export$b1a468160bc49f70));
$8b034d7367ec2256$var$Stimulus.register("gender-select", (0, $3e120f2118d76ac8$export$968691de411f5320));
$8b034d7367ec2256$var$Stimulus.register("image-picker", (0, $4549ab881969af81$export$53e562c37b02f57d));
$8b034d7367ec2256$var$Stimulus.register("websocket", (0, $260533b4e9b5e7fd$export$873a738f46b480f6));
$8b034d7367ec2256$var$Stimulus.register("authflow-websocket", (0, $858985dec7133fe7$export$6305564e8c07011f));
$8b034d7367ec2256$var$Stimulus.register("authflow-polling", (0, $ad122db40346eba6$export$c36e5e28cd33a95));
$8b034d7367ec2256$var$Stimulus.register("format-date-relative", (0, $13ALN.FormatDateRelativeController));
$8b034d7367ec2256$var$Stimulus.register("format-input-date", (0, $13ALN.FormatInputDateController));
$8b034d7367ec2256$var$Stimulus.register("restore-form", (0, $3kulJ.RestoreFormController));
$8b034d7367ec2256$var$Stimulus.register("retain-form-form", (0, $3kulJ.RetainFormFormController));
$8b034d7367ec2256$var$Stimulus.register("retain-form-input", (0, $3kulJ.RetainFormInputController));
$8b034d7367ec2256$var$Stimulus.register("modal", (0, $7e7dbfcbf1eb3f62$export$d507f25e63650365));
$8b034d7367ec2256$var$Stimulus.register("simple-modal", (0, $10b0af16b46e080f$export$f720643190922065));
$8b034d7367ec2256$var$Stimulus.register("back-button", (0, $514e8b9423d166d2$export$e5ebe865d6ee37f8));
$8b034d7367ec2256$var$Stimulus.register("passkey-creation", (0, $10747cf896bc087a$export$58aebb7fd963a6e5));
$8b034d7367ec2256$var$Stimulus.register("passkey-request", (0, $10747cf896bc087a$export$4f73e5135a0b306));
$8b034d7367ec2256$var$Stimulus.register("passkey-autofill", (0, $10747cf896bc087a$export$61efde872c211e81));
$8b034d7367ec2256$var$Stimulus.register("authflow-passkey-request", (0, $10747cf896bc087a$export$b131e57e56d01eab));
$8b034d7367ec2256$var$Stimulus.register("authflow-passkey-creation", (0, $10747cf896bc087a$export$38c3ed2085643c70));
$8b034d7367ec2256$var$Stimulus.register("web3-wallet-confirmation", (0, $8781d986c8adc58b$export$94be79847e452b18));
$8b034d7367ec2256$var$Stimulus.register("web3-wallet-icon", (0, $8781d986c8adc58b$export$b8773302f66f36da));
$8b034d7367ec2256$var$Stimulus.register("lockout", (0, $h6hDM.LockoutController));
$8b034d7367ec2256$var$Stimulus.register("mirror-button", (0, $0c2e9438e1ae6e25$export$6ef038e04f1ea122));

})();
//# sourceMappingURL=authgear-classic.e65fd1d6.js.map
